{
  "DESKTOP.json": {
    "$id": "urn:dm:schemas:DESKTOP.json",
    "DesignQuery": true,
    "DataQuery": true,
    "PropertyQuery": true,
    "VariantsQuery": true,
    "StyleId": true,
    "MobileHintsQuery": true,
    "BehaviorQuery": true,
    "ConnectionQuery": true,
    "LayoutQuery": true,
    "AnchorQuery": true,
    "BreakpointsQuery": true,
    "BreakpointVariantsQuery": true,
    "TransformationQuery": true,
    "TransitionQuery": true,
    "ModesDefinition": {
      "type": "object",
      "properties": {
        "definitions": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "label": true,
              "modeId": true,
              "params": true,
              "settings": {
                "type": "object",
                "properties": {
                  "pagesGroupId": true
                },
                "additionalProperties": false
              },
              "type": {
                "type": "string",
                "enum": [
                  "HOVER",
                  "DEFAULT",
                  "SHOW_ON_SOME_PAGES",
                  "POPOVER"
                ]
              }
            },
            "additionalProperties": false
          }
        },
        "isHiddenByModes": true,
        "overrides": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "isHiddenByModes": true,
              "modeIds": {
                "type": "array",
                "items": true
              },
              "layout": {
                "type": "object",
                "properties": {
                  "x": true,
                  "y": true,
                  "width": true,
                  "height": true,
                  "rotationInDegrees": true,
                  "fixedPosition": true,
                  "scale": true,
                  "docked": {
                    "type": "object",
                    "properties": {
                      "left": {
                        "type": "object",
                        "properties": {
                          "px": true,
                          "pct": true,
                          "vw": true,
                          "vh": true
                        },
                        "additionalProperties": false
                      },
                      "right": {
                        "type": "object",
                        "properties": {
                          "px": true,
                          "pct": true,
                          "vw": true,
                          "vh": true
                        },
                        "additionalProperties": false
                      },
                      "top": {
                        "type": "object",
                        "properties": {
                          "px": true,
                          "pct": true,
                          "vw": true,
                          "vh": true
                        },
                        "additionalProperties": false
                      },
                      "bottom": {
                        "type": "object",
                        "properties": {
                          "px": true,
                          "pct": true,
                          "vw": true,
                          "vh": true
                        },
                        "additionalProperties": false
                      },
                      "hCenter": {
                        "type": "object",
                        "properties": {
                          "px": true,
                          "pct": true,
                          "vw": true,
                          "vh": true
                        },
                        "additionalProperties": false
                      },
                      "vCenter": {
                        "type": "object",
                        "properties": {
                          "px": true,
                          "pct": true,
                          "vw": true,
                          "vh": true
                        },
                        "additionalProperties": false
                      }
                    },
                    "additionalProperties": false
                  },
                  "anchors": {
                    "type": [
                      "null",
                      "array"
                    ],
                    "items": {
                      "type": "object",
                      "properties": {
                        "distance": true,
                        "type": {
                          "type": "string",
                          "enum": [
                            "TOP_TOP",
                            "BOTTOM_TOP",
                            "BOTTOM_PARENT",
                            "BOTTOM_BOTTOM",
                            "LOCK_BOTTOM"
                          ]
                        },
                        "locked": true,
                        "targetComponent": true
                      },
                      "additionalProperties": false
                    }
                  }
                },
                "additionalProperties": false
              },
              "designQuery": true,
              "propertyQuery": true,
              "styleId": true
            },
            "additionalProperties": false
          }
        }
      },
      "additionalProperties": false
    },
    "AnchorDefinition": {
      "type": "object",
      "properties": {
        "distance": true,
        "type": {
          "type": "string",
          "enum": [
            "TOP_TOP",
            "BOTTOM_TOP",
            "BOTTOM_PARENT",
            "BOTTOM_BOTTOM",
            "LOCK_BOTTOM"
          ]
        },
        "locked": true,
        "targetComponent": true
      },
      "additionalProperties": false
    },
    "PartialLayoutObjectForMasterPage": {
      "type": "object",
      "properties": {
        "y": {
          "enum": [
            0
          ]
        },
        "rotationInDegrees": {
          "enum": [
            0
          ]
        },
        "anchors": {
          "type": [
            "null",
            "array"
          ],
          "items": {
            "type": "object",
            "properties": {
              "distance": true,
              "type": {
                "type": "string",
                "enum": [
                  "TOP_TOP",
                  "BOTTOM_TOP",
                  "BOTTOM_PARENT",
                  "BOTTOM_BOTTOM",
                  "LOCK_BOTTOM"
                ]
              },
              "locked": true,
              "targetComponent": true
            },
            "additionalProperties": false
          }
        }
      },
      "additionalProperties": false
    },
    "DockingUnitSize": {
      "type": "object",
      "properties": {
        "px": true,
        "pct": true,
        "vw": true,
        "vh": true
      },
      "additionalProperties": false
    },
    "DockingDefinition": {
      "type": "object",
      "properties": {
        "left": {
          "type": "object",
          "properties": {
            "px": true,
            "pct": true,
            "vw": true,
            "vh": true
          },
          "additionalProperties": false
        },
        "right": {
          "type": "object",
          "properties": {
            "px": true,
            "pct": true,
            "vw": true,
            "vh": true
          },
          "additionalProperties": false
        },
        "top": {
          "type": "object",
          "properties": {
            "px": true,
            "pct": true,
            "vw": true,
            "vh": true
          },
          "additionalProperties": false
        },
        "bottom": {
          "type": "object",
          "properties": {
            "px": true,
            "pct": true,
            "vw": true,
            "vh": true
          },
          "additionalProperties": false
        },
        "hCenter": {
          "type": "object",
          "properties": {
            "px": true,
            "pct": true,
            "vw": true,
            "vh": true
          },
          "additionalProperties": false
        },
        "vCenter": {
          "type": "object",
          "properties": {
            "px": true,
            "pct": true,
            "vw": true,
            "vh": true
          },
          "additionalProperties": false
        }
      },
      "additionalProperties": false
    },
    "BaseComponentObject": {
      "type": "object",
      "properties": {
        "metaData": true,
        "id": true,
        "type": true,
        "parent": true
      },
      "additionalProperties": false
    },
    "MetaDataForComponents": {
      "type": "object",
      "properties": {},
      "additionalProperties": false
    },
    "LayoutObjectForComponents": {
      "type": "object",
      "properties": {
        "x": true,
        "y": true,
        "width": true,
        "height": true,
        "rotationInDegrees": true,
        "fixedPosition": true,
        "scale": true,
        "docked": {
          "type": "object",
          "properties": {
            "left": {
              "type": "object",
              "properties": {
                "px": true,
                "pct": true,
                "vw": true,
                "vh": true
              },
              "additionalProperties": false
            },
            "right": {
              "type": "object",
              "properties": {
                "px": true,
                "pct": true,
                "vw": true,
                "vh": true
              },
              "additionalProperties": false
            },
            "top": {
              "type": "object",
              "properties": {
                "px": true,
                "pct": true,
                "vw": true,
                "vh": true
              },
              "additionalProperties": false
            },
            "bottom": {
              "type": "object",
              "properties": {
                "px": true,
                "pct": true,
                "vw": true,
                "vh": true
              },
              "additionalProperties": false
            },
            "hCenter": {
              "type": "object",
              "properties": {
                "px": true,
                "pct": true,
                "vw": true,
                "vh": true
              },
              "additionalProperties": false
            },
            "vCenter": {
              "type": "object",
              "properties": {
                "px": true,
                "pct": true,
                "vw": true,
                "vh": true
              },
              "additionalProperties": false
            }
          },
          "additionalProperties": false
        },
        "anchors": {
          "type": [
            "null",
            "array"
          ],
          "items": {
            "type": "object",
            "properties": {
              "distance": true,
              "type": {
                "type": "string",
                "enum": [
                  "TOP_TOP",
                  "BOTTOM_TOP",
                  "BOTTOM_PARENT",
                  "BOTTOM_BOTTOM",
                  "LOCK_BOTTOM"
                ]
              },
              "locked": true,
              "targetComponent": true
            },
            "additionalProperties": false
          }
        }
      },
      "additionalProperties": false
    },
    "ShouldReallyBeAnIntAtSomePoint": true,
    "ComponentsList": {
      "type": [
        "array",
        "null"
      ],
      "items": true
    },
    "Component": {
      "type": [
        "object"
      ],
      "properties": {
        "metaData": true,
        "id": true,
        "type": true,
        "parent": true,
        "dataQuery": true,
        "propertyQuery": true,
        "designQuery": true,
        "mobileHintsQuery": true,
        "behaviorQuery": true,
        "connectionQuery": true,
        "layoutQuery": true,
        "anchorQuery": true,
        "breakpointsQuery": true,
        "breakpointVariantsQuery": true,
        "transformationQuery": true,
        "transitionQuery": true,
        "variantsQuery": true,
        "styleId": true,
        "layout": {
          "type": "object",
          "properties": {
            "x": true,
            "y": true,
            "width": true,
            "height": true,
            "rotationInDegrees": true,
            "fixedPosition": true,
            "scale": true,
            "docked": {
              "type": "object",
              "properties": {
                "left": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                },
                "right": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                },
                "top": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                },
                "bottom": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                },
                "hCenter": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                },
                "vCenter": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            "anchors": {
              "type": [
                "null",
                "array"
              ],
              "items": {
                "type": "object",
                "properties": {
                  "distance": true,
                  "type": {
                    "type": "string",
                    "enum": [
                      "TOP_TOP",
                      "BOTTOM_TOP",
                      "BOTTOM_PARENT",
                      "BOTTOM_BOTTOM",
                      "LOCK_BOTTOM"
                    ]
                  },
                  "locked": true,
                  "targetComponent": true
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "classnamesQuery": true,
        "contentRoleQuery": true,
        "controllersQuery": true,
        "cursorQuery": true,
        "discussionsQuery": true,
        "editorsettingsQuery": true,
        "effectsQuery": true,
        "groupingQuery": true,
        "innerElementsQuery": true,
        "innerElementsMetaDataQuery": true,
        "intentQuery": true,
        "layoutSettingsQuery": true,
        "manifestQuery": true,
        "measurementsQuery": true,
        "migrationQuery": true,
        "namingQuery": true,
        "notificationsQuery": true,
        "pageSectionsQuery": true,
        "presetsQuery": true,
        "reactionsQuery": true,
        "slotsQuery": true,
        "sourceQuery": true,
        "statesQuery": true,
        "triggersQuery": true,
        "variablesQuery": true,
        "componentType": true,
        "skin": true,
        "modes": {
          "type": "object",
          "properties": {
            "definitions": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "label": true,
                  "modeId": true,
                  "params": true,
                  "settings": {
                    "type": "object",
                    "properties": {
                      "pagesGroupId": true
                    },
                    "additionalProperties": false
                  },
                  "type": {
                    "type": "string",
                    "enum": [
                      "HOVER",
                      "DEFAULT",
                      "SHOW_ON_SOME_PAGES",
                      "POPOVER"
                    ]
                  }
                },
                "additionalProperties": false
              }
            },
            "isHiddenByModes": true,
            "overrides": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "isHiddenByModes": true,
                  "modeIds": {
                    "type": "array",
                    "items": true
                  },
                  "layout": {
                    "type": "object",
                    "properties": {
                      "x": true,
                      "y": true,
                      "width": true,
                      "height": true,
                      "rotationInDegrees": true,
                      "fixedPosition": true,
                      "scale": true,
                      "docked": {
                        "type": "object",
                        "properties": {
                          "left": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          },
                          "right": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          },
                          "top": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          },
                          "bottom": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          },
                          "hCenter": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          },
                          "vCenter": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          }
                        },
                        "additionalProperties": false
                      },
                      "anchors": {
                        "type": [
                          "null",
                          "array"
                        ],
                        "items": {
                          "type": "object",
                          "properties": {
                            "distance": true,
                            "type": {
                              "type": "string",
                              "enum": [
                                "TOP_TOP",
                                "BOTTOM_TOP",
                                "BOTTOM_PARENT",
                                "BOTTOM_BOTTOM",
                                "LOCK_BOTTOM"
                              ]
                            },
                            "locked": true,
                            "targetComponent": true
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    "additionalProperties": false
                  },
                  "designQuery": true,
                  "propertyQuery": true,
                  "styleId": true
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        }
      },
      "additionalProperties": false
    },
    "ComponentQueries": {
      "type": "object",
      "properties": {
        "dataQuery": true,
        "propertyQuery": true,
        "designQuery": true,
        "mobileHintsQuery": true,
        "behaviorQuery": true,
        "connectionQuery": true,
        "layoutQuery": true,
        "anchorQuery": true,
        "breakpointsQuery": true,
        "breakpointVariantsQuery": true,
        "transformationQuery": true,
        "transitionQuery": true,
        "variantsQuery": true,
        "styleId": true,
        "layout": {
          "type": "object",
          "properties": {
            "x": true,
            "y": true,
            "width": true,
            "height": true,
            "rotationInDegrees": true,
            "fixedPosition": true,
            "scale": true,
            "docked": {
              "type": "object",
              "properties": {
                "left": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                },
                "right": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                },
                "top": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                },
                "bottom": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                },
                "hCenter": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                },
                "vCenter": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            "anchors": {
              "type": [
                "null",
                "array"
              ],
              "items": {
                "type": "object",
                "properties": {
                  "distance": true,
                  "type": {
                    "type": "string",
                    "enum": [
                      "TOP_TOP",
                      "BOTTOM_TOP",
                      "BOTTOM_PARENT",
                      "BOTTOM_BOTTOM",
                      "LOCK_BOTTOM"
                    ]
                  },
                  "locked": true,
                  "targetComponent": true
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "classnamesQuery": true,
        "contentRoleQuery": true,
        "controllersQuery": true,
        "cursorQuery": true,
        "discussionsQuery": true,
        "editorsettingsQuery": true,
        "effectsQuery": true,
        "groupingQuery": true,
        "innerElementsQuery": true,
        "innerElementsMetaDataQuery": true,
        "intentQuery": true,
        "layoutSettingsQuery": true,
        "manifestQuery": true,
        "measurementsQuery": true,
        "migrationQuery": true,
        "namingQuery": true,
        "notificationsQuery": true,
        "pageSectionsQuery": true,
        "presetsQuery": true,
        "reactionsQuery": true,
        "slotsQuery": true,
        "sourceQuery": true,
        "statesQuery": true,
        "triggersQuery": true,
        "variablesQuery": true
      },
      "additionalProperties": false
    },
    "RefComponent": {
      "type": [
        "object"
      ],
      "properties": {
        "metaData": true,
        "id": true,
        "type": true,
        "parent": true,
        "dataQuery": true,
        "propertyQuery": true,
        "designQuery": true,
        "mobileHintsQuery": true,
        "behaviorQuery": true,
        "connectionQuery": true,
        "layoutQuery": true,
        "anchorQuery": true,
        "breakpointsQuery": true,
        "breakpointVariantsQuery": true,
        "transformationQuery": true,
        "transitionQuery": true,
        "variantsQuery": true,
        "styleId": true,
        "layout": {
          "type": "object",
          "properties": {
            "x": true,
            "y": true,
            "width": true,
            "height": true,
            "rotationInDegrees": true,
            "fixedPosition": true,
            "scale": true,
            "docked": {
              "type": "object",
              "properties": {
                "left": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                },
                "right": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                },
                "top": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                },
                "bottom": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                },
                "hCenter": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                },
                "vCenter": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            "anchors": {
              "type": [
                "null",
                "array"
              ],
              "items": {
                "type": "object",
                "properties": {
                  "distance": true,
                  "type": {
                    "type": "string",
                    "enum": [
                      "TOP_TOP",
                      "BOTTOM_TOP",
                      "BOTTOM_PARENT",
                      "BOTTOM_BOTTOM",
                      "LOCK_BOTTOM"
                    ]
                  },
                  "locked": true,
                  "targetComponent": true
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "classnamesQuery": true,
        "contentRoleQuery": true,
        "controllersQuery": true,
        "cursorQuery": true,
        "discussionsQuery": true,
        "editorsettingsQuery": true,
        "effectsQuery": true,
        "groupingQuery": true,
        "innerElementsQuery": true,
        "innerElementsMetaDataQuery": true,
        "intentQuery": true,
        "layoutSettingsQuery": true,
        "manifestQuery": true,
        "measurementsQuery": true,
        "migrationQuery": true,
        "namingQuery": true,
        "notificationsQuery": true,
        "pageSectionsQuery": true,
        "presetsQuery": true,
        "reactionsQuery": true,
        "slotsQuery": true,
        "sourceQuery": true,
        "statesQuery": true,
        "triggersQuery": true,
        "variablesQuery": true,
        "componentType": true,
        "skin": true,
        "modes": {
          "type": "object",
          "properties": {
            "definitions": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "label": true,
                  "modeId": true,
                  "params": true,
                  "settings": {
                    "type": "object",
                    "properties": {
                      "pagesGroupId": true
                    },
                    "additionalProperties": false
                  },
                  "type": {
                    "type": "string",
                    "enum": [
                      "HOVER",
                      "DEFAULT",
                      "SHOW_ON_SOME_PAGES",
                      "POPOVER"
                    ]
                  }
                },
                "additionalProperties": false
              }
            },
            "isHiddenByModes": true,
            "overrides": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "isHiddenByModes": true,
                  "modeIds": {
                    "type": "array",
                    "items": true
                  },
                  "layout": {
                    "type": "object",
                    "properties": {
                      "x": true,
                      "y": true,
                      "width": true,
                      "height": true,
                      "rotationInDegrees": true,
                      "fixedPosition": true,
                      "scale": true,
                      "docked": {
                        "type": "object",
                        "properties": {
                          "left": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          },
                          "right": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          },
                          "top": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          },
                          "bottom": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          },
                          "hCenter": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          },
                          "vCenter": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          }
                        },
                        "additionalProperties": false
                      },
                      "anchors": {
                        "type": [
                          "null",
                          "array"
                        ],
                        "items": {
                          "type": "object",
                          "properties": {
                            "distance": true,
                            "type": {
                              "type": "string",
                              "enum": [
                                "TOP_TOP",
                                "BOTTOM_TOP",
                                "BOTTOM_PARENT",
                                "BOTTOM_BOTTOM",
                                "LOCK_BOTTOM"
                              ]
                            },
                            "locked": true,
                            "targetComponent": true
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    "additionalProperties": false
                  },
                  "designQuery": true,
                  "propertyQuery": true,
                  "styleId": true
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "components": {
          "type": [
            "array",
            "null"
          ],
          "items": true
        }
      },
      "additionalProperties": false
    },
    "RepeaterContainer": {
      "type": [
        "object"
      ],
      "properties": {
        "metaData": true,
        "id": true,
        "type": true,
        "parent": true,
        "dataQuery": true,
        "propertyQuery": true,
        "designQuery": true,
        "mobileHintsQuery": true,
        "behaviorQuery": true,
        "connectionQuery": true,
        "layoutQuery": true,
        "anchorQuery": true,
        "breakpointsQuery": true,
        "breakpointVariantsQuery": true,
        "transformationQuery": true,
        "transitionQuery": true,
        "variantsQuery": true,
        "styleId": true,
        "layout": {
          "type": "object",
          "properties": {
            "x": true,
            "y": true,
            "width": true,
            "height": true,
            "rotationInDegrees": true,
            "fixedPosition": true,
            "scale": true,
            "docked": {
              "type": "object",
              "properties": {
                "left": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                },
                "right": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                },
                "top": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                },
                "bottom": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                },
                "hCenter": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                },
                "vCenter": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            "anchors": {
              "type": [
                "null",
                "array"
              ],
              "items": {
                "type": "object",
                "properties": {
                  "distance": true,
                  "type": {
                    "type": "string",
                    "enum": [
                      "TOP_TOP",
                      "BOTTOM_TOP",
                      "BOTTOM_PARENT",
                      "BOTTOM_BOTTOM",
                      "LOCK_BOTTOM"
                    ]
                  },
                  "locked": true,
                  "targetComponent": true
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "classnamesQuery": true,
        "contentRoleQuery": true,
        "controllersQuery": true,
        "cursorQuery": true,
        "discussionsQuery": true,
        "editorsettingsQuery": true,
        "effectsQuery": true,
        "groupingQuery": true,
        "innerElementsQuery": true,
        "innerElementsMetaDataQuery": true,
        "intentQuery": true,
        "layoutSettingsQuery": true,
        "manifestQuery": true,
        "measurementsQuery": true,
        "migrationQuery": true,
        "namingQuery": true,
        "notificationsQuery": true,
        "pageSectionsQuery": true,
        "presetsQuery": true,
        "reactionsQuery": true,
        "slotsQuery": true,
        "sourceQuery": true,
        "statesQuery": true,
        "triggersQuery": true,
        "variablesQuery": true,
        "componentType": true,
        "skin": true,
        "modes": {
          "type": "object",
          "properties": {
            "definitions": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "label": true,
                  "modeId": true,
                  "params": true,
                  "settings": {
                    "type": "object",
                    "properties": {
                      "pagesGroupId": true
                    },
                    "additionalProperties": false
                  },
                  "type": {
                    "type": "string",
                    "enum": [
                      "HOVER",
                      "DEFAULT",
                      "SHOW_ON_SOME_PAGES",
                      "POPOVER"
                    ]
                  }
                },
                "additionalProperties": false
              }
            },
            "isHiddenByModes": true,
            "overrides": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "isHiddenByModes": true,
                  "modeIds": {
                    "type": "array",
                    "items": true
                  },
                  "layout": {
                    "type": "object",
                    "properties": {
                      "x": true,
                      "y": true,
                      "width": true,
                      "height": true,
                      "rotationInDegrees": true,
                      "fixedPosition": true,
                      "scale": true,
                      "docked": {
                        "type": "object",
                        "properties": {
                          "left": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          },
                          "right": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          },
                          "top": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          },
                          "bottom": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          },
                          "hCenter": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          },
                          "vCenter": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          }
                        },
                        "additionalProperties": false
                      },
                      "anchors": {
                        "type": [
                          "null",
                          "array"
                        ],
                        "items": {
                          "type": "object",
                          "properties": {
                            "distance": true,
                            "type": {
                              "type": "string",
                              "enum": [
                                "TOP_TOP",
                                "BOTTOM_TOP",
                                "BOTTOM_PARENT",
                                "BOTTOM_BOTTOM",
                                "LOCK_BOTTOM"
                              ]
                            },
                            "locked": true,
                            "targetComponent": true
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    "additionalProperties": false
                  },
                  "designQuery": true,
                  "propertyQuery": true,
                  "styleId": true
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "components": {
          "type": [
            "array",
            "null"
          ],
          "items": true
        },
        "patternsQuery": true
      },
      "additionalProperties": false
    },
    "RepeaterVariantsQuery": true,
    "RepeaterQueries": {
      "type": "object",
      "properties": {
        "variantsQuery": true,
        "patternsQuery": true
      },
      "additionalProperties": false
    },
    "Container": {
      "type": [
        "object"
      ],
      "properties": {
        "metaData": true,
        "id": true,
        "type": true,
        "parent": true,
        "dataQuery": true,
        "propertyQuery": true,
        "designQuery": true,
        "mobileHintsQuery": true,
        "behaviorQuery": true,
        "connectionQuery": true,
        "layoutQuery": true,
        "anchorQuery": true,
        "breakpointsQuery": true,
        "breakpointVariantsQuery": true,
        "transformationQuery": true,
        "transitionQuery": true,
        "variantsQuery": true,
        "styleId": true,
        "layout": {
          "type": "object",
          "properties": {
            "x": true,
            "y": true,
            "width": true,
            "height": true,
            "rotationInDegrees": true,
            "fixedPosition": true,
            "scale": true,
            "docked": {
              "type": "object",
              "properties": {
                "left": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                },
                "right": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                },
                "top": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                },
                "bottom": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                },
                "hCenter": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                },
                "vCenter": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            "anchors": {
              "type": [
                "null",
                "array"
              ],
              "items": {
                "type": "object",
                "properties": {
                  "distance": true,
                  "type": {
                    "type": "string",
                    "enum": [
                      "TOP_TOP",
                      "BOTTOM_TOP",
                      "BOTTOM_PARENT",
                      "BOTTOM_BOTTOM",
                      "LOCK_BOTTOM"
                    ]
                  },
                  "locked": true,
                  "targetComponent": true
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "classnamesQuery": true,
        "contentRoleQuery": true,
        "controllersQuery": true,
        "cursorQuery": true,
        "discussionsQuery": true,
        "editorsettingsQuery": true,
        "effectsQuery": true,
        "groupingQuery": true,
        "innerElementsQuery": true,
        "innerElementsMetaDataQuery": true,
        "intentQuery": true,
        "layoutSettingsQuery": true,
        "manifestQuery": true,
        "measurementsQuery": true,
        "migrationQuery": true,
        "namingQuery": true,
        "notificationsQuery": true,
        "pageSectionsQuery": true,
        "presetsQuery": true,
        "reactionsQuery": true,
        "slotsQuery": true,
        "sourceQuery": true,
        "statesQuery": true,
        "triggersQuery": true,
        "variablesQuery": true,
        "componentType": true,
        "skin": true,
        "modes": {
          "type": "object",
          "properties": {
            "definitions": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "label": true,
                  "modeId": true,
                  "params": true,
                  "settings": {
                    "type": "object",
                    "properties": {
                      "pagesGroupId": true
                    },
                    "additionalProperties": false
                  },
                  "type": {
                    "type": "string",
                    "enum": [
                      "HOVER",
                      "DEFAULT",
                      "SHOW_ON_SOME_PAGES",
                      "POPOVER"
                    ]
                  }
                },
                "additionalProperties": false
              }
            },
            "isHiddenByModes": true,
            "overrides": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "isHiddenByModes": true,
                  "modeIds": {
                    "type": "array",
                    "items": true
                  },
                  "layout": {
                    "type": "object",
                    "properties": {
                      "x": true,
                      "y": true,
                      "width": true,
                      "height": true,
                      "rotationInDegrees": true,
                      "fixedPosition": true,
                      "scale": true,
                      "docked": {
                        "type": "object",
                        "properties": {
                          "left": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          },
                          "right": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          },
                          "top": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          },
                          "bottom": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          },
                          "hCenter": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          },
                          "vCenter": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          }
                        },
                        "additionalProperties": false
                      },
                      "anchors": {
                        "type": [
                          "null",
                          "array"
                        ],
                        "items": {
                          "type": "object",
                          "properties": {
                            "distance": true,
                            "type": {
                              "type": "string",
                              "enum": [
                                "TOP_TOP",
                                "BOTTOM_TOP",
                                "BOTTOM_PARENT",
                                "BOTTOM_BOTTOM",
                                "LOCK_BOTTOM"
                              ]
                            },
                            "locked": true,
                            "targetComponent": true
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    "additionalProperties": false
                  },
                  "designQuery": true,
                  "propertyQuery": true,
                  "styleId": true
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "components": {
          "type": [
            "array",
            "null"
          ],
          "items": true
        }
      },
      "additionalProperties": false
    },
    "PageQueries": {
      "type": "object",
      "properties": {
        "fixerVersionsQuery": true
      },
      "additionalProperties": false
    },
    "Page": {
      "type": [
        "object"
      ],
      "properties": {
        "metaData": true,
        "id": true,
        "type": true,
        "parent": true,
        "dataQuery": true,
        "propertyQuery": true,
        "designQuery": true,
        "mobileHintsQuery": true,
        "behaviorQuery": true,
        "connectionQuery": true,
        "layoutQuery": true,
        "anchorQuery": true,
        "breakpointsQuery": true,
        "breakpointVariantsQuery": true,
        "transformationQuery": true,
        "transitionQuery": true,
        "variantsQuery": true,
        "styleId": true,
        "layout": {
          "type": "object",
          "properties": {
            "x": true,
            "y": true,
            "width": true,
            "height": true,
            "rotationInDegrees": true,
            "fixedPosition": true,
            "scale": true,
            "docked": {
              "type": "object",
              "properties": {
                "left": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                },
                "right": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                },
                "top": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                },
                "bottom": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                },
                "hCenter": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                },
                "vCenter": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            "anchors": {
              "type": [
                "null",
                "array"
              ],
              "items": {
                "type": "object",
                "properties": {
                  "distance": true,
                  "type": {
                    "type": "string",
                    "enum": [
                      "TOP_TOP",
                      "BOTTOM_TOP",
                      "BOTTOM_PARENT",
                      "BOTTOM_BOTTOM",
                      "LOCK_BOTTOM"
                    ]
                  },
                  "locked": true,
                  "targetComponent": true
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "classnamesQuery": true,
        "contentRoleQuery": true,
        "controllersQuery": true,
        "cursorQuery": true,
        "discussionsQuery": true,
        "editorsettingsQuery": true,
        "effectsQuery": true,
        "groupingQuery": true,
        "innerElementsQuery": true,
        "innerElementsMetaDataQuery": true,
        "intentQuery": true,
        "layoutSettingsQuery": true,
        "manifestQuery": true,
        "measurementsQuery": true,
        "migrationQuery": true,
        "namingQuery": true,
        "notificationsQuery": true,
        "pageSectionsQuery": true,
        "presetsQuery": true,
        "reactionsQuery": true,
        "slotsQuery": true,
        "sourceQuery": true,
        "statesQuery": true,
        "triggersQuery": true,
        "variablesQuery": true,
        "componentType": true,
        "skin": true,
        "modes": {
          "type": "object",
          "properties": {
            "definitions": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "label": true,
                  "modeId": true,
                  "params": true,
                  "settings": {
                    "type": "object",
                    "properties": {
                      "pagesGroupId": true
                    },
                    "additionalProperties": false
                  },
                  "type": {
                    "type": "string",
                    "enum": [
                      "HOVER",
                      "DEFAULT",
                      "SHOW_ON_SOME_PAGES",
                      "POPOVER"
                    ]
                  }
                },
                "additionalProperties": false
              }
            },
            "isHiddenByModes": true,
            "overrides": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "isHiddenByModes": true,
                  "modeIds": {
                    "type": "array",
                    "items": true
                  },
                  "layout": {
                    "type": "object",
                    "properties": {
                      "x": true,
                      "y": true,
                      "width": true,
                      "height": true,
                      "rotationInDegrees": true,
                      "fixedPosition": true,
                      "scale": true,
                      "docked": {
                        "type": "object",
                        "properties": {
                          "left": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          },
                          "right": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          },
                          "top": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          },
                          "bottom": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          },
                          "hCenter": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          },
                          "vCenter": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          }
                        },
                        "additionalProperties": false
                      },
                      "anchors": {
                        "type": [
                          "null",
                          "array"
                        ],
                        "items": {
                          "type": "object",
                          "properties": {
                            "distance": true,
                            "type": {
                              "type": "string",
                              "enum": [
                                "TOP_TOP",
                                "BOTTOM_TOP",
                                "BOTTOM_PARENT",
                                "BOTTOM_BOTTOM",
                                "LOCK_BOTTOM"
                              ]
                            },
                            "locked": true,
                            "targetComponent": true
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    "additionalProperties": false
                  },
                  "designQuery": true,
                  "propertyQuery": true,
                  "styleId": true
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "components": {
          "type": [
            "array",
            "null"
          ],
          "items": true
        },
        "fixerVersionsQuery": true
      },
      "additionalProperties": false
    },
    "DocumentProperties": {
      "type": "object",
      "properties": {
        "documentType": {
          "enum": [
            "document"
          ]
        },
        "layout": {
          "type": "object",
          "properties": {
            "y": {
              "enum": [
                0
              ]
            },
            "rotationInDegrees": {
              "enum": [
                0
              ]
            },
            "anchors": {
              "type": [
                "null",
                "array"
              ],
              "items": {
                "type": "object",
                "properties": {
                  "distance": true,
                  "type": {
                    "type": "string",
                    "enum": [
                      "TOP_TOP",
                      "BOTTOM_TOP",
                      "BOTTOM_PARENT",
                      "BOTTOM_BOTTOM",
                      "LOCK_BOTTOM"
                    ]
                  },
                  "locked": true,
                  "targetComponent": true
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "componentProperties": {
          "type": "object",
          "properties": {},
          "additionalProperties": false
        },
        "themeData": {
          "type": "object",
          "properties": {},
          "additionalProperties": false
        },
        "variantsQuery": true,
        "fixerVersionsQuery": true,
        "themeConfigQuery": true
      },
      "additionalProperties": false
    },
    "Document": {
      "type": [
        "object"
      ],
      "properties": {
        "metaData": true,
        "id": true,
        "type": true,
        "parent": true,
        "dataQuery": true,
        "propertyQuery": true,
        "designQuery": true,
        "mobileHintsQuery": true,
        "behaviorQuery": true,
        "connectionQuery": true,
        "layoutQuery": true,
        "anchorQuery": true,
        "breakpointsQuery": true,
        "breakpointVariantsQuery": true,
        "transformationQuery": true,
        "transitionQuery": true,
        "variantsQuery": true,
        "styleId": true,
        "layout": {
          "type": "object",
          "properties": {
            "y": {
              "enum": [
                0
              ]
            },
            "rotationInDegrees": {
              "enum": [
                0
              ]
            },
            "anchors": {
              "type": [
                "null",
                "array"
              ],
              "items": {
                "type": "object",
                "properties": {
                  "distance": true,
                  "type": {
                    "type": "string",
                    "enum": [
                      "TOP_TOP",
                      "BOTTOM_TOP",
                      "BOTTOM_PARENT",
                      "BOTTOM_BOTTOM",
                      "LOCK_BOTTOM"
                    ]
                  },
                  "locked": true,
                  "targetComponent": true
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "classnamesQuery": true,
        "contentRoleQuery": true,
        "controllersQuery": true,
        "cursorQuery": true,
        "discussionsQuery": true,
        "editorsettingsQuery": true,
        "effectsQuery": true,
        "groupingQuery": true,
        "innerElementsQuery": true,
        "innerElementsMetaDataQuery": true,
        "intentQuery": true,
        "layoutSettingsQuery": true,
        "manifestQuery": true,
        "measurementsQuery": true,
        "migrationQuery": true,
        "namingQuery": true,
        "notificationsQuery": true,
        "pageSectionsQuery": true,
        "presetsQuery": true,
        "reactionsQuery": true,
        "slotsQuery": true,
        "sourceQuery": true,
        "statesQuery": true,
        "triggersQuery": true,
        "variablesQuery": true,
        "componentType": true,
        "skin": true,
        "modes": {
          "type": "object",
          "properties": {
            "definitions": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "label": true,
                  "modeId": true,
                  "params": true,
                  "settings": {
                    "type": "object",
                    "properties": {
                      "pagesGroupId": true
                    },
                    "additionalProperties": false
                  },
                  "type": {
                    "type": "string",
                    "enum": [
                      "HOVER",
                      "DEFAULT",
                      "SHOW_ON_SOME_PAGES",
                      "POPOVER"
                    ]
                  }
                },
                "additionalProperties": false
              }
            },
            "isHiddenByModes": true,
            "overrides": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "isHiddenByModes": true,
                  "modeIds": {
                    "type": "array",
                    "items": true
                  },
                  "layout": {
                    "type": "object",
                    "properties": {
                      "x": true,
                      "y": true,
                      "width": true,
                      "height": true,
                      "rotationInDegrees": true,
                      "fixedPosition": true,
                      "scale": true,
                      "docked": {
                        "type": "object",
                        "properties": {
                          "left": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          },
                          "right": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          },
                          "top": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          },
                          "bottom": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          },
                          "hCenter": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          },
                          "vCenter": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          }
                        },
                        "additionalProperties": false
                      },
                      "anchors": {
                        "type": [
                          "null",
                          "array"
                        ],
                        "items": {
                          "type": "object",
                          "properties": {
                            "distance": true,
                            "type": {
                              "type": "string",
                              "enum": [
                                "TOP_TOP",
                                "BOTTOM_TOP",
                                "BOTTOM_PARENT",
                                "BOTTOM_BOTTOM",
                                "LOCK_BOTTOM"
                              ]
                            },
                            "locked": true,
                            "targetComponent": true
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    "additionalProperties": false
                  },
                  "designQuery": true,
                  "propertyQuery": true,
                  "styleId": true
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "components": {
          "type": [
            "array",
            "null"
          ],
          "items": true
        },
        "documentType": {
          "enum": [
            "document"
          ]
        },
        "componentProperties": {
          "type": "object",
          "properties": {},
          "additionalProperties": false
        },
        "themeData": {
          "type": "object",
          "properties": {},
          "additionalProperties": false
        },
        "fixerVersionsQuery": true,
        "themeConfigQuery": true
      },
      "additionalProperties": false
    },
    "Parent": true,
    "ClassnamesQuery": true,
    "ContentRoleQuery": true,
    "ControllersQuery": true,
    "CursorQuery": true,
    "DiscussionsQuery": true,
    "EditorsettingsQuery": true,
    "EffectsQuery": true,
    "FixerVersionsQuery": true,
    "GroupingQuery": true,
    "InnerElementsQuery": true,
    "InnerElementsMetaDataQuery": true,
    "IntentQuery": true,
    "LayoutSettingsQuery": true,
    "ManifestQuery": true,
    "MeasurementsQuery": true,
    "MigrationQuery": true,
    "NamingQuery": true,
    "NotificationsQuery": true,
    "PageSectionsQuery": true,
    "PatternsQuery": true,
    "PresetsQuery": true,
    "ReactionsQuery": true,
    "SlotsQuery": true,
    "SourceQuery": true,
    "StatesQuery": true,
    "ThemeConfigQuery": true,
    "TriggersQuery": true,
    "VariablesQuery": true
  },
  "MOBILE.json": {
    "$id": "urn:dm:schemas:MOBILE.json",
    "DesignQuery": true,
    "DataQuery": true,
    "PropertyQuery": true,
    "VariantsQuery": true,
    "StyleId": true,
    "MobileHintsQuery": true,
    "BehaviorQuery": true,
    "ConnectionQuery": true,
    "LayoutQuery": true,
    "AnchorQuery": true,
    "BreakpointsQuery": true,
    "BreakpointVariantsQuery": true,
    "TransformationQuery": true,
    "TransitionQuery": true,
    "ModesDefinition": {
      "type": "object",
      "properties": {
        "definitions": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "label": true,
              "modeId": true,
              "params": true,
              "settings": {
                "type": "object",
                "properties": {
                  "pagesGroupId": true
                },
                "additionalProperties": false
              },
              "type": {
                "type": "string",
                "enum": [
                  "HOVER",
                  "DEFAULT",
                  "SHOW_ON_SOME_PAGES",
                  "POPOVER"
                ]
              }
            },
            "additionalProperties": false
          }
        },
        "isHiddenByModes": true,
        "overrides": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "isHiddenByModes": true,
              "modeIds": {
                "type": "array",
                "items": true
              },
              "layout": {
                "type": "object",
                "properties": {
                  "x": true,
                  "y": true,
                  "width": true,
                  "height": true,
                  "rotationInDegrees": true,
                  "fixedPosition": true,
                  "scale": true,
                  "docked": {
                    "type": "object",
                    "properties": {
                      "left": {
                        "type": "object",
                        "properties": {
                          "px": true,
                          "pct": true,
                          "vw": true,
                          "vh": true
                        },
                        "additionalProperties": false
                      },
                      "right": {
                        "type": "object",
                        "properties": {
                          "px": true,
                          "pct": true,
                          "vw": true,
                          "vh": true
                        },
                        "additionalProperties": false
                      },
                      "top": {
                        "type": "object",
                        "properties": {
                          "px": true,
                          "pct": true,
                          "vw": true,
                          "vh": true
                        },
                        "additionalProperties": false
                      },
                      "bottom": {
                        "type": "object",
                        "properties": {
                          "px": true,
                          "pct": true,
                          "vw": true,
                          "vh": true
                        },
                        "additionalProperties": false
                      },
                      "hCenter": {
                        "type": "object",
                        "properties": {
                          "px": true,
                          "pct": true,
                          "vw": true,
                          "vh": true
                        },
                        "additionalProperties": false
                      },
                      "vCenter": {
                        "type": "object",
                        "properties": {
                          "px": true,
                          "pct": true,
                          "vw": true,
                          "vh": true
                        },
                        "additionalProperties": false
                      }
                    },
                    "additionalProperties": false
                  },
                  "anchors": {
                    "type": [
                      "null",
                      "array"
                    ],
                    "items": {
                      "type": "object",
                      "properties": {
                        "distance": true,
                        "type": {
                          "type": "string",
                          "enum": [
                            "TOP_TOP",
                            "BOTTOM_TOP",
                            "BOTTOM_PARENT",
                            "BOTTOM_BOTTOM",
                            "LOCK_BOTTOM"
                          ]
                        },
                        "locked": true,
                        "targetComponent": true
                      },
                      "additionalProperties": false
                    }
                  }
                },
                "additionalProperties": false
              },
              "designQuery": true,
              "propertyQuery": true,
              "styleId": true
            },
            "additionalProperties": false
          }
        }
      },
      "additionalProperties": false
    },
    "AnchorDefinition": {
      "type": "object",
      "properties": {
        "distance": true,
        "type": {
          "type": "string",
          "enum": [
            "TOP_TOP",
            "BOTTOM_TOP",
            "BOTTOM_PARENT",
            "BOTTOM_BOTTOM",
            "LOCK_BOTTOM"
          ]
        },
        "locked": true,
        "targetComponent": true
      },
      "additionalProperties": false
    },
    "PartialLayoutObjectForMasterPage": {
      "type": "object",
      "properties": {
        "y": {
          "enum": [
            0
          ]
        },
        "rotationInDegrees": {
          "enum": [
            0
          ]
        },
        "anchors": {
          "type": [
            "null",
            "array"
          ],
          "items": {
            "type": "object",
            "properties": {
              "distance": true,
              "type": {
                "type": "string",
                "enum": [
                  "TOP_TOP",
                  "BOTTOM_TOP",
                  "BOTTOM_PARENT",
                  "BOTTOM_BOTTOM",
                  "LOCK_BOTTOM"
                ]
              },
              "locked": true,
              "targetComponent": true
            },
            "additionalProperties": false
          }
        }
      },
      "additionalProperties": false
    },
    "DockingUnitSize": {
      "type": "object",
      "properties": {
        "px": true,
        "pct": true,
        "vw": true,
        "vh": true
      },
      "additionalProperties": false
    },
    "DockingDefinition": {
      "type": "object",
      "properties": {
        "left": {
          "type": "object",
          "properties": {
            "px": true,
            "pct": true,
            "vw": true,
            "vh": true
          },
          "additionalProperties": false
        },
        "right": {
          "type": "object",
          "properties": {
            "px": true,
            "pct": true,
            "vw": true,
            "vh": true
          },
          "additionalProperties": false
        },
        "top": {
          "type": "object",
          "properties": {
            "px": true,
            "pct": true,
            "vw": true,
            "vh": true
          },
          "additionalProperties": false
        },
        "bottom": {
          "type": "object",
          "properties": {
            "px": true,
            "pct": true,
            "vw": true,
            "vh": true
          },
          "additionalProperties": false
        },
        "hCenter": {
          "type": "object",
          "properties": {
            "px": true,
            "pct": true,
            "vw": true,
            "vh": true
          },
          "additionalProperties": false
        },
        "vCenter": {
          "type": "object",
          "properties": {
            "px": true,
            "pct": true,
            "vw": true,
            "vh": true
          },
          "additionalProperties": false
        }
      },
      "additionalProperties": false
    },
    "BaseComponentObject": {
      "type": "object",
      "properties": {
        "metaData": true,
        "id": true,
        "type": true,
        "parent": true
      },
      "additionalProperties": false
    },
    "MetaDataForComponents": {
      "type": "object",
      "properties": {},
      "additionalProperties": false
    },
    "LayoutObjectForComponents": {
      "type": "object",
      "properties": {
        "x": true,
        "y": true,
        "width": true,
        "height": true,
        "rotationInDegrees": true,
        "fixedPosition": true,
        "scale": true,
        "docked": {
          "type": "object",
          "properties": {
            "left": {
              "type": "object",
              "properties": {
                "px": true,
                "pct": true,
                "vw": true,
                "vh": true
              },
              "additionalProperties": false
            },
            "right": {
              "type": "object",
              "properties": {
                "px": true,
                "pct": true,
                "vw": true,
                "vh": true
              },
              "additionalProperties": false
            },
            "top": {
              "type": "object",
              "properties": {
                "px": true,
                "pct": true,
                "vw": true,
                "vh": true
              },
              "additionalProperties": false
            },
            "bottom": {
              "type": "object",
              "properties": {
                "px": true,
                "pct": true,
                "vw": true,
                "vh": true
              },
              "additionalProperties": false
            },
            "hCenter": {
              "type": "object",
              "properties": {
                "px": true,
                "pct": true,
                "vw": true,
                "vh": true
              },
              "additionalProperties": false
            },
            "vCenter": {
              "type": "object",
              "properties": {
                "px": true,
                "pct": true,
                "vw": true,
                "vh": true
              },
              "additionalProperties": false
            }
          },
          "additionalProperties": false
        },
        "anchors": {
          "type": [
            "null",
            "array"
          ],
          "items": {
            "type": "object",
            "properties": {
              "distance": true,
              "type": {
                "type": "string",
                "enum": [
                  "TOP_TOP",
                  "BOTTOM_TOP",
                  "BOTTOM_PARENT",
                  "BOTTOM_BOTTOM",
                  "LOCK_BOTTOM"
                ]
              },
              "locked": true,
              "targetComponent": true
            },
            "additionalProperties": false
          }
        }
      },
      "additionalProperties": false
    },
    "ShouldReallyBeAnIntAtSomePoint": true,
    "ComponentsList": {
      "type": [
        "array",
        "null"
      ],
      "items": true
    },
    "Component": {
      "type": [
        "object"
      ],
      "properties": {
        "metaData": true,
        "id": true,
        "type": true,
        "parent": true,
        "dataQuery": true,
        "propertyQuery": true,
        "designQuery": true,
        "mobileHintsQuery": true,
        "behaviorQuery": true,
        "connectionQuery": true,
        "layoutQuery": true,
        "anchorQuery": true,
        "breakpointsQuery": true,
        "breakpointVariantsQuery": true,
        "transformationQuery": true,
        "transitionQuery": true,
        "variantsQuery": true,
        "styleId": true,
        "layout": {
          "type": "object",
          "properties": {
            "x": true,
            "y": true,
            "width": true,
            "height": true,
            "rotationInDegrees": true,
            "fixedPosition": true,
            "scale": true,
            "docked": {
              "type": "object",
              "properties": {
                "left": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                },
                "right": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                },
                "top": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                },
                "bottom": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                },
                "hCenter": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                },
                "vCenter": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            "anchors": {
              "type": [
                "null",
                "array"
              ],
              "items": {
                "type": "object",
                "properties": {
                  "distance": true,
                  "type": {
                    "type": "string",
                    "enum": [
                      "TOP_TOP",
                      "BOTTOM_TOP",
                      "BOTTOM_PARENT",
                      "BOTTOM_BOTTOM",
                      "LOCK_BOTTOM"
                    ]
                  },
                  "locked": true,
                  "targetComponent": true
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "classnamesQuery": true,
        "contentRoleQuery": true,
        "controllersQuery": true,
        "cursorQuery": true,
        "discussionsQuery": true,
        "editorsettingsQuery": true,
        "effectsQuery": true,
        "groupingQuery": true,
        "innerElementsQuery": true,
        "innerElementsMetaDataQuery": true,
        "intentQuery": true,
        "layoutSettingsQuery": true,
        "manifestQuery": true,
        "measurementsQuery": true,
        "migrationQuery": true,
        "namingQuery": true,
        "notificationsQuery": true,
        "pageSectionsQuery": true,
        "presetsQuery": true,
        "reactionsQuery": true,
        "slotsQuery": true,
        "sourceQuery": true,
        "statesQuery": true,
        "triggersQuery": true,
        "variablesQuery": true,
        "componentType": true,
        "skin": true,
        "modes": {
          "type": "object",
          "properties": {
            "definitions": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "label": true,
                  "modeId": true,
                  "params": true,
                  "settings": {
                    "type": "object",
                    "properties": {
                      "pagesGroupId": true
                    },
                    "additionalProperties": false
                  },
                  "type": {
                    "type": "string",
                    "enum": [
                      "HOVER",
                      "DEFAULT",
                      "SHOW_ON_SOME_PAGES",
                      "POPOVER"
                    ]
                  }
                },
                "additionalProperties": false
              }
            },
            "isHiddenByModes": true,
            "overrides": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "isHiddenByModes": true,
                  "modeIds": {
                    "type": "array",
                    "items": true
                  },
                  "layout": {
                    "type": "object",
                    "properties": {
                      "x": true,
                      "y": true,
                      "width": true,
                      "height": true,
                      "rotationInDegrees": true,
                      "fixedPosition": true,
                      "scale": true,
                      "docked": {
                        "type": "object",
                        "properties": {
                          "left": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          },
                          "right": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          },
                          "top": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          },
                          "bottom": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          },
                          "hCenter": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          },
                          "vCenter": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          }
                        },
                        "additionalProperties": false
                      },
                      "anchors": {
                        "type": [
                          "null",
                          "array"
                        ],
                        "items": {
                          "type": "object",
                          "properties": {
                            "distance": true,
                            "type": {
                              "type": "string",
                              "enum": [
                                "TOP_TOP",
                                "BOTTOM_TOP",
                                "BOTTOM_PARENT",
                                "BOTTOM_BOTTOM",
                                "LOCK_BOTTOM"
                              ]
                            },
                            "locked": true,
                            "targetComponent": true
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    "additionalProperties": false
                  },
                  "designQuery": true,
                  "propertyQuery": true,
                  "styleId": true
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        }
      },
      "additionalProperties": false
    },
    "ComponentQueries": {
      "type": "object",
      "properties": {
        "dataQuery": true,
        "propertyQuery": true,
        "designQuery": true,
        "mobileHintsQuery": true,
        "behaviorQuery": true,
        "connectionQuery": true,
        "layoutQuery": true,
        "anchorQuery": true,
        "breakpointsQuery": true,
        "breakpointVariantsQuery": true,
        "transformationQuery": true,
        "transitionQuery": true,
        "variantsQuery": true,
        "styleId": true,
        "layout": {
          "type": "object",
          "properties": {
            "x": true,
            "y": true,
            "width": true,
            "height": true,
            "rotationInDegrees": true,
            "fixedPosition": true,
            "scale": true,
            "docked": {
              "type": "object",
              "properties": {
                "left": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                },
                "right": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                },
                "top": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                },
                "bottom": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                },
                "hCenter": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                },
                "vCenter": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            "anchors": {
              "type": [
                "null",
                "array"
              ],
              "items": {
                "type": "object",
                "properties": {
                  "distance": true,
                  "type": {
                    "type": "string",
                    "enum": [
                      "TOP_TOP",
                      "BOTTOM_TOP",
                      "BOTTOM_PARENT",
                      "BOTTOM_BOTTOM",
                      "LOCK_BOTTOM"
                    ]
                  },
                  "locked": true,
                  "targetComponent": true
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "classnamesQuery": true,
        "contentRoleQuery": true,
        "controllersQuery": true,
        "cursorQuery": true,
        "discussionsQuery": true,
        "editorsettingsQuery": true,
        "effectsQuery": true,
        "groupingQuery": true,
        "innerElementsQuery": true,
        "innerElementsMetaDataQuery": true,
        "intentQuery": true,
        "layoutSettingsQuery": true,
        "manifestQuery": true,
        "measurementsQuery": true,
        "migrationQuery": true,
        "namingQuery": true,
        "notificationsQuery": true,
        "pageSectionsQuery": true,
        "presetsQuery": true,
        "reactionsQuery": true,
        "slotsQuery": true,
        "sourceQuery": true,
        "statesQuery": true,
        "triggersQuery": true,
        "variablesQuery": true
      },
      "additionalProperties": false
    },
    "RefComponent": {
      "type": [
        "object"
      ],
      "properties": {
        "metaData": true,
        "id": true,
        "type": true,
        "parent": true,
        "dataQuery": true,
        "propertyQuery": true,
        "designQuery": true,
        "mobileHintsQuery": true,
        "behaviorQuery": true,
        "connectionQuery": true,
        "layoutQuery": true,
        "anchorQuery": true,
        "breakpointsQuery": true,
        "breakpointVariantsQuery": true,
        "transformationQuery": true,
        "transitionQuery": true,
        "variantsQuery": true,
        "styleId": true,
        "layout": {
          "type": "object",
          "properties": {
            "x": true,
            "y": true,
            "width": true,
            "height": true,
            "rotationInDegrees": true,
            "fixedPosition": true,
            "scale": true,
            "docked": {
              "type": "object",
              "properties": {
                "left": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                },
                "right": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                },
                "top": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                },
                "bottom": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                },
                "hCenter": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                },
                "vCenter": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            "anchors": {
              "type": [
                "null",
                "array"
              ],
              "items": {
                "type": "object",
                "properties": {
                  "distance": true,
                  "type": {
                    "type": "string",
                    "enum": [
                      "TOP_TOP",
                      "BOTTOM_TOP",
                      "BOTTOM_PARENT",
                      "BOTTOM_BOTTOM",
                      "LOCK_BOTTOM"
                    ]
                  },
                  "locked": true,
                  "targetComponent": true
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "classnamesQuery": true,
        "contentRoleQuery": true,
        "controllersQuery": true,
        "cursorQuery": true,
        "discussionsQuery": true,
        "editorsettingsQuery": true,
        "effectsQuery": true,
        "groupingQuery": true,
        "innerElementsQuery": true,
        "innerElementsMetaDataQuery": true,
        "intentQuery": true,
        "layoutSettingsQuery": true,
        "manifestQuery": true,
        "measurementsQuery": true,
        "migrationQuery": true,
        "namingQuery": true,
        "notificationsQuery": true,
        "pageSectionsQuery": true,
        "presetsQuery": true,
        "reactionsQuery": true,
        "slotsQuery": true,
        "sourceQuery": true,
        "statesQuery": true,
        "triggersQuery": true,
        "variablesQuery": true,
        "componentType": true,
        "skin": true,
        "modes": {
          "type": "object",
          "properties": {
            "definitions": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "label": true,
                  "modeId": true,
                  "params": true,
                  "settings": {
                    "type": "object",
                    "properties": {
                      "pagesGroupId": true
                    },
                    "additionalProperties": false
                  },
                  "type": {
                    "type": "string",
                    "enum": [
                      "HOVER",
                      "DEFAULT",
                      "SHOW_ON_SOME_PAGES",
                      "POPOVER"
                    ]
                  }
                },
                "additionalProperties": false
              }
            },
            "isHiddenByModes": true,
            "overrides": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "isHiddenByModes": true,
                  "modeIds": {
                    "type": "array",
                    "items": true
                  },
                  "layout": {
                    "type": "object",
                    "properties": {
                      "x": true,
                      "y": true,
                      "width": true,
                      "height": true,
                      "rotationInDegrees": true,
                      "fixedPosition": true,
                      "scale": true,
                      "docked": {
                        "type": "object",
                        "properties": {
                          "left": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          },
                          "right": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          },
                          "top": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          },
                          "bottom": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          },
                          "hCenter": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          },
                          "vCenter": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          }
                        },
                        "additionalProperties": false
                      },
                      "anchors": {
                        "type": [
                          "null",
                          "array"
                        ],
                        "items": {
                          "type": "object",
                          "properties": {
                            "distance": true,
                            "type": {
                              "type": "string",
                              "enum": [
                                "TOP_TOP",
                                "BOTTOM_TOP",
                                "BOTTOM_PARENT",
                                "BOTTOM_BOTTOM",
                                "LOCK_BOTTOM"
                              ]
                            },
                            "locked": true,
                            "targetComponent": true
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    "additionalProperties": false
                  },
                  "designQuery": true,
                  "propertyQuery": true,
                  "styleId": true
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "components": {
          "type": [
            "array",
            "null"
          ],
          "items": true
        }
      },
      "additionalProperties": false
    },
    "RepeaterContainer": {
      "type": [
        "object"
      ],
      "properties": {
        "metaData": true,
        "id": true,
        "type": true,
        "parent": true,
        "dataQuery": true,
        "propertyQuery": true,
        "designQuery": true,
        "mobileHintsQuery": true,
        "behaviorQuery": true,
        "connectionQuery": true,
        "layoutQuery": true,
        "anchorQuery": true,
        "breakpointsQuery": true,
        "breakpointVariantsQuery": true,
        "transformationQuery": true,
        "transitionQuery": true,
        "variantsQuery": true,
        "styleId": true,
        "layout": {
          "type": "object",
          "properties": {
            "x": true,
            "y": true,
            "width": true,
            "height": true,
            "rotationInDegrees": true,
            "fixedPosition": true,
            "scale": true,
            "docked": {
              "type": "object",
              "properties": {
                "left": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                },
                "right": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                },
                "top": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                },
                "bottom": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                },
                "hCenter": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                },
                "vCenter": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            "anchors": {
              "type": [
                "null",
                "array"
              ],
              "items": {
                "type": "object",
                "properties": {
                  "distance": true,
                  "type": {
                    "type": "string",
                    "enum": [
                      "TOP_TOP",
                      "BOTTOM_TOP",
                      "BOTTOM_PARENT",
                      "BOTTOM_BOTTOM",
                      "LOCK_BOTTOM"
                    ]
                  },
                  "locked": true,
                  "targetComponent": true
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "classnamesQuery": true,
        "contentRoleQuery": true,
        "controllersQuery": true,
        "cursorQuery": true,
        "discussionsQuery": true,
        "editorsettingsQuery": true,
        "effectsQuery": true,
        "groupingQuery": true,
        "innerElementsQuery": true,
        "innerElementsMetaDataQuery": true,
        "intentQuery": true,
        "layoutSettingsQuery": true,
        "manifestQuery": true,
        "measurementsQuery": true,
        "migrationQuery": true,
        "namingQuery": true,
        "notificationsQuery": true,
        "pageSectionsQuery": true,
        "presetsQuery": true,
        "reactionsQuery": true,
        "slotsQuery": true,
        "sourceQuery": true,
        "statesQuery": true,
        "triggersQuery": true,
        "variablesQuery": true,
        "componentType": true,
        "skin": true,
        "modes": {
          "type": "object",
          "properties": {
            "definitions": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "label": true,
                  "modeId": true,
                  "params": true,
                  "settings": {
                    "type": "object",
                    "properties": {
                      "pagesGroupId": true
                    },
                    "additionalProperties": false
                  },
                  "type": {
                    "type": "string",
                    "enum": [
                      "HOVER",
                      "DEFAULT",
                      "SHOW_ON_SOME_PAGES",
                      "POPOVER"
                    ]
                  }
                },
                "additionalProperties": false
              }
            },
            "isHiddenByModes": true,
            "overrides": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "isHiddenByModes": true,
                  "modeIds": {
                    "type": "array",
                    "items": true
                  },
                  "layout": {
                    "type": "object",
                    "properties": {
                      "x": true,
                      "y": true,
                      "width": true,
                      "height": true,
                      "rotationInDegrees": true,
                      "fixedPosition": true,
                      "scale": true,
                      "docked": {
                        "type": "object",
                        "properties": {
                          "left": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          },
                          "right": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          },
                          "top": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          },
                          "bottom": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          },
                          "hCenter": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          },
                          "vCenter": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          }
                        },
                        "additionalProperties": false
                      },
                      "anchors": {
                        "type": [
                          "null",
                          "array"
                        ],
                        "items": {
                          "type": "object",
                          "properties": {
                            "distance": true,
                            "type": {
                              "type": "string",
                              "enum": [
                                "TOP_TOP",
                                "BOTTOM_TOP",
                                "BOTTOM_PARENT",
                                "BOTTOM_BOTTOM",
                                "LOCK_BOTTOM"
                              ]
                            },
                            "locked": true,
                            "targetComponent": true
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    "additionalProperties": false
                  },
                  "designQuery": true,
                  "propertyQuery": true,
                  "styleId": true
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "components": {
          "type": [
            "array",
            "null"
          ],
          "items": true
        },
        "patternsQuery": true
      },
      "additionalProperties": false
    },
    "RepeaterVariantsQuery": true,
    "RepeaterQueries": {
      "type": "object",
      "properties": {
        "variantsQuery": true,
        "patternsQuery": true
      },
      "additionalProperties": false
    },
    "Container": {
      "type": [
        "object"
      ],
      "properties": {
        "metaData": true,
        "id": true,
        "type": true,
        "parent": true,
        "dataQuery": true,
        "propertyQuery": true,
        "designQuery": true,
        "mobileHintsQuery": true,
        "behaviorQuery": true,
        "connectionQuery": true,
        "layoutQuery": true,
        "anchorQuery": true,
        "breakpointsQuery": true,
        "breakpointVariantsQuery": true,
        "transformationQuery": true,
        "transitionQuery": true,
        "variantsQuery": true,
        "styleId": true,
        "layout": {
          "type": "object",
          "properties": {
            "x": true,
            "y": true,
            "width": true,
            "height": true,
            "rotationInDegrees": true,
            "fixedPosition": true,
            "scale": true,
            "docked": {
              "type": "object",
              "properties": {
                "left": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                },
                "right": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                },
                "top": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                },
                "bottom": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                },
                "hCenter": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                },
                "vCenter": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            "anchors": {
              "type": [
                "null",
                "array"
              ],
              "items": {
                "type": "object",
                "properties": {
                  "distance": true,
                  "type": {
                    "type": "string",
                    "enum": [
                      "TOP_TOP",
                      "BOTTOM_TOP",
                      "BOTTOM_PARENT",
                      "BOTTOM_BOTTOM",
                      "LOCK_BOTTOM"
                    ]
                  },
                  "locked": true,
                  "targetComponent": true
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "classnamesQuery": true,
        "contentRoleQuery": true,
        "controllersQuery": true,
        "cursorQuery": true,
        "discussionsQuery": true,
        "editorsettingsQuery": true,
        "effectsQuery": true,
        "groupingQuery": true,
        "innerElementsQuery": true,
        "innerElementsMetaDataQuery": true,
        "intentQuery": true,
        "layoutSettingsQuery": true,
        "manifestQuery": true,
        "measurementsQuery": true,
        "migrationQuery": true,
        "namingQuery": true,
        "notificationsQuery": true,
        "pageSectionsQuery": true,
        "presetsQuery": true,
        "reactionsQuery": true,
        "slotsQuery": true,
        "sourceQuery": true,
        "statesQuery": true,
        "triggersQuery": true,
        "variablesQuery": true,
        "componentType": true,
        "skin": true,
        "modes": {
          "type": "object",
          "properties": {
            "definitions": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "label": true,
                  "modeId": true,
                  "params": true,
                  "settings": {
                    "type": "object",
                    "properties": {
                      "pagesGroupId": true
                    },
                    "additionalProperties": false
                  },
                  "type": {
                    "type": "string",
                    "enum": [
                      "HOVER",
                      "DEFAULT",
                      "SHOW_ON_SOME_PAGES",
                      "POPOVER"
                    ]
                  }
                },
                "additionalProperties": false
              }
            },
            "isHiddenByModes": true,
            "overrides": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "isHiddenByModes": true,
                  "modeIds": {
                    "type": "array",
                    "items": true
                  },
                  "layout": {
                    "type": "object",
                    "properties": {
                      "x": true,
                      "y": true,
                      "width": true,
                      "height": true,
                      "rotationInDegrees": true,
                      "fixedPosition": true,
                      "scale": true,
                      "docked": {
                        "type": "object",
                        "properties": {
                          "left": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          },
                          "right": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          },
                          "top": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          },
                          "bottom": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          },
                          "hCenter": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          },
                          "vCenter": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          }
                        },
                        "additionalProperties": false
                      },
                      "anchors": {
                        "type": [
                          "null",
                          "array"
                        ],
                        "items": {
                          "type": "object",
                          "properties": {
                            "distance": true,
                            "type": {
                              "type": "string",
                              "enum": [
                                "TOP_TOP",
                                "BOTTOM_TOP",
                                "BOTTOM_PARENT",
                                "BOTTOM_BOTTOM",
                                "LOCK_BOTTOM"
                              ]
                            },
                            "locked": true,
                            "targetComponent": true
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    "additionalProperties": false
                  },
                  "designQuery": true,
                  "propertyQuery": true,
                  "styleId": true
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "components": {
          "type": [
            "array",
            "null"
          ],
          "items": true
        }
      },
      "additionalProperties": false
    },
    "PageQueries": {
      "type": "object",
      "properties": {
        "fixerVersionsQuery": true
      },
      "additionalProperties": false
    },
    "Page": {
      "type": [
        "object"
      ],
      "properties": {
        "metaData": true,
        "id": true,
        "type": true,
        "parent": true,
        "dataQuery": true,
        "propertyQuery": true,
        "designQuery": true,
        "mobileHintsQuery": true,
        "behaviorQuery": true,
        "connectionQuery": true,
        "layoutQuery": true,
        "anchorQuery": true,
        "breakpointsQuery": true,
        "breakpointVariantsQuery": true,
        "transformationQuery": true,
        "transitionQuery": true,
        "variantsQuery": true,
        "styleId": true,
        "layout": {
          "type": "object",
          "properties": {
            "x": true,
            "y": true,
            "width": true,
            "height": true,
            "rotationInDegrees": true,
            "fixedPosition": true,
            "scale": true,
            "docked": {
              "type": "object",
              "properties": {
                "left": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                },
                "right": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                },
                "top": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                },
                "bottom": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                },
                "hCenter": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                },
                "vCenter": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            "anchors": {
              "type": [
                "null",
                "array"
              ],
              "items": {
                "type": "object",
                "properties": {
                  "distance": true,
                  "type": {
                    "type": "string",
                    "enum": [
                      "TOP_TOP",
                      "BOTTOM_TOP",
                      "BOTTOM_PARENT",
                      "BOTTOM_BOTTOM",
                      "LOCK_BOTTOM"
                    ]
                  },
                  "locked": true,
                  "targetComponent": true
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "classnamesQuery": true,
        "contentRoleQuery": true,
        "controllersQuery": true,
        "cursorQuery": true,
        "discussionsQuery": true,
        "editorsettingsQuery": true,
        "effectsQuery": true,
        "groupingQuery": true,
        "innerElementsQuery": true,
        "innerElementsMetaDataQuery": true,
        "intentQuery": true,
        "layoutSettingsQuery": true,
        "manifestQuery": true,
        "measurementsQuery": true,
        "migrationQuery": true,
        "namingQuery": true,
        "notificationsQuery": true,
        "pageSectionsQuery": true,
        "presetsQuery": true,
        "reactionsQuery": true,
        "slotsQuery": true,
        "sourceQuery": true,
        "statesQuery": true,
        "triggersQuery": true,
        "variablesQuery": true,
        "componentType": true,
        "skin": true,
        "modes": {
          "type": "object",
          "properties": {
            "definitions": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "label": true,
                  "modeId": true,
                  "params": true,
                  "settings": {
                    "type": "object",
                    "properties": {
                      "pagesGroupId": true
                    },
                    "additionalProperties": false
                  },
                  "type": {
                    "type": "string",
                    "enum": [
                      "HOVER",
                      "DEFAULT",
                      "SHOW_ON_SOME_PAGES",
                      "POPOVER"
                    ]
                  }
                },
                "additionalProperties": false
              }
            },
            "isHiddenByModes": true,
            "overrides": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "isHiddenByModes": true,
                  "modeIds": {
                    "type": "array",
                    "items": true
                  },
                  "layout": {
                    "type": "object",
                    "properties": {
                      "x": true,
                      "y": true,
                      "width": true,
                      "height": true,
                      "rotationInDegrees": true,
                      "fixedPosition": true,
                      "scale": true,
                      "docked": {
                        "type": "object",
                        "properties": {
                          "left": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          },
                          "right": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          },
                          "top": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          },
                          "bottom": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          },
                          "hCenter": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          },
                          "vCenter": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          }
                        },
                        "additionalProperties": false
                      },
                      "anchors": {
                        "type": [
                          "null",
                          "array"
                        ],
                        "items": {
                          "type": "object",
                          "properties": {
                            "distance": true,
                            "type": {
                              "type": "string",
                              "enum": [
                                "TOP_TOP",
                                "BOTTOM_TOP",
                                "BOTTOM_PARENT",
                                "BOTTOM_BOTTOM",
                                "LOCK_BOTTOM"
                              ]
                            },
                            "locked": true,
                            "targetComponent": true
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    "additionalProperties": false
                  },
                  "designQuery": true,
                  "propertyQuery": true,
                  "styleId": true
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "components": {
          "type": [
            "array",
            "null"
          ],
          "items": true
        },
        "fixerVersionsQuery": true
      },
      "additionalProperties": false
    },
    "DocumentProperties": {
      "type": "object",
      "properties": {
        "documentType": {
          "enum": [
            "document"
          ]
        },
        "layout": {
          "type": "object",
          "properties": {
            "y": {
              "enum": [
                0
              ]
            },
            "rotationInDegrees": {
              "enum": [
                0
              ]
            },
            "anchors": {
              "type": [
                "null",
                "array"
              ],
              "items": {
                "type": "object",
                "properties": {
                  "distance": true,
                  "type": {
                    "type": "string",
                    "enum": [
                      "TOP_TOP",
                      "BOTTOM_TOP",
                      "BOTTOM_PARENT",
                      "BOTTOM_BOTTOM",
                      "LOCK_BOTTOM"
                    ]
                  },
                  "locked": true,
                  "targetComponent": true
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "componentProperties": {
          "type": "object",
          "properties": {},
          "additionalProperties": false
        },
        "themeData": {
          "type": "object",
          "properties": {},
          "additionalProperties": false
        },
        "variantsQuery": true,
        "fixerVersionsQuery": true,
        "themeConfigQuery": true
      },
      "additionalProperties": false
    },
    "Document": {
      "type": [
        "object"
      ],
      "properties": {
        "metaData": true,
        "id": true,
        "type": true,
        "parent": true,
        "dataQuery": true,
        "propertyQuery": true,
        "designQuery": true,
        "mobileHintsQuery": true,
        "behaviorQuery": true,
        "connectionQuery": true,
        "layoutQuery": true,
        "anchorQuery": true,
        "breakpointsQuery": true,
        "breakpointVariantsQuery": true,
        "transformationQuery": true,
        "transitionQuery": true,
        "variantsQuery": true,
        "styleId": true,
        "layout": {
          "type": "object",
          "properties": {
            "y": {
              "enum": [
                0
              ]
            },
            "rotationInDegrees": {
              "enum": [
                0
              ]
            },
            "anchors": {
              "type": [
                "null",
                "array"
              ],
              "items": {
                "type": "object",
                "properties": {
                  "distance": true,
                  "type": {
                    "type": "string",
                    "enum": [
                      "TOP_TOP",
                      "BOTTOM_TOP",
                      "BOTTOM_PARENT",
                      "BOTTOM_BOTTOM",
                      "LOCK_BOTTOM"
                    ]
                  },
                  "locked": true,
                  "targetComponent": true
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "classnamesQuery": true,
        "contentRoleQuery": true,
        "controllersQuery": true,
        "cursorQuery": true,
        "discussionsQuery": true,
        "editorsettingsQuery": true,
        "effectsQuery": true,
        "groupingQuery": true,
        "innerElementsQuery": true,
        "innerElementsMetaDataQuery": true,
        "intentQuery": true,
        "layoutSettingsQuery": true,
        "manifestQuery": true,
        "measurementsQuery": true,
        "migrationQuery": true,
        "namingQuery": true,
        "notificationsQuery": true,
        "pageSectionsQuery": true,
        "presetsQuery": true,
        "reactionsQuery": true,
        "slotsQuery": true,
        "sourceQuery": true,
        "statesQuery": true,
        "triggersQuery": true,
        "variablesQuery": true,
        "componentType": true,
        "skin": true,
        "modes": {
          "type": "object",
          "properties": {
            "definitions": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "label": true,
                  "modeId": true,
                  "params": true,
                  "settings": {
                    "type": "object",
                    "properties": {
                      "pagesGroupId": true
                    },
                    "additionalProperties": false
                  },
                  "type": {
                    "type": "string",
                    "enum": [
                      "HOVER",
                      "DEFAULT",
                      "SHOW_ON_SOME_PAGES",
                      "POPOVER"
                    ]
                  }
                },
                "additionalProperties": false
              }
            },
            "isHiddenByModes": true,
            "overrides": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "isHiddenByModes": true,
                  "modeIds": {
                    "type": "array",
                    "items": true
                  },
                  "layout": {
                    "type": "object",
                    "properties": {
                      "x": true,
                      "y": true,
                      "width": true,
                      "height": true,
                      "rotationInDegrees": true,
                      "fixedPosition": true,
                      "scale": true,
                      "docked": {
                        "type": "object",
                        "properties": {
                          "left": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          },
                          "right": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          },
                          "top": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          },
                          "bottom": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          },
                          "hCenter": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          },
                          "vCenter": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          }
                        },
                        "additionalProperties": false
                      },
                      "anchors": {
                        "type": [
                          "null",
                          "array"
                        ],
                        "items": {
                          "type": "object",
                          "properties": {
                            "distance": true,
                            "type": {
                              "type": "string",
                              "enum": [
                                "TOP_TOP",
                                "BOTTOM_TOP",
                                "BOTTOM_PARENT",
                                "BOTTOM_BOTTOM",
                                "LOCK_BOTTOM"
                              ]
                            },
                            "locked": true,
                            "targetComponent": true
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    "additionalProperties": false
                  },
                  "designQuery": true,
                  "propertyQuery": true,
                  "styleId": true
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "components": {
          "type": [
            "array",
            "null"
          ],
          "items": true
        },
        "documentType": {
          "enum": [
            "document"
          ]
        },
        "componentProperties": {
          "type": "object",
          "properties": {},
          "additionalProperties": false
        },
        "themeData": {
          "type": "object",
          "properties": {},
          "additionalProperties": false
        },
        "fixerVersionsQuery": true,
        "themeConfigQuery": true
      },
      "additionalProperties": false
    },
    "Parent": true,
    "ClassnamesQuery": true,
    "ContentRoleQuery": true,
    "ControllersQuery": true,
    "CursorQuery": true,
    "DiscussionsQuery": true,
    "EditorsettingsQuery": true,
    "EffectsQuery": true,
    "FixerVersionsQuery": true,
    "GroupingQuery": true,
    "InnerElementsQuery": true,
    "InnerElementsMetaDataQuery": true,
    "IntentQuery": true,
    "LayoutSettingsQuery": true,
    "ManifestQuery": true,
    "MeasurementsQuery": true,
    "MigrationQuery": true,
    "NamingQuery": true,
    "NotificationsQuery": true,
    "PageSectionsQuery": true,
    "PatternsQuery": true,
    "PresetsQuery": true,
    "ReactionsQuery": true,
    "SlotsQuery": true,
    "SourceQuery": true,
    "StatesQuery": true,
    "ThemeConfigQuery": true,
    "TriggersQuery": true,
    "VariablesQuery": true
  },
  "anchors_data.json": {
    "$id": "urn:dm:schemas:anchors_data.json",
    "AnchorInfo": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "name": true,
        "urlFragment": true
      },
      "additionalProperties": false
    }
  },
  "atomicScopes.json": {
    "$id": "urn:dm:schemas:atomicScopes.json",
    "AtomicScope": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true
      },
      "additionalProperties": false
    }
  },
  "behaviors_data.json": {
    "$id": "urn:dm:schemas:behaviors_data.json",
    "ObsoleteBehaviorsList": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "items": true
      },
      "additionalProperties": false
    }
  },
  "breakpoints_data.json": {
    "$id": "urn:dm:schemas:breakpoints_data.json",
    "BreakpointsData": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "values": {
          "type": [
            "array",
            "null"
          ],
          "items": true
        },
        "componentId": true
      },
      "additionalProperties": false
    },
    "BreakpointRange": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "min": true,
        "max": true,
        "canvasSize": true
      },
      "additionalProperties": false
    }
  },
  "classnames.json": {
    "$id": "urn:dm:schemas:classnames.json",
    "Classnames": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "classnames": {
          "type": "array",
          "items": {
            "type": "string",
            "pattern": "^-?[_a-zA-Z]+[_a-zA-Z0-9-]*$"
          }
        }
      },
      "additionalProperties": false
    }
  },
  "commonSchemas.json": {
    "$id": "urn:dm:schemas:commonSchemas.json",
    "RefArray": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "values": {
          "type": [
            "array"
          ],
          "items": true
        }
      },
      "additionalProperties": false
    },
    "BreakpointRelation": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "breakpoint": true,
        "ref": true
      },
      "additionalProperties": false
    },
    "VariantRelation": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "variants": {
          "type": "array",
          "items": true
        },
        "remoteVariants": {
          "type": "array",
          "items": true
        },
        "from": true,
        "to": true
      },
      "additionalProperties": false
    },
    "MinimalUnitSize": {
      "type": "object",
      "properties": {
        "value": true,
        "type": {
          "enum": [
            "px",
            "percentage"
          ]
        }
      },
      "additionalProperties": false
    },
    "UnitSize": {
      "type": "object",
      "properties": {
        "value": true,
        "type": {
          "enum": [
            "px",
            "em",
            "rem",
            "fr",
            "percentage",
            "vh",
            "vw",
            "spx",
            "siteWidthPercentage"
          ]
        }
      },
      "additionalProperties": false
    },
    "SPXReferenceDefinition": {
      "type": "object",
      "properties": {
        "refWidth": true,
        "resolverType": {
          "type": "string",
          "enum": [
            "scale",
            "fixed"
          ]
        }
      },
      "additionalProperties": false
    },
    "UnitLength": {
      "type": "object",
      "properties": {
        "value": true,
        "type": {
          "enum": [
            "px",
            "em",
            "rem",
            "vh",
            "vw",
            "vmin",
            "vmax"
          ]
        }
      },
      "additionalProperties": false
    },
    "UnitLengthPercentage": {
      "type": "object",
      "properties": {
        "value": true,
        "type": {
          "enum": [
            "px",
            "em",
            "rem",
            "percentage",
            "vh",
            "vw",
            "vmin",
            "vmax"
          ]
        }
      },
      "additionalProperties": false
    },
    "UnitAngle": {
      "type": "object",
      "properties": {
        "value": true,
        "type": {
          "enum": [
            "deg",
            "percentage"
          ]
        }
      },
      "additionalProperties": false
    },
    "UnitSizeArea": {
      "type": "object",
      "properties": {
        "width": {
          "type": "object",
          "properties": {
            "value": true,
            "type": {
              "enum": [
                "px",
                "em",
                "rem",
                "percentage",
                "vh",
                "vw",
                "vmin",
                "vmax"
              ]
            }
          },
          "additionalProperties": false
        },
        "height": {
          "type": "object",
          "properties": {
            "value": true,
            "type": {
              "enum": [
                "px",
                "em",
                "rem",
                "percentage",
                "vh",
                "vw",
                "vmin",
                "vmax"
              ]
            }
          },
          "additionalProperties": false
        }
      },
      "additionalProperties": false
    },
    "UnitSizePoint": {
      "type": "object",
      "properties": {
        "x": {
          "type": "object",
          "properties": {
            "value": true,
            "type": {
              "enum": [
                "px",
                "em",
                "rem",
                "percentage",
                "vh",
                "vw",
                "vmin",
                "vmax"
              ]
            }
          },
          "additionalProperties": false
        },
        "y": {
          "type": "object",
          "properties": {
            "value": true,
            "type": {
              "enum": [
                "px",
                "em",
                "rem",
                "percentage",
                "vh",
                "vw",
                "vmin",
                "vmax"
              ]
            }
          },
          "additionalProperties": false
        }
      },
      "additionalProperties": false
    },
    "BreakpointsData": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "values": {
          "type": [
            "array",
            "null"
          ],
          "items": true
        },
        "componentId": true
      },
      "additionalProperties": false
    },
    "BreakpointRange": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "min": true,
        "max": true,
        "canvasSize": true
      },
      "additionalProperties": false
    },
    "NumberThatCanConnectToAVariable": true,
    "LinkReference": {
      "type": [
        "null",
        "string"
      ],
      "pattern": "^$|^#"
    },
    "Common_Image": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "link": {
          "type": [
            "null",
            "string"
          ],
          "pattern": "^$|^#"
        },
        "title": true,
        "name": true,
        "uri": {
          "type": "string",
          "pattern": "^[\\w:~\\-_+%.\\/,\\?=\\()]+$"
        },
        "description": true,
        "height": true,
        "width": true,
        "borderSize": true,
        "alt": true,
        "decorative": true,
        "hasAnimation": true,
        "originalImageDataRef": true,
        "opacity": true,
        "crop": {
          "oneOf": [
            {
              "type": "null"
            },
            {
              "type": "object",
              "properties": {
                "x": true,
                "y": true,
                "width": true,
                "height": true,
                "svgId": true,
                "flip": {
                  "type": "string",
                  "enum": [
                    "x",
                    "y",
                    "xy",
                    "none"
                  ]
                },
                "rotate": true
              },
              "additionalProperties": false
            }
          ]
        },
        "upscaleMethod": true,
        "focalPoint": {
          "oneOf": [
            {
              "type": "null"
            },
            {
              "type": "object",
              "properties": {
                "x": true,
                "y": true
              },
              "additionalProperties": false
            }
          ]
        },
        "artist": {
          "type": "object",
          "properties": {
            "name": true,
            "id": true
          },
          "additionalProperties": false
        }
      },
      "additionalProperties": false
    },
    "Common_SVGItem": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "svgId": true
      },
      "additionalProperties": false
    },
    "ColorLayers": {
      "type": [
        "array",
        "null"
      ],
      "items": true
    },
    "GradientLinearLayer": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "opacity": true,
        "fill": {
          "type": "object",
          "properties": {
            "type": {
              "type": "string",
              "enum": [
                "GradientLinear"
              ]
            },
            "repeat": true,
            "blendMode": {
              "type": "string",
              "enum": [
                "normal",
                "multiply",
                "screen",
                "darken",
                "lighten",
                "overlay",
                "colorDodge",
                "colorBurn",
                "hardLight",
                "softLight",
                "difference",
                "exclusion",
                "hue",
                "saturation",
                "color",
                "luminosity"
              ]
            },
            "angle": true,
            "colorStops": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "size": {
                    "type": "object",
                    "properties": {
                      "value": true,
                      "type": {
                        "enum": [
                          "px",
                          "em",
                          "rem",
                          "percentage",
                          "vh",
                          "vw",
                          "vmin",
                          "vmax"
                        ]
                      }
                    },
                    "additionalProperties": false
                  },
                  "color": {
                    "type": "string",
                    "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
                  },
                  "opacity": true
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        }
      },
      "additionalProperties": false
    },
    "GradientCircleLayer": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "opacity": true,
        "fill": {
          "type": "object",
          "properties": {
            "type": {
              "type": "string",
              "enum": [
                "GradientCircle"
              ]
            },
            "repeat": true,
            "blendMode": {
              "type": "string",
              "enum": [
                "normal",
                "multiply",
                "screen",
                "darken",
                "lighten",
                "overlay",
                "colorDodge",
                "colorBurn",
                "hardLight",
                "softLight",
                "difference",
                "exclusion",
                "hue",
                "saturation",
                "color",
                "luminosity"
              ]
            },
            "size": {
              "type": "object",
              "properties": {
                "keyword": {
                  "type": "string",
                  "enum": [
                    "closest-side",
                    "closest-corner",
                    "farthest-side",
                    "farthest-corner"
                  ]
                },
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "vh",
                    "vw",
                    "vmin",
                    "vmax"
                  ]
                }
              },
              "additionalProperties": false
            },
            "position": {
              "type": "object",
              "properties": {
                "x": {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "percentage",
                        "vh",
                        "vw",
                        "vmin",
                        "vmax"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "y": {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "percentage",
                        "vh",
                        "vw",
                        "vmin",
                        "vmax"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            "colorStops": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "size": {
                    "type": "object",
                    "properties": {
                      "value": true,
                      "type": {
                        "enum": [
                          "px",
                          "em",
                          "rem",
                          "percentage",
                          "vh",
                          "vw",
                          "vmin",
                          "vmax"
                        ]
                      }
                    },
                    "additionalProperties": false
                  },
                  "color": {
                    "type": "string",
                    "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
                  },
                  "opacity": true
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        }
      },
      "additionalProperties": false
    },
    "GradientEllipseLayer": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "opacity": true,
        "fill": {
          "type": "object",
          "properties": {
            "type": {
              "type": "string",
              "enum": [
                "GradientEllipse"
              ]
            },
            "repeat": true,
            "blendMode": {
              "type": "string",
              "enum": [
                "normal",
                "multiply",
                "screen",
                "darken",
                "lighten",
                "overlay",
                "colorDodge",
                "colorBurn",
                "hardLight",
                "softLight",
                "difference",
                "exclusion",
                "hue",
                "saturation",
                "color",
                "luminosity"
              ]
            },
            "size": {
              "type": "object",
              "properties": {
                "keyword": {
                  "type": "string",
                  "enum": [
                    "closest-side",
                    "closest-corner",
                    "farthest-side",
                    "farthest-corner"
                  ]
                },
                "width": {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "percentage",
                        "vh",
                        "vw",
                        "vmin",
                        "vmax"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "height": {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "percentage",
                        "vh",
                        "vw",
                        "vmin",
                        "vmax"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            "position": {
              "type": "object",
              "properties": {
                "x": {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "percentage",
                        "vh",
                        "vw",
                        "vmin",
                        "vmax"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "y": {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "percentage",
                        "vh",
                        "vw",
                        "vmin",
                        "vmax"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            "colorStops": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "size": {
                    "type": "object",
                    "properties": {
                      "value": true,
                      "type": {
                        "enum": [
                          "px",
                          "em",
                          "rem",
                          "percentage",
                          "vh",
                          "vw",
                          "vmin",
                          "vmax"
                        ]
                      }
                    },
                    "additionalProperties": false
                  },
                  "color": {
                    "type": "string",
                    "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
                  },
                  "opacity": true
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        }
      },
      "additionalProperties": false
    },
    "GradientMeshLayer": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "opacity": true,
        "fill": {
          "type": "object",
          "properties": {
            "type": {
              "type": "string",
              "enum": [
                "GradientMesh"
              ]
            },
            "gradients": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "type": {
                    "type": "string",
                    "enum": [
                      "GradientCircle"
                    ]
                  },
                  "repeat": true,
                  "blendMode": {
                    "type": "string",
                    "enum": [
                      "normal",
                      "multiply",
                      "screen",
                      "darken",
                      "lighten",
                      "overlay",
                      "colorDodge",
                      "colorBurn",
                      "hardLight",
                      "softLight",
                      "difference",
                      "exclusion",
                      "hue",
                      "saturation",
                      "color",
                      "luminosity"
                    ]
                  },
                  "size": {
                    "type": "object",
                    "properties": {
                      "keyword": {
                        "type": "string",
                        "enum": [
                          "closest-side",
                          "closest-corner",
                          "farthest-side",
                          "farthest-corner"
                        ]
                      },
                      "value": true,
                      "type": {
                        "enum": [
                          "px",
                          "em",
                          "rem",
                          "vh",
                          "vw",
                          "vmin",
                          "vmax"
                        ]
                      }
                    },
                    "additionalProperties": false
                  },
                  "position": {
                    "type": "object",
                    "properties": {
                      "x": {
                        "type": "object",
                        "properties": {
                          "value": true,
                          "type": {
                            "enum": [
                              "px",
                              "em",
                              "rem",
                              "percentage",
                              "vh",
                              "vw",
                              "vmin",
                              "vmax"
                            ]
                          }
                        },
                        "additionalProperties": false
                      },
                      "y": {
                        "type": "object",
                        "properties": {
                          "value": true,
                          "type": {
                            "enum": [
                              "px",
                              "em",
                              "rem",
                              "percentage",
                              "vh",
                              "vw",
                              "vmin",
                              "vmax"
                            ]
                          }
                        },
                        "additionalProperties": false
                      }
                    },
                    "additionalProperties": false
                  },
                  "colorStops": {
                    "type": "array",
                    "items": {
                      "type": "object",
                      "properties": {
                        "size": {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "percentage",
                                "vh",
                                "vw",
                                "vmin",
                                "vmax"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        "color": {
                          "type": "string",
                          "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
                        },
                        "opacity": true
                      },
                      "additionalProperties": false
                    }
                  }
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        }
      },
      "additionalProperties": false
    },
    "GradientConicLayer": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "opacity": true,
        "fill": {
          "type": "object",
          "properties": {
            "type": {
              "type": "string",
              "enum": [
                "GradientConic"
              ]
            },
            "repeat": true,
            "blendMode": {
              "type": "string",
              "enum": [
                "normal",
                "multiply",
                "screen",
                "darken",
                "lighten",
                "overlay",
                "colorDodge",
                "colorBurn",
                "hardLight",
                "softLight",
                "difference",
                "exclusion",
                "hue",
                "saturation",
                "color",
                "luminosity"
              ]
            },
            "angle": true,
            "position": {
              "type": "object",
              "properties": {
                "x": {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "percentage",
                        "vh",
                        "vw",
                        "vmin",
                        "vmax"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "y": {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "percentage",
                        "vh",
                        "vw",
                        "vmin",
                        "vmax"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            "colorStops": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "size": {
                    "type": "object",
                    "properties": {
                      "value": true,
                      "type": {
                        "enum": [
                          "deg",
                          "percentage"
                        ]
                      }
                    },
                    "additionalProperties": false
                  },
                  "color": {
                    "type": "string",
                    "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
                  },
                  "opacity": true
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        }
      },
      "additionalProperties": false
    },
    "SolidColorLayer": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "opacity": true,
        "fill": {
          "type": "object",
          "properties": {
            "type": {
              "type": "string",
              "enum": [
                "SolidColor"
              ]
            },
            "color": {
              "type": "string",
              "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
            }
          },
          "additionalProperties": false
        }
      },
      "additionalProperties": false
    },
    "GradientLinear": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "GradientLinear"
          ]
        },
        "repeat": true,
        "blendMode": {
          "type": "string",
          "enum": [
            "normal",
            "multiply",
            "screen",
            "darken",
            "lighten",
            "overlay",
            "colorDodge",
            "colorBurn",
            "hardLight",
            "softLight",
            "difference",
            "exclusion",
            "hue",
            "saturation",
            "color",
            "luminosity"
          ]
        },
        "angle": true,
        "colorStops": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "size": {
                "type": "object",
                "properties": {
                  "value": true,
                  "type": {
                    "enum": [
                      "px",
                      "em",
                      "rem",
                      "percentage",
                      "vh",
                      "vw",
                      "vmin",
                      "vmax"
                    ]
                  }
                },
                "additionalProperties": false
              },
              "color": {
                "type": "string",
                "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
              },
              "opacity": true
            },
            "additionalProperties": false
          }
        }
      },
      "additionalProperties": false
    },
    "GradientCircleSize": {
      "type": "object",
      "properties": {
        "keyword": {
          "type": "string",
          "enum": [
            "closest-side",
            "closest-corner",
            "farthest-side",
            "farthest-corner"
          ]
        },
        "value": true,
        "type": {
          "enum": [
            "px",
            "em",
            "rem",
            "vh",
            "vw",
            "vmin",
            "vmax"
          ]
        }
      },
      "additionalProperties": false
    },
    "GradientCircle": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "GradientCircle"
          ]
        },
        "repeat": true,
        "blendMode": {
          "type": "string",
          "enum": [
            "normal",
            "multiply",
            "screen",
            "darken",
            "lighten",
            "overlay",
            "colorDodge",
            "colorBurn",
            "hardLight",
            "softLight",
            "difference",
            "exclusion",
            "hue",
            "saturation",
            "color",
            "luminosity"
          ]
        },
        "size": {
          "type": "object",
          "properties": {
            "keyword": {
              "type": "string",
              "enum": [
                "closest-side",
                "closest-corner",
                "farthest-side",
                "farthest-corner"
              ]
            },
            "value": true,
            "type": {
              "enum": [
                "px",
                "em",
                "rem",
                "vh",
                "vw",
                "vmin",
                "vmax"
              ]
            }
          },
          "additionalProperties": false
        },
        "position": {
          "type": "object",
          "properties": {
            "x": {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "percentage",
                    "vh",
                    "vw",
                    "vmin",
                    "vmax"
                  ]
                }
              },
              "additionalProperties": false
            },
            "y": {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "percentage",
                    "vh",
                    "vw",
                    "vmin",
                    "vmax"
                  ]
                }
              },
              "additionalProperties": false
            }
          },
          "additionalProperties": false
        },
        "colorStops": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "size": {
                "type": "object",
                "properties": {
                  "value": true,
                  "type": {
                    "enum": [
                      "px",
                      "em",
                      "rem",
                      "percentage",
                      "vh",
                      "vw",
                      "vmin",
                      "vmax"
                    ]
                  }
                },
                "additionalProperties": false
              },
              "color": {
                "type": "string",
                "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
              },
              "opacity": true
            },
            "additionalProperties": false
          }
        }
      },
      "additionalProperties": false
    },
    "GradientEllipseSize": {
      "type": "object",
      "properties": {
        "keyword": {
          "type": "string",
          "enum": [
            "closest-side",
            "closest-corner",
            "farthest-side",
            "farthest-corner"
          ]
        },
        "width": {
          "type": "object",
          "properties": {
            "value": true,
            "type": {
              "enum": [
                "px",
                "em",
                "rem",
                "percentage",
                "vh",
                "vw",
                "vmin",
                "vmax"
              ]
            }
          },
          "additionalProperties": false
        },
        "height": {
          "type": "object",
          "properties": {
            "value": true,
            "type": {
              "enum": [
                "px",
                "em",
                "rem",
                "percentage",
                "vh",
                "vw",
                "vmin",
                "vmax"
              ]
            }
          },
          "additionalProperties": false
        }
      },
      "additionalProperties": false
    },
    "GradientEllipse": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "GradientEllipse"
          ]
        },
        "repeat": true,
        "blendMode": {
          "type": "string",
          "enum": [
            "normal",
            "multiply",
            "screen",
            "darken",
            "lighten",
            "overlay",
            "colorDodge",
            "colorBurn",
            "hardLight",
            "softLight",
            "difference",
            "exclusion",
            "hue",
            "saturation",
            "color",
            "luminosity"
          ]
        },
        "size": {
          "type": "object",
          "properties": {
            "keyword": {
              "type": "string",
              "enum": [
                "closest-side",
                "closest-corner",
                "farthest-side",
                "farthest-corner"
              ]
            },
            "width": {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "percentage",
                    "vh",
                    "vw",
                    "vmin",
                    "vmax"
                  ]
                }
              },
              "additionalProperties": false
            },
            "height": {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "percentage",
                    "vh",
                    "vw",
                    "vmin",
                    "vmax"
                  ]
                }
              },
              "additionalProperties": false
            }
          },
          "additionalProperties": false
        },
        "position": {
          "type": "object",
          "properties": {
            "x": {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "percentage",
                    "vh",
                    "vw",
                    "vmin",
                    "vmax"
                  ]
                }
              },
              "additionalProperties": false
            },
            "y": {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "percentage",
                    "vh",
                    "vw",
                    "vmin",
                    "vmax"
                  ]
                }
              },
              "additionalProperties": false
            }
          },
          "additionalProperties": false
        },
        "colorStops": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "size": {
                "type": "object",
                "properties": {
                  "value": true,
                  "type": {
                    "enum": [
                      "px",
                      "em",
                      "rem",
                      "percentage",
                      "vh",
                      "vw",
                      "vmin",
                      "vmax"
                    ]
                  }
                },
                "additionalProperties": false
              },
              "color": {
                "type": "string",
                "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
              },
              "opacity": true
            },
            "additionalProperties": false
          }
        }
      },
      "additionalProperties": false
    },
    "GradientConic": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "GradientConic"
          ]
        },
        "repeat": true,
        "blendMode": {
          "type": "string",
          "enum": [
            "normal",
            "multiply",
            "screen",
            "darken",
            "lighten",
            "overlay",
            "colorDodge",
            "colorBurn",
            "hardLight",
            "softLight",
            "difference",
            "exclusion",
            "hue",
            "saturation",
            "color",
            "luminosity"
          ]
        },
        "angle": true,
        "position": {
          "type": "object",
          "properties": {
            "x": {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "percentage",
                    "vh",
                    "vw",
                    "vmin",
                    "vmax"
                  ]
                }
              },
              "additionalProperties": false
            },
            "y": {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "percentage",
                    "vh",
                    "vw",
                    "vmin",
                    "vmax"
                  ]
                }
              },
              "additionalProperties": false
            }
          },
          "additionalProperties": false
        },
        "colorStops": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "size": {
                "type": "object",
                "properties": {
                  "value": true,
                  "type": {
                    "enum": [
                      "deg",
                      "percentage"
                    ]
                  }
                },
                "additionalProperties": false
              },
              "color": {
                "type": "string",
                "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
              },
              "opacity": true
            },
            "additionalProperties": false
          }
        }
      },
      "additionalProperties": false
    },
    "SolidColor": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "SolidColor"
          ]
        },
        "color": {
          "type": "string",
          "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
        }
      },
      "additionalProperties": false
    },
    "BlendMode": {
      "type": "string",
      "enum": [
        "normal",
        "multiply",
        "screen",
        "darken",
        "lighten",
        "overlay",
        "colorDodge",
        "colorBurn",
        "hardLight",
        "softLight",
        "difference",
        "exclusion",
        "hue",
        "saturation",
        "color",
        "luminosity"
      ]
    },
    "GradientColorStop": {
      "type": "object",
      "properties": {
        "size": {
          "type": "object",
          "properties": {
            "value": true,
            "type": {
              "enum": [
                "px",
                "em",
                "rem",
                "percentage",
                "vh",
                "vw",
                "vmin",
                "vmax"
              ]
            }
          },
          "additionalProperties": false
        },
        "color": {
          "type": "string",
          "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
        },
        "opacity": true
      },
      "additionalProperties": false
    },
    "GradientAngularColorStop": {
      "type": "object",
      "properties": {
        "size": {
          "type": "object",
          "properties": {
            "value": true,
            "type": {
              "enum": [
                "deg",
                "percentage"
              ]
            }
          },
          "additionalProperties": false
        },
        "color": {
          "type": "string",
          "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
        },
        "opacity": true
      },
      "additionalProperties": false
    }
  },
  "component_properties.json": {
    "$id": "urn:dm:schemas:component_properties.json",
    "FontsEnum": {
      "type": "string",
      "enum": [
        "lucidaSansConsole",
        "palatinoLinotype",
        "americantypwrteritcw01--731025",
        "anton",
        "arial",
        "arialBlack",
        "avenida-w01",
        "basic",
        "caudex",
        "clarendon-w01-medium-692107",
        "comicSansMS",
        "cookie",
        "coquette-w00-light",
        "courierNew",
        "din-next-w01-light",
        "droid-serif-w01-regular",
        "eb garamond",
        "enriqueta",
        "forum",
        "georgia",
        "helvetica-w01-roman",
        "helvetica-w01-bold",
        "helvetica-w01-light",
        "impact",
        "jockey one",
        "jura",
        "kelly slab",
        "lobster",
        "lucidaConsole",
        "marck script",
        "monoton",
        "noticia text",
        "open sans",
        "open sans condensed",
        "palatino linotype",
        "patrick hand",
        "play",
        "reklamescriptw00-medium",
        "sacramento",
        "sarina",
        "signika",
        "soho-w01-thin-condensed",
        "tahoma",
        "timesNewRoman",
        "verdana",
        "bodoni-w01-poster",
        "ｍｓ ゴシック",
        "ｍｓ 明朝",
        "ｍｓ ｐゴシック",
        "ｍｓ ｐ明朝",
        "meiryo",
        "メイリオ",
        "bm-hanna",
        "돋움",
        "fbbluegothicl",
        "fbchamblue",
        "fbgreen",
        "fbneogothic",
        "fbplum",
        "굴림",
        "맑은 고딕",
        "nanumgothic-regular",
        "ahmedltw20-outlineregul",
        "amiri",
        "arabictypesettingw23-re",
        "arian-lt-w20-regular",
        "arian-lt-w20-light",
        "coheadlinew23-arabicbol",
        "dinnextltw23-ultralight",
        "droid-naskh",
        "janna-lt-w20-regular",
        "kufi-lt-w20-regular",
        "midan-w20",
        "helveticaneueltw20-ligh",
        "tanseekmodernw20-light",
        "adler-w26-regular",
        "alef-regular",
        "almoni-dl-aaa-700",
        "almoni-dl-aaa-300",
        "almoni-dl-aaa-400",
        "asimon-aaa-400",
        "atlas-aaa-500",
        "chips-w26-normal",
        "frank-ruhl-w26-regular",
        "gulash-w26-regular",
        "haim-arukeem-w26-medium",
        "miriam-w26-medium",
        "mixtape-aaa-400",
        "museum-aaa-400",
        "nekudot-w26-bold",
        "omes-aaa-400",
        "opensanshebrewcondensed-regular",
        "shabazi-w26-bold",
        "amatic sc",
        "braggadocio-w01",
        "chelsea market",
        "corben",
        "fredericka the great",
        "geotica-w01-four-open",
        "helvetica neue",
        "helvetica neue italic",
        "helvetica neue medium",
        "helvetica neue thin",
        "itc-arecibo-w01-regular",
        "josefin slab",
        "lucida sans unicode",
        "marzo-w00-regular",
        "mr de haviland",
        "museo-w01-700",
        "museo-slab-w01-100",
        "niconne",
        "nimbus-sans-tw01con",
        "overlock",
        "pacifica-w00-condensed",
        "raleway",
        "rosewood-w01-regular",
        "snellroundhandw01-scrip",
        "spinnaker",
        "stencil-w01-bold"
      ]
    },
    "DefaultProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "FlipProperties": {
      "type": "object",
      "properties": {
        "flip": {
          "type": "string",
          "enum": [
            "x",
            "y",
            "xy",
            "horizontal",
            "vertical",
            "both",
            "none"
          ]
        }
      },
      "additionalProperties": false
    },
    "VideoBackgroundProperties": {
      "type": "object",
      "properties": {
        "enableBackgroundVideo": true
      },
      "additionalProperties": false
    },
    "CardsLayoutProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "alignment": {
          "type": "string",
          "enum": [
            "left",
            "center",
            "right",
            "justify"
          ]
        },
        "gap": {
          "type": "object",
          "properties": {
            "vertical": true,
            "horizontal": true
          },
          "additionalProperties": false
        },
        "direction": {
          "enum": [
            "rtl",
            "ltr"
          ]
        },
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "VerticalLayoutProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "gap": true,
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "DisableableProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "isDisabled": true,
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "ClassicSectionProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "mediaBackgroundPadding": {
          "type": [
            "object",
            "null"
          ],
          "properties": {
            "top": true,
            "bottom": true
          },
          "additionalProperties": false
        },
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true,
        "enableBackgroundVideo": true
      },
      "additionalProperties": false
    },
    "StripColumnsContainerProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "columnsMargin": true,
        "frameMargin": true,
        "fullWidth": true,
        "fullHeight": true,
        "rowMargin": true,
        "siteMargin": true,
        "horizontalPaddingOnMobile": true,
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true,
        "enableBackgroundVideo": true
      },
      "additionalProperties": false
    },
    "ColumnProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "background": true,
        "alignment": true,
        "mediaBackgroundPadding": {
          "oneOf": [
            {
              "type": "null"
            },
            {
              "type": "object",
              "properties": {
                "top": true,
                "bottom": true
              },
              "additionalProperties": false
            }
          ]
        },
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true,
        "enableBackgroundVideo": true
      },
      "additionalProperties": false
    },
    "InputProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "label": true,
        "required": true,
        "autoFocus": true,
        "readOnly": true,
        "tabIndex": true,
        "inputHeight": true,
        "inputHeightMobile": true,
        "labelMargin": true,
        "labelPadding": true,
        "labelMobileFontSize": true,
        "inputMobileFontSize": true,
        "isDisabled": true,
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "InputElementsErrorProperties": {
      "type": "object",
      "properties": {
        "errorMessageType": {
          "type": "string",
          "enum": [
            "inline",
            "tooltip"
          ]
        }
      },
      "additionalProperties": false
    },
    "QuickActionBarProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "colorScheme": {
          "type": "string",
          "enum": [
            "black",
            "grey",
            "brand"
          ]
        },
        "invertColors": true,
        "hideText": true,
        "alignment": {
          "type": "string",
          "enum": [
            "right",
            "left"
          ]
        },
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "PhotoProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "imageSize": {
          "type": "string",
          "enum": [
            "small",
            "medium",
            "large"
          ]
        },
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "FacebookLikeBoxProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "transparentBg": true,
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "ImageButtonProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "transition": {
          "type": "string",
          "enum": [
            "none",
            "fade"
          ]
        },
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "MultiSelectionProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "placeholder": true,
        "newItemText": true,
        "selectionOnly": true,
        "maxTextLength": true,
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "MultiSelectionItemProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "NumericStepperProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "minValue": true,
        "maxValue": true,
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "PinterestPinItProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "size": {
          "type": "string",
          "enum": [
            "small",
            "large"
          ]
        },
        "color": {
          "type": "string",
          "enum": [
            "gray",
            "red",
            "white"
          ]
        },
        "counterPosition": {
          "type": "string",
          "enum": [
            "none",
            "above",
            "beside"
          ]
        },
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "SingleAudioPlayerProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "volume": true,
        "autoplay": true,
        "loop": true,
        "showArtist": true,
        "showTrack": true,
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "SkypeCallButtonProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "imageSize": {
          "type": "string",
          "enum": [
            "small",
            "medium",
            "large"
          ]
        },
        "imageColor": {
          "type": "string",
          "enum": [
            "blue",
            "white"
          ]
        },
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "SpotifyFollowProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "size": {
          "type": "string",
          "enum": [
            "small",
            "large"
          ]
        },
        "theme": {
          "type": "string",
          "enum": [
            "light",
            "dark"
          ]
        },
        "showFollowersCount": true,
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "SpotifyPlayerProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "size": {
          "type": "string",
          "enum": [
            "compact",
            "large"
          ]
        },
        "color": {
          "type": "string",
          "enum": [
            "black",
            "white"
          ]
        },
        "style": {
          "type": "string",
          "enum": [
            "list",
            "coverart"
          ]
        },
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "SubscribeFormProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "hiddenFirstNameField": true,
        "hiddenLastNameField": true,
        "hiddenEmailField": true,
        "hiddenPhoneField": true,
        "requiredFirstNameField": true,
        "requiredLastNameField": true,
        "requiredEmailField": true,
        "requiredPhoneField": true,
        "useCookie": true,
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "VerticalMenuProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "itemsAlignment": {
          "type": "string",
          "enum": [
            "left",
            "center",
            "right"
          ]
        },
        "subMenuOpenSide": {
          "type": "string",
          "enum": [
            "left",
            "right"
          ]
        },
        "originalHeight": true,
        "menuItemHeight": true,
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "YouTubeSubscribeButtonProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "layout": {
          "type": "string",
          "enum": [
            "default",
            "full"
          ]
        },
        "theme": {
          "type": "string",
          "enum": [
            "light",
            "dark"
          ]
        },
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "BgImageStripProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "bgUrl": true,
        "bgSize": {
          "type": "string",
          "enum": [
            "auto",
            "cover",
            "contain"
          ]
        },
        "bgRepeat": {
          "type": "string",
          "enum": [
            "no-repeat",
            "repeat-x",
            "repeat-y",
            "repeat"
          ]
        },
        "bgPosition": {
          "type": "string",
          "enum": [
            "top left",
            "top center",
            "top right",
            "center left",
            "center",
            "center right",
            "bottom left",
            "bottom center",
            "bottom right"
          ]
        },
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "BgImageStripUnifiedProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "fittingType": {
          "type": "string",
          "enum": [
            "fill",
            "fit",
            "actual_size",
            "tile",
            "fit_and_tile",
            "tile_horizontal",
            "tile_vertical",
            "legacy_strip_tile",
            "legacy_strip_tile_horizontal",
            "legacy_strip_tile_vertical",
            "legacy_strip_original_size",
            "legacy_strip_fill",
            "legacy_strip_fit",
            "legacy_strip_fit_and_tile"
          ]
        },
        "alignType": {
          "type": "string",
          "enum": [
            "top_left",
            "top",
            "top_right",
            "left",
            "center",
            "right",
            "bottom_left",
            "bottom",
            "bottom_right"
          ]
        },
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "FileUploaderProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "buttonAlignment": {
          "type": "string",
          "enum": [
            "rtl",
            "ltr"
          ]
        },
        "filesAlignment": {
          "type": "string",
          "enum": [
            "left",
            "center",
            "right"
          ]
        },
        "showPlaceholder": true,
        "filesType": {
          "type": "string",
          "enum": [
            "Image",
            "Document",
            "Video",
            "Audio",
            "Archive",
            "Gallery"
          ]
        },
        "filesSizeLimit": true,
        "numFilesLimit": true,
        "showFileName": true,
        "textBelowButtonMobileFontSize": true,
        "label": true,
        "required": true,
        "autoFocus": true,
        "readOnly": true,
        "tabIndex": true,
        "inputHeight": true,
        "inputHeightMobile": true,
        "labelMargin": true,
        "labelPadding": true,
        "labelMobileFontSize": true,
        "inputMobileFontSize": true,
        "isDisabled": true,
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "UploadNameProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "ButtonProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "align": {
          "type": "string",
          "enum": [
            "left",
            "center",
            "right"
          ]
        },
        "margin": true,
        "isDisabled": true,
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "LoginSocialBarProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "buttonsDirection": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl"
          ]
        },
        "iconSize": true,
        "loggedOutIconSize": true,
        "dropDownTextAlignment": {
          "type": "string",
          "enum": [
            "left",
            "center",
            "right"
          ]
        },
        "buttonsAlignment": {
          "type": "string",
          "enum": [
            "left",
            "center",
            "right"
          ]
        },
        "arrowShape": {
          "type": "string",
          "enum": [
            "none",
            "line",
            "full"
          ]
        },
        "arrowSize": true,
        "showBellIcon": true,
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "ComboBoxInputProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "textAlignment": {
          "oneOf": [
            {
              "type": "null"
            },
            {
              "type": "string",
              "enum": [
                "left",
                "right",
                "center"
              ]
            }
          ]
        },
        "textPadding": true,
        "placeholder": {
          "oneOf": [
            {
              "type": "null"
            },
            {
              "type": "object",
              "properties": {
                "value": true,
                "text": true
              },
              "additionalProperties": false
            }
          ]
        },
        "size": true,
        "designableList": true,
        "dropdownItemsSpacing": true,
        "autocomplete": true,
        "label": true,
        "required": true,
        "autoFocus": true,
        "readOnly": true,
        "tabIndex": true,
        "inputHeight": true,
        "inputHeightMobile": true,
        "labelMargin": true,
        "labelPadding": true,
        "labelMobileFontSize": true,
        "inputMobileFontSize": true,
        "isDisabled": true,
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true,
        "errorMessageType": {
          "type": "string",
          "enum": [
            "inline",
            "tooltip"
          ]
        }
      },
      "additionalProperties": false
    },
    "RadioButtonProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "label": true,
        "required": true,
        "autoFocus": true,
        "readOnly": true,
        "tabIndex": true,
        "inputHeight": true,
        "inputHeightMobile": true,
        "labelMargin": true,
        "labelPadding": true,
        "labelMobileFontSize": true,
        "inputMobileFontSize": true,
        "isDisabled": true,
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "RadioGroupProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "alignment": {
          "type": "string",
          "enum": [
            "left",
            "right"
          ]
        },
        "layout": {
          "type": "string",
          "enum": [
            "vertical",
            "horizontal"
          ]
        },
        "buttonsMargin": true,
        "spacing": true,
        "buttonSize": true,
        "labelMargin": true,
        "label": true,
        "required": true,
        "autoFocus": true,
        "readOnly": true,
        "tabIndex": true,
        "inputHeight": true,
        "inputHeightMobile": true,
        "labelPadding": true,
        "labelMobileFontSize": true,
        "inputMobileFontSize": true,
        "isDisabled": true,
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true,
        "errorMessageType": {
          "type": "string",
          "enum": [
            "inline",
            "tooltip"
          ]
        }
      },
      "additionalProperties": false
    },
    "CheckboxGroupProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "alignment": {
          "type": "string",
          "enum": [
            "left",
            "right"
          ]
        },
        "layout": {
          "type": "string",
          "enum": [
            "vertical",
            "horizontal"
          ]
        },
        "buttonsMargin": true,
        "spacing": true,
        "buttonSize": true,
        "labelMargin": true,
        "label": true,
        "required": true,
        "autoFocus": true,
        "readOnly": true,
        "tabIndex": true,
        "inputHeight": true,
        "inputHeightMobile": true,
        "labelPadding": true,
        "labelMobileFontSize": true,
        "inputMobileFontSize": true,
        "isDisabled": true,
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true,
        "errorMessageType": {
          "type": "string",
          "enum": [
            "inline",
            "tooltip"
          ]
        }
      },
      "additionalProperties": false
    },
    "ContactFormProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "hidden_emailFieldLabel": true,
        "hidden_nameFieldLabel": true,
        "hidden_phoneFieldLabel": true,
        "hidden_addressFieldLabel": true,
        "hidden_subjectFieldLabel": true,
        "hidden_messageFieldLabel": true,
        "required_emailFieldLabel": true,
        "required_nameFieldLabel": true,
        "required_phoneFieldLabel": true,
        "required_addressFieldLabel": true,
        "required_subjectFieldLabel": true,
        "required_messageFieldLabel": true,
        "useCookie": true,
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "DocumentMediaProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "showTitle": true,
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "EbayItemsBySellerProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "headerImage": {
          "enum": [
            "0",
            "2",
            "3",
            "4",
            "5",
            "6",
            "7",
            "8",
            "9",
            "10",
            "11"
          ]
        },
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "FiveGridLineProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "fullScreenModeOn": true,
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "FlashComponentProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "displayMode": {
          "type": "string",
          "enum": [
            "original",
            "fit",
            "stretch"
          ]
        },
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "GalleryExpandProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "expandEnabled": true,
        "goToLinkText": true,
        "galleryImageOnClickAction": {
          "type": "string",
          "enum": [
            "disabled",
            "zoomMode",
            "goToLink"
          ]
        },
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "GoogleMapProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "showZoom": true,
        "fullscreenControl": true,
        "showPosition": true,
        "showStreetView": true,
        "showMapType": true,
        "zoom": true,
        "mapDragging": true,
        "showDirectionsLink": true,
        "mapType": {
          "type": "string",
          "enum": [
            "ROADMAP",
            "TERRAIN",
            "SATELLITE",
            "HYBRID"
          ]
        },
        "language": {
          "type": "string",
          "enum": [
            "userLang",
            "cs",
            "da",
            "de",
            "en",
            "es",
            "fr",
            "hi",
            "it",
            "ja",
            "ko",
            "nl",
            "no",
            "pl",
            "pt",
            "ru",
            "sv",
            "zh",
            "th",
            "uk",
            "tr"
          ]
        },
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "HorizontalMenuProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "alignButtons": {
          "type": "string",
          "enum": [
            "left",
            "center",
            "right"
          ]
        },
        "alignText": {
          "type": "string",
          "enum": [
            "left",
            "center",
            "right"
          ]
        },
        "sameWidthButtons": true,
        "moreButtonLabel": true,
        "moreItemHeight": true,
        "stretchButtonsToMenuWidth": true,
        "rtl": true,
        "autoTextDirection": true,
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "ImpressProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "font": {
          "type": "string",
          "enum": [
            "lucidaSansConsole",
            "palatinoLinotype",
            "americantypwrteritcw01--731025",
            "anton",
            "arial",
            "arialBlack",
            "avenida-w01",
            "basic",
            "caudex",
            "clarendon-w01-medium-692107",
            "comicSansMS",
            "cookie",
            "coquette-w00-light",
            "courierNew",
            "din-next-w01-light",
            "droid-serif-w01-regular",
            "eb garamond",
            "enriqueta",
            "forum",
            "georgia",
            "helvetica-w01-roman",
            "helvetica-w01-bold",
            "helvetica-w01-light",
            "impact",
            "jockey one",
            "jura",
            "kelly slab",
            "lobster",
            "lucidaConsole",
            "marck script",
            "monoton",
            "noticia text",
            "open sans",
            "open sans condensed",
            "palatino linotype",
            "patrick hand",
            "play",
            "reklamescriptw00-medium",
            "sacramento",
            "sarina",
            "signika",
            "soho-w01-thin-condensed",
            "tahoma",
            "timesNewRoman",
            "verdana",
            "bodoni-w01-poster",
            "ｍｓ ゴシック",
            "ｍｓ 明朝",
            "ｍｓ ｐゴシック",
            "ｍｓ ｐ明朝",
            "meiryo",
            "メイリオ",
            "bm-hanna",
            "돋움",
            "fbbluegothicl",
            "fbchamblue",
            "fbgreen",
            "fbneogothic",
            "fbplum",
            "굴림",
            "맑은 고딕",
            "nanumgothic-regular",
            "ahmedltw20-outlineregul",
            "amiri",
            "arabictypesettingw23-re",
            "arian-lt-w20-regular",
            "arian-lt-w20-light",
            "coheadlinew23-arabicbol",
            "dinnextltw23-ultralight",
            "droid-naskh",
            "janna-lt-w20-regular",
            "kufi-lt-w20-regular",
            "midan-w20",
            "helveticaneueltw20-ligh",
            "tanseekmodernw20-light",
            "adler-w26-regular",
            "alef-regular",
            "almoni-dl-aaa-700",
            "almoni-dl-aaa-300",
            "almoni-dl-aaa-400",
            "asimon-aaa-400",
            "atlas-aaa-500",
            "chips-w26-normal",
            "frank-ruhl-w26-regular",
            "gulash-w26-regular",
            "haim-arukeem-w26-medium",
            "miriam-w26-medium",
            "mixtape-aaa-400",
            "museum-aaa-400",
            "nekudot-w26-bold",
            "omes-aaa-400",
            "opensanshebrewcondensed-regular",
            "shabazi-w26-bold",
            "amatic sc",
            "braggadocio-w01",
            "chelsea market",
            "corben",
            "fredericka the great",
            "geotica-w01-four-open",
            "helvetica neue",
            "helvetica neue italic",
            "helvetica neue medium",
            "helvetica neue thin",
            "itc-arecibo-w01-regular",
            "josefin slab",
            "lucida sans unicode",
            "marzo-w00-regular",
            "mr de haviland",
            "museo-w01-700",
            "museo-slab-w01-100",
            "niconne",
            "nimbus-sans-tw01con",
            "overlock",
            "pacifica-w00-condensed",
            "raleway",
            "rosewood-w01-regular",
            "snellroundhandw01-scrip",
            "spinnaker",
            "stencil-w01-bold"
          ]
        },
        "textMode": {
          "type": "string",
          "enum": [
            "titleAndDescription",
            "titleOnly",
            "descriptionOnly",
            "noText"
          ]
        },
        "alignText": {
          "type": "string",
          "enum": [
            "left",
            "center",
            "right"
          ]
        },
        "autoplayInterval": true,
        "autoplay": true,
        "showPagination": true,
        "galleryImageOnClickAction": {
          "type": "string",
          "enum": [
            "disabled",
            "zoomMode",
            "goToLink"
          ]
        },
        "cropAndFitStage": {
          "type": "string",
          "enum": [
            "crop",
            "fit"
          ]
        },
        "transition": {
          "type": "string",
          "enum": [
            "none",
            "1",
            "2",
            "3",
            "4",
            "5",
            "random"
          ]
        },
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "MasonryProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "font": {
          "type": "string",
          "enum": [
            "lucidaSansConsole",
            "palatinoLinotype",
            "americantypwrteritcw01--731025",
            "anton",
            "arial",
            "arialBlack",
            "avenida-w01",
            "basic",
            "caudex",
            "clarendon-w01-medium-692107",
            "comicSansMS",
            "cookie",
            "coquette-w00-light",
            "courierNew",
            "din-next-w01-light",
            "droid-serif-w01-regular",
            "eb garamond",
            "enriqueta",
            "forum",
            "georgia",
            "helvetica-w01-roman",
            "helvetica-w01-bold",
            "helvetica-w01-light",
            "impact",
            "jockey one",
            "jura",
            "kelly slab",
            "lobster",
            "lucidaConsole",
            "marck script",
            "monoton",
            "noticia text",
            "open sans",
            "open sans condensed",
            "palatino linotype",
            "patrick hand",
            "play",
            "reklamescriptw00-medium",
            "sacramento",
            "sarina",
            "signika",
            "soho-w01-thin-condensed",
            "tahoma",
            "timesNewRoman",
            "verdana",
            "bodoni-w01-poster",
            "ｍｓ ゴシック",
            "ｍｓ 明朝",
            "ｍｓ ｐゴシック",
            "ｍｓ ｐ明朝",
            "meiryo",
            "メイリオ",
            "bm-hanna",
            "돋움",
            "fbbluegothicl",
            "fbchamblue",
            "fbgreen",
            "fbneogothic",
            "fbplum",
            "굴림",
            "맑은 고딕",
            "nanumgothic-regular",
            "ahmedltw20-outlineregul",
            "amiri",
            "arabictypesettingw23-re",
            "arian-lt-w20-regular",
            "arian-lt-w20-light",
            "coheadlinew23-arabicbol",
            "dinnextltw23-ultralight",
            "droid-naskh",
            "janna-lt-w20-regular",
            "kufi-lt-w20-regular",
            "midan-w20",
            "helveticaneueltw20-ligh",
            "tanseekmodernw20-light",
            "adler-w26-regular",
            "alef-regular",
            "almoni-dl-aaa-700",
            "almoni-dl-aaa-300",
            "almoni-dl-aaa-400",
            "asimon-aaa-400",
            "atlas-aaa-500",
            "chips-w26-normal",
            "frank-ruhl-w26-regular",
            "gulash-w26-regular",
            "haim-arukeem-w26-medium",
            "miriam-w26-medium",
            "mixtape-aaa-400",
            "museum-aaa-400",
            "nekudot-w26-bold",
            "omes-aaa-400",
            "opensanshebrewcondensed-regular",
            "shabazi-w26-bold",
            "amatic sc",
            "braggadocio-w01",
            "chelsea market",
            "corben",
            "fredericka the great",
            "geotica-w01-four-open",
            "helvetica neue",
            "helvetica neue italic",
            "helvetica neue medium",
            "helvetica neue thin",
            "itc-arecibo-w01-regular",
            "josefin slab",
            "lucida sans unicode",
            "marzo-w00-regular",
            "mr de haviland",
            "museo-w01-700",
            "museo-slab-w01-100",
            "niconne",
            "nimbus-sans-tw01con",
            "overlock",
            "pacifica-w00-condensed",
            "raleway",
            "rosewood-w01-regular",
            "snellroundhandw01-scrip",
            "spinnaker",
            "stencil-w01-bold"
          ]
        },
        "galleryImageOnClickAction": {
          "type": "string",
          "enum": [
            "disabled",
            "zoomMode",
            "goToLink"
          ]
        },
        "numCols": true,
        "margin": true,
        "textMode": {
          "type": "string",
          "enum": [
            "titleAndDescription",
            "titleOnly",
            "descriptionOnly",
            "noText"
          ]
        },
        "alignText": {
          "type": "string",
          "enum": [
            "left",
            "center",
            "right"
          ]
        },
        "boxShadowIsOn": true,
        "boxShadow": true,
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "StripShowcaseProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "galleryImageOnClickAction": {
          "type": "string",
          "enum": [
            "disabled",
            "zoomMode",
            "goToLink"
          ]
        },
        "cropAndFitStage": {
          "type": "string",
          "enum": [
            "crop",
            "fit"
          ]
        },
        "imageScale": {
          "type": "string",
          "enum": [
            "16:9",
            "4:3",
            "1:1",
            "3:4",
            "9:16"
          ]
        },
        "imageMargin": true,
        "showThumbnails": true,
        "thumbsScale": {
          "type": "string",
          "enum": [
            "16:9",
            "4:3",
            "1:1",
            "3:4",
            "9:16"
          ]
        },
        "thumbsMargin": true,
        "autoplay": true,
        "autoplayInterval": true,
        "arrowMode": true,
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "StripSlideshowProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "font": {
          "type": "string",
          "enum": [
            "lucidaSansConsole",
            "palatinoLinotype",
            "americantypwrteritcw01--731025",
            "anton",
            "arial",
            "arialBlack",
            "avenida-w01",
            "basic",
            "caudex",
            "clarendon-w01-medium-692107",
            "comicSansMS",
            "cookie",
            "coquette-w00-light",
            "courierNew",
            "din-next-w01-light",
            "droid-serif-w01-regular",
            "eb garamond",
            "enriqueta",
            "forum",
            "georgia",
            "helvetica-w01-roman",
            "helvetica-w01-bold",
            "helvetica-w01-light",
            "impact",
            "jockey one",
            "jura",
            "kelly slab",
            "lobster",
            "lucidaConsole",
            "marck script",
            "monoton",
            "noticia text",
            "open sans",
            "open sans condensed",
            "palatino linotype",
            "patrick hand",
            "play",
            "reklamescriptw00-medium",
            "sacramento",
            "sarina",
            "signika",
            "soho-w01-thin-condensed",
            "tahoma",
            "timesNewRoman",
            "verdana",
            "bodoni-w01-poster",
            "ｍｓ ゴシック",
            "ｍｓ 明朝",
            "ｍｓ ｐゴシック",
            "ｍｓ ｐ明朝",
            "meiryo",
            "メイリオ",
            "bm-hanna",
            "돋움",
            "fbbluegothicl",
            "fbchamblue",
            "fbgreen",
            "fbneogothic",
            "fbplum",
            "굴림",
            "맑은 고딕",
            "nanumgothic-regular",
            "ahmedltw20-outlineregul",
            "amiri",
            "arabictypesettingw23-re",
            "arian-lt-w20-regular",
            "arian-lt-w20-light",
            "coheadlinew23-arabicbol",
            "dinnextltw23-ultralight",
            "droid-naskh",
            "janna-lt-w20-regular",
            "kufi-lt-w20-regular",
            "midan-w20",
            "helveticaneueltw20-ligh",
            "tanseekmodernw20-light",
            "adler-w26-regular",
            "alef-regular",
            "almoni-dl-aaa-700",
            "almoni-dl-aaa-300",
            "almoni-dl-aaa-400",
            "asimon-aaa-400",
            "atlas-aaa-500",
            "chips-w26-normal",
            "frank-ruhl-w26-regular",
            "gulash-w26-regular",
            "haim-arukeem-w26-medium",
            "miriam-w26-medium",
            "mixtape-aaa-400",
            "museum-aaa-400",
            "nekudot-w26-bold",
            "omes-aaa-400",
            "opensanshebrewcondensed-regular",
            "shabazi-w26-bold",
            "amatic sc",
            "braggadocio-w01",
            "chelsea market",
            "corben",
            "fredericka the great",
            "geotica-w01-four-open",
            "helvetica neue",
            "helvetica neue italic",
            "helvetica neue medium",
            "helvetica neue thin",
            "itc-arecibo-w01-regular",
            "josefin slab",
            "lucida sans unicode",
            "marzo-w00-regular",
            "mr de haviland",
            "museo-w01-700",
            "museo-slab-w01-100",
            "niconne",
            "nimbus-sans-tw01con",
            "overlock",
            "pacifica-w00-condensed",
            "raleway",
            "rosewood-w01-regular",
            "snellroundhandw01-scrip",
            "spinnaker",
            "stencil-w01-bold"
          ]
        },
        "textMode": {
          "type": "string",
          "enum": [
            "titleAndDescription",
            "titleOnly",
            "descriptionOnly",
            "noText"
          ]
        },
        "alignText": {
          "type": "string",
          "enum": [
            "left",
            "center",
            "right"
          ]
        },
        "autoplayInterval": true,
        "showPlaybackControl": true,
        "autoplay": true,
        "transDuration": true,
        "transition": {
          "type": "string",
          "enum": [
            "none",
            "crossFade",
            "slide",
            "scroll",
            "zoom",
            "random"
          ]
        },
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "ThumbnailsProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "font": {
          "type": "string",
          "enum": [
            "lucidaSansConsole",
            "palatinoLinotype",
            "americantypwrteritcw01--731025",
            "anton",
            "arial",
            "arialBlack",
            "avenida-w01",
            "basic",
            "caudex",
            "clarendon-w01-medium-692107",
            "comicSansMS",
            "cookie",
            "coquette-w00-light",
            "courierNew",
            "din-next-w01-light",
            "droid-serif-w01-regular",
            "eb garamond",
            "enriqueta",
            "forum",
            "georgia",
            "helvetica-w01-roman",
            "helvetica-w01-bold",
            "helvetica-w01-light",
            "impact",
            "jockey one",
            "jura",
            "kelly slab",
            "lobster",
            "lucidaConsole",
            "marck script",
            "monoton",
            "noticia text",
            "open sans",
            "open sans condensed",
            "palatino linotype",
            "patrick hand",
            "play",
            "reklamescriptw00-medium",
            "sacramento",
            "sarina",
            "signika",
            "soho-w01-thin-condensed",
            "tahoma",
            "timesNewRoman",
            "verdana",
            "bodoni-w01-poster",
            "ｍｓ ゴシック",
            "ｍｓ 明朝",
            "ｍｓ ｐゴシック",
            "ｍｓ ｐ明朝",
            "meiryo",
            "メイリオ",
            "bm-hanna",
            "돋움",
            "fbbluegothicl",
            "fbchamblue",
            "fbgreen",
            "fbneogothic",
            "fbplum",
            "굴림",
            "맑은 고딕",
            "nanumgothic-regular",
            "ahmedltw20-outlineregul",
            "amiri",
            "arabictypesettingw23-re",
            "arian-lt-w20-regular",
            "arian-lt-w20-light",
            "coheadlinew23-arabicbol",
            "dinnextltw23-ultralight",
            "droid-naskh",
            "janna-lt-w20-regular",
            "kufi-lt-w20-regular",
            "midan-w20",
            "helveticaneueltw20-ligh",
            "tanseekmodernw20-light",
            "adler-w26-regular",
            "alef-regular",
            "almoni-dl-aaa-700",
            "almoni-dl-aaa-300",
            "almoni-dl-aaa-400",
            "asimon-aaa-400",
            "atlas-aaa-500",
            "chips-w26-normal",
            "frank-ruhl-w26-regular",
            "gulash-w26-regular",
            "haim-arukeem-w26-medium",
            "miriam-w26-medium",
            "mixtape-aaa-400",
            "museum-aaa-400",
            "nekudot-w26-bold",
            "omes-aaa-400",
            "opensanshebrewcondensed-regular",
            "shabazi-w26-bold",
            "amatic sc",
            "braggadocio-w01",
            "chelsea market",
            "corben",
            "fredericka the great",
            "geotica-w01-four-open",
            "helvetica neue",
            "helvetica neue italic",
            "helvetica neue medium",
            "helvetica neue thin",
            "itc-arecibo-w01-regular",
            "josefin slab",
            "lucida sans unicode",
            "marzo-w00-regular",
            "mr de haviland",
            "museo-w01-700",
            "museo-slab-w01-100",
            "niconne",
            "nimbus-sans-tw01con",
            "overlock",
            "pacifica-w00-condensed",
            "raleway",
            "rosewood-w01-regular",
            "snellroundhandw01-scrip",
            "spinnaker",
            "stencil-w01-bold"
          ]
        },
        "cropAndFitStage": {
          "type": "string",
          "enum": [
            "crop",
            "fit"
          ]
        },
        "componentScale": {
          "type": "string",
          "enum": [
            "16:9",
            "4:3",
            "1:1"
          ]
        },
        "margin": true,
        "textMode": {
          "type": "string",
          "enum": [
            "titleAndDescription",
            "titleOnly",
            "descriptionOnly",
            "noText"
          ]
        },
        "arrowMode": true,
        "alignText": {
          "type": "string",
          "enum": [
            "left",
            "center",
            "right"
          ]
        },
        "autoplayInterval": true,
        "autoplay": true,
        "transDuration": true,
        "transition": {
          "type": "string",
          "enum": [
            "none",
            "crossFade",
            "slide",
            "scroll",
            "zoom",
            "random"
          ]
        },
        "thumbnailsGravity": {
          "type": "string",
          "enum": [
            "top",
            "bottom",
            "left",
            "right"
          ]
        },
        "galleryImageOnClickAction": {
          "type": "string",
          "enum": [
            "disabled",
            "zoomMode",
            "goToLink"
          ]
        },
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "AccordionProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "font": {
          "type": "string",
          "enum": [
            "lucidaSansConsole",
            "palatinoLinotype",
            "americantypwrteritcw01--731025",
            "anton",
            "arial",
            "arialBlack",
            "avenida-w01",
            "basic",
            "caudex",
            "clarendon-w01-medium-692107",
            "comicSansMS",
            "cookie",
            "coquette-w00-light",
            "courierNew",
            "din-next-w01-light",
            "droid-serif-w01-regular",
            "eb garamond",
            "enriqueta",
            "forum",
            "georgia",
            "helvetica-w01-roman",
            "helvetica-w01-bold",
            "helvetica-w01-light",
            "impact",
            "jockey one",
            "jura",
            "kelly slab",
            "lobster",
            "lucidaConsole",
            "marck script",
            "monoton",
            "noticia text",
            "open sans",
            "open sans condensed",
            "palatino linotype",
            "patrick hand",
            "play",
            "reklamescriptw00-medium",
            "sacramento",
            "sarina",
            "signika",
            "soho-w01-thin-condensed",
            "tahoma",
            "timesNewRoman",
            "verdana",
            "bodoni-w01-poster",
            "ｍｓ ゴシック",
            "ｍｓ 明朝",
            "ｍｓ ｐゴシック",
            "ｍｓ ｐ明朝",
            "meiryo",
            "メイリオ",
            "bm-hanna",
            "돋움",
            "fbbluegothicl",
            "fbchamblue",
            "fbgreen",
            "fbneogothic",
            "fbplum",
            "굴림",
            "맑은 고딕",
            "nanumgothic-regular",
            "ahmedltw20-outlineregul",
            "amiri",
            "arabictypesettingw23-re",
            "arian-lt-w20-regular",
            "arian-lt-w20-light",
            "coheadlinew23-arabicbol",
            "dinnextltw23-ultralight",
            "droid-naskh",
            "janna-lt-w20-regular",
            "kufi-lt-w20-regular",
            "midan-w20",
            "helveticaneueltw20-ligh",
            "tanseekmodernw20-light",
            "adler-w26-regular",
            "alef-regular",
            "almoni-dl-aaa-700",
            "almoni-dl-aaa-300",
            "almoni-dl-aaa-400",
            "asimon-aaa-400",
            "atlas-aaa-500",
            "chips-w26-normal",
            "frank-ruhl-w26-regular",
            "gulash-w26-regular",
            "haim-arukeem-w26-medium",
            "miriam-w26-medium",
            "mixtape-aaa-400",
            "museum-aaa-400",
            "nekudot-w26-bold",
            "omes-aaa-400",
            "opensanshebrewcondensed-regular",
            "shabazi-w26-bold",
            "amatic sc",
            "braggadocio-w01",
            "chelsea market",
            "corben",
            "fredericka the great",
            "geotica-w01-four-open",
            "helvetica neue",
            "helvetica neue italic",
            "helvetica neue medium",
            "helvetica neue thin",
            "itc-arecibo-w01-regular",
            "josefin slab",
            "lucida sans unicode",
            "marzo-w00-regular",
            "mr de haviland",
            "museo-w01-700",
            "museo-slab-w01-100",
            "niconne",
            "nimbus-sans-tw01con",
            "overlock",
            "pacifica-w00-condensed",
            "raleway",
            "rosewood-w01-regular",
            "snellroundhandw01-scrip",
            "spinnaker",
            "stencil-w01-bold"
          ]
        },
        "descFont": {
          "type": "string",
          "enum": [
            "lucidaSansConsole",
            "palatinoLinotype",
            "americantypwrteritcw01--731025",
            "anton",
            "arial",
            "arialBlack",
            "avenida-w01",
            "basic",
            "caudex",
            "clarendon-w01-medium-692107",
            "comicSansMS",
            "cookie",
            "coquette-w00-light",
            "courierNew",
            "din-next-w01-light",
            "droid-serif-w01-regular",
            "eb garamond",
            "enriqueta",
            "forum",
            "georgia",
            "helvetica-w01-roman",
            "helvetica-w01-bold",
            "helvetica-w01-light",
            "impact",
            "jockey one",
            "jura",
            "kelly slab",
            "lobster",
            "lucidaConsole",
            "marck script",
            "monoton",
            "noticia text",
            "open sans",
            "open sans condensed",
            "palatino linotype",
            "patrick hand",
            "play",
            "reklamescriptw00-medium",
            "sacramento",
            "sarina",
            "signika",
            "soho-w01-thin-condensed",
            "tahoma",
            "timesNewRoman",
            "verdana",
            "bodoni-w01-poster",
            "ｍｓ ゴシック",
            "ｍｓ 明朝",
            "ｍｓ ｐゴシック",
            "ｍｓ ｐ明朝",
            "meiryo",
            "メイリオ",
            "bm-hanna",
            "돋움",
            "fbbluegothicl",
            "fbchamblue",
            "fbgreen",
            "fbneogothic",
            "fbplum",
            "굴림",
            "맑은 고딕",
            "nanumgothic-regular",
            "ahmedltw20-outlineregul",
            "amiri",
            "arabictypesettingw23-re",
            "arian-lt-w20-regular",
            "arian-lt-w20-light",
            "coheadlinew23-arabicbol",
            "dinnextltw23-ultralight",
            "droid-naskh",
            "janna-lt-w20-regular",
            "kufi-lt-w20-regular",
            "midan-w20",
            "helveticaneueltw20-ligh",
            "tanseekmodernw20-light",
            "adler-w26-regular",
            "alef-regular",
            "almoni-dl-aaa-700",
            "almoni-dl-aaa-300",
            "almoni-dl-aaa-400",
            "asimon-aaa-400",
            "atlas-aaa-500",
            "chips-w26-normal",
            "frank-ruhl-w26-regular",
            "gulash-w26-regular",
            "haim-arukeem-w26-medium",
            "miriam-w26-medium",
            "mixtape-aaa-400",
            "museum-aaa-400",
            "nekudot-w26-bold",
            "omes-aaa-400",
            "opensanshebrewcondensed-regular",
            "shabazi-w26-bold",
            "amatic sc",
            "braggadocio-w01",
            "chelsea market",
            "corben",
            "fredericka the great",
            "geotica-w01-four-open",
            "helvetica neue",
            "helvetica neue italic",
            "helvetica neue medium",
            "helvetica neue thin",
            "itc-arecibo-w01-regular",
            "josefin slab",
            "lucida sans unicode",
            "marzo-w00-regular",
            "mr de haviland",
            "museo-w01-700",
            "museo-slab-w01-100",
            "niconne",
            "nimbus-sans-tw01con",
            "overlock",
            "pacifica-w00-condensed",
            "raleway",
            "rosewood-w01-regular",
            "snellroundhandw01-scrip",
            "spinnaker",
            "stencil-w01-bold"
          ]
        },
        "alignText": {
          "type": "string",
          "enum": [
            "left",
            "center",
            "right"
          ]
        },
        "textMode": {
          "type": "string",
          "enum": [
            "titleOnly",
            "noText"
          ]
        },
        "galleryImageOnClickAction": {
          "type": "string",
          "enum": [
            "disabled",
            "zoomMode",
            "goToLink"
          ]
        },
        "borderWidth": true,
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "CollageProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "font": {
          "type": "string",
          "enum": [
            "lucidaSansConsole",
            "palatinoLinotype",
            "americantypwrteritcw01--731025",
            "anton",
            "arial",
            "arialBlack",
            "avenida-w01",
            "basic",
            "caudex",
            "clarendon-w01-medium-692107",
            "comicSansMS",
            "cookie",
            "coquette-w00-light",
            "courierNew",
            "din-next-w01-light",
            "droid-serif-w01-regular",
            "eb garamond",
            "enriqueta",
            "forum",
            "georgia",
            "helvetica-w01-roman",
            "helvetica-w01-bold",
            "helvetica-w01-light",
            "impact",
            "jockey one",
            "jura",
            "kelly slab",
            "lobster",
            "lucidaConsole",
            "marck script",
            "monoton",
            "noticia text",
            "open sans",
            "open sans condensed",
            "palatino linotype",
            "patrick hand",
            "play",
            "reklamescriptw00-medium",
            "sacramento",
            "sarina",
            "signika",
            "soho-w01-thin-condensed",
            "tahoma",
            "timesNewRoman",
            "verdana",
            "bodoni-w01-poster",
            "ｍｓ ゴシック",
            "ｍｓ 明朝",
            "ｍｓ ｐゴシック",
            "ｍｓ ｐ明朝",
            "meiryo",
            "メイリオ",
            "bm-hanna",
            "돋움",
            "fbbluegothicl",
            "fbchamblue",
            "fbgreen",
            "fbneogothic",
            "fbplum",
            "굴림",
            "맑은 고딕",
            "nanumgothic-regular",
            "ahmedltw20-outlineregul",
            "amiri",
            "arabictypesettingw23-re",
            "arian-lt-w20-regular",
            "arian-lt-w20-light",
            "coheadlinew23-arabicbol",
            "dinnextltw23-ultralight",
            "droid-naskh",
            "janna-lt-w20-regular",
            "kufi-lt-w20-regular",
            "midan-w20",
            "helveticaneueltw20-ligh",
            "tanseekmodernw20-light",
            "adler-w26-regular",
            "alef-regular",
            "almoni-dl-aaa-700",
            "almoni-dl-aaa-300",
            "almoni-dl-aaa-400",
            "asimon-aaa-400",
            "atlas-aaa-500",
            "chips-w26-normal",
            "frank-ruhl-w26-regular",
            "gulash-w26-regular",
            "haim-arukeem-w26-medium",
            "miriam-w26-medium",
            "mixtape-aaa-400",
            "museum-aaa-400",
            "nekudot-w26-bold",
            "omes-aaa-400",
            "opensanshebrewcondensed-regular",
            "shabazi-w26-bold",
            "amatic sc",
            "braggadocio-w01",
            "chelsea market",
            "corben",
            "fredericka the great",
            "geotica-w01-four-open",
            "helvetica neue",
            "helvetica neue italic",
            "helvetica neue medium",
            "helvetica neue thin",
            "itc-arecibo-w01-regular",
            "josefin slab",
            "lucida sans unicode",
            "marzo-w00-regular",
            "mr de haviland",
            "museo-w01-700",
            "museo-slab-w01-100",
            "niconne",
            "nimbus-sans-tw01con",
            "overlock",
            "pacifica-w00-condensed",
            "raleway",
            "rosewood-w01-regular",
            "snellroundhandw01-scrip",
            "spinnaker",
            "stencil-w01-bold"
          ]
        },
        "alignText": {
          "type": "string",
          "enum": [
            "left",
            "center",
            "right"
          ]
        },
        "textMode": {
          "type": "string",
          "enum": [
            "titleAndDescription",
            "titleOnly",
            "noText"
          ]
        },
        "galleryImageOnClickAction": {
          "type": "string",
          "enum": [
            "disabled",
            "zoomMode",
            "goToLink"
          ]
        },
        "minImageSize": true,
        "maxImageSize": true,
        "avergeImageSize": true,
        "margin": true,
        "fitToScreenWidth": true,
        "showNavButtons": true,
        "numOfCells": true,
        "orientation": {
          "type": "string",
          "enum": [
            "vertical",
            "horizontal"
          ]
        },
        "layoutSeed": true,
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "FreestyleProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "galleryImageOnClickAction": {
          "type": "string",
          "enum": [
            "disabled",
            "zoomMode",
            "goToLink"
          ]
        },
        "layoutSeed": true,
        "cropAndFitStage": {
          "type": "string",
          "enum": [
            "crop",
            "fit"
          ]
        },
        "imageDecoration": {
          "type": "string",
          "enum": [
            "none",
            "polaroid",
            "scotchTape",
            "vintageFrame",
            "random"
          ]
        },
        "borderWidth": true,
        "orientation": {
          "type": "string",
          "enum": [
            "vertical",
            "horizontal"
          ]
        },
        "applyRotationInLayout": true,
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "ItunesButtonProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "language": {
          "type": "string",
          "enum": [
            "userLang",
            "da",
            "de",
            "en",
            "es",
            "fr",
            "it",
            "jp",
            "ko",
            "nl",
            "no",
            "pl",
            "pt",
            "ru",
            "sv",
            "tr"
          ]
        },
        "openIn": {
          "type": "string",
          "enum": [
            "_self",
            "_blank"
          ]
        },
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "LayoutProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "x": true,
        "y": true,
        "w": true,
        "h": true,
        "anchors": true,
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "LinkBarProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "gallery": true,
        "iconSize": true,
        "spacing": true,
        "bgScale": true,
        "orientation": {
          "type": "string",
          "enum": [
            "HORIZ",
            "VERT"
          ]
        },
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "MatrixGalleryProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "imageMode": {
          "type": "string",
          "enum": [
            "clipImage",
            "flexibleWidthFixed"
          ]
        },
        "itemHeight": true,
        "numCols": true,
        "maxRows": true,
        "incRows": true,
        "margin": true,
        "alignText": {
          "type": "string",
          "enum": [
            "left",
            "center",
            "right"
          ]
        },
        "showMoreLabel": true,
        "expandEnabled": true,
        "goToLinkText": true,
        "galleryImageOnClickAction": {
          "type": "string",
          "enum": [
            "disabled",
            "zoomMode",
            "goToLink"
          ]
        },
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "NumberInputProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "minValue": true,
        "maxValue": true,
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "PageGroupProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "transition": {
          "type": "string",
          "enum": [
            "none",
            "swipeHorizontalFullScreen",
            "swipeVerticalFullScreen",
            "crossfade",
            "outIn",
            "slide"
          ]
        },
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "PaginatedGridGalleryProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "imageMode": {
          "type": "string",
          "enum": [
            "clipImage"
          ]
        },
        "numCols": true,
        "maxRows": true,
        "margin": true,
        "transition": {
          "type": "string",
          "enum": [
            "none",
            "seq_crossFade_All",
            "seq_shrink_All",
            "swipe_horiz_All",
            "swipe_vert_All",
            "seq_random"
          ]
        },
        "transDuration": true,
        "autoplayInterval": true,
        "autoplay": true,
        "showAutoplay": true,
        "showNavigation": true,
        "showCounter": true,
        "expandEnabled": true,
        "goToLinkText": true,
        "galleryImageOnClickAction": {
          "type": "string",
          "enum": [
            "disabled",
            "zoomMode",
            "goToLink"
          ]
        },
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "PayPalButtonProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "buttonType": {
          "type": "string",
          "enum": [
            "buy",
            "donate"
          ]
        },
        "itemName": true,
        "itemID": true,
        "organizationName": true,
        "organizationID": true,
        "amount": true,
        "currencyCode": true,
        "target": {
          "type": "string",
          "enum": [
            "_self",
            "_blank"
          ]
        },
        "showCreditCards": true,
        "smallButton": true,
        "language": {
          "type": "string",
          "enum": [
            "userLang",
            "da",
            "de",
            "en",
            "es",
            "fr",
            "it",
            "ja",
            "nl",
            "no",
            "pl",
            "pt",
            "ru",
            "sv",
            "tr"
          ]
        },
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "SiteSegmentContainerProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "fixedPosition": true,
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "SliderGalleryProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "imageMode": {
          "type": "string",
          "enum": [
            "clipImage",
            "flexibleWidth"
          ]
        },
        "margin": true,
        "maxSpeed": true,
        "aspectRatio": true,
        "aspectRatioPreset": {
          "type": "string",
          "enum": [
            "16:9",
            "4:3",
            "1:1",
            "3:4",
            "9:16"
          ]
        },
        "loop": true,
        "showCounter": true,
        "expandEnabled": true,
        "goToLinkText": true,
        "galleryImageOnClickAction": {
          "type": "string",
          "enum": [
            "disabled",
            "zoomMode",
            "goToLink"
          ]
        },
        "autoplayInterval": true,
        "transDuration": true,
        "showAutoplay": true,
        "autoplay": true,
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "SlideShowGalleryProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "imageMode": {
          "type": "string",
          "enum": [
            "clipImage",
            "flexibleHeight",
            "flexibleWidthFixed"
          ]
        },
        "transition": {
          "type": "string",
          "enum": [
            "none",
            "swipeVertical",
            "swipeHorizontal",
            "crossfade",
            "outIn"
          ]
        },
        "autoplayInterval": true,
        "autoplay": true,
        "transDuration": true,
        "bidirectional": true,
        "reverse": true,
        "showAutoplay": true,
        "showNavigation": true,
        "showCounter": true,
        "expandEnabled": true,
        "goToLinkText": true,
        "galleryImageOnClickAction": {
          "type": "string",
          "enum": [
            "disabled",
            "zoomMode",
            "goToLink"
          ]
        },
        "alignText": {
          "type": "string",
          "enum": [
            "left",
            "right"
          ]
        },
        "showSocial": true,
        "showExpand": true,
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "SvgShapeProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "maintainAspectRatio": true,
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "VectorImageProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "displayMode": {
          "type": "string",
          "enum": [
            "legacyFit",
            "fit",
            "stretch"
          ]
        },
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true,
        "flip": {
          "type": "string",
          "enum": [
            "x",
            "y",
            "xy",
            "horizontal",
            "vertical",
            "both",
            "none"
          ]
        }
      },
      "additionalProperties": false
    },
    "TableComponentProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "minHeight": true,
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "TinyMenuProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "direction": {
          "type": "string",
          "enum": [
            "left",
            "center",
            "right"
          ]
        },
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "ExpandableMenuProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "itemsAlignment": {
          "type": "string",
          "enum": [
            "left",
            "center",
            "right"
          ]
        },
        "subMenuOpenSide": {
          "type": "string",
          "enum": [
            "left",
            "center",
            "right"
          ]
        },
        "originalHeight": true,
        "menuItemHeight": true,
        "menuArrowDirection": {
          "enum": [
            "left",
            "center",
            "right"
          ]
        },
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "TwitterFeedProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "numOfTweets": true,
        "subject": true,
        "title": true,
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "VideoProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "autoplay": true,
        "loop": true,
        "showinfo": true,
        "lightTheme": true,
        "showControls": {
          "type": "string",
          "enum": [
            "always_show",
            "always_hide",
            "temp_show"
          ]
        },
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "VKShareProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "rightAngles": true,
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "WFacebookCommentProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "numPosts": true,
        "width": true,
        "colorScheme": {
          "type": "string",
          "enum": [
            "light",
            "dark"
          ]
        },
        "canBeShownOnAllPagesBug": true,
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "DisqusCommentsProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "disqusId": true,
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "WFacebookLikeProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "layout": {
          "type": "string",
          "enum": [
            "standard",
            "button_count",
            "box_count"
          ]
        },
        "send": true,
        "show_faces": true,
        "width": true,
        "action": {
          "type": "string",
          "enum": [
            "like",
            "recommend"
          ]
        },
        "font": {
          "type": "string",
          "enum": [
            "helvetica",
            "arial",
            "lucida grande",
            "segoe ui",
            "tahoma",
            "trebuchet ms",
            "verdana"
          ]
        },
        "colorScheme": {
          "type": "string",
          "enum": [
            "light",
            "dark"
          ]
        },
        "language": {
          "type": "string",
          "enum": [
            "userLang",
            "da",
            "de",
            "en",
            "es",
            "fr",
            "it",
            "ja",
            "kr",
            "nl",
            "no",
            "pl",
            "pt",
            "ru",
            "sv",
            "tr"
          ]
        },
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "WGooglePlusOneProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "size": {
          "type": "string",
          "enum": [
            "small",
            "medium",
            "standard",
            "tall"
          ]
        },
        "annotation": {
          "type": "string",
          "enum": [
            "none",
            "bubble",
            "inline"
          ]
        },
        "width": true,
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "WPhotoProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "displayMode": {
          "type": "string",
          "enum": [
            "fit",
            "fill",
            "full",
            "stretch",
            "fitWidth",
            "fitWidthStrict",
            "fitHeightStrict"
          ]
        },
        "autoFill": true,
        "onClickBehavior": {
          "type": "string",
          "enum": [
            "disabled",
            "goToLink",
            "zoomMode",
            "zoomAndPanMode"
          ]
        },
        "effectName": true,
        "filterEffect": {
          "type": [
            "object",
            "null"
          ],
          "properties": {
            "effectType": true,
            "brightness": true,
            "contrast": true,
            "saturation": true,
            "hue": true,
            "duotoneDark": true,
            "duotoneLight": true,
            "invert": true,
            "isCustom": true
          },
          "additionalProperties": false
        },
        "overrideCrop": {
          "oneOf": [
            {
              "type": "null"
            },
            {
              "type": [
                "object"
              ],
              "properties": {
                "x": true,
                "y": true,
                "width": true,
                "height": true,
                "svgId": true,
                "rotate": true,
                "flip": {
                  "type": "string",
                  "enum": [
                    "x",
                    "y",
                    "xy",
                    "horizontal",
                    "vertical",
                    "both",
                    "none"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "WRichTextProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "packed": true,
        "brightness": true,
        "overrideAlignment": {
          "oneOf": [
            {
              "type": "null"
            },
            {
              "type": "string",
              "enum": [
                "left",
                "right",
                "center",
                "justify"
              ]
            }
          ]
        },
        "overrideColor": true,
        "minHeight": true,
        "minWidth": true,
        "verticalText": true,
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "RefComponentProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "minHeight": true,
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "WTwitterFollowProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "showCount": true,
        "showScreenName": true,
        "textColor": {
          "type": [
            "string",
            "null"
          ],
          "pattern": "^(#(([0-9|a-f|A-F]){3}){1,2})$"
        },
        "linkColor": {
          "type": [
            "string",
            "null"
          ],
          "pattern": "^(#(([0-9|a-f|A-F]){3}){1,2})$"
        },
        "width": true,
        "dataLang": {
          "type": "string",
          "enum": [
            "userLang",
            "da",
            "de",
            "en",
            "es",
            "fr",
            "hi",
            "it",
            "ja",
            "ko",
            "nl",
            "no",
            "pl",
            "pt",
            "ru",
            "sv",
            "tr"
          ]
        },
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "WTwitterTweetProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "dataCount": {
          "type": "string",
          "enum": [
            "none",
            "horizontal",
            "vertical"
          ]
        },
        "dataLang": {
          "type": "string",
          "enum": [
            "userLang",
            "da",
            "de",
            "en",
            "es",
            "fr",
            "hi",
            "it",
            "ja",
            "ko",
            "nl",
            "no",
            "pl",
            "pt",
            "ru",
            "sv",
            "tr"
          ]
        },
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "HoverBoxProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "mobileDisplayedModeId": true,
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true,
        "enableBackgroundVideo": true
      },
      "additionalProperties": false
    },
    "TPAGluedProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "placement": true,
        "verticalMargin": true,
        "horizontalMargin": true,
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "HoneycombProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "font": {
          "type": "string",
          "enum": [
            "lucidaSansConsole",
            "palatinoLinotype",
            "americantypwrteritcw01--731025",
            "anton",
            "arial",
            "arialBlack",
            "avenida-w01",
            "basic",
            "caudex",
            "clarendon-w01-medium-692107",
            "comicSansMS",
            "cookie",
            "coquette-w00-light",
            "courierNew",
            "din-next-w01-light",
            "droid-serif-w01-regular",
            "eb garamond",
            "enriqueta",
            "forum",
            "georgia",
            "helvetica-w01-roman",
            "helvetica-w01-bold",
            "helvetica-w01-light",
            "impact",
            "jockey one",
            "jura",
            "kelly slab",
            "lobster",
            "lucidaConsole",
            "marck script",
            "monoton",
            "noticia text",
            "open sans",
            "open sans condensed",
            "palatino linotype",
            "patrick hand",
            "play",
            "reklamescriptw00-medium",
            "sacramento",
            "sarina",
            "signika",
            "soho-w01-thin-condensed",
            "tahoma",
            "timesNewRoman",
            "verdana",
            "bodoni-w01-poster",
            "ｍｓ ゴシック",
            "ｍｓ 明朝",
            "ｍｓ ｐゴシック",
            "ｍｓ ｐ明朝",
            "meiryo",
            "メイリオ",
            "bm-hanna",
            "돋움",
            "fbbluegothicl",
            "fbchamblue",
            "fbgreen",
            "fbneogothic",
            "fbplum",
            "굴림",
            "맑은 고딕",
            "nanumgothic-regular",
            "ahmedltw20-outlineregul",
            "amiri",
            "arabictypesettingw23-re",
            "arian-lt-w20-regular",
            "arian-lt-w20-light",
            "coheadlinew23-arabicbol",
            "dinnextltw23-ultralight",
            "droid-naskh",
            "janna-lt-w20-regular",
            "kufi-lt-w20-regular",
            "midan-w20",
            "helveticaneueltw20-ligh",
            "tanseekmodernw20-light",
            "adler-w26-regular",
            "alef-regular",
            "almoni-dl-aaa-700",
            "almoni-dl-aaa-300",
            "almoni-dl-aaa-400",
            "asimon-aaa-400",
            "atlas-aaa-500",
            "chips-w26-normal",
            "frank-ruhl-w26-regular",
            "gulash-w26-regular",
            "haim-arukeem-w26-medium",
            "miriam-w26-medium",
            "mixtape-aaa-400",
            "museum-aaa-400",
            "nekudot-w26-bold",
            "omes-aaa-400",
            "opensanshebrewcondensed-regular",
            "shabazi-w26-bold",
            "amatic sc",
            "braggadocio-w01",
            "chelsea market",
            "corben",
            "fredericka the great",
            "geotica-w01-four-open",
            "helvetica neue",
            "helvetica neue italic",
            "helvetica neue medium",
            "helvetica neue thin",
            "itc-arecibo-w01-regular",
            "josefin slab",
            "lucida sans unicode",
            "marzo-w00-regular",
            "mr de haviland",
            "museo-w01-700",
            "museo-slab-w01-100",
            "niconne",
            "nimbus-sans-tw01con",
            "overlock",
            "pacifica-w00-condensed",
            "raleway",
            "rosewood-w01-regular",
            "snellroundhandw01-scrip",
            "spinnaker",
            "stencil-w01-bold"
          ]
        },
        "alignText": {
          "type": "string",
          "enum": [
            "left",
            "center",
            "right"
          ]
        },
        "textMode": {
          "type": "string",
          "enum": [
            "titleAndDescription",
            "titleOnly",
            "descriptionOnly",
            "noText"
          ]
        },
        "galleryImageOnClickAction": {
          "type": "string",
          "enum": [
            "disabled",
            "zoomMode",
            "goToLink"
          ]
        },
        "margin": true,
        "numOfColumns": true,
        "numOfHoles": true,
        "layoutSeed": true,
        "rolloverAnimation": {
          "type": "string",
          "enum": [
            "colorOnly",
            "glow",
            "bounce"
          ]
        },
        "imageShape": {
          "type": "string",
          "enum": [
            "hexagon",
            "square",
            "triangle"
          ]
        },
        "imageScale": {
          "type": "string",
          "enum": [
            "x1",
            "x2",
            "x3"
          ]
        },
        "expandEnabled": true,
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "AppPartProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "direction": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl"
          ]
        },
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "RssButtonProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "transition": {
          "type": "string",
          "enum": [
            "none",
            "fade",
            "float",
            "expand",
            "spin",
            "fly",
            "turn",
            "reveal",
            "slide",
            "puff",
            "flip",
            "fold",
            "arc"
          ]
        },
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "BoxSlideShowProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "transition": {
          "type": "string",
          "enum": [
            "NoTransition",
            "SlideVertical",
            "SlideHorizontal",
            "CrossFade",
            "OutIn"
          ]
        },
        "autoPlay": true,
        "autoPlayInterval": true,
        "showPlaybackControl": true,
        "direction": {
          "type": "string",
          "enum": [
            "LTR",
            "RTL"
          ]
        },
        "pauseAutoPlayOnMouseOver": true,
        "transDuration": true,
        "shouldHideOverflowContent": true,
        "flexibleBoxHeight": true,
        "showNavigationButton": true,
        "navigationButtonSize": true,
        "navigationButtonMargin": true,
        "showNavigationDots": true,
        "navigationDotsAlignment": {
          "type": "string",
          "enum": [
            "left",
            "center",
            "right"
          ]
        },
        "navigationDotsSize": true,
        "navigationDotsMargin": true,
        "navigationDotsGap": true,
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "BoxSlideShowSlideProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true,
        "enableBackgroundVideo": true
      },
      "additionalProperties": false
    },
    "StateBoxProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "transition": {
          "type": "string",
          "enum": [
            "NoTransition",
            "SlideVertical",
            "SlideHorizontal",
            "CrossFade",
            "OutIn"
          ]
        },
        "transDuration": true,
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "StateBoxStateProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true,
        "enableBackgroundVideo": true
      },
      "additionalProperties": false
    },
    "StateBoxFormStateProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true,
        "enableBackgroundVideo": true
      },
      "additionalProperties": false
    },
    "StripContainerSlideShowProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "transition": {
          "type": "string",
          "enum": [
            "NoTransition",
            "SlideVertical",
            "SlideHorizontal",
            "CrossFade",
            "OutIn"
          ]
        },
        "autoPlay": true,
        "showPlaybackControl": true,
        "autoPlayInterval": true,
        "direction": {
          "type": "string",
          "enum": [
            "LTR",
            "RTL"
          ]
        },
        "pauseAutoPlayOnMouseOver": true,
        "transDuration": true,
        "shouldHideOverflowContent": true,
        "flexibleBoxHeight": true,
        "showNavigationButton": true,
        "navigationButtonSize": true,
        "navigationButtonMargin": true,
        "showNavigationDots": true,
        "navigationDotsAlignment": {
          "type": "string",
          "enum": [
            "left",
            "center",
            "right"
          ]
        },
        "navigationDotsSize": true,
        "navigationDotsMargin": true,
        "navigationDotsGap": true,
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "StripContainerSlideShowSlideProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true,
        "enableBackgroundVideo": true
      },
      "additionalProperties": false
    },
    "VerticalAnchorsMenuProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "itemsAlignment": {
          "type": "string",
          "enum": [
            "left",
            "center",
            "right"
          ]
        },
        "orientation": {
          "type": "string",
          "enum": [
            "left",
            "right"
          ]
        },
        "autoColor": true,
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "TextInputProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "textAlignment": {
          "oneOf": [
            {
              "type": "null"
            },
            {
              "type": "string",
              "enum": [
                "left",
                "right",
                "center"
              ]
            }
          ]
        },
        "textPadding": true,
        "placeholder": true,
        "defaultTextType": {
          "oneOf": [
            {
              "type": "null"
            },
            {
              "type": "string",
              "enum": [
                "none",
                "initialText",
                "placeholderText",
                "placeholderAndInitialText"
              ]
            }
          ]
        },
        "autoComplete": true,
        "label": true,
        "required": true,
        "autoFocus": true,
        "readOnly": true,
        "tabIndex": true,
        "inputHeight": true,
        "inputHeightMobile": true,
        "labelMargin": true,
        "labelPadding": true,
        "labelMobileFontSize": true,
        "inputMobileFontSize": true,
        "isDisabled": true,
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true,
        "errorMessageType": {
          "type": "string",
          "enum": [
            "inline",
            "tooltip"
          ]
        }
      },
      "additionalProperties": false
    },
    "TextAreaInputProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "textAlignment": {
          "type": "string",
          "enum": [
            "left",
            "right",
            "center"
          ]
        },
        "textPadding": true,
        "placeholder": true,
        "defaultTextType": {
          "type": "string",
          "enum": [
            "none",
            "initialText",
            "placeholderText",
            "placeholderAndInitialText"
          ]
        },
        "label": true,
        "required": true,
        "autoFocus": true,
        "readOnly": true,
        "tabIndex": true,
        "inputHeight": true,
        "inputHeightMobile": true,
        "labelMargin": true,
        "labelPadding": true,
        "labelMobileFontSize": true,
        "inputMobileFontSize": true,
        "isDisabled": true,
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true,
        "errorMessageType": {
          "type": "string",
          "enum": [
            "inline",
            "tooltip"
          ]
        }
      },
      "additionalProperties": false
    },
    "CheckboxProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "alignment": {
          "type": "string",
          "enum": [
            "left",
            "right"
          ]
        },
        "buttonSize": true,
        "spacing": true,
        "label": true,
        "required": true,
        "autoFocus": true,
        "readOnly": true,
        "tabIndex": true,
        "inputHeight": true,
        "inputHeightMobile": true,
        "labelMargin": true,
        "labelPadding": true,
        "labelMobileFontSize": true,
        "inputMobileFontSize": true,
        "isDisabled": true,
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "DatePickerProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "textAlignment": {
          "type": "string",
          "enum": [
            "left",
            "right",
            "center"
          ]
        },
        "textPadding": true,
        "placeholder": true,
        "dateFormat": {
          "type": "string",
          "enum": [
            "MM/DD/YYYY",
            "DD/MM/YYYY",
            "YYYY/MM/DD",
            "YYYY/M/D"
          ]
        },
        "defaultTextType": {
          "type": "string",
          "enum": [
            "none",
            "today",
            "placeholder"
          ]
        },
        "dayToStart": {
          "oneOf": [
            {
              "type": "null"
            },
            {
              "type": "string",
              "enum": [
                "Sunday",
                "Monday"
              ]
            }
          ]
        },
        "label": true,
        "required": true,
        "autoFocus": true,
        "readOnly": true,
        "tabIndex": true,
        "inputHeight": true,
        "inputHeightMobile": true,
        "labelMargin": true,
        "labelPadding": true,
        "labelMobileFontSize": true,
        "inputMobileFontSize": true,
        "isDisabled": true,
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "GridProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "columns": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "id": true,
              "dataPath": true,
              "linkPath": true,
              "label": true,
              "width": true,
              "visible": true,
              "type": {
                "type": "string",
                "enum": [
                  "number",
                  "string",
                  "date",
                  "image",
                  "bool",
                  "richText"
                ]
              },
              "imageAltPath": true
            },
            "additionalProperties": false
          }
        },
        "showHeader": true,
        "headerHeight": true,
        "rowHeight": true,
        "allowUserSorting": true,
        "allowUserFiltering": true,
        "allowUserEditing": true,
        "heightLayout": {
          "type": "string",
          "enum": [
            "manual",
            "auto"
          ]
        },
        "pagination": {
          "type": "object",
          "properties": {
            "type": {
              "type": "string",
              "enum": [
                "normal",
                "pagination",
                "virtual"
              ]
            },
            "rowsPerPage": true,
            "manualHeightProps": {
              "type": "object",
              "properties": {
                "rowsPerPage": true,
                "gridHeight": true,
                "type": {
                  "type": "string",
                  "enum": [
                    "normal",
                    "pagination",
                    "virtual"
                  ]
                }
              },
              "additionalProperties": false
            },
            "style": {
              "type": "string",
              "enum": [
                "text",
                "number",
                "simple"
              ]
            },
            "alignment": {
              "type": "string",
              "enum": [
                "left",
                "center",
                "right",
                "spread"
              ]
            }
          },
          "additionalProperties": false
        },
        "userSelectionType": {
          "type": "string",
          "enum": [
            "none",
            "cell",
            "row"
          ]
        },
        "dateFormat": true,
        "sorting": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "colId": true,
              "sort": {
                "type": "string",
                "enum": [
                  "asc",
                  "desc",
                  "none"
                ]
              }
            },
            "additionalProperties": false
          }
        },
        "linkTarget": {
          "type": "string",
          "enum": [
            "_self",
            "_blank"
          ]
        },
        "columnLayout": {
          "type": "string",
          "enum": [
            "equal",
            "fitContent",
            "manual"
          ]
        },
        "horizontalAlignment": {
          "type": "string",
          "enum": [
            "left",
            "center",
            "right"
          ]
        },
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "PagePropertiesForDevice": {
      "type": [
        "object",
        "null"
      ],
      "properties": {
        "minHeight": true,
        "popup": {
          "type": "object",
          "properties": {
            "closeOnOverlayClick": true
          },
          "additionalProperties": false
        }
      },
      "additionalProperties": false
    },
    "PageProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "desktop": {
          "type": [
            "object",
            "null"
          ],
          "properties": {
            "minHeight": true,
            "popup": {
              "type": "object",
              "properties": {
                "closeOnOverlayClick": true
              },
              "additionalProperties": false
            }
          },
          "additionalProperties": false
        },
        "mobile": {
          "type": [
            "object",
            "null"
          ],
          "properties": {
            "minHeight": true,
            "popup": {
              "type": "object",
              "properties": {
                "closeOnOverlayClick": true
              },
              "additionalProperties": false
            }
          },
          "additionalProperties": false
        },
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "PopupContainerProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "horizontalAlignment": {
          "type": "string",
          "enum": [
            "left",
            "right",
            "center"
          ]
        },
        "verticalAlignment": {
          "type": "string",
          "enum": [
            "top",
            "bottom",
            "center"
          ]
        },
        "alignmentType": {
          "type": "string",
          "enum": [
            "nineGrid",
            "fullHeight",
            "fullWidth"
          ]
        },
        "horizontalOffset": true,
        "verticalOffset": true,
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true,
        "enableBackgroundVideo": true
      },
      "additionalProperties": false
    },
    "MediaPlayerProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "autoplay": true,
        "playerInteraction": {
          "type": "object",
          "properties": {
            "click": {
              "type": [
                "string",
                "null"
              ],
              "enum": [
                "none",
                "play",
                "toggle"
              ]
            },
            "rollIn": {
              "type": [
                "string",
                "null"
              ],
              "enum": [
                "none",
                "play",
                "pause"
              ]
            },
            "rollOut": {
              "type": [
                "string",
                "null"
              ],
              "enum": [
                "none",
                "play",
                "pause"
              ]
            },
            "allowReplay": true
          },
          "additionalProperties": false
        },
        "playerAudioInteraction": {
          "type": "object",
          "properties": {
            "rollIn": {
              "type": [
                "string",
                "null"
              ],
              "enum": [
                "none",
                "mute",
                "unmute"
              ]
            },
            "rollOut": {
              "type": [
                "string",
                "null"
              ],
              "enum": [
                "none",
                "mute",
                "unmute"
              ]
            }
          },
          "additionalProperties": false
        },
        "animatePoster": {
          "type": [
            "string",
            "null"
          ],
          "enum": [
            "none",
            "fade"
          ]
        },
        "mute": true,
        "disableAudio": true,
        "loop": true,
        "overrideMask": {
          "oneOf": [
            {
              "type": "null"
            },
            {
              "type": "object",
              "properties": {
                "x": true,
                "y": true,
                "width": true,
                "height": true,
                "svgId": true,
                "flip": {
                  "type": "string",
                  "enum": [
                    "x",
                    "y",
                    "xy",
                    "none"
                  ]
                },
                "rotate": true,
                "mode": {
                  "type": "string",
                  "enum": [
                    "alpha",
                    "luminance"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "enableBackgroundVideo": true,
        "flip": {
          "type": "string",
          "enum": [
            "x",
            "y",
            "xy",
            "horizontal",
            "vertical",
            "both",
            "none"
          ]
        },
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "MediaControlsProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "showStoryboard": {
          "type": "string",
          "enum": [
            "videoAndTime",
            "time",
            "none"
          ]
        },
        "playerId": true,
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "MediaOverlayControlsProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "playerId": true,
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "LanguageSelectorProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "displayMode": {
          "type": "string",
          "enum": [
            "horizontal",
            "dropdown"
          ]
        },
        "iconType": {
          "type": "string",
          "enum": [
            "none",
            "circle",
            "square",
            "rounded"
          ]
        },
        "iconSize": true,
        "hasArrow": true,
        "itemFormat": {
          "type": "string",
          "enum": [
            "shortName",
            "fullName",
            "iconOnly",
            "fullLocalizedName"
          ]
        },
        "alignTabs": {
          "type": "string",
          "enum": [
            "left",
            "center",
            "right"
          ]
        },
        "languagesOrder": {
          "type": "array",
          "items": true
        },
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "MediaBoxProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "allowOverflowContent": true,
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "PopoverProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "position": {
          "type": "string",
          "enum": [
            "top",
            "bottom",
            "left",
            "right"
          ]
        },
        "alignment": {
          "type": "string",
          "enum": [
            "start",
            "center",
            "end"
          ]
        },
        "horizontalOffset": true,
        "verticalOffset": true,
        "closeMethod": {
          "type": "string",
          "enum": [
            "mouseOut",
            "outerClick",
            "manual"
          ]
        },
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "mobui.MobuiPickerProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "required": true,
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "MobuiPickerItemType": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "label": true,
        "value": true,
        "disabled": true,
        "isDefault": true,
        "unavailable": true,
        "subtitle": true,
        "isSelected": true
      },
      "additionalProperties": false
    },
    "mobui.MobuiTextInputProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "hasInitialValue": true,
        "multiline": true,
        "readOnly": true,
        "hasPrefix": true,
        "hasSuffix": true,
        "required": true,
        "autoCorrect": true,
        "hasAutoComplete": true,
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "AccordionContainerProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "defaultOpened": {
          "type": "string",
          "enum": [
            "close_all",
            "open_first",
            "open_all"
          ]
        },
        "multiple": true,
        "animated": true,
        "animationTime": true,
        "icon": {
          "type": "string",
          "enum": [
            "arrow",
            "plus"
          ]
        }
      },
      "additionalProperties": false
    },
    "AccordionItemProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "isParentFullWidth": true
      },
      "additionalProperties": false
    },
    "AddressInputProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "alignment": {
          "type": "string",
          "enum": [
            "left",
            "center",
            "right"
          ]
        },
        "iconVisible": true,
        "dividerVisible": true,
        "label": true,
        "required": true,
        "autoFocus": true,
        "readOnly": true,
        "tabIndex": true,
        "inputHeight": true,
        "inputHeightMobile": true,
        "labelMargin": true,
        "labelPadding": true,
        "labelMobileFontSize": true,
        "inputMobileFontSize": true,
        "isDisabled": true,
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "BoltComponentProperties": {
      "type": "object",
      "anyOf": [
        {
          "properties": {},
          "additionalProperties": false
        }
      ]
    },
    "BreadcrumbsProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "separator": {
          "type": "string",
          "enum": [
            "greater-than",
            "slash"
          ]
        },
        "shouldWrap": true,
        "direction": {
          "type": "string",
          "enum": [
            "rtl",
            "ltr"
          ]
        },
        "alignment": {
          "type": "string",
          "enum": [
            "flex-start",
            "center",
            "flex-end"
          ]
        },
        "showHomePage": true,
        "showHomePageAsIcon": true,
        "showCurrentPage": true,
        "showOnlyPreviousPageOnMobile": true,
        "horizontalMargin": true,
        "verticalMargin": true,
        "isCollapsedByDefault": true,
        "itemsBeforeCollapse": true,
        "itemsAfterCollapse": true,
        "align": {
          "type": "string",
          "enum": [
            "start",
            "center",
            "end"
          ]
        },
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "CaptchaProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "theme": {
          "type": "string",
          "enum": [
            "light",
            "dark"
          ]
        },
        "size": {
          "type": "string",
          "enum": [
            "normal",
            "compact"
          ]
        },
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "CollapsibleTextProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "ellipsis": true,
        "showExpandControl": true,
        "direction": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl"
          ]
        },
        "align": {
          "type": "string",
          "enum": [
            "left",
            "right",
            "center"
          ]
        },
        "alignButton": {
          "type": "string",
          "enum": [
            "left",
            "right",
            "center"
          ]
        },
        "maxLines": true,
        "wrappingStyle": {
          "type": "string",
          "enum": [
            "single-line",
            "multi-line"
          ]
        },
        "expandControlSpacing": true,
        "expandMode": {
          "type": "string",
          "enum": [
            "button",
            "link"
          ]
        },
        "isExpanded": true,
        "lastUserDefinedWidth": true,
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "HamburgerCloseButtonProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "iconCollapsed": true,
        "isMaxContent": true,
        "isWrapText": true,
        "isDisabled": true,
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "HamburgerMenuContainerProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "fullWidth": true
      },
      "additionalProperties": false
    },
    "HamburgerOpenButtonProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "iconCollapsed": true,
        "isMaxContent": true,
        "isWrapText": true,
        "isDisabled": true,
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "LineShareButtonProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "buttonType": {
          "type": "string",
          "enum": [
            "button",
            "classicWithButton",
            "classicBig",
            "classicMedium",
            "classicSmall",
            "bubbleBig",
            "bubbleMedium",
            "bubbleSmall"
          ]
        },
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "MusicPlayerProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "layout": {
          "type": "string",
          "enum": [
            "classic",
            "icon"
          ]
        },
        "source": {
          "type": "string",
          "enum": [
            "uploads",
            "url",
            "wixMusic"
          ]
        },
        "showCover": true,
        "showArtistName": true,
        "showTrackName": true,
        "showProgressBar": true,
        "showTimeStamp": true,
        "autoplay": true,
        "loop": true,
        "showPlaylist": true,
        "playlistTracksInfo": {
          "type": "string",
          "enum": [
            "trackName",
            "trackNameAndArtistName"
          ]
        },
        "playlistTracksAction": {
          "type": "string",
          "enum": [
            "onActive",
            "onAll"
          ]
        },
        "playlistTrackSpacing": true,
        "iconId": true,
        "consentToShareAlbum": true,
        "consentToShareTracks": true,
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "PaginationProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "showFirstLastNavButtons": true,
        "showFirstPage": true,
        "showLastPage": true,
        "showInputModeTotalPages": true,
        "paginationMode": {
          "type": "string",
          "enum": [
            "pages",
            "input",
            "arrows"
          ]
        },
        "navigationType": {
          "type": "string",
          "enum": [
            "arrows",
            "text"
          ]
        },
        "paginationDirection": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl"
          ]
        },
        "alignment": {
          "type": "string",
          "enum": [
            "left",
            "center",
            "spread",
            "right"
          ]
        },
        "showPageNumbersBar": true,
        "isDisabled": true,
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "ProGalleryProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "options": {
          "type": "object",
          "properties": {
            "controllers_optionsMap_behaviourParams_item_video_volume": true,
            "controllers_layoutParams_info_allowTitleAndDescription": true,
            "layoutParams_structure_galleryLayout": true,
            "layoutParams_structure_scrollDirection": true,
            "layoutParams_structure_layoutOrientation": true,
            "behaviourParams_gallery_layoutDirection": true,
            "layoutParams_structure_itemSpacing": true,
            "layoutParams_structure_numberOfGridRows": true,
            "layoutParams_structure_numberOfColumns": true,
            "layoutParams_groups_density": true,
            "layoutParams_targetItemSize_value": true,
            "layoutParams_crop_method": true,
            "layoutParams_crop_ratios": true,
            "layoutParams_structure_responsiveMode": true,
            "layoutParams_thumbnails_alignment": true,
            "layoutParams_thumbnails_size": true,
            "layoutParams_thumbnails_spacing": true,
            "controllers_layoutParams_thumbnails_marginToGallery": true,
            "behaviourParams_gallery_vertical_loadMore_enable": true,
            "behaviourParams_gallery_vertical_loadMore_text": true,
            "behaviourParams_gallery_horizontal_navigationDuration": true,
            "behaviourParams_gallery_horizontal_loop": true,
            "behaviourParams_gallery_horizontal_autoSlide_interval": true,
            "behaviourParams_gallery_horizontal_autoSlide_speed": true,
            "behaviourParams_gallery_horizontal_autoSlide_pauseOnHover": true,
            "behaviourParams_gallery_blockContextMenu": true,
            "layoutParams_navigationArrows_enable": true,
            "layoutParams_navigationArrows_size": true,
            "layoutParams_navigationArrows_position": true,
            "layoutParams_navigationArrows_container_type": true,
            "layoutParams_navigationArrows_mouseCursorContainerMaxWidth": true,
            "layoutParams_navigationArrows_verticalAlignment": true,
            "controllers_behaviourParams_item_overlay_hoverAnimationBehavior": true,
            "behaviourParams_item_content_hoverAnimation": true,
            "behaviourParams_item_content_loader": true,
            "behaviourParams_item_content_placementAnimation": true,
            "behaviourParams_gallery_scrollAnimation": true,
            "behaviourParams_gallery_horizontal_slideAnimation": true,
            "behaviourParams_item_video_enablePlayButton": true,
            "behaviourParams_item_video_playTrigger": true,
            "behaviourParams_item_video_speed": true,
            "behaviourParams_item_video_volume": true,
            "behaviourParams_item_video_loop": true,
            "behaviourParams_item_clickAction": true,
            "behaviourParams_item_content_magnificationValue": true,
            "layoutParams_navigationArrows_padding": true,
            "behaviourParams_gallery_vertical_loadMore_amount": true,
            "behaviourParams_gallery_horizontal_autoSlide_behaviour": true,
            "behaviourParams_gallery_horizontal_slideTransition": true,
            "controllers_layoutParams_external_info_placement": true,
            "controllers_layoutParams_external_info_CustomButtonHorizontalAlignment": true,
            "controllers_layoutParams_internal_info_CustomButtonHorizontalAlignment": true,
            "controllers_layoutParams_internal_info_CustomButtonCustomButtonText": true,
            "controllers_layoutParams_external_info_CustomButtonCustomButtonText": true,
            "controllers_layoutParams_external_info_SocialButtonsHorizontalAlignment": true,
            "controllers_layoutParams_internal_info_SocialButtonsHorizontalAlignment": true,
            "layoutParams_info_placement": true,
            "controllers_layoutParams_info_allowTitle": true,
            "controllers_layoutParams_info_allowDescription": true,
            "controllers_layoutParams_info_verticalPadding": true,
            "controllers_layoutParams_info_horizontalPadding": true,
            "controllers_layoutParams_infoElementOptions_external_enabled": true,
            "controllers_layoutParams_infoElementOptions_internal_enabled": true,
            "controllers_experimental_useNewInfo": true,
            "controllers_layoutParams_infoElementOptions_external_order": true,
            "controllers_layoutParams_infoElementOptions_internal_order": true,
            "controllers_layoutParams_info_verticalAlignment": true,
            "controllers_layoutParams_info_horizontalAlignment": true,
            "controllers_layoutParams_structure_imageWidth_method": true,
            "controllers_layoutParams_structure_numberOfDisplayedItems": true,
            "layoutParams_info_sizeUnits": true,
            "layoutParams_info_height": true,
            "controllers_layoutParams_info_width_pixel": true,
            "controllers_layoutParams_info_width_percent": true,
            "behaviourParams_item_overlay_hoveringBehaviour": true,
            "controllers_behaviourParams_item_overlay_overlayType": true,
            "behaviourParams_item_overlay_sizeUnits": true,
            "controllers_behaviourParams_item_overlay_size_percent": true,
            "controllers_behaviourParams_item_overlay_size_pixel": true,
            "behaviourParams_item_overlay_position": true,
            "behaviourParams_item_overlay_padding": true,
            "behaviourParams_item_secondaryMedia_enableHoverTrigger": true,
            "behaviourParams_item_overlay_hoverAnimation": true,
            "controllers_layoutParams_structure_galleryRatio_method": true,
            "controllers_layoutParams_structure_galleryRatio_value": true,
            "controllers_fullscreen_allowTitleExpand": true,
            "controllers_behaviourParams_item_overlay_enabled": true,
            "controllers_layoutParams_info_newInfo_external_enabled": true,
            "controllers_fullscreen_allowDescriptionExpand": true,
            "controllers_fullscreen_allowLinkExpand": true,
            "controllers_fullscreen_expandInfoPosition": true,
            "controllers_fullscreen_showInfoExpandButton": true,
            "controllers_fullscreen_whenToShowInfo": true,
            "controllers_fullscreen_allowFullscreenExpand": true,
            "controllers_fullscreen_fullscreenLoop": true,
            "controllers_fullscreen_allowFullscreenMagnifyImage": true,
            "controllers_fullscreen_fullscreenMagnificationLevel": true,
            "controllers_fullscreen_fullscreenMagnificationPercent": true,
            "controllers_fullscreen_backgroundBlurFilter": true,
            "controllers_fullscreen_backgroundGrayscaleFilter": true,
            "controllers_showManageMedia": true,
            "variant_count": true
          },
          "additionalProperties": false
        },
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "ProgressBarProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "direction": {
          "type": "string",
          "enum": [
            "rtl",
            "ltr"
          ]
        },
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "RangeSliderProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "align": {
          "type": "string",
          "enum": [
            "start",
            "center",
            "end"
          ]
        },
        "isDisabled": true,
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "RatingsDisplayProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "showReviewsCount": true,
        "showRating": true,
        "noReviewsMode": {
          "type": "string",
          "enum": [
            "nothing",
            "emptyIcons",
            "placeholderText"
          ]
        },
        "ratingPosition": {
          "type": "string",
          "enum": [
            "before",
            "after"
          ]
        },
        "shapeSize": true,
        "shapeSpacing": true,
        "alignment": {
          "type": "string",
          "enum": [
            "left",
            "right",
            "center"
          ]
        },
        "direction": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl"
          ]
        },
        "renderSeo": true,
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "RatingsInputProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "showTitle": true,
        "showLabels": true,
        "labelPosition": {
          "type": "string",
          "enum": [
            "top",
            "bottom",
            "side"
          ]
        },
        "a11yLabelPosition": {
          "type": "string",
          "enum": [
            "top",
            "bottom",
            "side"
          ]
        },
        "labelAlignment": {
          "type": "string",
          "enum": [
            "left",
            "center",
            "right"
          ]
        },
        "a11yLabelAlignment": {
          "type": "string",
          "enum": [
            "left",
            "center",
            "right"
          ]
        },
        "shapeSize": true,
        "shapeSpacing": true,
        "direction": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl"
          ]
        },
        "label": true,
        "required": true,
        "autoFocus": true,
        "readOnly": true,
        "tabIndex": true,
        "inputHeight": true,
        "inputHeightMobile": true,
        "labelMargin": true,
        "labelPadding": true,
        "labelMobileFontSize": true,
        "inputMobileFontSize": true,
        "isDisabled": true,
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "RichTextBoxProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "textAlignment": {
          "type": "string",
          "enum": [
            "left",
            "right",
            "center"
          ]
        },
        "textPadding": true,
        "toolbarPosition": {
          "type": "string",
          "enum": [
            "top",
            "bottom",
            "inline"
          ]
        },
        "placeholder": true,
        "defaultTextType": {
          "type": "string",
          "enum": [
            "none",
            "initialText",
            "placeholderText",
            "placeholderAndInitialText"
          ]
        },
        "allowLinks": true,
        "label": true,
        "required": true,
        "autoFocus": true,
        "readOnly": true,
        "tabIndex": true,
        "inputHeight": true,
        "inputHeightMobile": true,
        "labelMargin": true,
        "labelPadding": true,
        "labelMobileFontSize": true,
        "inputMobileFontSize": true,
        "isDisabled": true,
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "SearchBoxProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "layout": {
          "type": "string",
          "enum": [
            "icon",
            "button",
            "icon-only",
            "expandable"
          ]
        },
        "iconAlignment": {
          "type": "string",
          "enum": [
            "left",
            "right"
          ]
        },
        "textAlignment": {
          "type": "string",
          "enum": [
            "left",
            "center"
          ]
        },
        "textSpacing": true,
        "iconSpacing": true,
        "trendingItemsEnabled": true,
        "isExpandable": true,
        "expandedDirection": {
          "type": "string",
          "enum": [
            "left",
            "right"
          ]
        },
        "expandedWidth": true,
        "label": true,
        "required": true,
        "autoFocus": true,
        "readOnly": true,
        "tabIndex": true,
        "inputHeight": true,
        "inputHeightMobile": true,
        "labelMargin": true,
        "labelPadding": true,
        "labelMobileFontSize": true,
        "inputMobileFontSize": true,
        "isDisabled": true,
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "SearchButtonProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "iconCollapsed": true,
        "isMaxContent": true,
        "isWrapText": true,
        "isDisabled": true,
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "SelectionTagsListProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "direction": {
          "type": "string",
          "enum": [
            "rtl",
            "ltr"
          ]
        },
        "alignment": {
          "type": "string",
          "enum": [
            "left",
            "center",
            "right"
          ]
        },
        "hasAutoHeight": true,
        "label": true,
        "required": true,
        "autoFocus": true,
        "readOnly": true,
        "tabIndex": true,
        "inputHeight": true,
        "inputHeightMobile": true,
        "labelMargin": true,
        "labelPadding": true,
        "labelMobileFontSize": true,
        "inputMobileFontSize": true,
        "isDisabled": true,
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "SignatureInputProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "direction": {
          "type": "string",
          "enum": [
            "rtl",
            "ltr"
          ]
        },
        "required": true,
        "titlePaddingStart": true,
        "titleMarginBottom": true,
        "labelMobileFontSize": true,
        "inputMobileFontSize": true,
        "isDisabled": true,
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "SingleTabProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "isParentFullWidth": true
      },
      "additionalProperties": false
    },
    "SliderProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "trackSize": true,
        "orientation": {
          "type": "string",
          "enum": [
            "horizontal",
            "vertical"
          ]
        },
        "thumbShape": {
          "type": "string",
          "enum": [
            "circle",
            "square",
            "rectangle",
            "bar"
          ]
        },
        "thumbSize": true,
        "tickMarksShape": {
          "type": "string",
          "enum": [
            "none",
            "line",
            "dot"
          ]
        },
        "tooltipVisibility": {
          "type": "string",
          "enum": [
            "none",
            "hover",
            "always"
          ]
        },
        "tooltipPosition": {
          "type": "string",
          "enum": [
            "normal",
            "across"
          ]
        },
        "tooltipPrefix": true,
        "tooltipSuffix": true,
        "tickMarksPosition": {
          "type": "string",
          "enum": [
            "normal",
            "middle",
            "across"
          ]
        },
        "dir": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl"
          ]
        },
        "label": true,
        "required": true,
        "autoFocus": true,
        "readOnly": true,
        "tabIndex": true,
        "inputHeight": true,
        "inputHeightMobile": true,
        "labelMargin": true,
        "labelPadding": true,
        "labelMobileFontSize": true,
        "inputMobileFontSize": true,
        "isDisabled": true,
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "SlideshowProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "isHidden": true,
        "isCollapsed": true,
        "isPlaying": true,
        "slideDuration": true,
        "pauseOnHover": true,
        "showPlaybackControl": true,
        "loop": true,
        "previewItemId": true
      },
      "additionalProperties": false
    },
    "SlideshowButtonProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "action": {
          "type": "string",
          "enum": [
            "prev",
            "next"
          ]
        },
        "iconCollapsed": true,
        "isMaxContent": true,
        "isWrapText": true,
        "isDisabled": true,
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "SocialAuthProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "isSmallIcons": true,
        "isSocialLoginGoogleEnabled": true,
        "isSocialLoginFacebookEnabled": true,
        "mode": {
          "type": [
            "string",
            "null"
          ],
          "enum": [
            "signup",
            "login"
          ]
        },
        "formType": {
          "type": [
            "string",
            "null"
          ],
          "enum": [
            "default",
            "custom",
            "corvid"
          ]
        },
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "StylableButtonProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "iconCollapsed": true,
        "isMaxContent": true,
        "isWrapText": true,
        "isDisabled": true,
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "StylableHorizontalMenuProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "menuMode": {
          "type": "string",
          "enum": [
            "wrap",
            "scroll"
          ]
        },
        "submenuMode": {
          "type": "string",
          "enum": [
            "columnMenu",
            "columnStretched",
            "flyout"
          ]
        },
        "slotMap": true,
        "isContainerStretched": true,
        "submenuOrder": {
          "type": "string",
          "enum": [
            "vertical",
            "horizontal"
          ]
        },
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "TabsProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "itemSpacing": true,
        "itemRowSpacing": true,
        "containerSpacing": true,
        "tabWidth": true,
        "stretchTabsToMenuWidth": true,
        "fitTabsToTextWidth": true,
        "itemsOrientation": {
          "type": "string",
          "enum": [
            "horizontal",
            "vertical"
          ]
        },
        "itemsAlignment": {
          "type": "string",
          "enum": [
            "left",
            "center",
            "right"
          ]
        },
        "contentAlignment": {
          "type": "string",
          "enum": [
            "left",
            "center",
            "right"
          ]
        },
        "itemsLogicalAlign": {
          "type": "string",
          "enum": [
            "start",
            "center",
            "end"
          ]
        },
        "contentLogicalAlign": {
          "type": "string",
          "enum": [
            "start",
            "center",
            "end"
          ]
        },
        "horizontalTabPadding": true,
        "verticalTabPadding": true,
        "menuMode": {
          "type": "string",
          "enum": [
            "wrap",
            "scroll"
          ]
        },
        "itemsDirection": {
          "type": "string",
          "enum": [
            "rtl",
            "ltr"
          ]
        },
        "tabEnterAnimationName": {
          "type": "string",
          "enum": [
            "none",
            "fadeIn",
            "floatFromTop",
            "floatFromBottom"
          ]
        },
        "tabExitAnimationName": {
          "type": "string",
          "enum": [
            "none",
            "fadeOut"
          ]
        },
        "animationDuration": true,
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "TimePickerProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "alignment": {
          "type": "string",
          "enum": [
            "left",
            "center",
            "right"
          ]
        },
        "useAmPmFormat": true,
        "controller": {
          "type": "string",
          "enum": [
            "text",
            "stepper",
            "dropdown"
          ]
        },
        "initialTime": {
          "type": "string",
          "enum": [
            "none",
            "current",
            "value",
            "placeholder"
          ]
        },
        "margin": true,
        "disabledTimes": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "startTime": true,
              "endTime": true
            },
            "additionalProperties": false
          }
        },
        "enabledTimes": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "startTime": true,
              "endTime": true
            },
            "additionalProperties": false
          }
        },
        "label": true,
        "required": true,
        "autoFocus": true,
        "readOnly": true,
        "tabIndex": true,
        "inputHeight": true,
        "inputHeightMobile": true,
        "labelMargin": true,
        "labelPadding": true,
        "labelMobileFontSize": true,
        "inputMobileFontSize": true,
        "isDisabled": true,
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "ToggleSwitchProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "displayKnobIcons": true,
        "trackHeight": true,
        "knobSize": true,
        "alignment": {
          "type": "string",
          "enum": [
            "left",
            "right"
          ]
        },
        "switchHeight": true,
        "label": true,
        "required": true,
        "autoFocus": true,
        "readOnly": true,
        "tabIndex": true,
        "inputHeight": true,
        "inputHeightMobile": true,
        "labelMargin": true,
        "labelPadding": true,
        "labelMobileFontSize": true,
        "inputMobileFontSize": true,
        "isDisabled": true,
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    },
    "VideoPlayerProperties": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "showVideoTitle": true,
        "autoplay": true,
        "loop": true,
        "share": true,
        "controlsVisibility": {
          "type": "string",
          "enum": [
            "hover",
            "never"
          ]
        },
        "animatePoster": {
          "type": "string",
          "enum": [
            "fade",
            "none"
          ]
        },
        "isHidden": true,
        "isCollapsed": true,
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ]
        },
        "fontScale": true,
        "deleted": true
      },
      "additionalProperties": false
    }
  },
  "connections_data.json": {
    "$id": "urn:dm:schemas:connections_data.json",
    "ConnectionList": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "items": {
          "type": "array",
          "items": {
            "type": "object",
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "controllerId": true,
                  "isPrimary": true,
                  "config": true,
                  "subRole": true,
                  "role": true,
                  "type": {
                    "type": "string",
                    "enum": [
                      "ConnectionItem"
                    ]
                  }
                },
                "additionalProperties": false
              },
              {
                "type": "object",
                "properties": {
                  "role": true,
                  "type": {
                    "type": "string",
                    "enum": [
                      "WixCodeConnectionItem"
                    ]
                  }
                },
                "additionalProperties": false
              }
            ]
          }
        }
      },
      "additionalProperties": false
    },
    "ConnectionItem": {
      "type": "object",
      "properties": {
        "controllerId": true,
        "isPrimary": true,
        "config": true,
        "subRole": true,
        "role": true,
        "type": {
          "type": "string",
          "enum": [
            "ConnectionItem"
          ]
        }
      },
      "additionalProperties": false
    },
    "WixCodeConnectionItem": {
      "type": "object",
      "properties": {
        "role": true,
        "type": {
          "type": "string",
          "enum": [
            "WixCodeConnectionItem"
          ]
        }
      },
      "additionalProperties": false
    }
  },
  "contentRole.json": {
    "$id": "urn:dm:schemas:contentRole.json",
    "ContainerRole": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "contentRole": true,
        "fieldRole": true,
        "listRole": true,
        "complexity": true,
        "allowedFlows": {
          "type": "array",
          "items": true
        }
      },
      "additionalProperties": false
    },
    "Field": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "fieldRole": true,
        "listItemId": true,
        "allowedFlows": {
          "type": "array",
          "items": true
        }
      },
      "additionalProperties": false
    }
  },
  "controllers.json": {
    "$id": "urn:dm:schemas:controllers.json",
    "ControllerList": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "controllers": {
          "type": [
            "array"
          ],
          "items": true
        }
      },
      "additionalProperties": false
    }
  },
  "css-value-definitions.schema.json": {
    "$id": "urn:dm:schemas:css-value-definitions.schema.json",
    "title": true,
    "description": true,
    "definitions": true
  },
  "cssPropertySchemas.json": {
    "$id": "urn:dm:schemas:cssPropertySchemas.json",
    "title": true,
    "description": true,
    "definitions": true
  },
  "cursor.json": {
    "$id": "urn:dm:schemas:cursor.json",
    "Cursor": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "media": true,
        "offsetX": true,
        "offsetY": true,
        "width": true,
        "height": true
      },
      "additionalProperties": false
    },
    "Image": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "link": {
          "type": [
            "null",
            "string"
          ],
          "pattern": "^$|^#"
        },
        "title": true,
        "name": true,
        "uri": {
          "type": "string",
          "pattern": "^[\\w:~\\-_+%.\\/,\\?=\\()]+$"
        },
        "description": true,
        "height": true,
        "width": true,
        "borderSize": true,
        "alt": true,
        "decorative": true,
        "hasAnimation": true,
        "originalImageDataRef": true,
        "opacity": true,
        "crop": {
          "oneOf": [
            {
              "type": "null"
            },
            {
              "type": "object",
              "properties": {
                "x": true,
                "y": true,
                "width": true,
                "height": true,
                "svgId": true,
                "flip": {
                  "type": "string",
                  "enum": [
                    "x",
                    "y",
                    "xy",
                    "none"
                  ]
                },
                "rotate": true
              },
              "additionalProperties": false
            }
          ]
        },
        "upscaleMethod": true,
        "focalPoint": {
          "oneOf": [
            {
              "type": "null"
            },
            {
              "type": "object",
              "properties": {
                "x": true,
                "y": true
              },
              "additionalProperties": false
            }
          ]
        },
        "artist": {
          "type": "object",
          "properties": {
            "name": true,
            "id": true
          },
          "additionalProperties": false
        }
      },
      "additionalProperties": false
    },
    "SVGItem": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "svgId": true
      },
      "additionalProperties": false
    },
    "RefArray": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "values": {
          "type": [
            "array"
          ],
          "items": true
        }
      },
      "additionalProperties": false
    },
    "VariantRelation": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "variants": {
          "type": "array",
          "items": true
        },
        "remoteVariants": {
          "type": "array",
          "items": true
        },
        "from": true,
        "to": true
      },
      "additionalProperties": false
    }
  },
  "design_data.json": {
    "$id": "urn:dm:schemas:design_data.json",
    "MediaContainerDesignData": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "charas": true,
        "background": true,
        "dataChangeBehaviors": {
          "type": [
            "array",
            "null"
          ],
          "items": {
            "type": "object",
            "properties": {
              "trigger": true,
              "type": true,
              "part": true,
              "name": true,
              "params": true
            },
            "additionalProperties": false
          }
        },
        "cssStyle": {
          "type": "object",
          "properties": {
            "cssBorder": {
              "oneOf": [
                {
                  "type": "null"
                },
                {
                  "type": "object",
                  "properties": {
                    "width": {
                      "type": "object",
                      "properties": {
                        "top": {
                          "oneOf": [
                            {
                              "type": "object",
                              "properties": {
                                "unit": {
                                  "oneOf": [
                                    {
                                      "enum": [
                                        "px",
                                        "cm",
                                        "mm",
                                        "q",
                                        "in",
                                        "pt",
                                        "pc"
                                      ]
                                    },
                                    {
                                      "enum": [
                                        "em",
                                        "ex",
                                        "ch",
                                        "rem",
                                        "vw",
                                        "vh",
                                        "vmin",
                                        "vmax"
                                      ]
                                    }
                                  ]
                                },
                                "value": true
                              },
                              "additionalProperties": false
                            }
                          ]
                        },
                        "right": {
                          "oneOf": [
                            {
                              "type": "object",
                              "properties": {
                                "unit": {
                                  "oneOf": [
                                    {
                                      "enum": [
                                        "px",
                                        "cm",
                                        "mm",
                                        "q",
                                        "in",
                                        "pt",
                                        "pc"
                                      ]
                                    },
                                    {
                                      "enum": [
                                        "em",
                                        "ex",
                                        "ch",
                                        "rem",
                                        "vw",
                                        "vh",
                                        "vmin",
                                        "vmax"
                                      ]
                                    }
                                  ]
                                },
                                "value": true
                              },
                              "additionalProperties": false
                            }
                          ]
                        },
                        "bottom": {
                          "oneOf": [
                            {
                              "type": "object",
                              "properties": {
                                "unit": {
                                  "oneOf": [
                                    {
                                      "enum": [
                                        "px",
                                        "cm",
                                        "mm",
                                        "q",
                                        "in",
                                        "pt",
                                        "pc"
                                      ]
                                    },
                                    {
                                      "enum": [
                                        "em",
                                        "ex",
                                        "ch",
                                        "rem",
                                        "vw",
                                        "vh",
                                        "vmin",
                                        "vmax"
                                      ]
                                    }
                                  ]
                                },
                                "value": true
                              },
                              "additionalProperties": false
                            }
                          ]
                        },
                        "left": {
                          "oneOf": [
                            {
                              "type": "object",
                              "properties": {
                                "unit": {
                                  "oneOf": [
                                    {
                                      "enum": [
                                        "px",
                                        "cm",
                                        "mm",
                                        "q",
                                        "in",
                                        "pt",
                                        "pc"
                                      ]
                                    },
                                    {
                                      "enum": [
                                        "em",
                                        "ex",
                                        "ch",
                                        "rem",
                                        "vw",
                                        "vh",
                                        "vmin",
                                        "vmax"
                                      ]
                                    }
                                  ]
                                },
                                "value": true
                              },
                              "additionalProperties": false
                            }
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    "style": {
                      "type": "object",
                      "properties": {
                        "top": {
                          "enum": [
                            "none",
                            "hidden",
                            "dotted",
                            "dashed",
                            "solid",
                            "double",
                            "groove",
                            "ridge",
                            "inset",
                            "outset"
                          ]
                        },
                        "right": {
                          "enum": [
                            "none",
                            "hidden",
                            "dotted",
                            "dashed",
                            "solid",
                            "double",
                            "groove",
                            "ridge",
                            "inset",
                            "outset"
                          ]
                        },
                        "bottom": {
                          "enum": [
                            "none",
                            "hidden",
                            "dotted",
                            "dashed",
                            "solid",
                            "double",
                            "groove",
                            "ridge",
                            "inset",
                            "outset"
                          ]
                        },
                        "left": {
                          "enum": [
                            "none",
                            "hidden",
                            "dotted",
                            "dashed",
                            "solid",
                            "double",
                            "groove",
                            "ridge",
                            "inset",
                            "outset"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    "color": {
                      "type": "object",
                      "properties": {
                        "top": {
                          "type": "object",
                          "properties": {
                            "red": true,
                            "green": true,
                            "blue": true,
                            "alpha": true
                          },
                          "additionalProperties": false
                        },
                        "right": {
                          "type": "object",
                          "properties": {
                            "red": true,
                            "green": true,
                            "blue": true,
                            "alpha": true
                          },
                          "additionalProperties": false
                        },
                        "bottom": {
                          "type": "object",
                          "properties": {
                            "red": true,
                            "green": true,
                            "blue": true,
                            "alpha": true
                          },
                          "additionalProperties": false
                        },
                        "left": {
                          "type": "object",
                          "properties": {
                            "red": true,
                            "green": true,
                            "blue": true,
                            "alpha": true
                          },
                          "additionalProperties": false
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "cssBoxShadow": true,
            "cssBorderRadius": {
              "oneOf": [
                {
                  "type": "null"
                },
                {
                  "type": "object",
                  "properties": {
                    "topLeft": {
                      "oneOf": [
                        {
                          "type": "object",
                          "properties": {
                            "unit": {
                              "oneOf": [
                                {
                                  "enum": [
                                    "px",
                                    "cm",
                                    "mm",
                                    "q",
                                    "in",
                                    "pt",
                                    "pc"
                                  ]
                                },
                                {
                                  "enum": [
                                    "em",
                                    "ex",
                                    "ch",
                                    "rem",
                                    "vw",
                                    "vh",
                                    "vmin",
                                    "vmax"
                                  ]
                                }
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "unit": {
                              "enum": [
                                "%"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "topRight": {
                      "oneOf": [
                        {
                          "type": "object",
                          "properties": {
                            "unit": {
                              "oneOf": [
                                {
                                  "enum": [
                                    "px",
                                    "cm",
                                    "mm",
                                    "q",
                                    "in",
                                    "pt",
                                    "pc"
                                  ]
                                },
                                {
                                  "enum": [
                                    "em",
                                    "ex",
                                    "ch",
                                    "rem",
                                    "vw",
                                    "vh",
                                    "vmin",
                                    "vmax"
                                  ]
                                }
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "unit": {
                              "enum": [
                                "%"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "bottomLeft": {
                      "oneOf": [
                        {
                          "type": "object",
                          "properties": {
                            "unit": {
                              "oneOf": [
                                {
                                  "enum": [
                                    "px",
                                    "cm",
                                    "mm",
                                    "q",
                                    "in",
                                    "pt",
                                    "pc"
                                  ]
                                },
                                {
                                  "enum": [
                                    "em",
                                    "ex",
                                    "ch",
                                    "rem",
                                    "vw",
                                    "vh",
                                    "vmin",
                                    "vmax"
                                  ]
                                }
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "unit": {
                              "enum": [
                                "%"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "bottomRight": {
                      "oneOf": [
                        {
                          "type": "object",
                          "properties": {
                            "unit": {
                              "oneOf": [
                                {
                                  "enum": [
                                    "px",
                                    "cm",
                                    "mm",
                                    "q",
                                    "in",
                                    "pt",
                                    "pc"
                                  ]
                                },
                                {
                                  "enum": [
                                    "em",
                                    "ex",
                                    "ch",
                                    "rem",
                                    "vw",
                                    "vh",
                                    "vmin",
                                    "vmax"
                                  ]
                                }
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "unit": {
                              "enum": [
                                "%"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            }
          },
          "additionalProperties": false
        },
        "themeMappings": true,
        "mediaRef": true,
        "posterImageRef": true,
        "imageOverlay": true
      },
      "additionalProperties": false
    },
    "MediaContainerWithDividers": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "background": true,
        "dividerTop": true,
        "dividerBottom": true
      },
      "additionalProperties": false
    },
    "ShapeDivider": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "svgId": true,
        "color": {
          "type": "string",
          "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
        },
        "opacity": true,
        "padding": {
          "type": "object",
          "properties": {
            "value": true,
            "type": {
              "enum": [
                "px",
                "em",
                "rem",
                "percentage",
                "vh",
                "vw",
                "vmin",
                "vmax"
              ]
            }
          },
          "additionalProperties": false
        },
        "height": {
          "type": "object",
          "properties": {
            "value": true,
            "type": {
              "enum": [
                "px",
                "em",
                "rem",
                "percentage",
                "vh",
                "vw",
                "vmin",
                "vmax"
              ]
            }
          },
          "additionalProperties": false
        },
        "offsetX": {
          "type": "object",
          "properties": {
            "value": true,
            "type": {
              "enum": [
                "px",
                "em",
                "rem",
                "percentage",
                "vh",
                "vw",
                "vmin",
                "vmax"
              ]
            }
          },
          "additionalProperties": false
        },
        "flip": true,
        "invert": true,
        "keepAspectRatio": true,
        "shouldRepeat": true,
        "repeatCount": true,
        "layersEffect": {
          "oneOf": [
            {
              "type": "null"
            },
            {
              "type": "object",
              "properties": {
                "size": true,
                "y": {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "percentage",
                        "vh",
                        "vw",
                        "vmin",
                        "vmax"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "x": {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "percentage",
                        "vh",
                        "vw",
                        "vmin",
                        "vmax"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "pin": {
                  "type": "string",
                  "enum": [
                    "in",
                    "out"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "presetId": true
      },
      "additionalProperties": false
    },
    "MediaPlayerDesignData": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "charas": true,
        "background": true,
        "cssStyle": {
          "type": "object",
          "properties": {
            "cssBorder": {
              "oneOf": [
                {
                  "type": "null"
                },
                {
                  "type": "object",
                  "properties": {
                    "width": {
                      "type": "object",
                      "properties": {
                        "top": {
                          "oneOf": [
                            {
                              "type": "object",
                              "properties": {
                                "unit": {
                                  "oneOf": [
                                    {
                                      "enum": [
                                        "px",
                                        "cm",
                                        "mm",
                                        "q",
                                        "in",
                                        "pt",
                                        "pc"
                                      ]
                                    },
                                    {
                                      "enum": [
                                        "em",
                                        "ex",
                                        "ch",
                                        "rem",
                                        "vw",
                                        "vh",
                                        "vmin",
                                        "vmax"
                                      ]
                                    }
                                  ]
                                },
                                "value": true
                              },
                              "additionalProperties": false
                            }
                          ]
                        },
                        "right": {
                          "oneOf": [
                            {
                              "type": "object",
                              "properties": {
                                "unit": {
                                  "oneOf": [
                                    {
                                      "enum": [
                                        "px",
                                        "cm",
                                        "mm",
                                        "q",
                                        "in",
                                        "pt",
                                        "pc"
                                      ]
                                    },
                                    {
                                      "enum": [
                                        "em",
                                        "ex",
                                        "ch",
                                        "rem",
                                        "vw",
                                        "vh",
                                        "vmin",
                                        "vmax"
                                      ]
                                    }
                                  ]
                                },
                                "value": true
                              },
                              "additionalProperties": false
                            }
                          ]
                        },
                        "bottom": {
                          "oneOf": [
                            {
                              "type": "object",
                              "properties": {
                                "unit": {
                                  "oneOf": [
                                    {
                                      "enum": [
                                        "px",
                                        "cm",
                                        "mm",
                                        "q",
                                        "in",
                                        "pt",
                                        "pc"
                                      ]
                                    },
                                    {
                                      "enum": [
                                        "em",
                                        "ex",
                                        "ch",
                                        "rem",
                                        "vw",
                                        "vh",
                                        "vmin",
                                        "vmax"
                                      ]
                                    }
                                  ]
                                },
                                "value": true
                              },
                              "additionalProperties": false
                            }
                          ]
                        },
                        "left": {
                          "oneOf": [
                            {
                              "type": "object",
                              "properties": {
                                "unit": {
                                  "oneOf": [
                                    {
                                      "enum": [
                                        "px",
                                        "cm",
                                        "mm",
                                        "q",
                                        "in",
                                        "pt",
                                        "pc"
                                      ]
                                    },
                                    {
                                      "enum": [
                                        "em",
                                        "ex",
                                        "ch",
                                        "rem",
                                        "vw",
                                        "vh",
                                        "vmin",
                                        "vmax"
                                      ]
                                    }
                                  ]
                                },
                                "value": true
                              },
                              "additionalProperties": false
                            }
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    "style": {
                      "type": "object",
                      "properties": {
                        "top": {
                          "enum": [
                            "none",
                            "hidden",
                            "dotted",
                            "dashed",
                            "solid",
                            "double",
                            "groove",
                            "ridge",
                            "inset",
                            "outset"
                          ]
                        },
                        "right": {
                          "enum": [
                            "none",
                            "hidden",
                            "dotted",
                            "dashed",
                            "solid",
                            "double",
                            "groove",
                            "ridge",
                            "inset",
                            "outset"
                          ]
                        },
                        "bottom": {
                          "enum": [
                            "none",
                            "hidden",
                            "dotted",
                            "dashed",
                            "solid",
                            "double",
                            "groove",
                            "ridge",
                            "inset",
                            "outset"
                          ]
                        },
                        "left": {
                          "enum": [
                            "none",
                            "hidden",
                            "dotted",
                            "dashed",
                            "solid",
                            "double",
                            "groove",
                            "ridge",
                            "inset",
                            "outset"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    "color": {
                      "type": "object",
                      "properties": {
                        "top": {
                          "type": "object",
                          "properties": {
                            "red": true,
                            "green": true,
                            "blue": true,
                            "alpha": true
                          },
                          "additionalProperties": false
                        },
                        "right": {
                          "type": "object",
                          "properties": {
                            "red": true,
                            "green": true,
                            "blue": true,
                            "alpha": true
                          },
                          "additionalProperties": false
                        },
                        "bottom": {
                          "type": "object",
                          "properties": {
                            "red": true,
                            "green": true,
                            "blue": true,
                            "alpha": true
                          },
                          "additionalProperties": false
                        },
                        "left": {
                          "type": "object",
                          "properties": {
                            "red": true,
                            "green": true,
                            "blue": true,
                            "alpha": true
                          },
                          "additionalProperties": false
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "cssBoxShadow": true,
            "cssBorderRadius": {
              "oneOf": [
                {
                  "type": "null"
                },
                {
                  "type": "object",
                  "properties": {
                    "topLeft": {
                      "oneOf": [
                        {
                          "type": "object",
                          "properties": {
                            "unit": {
                              "oneOf": [
                                {
                                  "enum": [
                                    "px",
                                    "cm",
                                    "mm",
                                    "q",
                                    "in",
                                    "pt",
                                    "pc"
                                  ]
                                },
                                {
                                  "enum": [
                                    "em",
                                    "ex",
                                    "ch",
                                    "rem",
                                    "vw",
                                    "vh",
                                    "vmin",
                                    "vmax"
                                  ]
                                }
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "unit": {
                              "enum": [
                                "%"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "topRight": {
                      "oneOf": [
                        {
                          "type": "object",
                          "properties": {
                            "unit": {
                              "oneOf": [
                                {
                                  "enum": [
                                    "px",
                                    "cm",
                                    "mm",
                                    "q",
                                    "in",
                                    "pt",
                                    "pc"
                                  ]
                                },
                                {
                                  "enum": [
                                    "em",
                                    "ex",
                                    "ch",
                                    "rem",
                                    "vw",
                                    "vh",
                                    "vmin",
                                    "vmax"
                                  ]
                                }
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "unit": {
                              "enum": [
                                "%"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "bottomLeft": {
                      "oneOf": [
                        {
                          "type": "object",
                          "properties": {
                            "unit": {
                              "oneOf": [
                                {
                                  "enum": [
                                    "px",
                                    "cm",
                                    "mm",
                                    "q",
                                    "in",
                                    "pt",
                                    "pc"
                                  ]
                                },
                                {
                                  "enum": [
                                    "em",
                                    "ex",
                                    "ch",
                                    "rem",
                                    "vw",
                                    "vh",
                                    "vmin",
                                    "vmax"
                                  ]
                                }
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "unit": {
                              "enum": [
                                "%"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "bottomRight": {
                      "oneOf": [
                        {
                          "type": "object",
                          "properties": {
                            "unit": {
                              "oneOf": [
                                {
                                  "enum": [
                                    "px",
                                    "cm",
                                    "mm",
                                    "q",
                                    "in",
                                    "pt",
                                    "pc"
                                  ]
                                },
                                {
                                  "enum": [
                                    "em",
                                    "ex",
                                    "ch",
                                    "rem",
                                    "vw",
                                    "vh",
                                    "vmin",
                                    "vmax"
                                  ]
                                }
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "unit": {
                              "enum": [
                                "%"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            }
          },
          "additionalProperties": false
        },
        "themeMappings": true,
        "posterImageRef": true,
        "mediaRef": true,
        "imageOverlay": true
      },
      "additionalProperties": false
    },
    "TextFxDesign": {
      "type": "object",
      "properties": {
        "autoScale": true,
        "align": {
          "enum": [
            "start",
            "middle",
            "end"
          ]
        },
        "family": true,
        "size": true,
        "weight": {
          "enum": [
            "normal",
            "bold",
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
          ]
        },
        "style": {
          "enum": [
            "normal",
            "italic"
          ]
        },
        "decoration": {
          "enum": [
            "none",
            "underline",
            "line-through"
          ]
        },
        "transform": {
          "enum": [
            "none",
            "capitalize",
            "uppercase",
            "lowercase"
          ]
        },
        "letterSpacing": {
          "type": "object",
          "properties": {
            "value": true,
            "type": {
              "enum": [
                "px",
                "em",
                "rem",
                "percentage",
                "vh",
                "vw",
                "vmin",
                "vmax"
              ]
            }
          },
          "additionalProperties": false
        },
        "lineHeight": true,
        "outlineColor": {
          "type": "string",
          "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
        },
        "outlineOpacity": true,
        "outlineWidth": true,
        "shadow": {
          "oneOf": [
            {
              "type": "null"
            },
            {
              "type": "object",
              "properties": {
                "x": true,
                "y": true,
                "spreadRadius": true,
                "blurRadius": true,
                "opacity": true,
                "color": true
              },
              "additionalProperties": false
            }
          ]
        }
      },
      "additionalProperties": false
    },
    "TextFxMask": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "autoScale": true,
        "align": {
          "enum": [
            "start",
            "middle",
            "end"
          ]
        },
        "family": true,
        "size": true,
        "weight": {
          "enum": [
            "normal",
            "bold",
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
          ]
        },
        "style": {
          "enum": [
            "normal",
            "italic"
          ]
        },
        "decoration": {
          "enum": [
            "none",
            "underline",
            "line-through"
          ]
        },
        "transform": {
          "enum": [
            "none",
            "capitalize",
            "uppercase",
            "lowercase"
          ]
        },
        "letterSpacing": {
          "type": "object",
          "properties": {
            "value": true,
            "type": {
              "enum": [
                "px",
                "em",
                "rem",
                "percentage",
                "vh",
                "vw",
                "vmin",
                "vmax"
              ]
            }
          },
          "additionalProperties": false
        },
        "lineHeight": true,
        "outlineColor": {
          "type": "string",
          "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
        },
        "outlineOpacity": true,
        "outlineWidth": true,
        "shadow": {
          "oneOf": [
            {
              "type": "null"
            },
            {
              "type": "object",
              "properties": {
                "x": true,
                "y": true,
                "spreadRadius": true,
                "blurRadius": true,
                "opacity": true,
                "color": true
              },
              "additionalProperties": false
            }
          ]
        },
        "media": true,
        "mediaRotate": true,
        "mediaFlip": {
          "enum": [
            "none",
            "horizontal",
            "vertical",
            "both"
          ]
        },
        "viewBox": true
      },
      "additionalProperties": false
    },
    "TextFxPath": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "autoScale": true,
        "align": {
          "enum": [
            "start",
            "middle",
            "end"
          ]
        },
        "family": true,
        "size": true,
        "weight": {
          "enum": [
            "normal",
            "bold",
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
          ]
        },
        "style": {
          "enum": [
            "normal",
            "italic"
          ]
        },
        "decoration": {
          "enum": [
            "none",
            "underline",
            "line-through"
          ]
        },
        "transform": {
          "enum": [
            "none",
            "capitalize",
            "uppercase",
            "lowercase"
          ]
        },
        "letterSpacing": {
          "type": "object",
          "properties": {
            "value": true,
            "type": {
              "enum": [
                "px",
                "em",
                "rem",
                "percentage",
                "vh",
                "vw",
                "vmin",
                "vmax"
              ]
            }
          },
          "additionalProperties": false
        },
        "lineHeight": true,
        "outlineColor": {
          "type": "string",
          "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
        },
        "outlineOpacity": true,
        "outlineWidth": true,
        "shadow": {
          "oneOf": [
            {
              "type": "null"
            },
            {
              "type": "object",
              "properties": {
                "x": true,
                "y": true,
                "spreadRadius": true,
                "blurRadius": true,
                "opacity": true,
                "color": true
              },
              "additionalProperties": false
            }
          ]
        },
        "path": true,
        "keepAspectRatio": true,
        "keepFontSize": true,
        "inside": true,
        "verticalAlign": {
          "enum": [
            "top",
            "middle",
            "bottom"
          ]
        },
        "verticalOffset": true,
        "horizontalOffset": true,
        "spread": true,
        "textColor": {
          "type": "string",
          "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
        },
        "textOpacity": true,
        "fillColor": {
          "type": "string",
          "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
        },
        "fillOpacity": true,
        "strokeColor": {
          "type": "string",
          "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
        },
        "strokeOpacity": true,
        "strokeWidth": true,
        "viewBox": true,
        "presetId": true
      },
      "additionalProperties": false
    },
    "css-keyword": {
      "type": "boolean",
      "additionalProperties": false
    },
    "css-percentage": {
      "type": "object",
      "properties": {
        "value": true,
        "unit": {
          "enum": [
            "%"
          ]
        }
      },
      "additionalProperties": false
    },
    "css-absolute-length-unit": {
      "enum": [
        "px",
        "cm",
        "mm",
        "q",
        "in",
        "pt",
        "pc"
      ]
    },
    "css-relative-length-unit": {
      "enum": [
        "em",
        "ex",
        "ch",
        "rem",
        "vw",
        "vh",
        "vmin",
        "vmax"
      ]
    },
    "css-length": {
      "type": "object",
      "properties": {
        "unit": {
          "oneOf": [
            {
              "enum": [
                "px",
                "cm",
                "mm",
                "q",
                "in",
                "pt",
                "pc"
              ]
            },
            {
              "enum": [
                "em",
                "ex",
                "ch",
                "rem",
                "vw",
                "vh",
                "vmin",
                "vmax"
              ]
            }
          ]
        },
        "value": true
      },
      "additionalProperties": false
    },
    "css-length-or-percentage": {
      "oneOf": [
        {
          "type": "object",
          "properties": {
            "unit": {
              "oneOf": [
                {
                  "enum": [
                    "px",
                    "cm",
                    "mm",
                    "q",
                    "in",
                    "pt",
                    "pc"
                  ]
                },
                {
                  "enum": [
                    "em",
                    "ex",
                    "ch",
                    "rem",
                    "vw",
                    "vh",
                    "vmin",
                    "vmax"
                  ]
                }
              ]
            },
            "value": true
          },
          "additionalProperties": false
        },
        {
          "type": "object",
          "properties": {
            "value": true,
            "unit": {
              "enum": [
                "%"
              ]
            }
          },
          "additionalProperties": false
        }
      ]
    },
    "css-byte": true,
    "css-color": {
      "type": "object",
      "properties": {
        "red": true,
        "green": true,
        "blue": true,
        "alpha": true
      },
      "additionalProperties": false
    },
    "css-box-shadow": {
      "type": "array",
      "items": {
        "properties": {
          "inset": {
            "type": "boolean",
            "additionalProperties": false
          },
          "offsetX": {
            "type": "object",
            "properties": {
              "unit": {
                "oneOf": [
                  {
                    "enum": [
                      "px",
                      "cm",
                      "mm",
                      "q",
                      "in",
                      "pt",
                      "pc"
                    ]
                  },
                  {
                    "enum": [
                      "em",
                      "ex",
                      "ch",
                      "rem",
                      "vw",
                      "vh",
                      "vmin",
                      "vmax"
                    ]
                  }
                ]
              },
              "value": true
            },
            "additionalProperties": false
          },
          "offsetY": {
            "type": "object",
            "properties": {
              "unit": {
                "oneOf": [
                  {
                    "enum": [
                      "px",
                      "cm",
                      "mm",
                      "q",
                      "in",
                      "pt",
                      "pc"
                    ]
                  },
                  {
                    "enum": [
                      "em",
                      "ex",
                      "ch",
                      "rem",
                      "vw",
                      "vh",
                      "vmin",
                      "vmax"
                    ]
                  }
                ]
              },
              "value": true
            },
            "additionalProperties": false
          },
          "blurRadius": {
            "type": "object",
            "properties": {
              "unit": {
                "oneOf": [
                  {
                    "enum": [
                      "px",
                      "cm",
                      "mm",
                      "q",
                      "in",
                      "pt",
                      "pc"
                    ]
                  },
                  {
                    "enum": [
                      "em",
                      "ex",
                      "ch",
                      "rem",
                      "vw",
                      "vh",
                      "vmin",
                      "vmax"
                    ]
                  }
                ]
              },
              "value": true
            },
            "additionalProperties": false
          },
          "spreadRadius": {
            "type": "object",
            "properties": {
              "unit": {
                "oneOf": [
                  {
                    "enum": [
                      "px",
                      "cm",
                      "mm",
                      "q",
                      "in",
                      "pt",
                      "pc"
                    ]
                  },
                  {
                    "enum": [
                      "em",
                      "ex",
                      "ch",
                      "rem",
                      "vw",
                      "vh",
                      "vmin",
                      "vmax"
                    ]
                  }
                ]
              },
              "value": true
            },
            "additionalProperties": false
          },
          "color": {
            "type": "object",
            "properties": {
              "red": true,
              "green": true,
              "blue": true,
              "alpha": true
            },
            "additionalProperties": false
          }
        },
        "additionalProperties": false
      }
    },
    "css-border-radius": {
      "type": "object",
      "properties": {
        "topLeft": {
          "oneOf": [
            {
              "type": "object",
              "properties": {
                "unit": {
                  "oneOf": [
                    {
                      "enum": [
                        "px",
                        "cm",
                        "mm",
                        "q",
                        "in",
                        "pt",
                        "pc"
                      ]
                    },
                    {
                      "enum": [
                        "em",
                        "ex",
                        "ch",
                        "rem",
                        "vw",
                        "vh",
                        "vmin",
                        "vmax"
                      ]
                    }
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "value": true,
                "unit": {
                  "enum": [
                    "%"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "topRight": {
          "oneOf": [
            {
              "type": "object",
              "properties": {
                "unit": {
                  "oneOf": [
                    {
                      "enum": [
                        "px",
                        "cm",
                        "mm",
                        "q",
                        "in",
                        "pt",
                        "pc"
                      ]
                    },
                    {
                      "enum": [
                        "em",
                        "ex",
                        "ch",
                        "rem",
                        "vw",
                        "vh",
                        "vmin",
                        "vmax"
                      ]
                    }
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "value": true,
                "unit": {
                  "enum": [
                    "%"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "bottomLeft": {
          "oneOf": [
            {
              "type": "object",
              "properties": {
                "unit": {
                  "oneOf": [
                    {
                      "enum": [
                        "px",
                        "cm",
                        "mm",
                        "q",
                        "in",
                        "pt",
                        "pc"
                      ]
                    },
                    {
                      "enum": [
                        "em",
                        "ex",
                        "ch",
                        "rem",
                        "vw",
                        "vh",
                        "vmin",
                        "vmax"
                      ]
                    }
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "value": true,
                "unit": {
                  "enum": [
                    "%"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "bottomRight": {
          "oneOf": [
            {
              "type": "object",
              "properties": {
                "unit": {
                  "oneOf": [
                    {
                      "enum": [
                        "px",
                        "cm",
                        "mm",
                        "q",
                        "in",
                        "pt",
                        "pc"
                      ]
                    },
                    {
                      "enum": [
                        "em",
                        "ex",
                        "ch",
                        "rem",
                        "vw",
                        "vh",
                        "vmin",
                        "vmax"
                      ]
                    }
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "value": true,
                "unit": {
                  "enum": [
                    "%"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        }
      },
      "additionalProperties": false
    },
    "css-br-width": {
      "oneOf": [
        {
          "type": "object",
          "properties": {
            "unit": {
              "oneOf": [
                {
                  "enum": [
                    "px",
                    "cm",
                    "mm",
                    "q",
                    "in",
                    "pt",
                    "pc"
                  ]
                },
                {
                  "enum": [
                    "em",
                    "ex",
                    "ch",
                    "rem",
                    "vw",
                    "vh",
                    "vmin",
                    "vmax"
                  ]
                }
              ]
            },
            "value": true
          },
          "additionalProperties": false
        }
      ]
    },
    "css-border-width": {
      "type": "object",
      "properties": {
        "top": {
          "oneOf": [
            {
              "type": "object",
              "properties": {
                "unit": {
                  "oneOf": [
                    {
                      "enum": [
                        "px",
                        "cm",
                        "mm",
                        "q",
                        "in",
                        "pt",
                        "pc"
                      ]
                    },
                    {
                      "enum": [
                        "em",
                        "ex",
                        "ch",
                        "rem",
                        "vw",
                        "vh",
                        "vmin",
                        "vmax"
                      ]
                    }
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            }
          ]
        },
        "right": {
          "oneOf": [
            {
              "type": "object",
              "properties": {
                "unit": {
                  "oneOf": [
                    {
                      "enum": [
                        "px",
                        "cm",
                        "mm",
                        "q",
                        "in",
                        "pt",
                        "pc"
                      ]
                    },
                    {
                      "enum": [
                        "em",
                        "ex",
                        "ch",
                        "rem",
                        "vw",
                        "vh",
                        "vmin",
                        "vmax"
                      ]
                    }
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            }
          ]
        },
        "bottom": {
          "oneOf": [
            {
              "type": "object",
              "properties": {
                "unit": {
                  "oneOf": [
                    {
                      "enum": [
                        "px",
                        "cm",
                        "mm",
                        "q",
                        "in",
                        "pt",
                        "pc"
                      ]
                    },
                    {
                      "enum": [
                        "em",
                        "ex",
                        "ch",
                        "rem",
                        "vw",
                        "vh",
                        "vmin",
                        "vmax"
                      ]
                    }
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            }
          ]
        },
        "left": {
          "oneOf": [
            {
              "type": "object",
              "properties": {
                "unit": {
                  "oneOf": [
                    {
                      "enum": [
                        "px",
                        "cm",
                        "mm",
                        "q",
                        "in",
                        "pt",
                        "pc"
                      ]
                    },
                    {
                      "enum": [
                        "em",
                        "ex",
                        "ch",
                        "rem",
                        "vw",
                        "vh",
                        "vmin",
                        "vmax"
                      ]
                    }
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            }
          ]
        }
      },
      "additionalProperties": false
    },
    "css-br-style": {
      "enum": [
        "none",
        "hidden",
        "dotted",
        "dashed",
        "solid",
        "double",
        "groove",
        "ridge",
        "inset",
        "outset"
      ]
    },
    "css-border-style": {
      "type": "object",
      "properties": {
        "top": {
          "enum": [
            "none",
            "hidden",
            "dotted",
            "dashed",
            "solid",
            "double",
            "groove",
            "ridge",
            "inset",
            "outset"
          ]
        },
        "right": {
          "enum": [
            "none",
            "hidden",
            "dotted",
            "dashed",
            "solid",
            "double",
            "groove",
            "ridge",
            "inset",
            "outset"
          ]
        },
        "bottom": {
          "enum": [
            "none",
            "hidden",
            "dotted",
            "dashed",
            "solid",
            "double",
            "groove",
            "ridge",
            "inset",
            "outset"
          ]
        },
        "left": {
          "enum": [
            "none",
            "hidden",
            "dotted",
            "dashed",
            "solid",
            "double",
            "groove",
            "ridge",
            "inset",
            "outset"
          ]
        }
      },
      "additionalProperties": false
    },
    "css-border-color": {
      "type": "object",
      "properties": {
        "top": {
          "type": "object",
          "properties": {
            "red": true,
            "green": true,
            "blue": true,
            "alpha": true
          },
          "additionalProperties": false
        },
        "right": {
          "type": "object",
          "properties": {
            "red": true,
            "green": true,
            "blue": true,
            "alpha": true
          },
          "additionalProperties": false
        },
        "bottom": {
          "type": "object",
          "properties": {
            "red": true,
            "green": true,
            "blue": true,
            "alpha": true
          },
          "additionalProperties": false
        },
        "left": {
          "type": "object",
          "properties": {
            "red": true,
            "green": true,
            "blue": true,
            "alpha": true
          },
          "additionalProperties": false
        }
      },
      "additionalProperties": false
    },
    "css-border": {
      "type": "object",
      "properties": {
        "width": {
          "type": "object",
          "properties": {
            "top": {
              "oneOf": [
                {
                  "type": "object",
                  "properties": {
                    "unit": {
                      "oneOf": [
                        {
                          "enum": [
                            "px",
                            "cm",
                            "mm",
                            "q",
                            "in",
                            "pt",
                            "pc"
                          ]
                        },
                        {
                          "enum": [
                            "em",
                            "ex",
                            "ch",
                            "rem",
                            "vw",
                            "vh",
                            "vmin",
                            "vmax"
                          ]
                        }
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                }
              ]
            },
            "right": {
              "oneOf": [
                {
                  "type": "object",
                  "properties": {
                    "unit": {
                      "oneOf": [
                        {
                          "enum": [
                            "px",
                            "cm",
                            "mm",
                            "q",
                            "in",
                            "pt",
                            "pc"
                          ]
                        },
                        {
                          "enum": [
                            "em",
                            "ex",
                            "ch",
                            "rem",
                            "vw",
                            "vh",
                            "vmin",
                            "vmax"
                          ]
                        }
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                }
              ]
            },
            "bottom": {
              "oneOf": [
                {
                  "type": "object",
                  "properties": {
                    "unit": {
                      "oneOf": [
                        {
                          "enum": [
                            "px",
                            "cm",
                            "mm",
                            "q",
                            "in",
                            "pt",
                            "pc"
                          ]
                        },
                        {
                          "enum": [
                            "em",
                            "ex",
                            "ch",
                            "rem",
                            "vw",
                            "vh",
                            "vmin",
                            "vmax"
                          ]
                        }
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                }
              ]
            },
            "left": {
              "oneOf": [
                {
                  "type": "object",
                  "properties": {
                    "unit": {
                      "oneOf": [
                        {
                          "enum": [
                            "px",
                            "cm",
                            "mm",
                            "q",
                            "in",
                            "pt",
                            "pc"
                          ]
                        },
                        {
                          "enum": [
                            "em",
                            "ex",
                            "ch",
                            "rem",
                            "vw",
                            "vh",
                            "vmin",
                            "vmax"
                          ]
                        }
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                }
              ]
            }
          },
          "additionalProperties": false
        },
        "style": {
          "type": "object",
          "properties": {
            "top": {
              "enum": [
                "none",
                "hidden",
                "dotted",
                "dashed",
                "solid",
                "double",
                "groove",
                "ridge",
                "inset",
                "outset"
              ]
            },
            "right": {
              "enum": [
                "none",
                "hidden",
                "dotted",
                "dashed",
                "solid",
                "double",
                "groove",
                "ridge",
                "inset",
                "outset"
              ]
            },
            "bottom": {
              "enum": [
                "none",
                "hidden",
                "dotted",
                "dashed",
                "solid",
                "double",
                "groove",
                "ridge",
                "inset",
                "outset"
              ]
            },
            "left": {
              "enum": [
                "none",
                "hidden",
                "dotted",
                "dashed",
                "solid",
                "double",
                "groove",
                "ridge",
                "inset",
                "outset"
              ]
            }
          },
          "additionalProperties": false
        },
        "color": {
          "type": "object",
          "properties": {
            "top": {
              "type": "object",
              "properties": {
                "red": true,
                "green": true,
                "blue": true,
                "alpha": true
              },
              "additionalProperties": false
            },
            "right": {
              "type": "object",
              "properties": {
                "red": true,
                "green": true,
                "blue": true,
                "alpha": true
              },
              "additionalProperties": false
            },
            "bottom": {
              "type": "object",
              "properties": {
                "red": true,
                "green": true,
                "blue": true,
                "alpha": true
              },
              "additionalProperties": false
            },
            "left": {
              "type": "object",
              "properties": {
                "red": true,
                "green": true,
                "blue": true,
                "alpha": true
              },
              "additionalProperties": false
            }
          },
          "additionalProperties": false
        }
      },
      "additionalProperties": false
    },
    "cssBorder": {
      "type": "object",
      "properties": {
        "width": {
          "type": "object",
          "properties": {
            "top": {
              "oneOf": [
                {
                  "type": "object",
                  "properties": {
                    "unit": {
                      "oneOf": [
                        {
                          "enum": [
                            "px",
                            "cm",
                            "mm",
                            "q",
                            "in",
                            "pt",
                            "pc"
                          ]
                        },
                        {
                          "enum": [
                            "em",
                            "ex",
                            "ch",
                            "rem",
                            "vw",
                            "vh",
                            "vmin",
                            "vmax"
                          ]
                        }
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                }
              ]
            },
            "right": {
              "oneOf": [
                {
                  "type": "object",
                  "properties": {
                    "unit": {
                      "oneOf": [
                        {
                          "enum": [
                            "px",
                            "cm",
                            "mm",
                            "q",
                            "in",
                            "pt",
                            "pc"
                          ]
                        },
                        {
                          "enum": [
                            "em",
                            "ex",
                            "ch",
                            "rem",
                            "vw",
                            "vh",
                            "vmin",
                            "vmax"
                          ]
                        }
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                }
              ]
            },
            "bottom": {
              "oneOf": [
                {
                  "type": "object",
                  "properties": {
                    "unit": {
                      "oneOf": [
                        {
                          "enum": [
                            "px",
                            "cm",
                            "mm",
                            "q",
                            "in",
                            "pt",
                            "pc"
                          ]
                        },
                        {
                          "enum": [
                            "em",
                            "ex",
                            "ch",
                            "rem",
                            "vw",
                            "vh",
                            "vmin",
                            "vmax"
                          ]
                        }
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                }
              ]
            },
            "left": {
              "oneOf": [
                {
                  "type": "object",
                  "properties": {
                    "unit": {
                      "oneOf": [
                        {
                          "enum": [
                            "px",
                            "cm",
                            "mm",
                            "q",
                            "in",
                            "pt",
                            "pc"
                          ]
                        },
                        {
                          "enum": [
                            "em",
                            "ex",
                            "ch",
                            "rem",
                            "vw",
                            "vh",
                            "vmin",
                            "vmax"
                          ]
                        }
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                }
              ]
            }
          },
          "additionalProperties": false
        },
        "style": {
          "type": "object",
          "properties": {
            "top": {
              "enum": [
                "none",
                "hidden",
                "dotted",
                "dashed",
                "solid",
                "double",
                "groove",
                "ridge",
                "inset",
                "outset"
              ]
            },
            "right": {
              "enum": [
                "none",
                "hidden",
                "dotted",
                "dashed",
                "solid",
                "double",
                "groove",
                "ridge",
                "inset",
                "outset"
              ]
            },
            "bottom": {
              "enum": [
                "none",
                "hidden",
                "dotted",
                "dashed",
                "solid",
                "double",
                "groove",
                "ridge",
                "inset",
                "outset"
              ]
            },
            "left": {
              "enum": [
                "none",
                "hidden",
                "dotted",
                "dashed",
                "solid",
                "double",
                "groove",
                "ridge",
                "inset",
                "outset"
              ]
            }
          },
          "additionalProperties": false
        },
        "color": {
          "type": "object",
          "properties": {
            "top": {
              "type": "object",
              "properties": {
                "red": true,
                "green": true,
                "blue": true,
                "alpha": true
              },
              "additionalProperties": false
            },
            "right": {
              "type": "object",
              "properties": {
                "red": true,
                "green": true,
                "blue": true,
                "alpha": true
              },
              "additionalProperties": false
            },
            "bottom": {
              "type": "object",
              "properties": {
                "red": true,
                "green": true,
                "blue": true,
                "alpha": true
              },
              "additionalProperties": false
            },
            "left": {
              "type": "object",
              "properties": {
                "red": true,
                "green": true,
                "blue": true,
                "alpha": true
              },
              "additionalProperties": false
            }
          },
          "additionalProperties": false
        }
      },
      "additionalProperties": false
    },
    "cssBorderRadius": {
      "type": "object",
      "properties": {
        "topLeft": {
          "oneOf": [
            {
              "type": "object",
              "properties": {
                "unit": {
                  "oneOf": [
                    {
                      "enum": [
                        "px",
                        "cm",
                        "mm",
                        "q",
                        "in",
                        "pt",
                        "pc"
                      ]
                    },
                    {
                      "enum": [
                        "em",
                        "ex",
                        "ch",
                        "rem",
                        "vw",
                        "vh",
                        "vmin",
                        "vmax"
                      ]
                    }
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "value": true,
                "unit": {
                  "enum": [
                    "%"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "topRight": {
          "oneOf": [
            {
              "type": "object",
              "properties": {
                "unit": {
                  "oneOf": [
                    {
                      "enum": [
                        "px",
                        "cm",
                        "mm",
                        "q",
                        "in",
                        "pt",
                        "pc"
                      ]
                    },
                    {
                      "enum": [
                        "em",
                        "ex",
                        "ch",
                        "rem",
                        "vw",
                        "vh",
                        "vmin",
                        "vmax"
                      ]
                    }
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "value": true,
                "unit": {
                  "enum": [
                    "%"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "bottomLeft": {
          "oneOf": [
            {
              "type": "object",
              "properties": {
                "unit": {
                  "oneOf": [
                    {
                      "enum": [
                        "px",
                        "cm",
                        "mm",
                        "q",
                        "in",
                        "pt",
                        "pc"
                      ]
                    },
                    {
                      "enum": [
                        "em",
                        "ex",
                        "ch",
                        "rem",
                        "vw",
                        "vh",
                        "vmin",
                        "vmax"
                      ]
                    }
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "value": true,
                "unit": {
                  "enum": [
                    "%"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "bottomRight": {
          "oneOf": [
            {
              "type": "object",
              "properties": {
                "unit": {
                  "oneOf": [
                    {
                      "enum": [
                        "px",
                        "cm",
                        "mm",
                        "q",
                        "in",
                        "pt",
                        "pc"
                      ]
                    },
                    {
                      "enum": [
                        "em",
                        "ex",
                        "ch",
                        "rem",
                        "vw",
                        "vh",
                        "vmin",
                        "vmax"
                      ]
                    }
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "value": true,
                "unit": {
                  "enum": [
                    "%"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        }
      },
      "additionalProperties": false
    },
    "cssBoxShadow": {
      "type": "array",
      "items": {
        "properties": {
          "inset": {
            "type": "boolean",
            "additionalProperties": false
          },
          "offsetX": {
            "type": "object",
            "properties": {
              "unit": {
                "oneOf": [
                  {
                    "enum": [
                      "px",
                      "cm",
                      "mm",
                      "q",
                      "in",
                      "pt",
                      "pc"
                    ]
                  },
                  {
                    "enum": [
                      "em",
                      "ex",
                      "ch",
                      "rem",
                      "vw",
                      "vh",
                      "vmin",
                      "vmax"
                    ]
                  }
                ]
              },
              "value": true
            },
            "additionalProperties": false
          },
          "offsetY": {
            "type": "object",
            "properties": {
              "unit": {
                "oneOf": [
                  {
                    "enum": [
                      "px",
                      "cm",
                      "mm",
                      "q",
                      "in",
                      "pt",
                      "pc"
                    ]
                  },
                  {
                    "enum": [
                      "em",
                      "ex",
                      "ch",
                      "rem",
                      "vw",
                      "vh",
                      "vmin",
                      "vmax"
                    ]
                  }
                ]
              },
              "value": true
            },
            "additionalProperties": false
          },
          "blurRadius": {
            "type": "object",
            "properties": {
              "unit": {
                "oneOf": [
                  {
                    "enum": [
                      "px",
                      "cm",
                      "mm",
                      "q",
                      "in",
                      "pt",
                      "pc"
                    ]
                  },
                  {
                    "enum": [
                      "em",
                      "ex",
                      "ch",
                      "rem",
                      "vw",
                      "vh",
                      "vmin",
                      "vmax"
                    ]
                  }
                ]
              },
              "value": true
            },
            "additionalProperties": false
          },
          "spreadRadius": {
            "type": "object",
            "properties": {
              "unit": {
                "oneOf": [
                  {
                    "enum": [
                      "px",
                      "cm",
                      "mm",
                      "q",
                      "in",
                      "pt",
                      "pc"
                    ]
                  },
                  {
                    "enum": [
                      "em",
                      "ex",
                      "ch",
                      "rem",
                      "vw",
                      "vh",
                      "vmin",
                      "vmax"
                    ]
                  }
                ]
              },
              "value": true
            },
            "additionalProperties": false
          },
          "color": {
            "type": "object",
            "properties": {
              "red": true,
              "green": true,
              "blue": true,
              "alpha": true
            },
            "additionalProperties": false
          }
        },
        "additionalProperties": false
      }
    },
    "cssStyle": {
      "type": "object",
      "properties": {
        "cssBorder": {
          "oneOf": [
            {
              "type": "null"
            },
            {
              "type": "object",
              "properties": {
                "width": {
                  "type": "object",
                  "properties": {
                    "top": {
                      "oneOf": [
                        {
                          "type": "object",
                          "properties": {
                            "unit": {
                              "oneOf": [
                                {
                                  "enum": [
                                    "px",
                                    "cm",
                                    "mm",
                                    "q",
                                    "in",
                                    "pt",
                                    "pc"
                                  ]
                                },
                                {
                                  "enum": [
                                    "em",
                                    "ex",
                                    "ch",
                                    "rem",
                                    "vw",
                                    "vh",
                                    "vmin",
                                    "vmax"
                                  ]
                                }
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "right": {
                      "oneOf": [
                        {
                          "type": "object",
                          "properties": {
                            "unit": {
                              "oneOf": [
                                {
                                  "enum": [
                                    "px",
                                    "cm",
                                    "mm",
                                    "q",
                                    "in",
                                    "pt",
                                    "pc"
                                  ]
                                },
                                {
                                  "enum": [
                                    "em",
                                    "ex",
                                    "ch",
                                    "rem",
                                    "vw",
                                    "vh",
                                    "vmin",
                                    "vmax"
                                  ]
                                }
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "bottom": {
                      "oneOf": [
                        {
                          "type": "object",
                          "properties": {
                            "unit": {
                              "oneOf": [
                                {
                                  "enum": [
                                    "px",
                                    "cm",
                                    "mm",
                                    "q",
                                    "in",
                                    "pt",
                                    "pc"
                                  ]
                                },
                                {
                                  "enum": [
                                    "em",
                                    "ex",
                                    "ch",
                                    "rem",
                                    "vw",
                                    "vh",
                                    "vmin",
                                    "vmax"
                                  ]
                                }
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "left": {
                      "oneOf": [
                        {
                          "type": "object",
                          "properties": {
                            "unit": {
                              "oneOf": [
                                {
                                  "enum": [
                                    "px",
                                    "cm",
                                    "mm",
                                    "q",
                                    "in",
                                    "pt",
                                    "pc"
                                  ]
                                },
                                {
                                  "enum": [
                                    "em",
                                    "ex",
                                    "ch",
                                    "rem",
                                    "vw",
                                    "vh",
                                    "vmin",
                                    "vmax"
                                  ]
                                }
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        }
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "style": {
                  "type": "object",
                  "properties": {
                    "top": {
                      "enum": [
                        "none",
                        "hidden",
                        "dotted",
                        "dashed",
                        "solid",
                        "double",
                        "groove",
                        "ridge",
                        "inset",
                        "outset"
                      ]
                    },
                    "right": {
                      "enum": [
                        "none",
                        "hidden",
                        "dotted",
                        "dashed",
                        "solid",
                        "double",
                        "groove",
                        "ridge",
                        "inset",
                        "outset"
                      ]
                    },
                    "bottom": {
                      "enum": [
                        "none",
                        "hidden",
                        "dotted",
                        "dashed",
                        "solid",
                        "double",
                        "groove",
                        "ridge",
                        "inset",
                        "outset"
                      ]
                    },
                    "left": {
                      "enum": [
                        "none",
                        "hidden",
                        "dotted",
                        "dashed",
                        "solid",
                        "double",
                        "groove",
                        "ridge",
                        "inset",
                        "outset"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "color": {
                  "type": "object",
                  "properties": {
                    "top": {
                      "type": "object",
                      "properties": {
                        "red": true,
                        "green": true,
                        "blue": true,
                        "alpha": true
                      },
                      "additionalProperties": false
                    },
                    "right": {
                      "type": "object",
                      "properties": {
                        "red": true,
                        "green": true,
                        "blue": true,
                        "alpha": true
                      },
                      "additionalProperties": false
                    },
                    "bottom": {
                      "type": "object",
                      "properties": {
                        "red": true,
                        "green": true,
                        "blue": true,
                        "alpha": true
                      },
                      "additionalProperties": false
                    },
                    "left": {
                      "type": "object",
                      "properties": {
                        "red": true,
                        "green": true,
                        "blue": true,
                        "alpha": true
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "cssBoxShadow": true,
        "cssBorderRadius": {
          "oneOf": [
            {
              "type": "null"
            },
            {
              "type": "object",
              "properties": {
                "topLeft": {
                  "oneOf": [
                    {
                      "type": "object",
                      "properties": {
                        "unit": {
                          "oneOf": [
                            {
                              "enum": [
                                "px",
                                "cm",
                                "mm",
                                "q",
                                "in",
                                "pt",
                                "pc"
                              ]
                            },
                            {
                              "enum": [
                                "em",
                                "ex",
                                "ch",
                                "rem",
                                "vw",
                                "vh",
                                "vmin",
                                "vmax"
                              ]
                            }
                          ]
                        },
                        "value": true
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "value": true,
                        "unit": {
                          "enum": [
                            "%"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "topRight": {
                  "oneOf": [
                    {
                      "type": "object",
                      "properties": {
                        "unit": {
                          "oneOf": [
                            {
                              "enum": [
                                "px",
                                "cm",
                                "mm",
                                "q",
                                "in",
                                "pt",
                                "pc"
                              ]
                            },
                            {
                              "enum": [
                                "em",
                                "ex",
                                "ch",
                                "rem",
                                "vw",
                                "vh",
                                "vmin",
                                "vmax"
                              ]
                            }
                          ]
                        },
                        "value": true
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "value": true,
                        "unit": {
                          "enum": [
                            "%"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "bottomLeft": {
                  "oneOf": [
                    {
                      "type": "object",
                      "properties": {
                        "unit": {
                          "oneOf": [
                            {
                              "enum": [
                                "px",
                                "cm",
                                "mm",
                                "q",
                                "in",
                                "pt",
                                "pc"
                              ]
                            },
                            {
                              "enum": [
                                "em",
                                "ex",
                                "ch",
                                "rem",
                                "vw",
                                "vh",
                                "vmin",
                                "vmax"
                              ]
                            }
                          ]
                        },
                        "value": true
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "value": true,
                        "unit": {
                          "enum": [
                            "%"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "bottomRight": {
                  "oneOf": [
                    {
                      "type": "object",
                      "properties": {
                        "unit": {
                          "oneOf": [
                            {
                              "enum": [
                                "px",
                                "cm",
                                "mm",
                                "q",
                                "in",
                                "pt",
                                "pc"
                              ]
                            },
                            {
                              "enum": [
                                "em",
                                "ex",
                                "ch",
                                "rem",
                                "vw",
                                "vh",
                                "vmin",
                                "vmax"
                              ]
                            }
                          ]
                        },
                        "value": true
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "value": true,
                        "unit": {
                          "enum": [
                            "%"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        }
      },
      "additionalProperties": false
    },
    "LayersEffect": {
      "type": "object",
      "properties": {
        "size": true,
        "y": {
          "type": "object",
          "properties": {
            "value": true,
            "type": {
              "enum": [
                "px",
                "em",
                "rem",
                "percentage",
                "vh",
                "vw",
                "vmin",
                "vmax"
              ]
            }
          },
          "additionalProperties": false
        },
        "x": {
          "type": "object",
          "properties": {
            "value": true,
            "type": {
              "enum": [
                "px",
                "em",
                "rem",
                "percentage",
                "vh",
                "vw",
                "vmin",
                "vmax"
              ]
            }
          },
          "additionalProperties": false
        },
        "pin": {
          "type": "string",
          "enum": [
            "in",
            "out"
          ]
        }
      },
      "additionalProperties": false
    },
    "dataChangeBehaviors": {
      "type": [
        "array",
        "null"
      ],
      "items": {
        "type": "object",
        "properties": {
          "trigger": true,
          "type": true,
          "part": true,
          "name": true,
          "params": true
        },
        "additionalProperties": false
      }
    },
    "BackgroundMedia": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "mediaRef": true,
        "mediaTransforms": {
          "type": "object",
          "properties": {
            "scale": true,
            "opacity": true
          },
          "additionalProperties": false
        },
        "overlayTransforms": {
          "type": "object",
          "properties": {
            "scale": true,
            "opacity": true
          },
          "additionalProperties": false
        },
        "color": {
          "oneOf": [
            {
              "enum": [
                "transparent",
                "noColor"
              ]
            },
            {
              "type": "string",
              "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
            }
          ]
        },
        "colorOpacity": true,
        "alignType": {
          "type": "string",
          "enum": [
            "top",
            "bottom",
            "left",
            "right",
            "center",
            "top_left",
            "top_right",
            "bottom_left",
            "bottom_right"
          ]
        },
        "fittingType": {
          "type": "string",
          "enum": [
            "fill",
            "fit",
            "stretch",
            "actual_size",
            "original_size",
            "tile",
            "tile_horizontal",
            "tile_vertical",
            "fit_and_tile",
            "legacy_tile",
            "legacy_tile_horizontal",
            "legacy_tile_vertical",
            "legacy_normal"
          ]
        },
        "scrollType": {
          "type": "string",
          "enum": [
            "none",
            "fixed",
            "scroll",
            "local",
            "parallax"
          ]
        },
        "showOverlayForMediaType": {
          "type": "string",
          "enum": [
            "all",
            "WixVideo",
            "Image"
          ]
        },
        "imageOverlay": true,
        "colorOverlay": {
          "type": "string",
          "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
        },
        "colorOverlayOpacity": true,
        "overlayBlending": {
          "type": "object",
          "properties": {
            "color": true,
            "opacity": true,
            "contrast": true,
            "saturate": true,
            "blendMode": {
              "type": "string",
              "enum": [
                "normal",
                "multiply",
                "screen",
                "darken",
                "lighten",
                "overlay",
                "colorDodge",
                "colorBurn",
                "hardLight",
                "softLight",
                "difference",
                "exclusion",
                "hue",
                "saturation",
                "color",
                "luminosity"
              ]
            }
          },
          "additionalProperties": false
        },
        "filterEffect": {
          "type": [
            "object",
            "null"
          ],
          "properties": {
            "effectType": {
              "type": "string",
              "enum": [
                "none",
                "normal",
                "ink",
                "kennedy",
                "feathered",
                "blur",
                "whistler",
                "3d",
                "blueray",
                "lighten",
                "darken",
                "pinkrinse",
                "redrum",
                "greenwash",
                "yellowstreak",
                "neonsky",
                "seaweed",
                "soledad",
                "sangria",
                "malibu",
                "candyfloss",
                "elmo",
                "unicorn",
                "kerouac",
                "koolaid",
                "hydra",
                "pixie",
                "nightrain",
                "bauhaus",
                "neptune",
                "orca",
                "manhattan",
                "goldie",
                "flamingo",
                "faded",
                "gotham",
                "hulk",
                "midnight",
                "lucille",
                "organic",
                "grayscale",
                "tvDuotone",
                "tvMonotoneDark",
                "tvMonotoneLight",
                "tvHue"
              ]
            },
            "brightness": true,
            "contrast": true,
            "saturation": true,
            "hue": true,
            "duotoneDark": true,
            "duotoneLight": true,
            "invert": true,
            "isCustom": true
          },
          "additionalProperties": false
        },
        "colorLayers": {
          "type": [
            "array",
            "null"
          ],
          "items": true
        }
      },
      "additionalProperties": false
    },
    "BlendMode": {
      "type": "string",
      "enum": [
        "normal",
        "multiply",
        "screen",
        "darken",
        "lighten",
        "overlay",
        "colorDodge",
        "colorBurn",
        "hardLight",
        "softLight",
        "difference",
        "exclusion",
        "hue",
        "saturation",
        "color",
        "luminosity"
      ]
    },
    "Shadow": {
      "type": "object",
      "properties": {
        "x": true,
        "y": true,
        "spreadRadius": true,
        "blurRadius": true,
        "opacity": true,
        "color": true
      },
      "additionalProperties": false
    },
    "filterEffect": {
      "type": [
        "object",
        "null"
      ],
      "properties": {
        "effectType": {
          "type": "string",
          "enum": [
            "none",
            "normal",
            "ink",
            "kennedy",
            "feathered",
            "blur",
            "whistler",
            "3d",
            "blueray",
            "lighten",
            "darken",
            "pinkrinse",
            "redrum",
            "greenwash",
            "yellowstreak",
            "neonsky",
            "seaweed",
            "soledad",
            "sangria",
            "malibu",
            "candyfloss",
            "elmo",
            "unicorn",
            "kerouac",
            "koolaid",
            "hydra",
            "pixie",
            "nightrain",
            "bauhaus",
            "neptune",
            "orca",
            "manhattan",
            "goldie",
            "flamingo",
            "faded",
            "gotham",
            "hulk",
            "midnight",
            "lucille",
            "organic",
            "grayscale",
            "tvDuotone",
            "tvMonotoneDark",
            "tvMonotoneLight",
            "tvHue"
          ]
        },
        "brightness": true,
        "contrast": true,
        "saturation": true,
        "hue": true,
        "duotoneDark": true,
        "duotoneLight": true,
        "invert": true,
        "isCustom": true
      },
      "additionalProperties": false
    },
    "overlayBlending": {
      "type": "object",
      "properties": {
        "color": true,
        "opacity": true,
        "contrast": true,
        "saturate": true,
        "blendMode": {
          "type": "string",
          "enum": [
            "normal",
            "multiply",
            "screen",
            "darken",
            "lighten",
            "overlay",
            "colorDodge",
            "colorBurn",
            "hardLight",
            "softLight",
            "difference",
            "exclusion",
            "hue",
            "saturation",
            "color",
            "luminosity"
          ]
        }
      },
      "additionalProperties": false
    },
    "BackgroundTransforms": {
      "type": "object",
      "properties": {
        "scale": true,
        "opacity": true
      },
      "additionalProperties": false
    },
    "ImageMask": {
      "type": "object",
      "properties": {
        "x": true,
        "y": true,
        "width": true,
        "height": true,
        "svgId": true,
        "flip": {
          "type": "string",
          "enum": [
            "x",
            "y",
            "xy",
            "none"
          ]
        },
        "rotate": true,
        "mode": {
          "type": "string",
          "enum": [
            "alpha",
            "luminance"
          ]
        }
      },
      "additionalProperties": false
    },
    "WixVideo": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "title": true,
        "alt": true,
        "videoId": true,
        "generatedPosters": {
          "type": "array",
          "items": true
        },
        "qualities": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "quality": true,
              "width": true,
              "height": true,
              "formats": {
                "type": "array",
                "items": true
              },
              "format": {
                "type": "string",
                "enum": [
                  "mp4",
                  "webm"
                ]
              },
              "url": true
            },
            "additionalProperties": false
          }
        },
        "adaptiveVideo": {
          "type": [
            "array",
            "null"
          ],
          "items": {
            "type": "object",
            "properties": {
              "format": {
                "type": "string",
                "enum": [
                  "hls",
                  "dash"
                ]
              },
              "url": true
            },
            "additionalProperties": false
          }
        },
        "posterImageRef": true,
        "duration": true,
        "loop": true,
        "autoplay": true,
        "playbackSpeed": true,
        "fps": true,
        "preload": {
          "type": "string",
          "enum": [
            "auto",
            "metadata",
            "none"
          ]
        },
        "controls": {
          "type": "string",
          "enum": [
            "none",
            "full"
          ]
        },
        "mute": true,
        "hasAudio": true,
        "opacity": true,
        "artist": {
          "type": "object",
          "properties": {
            "name": true,
            "id": true
          },
          "additionalProperties": false
        },
        "mediaFeatures": true,
        "mask": {
          "oneOf": [
            {
              "type": "null"
            },
            {
              "type": "object",
              "properties": {
                "x": true,
                "y": true,
                "width": true,
                "height": true,
                "svgId": true,
                "flip": {
                  "type": "string",
                  "enum": [
                    "x",
                    "y",
                    "xy",
                    "none"
                  ]
                },
                "rotate": true,
                "mode": {
                  "type": "string",
                  "enum": [
                    "alpha",
                    "luminance"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "focalPoint": {
          "type": "object",
          "properties": {
            "x": true,
            "y": true
          },
          "additionalProperties": false
        }
      },
      "additionalProperties": false
    },
    "Video": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "videoId": true,
        "userId": true,
        "posterImage": true,
        "videoType": {
          "type": "string",
          "enum": [
            "YOUTUBE",
            "VIMEO",
            "FACEBOOK",
            "DAILYMOTION"
          ]
        }
      },
      "additionalProperties": false
    },
    "RepeatedData": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "original": true,
        "overrides": true
      },
      "additionalProperties": false
    },
    "Image": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "link": {
          "type": [
            "null",
            "string"
          ],
          "pattern": "^$|^#"
        },
        "title": true,
        "name": true,
        "uri": {
          "type": "string",
          "pattern": "^[\\w:~\\-_+%.\\/,\\?=\\()]+$"
        },
        "description": true,
        "height": true,
        "width": true,
        "borderSize": true,
        "alt": true,
        "decorative": true,
        "hasAnimation": true,
        "originalImageDataRef": true,
        "opacity": true,
        "crop": {
          "oneOf": [
            {
              "type": "null"
            },
            {
              "type": "object",
              "properties": {
                "x": true,
                "y": true,
                "width": true,
                "height": true,
                "svgId": true,
                "flip": {
                  "type": "string",
                  "enum": [
                    "x",
                    "y",
                    "xy",
                    "none"
                  ]
                },
                "rotate": true
              },
              "additionalProperties": false
            }
          ]
        },
        "upscaleMethod": true,
        "focalPoint": {
          "oneOf": [
            {
              "type": "null"
            },
            {
              "type": "object",
              "properties": {
                "x": true,
                "y": true
              },
              "additionalProperties": false
            }
          ]
        },
        "artist": {
          "type": "object",
          "properties": {
            "name": true,
            "id": true
          },
          "additionalProperties": false
        }
      },
      "additionalProperties": false
    },
    "MediaControlsDesignData": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "iconsDefaultDesign": true,
        "icons": {
          "type": [
            "array",
            "null"
          ],
          "items": true
        },
        "iconDesign": true
      },
      "additionalProperties": false
    },
    "ControlIconDesignData": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "name": true,
        "svgId": true,
        "iconDesign": true
      },
      "additionalProperties": false
    },
    "VectorImageDesignData": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "shadow": {
          "oneOf": [
            {
              "type": "null"
            },
            {
              "type": "object",
              "properties": {
                "x": true,
                "y": true,
                "spreadRadius": true,
                "blurRadius": true,
                "opacity": true,
                "color": true
              },
              "additionalProperties": false
            }
          ]
        },
        "shapeStyle": {
          "type": "object",
          "properties": {
            "opacity": true,
            "strokeWidth": true,
            "fill": true,
            "fillOpacity": true,
            "stroke": true,
            "strokeOpacity": true,
            "enableStroke": true
          },
          "additionalProperties": false
        },
        "overrideColors": {
          "oneOf": [
            {
              "type": "null"
            },
            {
              "type": "object",
              "properties": {
                "color1": true,
                "color2": true,
                "color3": true,
                "color4": true,
                "color5": true,
                "color6": true,
                "color7": true,
                "color8": true
              },
              "additionalProperties": false
            }
          ]
        }
      },
      "additionalProperties": false
    },
    "GradientMesh": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "GradientMesh"
          ]
        },
        "gradients": {
          "type": "array",
          "items": {
            "type": "object",
            "oneOf": [
              {
                "type": "object",
                "properties": {
                  "type": {
                    "type": "string",
                    "enum": [
                      "GradientLinear"
                    ]
                  },
                  "repeat": true,
                  "blendMode": {
                    "type": "string",
                    "enum": [
                      "normal",
                      "multiply",
                      "screen",
                      "darken",
                      "lighten",
                      "overlay",
                      "colorDodge",
                      "colorBurn",
                      "hardLight",
                      "softLight",
                      "difference",
                      "exclusion",
                      "hue",
                      "saturation",
                      "color",
                      "luminosity"
                    ]
                  },
                  "angle": true,
                  "colorStops": {
                    "type": "array",
                    "items": {
                      "type": "object",
                      "properties": {
                        "size": {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "percentage",
                                "vh",
                                "vw",
                                "vmin",
                                "vmax"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        "color": {
                          "type": "string",
                          "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
                        },
                        "opacity": true
                      },
                      "additionalProperties": false
                    }
                  }
                },
                "additionalProperties": false
              },
              {
                "type": "object",
                "properties": {
                  "type": {
                    "type": "string",
                    "enum": [
                      "GradientCircle"
                    ]
                  },
                  "repeat": true,
                  "blendMode": {
                    "type": "string",
                    "enum": [
                      "normal",
                      "multiply",
                      "screen",
                      "darken",
                      "lighten",
                      "overlay",
                      "colorDodge",
                      "colorBurn",
                      "hardLight",
                      "softLight",
                      "difference",
                      "exclusion",
                      "hue",
                      "saturation",
                      "color",
                      "luminosity"
                    ]
                  },
                  "size": {
                    "type": "object",
                    "properties": {
                      "keyword": {
                        "type": "string",
                        "enum": [
                          "closest-side",
                          "closest-corner",
                          "farthest-side",
                          "farthest-corner"
                        ]
                      },
                      "value": true,
                      "type": {
                        "enum": [
                          "px",
                          "em",
                          "rem",
                          "vh",
                          "vw",
                          "vmin",
                          "vmax"
                        ]
                      }
                    },
                    "additionalProperties": false
                  },
                  "position": {
                    "type": "object",
                    "properties": {
                      "x": {
                        "type": "object",
                        "properties": {
                          "value": true,
                          "type": {
                            "enum": [
                              "px",
                              "em",
                              "rem",
                              "percentage",
                              "vh",
                              "vw",
                              "vmin",
                              "vmax"
                            ]
                          }
                        },
                        "additionalProperties": false
                      },
                      "y": {
                        "type": "object",
                        "properties": {
                          "value": true,
                          "type": {
                            "enum": [
                              "px",
                              "em",
                              "rem",
                              "percentage",
                              "vh",
                              "vw",
                              "vmin",
                              "vmax"
                            ]
                          }
                        },
                        "additionalProperties": false
                      }
                    },
                    "additionalProperties": false
                  },
                  "colorStops": {
                    "type": "array",
                    "items": {
                      "type": "object",
                      "properties": {
                        "size": {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "percentage",
                                "vh",
                                "vw",
                                "vmin",
                                "vmax"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        "color": {
                          "type": "string",
                          "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
                        },
                        "opacity": true
                      },
                      "additionalProperties": false
                    }
                  }
                },
                "additionalProperties": false
              },
              {
                "type": "object",
                "properties": {
                  "type": {
                    "type": "string",
                    "enum": [
                      "GradientEllipse"
                    ]
                  },
                  "repeat": true,
                  "blendMode": {
                    "type": "string",
                    "enum": [
                      "normal",
                      "multiply",
                      "screen",
                      "darken",
                      "lighten",
                      "overlay",
                      "colorDodge",
                      "colorBurn",
                      "hardLight",
                      "softLight",
                      "difference",
                      "exclusion",
                      "hue",
                      "saturation",
                      "color",
                      "luminosity"
                    ]
                  },
                  "size": {
                    "type": "object",
                    "properties": {
                      "keyword": {
                        "type": "string",
                        "enum": [
                          "closest-side",
                          "closest-corner",
                          "farthest-side",
                          "farthest-corner"
                        ]
                      },
                      "width": {
                        "type": "object",
                        "properties": {
                          "value": true,
                          "type": {
                            "enum": [
                              "px",
                              "em",
                              "rem",
                              "percentage",
                              "vh",
                              "vw",
                              "vmin",
                              "vmax"
                            ]
                          }
                        },
                        "additionalProperties": false
                      },
                      "height": {
                        "type": "object",
                        "properties": {
                          "value": true,
                          "type": {
                            "enum": [
                              "px",
                              "em",
                              "rem",
                              "percentage",
                              "vh",
                              "vw",
                              "vmin",
                              "vmax"
                            ]
                          }
                        },
                        "additionalProperties": false
                      }
                    },
                    "additionalProperties": false
                  },
                  "position": {
                    "type": "object",
                    "properties": {
                      "x": {
                        "type": "object",
                        "properties": {
                          "value": true,
                          "type": {
                            "enum": [
                              "px",
                              "em",
                              "rem",
                              "percentage",
                              "vh",
                              "vw",
                              "vmin",
                              "vmax"
                            ]
                          }
                        },
                        "additionalProperties": false
                      },
                      "y": {
                        "type": "object",
                        "properties": {
                          "value": true,
                          "type": {
                            "enum": [
                              "px",
                              "em",
                              "rem",
                              "percentage",
                              "vh",
                              "vw",
                              "vmin",
                              "vmax"
                            ]
                          }
                        },
                        "additionalProperties": false
                      }
                    },
                    "additionalProperties": false
                  },
                  "colorStops": {
                    "type": "array",
                    "items": {
                      "type": "object",
                      "properties": {
                        "size": {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "percentage",
                                "vh",
                                "vw",
                                "vmin",
                                "vmax"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        "color": {
                          "type": "string",
                          "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
                        },
                        "opacity": true
                      },
                      "additionalProperties": false
                    }
                  }
                },
                "additionalProperties": false
              },
              {
                "type": "object",
                "properties": {
                  "type": {
                    "type": "string",
                    "enum": [
                      "GradientConic"
                    ]
                  },
                  "repeat": true,
                  "blendMode": {
                    "type": "string",
                    "enum": [
                      "normal",
                      "multiply",
                      "screen",
                      "darken",
                      "lighten",
                      "overlay",
                      "colorDodge",
                      "colorBurn",
                      "hardLight",
                      "softLight",
                      "difference",
                      "exclusion",
                      "hue",
                      "saturation",
                      "color",
                      "luminosity"
                    ]
                  },
                  "angle": true,
                  "position": {
                    "type": "object",
                    "properties": {
                      "x": {
                        "type": "object",
                        "properties": {
                          "value": true,
                          "type": {
                            "enum": [
                              "px",
                              "em",
                              "rem",
                              "percentage",
                              "vh",
                              "vw",
                              "vmin",
                              "vmax"
                            ]
                          }
                        },
                        "additionalProperties": false
                      },
                      "y": {
                        "type": "object",
                        "properties": {
                          "value": true,
                          "type": {
                            "enum": [
                              "px",
                              "em",
                              "rem",
                              "percentage",
                              "vh",
                              "vw",
                              "vmin",
                              "vmax"
                            ]
                          }
                        },
                        "additionalProperties": false
                      }
                    },
                    "additionalProperties": false
                  },
                  "colorStops": {
                    "type": "array",
                    "items": {
                      "type": "object",
                      "properties": {
                        "size": {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "deg",
                                "percentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        "color": {
                          "type": "string",
                          "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
                        },
                        "opacity": true
                      },
                      "additionalProperties": false
                    }
                  }
                },
                "additionalProperties": false
              }
            ]
          }
        }
      },
      "additionalProperties": false
    },
    "RefArray": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "values": {
          "type": [
            "array"
          ],
          "items": true
        }
      },
      "additionalProperties": false
    },
    "VariantRelation": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "variants": {
          "type": "array",
          "items": true
        },
        "remoteVariants": {
          "type": "array",
          "items": true
        },
        "from": true,
        "to": true
      },
      "additionalProperties": false
    },
    "GradientLinearLayer": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "opacity": true,
        "fill": {
          "type": "object",
          "properties": {
            "type": {
              "type": "string",
              "enum": [
                "GradientLinear"
              ]
            },
            "repeat": true,
            "blendMode": {
              "type": "string",
              "enum": [
                "normal",
                "multiply",
                "screen",
                "darken",
                "lighten",
                "overlay",
                "colorDodge",
                "colorBurn",
                "hardLight",
                "softLight",
                "difference",
                "exclusion",
                "hue",
                "saturation",
                "color",
                "luminosity"
              ]
            },
            "angle": true,
            "colorStops": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "size": {
                    "type": "object",
                    "properties": {
                      "value": true,
                      "type": {
                        "enum": [
                          "px",
                          "em",
                          "rem",
                          "percentage",
                          "vh",
                          "vw",
                          "vmin",
                          "vmax"
                        ]
                      }
                    },
                    "additionalProperties": false
                  },
                  "color": {
                    "type": "string",
                    "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
                  },
                  "opacity": true
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        }
      },
      "additionalProperties": false
    },
    "GradientCircleLayer": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "opacity": true,
        "fill": {
          "type": "object",
          "properties": {
            "type": {
              "type": "string",
              "enum": [
                "GradientCircle"
              ]
            },
            "repeat": true,
            "blendMode": {
              "type": "string",
              "enum": [
                "normal",
                "multiply",
                "screen",
                "darken",
                "lighten",
                "overlay",
                "colorDodge",
                "colorBurn",
                "hardLight",
                "softLight",
                "difference",
                "exclusion",
                "hue",
                "saturation",
                "color",
                "luminosity"
              ]
            },
            "size": {
              "type": "object",
              "properties": {
                "keyword": {
                  "type": "string",
                  "enum": [
                    "closest-side",
                    "closest-corner",
                    "farthest-side",
                    "farthest-corner"
                  ]
                },
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "vh",
                    "vw",
                    "vmin",
                    "vmax"
                  ]
                }
              },
              "additionalProperties": false
            },
            "position": {
              "type": "object",
              "properties": {
                "x": {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "percentage",
                        "vh",
                        "vw",
                        "vmin",
                        "vmax"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "y": {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "percentage",
                        "vh",
                        "vw",
                        "vmin",
                        "vmax"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            "colorStops": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "size": {
                    "type": "object",
                    "properties": {
                      "value": true,
                      "type": {
                        "enum": [
                          "px",
                          "em",
                          "rem",
                          "percentage",
                          "vh",
                          "vw",
                          "vmin",
                          "vmax"
                        ]
                      }
                    },
                    "additionalProperties": false
                  },
                  "color": {
                    "type": "string",
                    "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
                  },
                  "opacity": true
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        }
      },
      "additionalProperties": false
    },
    "GradientEllipseLayer": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "opacity": true,
        "fill": {
          "type": "object",
          "properties": {
            "type": {
              "type": "string",
              "enum": [
                "GradientEllipse"
              ]
            },
            "repeat": true,
            "blendMode": {
              "type": "string",
              "enum": [
                "normal",
                "multiply",
                "screen",
                "darken",
                "lighten",
                "overlay",
                "colorDodge",
                "colorBurn",
                "hardLight",
                "softLight",
                "difference",
                "exclusion",
                "hue",
                "saturation",
                "color",
                "luminosity"
              ]
            },
            "size": {
              "type": "object",
              "properties": {
                "keyword": {
                  "type": "string",
                  "enum": [
                    "closest-side",
                    "closest-corner",
                    "farthest-side",
                    "farthest-corner"
                  ]
                },
                "width": {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "percentage",
                        "vh",
                        "vw",
                        "vmin",
                        "vmax"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "height": {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "percentage",
                        "vh",
                        "vw",
                        "vmin",
                        "vmax"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            "position": {
              "type": "object",
              "properties": {
                "x": {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "percentage",
                        "vh",
                        "vw",
                        "vmin",
                        "vmax"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "y": {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "percentage",
                        "vh",
                        "vw",
                        "vmin",
                        "vmax"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            "colorStops": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "size": {
                    "type": "object",
                    "properties": {
                      "value": true,
                      "type": {
                        "enum": [
                          "px",
                          "em",
                          "rem",
                          "percentage",
                          "vh",
                          "vw",
                          "vmin",
                          "vmax"
                        ]
                      }
                    },
                    "additionalProperties": false
                  },
                  "color": {
                    "type": "string",
                    "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
                  },
                  "opacity": true
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        }
      },
      "additionalProperties": false
    },
    "GradientMeshLayer": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "opacity": true,
        "fill": {
          "type": "object",
          "properties": {
            "type": {
              "type": "string",
              "enum": [
                "GradientMesh"
              ]
            },
            "gradients": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "type": {
                    "type": "string",
                    "enum": [
                      "GradientCircle"
                    ]
                  },
                  "repeat": true,
                  "blendMode": {
                    "type": "string",
                    "enum": [
                      "normal",
                      "multiply",
                      "screen",
                      "darken",
                      "lighten",
                      "overlay",
                      "colorDodge",
                      "colorBurn",
                      "hardLight",
                      "softLight",
                      "difference",
                      "exclusion",
                      "hue",
                      "saturation",
                      "color",
                      "luminosity"
                    ]
                  },
                  "size": {
                    "type": "object",
                    "properties": {
                      "keyword": {
                        "type": "string",
                        "enum": [
                          "closest-side",
                          "closest-corner",
                          "farthest-side",
                          "farthest-corner"
                        ]
                      },
                      "value": true,
                      "type": {
                        "enum": [
                          "px",
                          "em",
                          "rem",
                          "vh",
                          "vw",
                          "vmin",
                          "vmax"
                        ]
                      }
                    },
                    "additionalProperties": false
                  },
                  "position": {
                    "type": "object",
                    "properties": {
                      "x": {
                        "type": "object",
                        "properties": {
                          "value": true,
                          "type": {
                            "enum": [
                              "px",
                              "em",
                              "rem",
                              "percentage",
                              "vh",
                              "vw",
                              "vmin",
                              "vmax"
                            ]
                          }
                        },
                        "additionalProperties": false
                      },
                      "y": {
                        "type": "object",
                        "properties": {
                          "value": true,
                          "type": {
                            "enum": [
                              "px",
                              "em",
                              "rem",
                              "percentage",
                              "vh",
                              "vw",
                              "vmin",
                              "vmax"
                            ]
                          }
                        },
                        "additionalProperties": false
                      }
                    },
                    "additionalProperties": false
                  },
                  "colorStops": {
                    "type": "array",
                    "items": {
                      "type": "object",
                      "properties": {
                        "size": {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "percentage",
                                "vh",
                                "vw",
                                "vmin",
                                "vmax"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        "color": {
                          "type": "string",
                          "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
                        },
                        "opacity": true
                      },
                      "additionalProperties": false
                    }
                  }
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        }
      },
      "additionalProperties": false
    },
    "GradientConicLayer": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "opacity": true,
        "fill": {
          "type": "object",
          "properties": {
            "type": {
              "type": "string",
              "enum": [
                "GradientConic"
              ]
            },
            "repeat": true,
            "blendMode": {
              "type": "string",
              "enum": [
                "normal",
                "multiply",
                "screen",
                "darken",
                "lighten",
                "overlay",
                "colorDodge",
                "colorBurn",
                "hardLight",
                "softLight",
                "difference",
                "exclusion",
                "hue",
                "saturation",
                "color",
                "luminosity"
              ]
            },
            "angle": true,
            "position": {
              "type": "object",
              "properties": {
                "x": {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "percentage",
                        "vh",
                        "vw",
                        "vmin",
                        "vmax"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "y": {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "percentage",
                        "vh",
                        "vw",
                        "vmin",
                        "vmax"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            "colorStops": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "size": {
                    "type": "object",
                    "properties": {
                      "value": true,
                      "type": {
                        "enum": [
                          "deg",
                          "percentage"
                        ]
                      }
                    },
                    "additionalProperties": false
                  },
                  "color": {
                    "type": "string",
                    "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
                  },
                  "opacity": true
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        }
      },
      "additionalProperties": false
    },
    "SolidColorLayer": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "opacity": true,
        "fill": {
          "type": "object",
          "properties": {
            "type": {
              "type": "string",
              "enum": [
                "SolidColor"
              ]
            },
            "color": {
              "type": "string",
              "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
            }
          },
          "additionalProperties": false
        }
      },
      "additionalProperties": false
    }
  },
  "discussions.json": {
    "$id": "urn:dm:schemas:discussions.json",
    "Discussions": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "discussions": {
          "type": "array",
          "items": true
        }
      },
      "additionalProperties": false
    },
    "RefArray": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "values": {
          "type": [
            "array"
          ],
          "items": true
        }
      },
      "additionalProperties": false
    },
    "VariantRelation": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "variants": {
          "type": "array",
          "items": true
        },
        "remoteVariants": {
          "type": "array",
          "items": true
        },
        "from": true,
        "to": true
      },
      "additionalProperties": false
    }
  },
  "document_data.json": {
    "$id": "urn:dm:schemas:document_data.json",
    "Direction": {
      "type": "string",
      "enum": [
        "ltr",
        "rtl",
        "inherit"
      ]
    },
    "AppVars": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "vars": {
          "type": "object",
          "additionalProperties": {
            "type": "object",
            "properties": {
              "value": true,
              "type": {
                "type": "string",
                "enum": [
                  "AppPartParam"
                ]
              }
            },
            "additionalProperties": false
          }
        },
        "appDefId": true
      },
      "additionalProperties": false
    },
    "SVGItem": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "svgId": true
      },
      "additionalProperties": false
    },
    "SVGReference": true,
    "BackgroundImage": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "url": true,
        "positionx": {
          "type": "string",
          "enum": [
            "left",
            "right",
            "center"
          ]
        },
        "imagesizew": true,
        "imagesizeh": true,
        "positiony": {
          "type": "string",
          "enum": [
            "top",
            "bottom",
            "center"
          ]
        },
        "width": true,
        "repeatx": {
          "type": "string",
          "enum": [
            "no_repeat",
            "repeat"
          ]
        },
        "repeaty": {
          "type": "string",
          "enum": [
            "no_repeat",
            "repeat"
          ]
        },
        "attachment": {
          "type": "string",
          "enum": [
            "scroll",
            "fixed",
            "inherit",
            "local"
          ]
        },
        "color": true
      },
      "additionalProperties": false
    },
    "BackgroundMedia": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "mediaRef": true,
        "mediaTransforms": {
          "type": "object",
          "properties": {
            "scale": true,
            "opacity": true
          },
          "additionalProperties": false
        },
        "overlayTransforms": {
          "type": "object",
          "properties": {
            "scale": true,
            "opacity": true
          },
          "additionalProperties": false
        },
        "color": {
          "oneOf": [
            {
              "enum": [
                "transparent",
                "noColor"
              ]
            },
            {
              "type": "string",
              "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
            }
          ]
        },
        "colorOpacity": true,
        "alignType": {
          "type": "string",
          "enum": [
            "top",
            "bottom",
            "left",
            "right",
            "center",
            "top_left",
            "top_right",
            "bottom_left",
            "bottom_right"
          ]
        },
        "fittingType": {
          "type": "string",
          "enum": [
            "fill",
            "fit",
            "stretch",
            "actual_size",
            "original_size",
            "tile",
            "tile_horizontal",
            "tile_vertical",
            "fit_and_tile",
            "legacy_tile",
            "legacy_tile_horizontal",
            "legacy_tile_vertical",
            "legacy_normal"
          ]
        },
        "scrollType": {
          "type": "string",
          "enum": [
            "none",
            "fixed",
            "scroll",
            "local",
            "parallax"
          ]
        },
        "showOverlayForMediaType": {
          "type": "string",
          "enum": [
            "all",
            "WixVideo",
            "Image"
          ]
        },
        "imageOverlay": true,
        "colorOverlay": {
          "type": "string",
          "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
        },
        "colorOverlayOpacity": true,
        "overlayBlending": {
          "type": "object",
          "properties": {
            "color": true,
            "opacity": true,
            "contrast": true,
            "saturate": true,
            "blendMode": {
              "type": "string",
              "enum": [
                "normal",
                "multiply",
                "screen",
                "darken",
                "lighten",
                "overlay",
                "colorDodge",
                "colorBurn",
                "hardLight",
                "softLight",
                "difference",
                "exclusion",
                "hue",
                "saturation",
                "color",
                "luminosity"
              ]
            }
          },
          "additionalProperties": false
        },
        "filterEffect": {
          "type": [
            "object",
            "null"
          ],
          "properties": {
            "effectType": {
              "type": "string",
              "enum": [
                "none",
                "normal",
                "ink",
                "kennedy",
                "feathered",
                "blur",
                "whistler",
                "3d",
                "blueray",
                "lighten",
                "darken",
                "pinkrinse",
                "redrum",
                "greenwash",
                "yellowstreak",
                "neonsky",
                "seaweed",
                "soledad",
                "sangria",
                "malibu",
                "candyfloss",
                "elmo",
                "unicorn",
                "kerouac",
                "koolaid",
                "hydra",
                "pixie",
                "nightrain",
                "bauhaus",
                "neptune",
                "orca",
                "manhattan",
                "goldie",
                "flamingo",
                "faded",
                "gotham",
                "hulk",
                "midnight",
                "lucille",
                "organic",
                "grayscale",
                "tvDuotone",
                "tvMonotoneDark",
                "tvMonotoneLight",
                "tvHue"
              ]
            },
            "brightness": true,
            "contrast": true,
            "saturation": true,
            "hue": true,
            "duotoneDark": true,
            "duotoneLight": true,
            "invert": true,
            "isCustom": true
          },
          "additionalProperties": false
        },
        "colorLayers": {
          "type": [
            "array",
            "null"
          ],
          "items": true
        }
      },
      "additionalProperties": false
    },
    "WixVideo": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "title": true,
        "alt": true,
        "videoId": true,
        "generatedPosters": {
          "type": "array",
          "items": true
        },
        "qualities": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "quality": true,
              "width": true,
              "height": true,
              "formats": {
                "type": "array",
                "items": true
              },
              "format": {
                "type": "string",
                "enum": [
                  "mp4",
                  "webm"
                ]
              },
              "url": true
            },
            "additionalProperties": false
          }
        },
        "adaptiveVideo": {
          "type": [
            "array",
            "null"
          ],
          "items": {
            "type": "object",
            "properties": {
              "format": {
                "type": "string",
                "enum": [
                  "hls",
                  "dash"
                ]
              },
              "url": true
            },
            "additionalProperties": false
          }
        },
        "posterImageRef": true,
        "duration": true,
        "fps": true,
        "hasAudio": true,
        "artist": {
          "type": "object",
          "properties": {
            "name": true,
            "id": true
          },
          "additionalProperties": false
        },
        "loop": true,
        "autoplay": true,
        "playbackSpeed": true,
        "preload": {
          "type": "string",
          "enum": [
            "auto",
            "metadata",
            "none"
          ]
        },
        "controls": {
          "type": "string",
          "enum": [
            "none",
            "full"
          ]
        },
        "mute": true,
        "opacity": true,
        "mediaFeatures": {
          "type": "array",
          "items": {
            "type": "string",
            "enum": [
              "alpha"
            ]
          }
        },
        "mask": {
          "anyOf": [
            {
              "type": "null"
            },
            {
              "type": "object",
              "properties": {
                "x": true,
                "y": true,
                "width": true,
                "height": true,
                "svgId": true,
                "flip": {
                  "type": "string",
                  "enum": [
                    "x",
                    "y",
                    "xy",
                    "none"
                  ]
                },
                "rotate": true,
                "mode": {
                  "type": "string",
                  "enum": [
                    "alpha",
                    "luminance"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        }
      },
      "additionalProperties": false
    },
    "WixVideoData": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "title": true,
        "alt": true,
        "videoId": true,
        "generatedPosters": {
          "type": "array",
          "items": true
        },
        "qualities": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "quality": true,
              "width": true,
              "height": true,
              "formats": {
                "type": "array",
                "items": true
              },
              "format": {
                "type": "string",
                "enum": [
                  "mp4",
                  "webm"
                ]
              },
              "url": true
            },
            "additionalProperties": false
          }
        },
        "adaptiveVideo": {
          "type": [
            "array",
            "null"
          ],
          "items": {
            "type": "object",
            "properties": {
              "format": {
                "type": "string",
                "enum": [
                  "hls",
                  "dash"
                ]
              },
              "url": true
            },
            "additionalProperties": false
          }
        },
        "posterImageRef": true,
        "duration": true,
        "fps": true,
        "hasAudio": true,
        "artist": {
          "type": "object",
          "properties": {
            "name": true,
            "id": true
          },
          "additionalProperties": false
        }
      },
      "additionalProperties": false
    },
    "Document": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "siteName": true,
        "usedFonts": {
          "type": "array",
          "items": true
        },
        "characterSets": {
          "type": "array",
          "items": true
        },
        "renderModifiers": true,
        "name": true,
        "mainPage": true,
        "mainPageId": true,
        "smSettings": {
          "type": [
            "object"
          ],
          "properties": {
            "socialLoginGoogleEnabled": true,
            "socialLoginFacebookEnabled": true,
            "privacyNoteType": {
              "type": "string",
              "enum": [
                "CHECKBOX",
                "NOTE"
              ]
            },
            "joinCommunityCheckedByDefault": true,
            "customSignUpPageId": true,
            "customSignInPageId": true,
            "customNoPermissionsPageId": true,
            "termsOfUse": {
              "type": "object",
              "properties": {
                "enabled": true,
                "link": {
                  "type": [
                    "null",
                    "string"
                  ],
                  "pattern": "^$|^#"
                }
              },
              "additionalProperties": false
            },
            "privacyPolicy": {
              "type": "object",
              "properties": {
                "enabled": true,
                "link": {
                  "type": [
                    "null",
                    "string"
                  ],
                  "pattern": "^$|^#"
                }
              },
              "additionalProperties": false
            },
            "codeOfConduct": {
              "type": "object",
              "properties": {
                "enabled": true,
                "link": {
                  "type": [
                    "null",
                    "string"
                  ],
                  "pattern": "^$|^#"
                }
              },
              "additionalProperties": false
            },
            "smFirstDialogLogin": true
          },
          "additionalProperties": false
        },
        "styleSettings": {
          "type": "object",
          "properties": {
            "stylesPerPage": true
          },
          "additionalProperties": false
        },
        "accessibilitySettings": {
          "type": "object",
          "properties": {
            "visualFocusDisabled": true,
            "skipToContent": true,
            "isRtlSupportEnabled": true,
            "currentSiteDirection": {
              "type": "string",
              "enum": [
                "ltr",
                "rtl"
              ]
            }
          },
          "additionalProperties": false
        },
        "mobileSettings": {
          "type": "object",
          "properties": {
            "animationsEnabled": true
          },
          "additionalProperties": false
        },
        "layoutSettings": {
          "type": "object",
          "properties": {
            "useDesktopSectionsLayout": true,
            "isFluid": true,
            "headerToPagesGap": true,
            "pagesToFooterGap": true,
            "mechanism": {
              "type": [
                "string"
              ],
              "enum": [
                "mesh",
                "anchors"
              ]
            },
            "soapCompsAroundPagesContainer": true
          },
          "additionalProperties": false
        },
        "appStudioData": true,
        "ignoreBottomBottomAnchors": true,
        "anchorLockThreshold": true,
        "supportMobile": true,
        "autoDomReorder": true,
        "appsInstallState": true,
        "usesNewAnimations": true
      },
      "additionalProperties": false
    },
    "AccessibilitySettings": {
      "type": "object",
      "properties": {
        "visualFocusDisabled": true,
        "skipToContent": true,
        "isRtlSupportEnabled": true,
        "currentSiteDirection": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl"
          ]
        }
      },
      "additionalProperties": false
    },
    "MobileSettings": {
      "type": "object",
      "properties": {
        "animationsEnabled": true
      },
      "additionalProperties": false
    },
    "LayoutSettings": {
      "type": "object",
      "properties": {
        "useDesktopSectionsLayout": true,
        "isFluid": true,
        "headerToPagesGap": true,
        "pagesToFooterGap": true,
        "mechanism": {
          "type": [
            "string"
          ],
          "enum": [
            "mesh",
            "anchors"
          ]
        },
        "soapCompsAroundPagesContainer": true
      },
      "additionalProperties": false
    },
    "StyleSettings": {
      "type": "object",
      "properties": {
        "stylesPerPage": true
      },
      "additionalProperties": false
    },
    "SiteMembersData": {
      "type": "object",
      "properties": {
        "socialLoginGoogleEnabled": true,
        "socialLoginFacebookEnabled": true,
        "privacyNoteType": {
          "type": "string",
          "enum": [
            "CHECKBOX",
            "NOTE"
          ]
        },
        "joinCommunityCheckedByDefault": true,
        "customSignUpPageId": true,
        "customSignInPageId": true,
        "customNoPermissionsPageId": true,
        "termsOfUse": {
          "type": "object",
          "properties": {
            "enabled": true,
            "link": {
              "type": [
                "null",
                "string"
              ],
              "pattern": "^$|^#"
            }
          },
          "additionalProperties": false
        },
        "privacyPolicy": {
          "type": "object",
          "properties": {
            "enabled": true,
            "link": {
              "type": [
                "null",
                "string"
              ],
              "pattern": "^$|^#"
            }
          },
          "additionalProperties": false
        },
        "codeOfConduct": {
          "type": "object",
          "properties": {
            "enabled": true,
            "link": {
              "type": [
                "null",
                "string"
              ],
              "pattern": "^$|^#"
            }
          },
          "additionalProperties": false
        },
        "smFirstDialogLogin": true
      },
      "additionalProperties": false
    },
    "AppStudioData": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "name": true,
        "description": true,
        "widgets": {
          "type": [
            "array",
            "null"
          ],
          "items": true
        },
        "codePackages": {
          "type": [
            "array",
            "null"
          ],
          "items": true
        },
        "panels": {
          "type": [
            "array",
            "null"
          ],
          "items": true
        },
        "dependencies": {
          "type": [
            "null",
            "array"
          ],
          "items": {
            "type": "object",
            "properties": {
              "appDefId": true,
              "dependencyData": {
                "type": "array",
                "items": {
                  "type": "string",
                  "enum": [
                    "PROVISION_ONLY_INSTALLATION",
                    "NOTIFY_USER_ON_DEPENDENCY",
                    "IS_BUNDLE"
                  ]
                }
              }
            },
            "additionalProperties": false
          }
        },
        "dashboards": {
          "type": [
            "array",
            "null"
          ],
          "items": true
        },
        "customDefinitions": {
          "type": [
            "array",
            "null"
          ],
          "items": true
        },
        "ssrCache": true
      },
      "additionalProperties": false
    },
    "CodePackagesDescriptor": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "displayName": true,
        "name": true,
        "description": true
      },
      "additionalProperties": false
    },
    "WidgetPropertyDefinition": {
      "additionalProperties": true
    },
    "CustomDefinitionDescriptor": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "structure": {
          "type": "object",
          "additionalProperties": {
            "type": "object",
            "properties": {
              "$id": true,
              "type": true,
              "title": true,
              "description": true,
              "properties": {
                "type": "object",
                "additionalProperties": {
                  "additionalProperties": true
                }
              },
              "default": true,
              "propertiesOrder": {
                "type": "array",
                "items": true
              }
            },
            "additionalProperties": false
          }
        }
      },
      "additionalProperties": false
    },
    "WidgetDescriptor": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "name": true,
        "devCenterWidgetId": true,
        "devCenterEditorReactComponentId": true,
        "kind": {
          "type": [
            "string",
            "null"
          ],
          "enum": [
            "container",
            "section"
          ]
        },
        "panels": {
          "type": [
            "array"
          ],
          "items": true
        },
        "defaultSize": {
          "type": [
            "object",
            "null"
          ],
          "properties": {
            "width": true,
            "height": true
          },
          "additionalProperties": false
        },
        "rootCompId": true,
        "variations": {
          "type": [
            "array",
            "null"
          ],
          "items": true
        },
        "presets": {
          "type": [
            "array",
            "null"
          ],
          "items": true
        },
        "plugin": {
          "type": "object",
          "properties": {
            "placements": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "appDefinitionId": true,
                  "widgetId": true,
                  "slotId": true
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "containedWidgets": {
          "type": "array",
          "items": true
        },
        "widgetApi": {
          "type": "object",
          "properties": {
            "functions": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "name": true,
                  "description": true,
                  "params": {
                    "type": "array",
                    "items": {
                      "type": "object",
                      "properties": {
                        "name": true,
                        "description": true
                      },
                      "additionalProperties": false
                    }
                  },
                  "returnsDescription": true
                },
                "additionalProperties": false
              }
            },
            "propertiesSchemas": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "structure": {
                    "type": "object",
                    "additionalProperties": {
                      "additionalProperties": true
                    }
                  }
                },
                "additionalProperties": false
              }
            },
            "events": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "name": true,
                  "description": true,
                  "args": {
                    "type": "array",
                    "items": {
                      "properties": {
                        "name": true
                      },
                      "additionalProperties": false
                    }
                  }
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "structureRef": {
          "type": "object",
          "properties": {
            "pageId": true,
            "rootCompId": true
          },
          "additionalProperties": false
        },
        "compType": true
      },
      "additionalProperties": false
    },
    "DashboardDescriptor": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "rootCompId": true,
        "title": true,
        "routePath": true,
        "hideInSidebar": true,
        "activeSidebarPageId": true,
        "isRoutePathConnectedToTitle": true
      },
      "additionalProperties": false
    },
    "PanelDescriptor": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "name": true,
        "devCenterPanelId": true,
        "title": true,
        "kind": {
          "type": "string",
          "enum": [
            "settings"
          ]
        },
        "helpId": true,
        "pageUrl": true,
        "height": true,
        "defaultSize": {
          "type": "object",
          "properties": {
            "width": true,
            "height": true
          },
          "additionalProperties": false
        },
        "rootCompId": true
      },
      "additionalProperties": false
    },
    "VariationDescriptor": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "name": true,
        "rootCompId": true
      },
      "additionalProperties": false
    },
    "PresetDescriptor": {
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:defaultSize\\/width|defaultSize\\/height)$"
                  },
                  "variableId": true
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": true,
        "id": true,
        "metaData": true,
        "presetId": true,
        "name": true,
        "defaultSize": {
          "type": "object",
          "properties": {
            "width": {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            "height": {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            }
          },
          "additionalProperties": false
        }
      },
      "additionalProperties": false
    },
    "FlatTheme": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "THEME_DIRECTORY": {
          "type": "string",
          "pattern": "^[\\/\\-|0-9|a-z|A-Z]*$"
        },
        "BG_DIRECTORY": {
          "type": "string",
          "pattern": "^[\\/\\-|0-9|a-z|A-Z]*$"
        },
        "CONTACT_DIRECTORY": {
          "type": "string",
          "pattern": "^[\\/\\-|0-9|a-z|A-Z]*$"
        },
        "NETWORKS_DIRECTORY": {
          "type": "string",
          "pattern": "^[\\/\\-|0-9|a-z|A-Z]*$"
        },
        "EXTERNAL_LINKS_DIRECTORY": {
          "type": "string",
          "pattern": "^[\\/\\-|0-9|a-z|A-Z]*$"
        },
        "PAGES_DIRECTORY": {
          "type": "string",
          "pattern": "^[\\/\\-|0-9|a-z|A-Z]*$"
        },
        "WEB_THEME_DIRECTORY": {
          "type": "string",
          "pattern": "^[\\/\\-|0-9|a-z|A-Z]*$"
        },
        "BASE_THEME_DIRECTORY": {
          "type": "string",
          "pattern": "^[\\/\\-|0-9|a-z|A-Z]*$"
        },
        "font": true,
        "bgId": true,
        "bgSize": true,
        "bgType": true,
        "siteBg": true,
        "mobileBg": true,
        "siteBgColor": {
          "type": "string",
          "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
        },
        "headerTextColor": {
          "type": "string",
          "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
        },
        "headerBgColor": {
          "type": "string",
          "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
        },
        "textColor": {
          "type": "string",
          "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
        },
        "areaBgColor": {
          "type": "string",
          "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
        },
        "iconBgColor": {
          "type": "string",
          "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
        },
        "borderColor": {
          "type": "string",
          "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
        },
        "fontHeader": true,
        "fontTitle": true,
        "fontSubTitle": true,
        "fontButton": true,
        "fontText": true,
        "fontSmallText": true,
        "borderContainer": {
          "type": "string",
          "pattern": "^$|^(0|([0-9]*([.][0-9]+){0,1}(px|em)[\\s]*){1,4})([Ss][Oo][Ll][Ii][Dd]|[Dd][Aa][Ss][Hh][Ee][Dd]|[Dd][Oo][Tt][Tt][Ee][Dd]|[Dd][Oo][Uu][Bb][Ll][Ee]|[Gg][Rr][Oo][Oo][Vv][Ee]|[Ii][Nn][Ss][Ee][Tt]|[Nn][Oo][Nn][Ee]|[Oo][Uu][Tt][Ss][Ee][Tt]|[Rr][Ii][Dd][Gg][Ee]){0,1}[\\s]*([{\\[]color_([0-9]{1,2}|100)[}\\]]|(#(([0-9|a-f]){3}){1,2}){0,1})|\\[borderColor\\]?$"
        },
        "borderThumb": {
          "type": "string",
          "pattern": "^$|^(0|([0-9]*([.][0-9]+){0,1}(px|em)[\\s]*){1,4})([Ss][Oo][Ll][Ii][Dd]|[Dd][Aa][Ss][Hh][Ee][Dd]|[Dd][Oo][Tt][Tt][Ee][Dd]|[Dd][Oo][Uu][Bb][Ll][Ee]|[Gg][Rr][Oo][Oo][Vv][Ee]|[Ii][Nn][Ss][Ee][Tt]|[Nn][Oo][Nn][Ee]|[Oo][Uu][Tt][Ss][Ee][Tt]|[Rr][Ii][Dd][Gg][Ee]){0,1}[\\s]*([{\\[]color_([0-9]{1,2}|100)[}\\]]|(#(([0-9|a-f]){3}){1,2}){0,1})|\\[borderColor\\]?$"
        },
        "borderButton": {
          "type": "string",
          "pattern": "^$|^(0|([0-9]*([.][0-9]+){0,1}(px|em)[\\s]*){1,4})([Ss][Oo][Ll][Ii][Dd]|[Dd][Aa][Ss][Hh][Ee][Dd]|[Dd][Oo][Tt][Tt][Ee][Dd]|[Dd][Oo][Uu][Bb][Ll][Ee]|[Gg][Rr][Oo][Oo][Vv][Ee]|[Ii][Nn][Ss][Ee][Tt]|[Nn][Oo][Nn][Ee]|[Oo][Uu][Tt][Ss][Ee][Tt]|[Rr][Ii][Dd][Gg][Ee]){0,1}[\\s]*([{\\[]color_([0-9]{1,2}|100)[}\\]]|(#(([0-9|a-f]){3}){1,2}){0,1})|\\[borderColor\\]?$"
        },
        "borderIcon": {
          "type": "string",
          "pattern": "^$|^(0|([0-9]*([.][0-9]+){0,1}(px|em)[\\s]*){1,4})([Ss][Oo][Ll][Ii][Dd]|[Dd][Aa][Ss][Hh][Ee][Dd]|[Dd][Oo][Tt][Tt][Ee][Dd]|[Dd][Oo][Uu][Bb][Ll][Ee]|[Gg][Rr][Oo][Oo][Vv][Ee]|[Ii][Nn][Ss][Ee][Tt]|[Nn][Oo][Nn][Ee]|[Oo][Uu][Tt][Ss][Ee][Tt]|[Rr][Ii][Dd][Gg][Ee]){0,1}[\\s]*([{\\[]color_([0-9]{1,2}|100)[}\\]]|(#(([0-9|a-f]){3}){1,2}){0,1})|\\[borderColor\\]?$"
        },
        "radiusContainer": {
          "type": "string",
          "pattern": "^$|^\\d*(.\\d+)?$|^(\\d+(.\\d+)?(em|px)|0(.0+)?)( +(\\d+(.\\d+)?(em|px)|0(.0+)?)){0,3}$"
        },
        "radiusThumb": {
          "type": "string",
          "pattern": "^$|^\\d*(.\\d+)?$|^(\\d+(.\\d+)?(em|px)|0(.0+)?)( +(\\d+(.\\d+)?(em|px)|0(.0+)?)){0,3}$"
        },
        "radiusButton": {
          "type": "string",
          "pattern": "^$|^\\d*(.\\d+)?$|^(\\d+(.\\d+)?(em|px)|0(.0+)?)( +(\\d+(.\\d+)?(em|px)|0(.0+)?)){0,3}$"
        },
        "radiusIcon": {
          "type": "string",
          "pattern": "^$|^\\d*(.\\d+)?$|^(\\d+(.\\d+)?(em|px)|0(.0+)?)( +(\\d+(.\\d+)?(em|px)|0(.0+)?)){0,3}$"
        },
        "padding1": {
          "type": "string",
          "pattern": "^$|^\\d*(.\\d+)?$|^(\\d+(.\\d+)?(em|px)|0(.0+)?)( +(\\d+(.\\d+)?(em|px)|0(.0+)?)){0,3}$"
        },
        "padding2": {
          "type": "string",
          "pattern": "^$|^\\d*(.\\d+)?$|^(\\d+(.\\d+)?(em|px)|0(.0+)?)( +(\\d+(.\\d+)?(em|px)|0(.0+)?)){0,3}$"
        },
        "padding3": {
          "type": "string",
          "pattern": "^$|^\\d*(.\\d+)?$|^(\\d+(.\\d+)?(em|px)|0(.0+)?)( +(\\d+(.\\d+)?(em|px)|0(.0+)?)){0,3}$"
        },
        "iconSize": {
          "type": "string",
          "pattern": "^\\d+(.\\d+)?(em|px)?$"
        },
        "bulletSize": {
          "type": "string",
          "pattern": "^\\d+(.\\d+)?(em|px)?$"
        },
        "headerSpacing": {
          "type": "string",
          "pattern": "^\\d+(.\\d+)?(em|px)?$"
        },
        "componentSpacing": {
          "type": "string",
          "pattern": "^\\d+(.\\d+)?(em|px)?$"
        },
        "itemSpacing": {
          "type": "string",
          "pattern": "^\\d+(.\\d+)?(em|px)?$"
        },
        "thumbSpacing": {
          "type": "string",
          "pattern": "^\\d+(.\\d+)?(em|px)?$"
        },
        "iconSpacing": {
          "type": "string",
          "pattern": "^\\d+(.\\d+)?(em|px)?$"
        }
      },
      "additionalProperties": false
    },
    "Image": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "link": {
          "type": [
            "null",
            "string"
          ],
          "pattern": "^$|^#"
        },
        "title": true,
        "name": true,
        "uri": {
          "type": "string",
          "pattern": "^[\\w:~\\-_+%.\\/,\\?=\\()]+$"
        },
        "description": true,
        "height": true,
        "width": true,
        "borderSize": true,
        "alt": true,
        "decorative": true,
        "hasAnimation": true,
        "originalImageDataRef": true,
        "opacity": true,
        "crop": {
          "oneOf": [
            {
              "type": "null"
            },
            {
              "type": "object",
              "properties": {
                "x": true,
                "y": true,
                "width": true,
                "height": true,
                "svgId": true,
                "flip": {
                  "type": "string",
                  "enum": [
                    "x",
                    "y",
                    "xy",
                    "none"
                  ]
                },
                "rotate": true
              },
              "additionalProperties": false
            }
          ]
        },
        "upscaleMethod": true,
        "focalPoint": {
          "oneOf": [
            {
              "type": "null"
            },
            {
              "type": "object",
              "properties": {
                "x": true,
                "y": true
              },
              "additionalProperties": false
            }
          ]
        },
        "artist": {
          "type": "object",
          "properties": {
            "name": true,
            "id": true
          },
          "additionalProperties": false
        },
        "a11y": true
      },
      "additionalProperties": false
    },
    "ImageA11y": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "label": true
      },
      "additionalProperties": false
    },
    "ImageReference": true,
    "GlobalImageQuality": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "quality": true,
        "unsharpMask": {
          "type": "object",
          "properties": {
            "radius": true,
            "amount": true,
            "threshold": true
          },
          "additionalProperties": false
        }
      },
      "additionalProperties": false
    },
    "ImageQuality": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "quality": true,
        "unsharpMask": {
          "type": "object",
          "properties": {
            "radius": true,
            "amount": true,
            "threshold": true
          },
          "additionalProperties": false
        }
      },
      "additionalProperties": false
    },
    "ClassicSectionA11y": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "label": true,
        "tabindex": true,
        "live": {
          "type": "string",
          "enum": [
            "polite",
            "assertive"
          ]
        },
        "role": {
          "type": "string",
          "enum": [
            "heading",
            "status",
            "alert"
          ]
        },
        "atomic": true,
        "hidden": true,
        "current": {
          "type": "string",
          "enum": [
            "step",
            "page",
            "true",
            "false"
          ]
        },
        "level": true
      },
      "additionalProperties": false
    },
    "StripColumnsContainerA11y": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "label": true,
        "tabindex": true,
        "live": {
          "type": "string",
          "enum": [
            "polite",
            "assertive"
          ]
        },
        "role": {
          "type": "string",
          "enum": [
            "heading",
            "status",
            "alert"
          ]
        },
        "atomic": true,
        "hidden": true,
        "current": {
          "type": "string",
          "enum": [
            "step",
            "page",
            "true",
            "false"
          ]
        },
        "level": true
      },
      "additionalProperties": false
    },
    "StripColumnsContainer": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "a11y": true,
        "itemsDirection": {
          "type": "string",
          "enum": [
            "rtl",
            "ltr"
          ]
        },
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        }
      },
      "additionalProperties": false
    },
    "ClassicSection": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "a11y": true
      },
      "additionalProperties": false
    },
    "StripContainer": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "background": true
      },
      "additionalProperties": false
    },
    "ImageList": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "items": {
          "type": [
            "array",
            "null"
          ],
          "items": true
        },
        "direction": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        }
      },
      "additionalProperties": false
    },
    "Link": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "linkType": {
          "type": "string",
          "enum": [
            "SMS",
            "CALL",
            "SKYPE",
            "MAP",
            "EMAIL",
            "FACEBOOK",
            "FLICKR",
            "BLOGGER",
            "MYSPACE",
            "LINKEDIN",
            "TWITTER",
            "TUMBLR",
            "YOUTUBE",
            "VIMEO",
            "PAGE",
            "FREE_LINK",
            "TEXT",
            "DELICIOUS",
            "WEBSITE",
            "DOCUMENT",
            "ADMIN_LOGIN",
            "LOGIN"
          ]
        },
        "href": true,
        "text": true,
        "target": true,
        "icon": true
      },
      "additionalProperties": false
    },
    "TextLink": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "linkType": {
          "type": "string",
          "enum": [
            "SMS",
            "CALL",
            "SKYPE",
            "MAP",
            "EMAIL",
            "FACEBOOK",
            "FLICKR",
            "BLOGGER",
            "MYSPACE",
            "LINKEDIN",
            "TWITTER",
            "TUMBLR",
            "YOUTUBE",
            "VIMEO",
            "PAGE",
            "FREE_LINK",
            "TEXT",
            "DELICIOUS",
            "WEBSITE",
            "DOCUMENT",
            "ADMIN_LOGIN",
            "LOGIN"
          ]
        },
        "href": true,
        "text": true,
        "target": true,
        "icon": true
      },
      "additionalProperties": false
    },
    "AnchorLink": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "anchorName": true,
        "anchorDataId": {
          "anyOf": [
            true,
            {
              "enum": [
                "SCROLL_TO_TOP"
              ]
            }
          ]
        },
        "pageId": true,
        "rel": {
          "type": "array",
          "items": {
            "type": "string",
            "enum": [
              "nofollow",
              "noopener",
              "noreferrer",
              "sponsored"
            ]
          }
        }
      },
      "additionalProperties": false
    },
    "DocumentLink": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "docId": true,
        "name": true,
        "indexable": true
      },
      "additionalProperties": false
    },
    "PhoneLink": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "phoneNumber": true
      },
      "additionalProperties": false
    },
    "WhatsAppLink": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "phoneNumber": true
      },
      "additionalProperties": false
    },
    "AddressLink": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "address": true
      },
      "additionalProperties": false
    },
    "EmailLink": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "recipient": true,
        "subject": true,
        "body": true
      },
      "additionalProperties": false
    },
    "FormSubmitButtonLink": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true
      },
      "additionalProperties": false
    },
    "ExternalLink": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "url": {
          "allOf": [
            true,
            {
              "not": {
                "type": "string",
                "pattern": ".*script://.*"
              }
            }
          ]
        },
        "target": {
          "type": "string",
          "enum": [
            "_self",
            "_blank"
          ]
        },
        "rel": {
          "type": "array",
          "items": {
            "type": "string",
            "enum": [
              "nofollow",
              "noopener",
              "noreferrer",
              "sponsored"
            ]
          }
        }
      },
      "additionalProperties": false
    },
    "LinkRelAttribute": {
      "type": "array",
      "items": {
        "type": "string",
        "enum": [
          "nofollow",
          "noopener",
          "noreferrer",
          "sponsored"
        ]
      }
    },
    "DynamicPageLink": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "routerId": true,
        "innerRoute": true,
        "anchorDataId": true,
        "isTpaRoute": true,
        "target": {
          "type": "string",
          "enum": [
            "_self",
            "_blank"
          ]
        },
        "rel": {
          "type": "array",
          "items": {
            "type": "string",
            "enum": [
              "nofollow",
              "noopener",
              "noreferrer",
              "sponsored"
            ]
          }
        }
      },
      "additionalProperties": false
    },
    "TpaPageLink": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "itemTypeIdentifier": true,
        "itemId": true,
        "pageId": true,
        "appDefinitionId": true,
        "path": true,
        "target": {
          "type": "string",
          "enum": [
            "_self",
            "_blank"
          ]
        },
        "rel": {
          "type": "array",
          "items": {
            "type": "string",
            "enum": [
              "nofollow",
              "noopener",
              "noreferrer",
              "sponsored"
            ]
          }
        }
      },
      "additionalProperties": false
    },
    "LoginToWixLink": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "postLoginUrl": true,
        "postSignupUrl": true,
        "dialog": {
          "type": "string",
          "enum": [
            "createUser",
            "login",
            "showLogin"
          ]
        },
        "sendMail": true,
        "mailTemplate": true,
        "userColor": true,
        "loginCompName": true
      },
      "additionalProperties": false
    },
    "PageLink": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "pageId": true,
        "target": {
          "type": "string",
          "enum": [
            "_self",
            "_blank"
          ]
        },
        "rel": {
          "type": "array",
          "items": {
            "type": "string",
            "enum": [
              "nofollow",
              "noopener",
              "noreferrer",
              "sponsored"
            ]
          }
        }
      },
      "additionalProperties": false
    },
    "MediaItem": {
      "type": "object",
      "properties": {
        "componentType": true,
        "dateCreated": true,
        "description": true,
        "fileName": true,
        "fileSize": true,
        "height": true,
        "width": true,
        "iconURL": true,
        "mediaType": true,
        "mimeType": true,
        "originalFileName": true,
        "sourceURL": true,
        "tags": true,
        "title": true,
        "version": true
      },
      "additionalProperties": false
    },
    "MediaRichText": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "text": true,
        "stylesMapId": true,
        "linkList": {
          "type": [
            "array",
            "null"
          ],
          "items": true
        },
        "componentDataList": {
          "type": [
            "array",
            "null"
          ],
          "items": true
        }
      },
      "additionalProperties": false
    },
    "Page": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "title": true,
        "hideTitle": true,
        "icon": true,
        "windowTitle": true,
        "descriptionSEO": true,
        "advancedSeoData": true,
        "metaKeywordsSEO": true,
        "pageTitleSEO": true,
        "pageUriSEO": true,
        "hidePage": true,
        "underConstruction": true,
        "tpaApplicationId": true,
        "appDefinitionId": true,
        "managingAppDefId": true,
        "tpaPageId": true,
        "parentPageId": true,
        "pageSecurity": true,
        "indexable": true,
        "mobileHidePage": true,
        "pageBackgrounds": {
          "type": "object",
          "properties": {
            "desktop": {
              "type": "object",
              "properties": {
                "custom": true,
                "mediaSizing": {
                  "type": "string",
                  "enum": [
                    "document",
                    "viewport"
                  ]
                },
                "ref": true,
                "isPreset": true
              },
              "additionalProperties": false
            },
            "mobile": {
              "type": "object",
              "properties": {
                "custom": true,
                "mediaSizing": {
                  "type": "string",
                  "enum": [
                    "document",
                    "viewport"
                  ]
                },
                "ref": true,
                "isPreset": true
              },
              "additionalProperties": false
            }
          },
          "additionalProperties": false
        },
        "isLandingPage": true,
        "isMobileLandingPage": true,
        "isPopup": true,
        "translationData": {
          "type": "object",
          "properties": {
            "uriSEOTranslated": true
          },
          "additionalProperties": false
        },
        "ogImage": true,
        "ogImageRef": true,
        "ignoreBottomBottomAnchors": true,
        "cacheMode": {
          "enum": [
            "auto",
            "manual",
            "disabled"
          ]
        },
        "cacheMaxAgeHours": true
      },
      "additionalProperties": false
    },
    "Text": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "text": true
      },
      "additionalProperties": false
    },
    "RichText": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "text": true,
        "defaultStyle": true
      },
      "additionalProperties": false
    },
    "RichTextImage": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "text": true,
        "image": true
      },
      "additionalProperties": false
    },
    "BaseInput": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "name": true,
        "formGroup": true
      },
      "additionalProperties": false
    },
    "BaseTextInput": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "value": true,
        "name": true,
        "formGroup": true
      },
      "additionalProperties": false
    },
    "TextInputA11y": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "label": true,
        "tabindex": true,
        "invalid": true,
        "multiline": true,
        "autocomplete": true,
        "live": {
          "type": "string",
          "enum": [
            "polite",
            "assertive"
          ]
        },
        "atomic": true
      },
      "additionalProperties": false
    },
    "TextInput": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "labelDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "inputDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "errorDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "textType": {
          "type": "string",
          "enum": [
            "text",
            "email",
            "url",
            "number",
            "tel",
            "password"
          ]
        },
        "maxLength": true,
        "min": true,
        "max": true,
        "pattern": true,
        "phoneFormat": {
          "type": [
            "string",
            "null"
          ],
          "pattern": "^#*(((#+-)*)#+$)"
        },
        "label": true,
        "placeholder": true,
        "a11y": true,
        "prefix": true,
        "step": true,
        "autoComplete": true,
        "value": true,
        "name": true,
        "formGroup": true
      },
      "additionalProperties": false
    },
    "TextAreaInput": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "labelDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "inputDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "errorDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "maxLength": true,
        "label": true,
        "placeholder": true,
        "value": true,
        "name": true,
        "formGroup": true
      },
      "additionalProperties": false
    },
    "CheckboxInput": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "checked": true,
        "linkLabel": true,
        "link": {
          "type": [
            "null",
            "string"
          ],
          "pattern": "^$|^#"
        },
        "label": true,
        "indeterminate": true,
        "direction": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "value": true,
        "name": true,
        "formGroup": true
      },
      "additionalProperties": false
    },
    "DateItem": true,
    "DateString": true,
    "DateRange": {
      "type": "object",
      "properties": {
        "startDate": true,
        "endDate": true
      },
      "additionalProperties": false
    },
    "DateRanges": {
      "type": "array",
      "items": {
        "type": "object",
        "properties": {
          "startDate": true,
          "endDate": true
        },
        "additionalProperties": false
      }
    },
    "DatePicker": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "labelDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "inputDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "disabledDates": {
          "type": "array",
          "items": true
        },
        "disabledDaysOfWeek": {
          "type": "array",
          "items": {
            "type": [
              "number"
            ],
            "enum": [
              0,
              1,
              2,
              3,
              4,
              5,
              6
            ]
          }
        },
        "minDate": true,
        "maxDate": true,
        "allowPastDates": true,
        "allowFutureDates": true,
        "label": true,
        "placeholder": true,
        "enabledDateRanges": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "startDate": true,
              "endDate": true
            },
            "additionalProperties": false
          }
        },
        "disabledDateRanges": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "startDate": true,
              "endDate": true
            },
            "additionalProperties": false
          }
        },
        "name": true,
        "formGroup": true
      },
      "additionalProperties": false
    },
    "Theme": {
      "type": [
        "object",
        "null"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "properties": true
      },
      "additionalProperties": false
    },
    "TwitterFollow": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "accountToFollow": true
      },
      "additionalProperties": false
    },
    "TwitterTweet": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "defaultText": true,
        "accountToFollow": true,
        "isHttpsEnabled": true,
        "urlFormat": {
          "type": "string",
          "enum": [
            "hashBang",
            "slash"
          ]
        }
      },
      "additionalProperties": false
    },
    "MobileMetaData": {
      "type": "object",
      "properties": {
        "adaptiveMobileOn": true
      },
      "additionalProperties": false
    },
    "Preloader": {
      "type": "object",
      "properties": {
        "enabled": true,
        "uri": true
      },
      "additionalProperties": false
    },
    "ContactInfo": {
      "type": "object",
      "properties": {
        "companyName": true,
        "phone": true,
        "email": true,
        "address": true,
        "fax": true
      },
      "additionalProperties": false
    },
    "SocialLink": {
      "type": "object",
      "properties": {
        "id": {
          "type": "string",
          "enum": [
            "facebook",
            "twitter",
            "pinterest",
            "google_plus",
            "tumblr",
            "blogger",
            "linkedin",
            "youtube",
            "vimeo",
            "flickr"
          ]
        },
        "url": true
      },
      "additionalProperties": false
    },
    "QuickActions": {
      "type": "object",
      "properties": {
        "colorScheme": {
          "type": "string",
          "enum": [
            "dark",
            "light"
          ]
        },
        "configuration": {
          "type": "object",
          "properties": {
            "addressEnabled": true,
            "emailEnabled": true,
            "navigationMenuEnabled": true,
            "phoneEnabled": true,
            "quickActionsMenuEnabled": true,
            "socialLinksEnabled": true
          },
          "additionalProperties": false
        },
        "socialLinks": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "id": {
                "type": "string",
                "enum": [
                  "facebook",
                  "twitter",
                  "pinterest",
                  "google_plus",
                  "tumblr",
                  "blogger",
                  "linkedin",
                  "youtube",
                  "vimeo",
                  "flickr"
                ]
              },
              "url": true
            },
            "additionalProperties": false
          }
        }
      },
      "additionalProperties": false
    },
    "QuickActionBarItem": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "link": {
          "type": [
            "null",
            "string"
          ],
          "pattern": "^$|^#"
        },
        "itemType": true,
        "text": true,
        "icon": true
      },
      "additionalProperties": false
    },
    "SiteSettings": {
      "type": "object",
      "properties": {
        "siteName": true,
        "siteTitleSEO": true,
        "siteDescriptionSEO": true,
        "keywordsSEO": true,
        "allowSEFindSite": true,
        "favicon": true,
        "thumbnail": true,
        "googleAnalyticsID": true,
        "fbAdminsUserId": true,
        "suppressTrackingCookies": true
      },
      "additionalProperties": false
    },
    "AdvancedSeoSettingsDialog": {
      "type": "object",
      "properties": {
        "userMetaTags": true
      },
      "additionalProperties": false
    },
    "Anchor": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "name": true,
        "compId": true,
        "urlFragment": true
      },
      "additionalProperties": false
    },
    "BasicMenuItem": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "link": {
          "type": [
            "null",
            "string"
          ],
          "pattern": "^$|^#"
        },
        "items": {
          "type": [
            "array",
            "null"
          ],
          "items": true
        },
        "slot": true,
        "label": true,
        "isVisible": true,
        "isVisibleMobile": true,
        "displayCount": true,
        "iconRef": true
      },
      "additionalProperties": false
    },
    "CustomMenu": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "name": true,
        "menuType": true,
        "syncWithPages": true,
        "appId": true,
        "appDefinitionId": true,
        "items": {
          "type": [
            "array",
            "null"
          ],
          "items": true
        }
      },
      "additionalProperties": false
    },
    "CustomMenusCollection": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "menus": {
          "type": [
            "array",
            "null"
          ],
          "items": true
        }
      },
      "additionalProperties": false
    },
    "CustomMenuDataRef": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "menuRef": true,
        "a11y": true,
        "direction": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "itemDirection": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "submenuDirection": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "submenuSubItemDirection": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        }
      },
      "additionalProperties": false
    },
    "CustomMenuDataRefA11y": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "label": true
      },
      "additionalProperties": false
    },
    "Menu": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "items": {
          "type": [
            "array",
            "null"
          ],
          "items": true
        }
      },
      "additionalProperties": false
    },
    "FacebookLikeBox": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "facebookPageId": true,
        "showFaces": true,
        "colorScheme": {
          "type": "string",
          "enum": [
            "light",
            "dark"
          ]
        },
        "showStream": true,
        "showBorder": true,
        "showHeader": true
      },
      "additionalProperties": false
    },
    "ImageButtonA11y": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "label": true
      },
      "additionalProperties": false
    },
    "ImageButton": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "link": {
          "type": [
            "null",
            "string"
          ],
          "pattern": "^$|^#"
        },
        "alt": true,
        "a11y": true,
        "defaultImage": true,
        "hoverImage": true,
        "activeImage": true
      },
      "additionalProperties": false
    },
    "NumericStepper": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "value": true
      },
      "additionalProperties": false
    },
    "PinItPinWidget": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "pinId": true
      },
      "additionalProperties": false
    },
    "PinterestPinIt": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "uri": true,
        "description": true,
        "isHttpsEnabled": true,
        "urlFormat": {
          "type": "string",
          "enum": [
            "hashBang",
            "slash"
          ]
        }
      },
      "additionalProperties": false
    },
    "SingleAudioPlayer": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "uri": true,
        "originalFileName": true,
        "artist": true,
        "track": true
      },
      "additionalProperties": false
    },
    "SkypeCallButton": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "skypeName": true,
        "buttonType": {
          "type": "string",
          "enum": [
            "call",
            "chat"
          ]
        }
      },
      "additionalProperties": false
    },
    "SpotifyFollow": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "uri": true
      },
      "additionalProperties": false
    },
    "SpotifyPlayer": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "uri": true
      },
      "additionalProperties": false
    },
    "SubscribeForm": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "toEmailAddress": true,
        "bccEmailAddress": true,
        "firstNameFieldLabel": true,
        "lastNameFieldLabel": true,
        "emailFieldLabel": true,
        "phoneFieldLabel": true,
        "subscribeFormTitle": true,
        "textDirection": {
          "type": "string",
          "enum": [
            "left",
            "right"
          ]
        },
        "submitButtonLabel": true,
        "successMessage": true,
        "errorMessage": true,
        "validationErrorMessage": true,
        "onSubmitBehavior": {
          "type": "string",
          "enum": [
            "message",
            "link"
          ]
        },
        "link": {
          "type": [
            "null",
            "string"
          ],
          "pattern": "^$|^#"
        }
      },
      "additionalProperties": false
    },
    "YouTubeSubscribeButton": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "youtubeChannelId": true
      },
      "additionalProperties": false
    },
    "AudioPlayer": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "uri": true,
        "autoPlay": true,
        "loop": true,
        "visible": true,
        "volume": true,
        "title": true,
        "description": true,
        "icon_uri": true,
        "originalFileName": true,
        "showToolTip": true
      },
      "additionalProperties": false
    },
    "Boolean": {
      "type": "object",
      "properties": {
        "value": true
      },
      "additionalProperties": false
    },
    "CheckBox": {
      "type": "object",
      "properties": {
        "value": true,
        "indeterminate": true
      },
      "additionalProperties": false
    },
    "Grid": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "dataSource": {
          "type": "object",
          "properties": {
            "type": {
              "type": "string",
              "enum": [
                "static",
                "dynamic"
              ]
            },
            "revision": true
          },
          "additionalProperties": false
        },
        "rows": {
          "type": "array",
          "items": true
        },
        "rowsCount": true,
        "revision": true,
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        }
      },
      "additionalProperties": false
    },
    "ContactForm": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "toEmailAddress": true,
        "bccEmailAddress": true,
        "nameFieldLabel": true,
        "emailFieldLabel": true,
        "phoneFieldLabel": true,
        "addressFieldLabel": true,
        "subjectFieldLabel": true,
        "messageFieldLabel": true,
        "submitButtonLabel": true,
        "successMessage": true,
        "errorMessage": true,
        "textDirection": {
          "type": "string",
          "enum": [
            "left",
            "right"
          ]
        },
        "validationErrorMessage": true,
        "onSubmitBehavior": {
          "type": "string",
          "enum": [
            "message",
            "link"
          ]
        },
        "link": {
          "type": [
            "null",
            "string"
          ],
          "pattern": "^$|^#"
        }
      },
      "additionalProperties": false
    },
    "DynamicContactForm": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "toEmailAddress": true,
        "bccEmailAddress": true,
        "submitButtonLabel": true,
        "successMessage": true,
        "errorMessage": true,
        "textDirection": {
          "type": "string",
          "enum": [
            "left",
            "right"
          ]
        },
        "validationErrorMessage": true,
        "onSubmitBehavior": {
          "type": "string",
          "enum": [
            "message",
            "link"
          ]
        },
        "link": {
          "type": [
            "null",
            "string"
          ],
          "pattern": "^$|^#"
        },
        "formName": true,
        "dynamicFields": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "name": true,
              "inputType": true,
              "displayLabel": true,
              "required": true,
              "displayed": true
            },
            "additionalProperties": false
          }
        }
      },
      "additionalProperties": false
    },
    "EbayItemsBySeller": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "sellerId": true,
        "registrationSite": true
      },
      "additionalProperties": false
    },
    "FacebookShareButton": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "urlChoice": {
          "type": "string",
          "enum": [
            "Current page",
            "Site"
          ]
        },
        "label": true,
        "isHttpsEnabled": true,
        "urlFormat": {
          "type": "string",
          "enum": [
            "hashBang",
            "slash"
          ]
        }
      },
      "additionalProperties": false
    },
    "FlashComponent": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "linkType": {
          "type": "string",
          "enum": [
            "SMS",
            "CALL",
            "SKYPE",
            "MAP",
            "EMAIL",
            "FACEBOOK",
            "FLICKR",
            "BLOGGER",
            "MYSPACE",
            "LINKEDIN",
            "TWITTER",
            "TUMBLR",
            "YOUTUBE",
            "VIMEO",
            "PAGE",
            "FREE_LINK",
            "TEXT",
            "DELICIOUS",
            "WEBSITE",
            "DOCUMENT",
            "ADMIN_LOGIN",
            "LOGIN"
          ]
        },
        "href": true,
        "text": true,
        "target": true,
        "icon": true,
        "title": true,
        "uri": true,
        "description": true,
        "height": true,
        "width": true,
        "placeHolderImage": true
      },
      "additionalProperties": false
    },
    "FlickrBadgeWidget": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "userId": true,
        "userName": true,
        "tag": true,
        "imageCount": true,
        "whichImages": true,
        "imageSize": true,
        "layoutOrientation": true
      },
      "additionalProperties": false
    },
    "GeoMapLocation": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "address": true,
        "latitude": true,
        "longitude": true,
        "title": true,
        "description": true,
        "link": {
          "type": [
            "null",
            "string"
          ],
          "pattern": "^$|^#"
        },
        "linkTitle": true,
        "pinIcon": true,
        "pinColor": true
      },
      "additionalProperties": false
    },
    "GeoMap": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "language": {
          "type": "string",
          "enum": [
            "af",
            "sq",
            "am",
            "ar",
            "hy",
            "az",
            "eu",
            "be",
            "bn",
            "bs",
            "bg",
            "my",
            "ca",
            "zh",
            "zh-CN",
            "zh-HK",
            "zh-TW",
            "hr",
            "cs",
            "da",
            "nl",
            "en",
            "en-AU",
            "en-GB",
            "et",
            "fa",
            "fi",
            "fil",
            "fr",
            "fr-CA",
            "gl",
            "ka",
            "de",
            "el",
            "gu",
            "iw",
            "hi",
            "hu",
            "is",
            "id",
            "it",
            "ja",
            "kn",
            "kk",
            "km",
            "ko",
            "ky",
            "lo",
            "lv",
            "lt",
            "mk",
            "ms",
            "ml",
            "mr",
            "mn",
            "ne",
            "no",
            "pl",
            "pt",
            "pt-BR",
            "pt-PT",
            "pa",
            "ro",
            "ru",
            "sr",
            "si",
            "sk",
            "sl",
            "es",
            "es-419",
            "sw",
            "sv",
            "ta",
            "te",
            "th",
            "tr",
            "uk",
            "ur",
            "uz",
            "vi",
            "zu"
          ]
        },
        "locations": {
          "type": [
            "array"
          ],
          "items": true
        },
        "address": true,
        "latitude": true,
        "longitude": true,
        "addressInfo": true,
        "defaultLocation": true,
        "mapStyle": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "elementType": {
                "type": "string",
                "enum": [
                  "all",
                  "geometry",
                  "geometry.fill",
                  "geometry.stroke",
                  "labels",
                  "labels.icon",
                  "labels.text",
                  "labels.text.fill",
                  "labels.text.stroke"
                ]
              },
              "featureType": {
                "type": "string",
                "enum": [
                  "administrative",
                  "administrative.country",
                  "administrative.land_parcel",
                  "administrative.locality",
                  "administrative.neighborhood",
                  "administrative.province",
                  "all",
                  "landscape",
                  "landscape.man_made",
                  "landscape.natural",
                  "landscape.natural.landcover",
                  "landscape.natural.terrain",
                  "poi",
                  "poi.attraction",
                  "poi.business",
                  "poi.government",
                  "poi.medical",
                  "poi.park",
                  "poi.place_of_worship",
                  "poi.school",
                  "poi.sports_complex",
                  "road",
                  "road.arterial",
                  "road.highway",
                  "road.highway.controlled_access",
                  "road.local",
                  "transit",
                  "transit.line",
                  "transit.station",
                  "transit.station.airport",
                  "transit.station.bus",
                  "transit.station.rail",
                  "water"
                ]
              },
              "stylers": {
                "type": "array",
                "items": {
                  "type": "object",
                  "properties": {
                    "color": true,
                    "gamma": true,
                    "hue": true,
                    "invert_lightness": true,
                    "lightness": true,
                    "saturation": true,
                    "visibility": {
                      "type": "string",
                      "enum": [
                        "on",
                        "off",
                        "simplified"
                      ]
                    },
                    "weight": true
                  },
                  "additionalProperties": false
                }
              }
            },
            "additionalProperties": false
          }
        }
      },
      "additionalProperties": false
    },
    "HtmlComponent": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "sourceType": true,
        "url": true,
        "title": true,
        "freezeFrame": true,
        "allowFullScreen": true,
        "componentConsentPolicy": {
          "type": "string",
          "enum": [
            "essential",
            "functional",
            "analytics",
            "advertising",
            "dataToThirdParty"
          ]
        }
      },
      "additionalProperties": false
    },
    "DisqusComments": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "disqusId": true
      },
      "additionalProperties": false
    },
    "ItunesButton": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "downloadUrl": true
      },
      "additionalProperties": false
    },
    "LinkableFlashComponent": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "link": {
          "type": [
            "null",
            "string"
          ],
          "pattern": "^$|^#"
        },
        "title": true,
        "uri": true,
        "description": true,
        "height": true,
        "width": true,
        "placeHolderImage": true
      },
      "additionalProperties": false
    },
    "LinkableButton": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "link": {
          "type": [
            "null",
            "string"
          ],
          "pattern": "^$|^#"
        },
        "direction": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "label": true,
        "a11y": true
      },
      "additionalProperties": false
    },
    "LoginButton": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "language": true
      },
      "additionalProperties": false
    },
    "TinyMenu": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "loginSocialBarRef": true,
        "menuRef": true
      },
      "additionalProperties": false
    },
    "LoginSocialBar": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "menuItemsRef": true,
        "iconItemsRef": true,
        "language": true,
        "loggedInMember": {
          "type": "string",
          "enum": [
            "avatarOnly",
            "textOnly",
            "avatarAndText",
            "memberInitials"
          ]
        },
        "loggedOutMember": {
          "type": "string",
          "enum": [
            "avatarOnly",
            "textOnly",
            "avatarAndText"
          ]
        },
        "loggedInAvatarIcon": {
          "type": "string",
          "enum": [
            "profileImage",
            "initials",
            "custom"
          ]
        },
        "loggedOutAvatarIcon": {
          "type": "string",
          "enum": [
            "profileImage",
            "initials",
            "custom"
          ]
        },
        "loggedInCustomAvatar": true,
        "loggedOutCustomAvatar": true,
        "loggedOutText": true,
        "showLoggedInText": true,
        "loggedInTextState": {
          "type": "string",
          "enum": [
            "memberName",
            "custom"
          ]
        },
        "loggedInText": true,
        "customLoggedInText": true,
        "logOutText": true
      },
      "additionalProperties": false
    },
    "PagesGroupData": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "appId": true,
        "appDefinitionId": true,
        "groupName": true,
        "pages": {
          "type": "array",
          "items": true
        }
      },
      "additionalProperties": false
    },
    "PagesGroupCollection": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "groups": {
          "type": [
            "array",
            "null"
          ],
          "items": true
        }
      },
      "additionalProperties": false
    },
    "PayPalButton": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "merchantID": true
      },
      "additionalProperties": false
    },
    "PermaLink": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "appType": {
          "enum": [
            "ListsApps",
            "ThirdPartyApps"
          ]
        },
        "dataItemRef": true,
        "mutableSeoTitle": true,
        "correctPermaLinkRef": true
      },
      "additionalProperties": false
    },
    "PinterestFollow": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "urlChoice": true,
        "label": true
      },
      "additionalProperties": false
    },
    "SelectableList": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "direction": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "labelDirection": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "inputDirection": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "dropdownDirection": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "errorDirection": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "options": {
          "type": [
            "array",
            "null"
          ],
          "items": true
        },
        "label": true,
        "placeholder": {
          "type": "object",
          "properties": {
            "value": true,
            "text": true
          },
          "additionalProperties": false
        },
        "value": true,
        "name": true,
        "formGroup": true
      },
      "additionalProperties": false
    },
    "SelectOption": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "value": true,
        "text": true,
        "selectedText": true,
        "disabled": true,
        "description": true
      },
      "additionalProperties": false
    },
    "RadioButton": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "label": true,
        "value": true,
        "name": true,
        "formGroup": true
      },
      "additionalProperties": false
    },
    "RadioGroup": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "labelDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "optionsDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "defaultValue": true,
        "options": {
          "type": [
            "array",
            "null"
          ],
          "items": true
        },
        "label": true,
        "placeholder": {
          "type": "object",
          "properties": {
            "value": true,
            "text": true
          },
          "additionalProperties": false
        },
        "value": true,
        "name": true,
        "formGroup": true
      },
      "additionalProperties": false
    },
    "CheckboxGroup": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "labelDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "optionsDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "options": {
          "type": [
            "array",
            "null"
          ],
          "items": true
        },
        "label": true,
        "name": true,
        "formGroup": true
      },
      "additionalProperties": false
    },
    "FileUploader": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "buttonLabel": true,
        "placeholderLabel": true,
        "label": true,
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "labelDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "buttonLabelDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "filesDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "iconPosition": {
          "type": [
            "string"
          ],
          "enum": [
            "row",
            "rowReverse",
            "column",
            "columnReverse"
          ]
        }
      },
      "additionalProperties": false
    },
    "UploadName": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true
      },
      "additionalProperties": false
    },
    "SiteButtonA11y": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "pressed": true,
        "tabindex": true,
        "label": true,
        "live": {
          "type": "string",
          "enum": [
            "polite",
            "assertive"
          ]
        },
        "haspopup": {
          "type": "string",
          "enum": [
            "true",
            "false",
            "menu",
            "dialog",
            "listbox",
            "tree",
            "grid"
          ]
        },
        "expanded": true,
        "disabled": true
      },
      "additionalProperties": false
    },
    "SiteButton": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "linkType": {
          "type": "string",
          "enum": [
            "SMS",
            "CALL",
            "SKYPE",
            "MAP",
            "EMAIL",
            "FACEBOOK",
            "FLICKR",
            "BLOGGER",
            "MYSPACE",
            "LINKEDIN",
            "TWITTER",
            "TUMBLR",
            "YOUTUBE",
            "VIMEO",
            "PAGE",
            "FREE_LINK",
            "TEXT",
            "DELICIOUS",
            "WEBSITE",
            "DOCUMENT",
            "ADMIN_LOGIN",
            "LOGIN"
          ]
        },
        "href": true,
        "text": true,
        "target": true,
        "icon": true,
        "label": true
      },
      "additionalProperties": false
    },
    "SoundCloudWidget": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "url": true,
        "showArtWork": true,
        "autoPlay": true,
        "embedSource": true
      },
      "additionalProperties": false
    },
    "StyledTextA11y": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "label": true,
        "live": {
          "type": "string",
          "enum": [
            "polite",
            "assertive"
          ]
        },
        "level": true,
        "role": {
          "type": "string",
          "enum": [
            "heading",
            "status",
            "alert"
          ]
        },
        "atomic": true,
        "hidden": true,
        "current": {
          "type": "string",
          "enum": [
            "step",
            "page",
            "true",
            "false"
          ]
        }
      },
      "additionalProperties": false
    },
    "StyledText": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "text": true,
        "stylesMapId": true,
        "linkList": {
          "type": [
            "array",
            "null"
          ],
          "items": true
        },
        "a11y": true
      },
      "additionalProperties": false
    },
    "StyledTextLinkHelper": {
      "type": "object",
      "properties": {
        "link": {
          "type": [
            "null",
            "string"
          ],
          "pattern": "^$|^#"
        }
      },
      "additionalProperties": false
    },
    "SvgShape": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "link": {
          "type": [
            "null",
            "string"
          ],
          "pattern": "^$|^#"
        },
        "alt": true
      },
      "additionalProperties": false
    },
    "VectorImage": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "link": {
          "type": [
            "null",
            "string"
          ],
          "pattern": "^$|^#"
        },
        "alt": true,
        "decorative": true,
        "title": true,
        "svgId": true
      },
      "additionalProperties": false
    },
    "Video": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "videoId": true,
        "userId": true,
        "posterImage": true,
        "videoType": {
          "type": "string",
          "enum": [
            "YOUTUBE",
            "VIMEO",
            "FACEBOOK",
            "DAILYMOTION"
          ]
        }
      },
      "additionalProperties": false
    },
    "VKShareButton": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "style": {
          "type": "string",
          "enum": [
            "Button",
            "ButtonWithoutCounter",
            "Link",
            "LinkWithoutIcon",
            "Icon"
          ]
        },
        "text": true,
        "isHttpsEnabled": true,
        "urlFormat": {
          "type": "string",
          "enum": [
            "hashBang",
            "slash"
          ]
        }
      },
      "additionalProperties": false
    },
    "ButtonWithIcon": {
      "type": "object",
      "properties": {
        "label": true,
        "toggleMode": true,
        "disabled": true,
        "iconSrc": true,
        "iconSize": true,
        "spriteOffset": true,
        "command": true,
        "commandParameter": true,
        "action": true
      },
      "additionalProperties": false
    },
    "EditorPreferences": {
      "type": "object",
      "properties": {
        "dontShowAgainTooltips": true,
        "dontShowAgainDialogs": true
      },
      "additionalProperties": false
    },
    "TPAWidget": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "applicationId": true,
        "appDefinitionId": true,
        "widgetId": true,
        "referenceId": true,
        "usesCssPerBreakpoint": true,
        "tpaData": true
      },
      "additionalProperties": false
    },
    "TPAData": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "content": true
      },
      "additionalProperties": false
    },
    "TPAGlobalData": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "content": true,
        "appDefinitionId": true
      },
      "additionalProperties": false
    },
    "TPA": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "applicationId": true,
        "appDefinitionId": true,
        "referenceId": true,
        "widgetId": true,
        "usesCssPerBreakpoint": true,
        "tpaData": true
      },
      "additionalProperties": false
    },
    "TPASection": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "applicationId": true,
        "referenceId": true,
        "usesCssPerBreakpoint": true,
        "tpaData": true
      },
      "additionalProperties": false
    },
    "TPAMultiSection": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "applicationId": true,
        "appDefinitionId": true,
        "widgetId": true,
        "referenceId": true,
        "usesCssPerBreakpoint": true,
        "tpaData": true
      },
      "additionalProperties": false
    },
    "RssButton": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "image": true,
        "link": {
          "type": [
            "null",
            "string"
          ],
          "pattern": "^$|^#"
        }
      },
      "additionalProperties": false
    },
    "AppPart": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "appInnerID": true,
        "appLogicParams": true,
        "appLogicCustomizations": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "fieldId": true,
              "forType": true,
              "format": true,
              "key": true,
              "type": true,
              "view": true,
              "mode": true,
              "value": true
            },
            "additionalProperties": false
          }
        },
        "appPartName": true,
        "viewName": true
      },
      "additionalProperties": false
    },
    "AppPartCustomization": {
      "type": "object",
      "properties": {
        "fieldId": true,
        "forType": true,
        "format": true,
        "key": true,
        "type": true,
        "view": true,
        "mode": true,
        "value": true
      },
      "additionalProperties": false
    },
    "AppPage": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "appPageId": true,
        "appInnerID": true,
        "appPageType": true,
        "repeaterPage": true,
        "title": true,
        "hideTitle": true,
        "icon": true,
        "windowTitle": true,
        "descriptionSEO": true,
        "advancedSeoData": true,
        "metaKeywordsSEO": true,
        "pageTitleSEO": true,
        "pageUriSEO": true,
        "hidePage": true,
        "underConstruction": true,
        "tpaApplicationId": true,
        "appDefinitionId": true,
        "managingAppDefId": true,
        "tpaPageId": true,
        "parentPageId": true,
        "pageSecurity": true,
        "indexable": true,
        "mobileHidePage": true,
        "pageBackgrounds": {
          "type": "object",
          "properties": {
            "desktop": {
              "type": "object",
              "properties": {
                "custom": true,
                "mediaSizing": {
                  "type": "string",
                  "enum": [
                    "document",
                    "viewport"
                  ]
                },
                "ref": true,
                "isPreset": true
              },
              "additionalProperties": false
            },
            "mobile": {
              "type": "object",
              "properties": {
                "custom": true,
                "mediaSizing": {
                  "type": "string",
                  "enum": [
                    "document",
                    "viewport"
                  ]
                },
                "ref": true,
                "isPreset": true
              },
              "additionalProperties": false
            }
          },
          "additionalProperties": false
        },
        "isLandingPage": true,
        "isMobileLandingPage": true,
        "isPopup": true,
        "translationData": {
          "type": "object",
          "properties": {
            "uriSEOTranslated": true
          },
          "additionalProperties": false
        },
        "ogImage": true,
        "ogImageRef": true,
        "ignoreBottomBottomAnchors": true,
        "cacheMode": {
          "enum": [
            "auto",
            "manual",
            "disabled"
          ]
        },
        "cacheMaxAgeHours": true
      },
      "additionalProperties": false
    },
    "AppBuilderComponent": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "appInnerID": true,
        "appPartName": true
      },
      "additionalProperties": false
    },
    "BoxSlideShow": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "direction": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        }
      },
      "additionalProperties": false
    },
    "BoxSlideShowSlide": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "title": true
      },
      "additionalProperties": false
    },
    "StripContainerSlideShow": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "direction": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        }
      },
      "additionalProperties": false
    },
    "StripContainerSlideShowSlide": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "title": true,
        "background": true
      },
      "additionalProperties": false
    },
    "VerticalAnchorsMenu": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "pageTopLabel": true,
        "pageBottomLabel": true,
        "hiddenAnchorIds": true,
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "bulletPosition": {
          "type": [
            "string"
          ],
          "enum": [
            "row",
            "rowReverse",
            "column",
            "columnReverse"
          ]
        }
      },
      "additionalProperties": false
    },
    "WFacebookComment": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "isHttpsEnabled": true,
        "urlFormat": {
          "type": "string",
          "enum": [
            "hashBang",
            "slash"
          ]
        }
      },
      "additionalProperties": false
    },
    "WFacebookLike": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "isHttpsEnabled": true,
        "urlFormat": {
          "type": "string",
          "enum": [
            "hashBang",
            "slash"
          ]
        }
      },
      "additionalProperties": false
    },
    "AppController": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "applicationId": true,
        "name": true,
        "controllerType": true,
        "settings": true,
        "externalId": true
      },
      "additionalProperties": false
    },
    "RepeaterA11y": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "label": true,
        "role": {
          "type": "string",
          "enum": [
            "region",
            "none",
            "radiogroup",
            "list",
            "group"
          ]
        }
      },
      "additionalProperties": false
    },
    "Repeater": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "direction": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "items": {
          "type": "array",
          "items": true
        },
        "a11y": true
      },
      "additionalProperties": false
    },
    "RepeatedData": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "original": true,
        "overrides": true
      },
      "additionalProperties": false
    },
    "ImageButtonWithText": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "label": true,
        "icon": true,
        "predefinedClass": true
      },
      "additionalProperties": false
    },
    "Icon": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "url": true,
        "width": true,
        "height": true,
        "title": true
      },
      "additionalProperties": false
    },
    "WidgetRef": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "appDefinitionId": true,
        "widgetId": true,
        "variationId": true,
        "name": true
      },
      "additionalProperties": false
    },
    "InternalRef": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "rootCompId": true,
        "pageId": true
      },
      "additionalProperties": false
    },
    "InternalBlocksRef": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "rootCompId": true,
        "pageId": true
      },
      "additionalProperties": false
    },
    "LightboxA11y": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "label": true
      },
      "additionalProperties": false
    },
    "LightboxContainer": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "a11y": true
      },
      "additionalProperties": false
    },
    "ContainerA11y": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "tabindex": true,
        "role": {
          "type": "string",
          "enum": [
            "region",
            "group",
            "none",
            "status",
            "alert",
            "nav",
            "list",
            "listitem",
            "tablist",
            "tab",
            "tabpanel",
            "menubar",
            "presentation",
            "heading"
          ]
        },
        "roledescription": true,
        "label": true,
        "level": true,
        "live": {
          "type": "string",
          "enum": [
            "polite",
            "assertive"
          ]
        },
        "atomic": true,
        "current": {
          "type": "string",
          "enum": [
            "step",
            "page",
            "true",
            "false"
          ]
        },
        "hidden": true,
        "relevant": {
          "type": "string",
          "enum": [
            "all",
            "additions",
            "text",
            "removals"
          ]
        }
      },
      "additionalProperties": false
    },
    "ContainerData": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "a11y": true
      },
      "additionalProperties": false
    },
    "MediaBoxData": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "a11y": true
      },
      "additionalProperties": false
    },
    "SlotsPlaceholderData": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "interfaces": {
          "type": "array",
          "items": true
        }
      },
      "additionalProperties": false
    },
    "LinkType": {
      "type": "string",
      "enum": [
        "SMS",
        "CALL",
        "SKYPE",
        "MAP",
        "EMAIL",
        "FACEBOOK",
        "FLICKR",
        "BLOGGER",
        "MYSPACE",
        "LINKEDIN",
        "TWITTER",
        "TUMBLR",
        "YOUTUBE",
        "VIMEO",
        "PAGE",
        "FREE_LINK",
        "TEXT",
        "DELICIOUS",
        "WEBSITE",
        "DOCUMENT",
        "ADMIN_LOGIN",
        "LOGIN"
      ]
    },
    "UrlFormat": {
      "type": "string",
      "enum": [
        "hashBang",
        "slash"
      ]
    },
    "MultiStateBoxDataA11y": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "label": true,
        "live": {
          "type": "string",
          "enum": [
            "polite",
            "assertive"
          ]
        },
        "tabindex": true,
        "role": {
          "type": "string",
          "enum": [
            "region",
            "group",
            "tablist",
            "tab",
            "tabpanel",
            "alert",
            "status",
            "list",
            "menubar",
            "presentation",
            "none",
            "nav",
            "listitem"
          ]
        },
        "atomic": true,
        "hidden": true,
        "current": {
          "type": "string",
          "enum": [
            "step",
            "page",
            "true",
            "false",
            "location",
            "date",
            "time"
          ]
        },
        "expanded": true,
        "relevant": true,
        "busy": true,
        "owns": true
      },
      "additionalProperties": false
    },
    "MultiStateBoxData": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "defaultStateId": true,
        "selectedStateId": true,
        "a11y": true
      },
      "additionalProperties": false
    },
    "AppsInstallState": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "stateMap": {
          "type": "object",
          "properties": {},
          "additionalProperties": {
            "type": "object",
            "properties": {
              "status": {
                "type": "string",
                "enum": [
                  "INSTALLED",
                  "REMOVED"
                ]
              },
              "version": true
            }
          }
        }
      },
      "additionalProperties": false
    },
    "StateBoxA11y": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "label": true,
        "live": {
          "type": "string",
          "enum": [
            "polite",
            "assertive"
          ]
        },
        "tabindex": true,
        "role": {
          "type": "string",
          "enum": [
            "region",
            "group",
            "tablist",
            "tab",
            "tabpanel",
            "alert",
            "status",
            "list",
            "menubar",
            "presentation",
            "none",
            "nav",
            "listitem"
          ]
        },
        "atomic": true,
        "hidden": true,
        "current": {
          "type": "string",
          "enum": [
            "step",
            "page",
            "true",
            "false",
            "location",
            "date",
            "time"
          ]
        },
        "expanded": true,
        "relevant": true,
        "busy": true,
        "owns": true
      },
      "additionalProperties": false
    },
    "StateBox": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "a11y": true
      },
      "additionalProperties": false
    },
    "StateBoxStateA11y": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "label": true,
        "live": {
          "type": "string",
          "enum": [
            "polite",
            "assertive"
          ]
        },
        "tabindex": true,
        "role": {
          "type": "string",
          "enum": [
            "region",
            "group",
            "tablist",
            "tab",
            "tabpanel",
            "alert",
            "status",
            "list",
            "menubar",
            "presentation",
            "none",
            "nav",
            "listitem"
          ]
        },
        "atomic": true,
        "hidden": true,
        "current": {
          "type": "string",
          "enum": [
            "step",
            "page",
            "true",
            "false",
            "location",
            "date",
            "time"
          ]
        },
        "expanded": true,
        "relevant": true,
        "busy": true,
        "owns": true
      },
      "additionalProperties": false
    },
    "StateBoxState": {
      "type": "object",
      "properties": {
        "a11y": true
      },
      "additionalProperties": false
    },
    "Builder.MenuItem": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "link": {
          "type": [
            "null",
            "string"
          ],
          "pattern": "^$|^#"
        },
        "items": {
          "type": [
            "array",
            "null"
          ],
          "items": true
        },
        "container": true,
        "label": true,
        "isVisible": true
      },
      "additionalProperties": false
    },
    "Builder.MenuItems": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "name": true,
        "items": {
          "type": [
            "array",
            "null"
          ],
          "items": true
        }
      },
      "additionalProperties": false
    },
    "Builder.Image": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "uri": true,
        "name": true,
        "width": true,
        "height": true
      },
      "additionalProperties": false
    },
    "Builder.Video": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "uri": true,
        "sources": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "quality": {
                "type": "string",
                "enum": [
                  "1080p",
                  "720p",
                  "480p",
                  "360p"
                ]
              },
              "width": true,
              "height": true,
              "types": {
                "type": "array",
                "items": {
                  "type": "object",
                  "properties": {
                    "format": {
                      "type": "string",
                      "enum": [
                        "mp4",
                        "mp4-luminance"
                      ]
                    },
                    "uri": true
                  },
                  "additionalProperties": false
                }
              }
            },
            "additionalProperties": false
          }
        },
        "adaptiveSources": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "format": {
                "type": "string",
                "enum": [
                  "hls",
                  "dash"
                ]
              },
              "uri": true
            },
            "additionalProperties": false
          }
        },
        "hasAudio": true,
        "fps": true,
        "poster": true,
        "duration": true
      },
      "additionalProperties": false
    },
    "Builder.VectorArt": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "uri": true
      },
      "additionalProperties": false
    },
    "Builder.RichText": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "text": true,
        "linkList": {
          "type": [
            "array",
            "null"
          ],
          "items": true
        }
      },
      "additionalProperties": false
    },
    "mobui.MobuiButton": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "contentType": {
          "type": "string",
          "enum": [
            "Text",
            "Icon",
            "Text and icon"
          ]
        },
        "label": true,
        "icon": true,
        "iconPosition": {
          "type": "string",
          "enum": [
            "Left",
            "Right"
          ]
        },
        "buttonType": {
          "type": "string",
          "enum": [
            "Full",
            "Outline",
            "Link"
          ]
        },
        "size": {
          "type": "string",
          "enum": [
            "Small",
            "Medium",
            "Large"
          ]
        }
      },
      "additionalProperties": false
    },
    "mobui.MobuiDatePicker": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "label": true,
        "initialText": {
          "type": "string",
          "enum": [
            "today's date",
            "placeholder"
          ]
        },
        "placeholder": true,
        "icon": true,
        "fieldType": {
          "type": "string",
          "enum": [
            "form",
            "settings",
            "filter"
          ]
        },
        "pickerType": {
          "type": "string",
          "enum": [
            "wheel",
            "calendar"
          ]
        },
        "pickerTitle": true,
        "showPastDates": true,
        "showFutureDates": true,
        "wheelMode": {
          "type": "string",
          "enum": [
            "DD/MM/YY",
            "MM/YY"
          ]
        },
        "firstDay": {
          "type": "string",
          "enum": [
            "Sunday",
            "Monday"
          ]
        },
        "disabledDaysOfWeek": {
          "type": [
            "array"
          ],
          "items": true
        },
        "enabledDateRanges": {
          "type": [
            "array"
          ],
          "items": true
        },
        "disabledDateRanges": {
          "type": [
            "array"
          ],
          "items": true
        },
        "readOnly": true,
        "required": true,
        "requiredErrorMessage": true,
        "validateOnStart": true,
        "validateOnChange": true,
        "disabledDates": {
          "type": [
            "array"
          ],
          "items": true
        },
        "minDate": true,
        "maxDate": true,
        "timeZone": true
      },
      "additionalProperties": false
    },
    "defaultItemSchemaType": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "label": true,
        "value": true,
        "disabled": true,
        "isDefault": true,
        "unavailable": true
      },
      "additionalProperties": false
    },
    "MobuiDateRangeType": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "label": true,
        "value": true,
        "disabled": true,
        "isDefault": true,
        "unavailable": true,
        "startDate": true,
        "endDate": true
      },
      "additionalProperties": false
    },
    "mobui.MobuiImage": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "src": true,
        "isExternalSource": true,
        "resizeMode": {
          "type": "string",
          "enum": [
            "cover",
            "contain",
            "stretch",
            "repeat",
            "center"
          ]
        }
      },
      "additionalProperties": false
    },
    "mobui.MobuiPicker": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "fieldType": {
          "type": "string",
          "enum": [
            "form",
            "filter",
            "settings"
          ]
        },
        "label": true,
        "placeholder": true,
        "pickerType": {
          "type": "string",
          "enum": [
            "fullScreen",
            "dialog"
          ]
        },
        "optionsDialogTitle": true,
        "optionsDialogSubtitle": true,
        "hasItemSubtitle": true,
        "isMultiselect": true,
        "selectionLimit": true,
        "hasSearchBar": true,
        "readOnly": true,
        "requiredErrorMessage": true,
        "validateOnStart": true,
        "validateOnChange": true,
        "validateOnBlur": true,
        "options": {
          "type": [
            "array"
          ],
          "items": true
        }
      },
      "additionalProperties": false
    },
    "MobuiPickerItemType": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "label": true,
        "value": true,
        "disabled": true,
        "isDefault": true,
        "unavailable": true,
        "subtitle": true,
        "isSelected": true
      },
      "additionalProperties": false
    },
    "mobui.MobuiSwitch": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "value": true
      },
      "additionalProperties": false
    },
    "mobui.MobuiText": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "text": true,
        "selectable": true
      },
      "additionalProperties": false
    },
    "mobui.MobuiTextInput": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "inputType": {
          "type": "string",
          "enum": [
            "text",
            "password",
            "phone",
            "email",
            "url",
            "number"
          ]
        },
        "label": true,
        "placeholder": true,
        "initialValue": true,
        "hasCharLimit": true,
        "maxInputLength": true,
        "prefixValue": true,
        "suffixValue": true,
        "requiredErrorMessage": true,
        "validatorErrorMessageValue": true,
        "validatorType": {
          "type": "string",
          "enum": [
            "none",
            "number",
            "email",
            "url",
            "required"
          ]
        },
        "textContentType": true,
        "autoComplete": true,
        "validateOnStart": true,
        "validateOnChange": true,
        "validateOnBlur": true
      },
      "additionalProperties": false
    },
    "mobui.MobuiVideoPlayer": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "title": true,
        "src": true,
        "poster": true,
        "isPlaying": true,
        "muteOnStart": true,
        "playInLoop": true,
        "enableFullScreen": true,
        "enableCasting": true,
        "showVideoSettings": true
      },
      "additionalProperties": false
    },
    "mobui.MobuiMultiStateBoxData": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "defaultStateId": true,
        "selectedStateId": true
      },
      "additionalProperties": false
    },
    "wixui.ExternalComponent": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "url": true,
        "compProps": true,
        "isTrusted": true,
        "importKey": true
      },
      "additionalProperties": false
    },
    "wixui.HamburgerOverlay": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "showBackgroundOverlay": true,
        "tapOutsideToClose": true,
        "isMenuContainerFullscreen": true
      },
      "additionalProperties": false
    },
    "wixui.Logo": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "isLoadingData": true,
        "logoId": true,
        "alt": true,
        "link": {
          "type": [
            "null",
            "string"
          ],
          "pattern": "^$|^#"
        },
        "preset": true,
        "hasBackground": true,
        "brandId": true,
        "backgroundColor": true,
        "logoUrl": true
      },
      "additionalProperties": false
    },
    "wixui.LottieEmbed": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "animationUrl": true,
        "speed": true,
        "loop": true,
        "autoplay": true,
        "alt": true,
        "isDecorative": true,
        "showPlaybackControl": true
      },
      "additionalProperties": false
    },
    "wixui.ProductSpecification": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "items": {
          "type": [
            "array"
          ],
          "items": true
        }
      },
      "additionalProperties": false
    },
    "wixui.RangeSlider": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "label": true,
        "sliderType": {
          "type": "string",
          "enum": [
            "Continuous",
            "Stepped"
          ]
        },
        "stepType": {
          "type": "string",
          "enum": [
            "Number",
            "Value"
          ]
        },
        "step": true,
        "direction": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl"
          ]
        },
        "rootDirection": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "labelDirection": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "sliderDirection": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "min": true,
        "max": true,
        "prefix": true,
        "suffix": true,
        "minValue": true,
        "maxValue": true,
        "thumbShape": {
          "type": "string",
          "enum": [
            "Circle",
            "Square",
            "Rectangle",
            "Bar"
          ]
        },
        "marksTickShape": {
          "type": "string",
          "enum": [
            "Lines",
            "Dots"
          ]
        },
        "thumbSize": true,
        "readOnly": true,
        "accessibleName": true
      },
      "additionalProperties": false
    },
    "wixui.Rive": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "animationFileUrl": true,
        "thumbnailFileUrl": true,
        "artboard": true,
        "stateMachine": true,
        "fit": true,
        "alignment": true,
        "isAutoPlayOn": true,
        "isTouchScrollEnabled": true,
        "alt": true,
        "fileName": true,
        "isDecorative": true
      },
      "additionalProperties": false
    },
    "wixui.ShareButtons": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "buttons": {
          "type": [
            "array"
          ],
          "items": true
        },
        "pageToShare": true,
        "shareUrl": true,
        "direction": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        }
      },
      "additionalProperties": false
    },
    "IShareButton": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "label": true,
        "value": true,
        "disabled": true,
        "isDefault": true,
        "unavailable": true,
        "platformId": true,
        "illustration": true,
        "isHidden": true
      },
      "additionalProperties": false
    },
    "wixui.SingleTab": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "tabId": true,
        "label": true,
        "isParentStretched": true
      },
      "additionalProperties": false
    },
    "AccordionContainerData": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "items": {
          "type": "array",
          "items": {
            "type": [
              "object"
            ],
            "properties": {
              "id": true,
              "label": true
            },
            "additionalProperties": false
          }
        }
      },
      "additionalProperties": false
    },
    "AccordionItemData": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "isParentStretched": true
      },
      "additionalProperties": false
    },
    "AddressInput": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "labelDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "inputDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "optionsDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "locale": true,
        "googleMapsApiKey": true,
        "filter": {
          "type": "object",
          "properties": {
            "country": true
          },
          "additionalProperties": false
        },
        "sorting": {
          "type": "object",
          "properties": {
            "location": {
              "type": "object",
              "properties": {
                "lat": true,
                "lng": true
              },
              "additionalProperties": false
            },
            "radius": true,
            "formatted": true
          },
          "additionalProperties": false
        },
        "placeholder": true,
        "label": true
      },
      "additionalProperties": false
    },
    "BoltComponentData": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true
      },
      "additionalProperties": false,
      "anyOf": [
        {
          "properties": {},
          "additionalProperties": false
        }
      ]
    },
    "BreadcrumbsData": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "svgId": true,
        "menuRef": true,
        "a11y": true,
        "direction": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "itemDirection": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "submenuDirection": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "submenuSubItemDirection": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        }
      },
      "additionalProperties": false
    },
    "Captcha": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "captchaType": {
          "type": "string",
          "enum": [
            "image",
            "audio"
          ]
        }
      },
      "additionalProperties": false
    },
    "CollapsibleTextData": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "text": true,
        "readMoreText": true,
        "readLessText": true,
        "link": {
          "type": [
            "null",
            "string"
          ],
          "pattern": "^$|^#"
        },
        "linkText": true,
        "textDescription": true,
        "tag": true,
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "textDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "buttonDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        }
      },
      "additionalProperties": false
    },
    "ComboBoxInputData": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "direction": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "labelDirection": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "inputDirection": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "dropdownDirection": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "errorDirection": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "options": {
          "type": [
            "array",
            "null"
          ],
          "items": true
        },
        "label": true,
        "placeholder": {
          "type": "object",
          "properties": {
            "value": true,
            "text": true
          },
          "additionalProperties": false
        },
        "value": true,
        "name": true,
        "formGroup": true
      },
      "additionalProperties": false
    },
    "CustomElement": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "tagName": true,
        "url": true,
        "hostedInCorvid": true,
        "initialAttributes": true,
        "shouldReload": true,
        "scriptType": {
          "type": "string",
          "enum": [
            "none",
            "module"
          ]
        },
        "appDefinitionId": true,
        "widgetId": true
      },
      "additionalProperties": false
    },
    "wixui.FastGallery": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "items": {
          "type": [
            "array"
          ],
          "items": true
        },
        "itemClickAction": {
          "type": "string",
          "enum": [
            "ACTION",
            "LINK",
            "NOTHING"
          ]
        },
        "downloadProtection": true,
        "wixSDKItems": {
          "type": [
            "array"
          ],
          "items": true
        }
      },
      "additionalProperties": false
    },
    "wixui.HamburgerMenuContainer": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true
      },
      "additionalProperties": false
    },
    "wixui.HamburgerMenuRoot": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true
      },
      "additionalProperties": false
    },
    "ImageX": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "image": {
          "type": "object",
          "properties": {
            "uri": true,
            "alt": true,
            "name": true,
            "height": true,
            "width": true,
            "decorative": true
          },
          "additionalProperties": false
        },
        "link": true,
        "scopedData": {
          "type": [
            "null",
            "array"
          ],
          "items": {
            "type": "object",
            "properties": {
              "breakpoint": true,
              "crop": {
                "type": "object",
                "properties": {
                  "x": true,
                  "y": true,
                  "width": true,
                  "height": true,
                  "svgId": true,
                  "rotate": true,
                  "flip": {
                    "type": "string",
                    "enum": [
                      "x",
                      "y",
                      "xy",
                      "none"
                    ]
                  }
                },
                "additionalProperties": false
              },
              "focalPoint": {
                "type": "object",
                "properties": {
                  "x": true,
                  "y": true
                },
                "additionalProperties": false
              },
              "displayMode": {
                "type": "string",
                "enum": [
                  "fill",
                  "fit",
                  "fitWidth"
                ]
              },
              "scrollEffect": {
                "type": "string",
                "enum": [
                  "parallax",
                  "fixed",
                  "zoomIn",
                  "fadeIn",
                  "none"
                ]
              },
              "clickAction": {
                "type": "string",
                "enum": [
                  "none",
                  "goToLink"
                ]
              }
            },
            "additionalProperties": false
          }
        },
        "mask": {
          "type": [
            "object",
            "null"
          ],
          "properties": {
            "x": true,
            "y": true,
            "width": true,
            "height": true,
            "svgId": true,
            "flip": {
              "type": "string",
              "enum": [
                "x",
                "y",
                "xy",
                "none"
              ]
            },
            "rotate": true,
            "mode": {
              "type": "string",
              "enum": [
                "alpha",
                "luminance"
              ]
            }
          },
          "additionalProperties": false
        },
        "parallaxSpeed": true,
        "parallaxDirection": {
          "type": "string",
          "enum": [
            "normal",
            "reverse"
          ]
        },
        "hasAnimation": true
      },
      "additionalProperties": false
    },
    "Crop": {
      "type": "object",
      "properties": {
        "x": true,
        "y": true,
        "width": true,
        "height": true,
        "svgId": true,
        "rotate": true,
        "flip": {
          "type": "string",
          "enum": [
            "x",
            "y",
            "xy",
            "none"
          ]
        }
      },
      "additionalProperties": false
    },
    "FocalPoint": {
      "type": "object",
      "properties": {
        "x": true,
        "y": true
      },
      "additionalProperties": false
    },
    "LanguageSelector": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        }
      },
      "additionalProperties": false
    },
    "wixui.MegaMenuContainerItem": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true
      },
      "additionalProperties": false
    },
    "MenuData": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "direction": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "itemDirection": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "submenuDirection": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "submenuItemDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "submenuSubItemDirection": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "navAriaLabel": true,
        "menuRef": true,
        "a11y": true
      },
      "additionalProperties": false
    },
    "wixui.MenuList": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "menus": {
          "type": [
            "array"
          ],
          "items": true
        }
      },
      "additionalProperties": false
    },
    "MusicPlayerData": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "coverDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "textDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "audioRef": true,
        "audioUrl": true,
        "playListId": true,
        "playlist": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "artistName": true,
              "trackName": true,
              "url": true,
              "cover": true,
              "durationFormatted": true
            },
            "additionalProperties": false
          }
        },
        "coverRef": true,
        "coverUrl": true,
        "artistName": true,
        "trackName": true,
        "description": true
      },
      "additionalProperties": false
    },
    "WixAudio": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "uri": true,
        "title": true,
        "duration": true
      },
      "additionalProperties": false
    },
    "Pagination": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "totalPages": true,
        "currentPage": true,
        "nextText": true,
        "previousText": true,
        "firstText": true,
        "lastText": true,
        "nextAriaLabel": true,
        "previousAriaLabel": true,
        "firstAriaLabel": true,
        "lastAriaLabel": true,
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "a11y": true
      },
      "additionalProperties": false
    },
    "PaginationA11y": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "label": true
      },
      "additionalProperties": false
    },
    "ProgressBar": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "value": true,
        "targetValue": true,
        "label": true,
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "labelDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "barDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        }
      },
      "additionalProperties": false
    },
    "RatingsDisplay": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "labelDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "ratingsDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "rating": true,
        "svgId": true,
        "numRatings": true,
        "reviewsCountLabel": true,
        "noReviewsPlaceholder": true
      },
      "additionalProperties": false
    },
    "RatingsInput": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "value": true,
        "titleText": true,
        "svgId": true,
        "labels": true,
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        }
      },
      "additionalProperties": false
    },
    "wixui.RichContentViewer": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "content": true,
        "trimEnabled": true,
        "trimMode": true,
        "trimLengthParagraph": true,
        "trimLengthWord": true,
        "trimExclude": true,
        "trimEllipsisEnabled": true,
        "trimEllipsisExpandText": true,
        "trimEllipsisCollapseText": true
      },
      "additionalProperties": false
    },
    "RichTextBox": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "maxLength": true,
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "labelDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "inputDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "value": true,
        "name": true,
        "formGroup": true
      },
      "additionalProperties": false
    },
    "SearchBox": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "placeholder": true,
        "suggestionsEnabled": true,
        "clearButtonText": true,
        "displaySettingsToggles": true
      },
      "additionalProperties": false
    },
    "Section": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "a11y": true
      },
      "additionalProperties": false
    },
    "SectionA11y": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "tabindex": true,
        "label": true,
        "live": {
          "type": "string",
          "enum": [
            "polite",
            "assertive"
          ]
        },
        "role": {
          "type": "string",
          "enum": [
            "heading",
            "alert",
            "status"
          ]
        },
        "atomic": true,
        "hidden": true,
        "current": {
          "type": "string",
          "enum": [
            "step",
            "page",
            "true",
            "false",
            "location",
            "date",
            "time"
          ]
        },
        "level": true
      },
      "additionalProperties": false
    },
    "wixui.SelectableContainer": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true
      },
      "additionalProperties": false
    },
    "wixui.SelectableContainerInput": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true
      },
      "additionalProperties": false
    },
    "SelectionTagsList": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "options": {
          "type": [
            "array"
          ],
          "items": true
        },
        "value": {
          "type": "array",
          "items": true
        },
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "labelDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "inputDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        }
      },
      "additionalProperties": false
    },
    "SelectionTag": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "value": true,
        "label": true,
        "link": true,
        "rel": {
          "type": "string",
          "enum": [
            "nofollow"
          ]
        }
      },
      "additionalProperties": false
    },
    "SignatureInput": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "titleText": true,
        "clearButtonText": true,
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "labelDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "inputDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "buttonDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "radioButtonsDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        }
      },
      "additionalProperties": false
    },
    "SiteButtonData": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "direction": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "link": {
          "type": [
            "null",
            "string"
          ],
          "pattern": "^$|^#"
        },
        "label": true,
        "a11y": true
      },
      "additionalProperties": false
    },
    "Slider": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "labelDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "trackDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "tooltipDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "min": true,
        "max": true,
        "value": true,
        "step": true,
        "stepType": {
          "type": "string",
          "enum": [
            "value",
            "count"
          ]
        },
        "disabled": true,
        "readOnly": true,
        "label": true
      },
      "additionalProperties": false
    },
    "wixui.Slideshow": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "direction": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        }
      },
      "additionalProperties": false
    },
    "SocialAuth": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true
      },
      "additionalProperties": false
    },
    "StylableButton": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "link": true,
        "label": true,
        "svgId": true,
        "isIconAnimated": true,
        "animatedIcon": {
          "type": "object",
          "properties": {
            "svgIdAnimationSelected": true,
            "customAnimatedIcon": {
              "type": [
                "object"
              ],
              "properties": {
                "svgIdAnimationStart": true,
                "svgIdAnimationEnd": true,
                "svgIdAnimationSelected": true
              },
              "additionalProperties": false
            },
            "animationDuration": true
          },
          "additionalProperties": false
        },
        "a11y": true,
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        }
      },
      "additionalProperties": false
    },
    "StylableButtonA11y": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "tabindex": true,
        "pressed": true,
        "expanded": true,
        "disabled": true,
        "haspopup": {
          "type": "string",
          "enum": [
            "true",
            "false",
            "dialog",
            "menu"
          ]
        },
        "label": true,
        "live": {
          "type": "string",
          "enum": [
            "polite",
            "assertive"
          ]
        }
      },
      "additionalProperties": false
    },
    "Submenu": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "itemDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "subItemDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        }
      },
      "additionalProperties": false
    },
    "SvgImage": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "decorative": true,
        "alt": true,
        "displayMode": {
          "type": "string",
          "enum": [
            "fit",
            "stretch"
          ]
        },
        "svgId": true,
        "link": {
          "type": [
            "null",
            "string"
          ],
          "pattern": "^$|^#"
        }
      },
      "additionalProperties": false
    },
    "wixui.Tabs": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "tabIds": {
          "type": "array",
          "items": true
        },
        "defaultTabId": true,
        "a11y": true,
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        }
      },
      "additionalProperties": false
    },
    "TabsA11y": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "tabindex": true,
        "label": true
      },
      "additionalProperties": false
    },
    "TextEffectsSharedData": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "text": true,
        "link": {
          "type": [
            "null",
            "string"
          ],
          "pattern": "^$|^#"
        },
        "isDecorative": true,
        "tagName": {
          "type": "string",
          "enum": [
            "h1",
            "h2",
            "h3",
            "h4",
            "h5",
            "h6",
            "blockquote",
            "div",
            "p"
          ]
        },
        "textDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "patternScope": {
          "type": "string",
          "enum": [
            "none",
            "character",
            "word"
          ]
        }
      },
      "additionalProperties": false
    },
    "TextMarqueeData": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "movementDirection": {
          "type": "string",
          "enum": [
            "rtl",
            "ltr"
          ]
        },
        "speed": true,
        "pauseOnHover": true,
        "textDirection": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl"
          ]
        },
        "headingLevel": true,
        "isDecorative": true,
        "tagName": {
          "type": "string",
          "enum": [
            "h1",
            "h2",
            "h3",
            "h4",
            "h5",
            "h6",
            "blockquote",
            "div",
            "p"
          ]
        },
        "svgId": true,
        "items": {
          "type": [
            "array"
          ],
          "items": true
        }
      },
      "additionalProperties": false
    },
    "TextMarqueeItem": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "link": {
          "type": [
            "null",
            "string"
          ],
          "pattern": "^$|^#"
        },
        "text": true
      },
      "additionalProperties": false
    },
    "TextFxData": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "text": true,
        "headingLevel": true,
        "isDecorative": true,
        "direction": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl"
          ]
        },
        "link": {
          "type": [
            "null",
            "string"
          ],
          "pattern": "^$|^#"
        },
        "tagName": {
          "type": "string",
          "enum": [
            "h1",
            "h2",
            "h3",
            "h4",
            "h5",
            "h6",
            "blockquote",
            "div",
            "p"
          ]
        }
      },
      "additionalProperties": false
    },
    "TextOnPathData": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "isDecorative": true,
        "text": true,
        "path": true,
        "pathLength": true,
        "viewBox": true,
        "speed": true,
        "movementDirection": {
          "type": "string",
          "enum": [
            "forward",
            "reverse"
          ]
        },
        "pauseOnHover": true,
        "direction": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl"
          ]
        },
        "tagName": {
          "type": "string",
          "enum": [
            "h1",
            "h2",
            "h3",
            "h4",
            "h5",
            "h6",
            "blockquote",
            "div"
          ]
        },
        "fillMode": {
          "type": "string",
          "enum": [
            "normal",
            "repeat",
            "justify"
          ]
        },
        "link": {
          "type": [
            "null",
            "string"
          ],
          "pattern": "^$|^#"
        },
        "startOffset": true,
        "fontSize": true,
        "pathStrokeWidth": true
      },
      "additionalProperties": false
    },
    "TimePickerData": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "labelDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "inputDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "placeholder": true,
        "step": true,
        "label": true,
        "margin": true,
        "disabledTimes": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "startTime": true,
              "endTime": true
            },
            "additionalProperties": false
          }
        },
        "value": true,
        "name": true,
        "formGroup": true
      },
      "additionalProperties": false
    },
    "ToggleSwitch": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "checked": true,
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "value": true,
        "name": true,
        "formGroup": true
      },
      "additionalProperties": false
    },
    "UnsupportedComponentData": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "migratedFrom": true
      },
      "additionalProperties": false
    },
    "VideoPlayer": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "videoType": {
          "type": "string",
          "enum": [
            "dailymotion",
            "facebook",
            "file",
            "twitch",
            "vimeo",
            "youtube"
          ]
        },
        "videoRef": true,
        "videoUrl": true,
        "posterUrl": true,
        "videoTitle": true,
        "description": true,
        "logoRef": true
      },
      "additionalProperties": false
    },
    "dsgnsys.ControlTypes": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "shortString": true,
        "longString": true,
        "options": {
          "type": [
            "array"
          ],
          "items": true
        },
        "dropdown": {
          "type": "string",
          "enum": [
            "Options 1",
            "Options 2",
            "Options 3",
            "Options 4"
          ]
        },
        "radioButtons": {
          "type": "string",
          "enum": [
            "Options 1",
            "Options 2",
            "Options 3",
            "Options 4"
          ]
        },
        "toggleSwitch": true,
        "thumbnails": true,
        "link": {
          "type": [
            "null",
            "string"
          ],
          "pattern": "^$|^#"
        },
        "slider": true,
        "numericInput": true,
        "colorPickerInput": true,
        "selectedFont": true
      },
      "additionalProperties": false
    },
    "dsgnsys.DashboardButton": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "label": true,
        "link": {
          "type": [
            "null",
            "string"
          ],
          "pattern": "^$|^#"
        },
        "skin": {
          "type": "string",
          "enum": [
            "Standard",
            "Light",
            "Destructive",
            "Premium",
            "Premium light",
            "Dark",
            "Transparent"
          ]
        },
        "showPrefix": true,
        "prefixIcon": true,
        "showSuffix": true,
        "suffixIcon": true,
        "disabled": true,
        "size": {
          "type": "string",
          "enum": [
            "Tiny",
            "Small",
            "Medium",
            "Large"
          ]
        },
        "priority": {
          "type": "string",
          "enum": [
            "Primary",
            "Secondary"
          ]
        }
      },
      "additionalProperties": false
    },
    "dsgnsys.DashboardHeading": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "text": true,
        "size": {
          "type": "string",
          "enum": [
            "Page title H1",
            "Modal title H2",
            "Card title H3",
            "Section title H4",
            "Card section title H5",
            "Caption H6"
          ]
        },
        "invertColor": true,
        "textAlignment": {
          "type": "string",
          "enum": [
            "Left",
            "Center",
            "Right"
          ]
        }
      },
      "additionalProperties": false
    },
    "dsgnsys.DashboardIconButton": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "icon": true,
        "tooltip": true,
        "link": {
          "type": [
            "null",
            "string"
          ],
          "pattern": "^$|^#"
        },
        "skin": {
          "type": "string",
          "enum": [
            "Standard",
            "Premium",
            "Light",
            "Transparent"
          ]
        },
        "disabled": true,
        "size": {
          "type": "string",
          "enum": [
            "Tiny",
            "Small",
            "Medium",
            "Large"
          ]
        },
        "priority": {
          "type": "string",
          "enum": [
            "Primary",
            "Secondary"
          ]
        }
      },
      "additionalProperties": false
    },
    "dsgnsys.DashboardInfoIcon": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "tooltip": true,
        "addLink": true,
        "tooltipLinkText": true,
        "tooltipLink": {
          "type": [
            "null",
            "string"
          ],
          "pattern": "^$|^#"
        },
        "size": {
          "type": "string",
          "enum": [
            "Small",
            "Medium"
          ]
        }
      },
      "additionalProperties": false
    },
    "dsgnsys.DashboardInput": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "label": true,
        "placeholder": true,
        "value": true,
        "showTooltip": true,
        "tooltip": true,
        "showPrefix": true,
        "prefixType": {
          "type": "string",
          "enum": [
            "Icon",
            "Text"
          ]
        },
        "prefixIcon": true,
        "prefixValue": true,
        "showSuffix": true,
        "suffixType": {
          "type": "string",
          "enum": [
            "Icon",
            "Text"
          ]
        },
        "suffixIcon": true,
        "suffixValue": true,
        "required": true,
        "setMaxLength": true,
        "maxLength": true,
        "disabled": true,
        "readOnly": true,
        "size": {
          "type": "string",
          "enum": [
            "Small",
            "Medium",
            "Large"
          ]
        },
        "border": {
          "type": "string",
          "enum": [
            "Default",
            "Round",
            "Line",
            "None"
          ]
        },
        "labelPosition": {
          "type": "string",
          "enum": [
            "Top",
            "Left",
            "Right"
          ]
        }
      },
      "additionalProperties": false
    },
    "dsgnsys.DashboardNumberInput": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "label": true,
        "placeholder": true,
        "value": true,
        "showTooltip": true,
        "tooltip": true,
        "showPrefix": true,
        "prefixType": {
          "type": "string",
          "enum": [
            "Icon",
            "Text"
          ]
        },
        "prefixIcon": true,
        "prefixValue": true,
        "showSuffix": true,
        "suffixType": {
          "type": "string",
          "enum": [
            "Icon",
            "Text"
          ]
        },
        "suffixIcon": true,
        "suffixValue": true,
        "required": true,
        "minAndMaxValues": true,
        "min": true,
        "max": true,
        "stepSize": true,
        "disabled": true,
        "readOnly": true,
        "size": {
          "type": "string",
          "enum": [
            "Small",
            "Medium",
            "Large"
          ]
        },
        "border": {
          "type": "string",
          "enum": [
            "Default",
            "Round",
            "Line",
            "None"
          ]
        },
        "labelPlacement": {
          "type": "string",
          "enum": [
            "Top",
            "Left",
            "Right"
          ]
        }
      },
      "additionalProperties": false
    },
    "dsgnsys.DashboardText": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "text": true,
        "preset": {
          "type": "string",
          "enum": [
            "Standard",
            "Standard secondary",
            "Light",
            "Light secondary",
            "Success",
            "Destructive",
            "Primary",
            "Premium",
            "Disabled"
          ]
        },
        "size": {
          "type": "string",
          "enum": [
            "Tiny",
            "Small",
            "Medium"
          ]
        },
        "weight": {
          "type": "string",
          "enum": [
            "Bold",
            "Normal",
            "Thin"
          ]
        },
        "textAlignment": {
          "type": "string",
          "enum": [
            "Left",
            "Center",
            "Right"
          ]
        },
        "overflow": {
          "type": "string",
          "enum": [
            "Wrap",
            "Ellipsis"
          ]
        },
        "maxLines": true
      },
      "additionalProperties": false
    },
    "dsgnsys.DashboardTextButton": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "label": true,
        "link": {
          "type": [
            "null",
            "string"
          ],
          "pattern": "^$|^#"
        },
        "skin": {
          "type": "string",
          "enum": [
            "Standard",
            "Premium",
            "Light",
            "Dark",
            "Destructive"
          ]
        },
        "showPrefix": true,
        "prefixIcon": true,
        "showSuffix": true,
        "suffixIcon": true,
        "underline": {
          "type": "string",
          "enum": [
            "Never",
            "On hover",
            "Always"
          ]
        },
        "disabled": true,
        "size": {
          "type": "string",
          "enum": [
            "Tiny",
            "Small",
            "Medium"
          ]
        },
        "weight": {
          "type": "string",
          "enum": [
            "Regular",
            "Medium"
          ]
        }
      },
      "additionalProperties": false
    },
    "dsgnsys.DashboardToggleSwitch": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "label": true,
        "checked": true,
        "skin": {
          "type": "string",
          "enum": [
            "Standard",
            "Success",
            "Destructive"
          ]
        },
        "showTooltip": true,
        "tooltip": true,
        "disabled": true,
        "size": {
          "type": "string",
          "enum": [
            "Small",
            "Medium",
            "Large"
          ]
        },
        "labelPosition": {
          "type": "string",
          "enum": [
            "Top",
            "Left",
            "Right"
          ]
        }
      },
      "additionalProperties": false
    },
    "dsgnsys.SettingsPanelContainer": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "theme": {
          "type": "string",
          "enum": [
            "classic",
            "responsive"
          ]
        },
        "debug": true
      },
      "additionalProperties": false
    },
    "dsgnsys.WbuAccordion": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "label": true,
        "tooltip": true,
        "openByDefault": true
      },
      "additionalProperties": false
    },
    "dsgnsys.WbuBackButton": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "label": true
      },
      "additionalProperties": false
    },
    "dsgnsys.WbuButton": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "fieldTitle": true,
        "tooltipInfo": true,
        "label": true,
        "skin": {
          "type": "string",
          "enum": [
            "standard",
            "standard secondary",
            "premium",
            "premium secondary",
            "alert",
            "alert secondary",
            "inverted"
          ]
        },
        "size": {
          "type": "string",
          "enum": [
            "small",
            "medium",
            "large"
          ]
        },
        "prefixIcon": true,
        "suffixIcon": true,
        "fullWidth": true,
        "divider": {
          "type": "string",
          "enum": [
            "long",
            "short",
            "none"
          ]
        }
      },
      "additionalProperties": false
    },
    "dsgnsys.WbuCheckboxGroup": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "fieldTitle": true,
        "options": {
          "type": [
            "array"
          ],
          "items": true
        },
        "tooltipInfo": true,
        "divider": {
          "type": "string",
          "enum": [
            "long",
            "short",
            "none"
          ]
        }
      },
      "additionalProperties": false
    },
    "dsgnsys.WbuColorPicker": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "label": true,
        "tooltip": true,
        "opacity": true,
        "showPercentage": true,
        "opacitySliderEnabled": true,
        "color": true,
        "divider": {
          "type": "string",
          "enum": [
            "long",
            "short",
            "none"
          ]
        }
      },
      "additionalProperties": false
    },
    "dsgnsys.WbuColorSelector": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "label": true,
        "color": true,
        "divider": {
          "type": "string",
          "enum": [
            "long",
            "short",
            "none"
          ]
        }
      },
      "additionalProperties": false
    },
    "dsgnsys.WbuColumnControllerControl": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "fieldTitle": true,
        "tooltipMessage": true,
        "enableReorder": true,
        "minimumValue": true,
        "dividerType": {
          "type": "string",
          "enum": [
            "long",
            "short",
            "none"
          ]
        },
        "columns": {
          "type": [
            "array"
          ],
          "items": true
        }
      },
      "additionalProperties": false
    },
    "dsgnsys.WbuDatePicker": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "label": true,
        "tooltip": true,
        "placeholder": true,
        "divider": {
          "type": "string",
          "enum": [
            "long",
            "short",
            "none"
          ]
        }
      },
      "additionalProperties": false
    },
    "dsgnsys.WbuDrillDown": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "label": true,
        "description": true,
        "iconType": {
          "type": "string",
          "enum": [
            "None",
            "Info",
            "Alert"
          ]
        },
        "tooltip": true
      },
      "additionalProperties": false
    },
    "dsgnsys.WbuDropdown": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "fieldTitle": true,
        "options": {
          "type": [
            "array"
          ],
          "items": true
        },
        "tooltipInfo": true,
        "placeholder": true,
        "divider": {
          "type": "string",
          "enum": [
            "long",
            "short",
            "none"
          ]
        }
      },
      "additionalProperties": false
    },
    "dsgnsys.WbuEmptyState": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "label": true,
        "description": true,
        "textButtonLabel": true,
        "url": true,
        "illustration": true
      },
      "additionalProperties": false
    },
    "dsgnsys.WbuFontAndColorPicker": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "label": true,
        "tooltip": true,
        "font": true,
        "color": true,
        "divider": {
          "type": "string",
          "enum": [
            "long",
            "short",
            "none"
          ]
        }
      },
      "additionalProperties": false
    },
    "dsgnsys.WbuHorizontalTabs": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "tabsStyle": {
          "type": "string",
          "enum": [
            "Folder",
            "Arrowed",
            "Arrowed Without a Line"
          ]
        },
        "options": {
          "type": [
            "array"
          ],
          "items": true
        },
        "maxVisibleTabs": true,
        "tabsToScroll": true
      },
      "additionalProperties": false
    },
    "dsgnsys.WbuLeftTextButton": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "text": true,
        "url": true,
        "size": {
          "type": "string",
          "enum": [
            "tiny",
            "small",
            "medium"
          ]
        },
        "skin": {
          "type": "string",
          "enum": [
            "standard",
            "premium"
          ]
        },
        "weight": {
          "type": "string",
          "enum": [
            "thin",
            "normal"
          ]
        },
        "prefixIcon": true,
        "suffixIcon": true,
        "divider": {
          "type": "string",
          "enum": [
            "long",
            "short",
            "none"
          ]
        }
      },
      "additionalProperties": false
    },
    "dsgnsys.WbuMultilineTextInput": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "label": true,
        "tooltip": true,
        "value": true,
        "placeholder": true,
        "maxLength": true,
        "closeOnEnterKeyPress": true,
        "autoFocus": true,
        "selectTextOnFocus": true,
        "readOnly": true,
        "usePatternValidation": true,
        "regexPattern": true,
        "validationMessage": true,
        "divider": {
          "type": "string",
          "enum": [
            "long",
            "short",
            "none"
          ]
        }
      },
      "additionalProperties": false
    },
    "dsgnsys.WbuNotificationBanner": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "label": true,
        "skin": {
          "type": "string",
          "enum": [
            "standard",
            "premium",
            "alert",
            "success"
          ]
        },
        "linkText": true,
        "linkUrl": true,
        "iconTooltipText": true,
        "multiline": true
      },
      "additionalProperties": false
    },
    "dsgnsys.WbuNumericInput": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "title": true,
        "value": true,
        "unitSuffix": {
          "type": "string",
          "enum": [
            "None",
            "Pixels",
            "Percentage",
            "Degrees"
          ]
        },
        "numberOfFractions": true,
        "steps": true,
        "stepControls": true,
        "minValue": true,
        "maxValue": true,
        "divider": {
          "type": "string",
          "enum": [
            "long",
            "short",
            "none"
          ]
        }
      },
      "additionalProperties": false
    },
    "dsgnsys.WbuRadioButtonGroup": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "fieldTitle": true,
        "options": {
          "type": [
            "array"
          ],
          "items": true
        },
        "tooltipInfo": true,
        "divider": {
          "type": "string",
          "enum": [
            "long",
            "short",
            "none"
          ]
        }
      },
      "additionalProperties": false
    },
    "dsgnsys.WbuRichText": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "richTextContent": true,
        "richTextLabel": true,
        "link": {
          "type": [
            "null",
            "string"
          ],
          "pattern": "^$|^#"
        },
        "richTextLink": true,
        "alignTextToCenter": true,
        "divider": {
          "type": "string",
          "enum": [
            "long",
            "short",
            "none"
          ]
        }
      },
      "additionalProperties": false
    },
    "dsgnsys.WbuSectionDivider": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "sectionTitle": true,
        "tooltipInfo": true
      },
      "additionalProperties": false
    },
    "dsgnsys.WbuSlider": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "fieldTitle": true,
        "tooltipInfo": true,
        "unitOfMeasurement": {
          "type": "string",
          "enum": [
            "number",
            "percentage",
            "pixels",
            "angle"
          ]
        },
        "defaultSelectedValue": true,
        "minimumValue": true,
        "maximumValue": true,
        "stepValue": true,
        "showNumericInput": true,
        "divider": {
          "type": "string",
          "enum": [
            "long",
            "short",
            "none"
          ]
        }
      },
      "additionalProperties": false
    },
    "dsgnsys.WbuTextInput": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "fieldTitle": true,
        "tooltipInfo": true,
        "defaultText": true,
        "placeholder": true,
        "prefix": true,
        "readOnly": true,
        "autofocus": true,
        "selectedOnFocus": true,
        "charactersLimit": true,
        "usePatternValidation": true,
        "regexPattern": true,
        "errorMessage": true,
        "divider": {
          "type": "string",
          "enum": [
            "long",
            "short",
            "none"
          ]
        }
      },
      "additionalProperties": false
    },
    "dsgnsys.WbuThumbnails": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "fieldTitle": true,
        "tooltipInfo": true,
        "setNumberOfColumns": true,
        "showEmptyThumbnail": true,
        "thumbnailHeight": {
          "type": "string",
          "enum": [
            "Fixed ratio (1:1)",
            "Fluid"
          ]
        },
        "displayLabels": true,
        "options": {
          "type": [
            "array"
          ],
          "items": true
        },
        "divider": {
          "type": "string",
          "enum": [
            "long",
            "short",
            "none"
          ]
        }
      },
      "additionalProperties": false
    },
    "ThumbnailItemData": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "label": true,
        "value": true,
        "disabled": true,
        "isDefault": true,
        "unavailable": true,
        "illustration": true
      },
      "additionalProperties": false
    },
    "dsgnsys.WbuToggleSwitch": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "label": true,
        "toggleSwitch": true,
        "disabled": true,
        "divider": {
          "type": "string",
          "enum": [
            "long",
            "short",
            "none"
          ]
        }
      },
      "additionalProperties": false
    },
    "dsgnsys.WutAvatar": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "firstName": true,
        "lastName": true,
        "src": true
      },
      "additionalProperties": false
    },
    "dsgnsys.WutAvatarGroup": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "maxAvatars": true,
        "showHiddenAvatarCount": true,
        "avatars": {
          "type": [
            "array"
          ],
          "items": true
        }
      },
      "additionalProperties": false
    },
    "dsgnsys.WutBadge": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "text": true,
        "icon": true,
        "composition": {
          "type": "string",
          "enum": [
            "TextAndIcon",
            "Text",
            "Icon",
            "None"
          ]
        },
        "alt": true
      },
      "additionalProperties": false
    },
    "dsgnsys.WutRadioButton": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "radioGroupName": true,
        "value": true,
        "checked": true,
        "required": true
      },
      "additionalProperties": false
    }
  },
  "editorsettings.json": {
    "$id": "urn:dm:schemas:editorsettings.json",
    "EditorSettings": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "dockingBehavior": {
          "type": "string",
          "enum": [
            "heuristic",
            "keep"
          ]
        },
        "layoutIntent": {
          "type": "string",
          "enum": [
            "SuperGrid",
            "CssGrid"
          ]
        },
        "sizingBehavior": {
          "type": "string",
          "enum": [
            "preset",
            "advanced"
          ]
        },
        "aspectRatioLock": true,
        "disableAutoDOMOrder": true,
        "progressStatus": {
          "type": "string",
          "enum": [
            "UNKNOWN",
            "TO_DO",
            "IN_PROGRESS",
            "ITERATE",
            "DONE"
          ]
        },
        "linkedComponents": {
          "type": "object",
          "patternProperties": {
            "^comp_": true
          }
        }
      },
      "additionalProperties": false
    }
  },
  "effects.json": {
    "$id": "urn:dm:schemas:effects.json",
    "KeyframeEffectList": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "values": {
          "type": [
            "array",
            "null"
          ],
          "items": true
        }
      },
      "additionalProperties": false
    },
    "KeyframeEffect": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "name": true,
        "keyframes": {
          "type": [
            "array",
            "null"
          ],
          "items": true
        }
      },
      "additionalProperties": false
    },
    "Keyframe": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "offset": true,
        "effectStyle": {
          "type": "object",
          "properties": {
            "opacity": true,
            "clipPath": {
              "type": "object",
              "properties": {
                "clipType": {
                  "type": "string",
                  "enum": [
                    "inset",
                    "circle",
                    "ellipse",
                    "polygon",
                    "path"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            }
          },
          "additionalProperties": false
        },
        "transform": true
      },
      "additionalProperties": false
    },
    "EffectsList": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "values": {
          "type": [
            "array",
            "null"
          ],
          "items": true
        }
      },
      "additionalProperties": false
    },
    "CanvasAnimation": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "name": true,
        "value": true
      },
      "additionalProperties": false
    },
    "CanvasAnimationOptions": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "namedEffect": true
      },
      "additionalProperties": false
    },
    "TimeAnimationOptions": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "duration": true,
        "delay": true,
        "endDelay": true,
        "allowReplay": {
          "type": "string",
          "enum": [
            "perPageView",
            "always",
            "never"
          ]
        },
        "keyframeEffect": true,
        "namedEffect": true,
        "customEffect": {
          "type": "object",
          "properties": {
            "ranges": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "name": {
                    "type": "string",
                    "enum": [
                      "offset",
                      "intensity",
                      "mouse",
                      "scroll",
                      "mouseIntensity"
                    ]
                  },
                  "min": true,
                  "max": true,
                  "step": true
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "easing": {
          "type": "string",
          "enum": [
            "linear",
            "ease",
            "easeIn",
            "easeOut",
            "easeInOut",
            "sineIn",
            "sineOut",
            "sineInOut",
            "quadIn",
            "quadOut",
            "quadInOut",
            "cubicIn",
            "cubicOut",
            "cubicInOut",
            "quartIn",
            "quartOut",
            "quartInOut",
            "quintIn",
            "quintOut",
            "quintInOut",
            "expoIn",
            "expoOut",
            "expoInOut",
            "circIn",
            "circOut",
            "circInOut",
            "backIn",
            "backOut",
            "backInOut",
            "hardBackOut"
          ]
        },
        "iterations": true,
        "alternate": true,
        "fill": {
          "type": "string",
          "enum": [
            "none",
            "backwards",
            "forwards",
            "both"
          ]
        },
        "reversed": true
      },
      "additionalProperties": false
    },
    "TimeAnimation": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "name": true,
        "value": true
      },
      "additionalProperties": false
    },
    "ScrubAnimationOptions": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "duration": {
          "type": "object",
          "properties": {
            "value": true,
            "type": {
              "enum": [
                "px",
                "em",
                "rem",
                "percentage",
                "vh",
                "vw",
                "vmin",
                "vmax"
              ]
            }
          },
          "additionalProperties": false
        },
        "startOffset": {
          "type": "object",
          "properties": {
            "name": {
              "type": "string",
              "enum": [
                "entry",
                "exit",
                "contain",
                "cover"
              ]
            },
            "offset": {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "percentage",
                    "vh",
                    "vw",
                    "vmin",
                    "vmax"
                  ]
                }
              },
              "additionalProperties": false
            }
          },
          "additionalProperties": false
        },
        "endOffset": {
          "type": "object",
          "properties": {
            "name": {
              "type": "string",
              "enum": [
                "entry",
                "exit",
                "contain",
                "cover"
              ]
            },
            "offset": {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "percentage",
                    "vh",
                    "vw",
                    "vmin",
                    "vmax"
                  ]
                }
              },
              "additionalProperties": false
            }
          },
          "additionalProperties": false
        },
        "centeredToTarget": true,
        "playbackRate": true,
        "transitionDuration": true,
        "transitionDelay": true,
        "transitionEasing": {
          "type": "string",
          "enum": [
            "linear",
            "ease",
            "easeIn",
            "easeOut",
            "easeInOut",
            "sineIn",
            "sineOut",
            "sineInOut",
            "quadIn",
            "quadOut",
            "quadInOut",
            "cubicIn",
            "cubicOut",
            "cubicInOut",
            "quartIn",
            "quartOut",
            "quartInOut",
            "quintIn",
            "quintOut",
            "quintInOut",
            "expoIn",
            "expoOut",
            "expoInOut",
            "circIn",
            "circOut",
            "circInOut",
            "backIn",
            "backOut",
            "backInOut",
            "hardBackOut"
          ]
        },
        "keyframeEffect": true,
        "namedEffect": true,
        "customEffect": {
          "type": "object",
          "properties": {
            "ranges": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "name": {
                    "type": "string",
                    "enum": [
                      "offset",
                      "intensity",
                      "mouse",
                      "scroll",
                      "mouseIntensity"
                    ]
                  },
                  "min": true,
                  "max": true,
                  "step": true
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "easing": {
          "type": "string",
          "enum": [
            "linear",
            "ease",
            "easeIn",
            "easeOut",
            "easeInOut",
            "sineIn",
            "sineOut",
            "sineInOut",
            "quadIn",
            "quadOut",
            "quadInOut",
            "cubicIn",
            "cubicOut",
            "cubicInOut",
            "quartIn",
            "quartOut",
            "quartInOut",
            "quintIn",
            "quintOut",
            "quintInOut",
            "expoIn",
            "expoOut",
            "expoInOut",
            "circIn",
            "circOut",
            "circInOut",
            "backIn",
            "backOut",
            "backInOut",
            "hardBackOut"
          ]
        },
        "iterations": true,
        "alternate": true,
        "fill": {
          "type": "string",
          "enum": [
            "none",
            "backwards",
            "forwards",
            "both"
          ]
        },
        "reversed": true
      },
      "additionalProperties": false
    },
    "ScrubAnimation": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "name": true,
        "value": true
      },
      "additionalProperties": false
    },
    "AnimationCommonOptions": {
      "type": "object",
      "properties": {
        "keyframeEffect": true,
        "namedEffect": true,
        "customEffect": {
          "type": "object",
          "properties": {
            "ranges": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "name": {
                    "type": "string",
                    "enum": [
                      "offset",
                      "intensity",
                      "mouse",
                      "scroll",
                      "mouseIntensity"
                    ]
                  },
                  "min": true,
                  "max": true,
                  "step": true
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "easing": {
          "type": "string",
          "enum": [
            "linear",
            "ease",
            "easeIn",
            "easeOut",
            "easeInOut",
            "sineIn",
            "sineOut",
            "sineInOut",
            "quadIn",
            "quadOut",
            "quadInOut",
            "cubicIn",
            "cubicOut",
            "cubicInOut",
            "quartIn",
            "quartOut",
            "quartInOut",
            "quintIn",
            "quintOut",
            "quintInOut",
            "expoIn",
            "expoOut",
            "expoInOut",
            "circIn",
            "circOut",
            "circInOut",
            "backIn",
            "backOut",
            "backInOut",
            "hardBackOut"
          ]
        },
        "iterations": true,
        "alternate": true,
        "fill": {
          "type": "string",
          "enum": [
            "none",
            "backwards",
            "forwards",
            "both"
          ]
        },
        "reversed": true
      },
      "additionalProperties": false
    },
    "RangeOffset": {
      "type": "object",
      "properties": {
        "name": {
          "type": "string",
          "enum": [
            "entry",
            "exit",
            "contain",
            "cover"
          ]
        },
        "offset": {
          "type": "object",
          "properties": {
            "value": true,
            "type": {
              "enum": [
                "px",
                "em",
                "rem",
                "percentage",
                "vh",
                "vw",
                "vmin",
                "vmax"
              ]
            }
          },
          "additionalProperties": false
        }
      },
      "additionalProperties": false
    },
    "Easing": {
      "type": "string",
      "enum": [
        "linear",
        "ease",
        "easeIn",
        "easeOut",
        "easeInOut",
        "sineIn",
        "sineOut",
        "sineInOut",
        "quadIn",
        "quadOut",
        "quadInOut",
        "cubicIn",
        "cubicOut",
        "cubicInOut",
        "quartIn",
        "quartOut",
        "quartInOut",
        "quintIn",
        "quintOut",
        "quintInOut",
        "expoIn",
        "expoOut",
        "expoInOut",
        "circIn",
        "circOut",
        "circInOut",
        "backIn",
        "backOut",
        "backInOut",
        "hardBackOut"
      ]
    },
    "EffectPower": {
      "type": "string",
      "enum": [
        "soft",
        "medium",
        "hard"
      ]
    },
    "EffectScrollRange": {
      "type": "string",
      "enum": [
        "in",
        "out",
        "continuous"
      ]
    },
    "EffectScaleDirection": {
      "type": "string",
      "enum": [
        "up",
        "down"
      ]
    },
    "EffectFourDirections": {
      "type": "string",
      "enum": [
        "left",
        "right",
        "top",
        "bottom"
      ]
    },
    "EffectFourCorners": {
      "type": "string",
      "enum": [
        "top-left",
        "top-right",
        "bottom-left",
        "bottom-right"
      ]
    },
    "EffectEightDirections": {
      "type": "string",
      "enum": [
        "right",
        "top-right",
        "top",
        "top-left",
        "left",
        "bottom-left",
        "bottom",
        "bottom-right"
      ]
    },
    "EffectNineDirections": {
      "type": "string",
      "enum": [
        "right",
        "top-right",
        "top",
        "top-left",
        "left",
        "bottom-left",
        "bottom",
        "bottom-right",
        "center"
      ]
    },
    "EffectAxes": {
      "type": "string",
      "enum": [
        "horizontal",
        "vertical",
        "both"
      ]
    },
    "ArcIn": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "direction": {
          "type": "string",
          "enum": [
            "left",
            "right",
            "top",
            "bottom"
          ]
        },
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        }
      },
      "additionalProperties": false
    },
    "CurveIn": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "direction": {
          "type": "string",
          "enum": [
            "left",
            "right"
          ]
        }
      },
      "additionalProperties": false
    },
    "DropIn": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        },
        "initialScale": true
      },
      "additionalProperties": false
    },
    "ExpandIn": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        },
        "direction": {
          "type": "string",
          "enum": [
            "right",
            "top-right",
            "top",
            "top-left",
            "left",
            "bottom-left",
            "bottom",
            "bottom-right",
            "center"
          ]
        },
        "initialScale": true
      },
      "additionalProperties": false
    },
    "FadeIn": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true
      },
      "additionalProperties": false
    },
    "FlipIn": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        },
        "direction": {
          "type": "string",
          "enum": [
            "left",
            "right",
            "top",
            "bottom"
          ]
        },
        "initialRotate": true
      },
      "additionalProperties": false
    },
    "FloatIn": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "direction": {
          "type": "string",
          "enum": [
            "left",
            "right",
            "top",
            "bottom"
          ]
        }
      },
      "additionalProperties": false
    },
    "ShuttersIn": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "direction": {
          "type": "string",
          "enum": [
            "left",
            "right",
            "top",
            "bottom"
          ]
        },
        "shutters": true,
        "staggered": true
      },
      "additionalProperties": false
    },
    "FoldIn": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        },
        "direction": {
          "type": "string",
          "enum": [
            "left",
            "right",
            "top",
            "bottom"
          ]
        },
        "initialRotate": true
      },
      "additionalProperties": false
    },
    "SlideIn": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        },
        "direction": {
          "type": "string",
          "enum": [
            "left",
            "right",
            "top",
            "bottom"
          ]
        },
        "initialTranslate": true
      },
      "additionalProperties": false
    },
    "SpinIn": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "spins": true,
        "direction": {
          "type": "string",
          "enum": [
            "clockwise",
            "counter-clockwise"
          ]
        },
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        },
        "initialScale": true
      },
      "additionalProperties": false
    },
    "BounceIn": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "direction": {
          "anyOf": [
            {
              "type": "string",
              "enum": [
                "left",
                "right",
                "top",
                "bottom"
              ]
            },
            {
              "type": "string",
              "enum": [
                "center"
              ]
            }
          ]
        },
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        },
        "distanceFactor": true
      },
      "additionalProperties": false
    },
    "PunchIn": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "direction": {
          "anyOf": [
            {
              "type": "string",
              "enum": [
                "top-left",
                "top-right",
                "bottom-left",
                "bottom-right"
              ]
            },
            {
              "type": "string",
              "enum": [
                "center"
              ]
            }
          ]
        },
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        }
      },
      "additionalProperties": false
    },
    "GlideIn": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "direction": true,
        "startFromOffScreen": true,
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        },
        "distance": {
          "type": "object",
          "properties": {
            "value": true,
            "type": {
              "enum": [
                "px",
                "em",
                "rem",
                "percentage",
                "vh",
                "vw",
                "vmin",
                "vmax"
              ]
            }
          },
          "additionalProperties": false
        }
      },
      "additionalProperties": false
    },
    "GlitchIn": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "direction": true,
        "startFromOffScreen": true,
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        },
        "distance": {
          "type": "object",
          "properties": {
            "value": true,
            "type": {
              "enum": [
                "px",
                "em",
                "rem",
                "percentage",
                "vh",
                "vw",
                "vmin",
                "vmax"
              ]
            }
          },
          "additionalProperties": false
        }
      },
      "additionalProperties": false
    },
    "TurnIn": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "direction": {
          "type": "string",
          "enum": [
            "top-left",
            "top-right",
            "bottom-left",
            "bottom-right"
          ]
        },
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        }
      },
      "additionalProperties": false
    },
    "CircleIn": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "direction": {
          "type": "string",
          "enum": [
            "left",
            "right"
          ]
        }
      },
      "additionalProperties": false
    },
    "WinkIn": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "direction": {
          "type": "string",
          "enum": [
            "vertical",
            "horizontal"
          ]
        }
      },
      "additionalProperties": false
    },
    "TiltIn": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "direction": {
          "type": "string",
          "enum": [
            "left",
            "right"
          ]
        }
      },
      "additionalProperties": false
    },
    "ShapeIn": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "shape": {
          "type": "string",
          "enum": [
            "ellipse",
            "circle",
            "rectangle",
            "diamond",
            "window"
          ]
        },
        "direction": {
          "type": "string",
          "enum": [
            "right",
            "top-right",
            "top",
            "top-left",
            "left",
            "bottom-left",
            "bottom",
            "bottom-right",
            "center"
          ]
        }
      },
      "additionalProperties": false
    },
    "GrowIn": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        },
        "direction": true,
        "initialScale": true,
        "distance": {
          "type": "object",
          "properties": {
            "value": true,
            "type": {
              "enum": [
                "px",
                "em",
                "rem",
                "percentage",
                "vh",
                "vw",
                "vmin",
                "vmax"
              ]
            }
          },
          "additionalProperties": false
        }
      },
      "additionalProperties": false
    },
    "FlyIn": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "direction": {
          "type": "string",
          "enum": [
            "right",
            "top-right",
            "top",
            "top-left",
            "left",
            "bottom-left",
            "bottom",
            "bottom-right"
          ]
        }
      },
      "additionalProperties": false
    },
    "RevealIn": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "direction": {
          "type": "string",
          "enum": [
            "left",
            "right",
            "top",
            "bottom"
          ]
        }
      },
      "additionalProperties": false
    },
    "BlurIn": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        },
        "blur": true
      },
      "additionalProperties": false
    },
    "Breathe": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "direction": {
          "type": "string",
          "enum": [
            "vertical",
            "horizontal",
            "center"
          ]
        },
        "distance": {
          "type": "object",
          "properties": {
            "value": true,
            "type": {
              "enum": [
                "px",
                "em",
                "rem",
                "percentage",
                "vh",
                "vw",
                "vmin",
                "vmax"
              ]
            }
          },
          "additionalProperties": false
        }
      },
      "additionalProperties": false
    },
    "Blink": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "distance": {
          "type": "object",
          "properties": {
            "value": true,
            "type": {
              "enum": [
                "px",
                "em",
                "rem",
                "percentage",
                "vh",
                "vw",
                "vmin",
                "vmax"
              ]
            }
          },
          "additionalProperties": false
        },
        "scale": true,
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        }
      },
      "additionalProperties": false
    },
    "Pulse": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        },
        "intensity": true
      },
      "additionalProperties": false
    },
    "Spin": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        },
        "direction": {
          "type": "string",
          "enum": [
            "clockwise",
            "counter-clockwise"
          ]
        }
      },
      "additionalProperties": false
    },
    "Poke": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "direction": {
          "type": "string",
          "enum": [
            "left",
            "right",
            "top",
            "bottom"
          ]
        },
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        },
        "intensity": true
      },
      "additionalProperties": false
    },
    "Flash": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true
      },
      "additionalProperties": false
    },
    "Swing": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        },
        "swing": true,
        "direction": {
          "type": "string",
          "enum": [
            "left",
            "right",
            "top",
            "bottom"
          ]
        }
      },
      "additionalProperties": false
    },
    "Flip": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        },
        "direction": {
          "type": "string",
          "enum": [
            "vertical",
            "horizontal"
          ]
        }
      },
      "additionalProperties": false
    },
    "Rubber": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        },
        "intensity": true
      },
      "additionalProperties": false
    },
    "Fold": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "direction": {
          "type": "string",
          "enum": [
            "left",
            "right",
            "top",
            "bottom"
          ]
        },
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        },
        "angle": true
      },
      "additionalProperties": false
    },
    "Jello": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        },
        "intensity": true
      },
      "additionalProperties": false
    },
    "Wiggle": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        },
        "intensity": true
      },
      "additionalProperties": false
    },
    "Bounce": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        },
        "intensity": true
      },
      "additionalProperties": false
    },
    "Cross": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "direction": {
          "type": "string",
          "enum": [
            "right",
            "top-right",
            "top",
            "top-left",
            "left",
            "bottom-left",
            "bottom",
            "bottom-right"
          ]
        }
      },
      "additionalProperties": false
    },
    "DVD": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        }
      },
      "additionalProperties": false
    },
    "ArcScroll": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "range": {
          "type": "string",
          "enum": [
            "in",
            "out",
            "continuous"
          ]
        },
        "direction": {
          "type": "string",
          "enum": [
            "vertical",
            "horizontal"
          ]
        }
      },
      "additionalProperties": false
    },
    "BlurScroll": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "range": {
          "type": "string",
          "enum": [
            "in",
            "out",
            "continuous"
          ]
        },
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        },
        "blur": true
      },
      "additionalProperties": false
    },
    "FadeScroll": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "range": {
          "type": "string",
          "enum": [
            "in",
            "out",
            "continuous"
          ]
        },
        "opacity": true
      },
      "additionalProperties": false
    },
    "FlipScroll": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "range": {
          "type": "string",
          "enum": [
            "in",
            "out",
            "continuous"
          ]
        },
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        },
        "rotate": true,
        "direction": {
          "type": "string",
          "enum": [
            "vertical",
            "horizontal"
          ]
        }
      },
      "additionalProperties": false
    },
    "GrowScroll": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "range": {
          "type": "string",
          "enum": [
            "in",
            "out",
            "continuous"
          ]
        },
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        },
        "scale": true,
        "distance": true,
        "speed": true,
        "direction": {
          "type": "string",
          "enum": [
            "right",
            "top-right",
            "top",
            "top-left",
            "left",
            "bottom-left",
            "bottom",
            "bottom-right",
            "center"
          ]
        }
      },
      "additionalProperties": false
    },
    "MoveScroll": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "range": {
          "type": "string",
          "enum": [
            "in",
            "out",
            "continuous"
          ]
        },
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        },
        "distance": {
          "type": "object",
          "properties": {
            "value": true,
            "type": {
              "enum": [
                "px",
                "em",
                "rem",
                "percentage",
                "vh",
                "vw",
                "vmin",
                "vmax"
              ]
            }
          },
          "additionalProperties": false
        },
        "angle": true
      },
      "additionalProperties": false
    },
    "PanScroll": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "range": {
          "type": "string",
          "enum": [
            "in",
            "out",
            "continuous"
          ]
        },
        "direction": {
          "type": "string",
          "enum": [
            "left",
            "right"
          ]
        },
        "distance": {
          "type": "object",
          "properties": {
            "value": true,
            "type": {
              "enum": [
                "px",
                "em",
                "rem",
                "percentage",
                "vh",
                "vw",
                "vmin",
                "vmax"
              ]
            }
          },
          "additionalProperties": false
        },
        "startFromOffScreen": true
      },
      "additionalProperties": false
    },
    "ParallaxScroll": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "range": {
          "type": "string",
          "enum": [
            "in",
            "out",
            "continuous"
          ]
        },
        "speed": true
      },
      "additionalProperties": false
    },
    "RevealScroll": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "range": {
          "type": "string",
          "enum": [
            "in",
            "out",
            "continuous"
          ]
        },
        "direction": {
          "type": "string",
          "enum": [
            "left",
            "right",
            "top",
            "bottom"
          ]
        }
      },
      "additionalProperties": false
    },
    "ShapeScroll": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "range": {
          "type": "string",
          "enum": [
            "in",
            "out",
            "continuous"
          ]
        },
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        },
        "intensity": true,
        "shape": {
          "type": "string",
          "enum": [
            "ellipse",
            "circle",
            "rectangle",
            "diamond",
            "window"
          ]
        }
      },
      "additionalProperties": false
    },
    "ShrinkScroll": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "range": {
          "type": "string",
          "enum": [
            "in",
            "out",
            "continuous"
          ]
        },
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        },
        "scale": true,
        "distance": true,
        "speed": true,
        "direction": {
          "type": "string",
          "enum": [
            "right",
            "top-right",
            "top",
            "top-left",
            "left",
            "bottom-left",
            "bottom",
            "bottom-right",
            "center"
          ]
        }
      },
      "additionalProperties": false
    },
    "ShuttersScroll": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "range": {
          "type": "string",
          "enum": [
            "in",
            "out",
            "continuous"
          ]
        },
        "shutters": true,
        "direction": {
          "type": "string",
          "enum": [
            "left",
            "right",
            "top",
            "bottom"
          ]
        },
        "staggered": true
      },
      "additionalProperties": false
    },
    "SkewPanScroll": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "range": {
          "type": "string",
          "enum": [
            "in",
            "out",
            "continuous"
          ]
        },
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        },
        "direction": {
          "type": "string",
          "enum": [
            "left",
            "right"
          ]
        },
        "skew": true
      },
      "additionalProperties": false
    },
    "SlideScroll": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "range": {
          "type": "string",
          "enum": [
            "in",
            "out",
            "continuous"
          ]
        },
        "direction": {
          "type": "string",
          "enum": [
            "left",
            "right",
            "top",
            "bottom"
          ]
        }
      },
      "additionalProperties": false
    },
    "Spin3dScroll": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "range": {
          "type": "string",
          "enum": [
            "in",
            "out",
            "continuous"
          ]
        },
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        },
        "rotate": true,
        "distance": true,
        "speed": true
      },
      "additionalProperties": false
    },
    "SpinScroll": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "range": {
          "type": "string",
          "enum": [
            "in",
            "out",
            "continuous"
          ]
        },
        "spins": true,
        "direction": {
          "type": "string",
          "enum": [
            "clockwise",
            "counter-clockwise"
          ]
        },
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        },
        "scale": true
      },
      "additionalProperties": false
    },
    "StretchScroll": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "range": {
          "type": "string",
          "enum": [
            "in",
            "out",
            "continuous"
          ]
        },
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        },
        "stretch": true
      },
      "additionalProperties": false
    },
    "TiltScroll": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "range": {
          "type": "string",
          "enum": [
            "in",
            "out",
            "continuous"
          ]
        },
        "direction": {
          "type": "string",
          "enum": [
            "left",
            "right"
          ]
        },
        "distance": true,
        "speed": true,
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        }
      },
      "additionalProperties": false
    },
    "TurnScroll": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "range": {
          "type": "string",
          "enum": [
            "in",
            "out",
            "continuous"
          ]
        },
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        },
        "direction": {
          "type": "string",
          "enum": [
            "left",
            "right"
          ]
        },
        "scale": true,
        "spin": {
          "type": "string",
          "enum": [
            "clockwise",
            "counter-clockwise"
          ]
        }
      },
      "additionalProperties": false
    },
    "TrackMouse": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "distance": {
          "type": "object",
          "properties": {
            "value": true,
            "type": {
              "enum": [
                "px",
                "em",
                "rem",
                "percentage",
                "vh",
                "vw",
                "vmin",
                "vmax"
              ]
            }
          },
          "additionalProperties": false
        },
        "axis": {
          "type": "string",
          "enum": [
            "horizontal",
            "vertical",
            "both"
          ]
        },
        "inverted": true,
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        }
      },
      "additionalProperties": false
    },
    "Tilt3DMouse": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "angle": true,
        "perspective": true,
        "inverted": true,
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        }
      },
      "additionalProperties": false
    },
    "SwivelMouse": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "angle": true,
        "perspective": true,
        "inverted": true,
        "pivotAxis": {
          "type": "string",
          "enum": [
            "center-vertical",
            "center-horizontal",
            "top",
            "bottom",
            "left",
            "right"
          ]
        },
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        }
      },
      "additionalProperties": false
    },
    "BlobMouse": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "distance": {
          "type": "object",
          "properties": {
            "value": true,
            "type": {
              "enum": [
                "px",
                "em",
                "rem",
                "percentage",
                "vh",
                "vw",
                "vmin",
                "vmax"
              ]
            }
          },
          "additionalProperties": false
        },
        "scale": true,
        "inverted": true,
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        }
      },
      "additionalProperties": false
    },
    "ScaleMouse": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "distance": {
          "type": "object",
          "properties": {
            "value": true,
            "type": {
              "enum": [
                "px",
                "em",
                "rem",
                "percentage",
                "vh",
                "vw",
                "vmin",
                "vmax"
              ]
            }
          },
          "additionalProperties": false
        },
        "scale": true,
        "axis": {
          "type": "string",
          "enum": [
            "horizontal",
            "vertical",
            "both"
          ]
        },
        "inverted": true,
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        },
        "scaleDirection": {
          "type": "string",
          "enum": [
            "up",
            "down"
          ]
        }
      },
      "additionalProperties": false
    },
    "Track3DMouse": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "distance": {
          "type": "object",
          "properties": {
            "value": true,
            "type": {
              "enum": [
                "px",
                "em",
                "rem",
                "percentage",
                "vh",
                "vw",
                "vmin",
                "vmax"
              ]
            }
          },
          "additionalProperties": false
        },
        "angle": true,
        "perspective": true,
        "axis": {
          "type": "string",
          "enum": [
            "horizontal",
            "vertical",
            "both"
          ]
        },
        "inverted": true,
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        }
      },
      "additionalProperties": false
    },
    "AiryMouse": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "distance": {
          "type": "object",
          "properties": {
            "value": true,
            "type": {
              "enum": [
                "px",
                "em",
                "rem",
                "percentage",
                "vh",
                "vw",
                "vmin",
                "vmax"
              ]
            }
          },
          "additionalProperties": false
        },
        "angle": true,
        "axis": {
          "type": "string",
          "enum": [
            "horizontal",
            "vertical",
            "both"
          ]
        },
        "inverted": true,
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        }
      },
      "additionalProperties": false
    },
    "BlurMouse": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "blur": true,
        "distance": {
          "type": "object",
          "properties": {
            "value": true,
            "type": {
              "enum": [
                "px",
                "em",
                "rem",
                "percentage",
                "vh",
                "vw",
                "vmin",
                "vmax"
              ]
            }
          },
          "additionalProperties": false
        },
        "scale": true,
        "angle": true,
        "inverted": true,
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        }
      },
      "additionalProperties": false
    },
    "SkewMouse": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "distance": {
          "type": "object",
          "properties": {
            "value": true,
            "type": {
              "enum": [
                "px",
                "em",
                "rem",
                "percentage",
                "vh",
                "vw",
                "vmin",
                "vmax"
              ]
            }
          },
          "additionalProperties": false
        },
        "axis": {
          "type": "string",
          "enum": [
            "horizontal",
            "vertical",
            "both"
          ]
        },
        "angle": true,
        "inverted": true,
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        }
      },
      "additionalProperties": false
    },
    "BgCloseUp": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "scale": true
      },
      "additionalProperties": false
    },
    "BgFade": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "range": {
          "type": "string",
          "enum": [
            "in",
            "out"
          ]
        }
      },
      "additionalProperties": false
    },
    "BgFadeBack": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "scale": true
      },
      "additionalProperties": false
    },
    "BgFake3D": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "zoom": true,
        "stretch": true
      },
      "additionalProperties": false
    },
    "BgPan": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "speed": true,
        "direction": {
          "type": "string",
          "enum": [
            "left",
            "right"
          ]
        }
      },
      "additionalProperties": false
    },
    "BgParallax": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "speed": true
      },
      "additionalProperties": false
    },
    "BgPullBack": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "scale": true
      },
      "additionalProperties": false
    },
    "BgReveal": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true
      },
      "additionalProperties": false
    },
    "BgRotate": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "angle": true,
        "direction": {
          "type": "string",
          "enum": [
            "clockwise",
            "counter-clockwise"
          ]
        }
      },
      "additionalProperties": false
    },
    "BgSkew": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "angle": true,
        "direction": {
          "type": "string",
          "enum": [
            "clockwise",
            "counter-clockwise"
          ]
        }
      },
      "additionalProperties": false
    },
    "BgZoom": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "zoom": true,
        "direction": {
          "type": "string",
          "enum": [
            "in",
            "out"
          ]
        }
      },
      "additionalProperties": false
    },
    "ImageParallax": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "speed": true,
        "inverted": true
      },
      "additionalProperties": false
    },
    "Kaleidoscope": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "autoplay": true,
        "isTriggeredByMouse": true,
        "isTriggeredByScroll": true,
        "segments": true,
        "rotation": true
      },
      "additionalProperties": false
    },
    "RGBSplit": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "autoplay": true,
        "isTriggeredByMouse": true,
        "isTriggeredByScroll": true,
        "splitType": {
          "type": "string",
          "enum": [
            "all",
            "red-cyan",
            "green-magenta",
            "blue-yellow"
          ]
        },
        "angle": true,
        "intensity": true,
        "frequency": true,
        "octaves": true,
        "speed": true,
        "radius": true
      },
      "additionalProperties": false
    },
    "RGBOrb": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "autoplay": true,
        "isTriggeredByMouse": true,
        "isTriggeredByScroll": true,
        "splitType": {
          "type": "string",
          "enum": [
            "all",
            "red-cyan",
            "green-magenta",
            "blue-yellow"
          ]
        },
        "angle": true,
        "intensity": true,
        "frequency": true,
        "octaves": true,
        "speed": true,
        "radius": true
      },
      "additionalProperties": false
    },
    "SlitScan": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "autoplay": true,
        "isTriggeredByMouse": true,
        "isTriggeredByScroll": true,
        "speed": true,
        "intensity": true,
        "frequency": true,
        "direction": {
          "type": "string",
          "enum": [
            "x",
            "y"
          ]
        }
      },
      "additionalProperties": false
    },
    "NoisyTrack": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "autoplay": true,
        "isTriggeredByMouse": true,
        "isTriggeredByScroll": true,
        "radius": true,
        "spread": true
      },
      "additionalProperties": false
    },
    "Smear": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "autoplay": true,
        "isTriggeredByMouse": true,
        "isTriggeredByScroll": true,
        "radius": true,
        "intensity": true,
        "duration": true,
        "decayPower": true
      },
      "additionalProperties": false
    },
    "Ripples": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "autoplay": true,
        "isTriggeredByMouse": true,
        "isTriggeredByScroll": true,
        "frequency": true,
        "octaves": true,
        "aspectRatio": true,
        "intensity": true,
        "speed": true
      },
      "additionalProperties": false
    },
    "RefArray": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "values": {
          "type": [
            "array"
          ],
          "items": true
        }
      },
      "additionalProperties": false
    },
    "VariantRelation": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "variants": {
          "type": "array",
          "items": true
        },
        "remoteVariants": {
          "type": "array",
          "items": true
        },
        "from": true,
        "to": true
      },
      "additionalProperties": false
    }
  },
  "fixerVersions.json": {
    "$id": "urn:dm:schemas:fixerVersions.json",
    "FixerVersions": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "viewer_fixer": true,
        "migration_fixer": true,
        "ds_fixer": true
      },
      "additionalProperties": false
    }
  },
  "grouping.json": {
    "$id": "urn:dm:schemas:grouping.json",
    "GroupRelation": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "groupId": true
      },
      "additionalProperties": false
    }
  },
  "innerElements.json": {
    "$id": "urn:dm:schemas:innerElements.json",
    "InnerElementQueries": {
      "type": "object",
      "properties": {
        "dataQuery": true,
        "innerElementsQuery": true,
        "innerElementsMetaDataQuery": true,
        "presetsQuery": true,
        "slotsQuery": true,
        "styleId": true
      },
      "additionalProperties": false
    },
    "InnerElement": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "referredType": true,
        "dataQuery": true,
        "innerElementsQuery": true,
        "innerElementsMetaDataQuery": true,
        "presetsQuery": true,
        "slotsQuery": true,
        "styleId": true
      },
      "additionalProperties": false
    }
  },
  "innerElementsMetaData.json": {
    "$id": "urn:dm:schemas:innerElementsMetaData.json",
    "InnerElementsMetaData": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "elementsRemovalState": {
          "type": "object",
          "additionalProperties": {
            "type": "string",
            "enum": [
              "REMOVED"
            ]
          }
        }
      },
      "additionalProperties": false
    }
  },
  "intent.json": {
    "$id": "urn:dm:schemas:intent.json",
    "Intent": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "intent": true
      },
      "additionalProperties": false
    }
  },
  "layoutSettings.json": {
    "$id": "urn:dm:schemas:layoutSettings.json",
    "LayoutSettings": {
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "enum": [
            "LayoutSettings"
          ]
        },
        "id": true,
        "metaData": true,
        "autoResponsivenessSettings": {
          "type": "object",
          "properties": {
            "mode": {
              "enum": [
                "adaptive"
              ]
            },
            "lastGroupingsHash": true
          },
          "additionalProperties": false
        }
      },
      "additionalProperties": false
    },
    "RefArray": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "values": {
          "type": [
            "array"
          ],
          "items": true
        }
      },
      "additionalProperties": false
    },
    "VariantRelation": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "variants": {
          "type": "array",
          "items": true
        },
        "remoteVariants": {
          "type": "array",
          "items": true
        },
        "from": true,
        "to": true
      },
      "additionalProperties": false
    }
  },
  "layout_data.json": {
    "$id": "urn:dm:schemas:layout_data.json",
    "KeywordSize": {
      "type": "object",
      "properties": {
        "type": {
          "enum": [
            "auto",
            "maxContent",
            "minContent",
            "unset",
            "fit"
          ]
        }
      },
      "additionalProperties": false
    },
    "Calculation": {
      "type": "object",
      "properties": {
        "type": {
          "enum": [
            "Calc"
          ]
        },
        "value": true
      },
      "additionalProperties": false
    },
    "CalculationFormula": {
      "type": "object",
      "properties": {
        "type": {
          "enum": [
            "CalcFormula"
          ]
        },
        "value": {
          "type": "object",
          "properties": {
            "formula": true,
            "values": {
              "type": "object",
              "properties": {},
              "additionalProperties": {
                "type": "object",
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "value": true,
                      "type": {
                        "enum": [
                          "px",
                          "em",
                          "rem",
                          "fr",
                          "percentage",
                          "vh",
                          "vw",
                          "spx",
                          "siteWidthPercentage"
                        ]
                      }
                    }
                  },
                  {
                    "type": "object",
                    "properties": {
                      "type": {
                        "enum": [
                          "SystemVariable"
                        ]
                      },
                      "value": {
                        "enum": [
                          "siteWidth",
                          "topBannerHeight"
                        ]
                      }
                    }
                  },
                  {
                    "type": "object",
                    "properties": {
                      "type": {
                        "enum": [
                          "Number"
                        ]
                      },
                      "value": true
                    }
                  }
                ]
              }
            }
          },
          "additionalProperties": false
        }
      },
      "additionalProperties": false
    },
    "AspectRatioSize": {
      "type": "object",
      "properties": {
        "type": {
          "enum": [
            "aspectRatio"
          ]
        },
        "value": true
      },
      "additionalProperties": false
    },
    "SystemVariableSize": {
      "type": "object",
      "properties": {
        "type": {
          "enum": [
            "SystemVariable"
          ]
        },
        "value": {
          "enum": [
            "siteWidth",
            "topBannerHeight"
          ]
        }
      },
      "additionalProperties": false
    },
    "NumberSize": {
      "type": "object",
      "properties": {
        "type": {
          "enum": [
            "Number"
          ]
        },
        "value": true
      },
      "additionalProperties": false
    },
    "LayoutSize": {
      "type": "object",
      "anyOf": [
        {
          "type": "object",
          "properties": {
            "value": true,
            "type": {
              "enum": [
                "px",
                "em",
                "rem",
                "fr",
                "percentage",
                "vh",
                "vw",
                "spx",
                "siteWidthPercentage"
              ]
            }
          },
          "additionalProperties": false
        },
        {
          "type": "object",
          "properties": {
            "type": {
              "enum": [
                "Calc"
              ]
            },
            "value": true
          },
          "additionalProperties": false
        },
        {
          "type": "object",
          "properties": {
            "type": {
              "enum": [
                "CalcFormula"
              ]
            },
            "value": {
              "type": "object",
              "properties": {
                "formula": true,
                "values": {
                  "type": "object",
                  "properties": {},
                  "additionalProperties": {
                    "type": "object",
                    "anyOf": [
                      {
                        "type": "object",
                        "properties": {
                          "value": true,
                          "type": {
                            "enum": [
                              "px",
                              "em",
                              "rem",
                              "fr",
                              "percentage",
                              "vh",
                              "vw",
                              "spx",
                              "siteWidthPercentage"
                            ]
                          }
                        }
                      },
                      {
                        "type": "object",
                        "properties": {
                          "type": {
                            "enum": [
                              "SystemVariable"
                            ]
                          },
                          "value": {
                            "enum": [
                              "siteWidth",
                              "topBannerHeight"
                            ]
                          }
                        }
                      },
                      {
                        "type": "object",
                        "properties": {
                          "type": {
                            "enum": [
                              "Number"
                            ]
                          },
                          "value": true
                        }
                      }
                    ]
                  }
                }
              },
              "additionalProperties": false
            }
          },
          "additionalProperties": false
        },
        {
          "type": "object",
          "properties": {
            "type": {
              "enum": [
                "SystemVariable"
              ]
            },
            "value": {
              "enum": [
                "siteWidth",
                "topBannerHeight"
              ]
            }
          },
          "additionalProperties": false
        },
        {
          "type": "object",
          "properties": {
            "type": {
              "enum": [
                "auto",
                "maxContent",
                "minContent",
                "unset",
                "fit"
              ]
            }
          },
          "additionalProperties": false
        }
      ]
    },
    "SpxStopper": {
      "type": "object",
      "properties": {
        "min": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "max": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        }
      },
      "additionalProperties": false
    },
    "StretchWithSoftMargins": {
      "type": "object",
      "properties": {
        "type": {
          "enum": [
            "StretchWithSoftMargins"
          ]
        },
        "value": {
          "type": "object",
          "properties": {
            "margins": {
              "type": "object",
              "properties": {
                "left": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "properties": {
                        "value": true,
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": true
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "properties": {
                            "formula": true,
                            "values": {
                              "type": "object",
                              "properties": {},
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "properties": {
                                      "value": true,
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": true
                                    }
                                  }
                                ]
                              }
                            }
                          },
                          "additionalProperties": false
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "right": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "properties": {
                        "value": true,
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": true
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "properties": {
                            "formula": true,
                            "values": {
                              "type": "object",
                              "properties": {},
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "properties": {
                                      "value": true,
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": true
                                    }
                                  }
                                ]
                              }
                            }
                          },
                          "additionalProperties": false
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                }
              },
              "additionalProperties": false
            }
          },
          "additionalProperties": false
        }
      },
      "additionalProperties": false
    },
    "Height": {
      "type": "object",
      "anyOf": [
        {
          "type": "object",
          "properties": {
            "type": {
              "enum": [
                "aspectRatio"
              ]
            },
            "value": true
          },
          "additionalProperties": false
        },
        {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        }
      ]
    },
    "MinMaxSize": {
      "type": "object",
      "properties": {
        "type": true,
        "min": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "max": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        }
      },
      "additionalProperties": false
    },
    "GridTrackSize": {
      "type": "object",
      "properties": {
        "type": true,
        "min": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "max": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "value": true,
        "length": {
          "anyOf": [
            {
              "type": "number"
            },
            {
              "enum": [
                "auto-fill",
                "auto-fit"
              ]
            }
          ]
        }
      },
      "additionalProperties": false
    },
    "BaseGridTrackSize": {
      "type": "object",
      "properties": {
        "type": true,
        "min": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "max": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "value": true
      },
      "additionalProperties": false
    },
    "KeywordLength": {
      "enum": [
        "auto-fill",
        "auto-fit"
      ]
    },
    "ItemsAlignment": {
      "type": "string",
      "enum": [
        "start",
        "end",
        "center",
        "stretch",
        "content"
      ]
    },
    "ContainerLayoutIntent": {
      "type": "object",
      "properties": {
        "layoutIntent": {
          "type": "string",
          "enum": [
            "Rows",
            "Cols",
            "Mosaic",
            "Slider",
            "SlideShow",
            "Bricks"
          ]
        }
      },
      "additionalProperties": false
    },
    "Alignment": {
      "type": "string",
      "enum": [
        "auto",
        "stretch",
        "start",
        "center",
        "end"
      ]
    },
    "Direction": {
      "enum": [
        "rtl",
        "ltr"
      ]
    },
    "Margins": {
      "type": "object",
      "properties": {
        "top": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "bottom": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "left": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "right": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        }
      },
      "additionalProperties": false
    },
    "Padding": {
      "type": "object",
      "properties": {
        "top": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "bottom": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "left": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "right": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        }
      },
      "additionalProperties": false
    },
    "FlexDirection": {
      "enum": [
        "row",
        "rowReverse",
        "column",
        "columnReverse"
      ]
    },
    "FlexWrap": {
      "enum": [
        "nowrap",
        "wrap"
      ]
    },
    "Overflow": {
      "enum": [
        "auto",
        "scroll",
        "hidden",
        "visible",
        "clip"
      ]
    },
    "Contain": {
      "enum": [
        "none",
        "paint"
      ]
    },
    "AutoFlow": {
      "enum": [
        "row",
        "column",
        "dense",
        "row dense",
        "column dense"
      ]
    },
    "JustifyContent": {
      "enum": [
        "start",
        "center",
        "end",
        "spaceBetween",
        "spaceAround",
        "spaceEvenly"
      ]
    },
    "GridArea": {
      "type": "object",
      "properties": {
        "rowStart": true,
        "columnStart": true,
        "rowEnd": true,
        "columnEnd": true
      },
      "additionalProperties": false
    },
    "LayoutData": {
      "type": "object",
      "properties": {
        "componentLayouts": {
          "type": [
            "array"
          ],
          "items": true
        },
        "itemLayouts": {
          "type": [
            "array"
          ],
          "items": true
        },
        "containerLayouts": {
          "type": [
            "array"
          ],
          "items": true
        }
      },
      "additionalProperties": false
    },
    "SingleLayoutData": {
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:componentLayout\\/width|componentLayout\\/width\\/value\\/margins\\/left|componentLayout\\/width\\/value\\/margins\\/right|componentLayout\\/height|componentLayout\\/minWidth|componentLayout\\/minHeight|componentLayout\\/maxWidth|componentLayout\\/maxHeight|componentLayout\\/margins\\/top|componentLayout\\/margins\\/bottom|componentLayout\\/margins\\/left|componentLayout\\/margins\\/right|itemLayout\\/margins\\/top|itemLayout\\/margins\\/bottom|itemLayout\\/margins\\/left|itemLayout\\/margins\\/right|itemLayout\\/top|itemLayout\\/bottom|itemLayout\\/left|itemLayout\\/right|itemLayout\\/basis|containerLayout\\/rows\\/\\d+?\\/min|containerLayout\\/rows\\/\\d+?\\/max|containerLayout\\/rows\\/\\d+?\\/value\\/\\d+?\\/min|containerLayout\\/rows\\/\\d+?\\/value\\/\\d+?\\/max|containerLayout\\/columns\\/\\d+?\\/min|containerLayout\\/columns\\/\\d+?\\/max|containerLayout\\/columns\\/\\d+?\\/value\\/\\d+?\\/min|containerLayout\\/columns\\/\\d+?\\/value\\/\\d+?\\/max|containerLayout\\/rowGap|containerLayout\\/columnGap|containerLayout\\/autoRows\\/\\d+?\\/min|containerLayout\\/autoRows\\/\\d+?\\/max|containerLayout\\/autoRows\\/\\d+?\\/value\\/\\d+?\\/min|containerLayout\\/autoRows\\/\\d+?\\/value\\/\\d+?\\/max|containerLayout\\/autoColumns\\/\\d+?\\/min|containerLayout\\/autoColumns\\/\\d+?\\/max|containerLayout\\/autoColumns\\/\\d+?\\/value\\/\\d+?\\/min|containerLayout\\/autoColumns\\/\\d+?\\/value\\/\\d+?\\/max|containerLayout\\/padding\\/top|containerLayout\\/padding\\/bottom|containerLayout\\/padding\\/left|containerLayout\\/padding\\/right|containerLayout\\/spxStopper\\/min|containerLayout\\/spxStopper\\/max|containerLayout\\/margins\\/top|containerLayout\\/margins\\/bottom|containerLayout\\/margins\\/left|containerLayout\\/margins\\/right|containerLayout\\/top|containerLayout\\/bottom|containerLayout\\/left|containerLayout\\/right|containerLayout\\/contentArea\\/width)$"
                  },
                  "variableId": true
                },
                "additionalProperties": false
              },
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:componentLayout\\/width|componentLayout\\/width\\/value\\/margins\\/left|componentLayout\\/width\\/value\\/margins\\/right|componentLayout\\/height|componentLayout\\/minWidth|componentLayout\\/minHeight|componentLayout\\/maxWidth|componentLayout\\/maxHeight|componentLayout\\/margins\\/top|componentLayout\\/margins\\/bottom|componentLayout\\/margins\\/left|componentLayout\\/margins\\/right|itemLayout\\/margins\\/top|itemLayout\\/margins\\/bottom|itemLayout\\/margins\\/left|itemLayout\\/margins\\/right|itemLayout\\/top|itemLayout\\/bottom|itemLayout\\/left|itemLayout\\/right|itemLayout\\/basis|containerLayout\\/rows\\/\\d+?\\/|containerLayout\\/rows\\/\\d+?\\/min|containerLayout\\/rows\\/\\d+?\\/max|containerLayout\\/rows\\/\\d+?\\/value\\/\\d+?\\/min|containerLayout\\/rows\\/\\d+?\\/value\\/\\d+?\\/max|containerLayout\\/columns\\/\\d+?\\/|containerLayout\\/columns\\/\\d+?\\/min|containerLayout\\/columns\\/\\d+?\\/max|containerLayout\\/columns\\/\\d+?\\/value\\/\\d+?\\/min|containerLayout\\/columns\\/\\d+?\\/value\\/\\d+?\\/max|containerLayout\\/rowGap|containerLayout\\/columnGap|containerLayout\\/autoRows\\/\\d+?\\/|containerLayout\\/autoRows\\/\\d+?\\/min|containerLayout\\/autoRows\\/\\d+?\\/max|containerLayout\\/autoRows\\/\\d+?\\/value\\/\\d+?\\/min|containerLayout\\/autoRows\\/\\d+?\\/value\\/\\d+?\\/max|containerLayout\\/autoColumns\\/\\d+?\\/|containerLayout\\/autoColumns\\/\\d+?\\/min|containerLayout\\/autoColumns\\/\\d+?\\/max|containerLayout\\/autoColumns\\/\\d+?\\/value\\/\\d+?\\/min|containerLayout\\/autoColumns\\/\\d+?\\/value\\/\\d+?\\/max|containerLayout\\/padding\\/top|containerLayout\\/padding\\/bottom|containerLayout\\/padding\\/left|containerLayout\\/padding\\/right|containerLayout\\/contentMaxWidth\\/maxWidth|containerLayout\\/spxStopper\\/min|containerLayout\\/spxStopper\\/max|containerLayout\\/margins\\/top|containerLayout\\/margins\\/bottom|containerLayout\\/margins\\/left|containerLayout\\/margins\\/right|containerLayout\\/top|containerLayout\\/bottom|containerLayout\\/left|containerLayout\\/right|containerLayout\\/contentArea\\/width)$"
                  },
                  "variableId": true
                },
                "additionalProperties": false
              },
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:componentLayout\\/height)$"
                  },
                  "variableId": true
                },
                "additionalProperties": false
              },
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:itemLayout\\/position|containerLayout\\/position)$"
                  },
                  "variableId": true
                },
                "additionalProperties": false
              },
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:itemLayout\\/gridArea\\/rowStart|itemLayout\\/gridArea\\/columnStart|itemLayout\\/gridArea\\/rowEnd|itemLayout\\/gridArea\\/columnEnd|containerLayout\\/rows\\/\\d+?\\/length|containerLayout\\/columns\\/\\d+?\\/length|containerLayout\\/autoRows\\/\\d+?\\/length|containerLayout\\/autoColumns\\/\\d+?\\/length)$"
                  },
                  "variableId": true
                },
                "additionalProperties": false
              },
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:itemLayout\\/alignSelf|itemLayout\\/justifySelf|containerLayout\\/alignItems|containerLayout\\/contentArea\\/alignment)$"
                  },
                  "variableId": true
                },
                "additionalProperties": false
              },
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:containerLayout\\/rows\\/\\d+?\\/length|containerLayout\\/columns\\/\\d+?\\/length|containerLayout\\/autoRows\\/\\d+?\\/length|containerLayout\\/autoColumns\\/\\d+?\\/length)$"
                  },
                  "variableId": true
                },
                "additionalProperties": false
              },
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:containerLayout\\/justifyContent)$"
                  },
                  "variableId": true
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": true,
        "id": true,
        "metaData": true,
        "componentLayout": {
          "type": "object",
          "anyOf": [
            {
              "type": [
                "object"
              ],
              "properties": {
                "containerType": {
                  "type": "string",
                  "enum": [
                    "inline-size"
                  ]
                },
                "width": {
                  "oneOf": [
                    {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "StretchWithSoftMargins"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "properties": {
                            "margins": {
                              "type": "object",
                              "properties": {
                                "left": {
                                  "type": "object",
                                  "anyOf": [
                                    {
                                      "type": "object",
                                      "properties": {
                                        "value": true,
                                        "type": {
                                          "enum": [
                                            "px",
                                            "em",
                                            "rem",
                                            "fr",
                                            "percentage",
                                            "vh",
                                            "vw",
                                            "spx",
                                            "siteWidthPercentage"
                                          ]
                                        }
                                      },
                                      "additionalProperties": false
                                    },
                                    {
                                      "type": "object",
                                      "properties": {
                                        "type": {
                                          "enum": [
                                            "Calc"
                                          ]
                                        },
                                        "value": true
                                      },
                                      "additionalProperties": false
                                    },
                                    {
                                      "type": "object",
                                      "properties": {
                                        "type": {
                                          "enum": [
                                            "CalcFormula"
                                          ]
                                        },
                                        "value": {
                                          "type": "object",
                                          "properties": {
                                            "formula": true,
                                            "values": {
                                              "type": "object",
                                              "properties": {},
                                              "additionalProperties": {
                                                "type": "object",
                                                "anyOf": [
                                                  {
                                                    "type": "object",
                                                    "properties": {
                                                      "value": true,
                                                      "type": {
                                                        "enum": [
                                                          "px",
                                                          "em",
                                                          "rem",
                                                          "fr",
                                                          "percentage",
                                                          "vh",
                                                          "vw",
                                                          "spx",
                                                          "siteWidthPercentage"
                                                        ]
                                                      }
                                                    }
                                                  },
                                                  {
                                                    "type": "object",
                                                    "properties": {
                                                      "type": {
                                                        "enum": [
                                                          "SystemVariable"
                                                        ]
                                                      },
                                                      "value": {
                                                        "enum": [
                                                          "siteWidth",
                                                          "topBannerHeight"
                                                        ]
                                                      }
                                                    }
                                                  },
                                                  {
                                                    "type": "object",
                                                    "properties": {
                                                      "type": {
                                                        "enum": [
                                                          "Number"
                                                        ]
                                                      },
                                                      "value": true
                                                    }
                                                  }
                                                ]
                                              }
                                            }
                                          },
                                          "additionalProperties": false
                                        }
                                      },
                                      "additionalProperties": false
                                    },
                                    {
                                      "type": "object",
                                      "properties": {
                                        "type": {
                                          "enum": [
                                            "SystemVariable"
                                          ]
                                        },
                                        "value": {
                                          "enum": [
                                            "siteWidth",
                                            "topBannerHeight"
                                          ]
                                        }
                                      },
                                      "additionalProperties": false
                                    },
                                    {
                                      "type": "object",
                                      "properties": {
                                        "type": {
                                          "enum": [
                                            "auto",
                                            "maxContent",
                                            "minContent",
                                            "unset",
                                            "fit"
                                          ]
                                        }
                                      },
                                      "additionalProperties": false
                                    }
                                  ]
                                },
                                "right": {
                                  "type": "object",
                                  "anyOf": [
                                    {
                                      "type": "object",
                                      "properties": {
                                        "value": true,
                                        "type": {
                                          "enum": [
                                            "px",
                                            "em",
                                            "rem",
                                            "fr",
                                            "percentage",
                                            "vh",
                                            "vw",
                                            "spx",
                                            "siteWidthPercentage"
                                          ]
                                        }
                                      },
                                      "additionalProperties": false
                                    },
                                    {
                                      "type": "object",
                                      "properties": {
                                        "type": {
                                          "enum": [
                                            "Calc"
                                          ]
                                        },
                                        "value": true
                                      },
                                      "additionalProperties": false
                                    },
                                    {
                                      "type": "object",
                                      "properties": {
                                        "type": {
                                          "enum": [
                                            "CalcFormula"
                                          ]
                                        },
                                        "value": {
                                          "type": "object",
                                          "properties": {
                                            "formula": true,
                                            "values": {
                                              "type": "object",
                                              "properties": {},
                                              "additionalProperties": {
                                                "type": "object",
                                                "anyOf": [
                                                  {
                                                    "type": "object",
                                                    "properties": {
                                                      "value": true,
                                                      "type": {
                                                        "enum": [
                                                          "px",
                                                          "em",
                                                          "rem",
                                                          "fr",
                                                          "percentage",
                                                          "vh",
                                                          "vw",
                                                          "spx",
                                                          "siteWidthPercentage"
                                                        ]
                                                      }
                                                    }
                                                  },
                                                  {
                                                    "type": "object",
                                                    "properties": {
                                                      "type": {
                                                        "enum": [
                                                          "SystemVariable"
                                                        ]
                                                      },
                                                      "value": {
                                                        "enum": [
                                                          "siteWidth",
                                                          "topBannerHeight"
                                                        ]
                                                      }
                                                    }
                                                  },
                                                  {
                                                    "type": "object",
                                                    "properties": {
                                                      "type": {
                                                        "enum": [
                                                          "Number"
                                                        ]
                                                      },
                                                      "value": true
                                                    }
                                                  }
                                                ]
                                              }
                                            }
                                          },
                                          "additionalProperties": false
                                        }
                                      },
                                      "additionalProperties": false
                                    },
                                    {
                                      "type": "object",
                                      "properties": {
                                        "type": {
                                          "enum": [
                                            "SystemVariable"
                                          ]
                                        },
                                        "value": {
                                          "enum": [
                                            "siteWidth",
                                            "topBannerHeight"
                                          ]
                                        }
                                      },
                                      "additionalProperties": false
                                    },
                                    {
                                      "type": "object",
                                      "properties": {
                                        "type": {
                                          "enum": [
                                            "auto",
                                            "maxContent",
                                            "minContent",
                                            "unset",
                                            "fit"
                                          ]
                                        }
                                      },
                                      "additionalProperties": false
                                    }
                                  ]
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "height": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "aspectRatio"
                          ]
                        },
                        "value": true
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    }
                  ]
                },
                "minWidth": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "properties": {
                        "value": true,
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": true
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "properties": {
                            "formula": true,
                            "values": {
                              "type": "object",
                              "properties": {},
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "properties": {
                                      "value": true,
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": true
                                    }
                                  }
                                ]
                              }
                            }
                          },
                          "additionalProperties": false
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "minHeight": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "properties": {
                        "value": true,
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": true
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "properties": {
                            "formula": true,
                            "values": {
                              "type": "object",
                              "properties": {},
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "properties": {
                                      "value": true,
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": true
                                    }
                                  }
                                ]
                              }
                            }
                          },
                          "additionalProperties": false
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "maxWidth": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "properties": {
                        "value": true,
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": true
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "properties": {
                            "formula": true,
                            "values": {
                              "type": "object",
                              "properties": {},
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "properties": {
                                      "value": true,
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": true
                                    }
                                  }
                                ]
                              }
                            }
                          },
                          "additionalProperties": false
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "maxHeight": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "properties": {
                        "value": true,
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": true
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "properties": {
                            "formula": true,
                            "values": {
                              "type": "object",
                              "properties": {},
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "properties": {
                                      "value": true,
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": true
                                    }
                                  }
                                ]
                              }
                            }
                          },
                          "additionalProperties": false
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "margins": {
                  "type": "object",
                  "properties": {
                    "top": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "bottom": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "left": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "right": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "direction": {
                  "enum": [
                    "rtl",
                    "ltr"
                  ]
                },
                "rotationInDegrees": true,
                "fixed": true,
                "hidden": true,
                "type": {
                  "type": "string",
                  "enum": [
                    "ComponentLayout"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": [
                "object"
              ],
              "properties": {
                "containerType": {
                  "type": "string",
                  "enum": [
                    "inline-size"
                  ]
                },
                "width": {
                  "oneOf": [
                    {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "StretchWithSoftMargins"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "properties": {
                            "margins": {
                              "type": "object",
                              "properties": {
                                "left": {
                                  "type": "object",
                                  "anyOf": [
                                    {
                                      "type": "object",
                                      "properties": {
                                        "value": true,
                                        "type": {
                                          "enum": [
                                            "px",
                                            "em",
                                            "rem",
                                            "fr",
                                            "percentage",
                                            "vh",
                                            "vw",
                                            "spx",
                                            "siteWidthPercentage"
                                          ]
                                        }
                                      },
                                      "additionalProperties": false
                                    },
                                    {
                                      "type": "object",
                                      "properties": {
                                        "type": {
                                          "enum": [
                                            "Calc"
                                          ]
                                        },
                                        "value": true
                                      },
                                      "additionalProperties": false
                                    },
                                    {
                                      "type": "object",
                                      "properties": {
                                        "type": {
                                          "enum": [
                                            "CalcFormula"
                                          ]
                                        },
                                        "value": {
                                          "type": "object",
                                          "properties": {
                                            "formula": true,
                                            "values": {
                                              "type": "object",
                                              "properties": {},
                                              "additionalProperties": {
                                                "type": "object",
                                                "anyOf": [
                                                  {
                                                    "type": "object",
                                                    "properties": {
                                                      "value": true,
                                                      "type": {
                                                        "enum": [
                                                          "px",
                                                          "em",
                                                          "rem",
                                                          "fr",
                                                          "percentage",
                                                          "vh",
                                                          "vw",
                                                          "spx",
                                                          "siteWidthPercentage"
                                                        ]
                                                      }
                                                    }
                                                  },
                                                  {
                                                    "type": "object",
                                                    "properties": {
                                                      "type": {
                                                        "enum": [
                                                          "SystemVariable"
                                                        ]
                                                      },
                                                      "value": {
                                                        "enum": [
                                                          "siteWidth",
                                                          "topBannerHeight"
                                                        ]
                                                      }
                                                    }
                                                  },
                                                  {
                                                    "type": "object",
                                                    "properties": {
                                                      "type": {
                                                        "enum": [
                                                          "Number"
                                                        ]
                                                      },
                                                      "value": true
                                                    }
                                                  }
                                                ]
                                              }
                                            }
                                          },
                                          "additionalProperties": false
                                        }
                                      },
                                      "additionalProperties": false
                                    },
                                    {
                                      "type": "object",
                                      "properties": {
                                        "type": {
                                          "enum": [
                                            "SystemVariable"
                                          ]
                                        },
                                        "value": {
                                          "enum": [
                                            "siteWidth",
                                            "topBannerHeight"
                                          ]
                                        }
                                      },
                                      "additionalProperties": false
                                    },
                                    {
                                      "type": "object",
                                      "properties": {
                                        "type": {
                                          "enum": [
                                            "auto",
                                            "maxContent",
                                            "minContent",
                                            "unset",
                                            "fit"
                                          ]
                                        }
                                      },
                                      "additionalProperties": false
                                    }
                                  ]
                                },
                                "right": {
                                  "type": "object",
                                  "anyOf": [
                                    {
                                      "type": "object",
                                      "properties": {
                                        "value": true,
                                        "type": {
                                          "enum": [
                                            "px",
                                            "em",
                                            "rem",
                                            "fr",
                                            "percentage",
                                            "vh",
                                            "vw",
                                            "spx",
                                            "siteWidthPercentage"
                                          ]
                                        }
                                      },
                                      "additionalProperties": false
                                    },
                                    {
                                      "type": "object",
                                      "properties": {
                                        "type": {
                                          "enum": [
                                            "Calc"
                                          ]
                                        },
                                        "value": true
                                      },
                                      "additionalProperties": false
                                    },
                                    {
                                      "type": "object",
                                      "properties": {
                                        "type": {
                                          "enum": [
                                            "CalcFormula"
                                          ]
                                        },
                                        "value": {
                                          "type": "object",
                                          "properties": {
                                            "formula": true,
                                            "values": {
                                              "type": "object",
                                              "properties": {},
                                              "additionalProperties": {
                                                "type": "object",
                                                "anyOf": [
                                                  {
                                                    "type": "object",
                                                    "properties": {
                                                      "value": true,
                                                      "type": {
                                                        "enum": [
                                                          "px",
                                                          "em",
                                                          "rem",
                                                          "fr",
                                                          "percentage",
                                                          "vh",
                                                          "vw",
                                                          "spx",
                                                          "siteWidthPercentage"
                                                        ]
                                                      }
                                                    }
                                                  },
                                                  {
                                                    "type": "object",
                                                    "properties": {
                                                      "type": {
                                                        "enum": [
                                                          "SystemVariable"
                                                        ]
                                                      },
                                                      "value": {
                                                        "enum": [
                                                          "siteWidth",
                                                          "topBannerHeight"
                                                        ]
                                                      }
                                                    }
                                                  },
                                                  {
                                                    "type": "object",
                                                    "properties": {
                                                      "type": {
                                                        "enum": [
                                                          "Number"
                                                        ]
                                                      },
                                                      "value": true
                                                    }
                                                  }
                                                ]
                                              }
                                            }
                                          },
                                          "additionalProperties": false
                                        }
                                      },
                                      "additionalProperties": false
                                    },
                                    {
                                      "type": "object",
                                      "properties": {
                                        "type": {
                                          "enum": [
                                            "SystemVariable"
                                          ]
                                        },
                                        "value": {
                                          "enum": [
                                            "siteWidth",
                                            "topBannerHeight"
                                          ]
                                        }
                                      },
                                      "additionalProperties": false
                                    },
                                    {
                                      "type": "object",
                                      "properties": {
                                        "type": {
                                          "enum": [
                                            "auto",
                                            "maxContent",
                                            "minContent",
                                            "unset",
                                            "fit"
                                          ]
                                        }
                                      },
                                      "additionalProperties": false
                                    }
                                  ]
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "height": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "aspectRatio"
                          ]
                        },
                        "value": true
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    }
                  ]
                },
                "minWidth": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "properties": {
                        "value": true,
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": true
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "properties": {
                            "formula": true,
                            "values": {
                              "type": "object",
                              "properties": {},
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "properties": {
                                      "value": true,
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": true
                                    }
                                  }
                                ]
                              }
                            }
                          },
                          "additionalProperties": false
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "minHeight": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "properties": {
                        "value": true,
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": true
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "properties": {
                            "formula": true,
                            "values": {
                              "type": "object",
                              "properties": {},
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "properties": {
                                      "value": true,
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": true
                                    }
                                  }
                                ]
                              }
                            }
                          },
                          "additionalProperties": false
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "maxWidth": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "properties": {
                        "value": true,
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": true
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "properties": {
                            "formula": true,
                            "values": {
                              "type": "object",
                              "properties": {},
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "properties": {
                                      "value": true,
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": true
                                    }
                                  }
                                ]
                              }
                            }
                          },
                          "additionalProperties": false
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "maxHeight": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "properties": {
                        "value": true,
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": true
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "properties": {
                            "formula": true,
                            "values": {
                              "type": "object",
                              "properties": {},
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "properties": {
                                      "value": true,
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": true
                                    }
                                  }
                                ]
                              }
                            }
                          },
                          "additionalProperties": false
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "margins": {
                  "type": "object",
                  "properties": {
                    "top": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "bottom": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "left": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "right": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "direction": {
                  "enum": [
                    "rtl",
                    "ltr"
                  ]
                },
                "rotationInDegrees": true,
                "fixed": true,
                "hidden": true,
                "type": {
                  "type": "string",
                  "enum": [
                    "ClassicComponentLayout"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "itemLayout": {
          "type": "object",
          "anyOf": [
            {
              "type": [
                "object"
              ],
              "properties": {
                "id": true,
                "type": {
                  "type": "string",
                  "enum": [
                    "GridItemLayout"
                  ]
                },
                "scrollSnapAlign": {
                  "enum": [
                    "center",
                    "end",
                    "start",
                    "none"
                  ]
                },
                "pinnedToContainer": true,
                "margins": {
                  "type": "object",
                  "properties": {
                    "top": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "bottom": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "left": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "right": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "position": {
                  "enum": [
                    "sticky",
                    "stickyToHeader",
                    "absolute",
                    "relative"
                  ]
                },
                "isInFront": true,
                "top": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "properties": {
                        "value": true,
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": true
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "properties": {
                            "formula": true,
                            "values": {
                              "type": "object",
                              "properties": {},
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "properties": {
                                      "value": true,
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": true
                                    }
                                  }
                                ]
                              }
                            }
                          },
                          "additionalProperties": false
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "bottom": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "properties": {
                        "value": true,
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": true
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "properties": {
                            "formula": true,
                            "values": {
                              "type": "object",
                              "properties": {},
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "properties": {
                                      "value": true,
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": true
                                    }
                                  }
                                ]
                              }
                            }
                          },
                          "additionalProperties": false
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "left": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "properties": {
                        "value": true,
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": true
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "properties": {
                            "formula": true,
                            "values": {
                              "type": "object",
                              "properties": {},
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "properties": {
                                      "value": true,
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": true
                                    }
                                  }
                                ]
                              }
                            }
                          },
                          "additionalProperties": false
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "right": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "properties": {
                        "value": true,
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": true
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "properties": {
                            "formula": true,
                            "values": {
                              "type": "object",
                              "properties": {},
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "properties": {
                                      "value": true,
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": true
                                    }
                                  }
                                ]
                              }
                            }
                          },
                          "additionalProperties": false
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "gridArea": {
                  "type": "object",
                  "properties": {
                    "rowStart": true,
                    "columnStart": true,
                    "rowEnd": true,
                    "columnEnd": true
                  },
                  "additionalProperties": false
                },
                "alignSelf": {
                  "type": "string",
                  "enum": [
                    "start",
                    "end",
                    "center",
                    "stretch",
                    "content"
                  ]
                },
                "justifySelf": {
                  "type": "string",
                  "enum": [
                    "start",
                    "end",
                    "center",
                    "stretch",
                    "content"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": [
                "object"
              ],
              "properties": {
                "id": true,
                "type": {
                  "type": "string",
                  "enum": [
                    "FixedItemLayout"
                  ]
                },
                "scrollSnapAlign": {
                  "enum": [
                    "center",
                    "end",
                    "start",
                    "none"
                  ]
                },
                "pinnedToContainer": true,
                "margins": {
                  "type": "object",
                  "properties": {
                    "top": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "bottom": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "left": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "right": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "position": {
                  "enum": [
                    "sticky",
                    "stickyToHeader",
                    "absolute",
                    "relative"
                  ]
                },
                "isInFront": true,
                "top": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "properties": {
                        "value": true,
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": true
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "properties": {
                            "formula": true,
                            "values": {
                              "type": "object",
                              "properties": {},
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "properties": {
                                      "value": true,
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": true
                                    }
                                  }
                                ]
                              }
                            }
                          },
                          "additionalProperties": false
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "bottom": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "properties": {
                        "value": true,
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": true
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "properties": {
                            "formula": true,
                            "values": {
                              "type": "object",
                              "properties": {},
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "properties": {
                                      "value": true,
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": true
                                    }
                                  }
                                ]
                              }
                            }
                          },
                          "additionalProperties": false
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "left": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "properties": {
                        "value": true,
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": true
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "properties": {
                            "formula": true,
                            "values": {
                              "type": "object",
                              "properties": {},
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "properties": {
                                      "value": true,
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": true
                                    }
                                  }
                                ]
                              }
                            }
                          },
                          "additionalProperties": false
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "right": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "properties": {
                        "value": true,
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": true
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "properties": {
                            "formula": true,
                            "values": {
                              "type": "object",
                              "properties": {},
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "properties": {
                                      "value": true,
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": true
                                    }
                                  }
                                ]
                              }
                            }
                          },
                          "additionalProperties": false
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "alignSelf": {
                  "type": "string",
                  "enum": [
                    "start",
                    "end",
                    "center",
                    "stretch",
                    "content"
                  ]
                },
                "justifySelf": {
                  "type": "string",
                  "enum": [
                    "start",
                    "end",
                    "center",
                    "stretch",
                    "content"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": [
                "object"
              ],
              "properties": {
                "id": true,
                "type": {
                  "type": "string",
                  "enum": [
                    "FlexItemLayout"
                  ]
                },
                "scrollSnapAlign": {
                  "enum": [
                    "center",
                    "end",
                    "start",
                    "none"
                  ]
                },
                "pinnedToContainer": true,
                "margins": {
                  "type": "object",
                  "properties": {
                    "top": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "bottom": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "left": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "right": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "position": {
                  "enum": [
                    "sticky",
                    "stickyToHeader",
                    "absolute",
                    "relative"
                  ]
                },
                "isInFront": true,
                "top": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "properties": {
                        "value": true,
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": true
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "properties": {
                            "formula": true,
                            "values": {
                              "type": "object",
                              "properties": {},
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "properties": {
                                      "value": true,
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": true
                                    }
                                  }
                                ]
                              }
                            }
                          },
                          "additionalProperties": false
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "bottom": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "properties": {
                        "value": true,
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": true
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "properties": {
                            "formula": true,
                            "values": {
                              "type": "object",
                              "properties": {},
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "properties": {
                                      "value": true,
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": true
                                    }
                                  }
                                ]
                              }
                            }
                          },
                          "additionalProperties": false
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "left": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "properties": {
                        "value": true,
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": true
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "properties": {
                            "formula": true,
                            "values": {
                              "type": "object",
                              "properties": {},
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "properties": {
                                      "value": true,
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": true
                                    }
                                  }
                                ]
                              }
                            }
                          },
                          "additionalProperties": false
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "right": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "properties": {
                        "value": true,
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": true
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "properties": {
                            "formula": true,
                            "values": {
                              "type": "object",
                              "properties": {},
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "properties": {
                                      "value": true,
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": true
                                    }
                                  }
                                ]
                              }
                            }
                          },
                          "additionalProperties": false
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "order": true,
                "alignSelf": {
                  "type": "string",
                  "enum": [
                    "start",
                    "end",
                    "center",
                    "stretch",
                    "content"
                  ]
                },
                "justifySelf": {
                  "type": "string",
                  "enum": [
                    "start",
                    "end",
                    "center",
                    "stretch",
                    "content"
                  ]
                },
                "basis": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "properties": {
                        "value": true,
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": true
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "properties": {
                            "formula": true,
                            "values": {
                              "type": "object",
                              "properties": {},
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "properties": {
                                      "value": true,
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": true
                                    }
                                  }
                                ]
                              }
                            }
                          },
                          "additionalProperties": false
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "grow": true,
                "shrink": true
              },
              "additionalProperties": false
            },
            {
              "type": [
                "object"
              ],
              "properties": {
                "id": true,
                "type": {
                  "type": "string",
                  "enum": [
                    "OrganizerItemLayout"
                  ]
                },
                "scrollSnapAlign": {
                  "enum": [
                    "center",
                    "end",
                    "start",
                    "none"
                  ]
                },
                "pinnedToContainer": true,
                "margins": {
                  "type": "object",
                  "properties": {
                    "top": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "bottom": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "left": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "right": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "position": {
                  "enum": [
                    "sticky",
                    "stickyToHeader",
                    "absolute",
                    "relative"
                  ]
                },
                "isInFront": true,
                "top": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "properties": {
                        "value": true,
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": true
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "properties": {
                            "formula": true,
                            "values": {
                              "type": "object",
                              "properties": {},
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "properties": {
                                      "value": true,
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": true
                                    }
                                  }
                                ]
                              }
                            }
                          },
                          "additionalProperties": false
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "bottom": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "properties": {
                        "value": true,
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": true
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "properties": {
                            "formula": true,
                            "values": {
                              "type": "object",
                              "properties": {},
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "properties": {
                                      "value": true,
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": true
                                    }
                                  }
                                ]
                              }
                            }
                          },
                          "additionalProperties": false
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "left": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "properties": {
                        "value": true,
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": true
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "properties": {
                            "formula": true,
                            "values": {
                              "type": "object",
                              "properties": {},
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "properties": {
                                      "value": true,
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": true
                                    }
                                  }
                                ]
                              }
                            }
                          },
                          "additionalProperties": false
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "right": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "properties": {
                        "value": true,
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": true
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "properties": {
                            "formula": true,
                            "values": {
                              "type": "object",
                              "properties": {},
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "properties": {
                                      "value": true,
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": true
                                    }
                                  }
                                ]
                              }
                            }
                          },
                          "additionalProperties": false
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "order": true,
                "alignSelf": {
                  "type": "string",
                  "enum": [
                    "start",
                    "end",
                    "center",
                    "stretch",
                    "content"
                  ]
                },
                "justifySelf": {
                  "type": "string",
                  "enum": [
                    "start",
                    "end",
                    "center",
                    "stretch",
                    "content"
                  ]
                },
                "basis": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "properties": {
                        "value": true,
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": true
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "properties": {
                            "formula": true,
                            "values": {
                              "type": "object",
                              "properties": {},
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "properties": {
                                      "value": true,
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": true
                                    }
                                  }
                                ]
                              }
                            }
                          },
                          "additionalProperties": false
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "grow": true,
                "shrink": true
              },
              "additionalProperties": false
            },
            {
              "type": [
                "object"
              ],
              "properties": {
                "id": true,
                "type": {
                  "type": "string",
                  "enum": [
                    "StackItemLayout"
                  ]
                },
                "scrollSnapAlign": {
                  "enum": [
                    "center",
                    "end",
                    "start",
                    "none"
                  ]
                },
                "pinnedToContainer": true,
                "margins": {
                  "type": "object",
                  "properties": {
                    "top": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "bottom": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "left": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "right": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "position": {
                  "enum": [
                    "sticky",
                    "stickyToHeader",
                    "absolute",
                    "relative"
                  ]
                },
                "isInFront": true,
                "top": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "properties": {
                        "value": true,
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": true
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "properties": {
                            "formula": true,
                            "values": {
                              "type": "object",
                              "properties": {},
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "properties": {
                                      "value": true,
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": true
                                    }
                                  }
                                ]
                              }
                            }
                          },
                          "additionalProperties": false
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "bottom": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "properties": {
                        "value": true,
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": true
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "properties": {
                            "formula": true,
                            "values": {
                              "type": "object",
                              "properties": {},
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "properties": {
                                      "value": true,
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": true
                                    }
                                  }
                                ]
                              }
                            }
                          },
                          "additionalProperties": false
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "left": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "properties": {
                        "value": true,
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": true
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "properties": {
                            "formula": true,
                            "values": {
                              "type": "object",
                              "properties": {},
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "properties": {
                                      "value": true,
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": true
                                    }
                                  }
                                ]
                              }
                            }
                          },
                          "additionalProperties": false
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "right": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "properties": {
                        "value": true,
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": true
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "properties": {
                            "formula": true,
                            "values": {
                              "type": "object",
                              "properties": {},
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "properties": {
                                      "value": true,
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": true
                                    }
                                  }
                                ]
                              }
                            }
                          },
                          "additionalProperties": false
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "order": true,
                "alignSelf": {
                  "type": "string",
                  "enum": [
                    "start",
                    "end",
                    "center",
                    "stretch",
                    "content"
                  ]
                },
                "justifySelf": {
                  "type": "string",
                  "enum": [
                    "start",
                    "end",
                    "center",
                    "stretch",
                    "content"
                  ]
                },
                "basis": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "properties": {
                        "value": true,
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": true
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "properties": {
                            "formula": true,
                            "values": {
                              "type": "object",
                              "properties": {},
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "properties": {
                                      "value": true,
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": true
                                    }
                                  }
                                ]
                              }
                            }
                          },
                          "additionalProperties": false
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "grow": true,
                "shrink": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "margins": {
                  "type": "object",
                  "properties": {
                    "top": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "bottom": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "left": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "right": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "type": {
                  "type": "string",
                  "enum": [
                    "MultiColumnsItemLayout"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "justifySelf": {
                  "type": "string",
                  "enum": [
                    "start",
                    "end",
                    "center",
                    "stretch",
                    "content"
                  ]
                },
                "margins": {
                  "type": "object",
                  "properties": {
                    "top": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "bottom": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "left": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "right": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "meshData": {
                  "type": "object",
                  "properties": {
                    "width": true,
                    "height": true,
                    "x": true,
                    "y": true,
                    "rotationInDegrees": true
                  },
                  "additionalProperties": false
                },
                "type": {
                  "type": "string",
                  "enum": [
                    "MeshItemLayout"
                  ]
                },
                "isAbsolutePosition": true
              },
              "additionalProperties": false
            },
            {
              "type": [
                "object"
              ],
              "properties": {
                "id": true,
                "type": {
                  "type": "string",
                  "enum": [
                    "FixedPositionItemLayout"
                  ]
                },
                "scrollSnapAlign": {
                  "enum": [
                    "center",
                    "end",
                    "start",
                    "none"
                  ]
                },
                "pinnedToContainer": true,
                "margins": {
                  "type": "object",
                  "properties": {
                    "top": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "bottom": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "left": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "right": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "position": {
                  "enum": [
                    "sticky",
                    "stickyToHeader",
                    "absolute",
                    "relative"
                  ]
                },
                "isInFront": true,
                "top": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "properties": {
                        "value": true,
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": true
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "properties": {
                            "formula": true,
                            "values": {
                              "type": "object",
                              "properties": {},
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "properties": {
                                      "value": true,
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": true
                                    }
                                  }
                                ]
                              }
                            }
                          },
                          "additionalProperties": false
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "bottom": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "properties": {
                        "value": true,
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": true
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "properties": {
                            "formula": true,
                            "values": {
                              "type": "object",
                              "properties": {},
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "properties": {
                                      "value": true,
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": true
                                    }
                                  }
                                ]
                              }
                            }
                          },
                          "additionalProperties": false
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "left": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "properties": {
                        "value": true,
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": true
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "properties": {
                            "formula": true,
                            "values": {
                              "type": "object",
                              "properties": {},
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "properties": {
                                      "value": true,
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": true
                                    }
                                  }
                                ]
                              }
                            }
                          },
                          "additionalProperties": false
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "right": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "properties": {
                        "value": true,
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": true
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "properties": {
                            "formula": true,
                            "values": {
                              "type": "object",
                              "properties": {},
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "properties": {
                                      "value": true,
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": true
                                    }
                                  }
                                ]
                              }
                            }
                          },
                          "additionalProperties": false
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": [
                "object"
              ],
              "properties": {
                "id": true,
                "type": {
                  "type": "string",
                  "enum": [
                    "BackgroundLayerItemLayout"
                  ]
                },
                "scrollSnapAlign": {
                  "enum": [
                    "center",
                    "end",
                    "start",
                    "none"
                  ]
                },
                "pinnedToContainer": true,
                "margins": {
                  "type": "object",
                  "properties": {
                    "top": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "bottom": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "left": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "right": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "position": {
                  "enum": [
                    "sticky",
                    "stickyToHeader",
                    "absolute",
                    "relative"
                  ]
                },
                "isInFront": true,
                "top": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "properties": {
                        "value": true,
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": true
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "properties": {
                            "formula": true,
                            "values": {
                              "type": "object",
                              "properties": {},
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "properties": {
                                      "value": true,
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": true
                                    }
                                  }
                                ]
                              }
                            }
                          },
                          "additionalProperties": false
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "bottom": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "properties": {
                        "value": true,
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": true
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "properties": {
                            "formula": true,
                            "values": {
                              "type": "object",
                              "properties": {},
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "properties": {
                                      "value": true,
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": true
                                    }
                                  }
                                ]
                              }
                            }
                          },
                          "additionalProperties": false
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "left": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "properties": {
                        "value": true,
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": true
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "properties": {
                            "formula": true,
                            "values": {
                              "type": "object",
                              "properties": {},
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "properties": {
                                      "value": true,
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": true
                                    }
                                  }
                                ]
                              }
                            }
                          },
                          "additionalProperties": false
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "right": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "properties": {
                        "value": true,
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": true
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "properties": {
                            "formula": true,
                            "values": {
                              "type": "object",
                              "properties": {},
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "properties": {
                                      "value": true,
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": true
                                    }
                                  }
                                ]
                              }
                            }
                          },
                          "additionalProperties": false
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "alignSelf": {
                  "type": "string",
                  "enum": [
                    "start",
                    "end",
                    "center",
                    "stretch",
                    "content"
                  ]
                },
                "justifySelf": {
                  "type": "string",
                  "enum": [
                    "start",
                    "end",
                    "center",
                    "stretch",
                    "content"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": [
                "object"
              ],
              "properties": {
                "id": true,
                "type": {
                  "type": "string",
                  "enum": [
                    "MasterPageItemLayout"
                  ]
                },
                "scrollSnapAlign": {
                  "enum": [
                    "center",
                    "end",
                    "start",
                    "none"
                  ]
                },
                "pinnedToContainer": true,
                "margins": {
                  "type": "object",
                  "properties": {
                    "top": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "bottom": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "left": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "right": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "position": {
                  "enum": [
                    "sticky",
                    "stickyToHeader",
                    "absolute",
                    "relative"
                  ]
                },
                "isInFront": true,
                "top": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "properties": {
                        "value": true,
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": true
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "properties": {
                            "formula": true,
                            "values": {
                              "type": "object",
                              "properties": {},
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "properties": {
                                      "value": true,
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": true
                                    }
                                  }
                                ]
                              }
                            }
                          },
                          "additionalProperties": false
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "bottom": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "properties": {
                        "value": true,
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": true
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "properties": {
                            "formula": true,
                            "values": {
                              "type": "object",
                              "properties": {},
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "properties": {
                                      "value": true,
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": true
                                    }
                                  }
                                ]
                              }
                            }
                          },
                          "additionalProperties": false
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "left": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "properties": {
                        "value": true,
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": true
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "properties": {
                            "formula": true,
                            "values": {
                              "type": "object",
                              "properties": {},
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "properties": {
                                      "value": true,
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": true
                                    }
                                  }
                                ]
                              }
                            }
                          },
                          "additionalProperties": false
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "right": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "properties": {
                        "value": true,
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": true
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "properties": {
                            "formula": true,
                            "values": {
                              "type": "object",
                              "properties": {},
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "properties": {
                                      "value": true,
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": true
                                    }
                                  }
                                ]
                              }
                            }
                          },
                          "additionalProperties": false
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "isFixed": true
              },
              "additionalProperties": false
            }
          ]
        },
        "containerLayout": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "rows": {
                  "type": "array",
                  "items": {
                    "type": "object",
                    "properties": {
                      "type": true,
                      "min": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            },
                            "additionalProperties": false
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Calc"
                                ]
                              },
                              "value": true
                            },
                            "additionalProperties": false
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "CalcFormula"
                                ]
                              },
                              "value": {
                                "type": "object",
                                "properties": {
                                  "formula": true,
                                  "values": {
                                    "type": "object",
                                    "properties": {},
                                    "additionalProperties": {
                                      "type": "object",
                                      "anyOf": [
                                        {
                                          "type": "object",
                                          "properties": {
                                            "value": true,
                                            "type": {
                                              "enum": [
                                                "px",
                                                "em",
                                                "rem",
                                                "fr",
                                                "percentage",
                                                "vh",
                                                "vw",
                                                "spx",
                                                "siteWidthPercentage"
                                              ]
                                            }
                                          }
                                        },
                                        {
                                          "type": "object",
                                          "properties": {
                                            "type": {
                                              "enum": [
                                                "SystemVariable"
                                              ]
                                            },
                                            "value": {
                                              "enum": [
                                                "siteWidth",
                                                "topBannerHeight"
                                              ]
                                            }
                                          }
                                        },
                                        {
                                          "type": "object",
                                          "properties": {
                                            "type": {
                                              "enum": [
                                                "Number"
                                              ]
                                            },
                                            "value": true
                                          }
                                        }
                                      ]
                                    }
                                  }
                                },
                                "additionalProperties": false
                              }
                            },
                            "additionalProperties": false
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            },
                            "additionalProperties": false
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "auto",
                                  "maxContent",
                                  "minContent",
                                  "unset",
                                  "fit"
                                ]
                              }
                            },
                            "additionalProperties": false
                          }
                        ]
                      },
                      "max": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            },
                            "additionalProperties": false
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Calc"
                                ]
                              },
                              "value": true
                            },
                            "additionalProperties": false
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "CalcFormula"
                                ]
                              },
                              "value": {
                                "type": "object",
                                "properties": {
                                  "formula": true,
                                  "values": {
                                    "type": "object",
                                    "properties": {},
                                    "additionalProperties": {
                                      "type": "object",
                                      "anyOf": [
                                        {
                                          "type": "object",
                                          "properties": {
                                            "value": true,
                                            "type": {
                                              "enum": [
                                                "px",
                                                "em",
                                                "rem",
                                                "fr",
                                                "percentage",
                                                "vh",
                                                "vw",
                                                "spx",
                                                "siteWidthPercentage"
                                              ]
                                            }
                                          }
                                        },
                                        {
                                          "type": "object",
                                          "properties": {
                                            "type": {
                                              "enum": [
                                                "SystemVariable"
                                              ]
                                            },
                                            "value": {
                                              "enum": [
                                                "siteWidth",
                                                "topBannerHeight"
                                              ]
                                            }
                                          }
                                        },
                                        {
                                          "type": "object",
                                          "properties": {
                                            "type": {
                                              "enum": [
                                                "Number"
                                              ]
                                            },
                                            "value": true
                                          }
                                        }
                                      ]
                                    }
                                  }
                                },
                                "additionalProperties": false
                              }
                            },
                            "additionalProperties": false
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            },
                            "additionalProperties": false
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "auto",
                                  "maxContent",
                                  "minContent",
                                  "unset",
                                  "fit"
                                ]
                              }
                            },
                            "additionalProperties": false
                          }
                        ]
                      },
                      "value": true,
                      "length": {
                        "anyOf": [
                          {
                            "type": "number"
                          },
                          {
                            "enum": [
                              "auto-fill",
                              "auto-fit"
                            ]
                          }
                        ]
                      }
                    },
                    "additionalProperties": false
                  }
                },
                "columns": {
                  "type": "array",
                  "items": {
                    "type": "object",
                    "properties": {
                      "type": true,
                      "min": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            },
                            "additionalProperties": false
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Calc"
                                ]
                              },
                              "value": true
                            },
                            "additionalProperties": false
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "CalcFormula"
                                ]
                              },
                              "value": {
                                "type": "object",
                                "properties": {
                                  "formula": true,
                                  "values": {
                                    "type": "object",
                                    "properties": {},
                                    "additionalProperties": {
                                      "type": "object",
                                      "anyOf": [
                                        {
                                          "type": "object",
                                          "properties": {
                                            "value": true,
                                            "type": {
                                              "enum": [
                                                "px",
                                                "em",
                                                "rem",
                                                "fr",
                                                "percentage",
                                                "vh",
                                                "vw",
                                                "spx",
                                                "siteWidthPercentage"
                                              ]
                                            }
                                          }
                                        },
                                        {
                                          "type": "object",
                                          "properties": {
                                            "type": {
                                              "enum": [
                                                "SystemVariable"
                                              ]
                                            },
                                            "value": {
                                              "enum": [
                                                "siteWidth",
                                                "topBannerHeight"
                                              ]
                                            }
                                          }
                                        },
                                        {
                                          "type": "object",
                                          "properties": {
                                            "type": {
                                              "enum": [
                                                "Number"
                                              ]
                                            },
                                            "value": true
                                          }
                                        }
                                      ]
                                    }
                                  }
                                },
                                "additionalProperties": false
                              }
                            },
                            "additionalProperties": false
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            },
                            "additionalProperties": false
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "auto",
                                  "maxContent",
                                  "minContent",
                                  "unset",
                                  "fit"
                                ]
                              }
                            },
                            "additionalProperties": false
                          }
                        ]
                      },
                      "max": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            },
                            "additionalProperties": false
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Calc"
                                ]
                              },
                              "value": true
                            },
                            "additionalProperties": false
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "CalcFormula"
                                ]
                              },
                              "value": {
                                "type": "object",
                                "properties": {
                                  "formula": true,
                                  "values": {
                                    "type": "object",
                                    "properties": {},
                                    "additionalProperties": {
                                      "type": "object",
                                      "anyOf": [
                                        {
                                          "type": "object",
                                          "properties": {
                                            "value": true,
                                            "type": {
                                              "enum": [
                                                "px",
                                                "em",
                                                "rem",
                                                "fr",
                                                "percentage",
                                                "vh",
                                                "vw",
                                                "spx",
                                                "siteWidthPercentage"
                                              ]
                                            }
                                          }
                                        },
                                        {
                                          "type": "object",
                                          "properties": {
                                            "type": {
                                              "enum": [
                                                "SystemVariable"
                                              ]
                                            },
                                            "value": {
                                              "enum": [
                                                "siteWidth",
                                                "topBannerHeight"
                                              ]
                                            }
                                          }
                                        },
                                        {
                                          "type": "object",
                                          "properties": {
                                            "type": {
                                              "enum": [
                                                "Number"
                                              ]
                                            },
                                            "value": true
                                          }
                                        }
                                      ]
                                    }
                                  }
                                },
                                "additionalProperties": false
                              }
                            },
                            "additionalProperties": false
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            },
                            "additionalProperties": false
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "auto",
                                  "maxContent",
                                  "minContent",
                                  "unset",
                                  "fit"
                                ]
                              }
                            },
                            "additionalProperties": false
                          }
                        ]
                      },
                      "value": true,
                      "length": {
                        "anyOf": [
                          {
                            "type": "number"
                          },
                          {
                            "enum": [
                              "auto-fill",
                              "auto-fit"
                            ]
                          }
                        ]
                      }
                    },
                    "additionalProperties": false
                  }
                },
                "rowGap": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "properties": {
                        "value": true,
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": true
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "properties": {
                            "formula": true,
                            "values": {
                              "type": "object",
                              "properties": {},
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "properties": {
                                      "value": true,
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": true
                                    }
                                  }
                                ]
                              }
                            }
                          },
                          "additionalProperties": false
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "columnGap": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "properties": {
                        "value": true,
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": true
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "properties": {
                            "formula": true,
                            "values": {
                              "type": "object",
                              "properties": {},
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "properties": {
                                      "value": true,
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": true
                                    }
                                  }
                                ]
                              }
                            }
                          },
                          "additionalProperties": false
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "autoRows": {
                  "type": "array",
                  "items": {
                    "type": "object",
                    "properties": {
                      "type": true,
                      "min": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            },
                            "additionalProperties": false
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Calc"
                                ]
                              },
                              "value": true
                            },
                            "additionalProperties": false
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "CalcFormula"
                                ]
                              },
                              "value": {
                                "type": "object",
                                "properties": {
                                  "formula": true,
                                  "values": {
                                    "type": "object",
                                    "properties": {},
                                    "additionalProperties": {
                                      "type": "object",
                                      "anyOf": [
                                        {
                                          "type": "object",
                                          "properties": {
                                            "value": true,
                                            "type": {
                                              "enum": [
                                                "px",
                                                "em",
                                                "rem",
                                                "fr",
                                                "percentage",
                                                "vh",
                                                "vw",
                                                "spx",
                                                "siteWidthPercentage"
                                              ]
                                            }
                                          }
                                        },
                                        {
                                          "type": "object",
                                          "properties": {
                                            "type": {
                                              "enum": [
                                                "SystemVariable"
                                              ]
                                            },
                                            "value": {
                                              "enum": [
                                                "siteWidth",
                                                "topBannerHeight"
                                              ]
                                            }
                                          }
                                        },
                                        {
                                          "type": "object",
                                          "properties": {
                                            "type": {
                                              "enum": [
                                                "Number"
                                              ]
                                            },
                                            "value": true
                                          }
                                        }
                                      ]
                                    }
                                  }
                                },
                                "additionalProperties": false
                              }
                            },
                            "additionalProperties": false
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            },
                            "additionalProperties": false
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "auto",
                                  "maxContent",
                                  "minContent",
                                  "unset",
                                  "fit"
                                ]
                              }
                            },
                            "additionalProperties": false
                          }
                        ]
                      },
                      "max": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            },
                            "additionalProperties": false
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Calc"
                                ]
                              },
                              "value": true
                            },
                            "additionalProperties": false
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "CalcFormula"
                                ]
                              },
                              "value": {
                                "type": "object",
                                "properties": {
                                  "formula": true,
                                  "values": {
                                    "type": "object",
                                    "properties": {},
                                    "additionalProperties": {
                                      "type": "object",
                                      "anyOf": [
                                        {
                                          "type": "object",
                                          "properties": {
                                            "value": true,
                                            "type": {
                                              "enum": [
                                                "px",
                                                "em",
                                                "rem",
                                                "fr",
                                                "percentage",
                                                "vh",
                                                "vw",
                                                "spx",
                                                "siteWidthPercentage"
                                              ]
                                            }
                                          }
                                        },
                                        {
                                          "type": "object",
                                          "properties": {
                                            "type": {
                                              "enum": [
                                                "SystemVariable"
                                              ]
                                            },
                                            "value": {
                                              "enum": [
                                                "siteWidth",
                                                "topBannerHeight"
                                              ]
                                            }
                                          }
                                        },
                                        {
                                          "type": "object",
                                          "properties": {
                                            "type": {
                                              "enum": [
                                                "Number"
                                              ]
                                            },
                                            "value": true
                                          }
                                        }
                                      ]
                                    }
                                  }
                                },
                                "additionalProperties": false
                              }
                            },
                            "additionalProperties": false
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            },
                            "additionalProperties": false
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "auto",
                                  "maxContent",
                                  "minContent",
                                  "unset",
                                  "fit"
                                ]
                              }
                            },
                            "additionalProperties": false
                          }
                        ]
                      },
                      "value": true,
                      "length": {
                        "anyOf": [
                          {
                            "type": "number"
                          },
                          {
                            "enum": [
                              "auto-fill",
                              "auto-fit"
                            ]
                          }
                        ]
                      }
                    },
                    "additionalProperties": false
                  }
                },
                "autoColumns": {
                  "type": "array",
                  "items": {
                    "type": "object",
                    "properties": {
                      "type": true,
                      "min": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            },
                            "additionalProperties": false
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Calc"
                                ]
                              },
                              "value": true
                            },
                            "additionalProperties": false
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "CalcFormula"
                                ]
                              },
                              "value": {
                                "type": "object",
                                "properties": {
                                  "formula": true,
                                  "values": {
                                    "type": "object",
                                    "properties": {},
                                    "additionalProperties": {
                                      "type": "object",
                                      "anyOf": [
                                        {
                                          "type": "object",
                                          "properties": {
                                            "value": true,
                                            "type": {
                                              "enum": [
                                                "px",
                                                "em",
                                                "rem",
                                                "fr",
                                                "percentage",
                                                "vh",
                                                "vw",
                                                "spx",
                                                "siteWidthPercentage"
                                              ]
                                            }
                                          }
                                        },
                                        {
                                          "type": "object",
                                          "properties": {
                                            "type": {
                                              "enum": [
                                                "SystemVariable"
                                              ]
                                            },
                                            "value": {
                                              "enum": [
                                                "siteWidth",
                                                "topBannerHeight"
                                              ]
                                            }
                                          }
                                        },
                                        {
                                          "type": "object",
                                          "properties": {
                                            "type": {
                                              "enum": [
                                                "Number"
                                              ]
                                            },
                                            "value": true
                                          }
                                        }
                                      ]
                                    }
                                  }
                                },
                                "additionalProperties": false
                              }
                            },
                            "additionalProperties": false
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            },
                            "additionalProperties": false
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "auto",
                                  "maxContent",
                                  "minContent",
                                  "unset",
                                  "fit"
                                ]
                              }
                            },
                            "additionalProperties": false
                          }
                        ]
                      },
                      "max": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            },
                            "additionalProperties": false
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Calc"
                                ]
                              },
                              "value": true
                            },
                            "additionalProperties": false
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "CalcFormula"
                                ]
                              },
                              "value": {
                                "type": "object",
                                "properties": {
                                  "formula": true,
                                  "values": {
                                    "type": "object",
                                    "properties": {},
                                    "additionalProperties": {
                                      "type": "object",
                                      "anyOf": [
                                        {
                                          "type": "object",
                                          "properties": {
                                            "value": true,
                                            "type": {
                                              "enum": [
                                                "px",
                                                "em",
                                                "rem",
                                                "fr",
                                                "percentage",
                                                "vh",
                                                "vw",
                                                "spx",
                                                "siteWidthPercentage"
                                              ]
                                            }
                                          }
                                        },
                                        {
                                          "type": "object",
                                          "properties": {
                                            "type": {
                                              "enum": [
                                                "SystemVariable"
                                              ]
                                            },
                                            "value": {
                                              "enum": [
                                                "siteWidth",
                                                "topBannerHeight"
                                              ]
                                            }
                                          }
                                        },
                                        {
                                          "type": "object",
                                          "properties": {
                                            "type": {
                                              "enum": [
                                                "Number"
                                              ]
                                            },
                                            "value": true
                                          }
                                        }
                                      ]
                                    }
                                  }
                                },
                                "additionalProperties": false
                              }
                            },
                            "additionalProperties": false
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            },
                            "additionalProperties": false
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "auto",
                                  "maxContent",
                                  "minContent",
                                  "unset",
                                  "fit"
                                ]
                              }
                            },
                            "additionalProperties": false
                          }
                        ]
                      },
                      "value": true,
                      "length": {
                        "anyOf": [
                          {
                            "type": "number"
                          },
                          {
                            "enum": [
                              "auto-fill",
                              "auto-fit"
                            ]
                          }
                        ]
                      }
                    },
                    "additionalProperties": false
                  }
                },
                "autoFlow": {
                  "enum": [
                    "row",
                    "column",
                    "dense",
                    "row dense",
                    "column dense"
                  ]
                },
                "overflowY": {
                  "enum": [
                    "auto",
                    "scroll",
                    "hidden",
                    "visible",
                    "clip"
                  ]
                },
                "overflowX": {
                  "enum": [
                    "auto",
                    "scroll",
                    "hidden",
                    "visible",
                    "clip"
                  ]
                },
                "hideScrollbar": true,
                "padding": {
                  "type": "object",
                  "properties": {
                    "top": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "bottom": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "left": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "right": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "scrollSnap": {
                  "type": "object",
                  "properties": {
                    "scrollSnapType": {
                      "enum": [
                        "mandatory",
                        "proximity",
                        "none"
                      ]
                    },
                    "scrollSnapDirection": {
                      "enum": [
                        "x",
                        "y"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "scrollBehavior": {
                  "enum": [
                    "auto",
                    "smooth"
                  ]
                },
                "contentMaxWidth": {
                  "type": "object",
                  "properties": {
                    "maxWidth": {
                      "type": "object",
                      "properties": {
                        "value": true,
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    "align": {
                      "type": "string",
                      "enum": [
                        "center",
                        "right",
                        "left"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "type": {
                  "type": "string",
                  "enum": [
                    "GridContainerLayout"
                  ]
                },
                "contain": {
                  "enum": [
                    "none",
                    "paint"
                  ]
                },
                "spxStopper": {
                  "type": "object",
                  "properties": {
                    "min": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "max": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": [
                "object"
              ],
              "properties": {
                "id": true,
                "type": {
                  "type": "string",
                  "enum": [
                    "FlexContainerLayout"
                  ]
                },
                "scrollSnapAlign": {
                  "enum": [
                    "center",
                    "end",
                    "start",
                    "none"
                  ]
                },
                "pinnedToContainer": true,
                "margins": {
                  "type": "object",
                  "properties": {
                    "top": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "bottom": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "left": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "right": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "position": {
                  "enum": [
                    "sticky",
                    "stickyToHeader",
                    "absolute",
                    "relative"
                  ]
                },
                "isInFront": true,
                "top": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "properties": {
                        "value": true,
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": true
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "properties": {
                            "formula": true,
                            "values": {
                              "type": "object",
                              "properties": {},
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "properties": {
                                      "value": true,
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": true
                                    }
                                  }
                                ]
                              }
                            }
                          },
                          "additionalProperties": false
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "bottom": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "properties": {
                        "value": true,
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": true
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "properties": {
                            "formula": true,
                            "values": {
                              "type": "object",
                              "properties": {},
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "properties": {
                                      "value": true,
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": true
                                    }
                                  }
                                ]
                              }
                            }
                          },
                          "additionalProperties": false
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "left": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "properties": {
                        "value": true,
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": true
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "properties": {
                            "formula": true,
                            "values": {
                              "type": "object",
                              "properties": {},
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "properties": {
                                      "value": true,
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": true
                                    }
                                  }
                                ]
                              }
                            }
                          },
                          "additionalProperties": false
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "right": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "properties": {
                        "value": true,
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": true
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "properties": {
                            "formula": true,
                            "values": {
                              "type": "object",
                              "properties": {},
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "properties": {
                                      "value": true,
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": true
                                    }
                                  }
                                ]
                              }
                            }
                          },
                          "additionalProperties": false
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "direction": {
                  "enum": [
                    "row",
                    "rowReverse",
                    "column",
                    "columnReverse"
                  ]
                },
                "wrap": {
                  "enum": [
                    "nowrap",
                    "wrap"
                  ]
                },
                "alignItems": {
                  "type": "string",
                  "enum": [
                    "start",
                    "end",
                    "center",
                    "stretch",
                    "content"
                  ]
                },
                "justifyContent": {
                  "enum": [
                    "start",
                    "center",
                    "end",
                    "spaceBetween",
                    "spaceAround",
                    "spaceEvenly"
                  ]
                },
                "overflowY": {
                  "enum": [
                    "auto",
                    "scroll",
                    "hidden",
                    "visible",
                    "clip"
                  ]
                },
                "overflowX": {
                  "enum": [
                    "auto",
                    "scroll",
                    "hidden",
                    "visible",
                    "clip"
                  ]
                },
                "hideScrollbar": true,
                "padding": {
                  "type": "object",
                  "properties": {
                    "top": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "bottom": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "left": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "right": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "scrollSnap": {
                  "type": "object",
                  "properties": {
                    "scrollSnapType": {
                      "enum": [
                        "mandatory",
                        "proximity",
                        "none"
                      ]
                    },
                    "scrollSnapDirection": {
                      "enum": [
                        "x",
                        "y"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "scrollBehaviour": {
                  "enum": [
                    "auto",
                    "smooth"
                  ]
                },
                "contentMaxWidth": {
                  "type": "object",
                  "properties": {
                    "maxWidth": {
                      "type": "object",
                      "properties": {
                        "value": true,
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    "align": {
                      "type": "string",
                      "enum": [
                        "center",
                        "right",
                        "left"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "spxStopper": {
                  "type": "object",
                  "properties": {
                    "min": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "max": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "rowGap": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "properties": {
                        "value": true,
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": true
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "properties": {
                            "formula": true,
                            "values": {
                              "type": "object",
                              "properties": {},
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "properties": {
                                      "value": true,
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": true
                                    }
                                  }
                                ]
                              }
                            }
                          },
                          "additionalProperties": false
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "columnGap": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "properties": {
                        "value": true,
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": true
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "properties": {
                            "formula": true,
                            "values": {
                              "type": "object",
                              "properties": {},
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "properties": {
                                      "value": true,
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": true
                                    }
                                  }
                                ]
                              }
                            }
                          },
                          "additionalProperties": false
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "contain": {
                  "enum": [
                    "none",
                    "paint"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": [
                "object"
              ],
              "properties": {
                "layoutIntent": {
                  "type": "string",
                  "enum": [
                    "Rows",
                    "Cols",
                    "Mosaic",
                    "Slider",
                    "SlideShow",
                    "Bricks"
                  ]
                },
                "id": true,
                "type": {
                  "type": "string",
                  "enum": [
                    "OrganizerContainerLayout"
                  ]
                },
                "scrollSnapAlign": {
                  "enum": [
                    "center",
                    "end",
                    "start",
                    "none"
                  ]
                },
                "pinnedToContainer": true,
                "margins": {
                  "type": "object",
                  "properties": {
                    "top": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "bottom": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "left": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "right": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "position": {
                  "enum": [
                    "sticky",
                    "stickyToHeader",
                    "absolute",
                    "relative"
                  ]
                },
                "isInFront": true,
                "top": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "properties": {
                        "value": true,
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": true
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "properties": {
                            "formula": true,
                            "values": {
                              "type": "object",
                              "properties": {},
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "properties": {
                                      "value": true,
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": true
                                    }
                                  }
                                ]
                              }
                            }
                          },
                          "additionalProperties": false
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "bottom": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "properties": {
                        "value": true,
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": true
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "properties": {
                            "formula": true,
                            "values": {
                              "type": "object",
                              "properties": {},
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "properties": {
                                      "value": true,
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": true
                                    }
                                  }
                                ]
                              }
                            }
                          },
                          "additionalProperties": false
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "left": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "properties": {
                        "value": true,
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": true
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "properties": {
                            "formula": true,
                            "values": {
                              "type": "object",
                              "properties": {},
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "properties": {
                                      "value": true,
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": true
                                    }
                                  }
                                ]
                              }
                            }
                          },
                          "additionalProperties": false
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "right": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "properties": {
                        "value": true,
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": true
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "properties": {
                            "formula": true,
                            "values": {
                              "type": "object",
                              "properties": {},
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "properties": {
                                      "value": true,
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": true
                                    }
                                  }
                                ]
                              }
                            }
                          },
                          "additionalProperties": false
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "direction": {
                  "enum": [
                    "row",
                    "rowReverse",
                    "column",
                    "columnReverse"
                  ]
                },
                "wrap": {
                  "enum": [
                    "nowrap",
                    "wrap"
                  ]
                },
                "alignItems": {
                  "type": "string",
                  "enum": [
                    "start",
                    "end",
                    "center",
                    "stretch",
                    "content"
                  ]
                },
                "justifyContent": {
                  "enum": [
                    "start",
                    "center",
                    "end",
                    "spaceBetween",
                    "spaceAround",
                    "spaceEvenly"
                  ]
                },
                "overflowY": {
                  "enum": [
                    "auto",
                    "scroll",
                    "hidden",
                    "visible",
                    "clip"
                  ]
                },
                "overflowX": {
                  "enum": [
                    "auto",
                    "scroll",
                    "hidden",
                    "visible",
                    "clip"
                  ]
                },
                "hideScrollbar": true,
                "padding": {
                  "type": "object",
                  "properties": {
                    "top": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "bottom": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "left": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "right": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "scrollSnap": {
                  "type": "object",
                  "properties": {
                    "scrollSnapType": {
                      "enum": [
                        "mandatory",
                        "proximity",
                        "none"
                      ]
                    },
                    "scrollSnapDirection": {
                      "enum": [
                        "x",
                        "y"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "scrollBehaviour": {
                  "enum": [
                    "auto",
                    "smooth"
                  ]
                },
                "contentMaxWidth": {
                  "type": "object",
                  "properties": {
                    "maxWidth": {
                      "type": "object",
                      "properties": {
                        "value": true,
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    "align": {
                      "type": "string",
                      "enum": [
                        "center",
                        "right",
                        "left"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "spxStopper": {
                  "type": "object",
                  "properties": {
                    "min": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "max": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "rowGap": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "properties": {
                        "value": true,
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": true
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "properties": {
                            "formula": true,
                            "values": {
                              "type": "object",
                              "properties": {},
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "properties": {
                                      "value": true,
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": true
                                    }
                                  }
                                ]
                              }
                            }
                          },
                          "additionalProperties": false
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "columnGap": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "properties": {
                        "value": true,
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": true
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "properties": {
                            "formula": true,
                            "values": {
                              "type": "object",
                              "properties": {},
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "properties": {
                                      "value": true,
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": true
                                    }
                                  }
                                ]
                              }
                            }
                          },
                          "additionalProperties": false
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "contain": {
                  "enum": [
                    "none",
                    "paint"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": [
                "object"
              ],
              "properties": {
                "id": true,
                "type": {
                  "type": "string",
                  "enum": [
                    "StackContainerLayout"
                  ]
                },
                "scrollSnapAlign": {
                  "enum": [
                    "center",
                    "end",
                    "start",
                    "none"
                  ]
                },
                "pinnedToContainer": true,
                "margins": {
                  "type": "object",
                  "properties": {
                    "top": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "bottom": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "left": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "right": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "position": {
                  "enum": [
                    "sticky",
                    "stickyToHeader",
                    "absolute",
                    "relative"
                  ]
                },
                "isInFront": true,
                "top": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "properties": {
                        "value": true,
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": true
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "properties": {
                            "formula": true,
                            "values": {
                              "type": "object",
                              "properties": {},
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "properties": {
                                      "value": true,
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": true
                                    }
                                  }
                                ]
                              }
                            }
                          },
                          "additionalProperties": false
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "bottom": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "properties": {
                        "value": true,
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": true
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "properties": {
                            "formula": true,
                            "values": {
                              "type": "object",
                              "properties": {},
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "properties": {
                                      "value": true,
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": true
                                    }
                                  }
                                ]
                              }
                            }
                          },
                          "additionalProperties": false
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "left": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "properties": {
                        "value": true,
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": true
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "properties": {
                            "formula": true,
                            "values": {
                              "type": "object",
                              "properties": {},
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "properties": {
                                      "value": true,
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": true
                                    }
                                  }
                                ]
                              }
                            }
                          },
                          "additionalProperties": false
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "right": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "properties": {
                        "value": true,
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": true
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "properties": {
                            "formula": true,
                            "values": {
                              "type": "object",
                              "properties": {},
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "properties": {
                                      "value": true,
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": true
                                    }
                                  }
                                ]
                              }
                            }
                          },
                          "additionalProperties": false
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "direction": {
                  "enum": [
                    "row",
                    "rowReverse",
                    "column",
                    "columnReverse"
                  ]
                },
                "wrap": {
                  "enum": [
                    "nowrap",
                    "wrap"
                  ]
                },
                "alignItems": {
                  "type": "string",
                  "enum": [
                    "start",
                    "end",
                    "center",
                    "stretch",
                    "content"
                  ]
                },
                "justifyContent": {
                  "enum": [
                    "start",
                    "center",
                    "end",
                    "spaceBetween",
                    "spaceAround",
                    "spaceEvenly"
                  ]
                },
                "overflowY": {
                  "enum": [
                    "auto",
                    "scroll",
                    "hidden",
                    "visible",
                    "clip"
                  ]
                },
                "overflowX": {
                  "enum": [
                    "auto",
                    "scroll",
                    "hidden",
                    "visible",
                    "clip"
                  ]
                },
                "hideScrollbar": true,
                "padding": {
                  "type": "object",
                  "properties": {
                    "top": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "bottom": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "left": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "right": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "scrollSnap": {
                  "type": "object",
                  "properties": {
                    "scrollSnapType": {
                      "enum": [
                        "mandatory",
                        "proximity",
                        "none"
                      ]
                    },
                    "scrollSnapDirection": {
                      "enum": [
                        "x",
                        "y"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "scrollBehaviour": {
                  "enum": [
                    "auto",
                    "smooth"
                  ]
                },
                "contentMaxWidth": {
                  "type": "object",
                  "properties": {
                    "maxWidth": {
                      "type": "object",
                      "properties": {
                        "value": true,
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    "align": {
                      "type": "string",
                      "enum": [
                        "center",
                        "right",
                        "left"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "spxStopper": {
                  "type": "object",
                  "properties": {
                    "min": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "max": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "rowGap": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "properties": {
                        "value": true,
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": true
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "properties": {
                            "formula": true,
                            "values": {
                              "type": "object",
                              "properties": {},
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "properties": {
                                      "value": true,
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": true
                                    }
                                  }
                                ]
                              }
                            }
                          },
                          "additionalProperties": false
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "columnGap": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "properties": {
                        "value": true,
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": true
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "properties": {
                            "formula": true,
                            "values": {
                              "type": "object",
                              "properties": {},
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "properties": {
                                      "value": true,
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": true
                                    }
                                  }
                                ]
                              }
                            }
                          },
                          "additionalProperties": false
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "contain": {
                  "enum": [
                    "none",
                    "paint"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "alignContent": {
                  "type": "string",
                  "enum": [
                    "auto",
                    "stretch",
                    "start",
                    "center",
                    "end"
                  ]
                },
                "columnCount": true,
                "padding": {
                  "type": "object",
                  "properties": {
                    "top": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "bottom": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "left": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "right": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "rowGap": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "properties": {
                        "value": true,
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": true
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "properties": {
                            "formula": true,
                            "values": {
                              "type": "object",
                              "properties": {},
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "properties": {
                                      "value": true,
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": true
                                    }
                                  }
                                ]
                              }
                            }
                          },
                          "additionalProperties": false
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "columnGap": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "properties": {
                        "value": true,
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": true
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "properties": {
                            "formula": true,
                            "values": {
                              "type": "object",
                              "properties": {},
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "properties": {
                                      "value": true,
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": true
                                    }
                                  }
                                ]
                              }
                            }
                          },
                          "additionalProperties": false
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "spxStopper": {
                  "type": "object",
                  "properties": {
                    "min": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "max": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "type": {
                  "type": "string",
                  "enum": [
                    "MultiColumnsContainerLayout"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "MeshContainerLayout"
                  ]
                },
                "meshData": {
                  "type": "object",
                  "properties": {
                    "contentHeight": {
                      "oneOf": [
                        {
                          "type": "number"
                        },
                        {
                          "type": "string",
                          "enum": [
                            "auto"
                          ]
                        }
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "contentArea": {
                  "type": "object",
                  "properties": {
                    "alignment": {
                      "type": "string",
                      "enum": [
                        "start",
                        "end",
                        "center",
                        "stretch",
                        "content"
                      ]
                    },
                    "width": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "properties": {
                                "formula": true,
                                "values": {
                                  "type": "object",
                                  "properties": {},
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "properties": {
                                          "value": true,
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": true
                                        }
                                      }
                                    ]
                                  }
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "ratio": true
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "spx": {
          "type": "object",
          "properties": {
            "refWidth": true,
            "resolverType": {
              "type": "string",
              "enum": [
                "scale",
                "fixed"
              ]
            }
          },
          "additionalProperties": false
        }
      },
      "additionalProperties": false
    },
    "ScrollSnapType": {
      "enum": [
        "mandatory",
        "proximity",
        "none"
      ]
    },
    "ScrollSnapDirection": {
      "enum": [
        "x",
        "y"
      ]
    },
    "ScrollBehavior": {
      "enum": [
        "auto",
        "smooth"
      ]
    },
    "ScrollSnapAlignType": {
      "enum": [
        "center",
        "end",
        "start",
        "none"
      ]
    },
    "ScrollSnapData": {
      "type": "object",
      "properties": {
        "scrollSnapType": {
          "enum": [
            "mandatory",
            "proximity",
            "none"
          ]
        },
        "scrollSnapDirection": {
          "enum": [
            "x",
            "y"
          ]
        }
      },
      "additionalProperties": false
    },
    "ContentMaxWidth": {
      "type": "object",
      "properties": {
        "maxWidth": {
          "type": "object",
          "properties": {
            "value": true,
            "type": {
              "enum": [
                "px",
                "em",
                "rem",
                "fr",
                "percentage",
                "vh",
                "vw",
                "spx",
                "siteWidthPercentage"
              ]
            }
          },
          "additionalProperties": false
        },
        "align": {
          "type": "string",
          "enum": [
            "center",
            "right",
            "left"
          ]
        }
      },
      "additionalProperties": false
    },
    "GridContainerLayout": {
      "type": "object",
      "properties": {
        "rows": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "type": true,
              "min": {
                "type": "object",
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "value": true,
                      "type": {
                        "enum": [
                          "px",
                          "em",
                          "rem",
                          "fr",
                          "percentage",
                          "vh",
                          "vw",
                          "spx",
                          "siteWidthPercentage"
                        ]
                      }
                    },
                    "additionalProperties": false
                  },
                  {
                    "type": "object",
                    "properties": {
                      "type": {
                        "enum": [
                          "Calc"
                        ]
                      },
                      "value": true
                    },
                    "additionalProperties": false
                  },
                  {
                    "type": "object",
                    "properties": {
                      "type": {
                        "enum": [
                          "CalcFormula"
                        ]
                      },
                      "value": {
                        "type": "object",
                        "properties": {
                          "formula": true,
                          "values": {
                            "type": "object",
                            "properties": {},
                            "additionalProperties": {
                              "type": "object",
                              "anyOf": [
                                {
                                  "type": "object",
                                  "properties": {
                                    "value": true,
                                    "type": {
                                      "enum": [
                                        "px",
                                        "em",
                                        "rem",
                                        "fr",
                                        "percentage",
                                        "vh",
                                        "vw",
                                        "spx",
                                        "siteWidthPercentage"
                                      ]
                                    }
                                  }
                                },
                                {
                                  "type": "object",
                                  "properties": {
                                    "type": {
                                      "enum": [
                                        "SystemVariable"
                                      ]
                                    },
                                    "value": {
                                      "enum": [
                                        "siteWidth",
                                        "topBannerHeight"
                                      ]
                                    }
                                  }
                                },
                                {
                                  "type": "object",
                                  "properties": {
                                    "type": {
                                      "enum": [
                                        "Number"
                                      ]
                                    },
                                    "value": true
                                  }
                                }
                              ]
                            }
                          }
                        },
                        "additionalProperties": false
                      }
                    },
                    "additionalProperties": false
                  },
                  {
                    "type": "object",
                    "properties": {
                      "type": {
                        "enum": [
                          "SystemVariable"
                        ]
                      },
                      "value": {
                        "enum": [
                          "siteWidth",
                          "topBannerHeight"
                        ]
                      }
                    },
                    "additionalProperties": false
                  },
                  {
                    "type": "object",
                    "properties": {
                      "type": {
                        "enum": [
                          "auto",
                          "maxContent",
                          "minContent",
                          "unset",
                          "fit"
                        ]
                      }
                    },
                    "additionalProperties": false
                  }
                ]
              },
              "max": {
                "type": "object",
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "value": true,
                      "type": {
                        "enum": [
                          "px",
                          "em",
                          "rem",
                          "fr",
                          "percentage",
                          "vh",
                          "vw",
                          "spx",
                          "siteWidthPercentage"
                        ]
                      }
                    },
                    "additionalProperties": false
                  },
                  {
                    "type": "object",
                    "properties": {
                      "type": {
                        "enum": [
                          "Calc"
                        ]
                      },
                      "value": true
                    },
                    "additionalProperties": false
                  },
                  {
                    "type": "object",
                    "properties": {
                      "type": {
                        "enum": [
                          "CalcFormula"
                        ]
                      },
                      "value": {
                        "type": "object",
                        "properties": {
                          "formula": true,
                          "values": {
                            "type": "object",
                            "properties": {},
                            "additionalProperties": {
                              "type": "object",
                              "anyOf": [
                                {
                                  "type": "object",
                                  "properties": {
                                    "value": true,
                                    "type": {
                                      "enum": [
                                        "px",
                                        "em",
                                        "rem",
                                        "fr",
                                        "percentage",
                                        "vh",
                                        "vw",
                                        "spx",
                                        "siteWidthPercentage"
                                      ]
                                    }
                                  }
                                },
                                {
                                  "type": "object",
                                  "properties": {
                                    "type": {
                                      "enum": [
                                        "SystemVariable"
                                      ]
                                    },
                                    "value": {
                                      "enum": [
                                        "siteWidth",
                                        "topBannerHeight"
                                      ]
                                    }
                                  }
                                },
                                {
                                  "type": "object",
                                  "properties": {
                                    "type": {
                                      "enum": [
                                        "Number"
                                      ]
                                    },
                                    "value": true
                                  }
                                }
                              ]
                            }
                          }
                        },
                        "additionalProperties": false
                      }
                    },
                    "additionalProperties": false
                  },
                  {
                    "type": "object",
                    "properties": {
                      "type": {
                        "enum": [
                          "SystemVariable"
                        ]
                      },
                      "value": {
                        "enum": [
                          "siteWidth",
                          "topBannerHeight"
                        ]
                      }
                    },
                    "additionalProperties": false
                  },
                  {
                    "type": "object",
                    "properties": {
                      "type": {
                        "enum": [
                          "auto",
                          "maxContent",
                          "minContent",
                          "unset",
                          "fit"
                        ]
                      }
                    },
                    "additionalProperties": false
                  }
                ]
              },
              "value": true,
              "length": {
                "anyOf": [
                  {
                    "type": "number"
                  },
                  {
                    "enum": [
                      "auto-fill",
                      "auto-fit"
                    ]
                  }
                ]
              }
            },
            "additionalProperties": false
          }
        },
        "columns": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "type": true,
              "min": {
                "type": "object",
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "value": true,
                      "type": {
                        "enum": [
                          "px",
                          "em",
                          "rem",
                          "fr",
                          "percentage",
                          "vh",
                          "vw",
                          "spx",
                          "siteWidthPercentage"
                        ]
                      }
                    },
                    "additionalProperties": false
                  },
                  {
                    "type": "object",
                    "properties": {
                      "type": {
                        "enum": [
                          "Calc"
                        ]
                      },
                      "value": true
                    },
                    "additionalProperties": false
                  },
                  {
                    "type": "object",
                    "properties": {
                      "type": {
                        "enum": [
                          "CalcFormula"
                        ]
                      },
                      "value": {
                        "type": "object",
                        "properties": {
                          "formula": true,
                          "values": {
                            "type": "object",
                            "properties": {},
                            "additionalProperties": {
                              "type": "object",
                              "anyOf": [
                                {
                                  "type": "object",
                                  "properties": {
                                    "value": true,
                                    "type": {
                                      "enum": [
                                        "px",
                                        "em",
                                        "rem",
                                        "fr",
                                        "percentage",
                                        "vh",
                                        "vw",
                                        "spx",
                                        "siteWidthPercentage"
                                      ]
                                    }
                                  }
                                },
                                {
                                  "type": "object",
                                  "properties": {
                                    "type": {
                                      "enum": [
                                        "SystemVariable"
                                      ]
                                    },
                                    "value": {
                                      "enum": [
                                        "siteWidth",
                                        "topBannerHeight"
                                      ]
                                    }
                                  }
                                },
                                {
                                  "type": "object",
                                  "properties": {
                                    "type": {
                                      "enum": [
                                        "Number"
                                      ]
                                    },
                                    "value": true
                                  }
                                }
                              ]
                            }
                          }
                        },
                        "additionalProperties": false
                      }
                    },
                    "additionalProperties": false
                  },
                  {
                    "type": "object",
                    "properties": {
                      "type": {
                        "enum": [
                          "SystemVariable"
                        ]
                      },
                      "value": {
                        "enum": [
                          "siteWidth",
                          "topBannerHeight"
                        ]
                      }
                    },
                    "additionalProperties": false
                  },
                  {
                    "type": "object",
                    "properties": {
                      "type": {
                        "enum": [
                          "auto",
                          "maxContent",
                          "minContent",
                          "unset",
                          "fit"
                        ]
                      }
                    },
                    "additionalProperties": false
                  }
                ]
              },
              "max": {
                "type": "object",
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "value": true,
                      "type": {
                        "enum": [
                          "px",
                          "em",
                          "rem",
                          "fr",
                          "percentage",
                          "vh",
                          "vw",
                          "spx",
                          "siteWidthPercentage"
                        ]
                      }
                    },
                    "additionalProperties": false
                  },
                  {
                    "type": "object",
                    "properties": {
                      "type": {
                        "enum": [
                          "Calc"
                        ]
                      },
                      "value": true
                    },
                    "additionalProperties": false
                  },
                  {
                    "type": "object",
                    "properties": {
                      "type": {
                        "enum": [
                          "CalcFormula"
                        ]
                      },
                      "value": {
                        "type": "object",
                        "properties": {
                          "formula": true,
                          "values": {
                            "type": "object",
                            "properties": {},
                            "additionalProperties": {
                              "type": "object",
                              "anyOf": [
                                {
                                  "type": "object",
                                  "properties": {
                                    "value": true,
                                    "type": {
                                      "enum": [
                                        "px",
                                        "em",
                                        "rem",
                                        "fr",
                                        "percentage",
                                        "vh",
                                        "vw",
                                        "spx",
                                        "siteWidthPercentage"
                                      ]
                                    }
                                  }
                                },
                                {
                                  "type": "object",
                                  "properties": {
                                    "type": {
                                      "enum": [
                                        "SystemVariable"
                                      ]
                                    },
                                    "value": {
                                      "enum": [
                                        "siteWidth",
                                        "topBannerHeight"
                                      ]
                                    }
                                  }
                                },
                                {
                                  "type": "object",
                                  "properties": {
                                    "type": {
                                      "enum": [
                                        "Number"
                                      ]
                                    },
                                    "value": true
                                  }
                                }
                              ]
                            }
                          }
                        },
                        "additionalProperties": false
                      }
                    },
                    "additionalProperties": false
                  },
                  {
                    "type": "object",
                    "properties": {
                      "type": {
                        "enum": [
                          "SystemVariable"
                        ]
                      },
                      "value": {
                        "enum": [
                          "siteWidth",
                          "topBannerHeight"
                        ]
                      }
                    },
                    "additionalProperties": false
                  },
                  {
                    "type": "object",
                    "properties": {
                      "type": {
                        "enum": [
                          "auto",
                          "maxContent",
                          "minContent",
                          "unset",
                          "fit"
                        ]
                      }
                    },
                    "additionalProperties": false
                  }
                ]
              },
              "value": true,
              "length": {
                "anyOf": [
                  {
                    "type": "number"
                  },
                  {
                    "enum": [
                      "auto-fill",
                      "auto-fit"
                    ]
                  }
                ]
              }
            },
            "additionalProperties": false
          }
        },
        "rowGap": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "columnGap": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "autoRows": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "type": true,
              "min": {
                "type": "object",
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "value": true,
                      "type": {
                        "enum": [
                          "px",
                          "em",
                          "rem",
                          "fr",
                          "percentage",
                          "vh",
                          "vw",
                          "spx",
                          "siteWidthPercentage"
                        ]
                      }
                    },
                    "additionalProperties": false
                  },
                  {
                    "type": "object",
                    "properties": {
                      "type": {
                        "enum": [
                          "Calc"
                        ]
                      },
                      "value": true
                    },
                    "additionalProperties": false
                  },
                  {
                    "type": "object",
                    "properties": {
                      "type": {
                        "enum": [
                          "CalcFormula"
                        ]
                      },
                      "value": {
                        "type": "object",
                        "properties": {
                          "formula": true,
                          "values": {
                            "type": "object",
                            "properties": {},
                            "additionalProperties": {
                              "type": "object",
                              "anyOf": [
                                {
                                  "type": "object",
                                  "properties": {
                                    "value": true,
                                    "type": {
                                      "enum": [
                                        "px",
                                        "em",
                                        "rem",
                                        "fr",
                                        "percentage",
                                        "vh",
                                        "vw",
                                        "spx",
                                        "siteWidthPercentage"
                                      ]
                                    }
                                  }
                                },
                                {
                                  "type": "object",
                                  "properties": {
                                    "type": {
                                      "enum": [
                                        "SystemVariable"
                                      ]
                                    },
                                    "value": {
                                      "enum": [
                                        "siteWidth",
                                        "topBannerHeight"
                                      ]
                                    }
                                  }
                                },
                                {
                                  "type": "object",
                                  "properties": {
                                    "type": {
                                      "enum": [
                                        "Number"
                                      ]
                                    },
                                    "value": true
                                  }
                                }
                              ]
                            }
                          }
                        },
                        "additionalProperties": false
                      }
                    },
                    "additionalProperties": false
                  },
                  {
                    "type": "object",
                    "properties": {
                      "type": {
                        "enum": [
                          "SystemVariable"
                        ]
                      },
                      "value": {
                        "enum": [
                          "siteWidth",
                          "topBannerHeight"
                        ]
                      }
                    },
                    "additionalProperties": false
                  },
                  {
                    "type": "object",
                    "properties": {
                      "type": {
                        "enum": [
                          "auto",
                          "maxContent",
                          "minContent",
                          "unset",
                          "fit"
                        ]
                      }
                    },
                    "additionalProperties": false
                  }
                ]
              },
              "max": {
                "type": "object",
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "value": true,
                      "type": {
                        "enum": [
                          "px",
                          "em",
                          "rem",
                          "fr",
                          "percentage",
                          "vh",
                          "vw",
                          "spx",
                          "siteWidthPercentage"
                        ]
                      }
                    },
                    "additionalProperties": false
                  },
                  {
                    "type": "object",
                    "properties": {
                      "type": {
                        "enum": [
                          "Calc"
                        ]
                      },
                      "value": true
                    },
                    "additionalProperties": false
                  },
                  {
                    "type": "object",
                    "properties": {
                      "type": {
                        "enum": [
                          "CalcFormula"
                        ]
                      },
                      "value": {
                        "type": "object",
                        "properties": {
                          "formula": true,
                          "values": {
                            "type": "object",
                            "properties": {},
                            "additionalProperties": {
                              "type": "object",
                              "anyOf": [
                                {
                                  "type": "object",
                                  "properties": {
                                    "value": true,
                                    "type": {
                                      "enum": [
                                        "px",
                                        "em",
                                        "rem",
                                        "fr",
                                        "percentage",
                                        "vh",
                                        "vw",
                                        "spx",
                                        "siteWidthPercentage"
                                      ]
                                    }
                                  }
                                },
                                {
                                  "type": "object",
                                  "properties": {
                                    "type": {
                                      "enum": [
                                        "SystemVariable"
                                      ]
                                    },
                                    "value": {
                                      "enum": [
                                        "siteWidth",
                                        "topBannerHeight"
                                      ]
                                    }
                                  }
                                },
                                {
                                  "type": "object",
                                  "properties": {
                                    "type": {
                                      "enum": [
                                        "Number"
                                      ]
                                    },
                                    "value": true
                                  }
                                }
                              ]
                            }
                          }
                        },
                        "additionalProperties": false
                      }
                    },
                    "additionalProperties": false
                  },
                  {
                    "type": "object",
                    "properties": {
                      "type": {
                        "enum": [
                          "SystemVariable"
                        ]
                      },
                      "value": {
                        "enum": [
                          "siteWidth",
                          "topBannerHeight"
                        ]
                      }
                    },
                    "additionalProperties": false
                  },
                  {
                    "type": "object",
                    "properties": {
                      "type": {
                        "enum": [
                          "auto",
                          "maxContent",
                          "minContent",
                          "unset",
                          "fit"
                        ]
                      }
                    },
                    "additionalProperties": false
                  }
                ]
              },
              "value": true,
              "length": {
                "anyOf": [
                  {
                    "type": "number"
                  },
                  {
                    "enum": [
                      "auto-fill",
                      "auto-fit"
                    ]
                  }
                ]
              }
            },
            "additionalProperties": false
          }
        },
        "autoColumns": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "type": true,
              "min": {
                "type": "object",
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "value": true,
                      "type": {
                        "enum": [
                          "px",
                          "em",
                          "rem",
                          "fr",
                          "percentage",
                          "vh",
                          "vw",
                          "spx",
                          "siteWidthPercentage"
                        ]
                      }
                    },
                    "additionalProperties": false
                  },
                  {
                    "type": "object",
                    "properties": {
                      "type": {
                        "enum": [
                          "Calc"
                        ]
                      },
                      "value": true
                    },
                    "additionalProperties": false
                  },
                  {
                    "type": "object",
                    "properties": {
                      "type": {
                        "enum": [
                          "CalcFormula"
                        ]
                      },
                      "value": {
                        "type": "object",
                        "properties": {
                          "formula": true,
                          "values": {
                            "type": "object",
                            "properties": {},
                            "additionalProperties": {
                              "type": "object",
                              "anyOf": [
                                {
                                  "type": "object",
                                  "properties": {
                                    "value": true,
                                    "type": {
                                      "enum": [
                                        "px",
                                        "em",
                                        "rem",
                                        "fr",
                                        "percentage",
                                        "vh",
                                        "vw",
                                        "spx",
                                        "siteWidthPercentage"
                                      ]
                                    }
                                  }
                                },
                                {
                                  "type": "object",
                                  "properties": {
                                    "type": {
                                      "enum": [
                                        "SystemVariable"
                                      ]
                                    },
                                    "value": {
                                      "enum": [
                                        "siteWidth",
                                        "topBannerHeight"
                                      ]
                                    }
                                  }
                                },
                                {
                                  "type": "object",
                                  "properties": {
                                    "type": {
                                      "enum": [
                                        "Number"
                                      ]
                                    },
                                    "value": true
                                  }
                                }
                              ]
                            }
                          }
                        },
                        "additionalProperties": false
                      }
                    },
                    "additionalProperties": false
                  },
                  {
                    "type": "object",
                    "properties": {
                      "type": {
                        "enum": [
                          "SystemVariable"
                        ]
                      },
                      "value": {
                        "enum": [
                          "siteWidth",
                          "topBannerHeight"
                        ]
                      }
                    },
                    "additionalProperties": false
                  },
                  {
                    "type": "object",
                    "properties": {
                      "type": {
                        "enum": [
                          "auto",
                          "maxContent",
                          "minContent",
                          "unset",
                          "fit"
                        ]
                      }
                    },
                    "additionalProperties": false
                  }
                ]
              },
              "max": {
                "type": "object",
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "value": true,
                      "type": {
                        "enum": [
                          "px",
                          "em",
                          "rem",
                          "fr",
                          "percentage",
                          "vh",
                          "vw",
                          "spx",
                          "siteWidthPercentage"
                        ]
                      }
                    },
                    "additionalProperties": false
                  },
                  {
                    "type": "object",
                    "properties": {
                      "type": {
                        "enum": [
                          "Calc"
                        ]
                      },
                      "value": true
                    },
                    "additionalProperties": false
                  },
                  {
                    "type": "object",
                    "properties": {
                      "type": {
                        "enum": [
                          "CalcFormula"
                        ]
                      },
                      "value": {
                        "type": "object",
                        "properties": {
                          "formula": true,
                          "values": {
                            "type": "object",
                            "properties": {},
                            "additionalProperties": {
                              "type": "object",
                              "anyOf": [
                                {
                                  "type": "object",
                                  "properties": {
                                    "value": true,
                                    "type": {
                                      "enum": [
                                        "px",
                                        "em",
                                        "rem",
                                        "fr",
                                        "percentage",
                                        "vh",
                                        "vw",
                                        "spx",
                                        "siteWidthPercentage"
                                      ]
                                    }
                                  }
                                },
                                {
                                  "type": "object",
                                  "properties": {
                                    "type": {
                                      "enum": [
                                        "SystemVariable"
                                      ]
                                    },
                                    "value": {
                                      "enum": [
                                        "siteWidth",
                                        "topBannerHeight"
                                      ]
                                    }
                                  }
                                },
                                {
                                  "type": "object",
                                  "properties": {
                                    "type": {
                                      "enum": [
                                        "Number"
                                      ]
                                    },
                                    "value": true
                                  }
                                }
                              ]
                            }
                          }
                        },
                        "additionalProperties": false
                      }
                    },
                    "additionalProperties": false
                  },
                  {
                    "type": "object",
                    "properties": {
                      "type": {
                        "enum": [
                          "SystemVariable"
                        ]
                      },
                      "value": {
                        "enum": [
                          "siteWidth",
                          "topBannerHeight"
                        ]
                      }
                    },
                    "additionalProperties": false
                  },
                  {
                    "type": "object",
                    "properties": {
                      "type": {
                        "enum": [
                          "auto",
                          "maxContent",
                          "minContent",
                          "unset",
                          "fit"
                        ]
                      }
                    },
                    "additionalProperties": false
                  }
                ]
              },
              "value": true,
              "length": {
                "anyOf": [
                  {
                    "type": "number"
                  },
                  {
                    "enum": [
                      "auto-fill",
                      "auto-fit"
                    ]
                  }
                ]
              }
            },
            "additionalProperties": false
          }
        },
        "autoFlow": {
          "enum": [
            "row",
            "column",
            "dense",
            "row dense",
            "column dense"
          ]
        },
        "overflowY": {
          "enum": [
            "auto",
            "scroll",
            "hidden",
            "visible",
            "clip"
          ]
        },
        "overflowX": {
          "enum": [
            "auto",
            "scroll",
            "hidden",
            "visible",
            "clip"
          ]
        },
        "hideScrollbar": true,
        "padding": {
          "type": "object",
          "properties": {
            "top": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "bottom": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "left": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "right": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            }
          },
          "additionalProperties": false
        },
        "scrollSnap": {
          "type": "object",
          "properties": {
            "scrollSnapType": {
              "enum": [
                "mandatory",
                "proximity",
                "none"
              ]
            },
            "scrollSnapDirection": {
              "enum": [
                "x",
                "y"
              ]
            }
          },
          "additionalProperties": false
        },
        "scrollBehavior": {
          "enum": [
            "auto",
            "smooth"
          ]
        },
        "contentMaxWidth": {
          "type": "object",
          "properties": {
            "maxWidth": {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            "align": {
              "type": "string",
              "enum": [
                "center",
                "right",
                "left"
              ]
            }
          },
          "additionalProperties": false
        },
        "type": {
          "type": "string",
          "enum": [
            "GridContainerLayout"
          ]
        },
        "contain": {
          "enum": [
            "none",
            "paint"
          ]
        },
        "spxStopper": {
          "type": "object",
          "properties": {
            "min": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "max": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            }
          },
          "additionalProperties": false
        }
      },
      "additionalProperties": false
    },
    "ComponentLayout": {
      "type": [
        "object"
      ],
      "properties": {
        "containerType": {
          "type": "string",
          "enum": [
            "inline-size"
          ]
        },
        "width": {
          "oneOf": [
            {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "StretchWithSoftMargins"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "margins": {
                      "type": "object",
                      "properties": {
                        "left": {
                          "type": "object",
                          "anyOf": [
                            {
                              "type": "object",
                              "properties": {
                                "value": true,
                                "type": {
                                  "enum": [
                                    "px",
                                    "em",
                                    "rem",
                                    "fr",
                                    "percentage",
                                    "vh",
                                    "vw",
                                    "spx",
                                    "siteWidthPercentage"
                                  ]
                                }
                              },
                              "additionalProperties": false
                            },
                            {
                              "type": "object",
                              "properties": {
                                "type": {
                                  "enum": [
                                    "Calc"
                                  ]
                                },
                                "value": true
                              },
                              "additionalProperties": false
                            },
                            {
                              "type": "object",
                              "properties": {
                                "type": {
                                  "enum": [
                                    "CalcFormula"
                                  ]
                                },
                                "value": {
                                  "type": "object",
                                  "properties": {
                                    "formula": true,
                                    "values": {
                                      "type": "object",
                                      "properties": {},
                                      "additionalProperties": {
                                        "type": "object",
                                        "anyOf": [
                                          {
                                            "type": "object",
                                            "properties": {
                                              "value": true,
                                              "type": {
                                                "enum": [
                                                  "px",
                                                  "em",
                                                  "rem",
                                                  "fr",
                                                  "percentage",
                                                  "vh",
                                                  "vw",
                                                  "spx",
                                                  "siteWidthPercentage"
                                                ]
                                              }
                                            }
                                          },
                                          {
                                            "type": "object",
                                            "properties": {
                                              "type": {
                                                "enum": [
                                                  "SystemVariable"
                                                ]
                                              },
                                              "value": {
                                                "enum": [
                                                  "siteWidth",
                                                  "topBannerHeight"
                                                ]
                                              }
                                            }
                                          },
                                          {
                                            "type": "object",
                                            "properties": {
                                              "type": {
                                                "enum": [
                                                  "Number"
                                                ]
                                              },
                                              "value": true
                                            }
                                          }
                                        ]
                                      }
                                    }
                                  },
                                  "additionalProperties": false
                                }
                              },
                              "additionalProperties": false
                            },
                            {
                              "type": "object",
                              "properties": {
                                "type": {
                                  "enum": [
                                    "SystemVariable"
                                  ]
                                },
                                "value": {
                                  "enum": [
                                    "siteWidth",
                                    "topBannerHeight"
                                  ]
                                }
                              },
                              "additionalProperties": false
                            },
                            {
                              "type": "object",
                              "properties": {
                                "type": {
                                  "enum": [
                                    "auto",
                                    "maxContent",
                                    "minContent",
                                    "unset",
                                    "fit"
                                  ]
                                }
                              },
                              "additionalProperties": false
                            }
                          ]
                        },
                        "right": {
                          "type": "object",
                          "anyOf": [
                            {
                              "type": "object",
                              "properties": {
                                "value": true,
                                "type": {
                                  "enum": [
                                    "px",
                                    "em",
                                    "rem",
                                    "fr",
                                    "percentage",
                                    "vh",
                                    "vw",
                                    "spx",
                                    "siteWidthPercentage"
                                  ]
                                }
                              },
                              "additionalProperties": false
                            },
                            {
                              "type": "object",
                              "properties": {
                                "type": {
                                  "enum": [
                                    "Calc"
                                  ]
                                },
                                "value": true
                              },
                              "additionalProperties": false
                            },
                            {
                              "type": "object",
                              "properties": {
                                "type": {
                                  "enum": [
                                    "CalcFormula"
                                  ]
                                },
                                "value": {
                                  "type": "object",
                                  "properties": {
                                    "formula": true,
                                    "values": {
                                      "type": "object",
                                      "properties": {},
                                      "additionalProperties": {
                                        "type": "object",
                                        "anyOf": [
                                          {
                                            "type": "object",
                                            "properties": {
                                              "value": true,
                                              "type": {
                                                "enum": [
                                                  "px",
                                                  "em",
                                                  "rem",
                                                  "fr",
                                                  "percentage",
                                                  "vh",
                                                  "vw",
                                                  "spx",
                                                  "siteWidthPercentage"
                                                ]
                                              }
                                            }
                                          },
                                          {
                                            "type": "object",
                                            "properties": {
                                              "type": {
                                                "enum": [
                                                  "SystemVariable"
                                                ]
                                              },
                                              "value": {
                                                "enum": [
                                                  "siteWidth",
                                                  "topBannerHeight"
                                                ]
                                              }
                                            }
                                          },
                                          {
                                            "type": "object",
                                            "properties": {
                                              "type": {
                                                "enum": [
                                                  "Number"
                                                ]
                                              },
                                              "value": true
                                            }
                                          }
                                        ]
                                      }
                                    }
                                  },
                                  "additionalProperties": false
                                }
                              },
                              "additionalProperties": false
                            },
                            {
                              "type": "object",
                              "properties": {
                                "type": {
                                  "enum": [
                                    "SystemVariable"
                                  ]
                                },
                                "value": {
                                  "enum": [
                                    "siteWidth",
                                    "topBannerHeight"
                                  ]
                                }
                              },
                              "additionalProperties": false
                            },
                            {
                              "type": "object",
                              "properties": {
                                "type": {
                                  "enum": [
                                    "auto",
                                    "maxContent",
                                    "minContent",
                                    "unset",
                                    "fit"
                                  ]
                                }
                              },
                              "additionalProperties": false
                            }
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "height": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "aspectRatio"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            }
          ]
        },
        "minWidth": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "minHeight": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "maxWidth": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "maxHeight": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "margins": {
          "type": "object",
          "properties": {
            "top": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "bottom": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "left": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "right": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            }
          },
          "additionalProperties": false
        },
        "direction": {
          "enum": [
            "rtl",
            "ltr"
          ]
        },
        "rotationInDegrees": true,
        "fixed": true,
        "hidden": true,
        "type": {
          "type": "string",
          "enum": [
            "ComponentLayout"
          ]
        }
      },
      "additionalProperties": false
    },
    "ClassicComponentLayout": {
      "type": [
        "object"
      ],
      "properties": {
        "containerType": {
          "type": "string",
          "enum": [
            "inline-size"
          ]
        },
        "width": {
          "oneOf": [
            {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "StretchWithSoftMargins"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "margins": {
                      "type": "object",
                      "properties": {
                        "left": {
                          "type": "object",
                          "anyOf": [
                            {
                              "type": "object",
                              "properties": {
                                "value": true,
                                "type": {
                                  "enum": [
                                    "px",
                                    "em",
                                    "rem",
                                    "fr",
                                    "percentage",
                                    "vh",
                                    "vw",
                                    "spx",
                                    "siteWidthPercentage"
                                  ]
                                }
                              },
                              "additionalProperties": false
                            },
                            {
                              "type": "object",
                              "properties": {
                                "type": {
                                  "enum": [
                                    "Calc"
                                  ]
                                },
                                "value": true
                              },
                              "additionalProperties": false
                            },
                            {
                              "type": "object",
                              "properties": {
                                "type": {
                                  "enum": [
                                    "CalcFormula"
                                  ]
                                },
                                "value": {
                                  "type": "object",
                                  "properties": {
                                    "formula": true,
                                    "values": {
                                      "type": "object",
                                      "properties": {},
                                      "additionalProperties": {
                                        "type": "object",
                                        "anyOf": [
                                          {
                                            "type": "object",
                                            "properties": {
                                              "value": true,
                                              "type": {
                                                "enum": [
                                                  "px",
                                                  "em",
                                                  "rem",
                                                  "fr",
                                                  "percentage",
                                                  "vh",
                                                  "vw",
                                                  "spx",
                                                  "siteWidthPercentage"
                                                ]
                                              }
                                            }
                                          },
                                          {
                                            "type": "object",
                                            "properties": {
                                              "type": {
                                                "enum": [
                                                  "SystemVariable"
                                                ]
                                              },
                                              "value": {
                                                "enum": [
                                                  "siteWidth",
                                                  "topBannerHeight"
                                                ]
                                              }
                                            }
                                          },
                                          {
                                            "type": "object",
                                            "properties": {
                                              "type": {
                                                "enum": [
                                                  "Number"
                                                ]
                                              },
                                              "value": true
                                            }
                                          }
                                        ]
                                      }
                                    }
                                  },
                                  "additionalProperties": false
                                }
                              },
                              "additionalProperties": false
                            },
                            {
                              "type": "object",
                              "properties": {
                                "type": {
                                  "enum": [
                                    "SystemVariable"
                                  ]
                                },
                                "value": {
                                  "enum": [
                                    "siteWidth",
                                    "topBannerHeight"
                                  ]
                                }
                              },
                              "additionalProperties": false
                            },
                            {
                              "type": "object",
                              "properties": {
                                "type": {
                                  "enum": [
                                    "auto",
                                    "maxContent",
                                    "minContent",
                                    "unset",
                                    "fit"
                                  ]
                                }
                              },
                              "additionalProperties": false
                            }
                          ]
                        },
                        "right": {
                          "type": "object",
                          "anyOf": [
                            {
                              "type": "object",
                              "properties": {
                                "value": true,
                                "type": {
                                  "enum": [
                                    "px",
                                    "em",
                                    "rem",
                                    "fr",
                                    "percentage",
                                    "vh",
                                    "vw",
                                    "spx",
                                    "siteWidthPercentage"
                                  ]
                                }
                              },
                              "additionalProperties": false
                            },
                            {
                              "type": "object",
                              "properties": {
                                "type": {
                                  "enum": [
                                    "Calc"
                                  ]
                                },
                                "value": true
                              },
                              "additionalProperties": false
                            },
                            {
                              "type": "object",
                              "properties": {
                                "type": {
                                  "enum": [
                                    "CalcFormula"
                                  ]
                                },
                                "value": {
                                  "type": "object",
                                  "properties": {
                                    "formula": true,
                                    "values": {
                                      "type": "object",
                                      "properties": {},
                                      "additionalProperties": {
                                        "type": "object",
                                        "anyOf": [
                                          {
                                            "type": "object",
                                            "properties": {
                                              "value": true,
                                              "type": {
                                                "enum": [
                                                  "px",
                                                  "em",
                                                  "rem",
                                                  "fr",
                                                  "percentage",
                                                  "vh",
                                                  "vw",
                                                  "spx",
                                                  "siteWidthPercentage"
                                                ]
                                              }
                                            }
                                          },
                                          {
                                            "type": "object",
                                            "properties": {
                                              "type": {
                                                "enum": [
                                                  "SystemVariable"
                                                ]
                                              },
                                              "value": {
                                                "enum": [
                                                  "siteWidth",
                                                  "topBannerHeight"
                                                ]
                                              }
                                            }
                                          },
                                          {
                                            "type": "object",
                                            "properties": {
                                              "type": {
                                                "enum": [
                                                  "Number"
                                                ]
                                              },
                                              "value": true
                                            }
                                          }
                                        ]
                                      }
                                    }
                                  },
                                  "additionalProperties": false
                                }
                              },
                              "additionalProperties": false
                            },
                            {
                              "type": "object",
                              "properties": {
                                "type": {
                                  "enum": [
                                    "SystemVariable"
                                  ]
                                },
                                "value": {
                                  "enum": [
                                    "siteWidth",
                                    "topBannerHeight"
                                  ]
                                }
                              },
                              "additionalProperties": false
                            },
                            {
                              "type": "object",
                              "properties": {
                                "type": {
                                  "enum": [
                                    "auto",
                                    "maxContent",
                                    "minContent",
                                    "unset",
                                    "fit"
                                  ]
                                }
                              },
                              "additionalProperties": false
                            }
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "height": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "aspectRatio"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            }
          ]
        },
        "minWidth": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "minHeight": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "maxWidth": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "maxHeight": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "margins": {
          "type": "object",
          "properties": {
            "top": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "bottom": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "left": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "right": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            }
          },
          "additionalProperties": false
        },
        "direction": {
          "enum": [
            "rtl",
            "ltr"
          ]
        },
        "rotationInDegrees": true,
        "fixed": true,
        "hidden": true,
        "type": {
          "type": "string",
          "enum": [
            "ClassicComponentLayout"
          ]
        }
      },
      "additionalProperties": false
    },
    "BaseComponentLayout": {
      "type": "object",
      "properties": {
        "containerType": {
          "type": "string",
          "enum": [
            "inline-size"
          ]
        },
        "width": {
          "oneOf": [
            {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "StretchWithSoftMargins"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "margins": {
                      "type": "object",
                      "properties": {
                        "left": {
                          "type": "object",
                          "anyOf": [
                            {
                              "type": "object",
                              "properties": {
                                "value": true,
                                "type": {
                                  "enum": [
                                    "px",
                                    "em",
                                    "rem",
                                    "fr",
                                    "percentage",
                                    "vh",
                                    "vw",
                                    "spx",
                                    "siteWidthPercentage"
                                  ]
                                }
                              },
                              "additionalProperties": false
                            },
                            {
                              "type": "object",
                              "properties": {
                                "type": {
                                  "enum": [
                                    "Calc"
                                  ]
                                },
                                "value": true
                              },
                              "additionalProperties": false
                            },
                            {
                              "type": "object",
                              "properties": {
                                "type": {
                                  "enum": [
                                    "CalcFormula"
                                  ]
                                },
                                "value": {
                                  "type": "object",
                                  "properties": {
                                    "formula": true,
                                    "values": {
                                      "type": "object",
                                      "properties": {},
                                      "additionalProperties": {
                                        "type": "object",
                                        "anyOf": [
                                          {
                                            "type": "object",
                                            "properties": {
                                              "value": true,
                                              "type": {
                                                "enum": [
                                                  "px",
                                                  "em",
                                                  "rem",
                                                  "fr",
                                                  "percentage",
                                                  "vh",
                                                  "vw",
                                                  "spx",
                                                  "siteWidthPercentage"
                                                ]
                                              }
                                            }
                                          },
                                          {
                                            "type": "object",
                                            "properties": {
                                              "type": {
                                                "enum": [
                                                  "SystemVariable"
                                                ]
                                              },
                                              "value": {
                                                "enum": [
                                                  "siteWidth",
                                                  "topBannerHeight"
                                                ]
                                              }
                                            }
                                          },
                                          {
                                            "type": "object",
                                            "properties": {
                                              "type": {
                                                "enum": [
                                                  "Number"
                                                ]
                                              },
                                              "value": true
                                            }
                                          }
                                        ]
                                      }
                                    }
                                  },
                                  "additionalProperties": false
                                }
                              },
                              "additionalProperties": false
                            },
                            {
                              "type": "object",
                              "properties": {
                                "type": {
                                  "enum": [
                                    "SystemVariable"
                                  ]
                                },
                                "value": {
                                  "enum": [
                                    "siteWidth",
                                    "topBannerHeight"
                                  ]
                                }
                              },
                              "additionalProperties": false
                            },
                            {
                              "type": "object",
                              "properties": {
                                "type": {
                                  "enum": [
                                    "auto",
                                    "maxContent",
                                    "minContent",
                                    "unset",
                                    "fit"
                                  ]
                                }
                              },
                              "additionalProperties": false
                            }
                          ]
                        },
                        "right": {
                          "type": "object",
                          "anyOf": [
                            {
                              "type": "object",
                              "properties": {
                                "value": true,
                                "type": {
                                  "enum": [
                                    "px",
                                    "em",
                                    "rem",
                                    "fr",
                                    "percentage",
                                    "vh",
                                    "vw",
                                    "spx",
                                    "siteWidthPercentage"
                                  ]
                                }
                              },
                              "additionalProperties": false
                            },
                            {
                              "type": "object",
                              "properties": {
                                "type": {
                                  "enum": [
                                    "Calc"
                                  ]
                                },
                                "value": true
                              },
                              "additionalProperties": false
                            },
                            {
                              "type": "object",
                              "properties": {
                                "type": {
                                  "enum": [
                                    "CalcFormula"
                                  ]
                                },
                                "value": {
                                  "type": "object",
                                  "properties": {
                                    "formula": true,
                                    "values": {
                                      "type": "object",
                                      "properties": {},
                                      "additionalProperties": {
                                        "type": "object",
                                        "anyOf": [
                                          {
                                            "type": "object",
                                            "properties": {
                                              "value": true,
                                              "type": {
                                                "enum": [
                                                  "px",
                                                  "em",
                                                  "rem",
                                                  "fr",
                                                  "percentage",
                                                  "vh",
                                                  "vw",
                                                  "spx",
                                                  "siteWidthPercentage"
                                                ]
                                              }
                                            }
                                          },
                                          {
                                            "type": "object",
                                            "properties": {
                                              "type": {
                                                "enum": [
                                                  "SystemVariable"
                                                ]
                                              },
                                              "value": {
                                                "enum": [
                                                  "siteWidth",
                                                  "topBannerHeight"
                                                ]
                                              }
                                            }
                                          },
                                          {
                                            "type": "object",
                                            "properties": {
                                              "type": {
                                                "enum": [
                                                  "Number"
                                                ]
                                              },
                                              "value": true
                                            }
                                          }
                                        ]
                                      }
                                    }
                                  },
                                  "additionalProperties": false
                                }
                              },
                              "additionalProperties": false
                            },
                            {
                              "type": "object",
                              "properties": {
                                "type": {
                                  "enum": [
                                    "SystemVariable"
                                  ]
                                },
                                "value": {
                                  "enum": [
                                    "siteWidth",
                                    "topBannerHeight"
                                  ]
                                }
                              },
                              "additionalProperties": false
                            },
                            {
                              "type": "object",
                              "properties": {
                                "type": {
                                  "enum": [
                                    "auto",
                                    "maxContent",
                                    "minContent",
                                    "unset",
                                    "fit"
                                  ]
                                }
                              },
                              "additionalProperties": false
                            }
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "height": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "aspectRatio"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            }
          ]
        },
        "minWidth": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "minHeight": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "maxWidth": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "maxHeight": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "margins": {
          "type": "object",
          "properties": {
            "top": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "bottom": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "left": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "right": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            }
          },
          "additionalProperties": false
        },
        "direction": {
          "enum": [
            "rtl",
            "ltr"
          ]
        },
        "rotationInDegrees": true,
        "fixed": true,
        "hidden": true
      },
      "additionalProperties": false
    },
    "GridItemLayout": {
      "type": [
        "object"
      ],
      "properties": {
        "id": true,
        "type": {
          "type": "string",
          "enum": [
            "GridItemLayout"
          ]
        },
        "scrollSnapAlign": {
          "enum": [
            "center",
            "end",
            "start",
            "none"
          ]
        },
        "pinnedToContainer": true,
        "margins": {
          "type": "object",
          "properties": {
            "top": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "bottom": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "left": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "right": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            }
          },
          "additionalProperties": false
        },
        "position": {
          "enum": [
            "sticky",
            "stickyToHeader",
            "absolute",
            "relative"
          ]
        },
        "isInFront": true,
        "top": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "bottom": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "left": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "right": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "gridArea": {
          "type": "object",
          "properties": {
            "rowStart": true,
            "columnStart": true,
            "rowEnd": true,
            "columnEnd": true
          },
          "additionalProperties": false
        },
        "alignSelf": {
          "type": "string",
          "enum": [
            "start",
            "end",
            "center",
            "stretch",
            "content"
          ]
        },
        "justifySelf": {
          "type": "string",
          "enum": [
            "start",
            "end",
            "center",
            "stretch",
            "content"
          ]
        }
      },
      "additionalProperties": false
    },
    "FixedItemLayout": {
      "type": [
        "object"
      ],
      "properties": {
        "id": true,
        "type": {
          "type": "string",
          "enum": [
            "FixedItemLayout"
          ]
        },
        "scrollSnapAlign": {
          "enum": [
            "center",
            "end",
            "start",
            "none"
          ]
        },
        "pinnedToContainer": true,
        "margins": {
          "type": "object",
          "properties": {
            "top": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "bottom": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "left": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "right": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            }
          },
          "additionalProperties": false
        },
        "position": {
          "enum": [
            "sticky",
            "stickyToHeader",
            "absolute",
            "relative"
          ]
        },
        "isInFront": true,
        "top": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "bottom": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "left": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "right": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "alignSelf": {
          "type": "string",
          "enum": [
            "start",
            "end",
            "center",
            "stretch",
            "content"
          ]
        },
        "justifySelf": {
          "type": "string",
          "enum": [
            "start",
            "end",
            "center",
            "stretch",
            "content"
          ]
        }
      },
      "additionalProperties": false
    },
    "BackgroundLayerItemLayout": {
      "type": [
        "object"
      ],
      "properties": {
        "id": true,
        "type": {
          "type": "string",
          "enum": [
            "BackgroundLayerItemLayout"
          ]
        },
        "scrollSnapAlign": {
          "enum": [
            "center",
            "end",
            "start",
            "none"
          ]
        },
        "pinnedToContainer": true,
        "margins": {
          "type": "object",
          "properties": {
            "top": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "bottom": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "left": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "right": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            }
          },
          "additionalProperties": false
        },
        "position": {
          "enum": [
            "sticky",
            "stickyToHeader",
            "absolute",
            "relative"
          ]
        },
        "isInFront": true,
        "top": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "bottom": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "left": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "right": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "alignSelf": {
          "type": "string",
          "enum": [
            "start",
            "end",
            "center",
            "stretch",
            "content"
          ]
        },
        "justifySelf": {
          "type": "string",
          "enum": [
            "start",
            "end",
            "center",
            "stretch",
            "content"
          ]
        }
      },
      "additionalProperties": false
    },
    "FixedPositionItemLayout": {
      "type": [
        "object"
      ],
      "properties": {
        "id": true,
        "type": {
          "type": "string",
          "enum": [
            "FixedPositionItemLayout"
          ]
        },
        "scrollSnapAlign": {
          "enum": [
            "center",
            "end",
            "start",
            "none"
          ]
        },
        "pinnedToContainer": true,
        "margins": {
          "type": "object",
          "properties": {
            "top": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "bottom": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "left": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "right": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            }
          },
          "additionalProperties": false
        },
        "position": {
          "enum": [
            "sticky",
            "stickyToHeader",
            "absolute",
            "relative"
          ]
        },
        "isInFront": true,
        "top": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "bottom": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "left": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "right": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        }
      },
      "additionalProperties": false
    },
    "MasterPageItemLayout": {
      "type": [
        "object"
      ],
      "properties": {
        "id": true,
        "type": {
          "type": "string",
          "enum": [
            "MasterPageItemLayout"
          ]
        },
        "scrollSnapAlign": {
          "enum": [
            "center",
            "end",
            "start",
            "none"
          ]
        },
        "pinnedToContainer": true,
        "margins": {
          "type": "object",
          "properties": {
            "top": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "bottom": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "left": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "right": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            }
          },
          "additionalProperties": false
        },
        "position": {
          "enum": [
            "sticky",
            "stickyToHeader",
            "absolute",
            "relative"
          ]
        },
        "isInFront": true,
        "top": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "bottom": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "left": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "right": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "isFixed": true
      },
      "additionalProperties": false
    },
    "FlexContainerLayoutBase": {
      "type": [
        "object"
      ],
      "properties": {
        "id": true,
        "type": true,
        "scrollSnapAlign": {
          "enum": [
            "center",
            "end",
            "start",
            "none"
          ]
        },
        "pinnedToContainer": true,
        "margins": {
          "type": "object",
          "properties": {
            "top": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "bottom": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "left": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "right": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            }
          },
          "additionalProperties": false
        },
        "position": {
          "enum": [
            "sticky",
            "stickyToHeader",
            "absolute",
            "relative"
          ]
        },
        "isInFront": true,
        "top": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "bottom": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "left": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "right": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "direction": {
          "enum": [
            "row",
            "rowReverse",
            "column",
            "columnReverse"
          ]
        },
        "wrap": {
          "enum": [
            "nowrap",
            "wrap"
          ]
        },
        "alignItems": {
          "type": "string",
          "enum": [
            "start",
            "end",
            "center",
            "stretch",
            "content"
          ]
        },
        "justifyContent": {
          "enum": [
            "start",
            "center",
            "end",
            "spaceBetween",
            "spaceAround",
            "spaceEvenly"
          ]
        },
        "overflowY": {
          "enum": [
            "auto",
            "scroll",
            "hidden",
            "visible",
            "clip"
          ]
        },
        "overflowX": {
          "enum": [
            "auto",
            "scroll",
            "hidden",
            "visible",
            "clip"
          ]
        },
        "hideScrollbar": true,
        "padding": {
          "type": "object",
          "properties": {
            "top": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "bottom": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "left": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "right": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            }
          },
          "additionalProperties": false
        },
        "scrollSnap": {
          "type": "object",
          "properties": {
            "scrollSnapType": {
              "enum": [
                "mandatory",
                "proximity",
                "none"
              ]
            },
            "scrollSnapDirection": {
              "enum": [
                "x",
                "y"
              ]
            }
          },
          "additionalProperties": false
        },
        "scrollBehaviour": {
          "enum": [
            "auto",
            "smooth"
          ]
        },
        "contentMaxWidth": {
          "type": "object",
          "properties": {
            "maxWidth": {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            "align": {
              "type": "string",
              "enum": [
                "center",
                "right",
                "left"
              ]
            }
          },
          "additionalProperties": false
        },
        "spxStopper": {
          "type": "object",
          "properties": {
            "min": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "max": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            }
          },
          "additionalProperties": false
        },
        "rowGap": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "columnGap": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "contain": {
          "enum": [
            "none",
            "paint"
          ]
        }
      },
      "additionalProperties": false
    },
    "FlexContainerLayout": {
      "type": [
        "object"
      ],
      "properties": {
        "id": true,
        "type": {
          "type": "string",
          "enum": [
            "FlexContainerLayout"
          ]
        },
        "scrollSnapAlign": {
          "enum": [
            "center",
            "end",
            "start",
            "none"
          ]
        },
        "pinnedToContainer": true,
        "margins": {
          "type": "object",
          "properties": {
            "top": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "bottom": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "left": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "right": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            }
          },
          "additionalProperties": false
        },
        "position": {
          "enum": [
            "sticky",
            "stickyToHeader",
            "absolute",
            "relative"
          ]
        },
        "isInFront": true,
        "top": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "bottom": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "left": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "right": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "direction": {
          "enum": [
            "row",
            "rowReverse",
            "column",
            "columnReverse"
          ]
        },
        "wrap": {
          "enum": [
            "nowrap",
            "wrap"
          ]
        },
        "alignItems": {
          "type": "string",
          "enum": [
            "start",
            "end",
            "center",
            "stretch",
            "content"
          ]
        },
        "justifyContent": {
          "enum": [
            "start",
            "center",
            "end",
            "spaceBetween",
            "spaceAround",
            "spaceEvenly"
          ]
        },
        "overflowY": {
          "enum": [
            "auto",
            "scroll",
            "hidden",
            "visible",
            "clip"
          ]
        },
        "overflowX": {
          "enum": [
            "auto",
            "scroll",
            "hidden",
            "visible",
            "clip"
          ]
        },
        "hideScrollbar": true,
        "padding": {
          "type": "object",
          "properties": {
            "top": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "bottom": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "left": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "right": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            }
          },
          "additionalProperties": false
        },
        "scrollSnap": {
          "type": "object",
          "properties": {
            "scrollSnapType": {
              "enum": [
                "mandatory",
                "proximity",
                "none"
              ]
            },
            "scrollSnapDirection": {
              "enum": [
                "x",
                "y"
              ]
            }
          },
          "additionalProperties": false
        },
        "scrollBehaviour": {
          "enum": [
            "auto",
            "smooth"
          ]
        },
        "contentMaxWidth": {
          "type": "object",
          "properties": {
            "maxWidth": {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            "align": {
              "type": "string",
              "enum": [
                "center",
                "right",
                "left"
              ]
            }
          },
          "additionalProperties": false
        },
        "spxStopper": {
          "type": "object",
          "properties": {
            "min": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "max": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            }
          },
          "additionalProperties": false
        },
        "rowGap": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "columnGap": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "contain": {
          "enum": [
            "none",
            "paint"
          ]
        }
      },
      "additionalProperties": false
    },
    "FlexItemLayoutBase": {
      "type": [
        "object"
      ],
      "properties": {
        "id": true,
        "type": true,
        "scrollSnapAlign": {
          "enum": [
            "center",
            "end",
            "start",
            "none"
          ]
        },
        "pinnedToContainer": true,
        "margins": {
          "type": "object",
          "properties": {
            "top": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "bottom": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "left": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "right": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            }
          },
          "additionalProperties": false
        },
        "position": {
          "enum": [
            "sticky",
            "stickyToHeader",
            "absolute",
            "relative"
          ]
        },
        "isInFront": true,
        "top": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "bottom": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "left": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "right": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "order": true,
        "alignSelf": {
          "type": "string",
          "enum": [
            "start",
            "end",
            "center",
            "stretch",
            "content"
          ]
        },
        "justifySelf": {
          "type": "string",
          "enum": [
            "start",
            "end",
            "center",
            "stretch",
            "content"
          ]
        },
        "basis": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "grow": true,
        "shrink": true
      },
      "additionalProperties": false
    },
    "FlexItemLayout": {
      "type": [
        "object"
      ],
      "properties": {
        "id": true,
        "type": {
          "type": "string",
          "enum": [
            "FlexItemLayout"
          ]
        },
        "scrollSnapAlign": {
          "enum": [
            "center",
            "end",
            "start",
            "none"
          ]
        },
        "pinnedToContainer": true,
        "margins": {
          "type": "object",
          "properties": {
            "top": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "bottom": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "left": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "right": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            }
          },
          "additionalProperties": false
        },
        "position": {
          "enum": [
            "sticky",
            "stickyToHeader",
            "absolute",
            "relative"
          ]
        },
        "isInFront": true,
        "top": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "bottom": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "left": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "right": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "order": true,
        "alignSelf": {
          "type": "string",
          "enum": [
            "start",
            "end",
            "center",
            "stretch",
            "content"
          ]
        },
        "justifySelf": {
          "type": "string",
          "enum": [
            "start",
            "end",
            "center",
            "stretch",
            "content"
          ]
        },
        "basis": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "grow": true,
        "shrink": true
      },
      "additionalProperties": false
    },
    "OrganizerContainerLayout": {
      "type": [
        "object"
      ],
      "properties": {
        "layoutIntent": {
          "type": "string",
          "enum": [
            "Rows",
            "Cols",
            "Mosaic",
            "Slider",
            "SlideShow",
            "Bricks"
          ]
        },
        "id": true,
        "type": {
          "type": "string",
          "enum": [
            "OrganizerContainerLayout"
          ]
        },
        "scrollSnapAlign": {
          "enum": [
            "center",
            "end",
            "start",
            "none"
          ]
        },
        "pinnedToContainer": true,
        "margins": {
          "type": "object",
          "properties": {
            "top": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "bottom": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "left": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "right": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            }
          },
          "additionalProperties": false
        },
        "position": {
          "enum": [
            "sticky",
            "stickyToHeader",
            "absolute",
            "relative"
          ]
        },
        "isInFront": true,
        "top": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "bottom": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "left": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "right": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "direction": {
          "enum": [
            "row",
            "rowReverse",
            "column",
            "columnReverse"
          ]
        },
        "wrap": {
          "enum": [
            "nowrap",
            "wrap"
          ]
        },
        "alignItems": {
          "type": "string",
          "enum": [
            "start",
            "end",
            "center",
            "stretch",
            "content"
          ]
        },
        "justifyContent": {
          "enum": [
            "start",
            "center",
            "end",
            "spaceBetween",
            "spaceAround",
            "spaceEvenly"
          ]
        },
        "overflowY": {
          "enum": [
            "auto",
            "scroll",
            "hidden",
            "visible",
            "clip"
          ]
        },
        "overflowX": {
          "enum": [
            "auto",
            "scroll",
            "hidden",
            "visible",
            "clip"
          ]
        },
        "hideScrollbar": true,
        "padding": {
          "type": "object",
          "properties": {
            "top": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "bottom": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "left": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "right": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            }
          },
          "additionalProperties": false
        },
        "scrollSnap": {
          "type": "object",
          "properties": {
            "scrollSnapType": {
              "enum": [
                "mandatory",
                "proximity",
                "none"
              ]
            },
            "scrollSnapDirection": {
              "enum": [
                "x",
                "y"
              ]
            }
          },
          "additionalProperties": false
        },
        "scrollBehaviour": {
          "enum": [
            "auto",
            "smooth"
          ]
        },
        "contentMaxWidth": {
          "type": "object",
          "properties": {
            "maxWidth": {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            "align": {
              "type": "string",
              "enum": [
                "center",
                "right",
                "left"
              ]
            }
          },
          "additionalProperties": false
        },
        "spxStopper": {
          "type": "object",
          "properties": {
            "min": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "max": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            }
          },
          "additionalProperties": false
        },
        "rowGap": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "columnGap": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "contain": {
          "enum": [
            "none",
            "paint"
          ]
        }
      },
      "additionalProperties": false
    },
    "MultiColumnsContainerLayout": {
      "type": "object",
      "properties": {
        "alignContent": {
          "type": "string",
          "enum": [
            "auto",
            "stretch",
            "start",
            "center",
            "end"
          ]
        },
        "columnCount": true,
        "padding": {
          "type": "object",
          "properties": {
            "top": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "bottom": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "left": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "right": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            }
          },
          "additionalProperties": false
        },
        "rowGap": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "columnGap": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "spxStopper": {
          "type": "object",
          "properties": {
            "min": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "max": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            }
          },
          "additionalProperties": false
        },
        "type": {
          "type": "string",
          "enum": [
            "MultiColumnsContainerLayout"
          ]
        }
      },
      "additionalProperties": false
    },
    "MultiColumnsItemLayout": {
      "type": "object",
      "properties": {
        "margins": {
          "type": "object",
          "properties": {
            "top": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "bottom": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "left": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "right": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            }
          },
          "additionalProperties": false
        },
        "type": {
          "type": "string",
          "enum": [
            "MultiColumnsItemLayout"
          ]
        }
      },
      "additionalProperties": false
    },
    "OrganizerItemLayout": {
      "type": [
        "object"
      ],
      "properties": {
        "id": true,
        "type": {
          "type": "string",
          "enum": [
            "OrganizerItemLayout"
          ]
        },
        "scrollSnapAlign": {
          "enum": [
            "center",
            "end",
            "start",
            "none"
          ]
        },
        "pinnedToContainer": true,
        "margins": {
          "type": "object",
          "properties": {
            "top": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "bottom": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "left": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "right": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            }
          },
          "additionalProperties": false
        },
        "position": {
          "enum": [
            "sticky",
            "stickyToHeader",
            "absolute",
            "relative"
          ]
        },
        "isInFront": true,
        "top": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "bottom": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "left": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "right": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "order": true,
        "alignSelf": {
          "type": "string",
          "enum": [
            "start",
            "end",
            "center",
            "stretch",
            "content"
          ]
        },
        "justifySelf": {
          "type": "string",
          "enum": [
            "start",
            "end",
            "center",
            "stretch",
            "content"
          ]
        },
        "basis": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "grow": true,
        "shrink": true
      },
      "additionalProperties": false
    },
    "StackContainerLayout": {
      "type": [
        "object"
      ],
      "properties": {
        "id": true,
        "type": {
          "type": "string",
          "enum": [
            "StackContainerLayout"
          ]
        },
        "scrollSnapAlign": {
          "enum": [
            "center",
            "end",
            "start",
            "none"
          ]
        },
        "pinnedToContainer": true,
        "margins": {
          "type": "object",
          "properties": {
            "top": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "bottom": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "left": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "right": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            }
          },
          "additionalProperties": false
        },
        "position": {
          "enum": [
            "sticky",
            "stickyToHeader",
            "absolute",
            "relative"
          ]
        },
        "isInFront": true,
        "top": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "bottom": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "left": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "right": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "direction": {
          "enum": [
            "row",
            "rowReverse",
            "column",
            "columnReverse"
          ]
        },
        "wrap": {
          "enum": [
            "nowrap",
            "wrap"
          ]
        },
        "alignItems": {
          "type": "string",
          "enum": [
            "start",
            "end",
            "center",
            "stretch",
            "content"
          ]
        },
        "justifyContent": {
          "enum": [
            "start",
            "center",
            "end",
            "spaceBetween",
            "spaceAround",
            "spaceEvenly"
          ]
        },
        "overflowY": {
          "enum": [
            "auto",
            "scroll",
            "hidden",
            "visible",
            "clip"
          ]
        },
        "overflowX": {
          "enum": [
            "auto",
            "scroll",
            "hidden",
            "visible",
            "clip"
          ]
        },
        "hideScrollbar": true,
        "padding": {
          "type": "object",
          "properties": {
            "top": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "bottom": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "left": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "right": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            }
          },
          "additionalProperties": false
        },
        "scrollSnap": {
          "type": "object",
          "properties": {
            "scrollSnapType": {
              "enum": [
                "mandatory",
                "proximity",
                "none"
              ]
            },
            "scrollSnapDirection": {
              "enum": [
                "x",
                "y"
              ]
            }
          },
          "additionalProperties": false
        },
        "scrollBehaviour": {
          "enum": [
            "auto",
            "smooth"
          ]
        },
        "contentMaxWidth": {
          "type": "object",
          "properties": {
            "maxWidth": {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            "align": {
              "type": "string",
              "enum": [
                "center",
                "right",
                "left"
              ]
            }
          },
          "additionalProperties": false
        },
        "spxStopper": {
          "type": "object",
          "properties": {
            "min": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "max": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            }
          },
          "additionalProperties": false
        },
        "rowGap": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "columnGap": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "contain": {
          "enum": [
            "none",
            "paint"
          ]
        }
      },
      "additionalProperties": false
    },
    "StackItemLayout": {
      "type": [
        "object"
      ],
      "properties": {
        "id": true,
        "type": {
          "type": "string",
          "enum": [
            "StackItemLayout"
          ]
        },
        "scrollSnapAlign": {
          "enum": [
            "center",
            "end",
            "start",
            "none"
          ]
        },
        "pinnedToContainer": true,
        "margins": {
          "type": "object",
          "properties": {
            "top": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "bottom": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "left": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "right": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            }
          },
          "additionalProperties": false
        },
        "position": {
          "enum": [
            "sticky",
            "stickyToHeader",
            "absolute",
            "relative"
          ]
        },
        "isInFront": true,
        "top": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "bottom": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "left": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "right": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "order": true,
        "alignSelf": {
          "type": "string",
          "enum": [
            "start",
            "end",
            "center",
            "stretch",
            "content"
          ]
        },
        "justifySelf": {
          "type": "string",
          "enum": [
            "start",
            "end",
            "center",
            "stretch",
            "content"
          ]
        },
        "basis": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "grow": true,
        "shrink": true
      },
      "additionalProperties": false
    },
    "LayoutDataItem": {
      "type": "object",
      "properties": {
        "id": true,
        "type": true
      },
      "additionalProperties": false
    },
    "BaseItemLayout": {
      "type": [
        "object"
      ],
      "properties": {
        "id": true,
        "type": true,
        "scrollSnapAlign": {
          "enum": [
            "center",
            "end",
            "start",
            "none"
          ]
        },
        "pinnedToContainer": true,
        "margins": {
          "type": "object",
          "properties": {
            "top": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "bottom": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "left": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "right": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            }
          },
          "additionalProperties": false
        },
        "position": {
          "enum": [
            "sticky",
            "stickyToHeader",
            "absolute",
            "relative"
          ]
        },
        "isInFront": true,
        "top": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "bottom": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "left": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "right": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        }
      },
      "additionalProperties": false
    },
    "PositionType": {
      "enum": [
        "sticky",
        "stickyToHeader",
        "absolute",
        "relative"
      ]
    },
    "WedgeItem": {
      "type": "object",
      "properties": {
        "distance": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "startsAtRow": true
      },
      "additionalProperties": false
    },
    "MeshGridArea": {
      "type": "object",
      "properties": {
        "rowStart": true,
        "rowEnd": true
      },
      "additionalProperties": false
    },
    "ItemMeshData": {
      "type": "object",
      "properties": {
        "width": true,
        "height": true,
        "x": true,
        "y": true,
        "rotationInDegrees": true
      },
      "additionalProperties": false
    },
    "MeshItemLayout": {
      "type": "object",
      "properties": {
        "justifySelf": {
          "type": "string",
          "enum": [
            "start",
            "end",
            "center",
            "stretch",
            "content"
          ]
        },
        "margins": {
          "type": "object",
          "properties": {
            "top": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "bottom": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "left": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "right": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            }
          },
          "additionalProperties": false
        },
        "meshData": {
          "type": "object",
          "properties": {
            "width": true,
            "height": true,
            "x": true,
            "y": true,
            "rotationInDegrees": true
          },
          "additionalProperties": false
        },
        "type": {
          "type": "string",
          "enum": [
            "MeshItemLayout"
          ]
        },
        "isAbsolutePosition": true
      },
      "additionalProperties": false
    },
    "ContainerMeshData": {
      "type": "object",
      "properties": {
        "contentHeight": {
          "oneOf": [
            {
              "type": "number"
            },
            {
              "type": "string",
              "enum": [
                "auto"
              ]
            }
          ]
        }
      },
      "additionalProperties": false
    },
    "ContentArea": {
      "type": "object",
      "properties": {
        "alignment": {
          "type": "string",
          "enum": [
            "start",
            "end",
            "center",
            "stretch",
            "content"
          ]
        },
        "width": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "ratio": true
      },
      "additionalProperties": false
    },
    "MeshContainerLayout": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "MeshContainerLayout"
          ]
        },
        "meshData": {
          "type": "object",
          "properties": {
            "contentHeight": {
              "oneOf": [
                {
                  "type": "number"
                },
                {
                  "type": "string",
                  "enum": [
                    "auto"
                  ]
                }
              ]
            }
          },
          "additionalProperties": false
        },
        "contentArea": {
          "type": "object",
          "properties": {
            "alignment": {
              "type": "string",
              "enum": [
                "start",
                "end",
                "center",
                "stretch",
                "content"
              ]
            },
            "width": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "ratio": true
          },
          "additionalProperties": false
        }
      },
      "additionalProperties": false
    },
    "RefArray": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "values": {
          "type": [
            "array"
          ],
          "items": true
        }
      },
      "additionalProperties": false
    },
    "VariantRelation": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "variants": {
          "type": "array",
          "items": true
        },
        "remoteVariants": {
          "type": "array",
          "items": true
        },
        "from": true,
        "to": true
      },
      "additionalProperties": false
    },
    "BreakpointRelation": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "breakpoint": true,
        "ref": true
      },
      "additionalProperties": false
    }
  },
  "manifest.json": {
    "$id": "urn:dm:schemas:manifest.json",
    "Manifest": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "gfpp": {
          "type": "object",
          "properties": {
            "desktop": {
              "type": "object",
              "properties": {
                "mainAction1": {
                  "anyOf": [
                    {
                      "type": "object",
                      "properties": {
                        "behavior": {
                          "enum": [
                            "CUSTOM_ACTION"
                          ]
                        },
                        "actionId": true,
                        "label": {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "shouldTranslate": true
                          },
                          "additionalProperties": false
                        },
                        "actionType": {
                          "enum": [
                            "settings",
                            "layout",
                            "design",
                            "manage",
                            "background"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "behavior": {
                          "enum": [
                            "HIDE",
                            "DEFAULT",
                            "DEFAULT1",
                            "DEFAULT2"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "mainAction2": {
                  "anyOf": [
                    {
                      "type": "object",
                      "properties": {
                        "behavior": {
                          "enum": [
                            "CUSTOM_ACTION"
                          ]
                        },
                        "actionId": true,
                        "label": {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "shouldTranslate": true
                          },
                          "additionalProperties": false
                        },
                        "actionType": {
                          "enum": [
                            "settings",
                            "layout",
                            "design",
                            "manage",
                            "background"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "behavior": {
                          "enum": [
                            "HIDE",
                            "DEFAULT",
                            "DEFAULT1",
                            "DEFAULT2"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "iconButtons": {
                  "type": "object",
                  "properties": {
                    "settings": {
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "behavior": {
                              "enum": [
                                "CUSTOM_ACTION"
                              ]
                            },
                            "actionId": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "behavior": {
                              "enum": [
                                "HIDE",
                                "DEFAULT"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "add": {
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "behavior": {
                              "enum": [
                                "CUSTOM_ACTION"
                              ]
                            },
                            "actionId": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "behavior": {
                              "enum": [
                                "HIDE",
                                "DEFAULT"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "design": {
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "behavior": {
                              "enum": [
                                "CUSTOM_ACTION"
                              ]
                            },
                            "actionId": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "behavior": {
                              "enum": [
                                "HIDE",
                                "DEFAULT"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "crop": {
                      "type": "object",
                      "properties": {
                        "behavior": {
                          "enum": [
                            "HIDE",
                            "DEFAULT"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    "filters": {
                      "type": "object",
                      "properties": {
                        "behavior": {
                          "enum": [
                            "HIDE",
                            "DEFAULT"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    "animation": {
                      "type": "object",
                      "properties": {
                        "behavior": {
                          "enum": [
                            "HIDE",
                            "DEFAULT"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    "link": {
                      "type": "object",
                      "properties": {
                        "behavior": {
                          "enum": [
                            "HIDE",
                            "DEFAULT"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    "stretch": {
                      "type": "object",
                      "properties": {
                        "behavior": {
                          "enum": [
                            "HIDE",
                            "DEFAULT"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    "layout": {
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "behavior": {
                              "enum": [
                                "CUSTOM_ACTION"
                              ]
                            },
                            "actionId": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "behavior": {
                              "enum": [
                                "HIDE",
                                "DEFAULT"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "upgrade": {
                      "anyOf": [
                        {
                          "anyOf": [
                            {
                              "type": "object",
                              "properties": {
                                "behavior": {
                                  "enum": [
                                    "CUSTOM_ACTION"
                                  ]
                                },
                                "actionId": true
                              },
                              "additionalProperties": false
                            },
                            {
                              "type": "object",
                              "properties": {
                                "behavior": {
                                  "enum": [
                                    "HIDE",
                                    "DEFAULT"
                                  ]
                                }
                              },
                              "additionalProperties": false
                            }
                          ]
                        },
                        {
                          "type": "object",
                          "properties": {
                            "behavior": {
                              "enum": [
                                "SITE_UPGRADE"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "connect": {
                      "type": "object",
                      "properties": {
                        "behavior": {
                          "enum": [
                            "HIDE",
                            "DEFAULT"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    "pinMode": {
                      "type": "object",
                      "properties": {
                        "behavior": {
                          "enum": [
                            "HIDE",
                            "DEFAULT"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    "customConnect": {
                      "type": "object",
                      "properties": {
                        "behavior": {
                          "enum": [
                            "CUSTOM_ACTION"
                          ]
                        },
                        "actionId": true
                      },
                      "additionalProperties": false
                    },
                    "focalPoint": {
                      "type": "object",
                      "properties": {
                        "behavior": {
                          "enum": [
                            "HIDE",
                            "DEFAULT"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    "presets": {
                      "type": "object",
                      "properties": {
                        "behavior": {
                          "enum": [
                            "HIDE",
                            "DEFAULT"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                "helpId": true
              },
              "additionalProperties": false
            }
          },
          "additionalProperties": false
        },
        "behavior": {
          "type": "object",
          "properties": {
            "duplicatable": true,
            "resizable": true,
            "preventHide": true,
            "dataEditOptions": true,
            "closed": {
              "type": "object",
              "properties": {
                "selectable": true,
                "hideFromHierarchy": true
              },
              "additionalProperties": false
            }
          },
          "additionalProperties": false
        },
        "displayName": {
          "type": "object",
          "properties": {
            "value": true,
            "shouldTranslate": true
          },
          "additionalProperties": false
        },
        "connections": {
          "type": "object",
          "properties": {
            "*": {
              "type": "object",
              "properties": {
                "gfpp": {
                  "type": "object",
                  "properties": {
                    "desktop": {
                      "type": "object",
                      "properties": {
                        "mainAction1": {
                          "anyOf": [
                            {
                              "type": "object",
                              "properties": {
                                "behavior": {
                                  "enum": [
                                    "CUSTOM_ACTION"
                                  ]
                                },
                                "actionId": true,
                                "label": {
                                  "type": "object",
                                  "properties": {
                                    "value": true,
                                    "shouldTranslate": true
                                  },
                                  "additionalProperties": false
                                },
                                "actionType": {
                                  "enum": [
                                    "settings",
                                    "layout",
                                    "design",
                                    "manage",
                                    "background"
                                  ]
                                }
                              },
                              "additionalProperties": false
                            },
                            {
                              "type": "object",
                              "properties": {
                                "behavior": {
                                  "enum": [
                                    "HIDE",
                                    "DEFAULT",
                                    "DEFAULT1",
                                    "DEFAULT2"
                                  ]
                                }
                              },
                              "additionalProperties": false
                            }
                          ]
                        },
                        "mainAction2": {
                          "anyOf": [
                            {
                              "type": "object",
                              "properties": {
                                "behavior": {
                                  "enum": [
                                    "CUSTOM_ACTION"
                                  ]
                                },
                                "actionId": true,
                                "label": {
                                  "type": "object",
                                  "properties": {
                                    "value": true,
                                    "shouldTranslate": true
                                  },
                                  "additionalProperties": false
                                },
                                "actionType": {
                                  "enum": [
                                    "settings",
                                    "layout",
                                    "design",
                                    "manage",
                                    "background"
                                  ]
                                }
                              },
                              "additionalProperties": false
                            },
                            {
                              "type": "object",
                              "properties": {
                                "behavior": {
                                  "enum": [
                                    "HIDE",
                                    "DEFAULT",
                                    "DEFAULT1",
                                    "DEFAULT2"
                                  ]
                                }
                              },
                              "additionalProperties": false
                            }
                          ]
                        },
                        "iconButtons": {
                          "type": "object",
                          "properties": {
                            "settings": {
                              "anyOf": [
                                {
                                  "type": "object",
                                  "properties": {
                                    "behavior": {
                                      "enum": [
                                        "CUSTOM_ACTION"
                                      ]
                                    },
                                    "actionId": true
                                  },
                                  "additionalProperties": false
                                },
                                {
                                  "type": "object",
                                  "properties": {
                                    "behavior": {
                                      "enum": [
                                        "HIDE",
                                        "DEFAULT"
                                      ]
                                    }
                                  },
                                  "additionalProperties": false
                                }
                              ]
                            },
                            "add": {
                              "anyOf": [
                                {
                                  "type": "object",
                                  "properties": {
                                    "behavior": {
                                      "enum": [
                                        "CUSTOM_ACTION"
                                      ]
                                    },
                                    "actionId": true
                                  },
                                  "additionalProperties": false
                                },
                                {
                                  "type": "object",
                                  "properties": {
                                    "behavior": {
                                      "enum": [
                                        "HIDE",
                                        "DEFAULT"
                                      ]
                                    }
                                  },
                                  "additionalProperties": false
                                }
                              ]
                            },
                            "design": {
                              "anyOf": [
                                {
                                  "type": "object",
                                  "properties": {
                                    "behavior": {
                                      "enum": [
                                        "CUSTOM_ACTION"
                                      ]
                                    },
                                    "actionId": true
                                  },
                                  "additionalProperties": false
                                },
                                {
                                  "type": "object",
                                  "properties": {
                                    "behavior": {
                                      "enum": [
                                        "HIDE",
                                        "DEFAULT"
                                      ]
                                    }
                                  },
                                  "additionalProperties": false
                                }
                              ]
                            },
                            "crop": {
                              "type": "object",
                              "properties": {
                                "behavior": {
                                  "enum": [
                                    "HIDE",
                                    "DEFAULT"
                                  ]
                                }
                              },
                              "additionalProperties": false
                            },
                            "filters": {
                              "type": "object",
                              "properties": {
                                "behavior": {
                                  "enum": [
                                    "HIDE",
                                    "DEFAULT"
                                  ]
                                }
                              },
                              "additionalProperties": false
                            },
                            "animation": {
                              "type": "object",
                              "properties": {
                                "behavior": {
                                  "enum": [
                                    "HIDE",
                                    "DEFAULT"
                                  ]
                                }
                              },
                              "additionalProperties": false
                            },
                            "link": {
                              "type": "object",
                              "properties": {
                                "behavior": {
                                  "enum": [
                                    "HIDE",
                                    "DEFAULT"
                                  ]
                                }
                              },
                              "additionalProperties": false
                            },
                            "stretch": {
                              "type": "object",
                              "properties": {
                                "behavior": {
                                  "enum": [
                                    "HIDE",
                                    "DEFAULT"
                                  ]
                                }
                              },
                              "additionalProperties": false
                            },
                            "layout": {
                              "anyOf": [
                                {
                                  "type": "object",
                                  "properties": {
                                    "behavior": {
                                      "enum": [
                                        "CUSTOM_ACTION"
                                      ]
                                    },
                                    "actionId": true
                                  },
                                  "additionalProperties": false
                                },
                                {
                                  "type": "object",
                                  "properties": {
                                    "behavior": {
                                      "enum": [
                                        "HIDE",
                                        "DEFAULT"
                                      ]
                                    }
                                  },
                                  "additionalProperties": false
                                }
                              ]
                            },
                            "upgrade": {
                              "anyOf": [
                                {
                                  "anyOf": [
                                    {
                                      "type": "object",
                                      "properties": {
                                        "behavior": {
                                          "enum": [
                                            "CUSTOM_ACTION"
                                          ]
                                        },
                                        "actionId": true
                                      },
                                      "additionalProperties": false
                                    },
                                    {
                                      "type": "object",
                                      "properties": {
                                        "behavior": {
                                          "enum": [
                                            "HIDE",
                                            "DEFAULT"
                                          ]
                                        }
                                      },
                                      "additionalProperties": false
                                    }
                                  ]
                                },
                                {
                                  "type": "object",
                                  "properties": {
                                    "behavior": {
                                      "enum": [
                                        "SITE_UPGRADE"
                                      ]
                                    }
                                  },
                                  "additionalProperties": false
                                }
                              ]
                            },
                            "connect": {
                              "type": "object",
                              "properties": {
                                "behavior": {
                                  "enum": [
                                    "HIDE",
                                    "DEFAULT"
                                  ]
                                }
                              },
                              "additionalProperties": false
                            },
                            "pinMode": {
                              "type": "object",
                              "properties": {
                                "behavior": {
                                  "enum": [
                                    "HIDE",
                                    "DEFAULT"
                                  ]
                                }
                              },
                              "additionalProperties": false
                            },
                            "customConnect": {
                              "type": "object",
                              "properties": {
                                "behavior": {
                                  "enum": [
                                    "CUSTOM_ACTION"
                                  ]
                                },
                                "actionId": true
                              },
                              "additionalProperties": false
                            },
                            "focalPoint": {
                              "type": "object",
                              "properties": {
                                "behavior": {
                                  "enum": [
                                    "HIDE",
                                    "DEFAULT"
                                  ]
                                }
                              },
                              "additionalProperties": false
                            },
                            "presets": {
                              "type": "object",
                              "properties": {
                                "behavior": {
                                  "enum": [
                                    "HIDE",
                                    "DEFAULT"
                                  ]
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        },
                        "helpId": true
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            }
          },
          "additionalProperties": false
        }
      },
      "additionalProperties": false
    },
    "ComponentStageBehavior": {
      "type": "object",
      "properties": {
        "duplicatable": true,
        "resizable": true,
        "preventHide": true,
        "dataEditOptions": true,
        "closed": {
          "type": "object",
          "properties": {
            "selectable": true,
            "hideFromHierarchy": true
          },
          "additionalProperties": false
        }
      },
      "additionalProperties": false
    },
    "GfppConfig": {
      "type": "object",
      "properties": {
        "desktop": {
          "type": "object",
          "properties": {
            "mainAction1": {
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "behavior": {
                      "enum": [
                        "CUSTOM_ACTION"
                      ]
                    },
                    "actionId": true,
                    "label": {
                      "type": "object",
                      "properties": {
                        "value": true,
                        "shouldTranslate": true
                      },
                      "additionalProperties": false
                    },
                    "actionType": {
                      "enum": [
                        "settings",
                        "layout",
                        "design",
                        "manage",
                        "background"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "behavior": {
                      "enum": [
                        "HIDE",
                        "DEFAULT",
                        "DEFAULT1",
                        "DEFAULT2"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "mainAction2": {
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "behavior": {
                      "enum": [
                        "CUSTOM_ACTION"
                      ]
                    },
                    "actionId": true,
                    "label": {
                      "type": "object",
                      "properties": {
                        "value": true,
                        "shouldTranslate": true
                      },
                      "additionalProperties": false
                    },
                    "actionType": {
                      "enum": [
                        "settings",
                        "layout",
                        "design",
                        "manage",
                        "background"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "behavior": {
                      "enum": [
                        "HIDE",
                        "DEFAULT",
                        "DEFAULT1",
                        "DEFAULT2"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "iconButtons": {
              "type": "object",
              "properties": {
                "settings": {
                  "anyOf": [
                    {
                      "type": "object",
                      "properties": {
                        "behavior": {
                          "enum": [
                            "CUSTOM_ACTION"
                          ]
                        },
                        "actionId": true
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "behavior": {
                          "enum": [
                            "HIDE",
                            "DEFAULT"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "add": {
                  "anyOf": [
                    {
                      "type": "object",
                      "properties": {
                        "behavior": {
                          "enum": [
                            "CUSTOM_ACTION"
                          ]
                        },
                        "actionId": true
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "behavior": {
                          "enum": [
                            "HIDE",
                            "DEFAULT"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "design": {
                  "anyOf": [
                    {
                      "type": "object",
                      "properties": {
                        "behavior": {
                          "enum": [
                            "CUSTOM_ACTION"
                          ]
                        },
                        "actionId": true
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "behavior": {
                          "enum": [
                            "HIDE",
                            "DEFAULT"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "crop": {
                  "type": "object",
                  "properties": {
                    "behavior": {
                      "enum": [
                        "HIDE",
                        "DEFAULT"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "filters": {
                  "type": "object",
                  "properties": {
                    "behavior": {
                      "enum": [
                        "HIDE",
                        "DEFAULT"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "animation": {
                  "type": "object",
                  "properties": {
                    "behavior": {
                      "enum": [
                        "HIDE",
                        "DEFAULT"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "link": {
                  "type": "object",
                  "properties": {
                    "behavior": {
                      "enum": [
                        "HIDE",
                        "DEFAULT"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "stretch": {
                  "type": "object",
                  "properties": {
                    "behavior": {
                      "enum": [
                        "HIDE",
                        "DEFAULT"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "layout": {
                  "anyOf": [
                    {
                      "type": "object",
                      "properties": {
                        "behavior": {
                          "enum": [
                            "CUSTOM_ACTION"
                          ]
                        },
                        "actionId": true
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "properties": {
                        "behavior": {
                          "enum": [
                            "HIDE",
                            "DEFAULT"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "upgrade": {
                  "anyOf": [
                    {
                      "anyOf": [
                        {
                          "type": "object",
                          "properties": {
                            "behavior": {
                              "enum": [
                                "CUSTOM_ACTION"
                              ]
                            },
                            "actionId": true
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "properties": {
                            "behavior": {
                              "enum": [
                                "HIDE",
                                "DEFAULT"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    {
                      "type": "object",
                      "properties": {
                        "behavior": {
                          "enum": [
                            "SITE_UPGRADE"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "connect": {
                  "type": "object",
                  "properties": {
                    "behavior": {
                      "enum": [
                        "HIDE",
                        "DEFAULT"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "pinMode": {
                  "type": "object",
                  "properties": {
                    "behavior": {
                      "enum": [
                        "HIDE",
                        "DEFAULT"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "customConnect": {
                  "type": "object",
                  "properties": {
                    "behavior": {
                      "enum": [
                        "CUSTOM_ACTION"
                      ]
                    },
                    "actionId": true
                  },
                  "additionalProperties": false
                },
                "focalPoint": {
                  "type": "object",
                  "properties": {
                    "behavior": {
                      "enum": [
                        "HIDE",
                        "DEFAULT"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "presets": {
                  "type": "object",
                  "properties": {
                    "behavior": {
                      "enum": [
                        "HIDE",
                        "DEFAULT"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            "helpId": true
          },
          "additionalProperties": false
        }
      },
      "additionalProperties": false
    },
    "MainActionConfig": {
      "anyOf": [
        {
          "type": "object",
          "properties": {
            "behavior": {
              "enum": [
                "CUSTOM_ACTION"
              ]
            },
            "actionId": true,
            "label": {
              "type": "object",
              "properties": {
                "value": true,
                "shouldTranslate": true
              },
              "additionalProperties": false
            },
            "actionType": {
              "enum": [
                "settings",
                "layout",
                "design",
                "manage",
                "background"
              ]
            }
          },
          "additionalProperties": false
        },
        {
          "type": "object",
          "properties": {
            "behavior": {
              "enum": [
                "HIDE",
                "DEFAULT",
                "DEFAULT1",
                "DEFAULT2"
              ]
            }
          },
          "additionalProperties": false
        }
      ]
    },
    "GfppMainActionButtonConfig": {
      "type": "object",
      "properties": {
        "behavior": {
          "enum": [
            "HIDE",
            "DEFAULT",
            "DEFAULT1",
            "DEFAULT2"
          ]
        }
      },
      "additionalProperties": false
    },
    "GfppMainActionDefinition": {
      "type": "object",
      "properties": {
        "behavior": {
          "enum": [
            "CUSTOM_ACTION"
          ]
        },
        "actionId": true,
        "label": {
          "type": "object",
          "properties": {
            "value": true,
            "shouldTranslate": true
          },
          "additionalProperties": false
        },
        "actionType": {
          "enum": [
            "settings",
            "layout",
            "design",
            "manage",
            "background"
          ]
        }
      },
      "additionalProperties": false
    },
    "IconButtonConfig": {
      "anyOf": [
        {
          "type": "object",
          "properties": {
            "behavior": {
              "enum": [
                "CUSTOM_ACTION"
              ]
            },
            "actionId": true
          },
          "additionalProperties": false
        },
        {
          "type": "object",
          "properties": {
            "behavior": {
              "enum": [
                "HIDE",
                "DEFAULT"
              ]
            }
          },
          "additionalProperties": false
        }
      ]
    },
    "GfppIconButtonConfig": {
      "type": "object",
      "properties": {
        "behavior": {
          "enum": [
            "HIDE",
            "DEFAULT"
          ]
        }
      },
      "additionalProperties": false
    },
    "GfppIconActionConfig": {
      "type": "object",
      "properties": {
        "behavior": {
          "enum": [
            "CUSTOM_ACTION"
          ]
        },
        "actionId": true
      },
      "additionalProperties": false
    },
    "GfppUpgradeConfig": {
      "type": "object",
      "properties": {
        "behavior": {
          "enum": [
            "SITE_UPGRADE"
          ]
        }
      },
      "additionalProperties": false
    },
    "TranslatableString": {
      "type": "object",
      "properties": {
        "value": true,
        "shouldTranslate": true
      },
      "additionalProperties": false
    }
  },
  "measurements.json": {
    "$id": "urn:dm:schemas:measurements.json",
    "MeasurementsData": {
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "MeasurementsData"
          ]
        },
        "id": true,
        "metaData": true,
        "width": true,
        "height": true,
        "x": true,
        "y": true,
        "viewportSize": true,
        "isFixedPosition": true
      },
      "additionalProperties": false
    }
  },
  "migration.json": {
    "$id": "urn:dm:schemas:migration.json",
    "migration": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "migrationStatus": true,
        "migrationSource": {
          "enum": [
            "classic",
            "figma",
            "site-description-file",
            "editor-x",
            "editor-x-force-migration",
            "site-generation"
          ]
        },
        "migrationRevision": true
      },
      "additionalProperties": false
    }
  },
  "mobile_hints.json": {
    "$id": "urn:dm:schemas:mobile_hints.json",
    "MobileHints": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "author": {
          "enum": [
            "studio",
            "duplicate"
          ]
        },
        "isLocked": true,
        "hidden": true,
        "offsetX": true,
        "offsetY": true,
        "offsetOrigin": {
          "enum": [
            "leftTop",
            "rightTop",
            "leftBottom"
          ]
        },
        "originalCompId": true,
        "recommendedScale": true,
        "recommendedWidth": true,
        "recommendedHeight": true,
        "orderIndex": true,
        "modifiedByUser": true,
        "shouldBeForceConverted": true
      },
      "additionalProperties": false
    }
  },
  "multilingualTranslations.json": {
    "$id": "urn:dm:schemas:multilingualTranslations.json",
    "Direction": {
      "type": "string",
      "enum": [
        "ltr",
        "rtl",
        "inherit"
      ]
    },
    "AppVars": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "vars": {
          "type": "object",
          "additionalProperties": {
            "type": "object",
            "properties": {
              "value": true,
              "type": {
                "type": "string",
                "enum": [
                  "AppPartParam"
                ]
              }
            },
            "additionalProperties": false
          }
        },
        "appDefId": true
      },
      "additionalProperties": false
    },
    "SVGItem": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "svgId": true
      },
      "additionalProperties": false
    },
    "SVGReference": true,
    "BackgroundImage": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "url": true,
        "positionx": {
          "type": "string",
          "enum": [
            "left",
            "right",
            "center"
          ]
        },
        "imagesizew": true,
        "imagesizeh": true,
        "positiony": {
          "type": "string",
          "enum": [
            "top",
            "bottom",
            "center"
          ]
        },
        "width": true,
        "repeatx": {
          "type": "string",
          "enum": [
            "no_repeat",
            "repeat"
          ]
        },
        "repeaty": {
          "type": "string",
          "enum": [
            "no_repeat",
            "repeat"
          ]
        },
        "attachment": {
          "type": "string",
          "enum": [
            "scroll",
            "fixed",
            "inherit",
            "local"
          ]
        },
        "color": true
      },
      "additionalProperties": false
    },
    "BackgroundMedia": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "mediaRef": true,
        "mediaTransforms": {
          "type": "object",
          "properties": {
            "scale": true,
            "opacity": true
          },
          "additionalProperties": false
        },
        "overlayTransforms": {
          "type": "object",
          "properties": {
            "scale": true,
            "opacity": true
          },
          "additionalProperties": false
        },
        "color": {
          "oneOf": [
            {
              "enum": [
                "transparent",
                "noColor"
              ]
            },
            {
              "type": "string",
              "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
            }
          ]
        },
        "colorOpacity": true,
        "alignType": {
          "type": "string",
          "enum": [
            "top",
            "bottom",
            "left",
            "right",
            "center",
            "top_left",
            "top_right",
            "bottom_left",
            "bottom_right"
          ]
        },
        "fittingType": {
          "type": "string",
          "enum": [
            "fill",
            "fit",
            "stretch",
            "actual_size",
            "original_size",
            "tile",
            "tile_horizontal",
            "tile_vertical",
            "fit_and_tile",
            "legacy_tile",
            "legacy_tile_horizontal",
            "legacy_tile_vertical",
            "legacy_normal"
          ]
        },
        "scrollType": {
          "type": "string",
          "enum": [
            "none",
            "fixed",
            "scroll",
            "local",
            "parallax"
          ]
        },
        "showOverlayForMediaType": {
          "type": "string",
          "enum": [
            "all",
            "WixVideo",
            "Image"
          ]
        },
        "imageOverlay": true,
        "colorOverlay": {
          "type": "string",
          "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
        },
        "colorOverlayOpacity": true,
        "overlayBlending": {
          "type": "object",
          "properties": {
            "color": true,
            "opacity": true,
            "contrast": true,
            "saturate": true,
            "blendMode": {
              "type": "string",
              "enum": [
                "normal",
                "multiply",
                "screen",
                "darken",
                "lighten",
                "overlay",
                "colorDodge",
                "colorBurn",
                "hardLight",
                "softLight",
                "difference",
                "exclusion",
                "hue",
                "saturation",
                "color",
                "luminosity"
              ]
            }
          },
          "additionalProperties": false
        },
        "filterEffect": {
          "type": [
            "object",
            "null"
          ],
          "properties": {
            "effectType": {
              "type": "string",
              "enum": [
                "none",
                "normal",
                "ink",
                "kennedy",
                "feathered",
                "blur",
                "whistler",
                "3d",
                "blueray",
                "lighten",
                "darken",
                "pinkrinse",
                "redrum",
                "greenwash",
                "yellowstreak",
                "neonsky",
                "seaweed",
                "soledad",
                "sangria",
                "malibu",
                "candyfloss",
                "elmo",
                "unicorn",
                "kerouac",
                "koolaid",
                "hydra",
                "pixie",
                "nightrain",
                "bauhaus",
                "neptune",
                "orca",
                "manhattan",
                "goldie",
                "flamingo",
                "faded",
                "gotham",
                "hulk",
                "midnight",
                "lucille",
                "organic",
                "grayscale",
                "tvDuotone",
                "tvMonotoneDark",
                "tvMonotoneLight",
                "tvHue"
              ]
            },
            "brightness": true,
            "contrast": true,
            "saturation": true,
            "hue": true,
            "duotoneDark": true,
            "duotoneLight": true,
            "invert": true,
            "isCustom": true
          },
          "additionalProperties": false
        },
        "colorLayers": {
          "type": [
            "array",
            "null"
          ],
          "items": true
        }
      },
      "additionalProperties": false
    },
    "WixVideo": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "title": true,
        "alt": true,
        "videoId": true,
        "generatedPosters": {
          "type": "array",
          "items": true
        },
        "qualities": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "quality": true,
              "width": true,
              "height": true,
              "formats": {
                "type": "array",
                "items": true
              },
              "format": {
                "type": "string",
                "enum": [
                  "mp4",
                  "webm"
                ]
              },
              "url": true
            },
            "additionalProperties": false
          }
        },
        "adaptiveVideo": {
          "type": [
            "array",
            "null"
          ],
          "items": {
            "type": "object",
            "properties": {
              "format": {
                "type": "string",
                "enum": [
                  "hls",
                  "dash"
                ]
              },
              "url": true
            },
            "additionalProperties": false
          }
        },
        "posterImageRef": true,
        "duration": true,
        "fps": true,
        "hasAudio": true,
        "artist": {
          "type": "object",
          "properties": {
            "name": true,
            "id": true
          },
          "additionalProperties": false
        },
        "loop": true,
        "autoplay": true,
        "playbackSpeed": true,
        "preload": {
          "type": "string",
          "enum": [
            "auto",
            "metadata",
            "none"
          ]
        },
        "controls": {
          "type": "string",
          "enum": [
            "none",
            "full"
          ]
        },
        "mute": true,
        "opacity": true,
        "mediaFeatures": {
          "type": "array",
          "items": {
            "type": "string",
            "enum": [
              "alpha"
            ]
          }
        },
        "mask": {
          "anyOf": [
            {
              "type": "null"
            },
            {
              "type": "object",
              "properties": {
                "x": true,
                "y": true,
                "width": true,
                "height": true,
                "svgId": true,
                "flip": {
                  "type": "string",
                  "enum": [
                    "x",
                    "y",
                    "xy",
                    "none"
                  ]
                },
                "rotate": true,
                "mode": {
                  "type": "string",
                  "enum": [
                    "alpha",
                    "luminance"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        }
      },
      "additionalProperties": false
    },
    "WixVideoData": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "title": true,
        "alt": true,
        "videoId": true,
        "generatedPosters": {
          "type": "array",
          "items": true
        },
        "qualities": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "quality": true,
              "width": true,
              "height": true,
              "formats": {
                "type": "array",
                "items": true
              },
              "format": {
                "type": "string",
                "enum": [
                  "mp4",
                  "webm"
                ]
              },
              "url": true
            },
            "additionalProperties": false
          }
        },
        "adaptiveVideo": {
          "type": [
            "array",
            "null"
          ],
          "items": {
            "type": "object",
            "properties": {
              "format": {
                "type": "string",
                "enum": [
                  "hls",
                  "dash"
                ]
              },
              "url": true
            },
            "additionalProperties": false
          }
        },
        "posterImageRef": true,
        "duration": true,
        "fps": true,
        "hasAudio": true,
        "artist": {
          "type": "object",
          "properties": {
            "name": true,
            "id": true
          },
          "additionalProperties": false
        }
      },
      "additionalProperties": false
    },
    "Document": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "siteName": true,
        "usedFonts": {
          "type": "array",
          "items": true
        },
        "characterSets": {
          "type": "array",
          "items": true
        },
        "renderModifiers": true,
        "name": true,
        "mainPage": true,
        "mainPageId": true,
        "smSettings": {
          "type": [
            "object"
          ],
          "properties": {
            "socialLoginGoogleEnabled": true,
            "socialLoginFacebookEnabled": true,
            "privacyNoteType": {
              "type": "string",
              "enum": [
                "CHECKBOX",
                "NOTE"
              ]
            },
            "joinCommunityCheckedByDefault": true,
            "customSignUpPageId": true,
            "customSignInPageId": true,
            "customNoPermissionsPageId": true,
            "termsOfUse": {
              "type": "object",
              "properties": {
                "enabled": true,
                "link": {
                  "type": [
                    "null",
                    "string"
                  ],
                  "pattern": "^$|^#"
                }
              },
              "additionalProperties": false
            },
            "privacyPolicy": {
              "type": "object",
              "properties": {
                "enabled": true,
                "link": {
                  "type": [
                    "null",
                    "string"
                  ],
                  "pattern": "^$|^#"
                }
              },
              "additionalProperties": false
            },
            "codeOfConduct": {
              "type": "object",
              "properties": {
                "enabled": true,
                "link": {
                  "type": [
                    "null",
                    "string"
                  ],
                  "pattern": "^$|^#"
                }
              },
              "additionalProperties": false
            },
            "smFirstDialogLogin": true
          },
          "additionalProperties": false
        },
        "styleSettings": {
          "type": "object",
          "properties": {
            "stylesPerPage": true
          },
          "additionalProperties": false
        },
        "accessibilitySettings": {
          "type": "object",
          "properties": {
            "visualFocusDisabled": true,
            "skipToContent": true,
            "isRtlSupportEnabled": true,
            "currentSiteDirection": {
              "type": "string",
              "enum": [
                "ltr",
                "rtl"
              ]
            }
          },
          "additionalProperties": false
        },
        "mobileSettings": {
          "type": "object",
          "properties": {
            "animationsEnabled": true
          },
          "additionalProperties": false
        },
        "layoutSettings": {
          "type": "object",
          "properties": {
            "useDesktopSectionsLayout": true,
            "isFluid": true,
            "headerToPagesGap": true,
            "pagesToFooterGap": true,
            "mechanism": {
              "type": [
                "string"
              ],
              "enum": [
                "mesh",
                "anchors"
              ]
            },
            "soapCompsAroundPagesContainer": true
          },
          "additionalProperties": false
        },
        "appStudioData": true,
        "ignoreBottomBottomAnchors": true,
        "anchorLockThreshold": true,
        "supportMobile": true,
        "autoDomReorder": true,
        "appsInstallState": true,
        "usesNewAnimations": true
      },
      "additionalProperties": false
    },
    "AccessibilitySettings": {
      "type": "object",
      "properties": {
        "visualFocusDisabled": true,
        "skipToContent": true,
        "isRtlSupportEnabled": true,
        "currentSiteDirection": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl"
          ]
        }
      },
      "additionalProperties": false
    },
    "MobileSettings": {
      "type": "object",
      "properties": {
        "animationsEnabled": true
      },
      "additionalProperties": false
    },
    "LayoutSettings": {
      "type": "object",
      "properties": {
        "useDesktopSectionsLayout": true,
        "isFluid": true,
        "headerToPagesGap": true,
        "pagesToFooterGap": true,
        "mechanism": {
          "type": [
            "string"
          ],
          "enum": [
            "mesh",
            "anchors"
          ]
        },
        "soapCompsAroundPagesContainer": true
      },
      "additionalProperties": false
    },
    "StyleSettings": {
      "type": "object",
      "properties": {
        "stylesPerPage": true
      },
      "additionalProperties": false
    },
    "SiteMembersData": {
      "type": "object",
      "properties": {
        "socialLoginGoogleEnabled": true,
        "socialLoginFacebookEnabled": true,
        "privacyNoteType": {
          "type": "string",
          "enum": [
            "CHECKBOX",
            "NOTE"
          ]
        },
        "joinCommunityCheckedByDefault": true,
        "customSignUpPageId": true,
        "customSignInPageId": true,
        "customNoPermissionsPageId": true,
        "termsOfUse": {
          "type": "object",
          "properties": {
            "enabled": true,
            "link": {
              "type": [
                "null",
                "string"
              ],
              "pattern": "^$|^#"
            }
          },
          "additionalProperties": false
        },
        "privacyPolicy": {
          "type": "object",
          "properties": {
            "enabled": true,
            "link": {
              "type": [
                "null",
                "string"
              ],
              "pattern": "^$|^#"
            }
          },
          "additionalProperties": false
        },
        "codeOfConduct": {
          "type": "object",
          "properties": {
            "enabled": true,
            "link": {
              "type": [
                "null",
                "string"
              ],
              "pattern": "^$|^#"
            }
          },
          "additionalProperties": false
        },
        "smFirstDialogLogin": true
      },
      "additionalProperties": false
    },
    "AppStudioData": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "name": true,
        "description": true,
        "widgets": {
          "type": [
            "array",
            "null"
          ],
          "items": true
        },
        "codePackages": {
          "type": [
            "array",
            "null"
          ],
          "items": true
        },
        "panels": {
          "type": [
            "array",
            "null"
          ],
          "items": true
        },
        "dependencies": {
          "type": [
            "null",
            "array"
          ],
          "items": {
            "type": "object",
            "properties": {
              "appDefId": true,
              "dependencyData": {
                "type": "array",
                "items": {
                  "type": "string",
                  "enum": [
                    "PROVISION_ONLY_INSTALLATION",
                    "NOTIFY_USER_ON_DEPENDENCY",
                    "IS_BUNDLE"
                  ]
                }
              }
            },
            "additionalProperties": false
          }
        },
        "dashboards": {
          "type": [
            "array",
            "null"
          ],
          "items": true
        },
        "customDefinitions": {
          "type": [
            "array",
            "null"
          ],
          "items": true
        },
        "ssrCache": true
      },
      "additionalProperties": false
    },
    "CodePackagesDescriptor": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "displayName": true,
        "name": true,
        "description": true
      },
      "additionalProperties": false
    },
    "WidgetPropertyDefinition": {
      "additionalProperties": true
    },
    "CustomDefinitionDescriptor": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "structure": {
          "type": "object",
          "additionalProperties": {
            "type": "object",
            "properties": {
              "$id": true,
              "type": true,
              "title": true,
              "description": true,
              "properties": {
                "type": "object",
                "additionalProperties": {
                  "additionalProperties": true
                }
              },
              "default": true,
              "propertiesOrder": {
                "type": "array",
                "items": true
              }
            },
            "additionalProperties": false
          }
        }
      },
      "additionalProperties": false
    },
    "WidgetDescriptor": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "name": true,
        "devCenterWidgetId": true,
        "devCenterEditorReactComponentId": true,
        "kind": {
          "type": [
            "string",
            "null"
          ],
          "enum": [
            "container",
            "section"
          ]
        },
        "panels": {
          "type": [
            "array"
          ],
          "items": true
        },
        "defaultSize": {
          "type": [
            "object",
            "null"
          ],
          "properties": {
            "width": true,
            "height": true
          },
          "additionalProperties": false
        },
        "rootCompId": true,
        "variations": {
          "type": [
            "array",
            "null"
          ],
          "items": true
        },
        "presets": {
          "type": [
            "array",
            "null"
          ],
          "items": true
        },
        "plugin": {
          "type": "object",
          "properties": {
            "placements": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "appDefinitionId": true,
                  "widgetId": true,
                  "slotId": true
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "containedWidgets": {
          "type": "array",
          "items": true
        },
        "widgetApi": {
          "type": "object",
          "properties": {
            "functions": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "name": true,
                  "description": true,
                  "params": {
                    "type": "array",
                    "items": {
                      "type": "object",
                      "properties": {
                        "name": true,
                        "description": true
                      },
                      "additionalProperties": false
                    }
                  },
                  "returnsDescription": true
                },
                "additionalProperties": false
              }
            },
            "propertiesSchemas": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "structure": {
                    "type": "object",
                    "additionalProperties": {
                      "additionalProperties": true
                    }
                  }
                },
                "additionalProperties": false
              }
            },
            "events": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "name": true,
                  "description": true,
                  "args": {
                    "type": "array",
                    "items": {
                      "properties": {
                        "name": true
                      },
                      "additionalProperties": false
                    }
                  }
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "structureRef": {
          "type": "object",
          "properties": {
            "pageId": true,
            "rootCompId": true
          },
          "additionalProperties": false
        },
        "compType": true
      },
      "additionalProperties": false
    },
    "DashboardDescriptor": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "rootCompId": true,
        "title": true,
        "routePath": true,
        "hideInSidebar": true,
        "activeSidebarPageId": true,
        "isRoutePathConnectedToTitle": true
      },
      "additionalProperties": false
    },
    "PanelDescriptor": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "name": true,
        "devCenterPanelId": true,
        "title": true,
        "kind": {
          "type": "string",
          "enum": [
            "settings"
          ]
        },
        "helpId": true,
        "pageUrl": true,
        "height": true,
        "defaultSize": {
          "type": "object",
          "properties": {
            "width": true,
            "height": true
          },
          "additionalProperties": false
        },
        "rootCompId": true
      },
      "additionalProperties": false
    },
    "VariationDescriptor": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "name": true,
        "rootCompId": true
      },
      "additionalProperties": false
    },
    "PresetDescriptor": {
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:defaultSize\\/width|defaultSize\\/height)$"
                  },
                  "variableId": true
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": true,
        "id": true,
        "metaData": true,
        "presetId": true,
        "name": true,
        "defaultSize": {
          "type": "object",
          "properties": {
            "width": {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            "height": {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            }
          },
          "additionalProperties": false
        }
      },
      "additionalProperties": false
    },
    "FlatTheme": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "THEME_DIRECTORY": {
          "type": "string",
          "pattern": "^[\\/\\-|0-9|a-z|A-Z]*$"
        },
        "BG_DIRECTORY": {
          "type": "string",
          "pattern": "^[\\/\\-|0-9|a-z|A-Z]*$"
        },
        "CONTACT_DIRECTORY": {
          "type": "string",
          "pattern": "^[\\/\\-|0-9|a-z|A-Z]*$"
        },
        "NETWORKS_DIRECTORY": {
          "type": "string",
          "pattern": "^[\\/\\-|0-9|a-z|A-Z]*$"
        },
        "EXTERNAL_LINKS_DIRECTORY": {
          "type": "string",
          "pattern": "^[\\/\\-|0-9|a-z|A-Z]*$"
        },
        "PAGES_DIRECTORY": {
          "type": "string",
          "pattern": "^[\\/\\-|0-9|a-z|A-Z]*$"
        },
        "WEB_THEME_DIRECTORY": {
          "type": "string",
          "pattern": "^[\\/\\-|0-9|a-z|A-Z]*$"
        },
        "BASE_THEME_DIRECTORY": {
          "type": "string",
          "pattern": "^[\\/\\-|0-9|a-z|A-Z]*$"
        },
        "font": true,
        "bgId": true,
        "bgSize": true,
        "bgType": true,
        "siteBg": true,
        "mobileBg": true,
        "siteBgColor": {
          "type": "string",
          "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
        },
        "headerTextColor": {
          "type": "string",
          "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
        },
        "headerBgColor": {
          "type": "string",
          "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
        },
        "textColor": {
          "type": "string",
          "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
        },
        "areaBgColor": {
          "type": "string",
          "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
        },
        "iconBgColor": {
          "type": "string",
          "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
        },
        "borderColor": {
          "type": "string",
          "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
        },
        "fontHeader": true,
        "fontTitle": true,
        "fontSubTitle": true,
        "fontButton": true,
        "fontText": true,
        "fontSmallText": true,
        "borderContainer": {
          "type": "string",
          "pattern": "^$|^(0|([0-9]*([.][0-9]+){0,1}(px|em)[\\s]*){1,4})([Ss][Oo][Ll][Ii][Dd]|[Dd][Aa][Ss][Hh][Ee][Dd]|[Dd][Oo][Tt][Tt][Ee][Dd]|[Dd][Oo][Uu][Bb][Ll][Ee]|[Gg][Rr][Oo][Oo][Vv][Ee]|[Ii][Nn][Ss][Ee][Tt]|[Nn][Oo][Nn][Ee]|[Oo][Uu][Tt][Ss][Ee][Tt]|[Rr][Ii][Dd][Gg][Ee]){0,1}[\\s]*([{\\[]color_([0-9]{1,2}|100)[}\\]]|(#(([0-9|a-f]){3}){1,2}){0,1})|\\[borderColor\\]?$"
        },
        "borderThumb": {
          "type": "string",
          "pattern": "^$|^(0|([0-9]*([.][0-9]+){0,1}(px|em)[\\s]*){1,4})([Ss][Oo][Ll][Ii][Dd]|[Dd][Aa][Ss][Hh][Ee][Dd]|[Dd][Oo][Tt][Tt][Ee][Dd]|[Dd][Oo][Uu][Bb][Ll][Ee]|[Gg][Rr][Oo][Oo][Vv][Ee]|[Ii][Nn][Ss][Ee][Tt]|[Nn][Oo][Nn][Ee]|[Oo][Uu][Tt][Ss][Ee][Tt]|[Rr][Ii][Dd][Gg][Ee]){0,1}[\\s]*([{\\[]color_([0-9]{1,2}|100)[}\\]]|(#(([0-9|a-f]){3}){1,2}){0,1})|\\[borderColor\\]?$"
        },
        "borderButton": {
          "type": "string",
          "pattern": "^$|^(0|([0-9]*([.][0-9]+){0,1}(px|em)[\\s]*){1,4})([Ss][Oo][Ll][Ii][Dd]|[Dd][Aa][Ss][Hh][Ee][Dd]|[Dd][Oo][Tt][Tt][Ee][Dd]|[Dd][Oo][Uu][Bb][Ll][Ee]|[Gg][Rr][Oo][Oo][Vv][Ee]|[Ii][Nn][Ss][Ee][Tt]|[Nn][Oo][Nn][Ee]|[Oo][Uu][Tt][Ss][Ee][Tt]|[Rr][Ii][Dd][Gg][Ee]){0,1}[\\s]*([{\\[]color_([0-9]{1,2}|100)[}\\]]|(#(([0-9|a-f]){3}){1,2}){0,1})|\\[borderColor\\]?$"
        },
        "borderIcon": {
          "type": "string",
          "pattern": "^$|^(0|([0-9]*([.][0-9]+){0,1}(px|em)[\\s]*){1,4})([Ss][Oo][Ll][Ii][Dd]|[Dd][Aa][Ss][Hh][Ee][Dd]|[Dd][Oo][Tt][Tt][Ee][Dd]|[Dd][Oo][Uu][Bb][Ll][Ee]|[Gg][Rr][Oo][Oo][Vv][Ee]|[Ii][Nn][Ss][Ee][Tt]|[Nn][Oo][Nn][Ee]|[Oo][Uu][Tt][Ss][Ee][Tt]|[Rr][Ii][Dd][Gg][Ee]){0,1}[\\s]*([{\\[]color_([0-9]{1,2}|100)[}\\]]|(#(([0-9|a-f]){3}){1,2}){0,1})|\\[borderColor\\]?$"
        },
        "radiusContainer": {
          "type": "string",
          "pattern": "^$|^\\d*(.\\d+)?$|^(\\d+(.\\d+)?(em|px)|0(.0+)?)( +(\\d+(.\\d+)?(em|px)|0(.0+)?)){0,3}$"
        },
        "radiusThumb": {
          "type": "string",
          "pattern": "^$|^\\d*(.\\d+)?$|^(\\d+(.\\d+)?(em|px)|0(.0+)?)( +(\\d+(.\\d+)?(em|px)|0(.0+)?)){0,3}$"
        },
        "radiusButton": {
          "type": "string",
          "pattern": "^$|^\\d*(.\\d+)?$|^(\\d+(.\\d+)?(em|px)|0(.0+)?)( +(\\d+(.\\d+)?(em|px)|0(.0+)?)){0,3}$"
        },
        "radiusIcon": {
          "type": "string",
          "pattern": "^$|^\\d*(.\\d+)?$|^(\\d+(.\\d+)?(em|px)|0(.0+)?)( +(\\d+(.\\d+)?(em|px)|0(.0+)?)){0,3}$"
        },
        "padding1": {
          "type": "string",
          "pattern": "^$|^\\d*(.\\d+)?$|^(\\d+(.\\d+)?(em|px)|0(.0+)?)( +(\\d+(.\\d+)?(em|px)|0(.0+)?)){0,3}$"
        },
        "padding2": {
          "type": "string",
          "pattern": "^$|^\\d*(.\\d+)?$|^(\\d+(.\\d+)?(em|px)|0(.0+)?)( +(\\d+(.\\d+)?(em|px)|0(.0+)?)){0,3}$"
        },
        "padding3": {
          "type": "string",
          "pattern": "^$|^\\d*(.\\d+)?$|^(\\d+(.\\d+)?(em|px)|0(.0+)?)( +(\\d+(.\\d+)?(em|px)|0(.0+)?)){0,3}$"
        },
        "iconSize": {
          "type": "string",
          "pattern": "^\\d+(.\\d+)?(em|px)?$"
        },
        "bulletSize": {
          "type": "string",
          "pattern": "^\\d+(.\\d+)?(em|px)?$"
        },
        "headerSpacing": {
          "type": "string",
          "pattern": "^\\d+(.\\d+)?(em|px)?$"
        },
        "componentSpacing": {
          "type": "string",
          "pattern": "^\\d+(.\\d+)?(em|px)?$"
        },
        "itemSpacing": {
          "type": "string",
          "pattern": "^\\d+(.\\d+)?(em|px)?$"
        },
        "thumbSpacing": {
          "type": "string",
          "pattern": "^\\d+(.\\d+)?(em|px)?$"
        },
        "iconSpacing": {
          "type": "string",
          "pattern": "^\\d+(.\\d+)?(em|px)?$"
        }
      },
      "additionalProperties": false
    },
    "Image": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "link": {
          "type": [
            "null",
            "string"
          ],
          "pattern": "^$|^#"
        },
        "title": true,
        "name": true,
        "uri": {
          "type": "string",
          "pattern": "^[\\w:~\\-_+%.\\/,\\?=\\()]+$"
        },
        "description": true,
        "height": true,
        "width": true,
        "borderSize": true,
        "alt": true,
        "decorative": true,
        "hasAnimation": true,
        "originalImageDataRef": true,
        "opacity": true,
        "crop": {
          "oneOf": [
            {
              "type": "null"
            },
            {
              "type": "object",
              "properties": {
                "x": true,
                "y": true,
                "width": true,
                "height": true,
                "svgId": true,
                "flip": {
                  "type": "string",
                  "enum": [
                    "x",
                    "y",
                    "xy",
                    "none"
                  ]
                },
                "rotate": true
              },
              "additionalProperties": false
            }
          ]
        },
        "upscaleMethod": true,
        "focalPoint": {
          "oneOf": [
            {
              "type": "null"
            },
            {
              "type": "object",
              "properties": {
                "x": true,
                "y": true
              },
              "additionalProperties": false
            }
          ]
        },
        "artist": {
          "type": "object",
          "properties": {
            "name": true,
            "id": true
          },
          "additionalProperties": false
        },
        "a11y": true
      },
      "additionalProperties": false
    },
    "ImageA11y": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "label": true
      },
      "additionalProperties": false
    },
    "ImageReference": true,
    "GlobalImageQuality": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "quality": true,
        "unsharpMask": {
          "type": "object",
          "properties": {
            "radius": true,
            "amount": true,
            "threshold": true
          },
          "additionalProperties": false
        }
      },
      "additionalProperties": false
    },
    "ImageQuality": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "quality": true,
        "unsharpMask": {
          "type": "object",
          "properties": {
            "radius": true,
            "amount": true,
            "threshold": true
          },
          "additionalProperties": false
        }
      },
      "additionalProperties": false
    },
    "ClassicSectionA11y": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "label": true,
        "tabindex": true,
        "live": {
          "type": "string",
          "enum": [
            "polite",
            "assertive"
          ]
        },
        "role": {
          "type": "string",
          "enum": [
            "heading",
            "status",
            "alert"
          ]
        },
        "atomic": true,
        "hidden": true,
        "current": {
          "type": "string",
          "enum": [
            "step",
            "page",
            "true",
            "false"
          ]
        },
        "level": true
      },
      "additionalProperties": false
    },
    "StripColumnsContainerA11y": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "label": true,
        "tabindex": true,
        "live": {
          "type": "string",
          "enum": [
            "polite",
            "assertive"
          ]
        },
        "role": {
          "type": "string",
          "enum": [
            "heading",
            "status",
            "alert"
          ]
        },
        "atomic": true,
        "hidden": true,
        "current": {
          "type": "string",
          "enum": [
            "step",
            "page",
            "true",
            "false"
          ]
        },
        "level": true
      },
      "additionalProperties": false
    },
    "StripColumnsContainer": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "a11y": true,
        "itemsDirection": {
          "type": "string",
          "enum": [
            "rtl",
            "ltr"
          ]
        },
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        }
      },
      "additionalProperties": false
    },
    "ClassicSection": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "a11y": true
      },
      "additionalProperties": false
    },
    "StripContainer": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "background": true
      },
      "additionalProperties": false
    },
    "ImageList": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "items": {
          "type": [
            "array",
            "null"
          ],
          "items": true
        },
        "direction": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        }
      },
      "additionalProperties": false
    },
    "Link": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "linkType": {
          "type": "string",
          "enum": [
            "SMS",
            "CALL",
            "SKYPE",
            "MAP",
            "EMAIL",
            "FACEBOOK",
            "FLICKR",
            "BLOGGER",
            "MYSPACE",
            "LINKEDIN",
            "TWITTER",
            "TUMBLR",
            "YOUTUBE",
            "VIMEO",
            "PAGE",
            "FREE_LINK",
            "TEXT",
            "DELICIOUS",
            "WEBSITE",
            "DOCUMENT",
            "ADMIN_LOGIN",
            "LOGIN"
          ]
        },
        "href": true,
        "text": true,
        "target": true,
        "icon": true
      },
      "additionalProperties": false
    },
    "TextLink": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "linkType": {
          "type": "string",
          "enum": [
            "SMS",
            "CALL",
            "SKYPE",
            "MAP",
            "EMAIL",
            "FACEBOOK",
            "FLICKR",
            "BLOGGER",
            "MYSPACE",
            "LINKEDIN",
            "TWITTER",
            "TUMBLR",
            "YOUTUBE",
            "VIMEO",
            "PAGE",
            "FREE_LINK",
            "TEXT",
            "DELICIOUS",
            "WEBSITE",
            "DOCUMENT",
            "ADMIN_LOGIN",
            "LOGIN"
          ]
        },
        "href": true,
        "text": true,
        "target": true,
        "icon": true
      },
      "additionalProperties": false
    },
    "AnchorLink": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "anchorName": true,
        "anchorDataId": {
          "anyOf": [
            true,
            {
              "enum": [
                "SCROLL_TO_TOP"
              ]
            }
          ]
        },
        "pageId": true,
        "rel": {
          "type": "array",
          "items": {
            "type": "string",
            "enum": [
              "nofollow",
              "noopener",
              "noreferrer",
              "sponsored"
            ]
          }
        }
      },
      "additionalProperties": false
    },
    "DocumentLink": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "docId": true,
        "name": true,
        "indexable": true
      },
      "additionalProperties": false
    },
    "PhoneLink": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "phoneNumber": true
      },
      "additionalProperties": false
    },
    "WhatsAppLink": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "phoneNumber": true
      },
      "additionalProperties": false
    },
    "AddressLink": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "address": true
      },
      "additionalProperties": false
    },
    "EmailLink": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "recipient": true,
        "subject": true,
        "body": true
      },
      "additionalProperties": false
    },
    "FormSubmitButtonLink": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true
      },
      "additionalProperties": false
    },
    "ExternalLink": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "url": {
          "allOf": [
            true,
            {
              "not": {
                "type": "string",
                "pattern": ".*script://.*"
              }
            }
          ]
        },
        "target": {
          "type": "string",
          "enum": [
            "_self",
            "_blank"
          ]
        },
        "rel": {
          "type": "array",
          "items": {
            "type": "string",
            "enum": [
              "nofollow",
              "noopener",
              "noreferrer",
              "sponsored"
            ]
          }
        }
      },
      "additionalProperties": false
    },
    "LinkRelAttribute": {
      "type": "array",
      "items": {
        "type": "string",
        "enum": [
          "nofollow",
          "noopener",
          "noreferrer",
          "sponsored"
        ]
      }
    },
    "DynamicPageLink": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "routerId": true,
        "innerRoute": true,
        "anchorDataId": true,
        "isTpaRoute": true,
        "target": {
          "type": "string",
          "enum": [
            "_self",
            "_blank"
          ]
        },
        "rel": {
          "type": "array",
          "items": {
            "type": "string",
            "enum": [
              "nofollow",
              "noopener",
              "noreferrer",
              "sponsored"
            ]
          }
        }
      },
      "additionalProperties": false
    },
    "TpaPageLink": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "itemTypeIdentifier": true,
        "itemId": true,
        "pageId": true,
        "appDefinitionId": true,
        "path": true,
        "target": {
          "type": "string",
          "enum": [
            "_self",
            "_blank"
          ]
        },
        "rel": {
          "type": "array",
          "items": {
            "type": "string",
            "enum": [
              "nofollow",
              "noopener",
              "noreferrer",
              "sponsored"
            ]
          }
        }
      },
      "additionalProperties": false
    },
    "LoginToWixLink": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "postLoginUrl": true,
        "postSignupUrl": true,
        "dialog": {
          "type": "string",
          "enum": [
            "createUser",
            "login",
            "showLogin"
          ]
        },
        "sendMail": true,
        "mailTemplate": true,
        "userColor": true,
        "loginCompName": true
      },
      "additionalProperties": false
    },
    "PageLink": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "pageId": true,
        "target": {
          "type": "string",
          "enum": [
            "_self",
            "_blank"
          ]
        },
        "rel": {
          "type": "array",
          "items": {
            "type": "string",
            "enum": [
              "nofollow",
              "noopener",
              "noreferrer",
              "sponsored"
            ]
          }
        }
      },
      "additionalProperties": false
    },
    "MediaItem": {
      "type": "object",
      "properties": {
        "componentType": true,
        "dateCreated": true,
        "description": true,
        "fileName": true,
        "fileSize": true,
        "height": true,
        "width": true,
        "iconURL": true,
        "mediaType": true,
        "mimeType": true,
        "originalFileName": true,
        "sourceURL": true,
        "tags": true,
        "title": true,
        "version": true
      },
      "additionalProperties": false
    },
    "MediaRichText": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "text": true,
        "stylesMapId": true,
        "linkList": {
          "type": [
            "array",
            "null"
          ],
          "items": true
        },
        "componentDataList": {
          "type": [
            "array",
            "null"
          ],
          "items": true
        }
      },
      "additionalProperties": false
    },
    "Page": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "title": true,
        "hideTitle": true,
        "icon": true,
        "windowTitle": true,
        "descriptionSEO": true,
        "advancedSeoData": true,
        "metaKeywordsSEO": true,
        "pageTitleSEO": true,
        "pageUriSEO": true,
        "hidePage": true,
        "underConstruction": true,
        "tpaApplicationId": true,
        "appDefinitionId": true,
        "managingAppDefId": true,
        "tpaPageId": true,
        "parentPageId": true,
        "pageSecurity": true,
        "indexable": true,
        "mobileHidePage": true,
        "pageBackgrounds": {
          "type": "object",
          "properties": {
            "desktop": {
              "type": "object",
              "properties": {
                "custom": true,
                "mediaSizing": {
                  "type": "string",
                  "enum": [
                    "document",
                    "viewport"
                  ]
                },
                "ref": true,
                "isPreset": true
              },
              "additionalProperties": false
            },
            "mobile": {
              "type": "object",
              "properties": {
                "custom": true,
                "mediaSizing": {
                  "type": "string",
                  "enum": [
                    "document",
                    "viewport"
                  ]
                },
                "ref": true,
                "isPreset": true
              },
              "additionalProperties": false
            }
          },
          "additionalProperties": false
        },
        "isLandingPage": true,
        "isMobileLandingPage": true,
        "isPopup": true,
        "translationData": {
          "type": "object",
          "properties": {
            "uriSEOTranslated": true
          },
          "additionalProperties": false
        },
        "ogImage": true,
        "ogImageRef": true,
        "ignoreBottomBottomAnchors": true,
        "cacheMode": {
          "enum": [
            "auto",
            "manual",
            "disabled"
          ]
        },
        "cacheMaxAgeHours": true
      },
      "additionalProperties": false
    },
    "Text": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "text": true
      },
      "additionalProperties": false
    },
    "RichText": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "text": true,
        "defaultStyle": true
      },
      "additionalProperties": false
    },
    "RichTextImage": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "text": true,
        "image": true
      },
      "additionalProperties": false
    },
    "BaseInput": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "name": true,
        "formGroup": true
      },
      "additionalProperties": false
    },
    "BaseTextInput": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "value": true,
        "name": true,
        "formGroup": true
      },
      "additionalProperties": false
    },
    "TextInputA11y": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "label": true,
        "tabindex": true,
        "invalid": true,
        "multiline": true,
        "autocomplete": true,
        "live": {
          "type": "string",
          "enum": [
            "polite",
            "assertive"
          ]
        },
        "atomic": true
      },
      "additionalProperties": false
    },
    "TextInput": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "labelDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "inputDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "errorDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "textType": {
          "type": "string",
          "enum": [
            "text",
            "email",
            "url",
            "number",
            "tel",
            "password"
          ]
        },
        "maxLength": true,
        "min": true,
        "max": true,
        "pattern": true,
        "phoneFormat": {
          "type": [
            "string",
            "null"
          ],
          "pattern": "^#*(((#+-)*)#+$)"
        },
        "label": true,
        "placeholder": true,
        "a11y": true,
        "prefix": true,
        "step": true,
        "autoComplete": true,
        "value": true,
        "name": true,
        "formGroup": true
      },
      "additionalProperties": false
    },
    "TextAreaInput": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "labelDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "inputDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "errorDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "maxLength": true,
        "label": true,
        "placeholder": true,
        "value": true,
        "name": true,
        "formGroup": true
      },
      "additionalProperties": false
    },
    "CheckboxInput": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "checked": true,
        "linkLabel": true,
        "link": {
          "type": [
            "null",
            "string"
          ],
          "pattern": "^$|^#"
        },
        "label": true,
        "indeterminate": true,
        "direction": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "value": true,
        "name": true,
        "formGroup": true
      },
      "additionalProperties": false
    },
    "DateItem": true,
    "DateString": true,
    "DateRange": {
      "type": "object",
      "properties": {
        "startDate": true,
        "endDate": true
      },
      "additionalProperties": false
    },
    "DateRanges": {
      "type": "array",
      "items": {
        "type": "object",
        "properties": {
          "startDate": true,
          "endDate": true
        },
        "additionalProperties": false
      }
    },
    "DatePicker": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "labelDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "inputDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "disabledDates": {
          "type": "array",
          "items": true
        },
        "disabledDaysOfWeek": {
          "type": "array",
          "items": {
            "type": [
              "number"
            ],
            "enum": [
              0,
              1,
              2,
              3,
              4,
              5,
              6
            ]
          }
        },
        "minDate": true,
        "maxDate": true,
        "allowPastDates": true,
        "allowFutureDates": true,
        "label": true,
        "placeholder": true,
        "enabledDateRanges": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "startDate": true,
              "endDate": true
            },
            "additionalProperties": false
          }
        },
        "disabledDateRanges": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "startDate": true,
              "endDate": true
            },
            "additionalProperties": false
          }
        },
        "name": true,
        "formGroup": true
      },
      "additionalProperties": false
    },
    "Theme": {
      "type": [
        "object",
        "null"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "properties": true
      },
      "additionalProperties": false
    },
    "TwitterFollow": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "accountToFollow": true
      },
      "additionalProperties": false
    },
    "TwitterTweet": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "defaultText": true,
        "accountToFollow": true,
        "isHttpsEnabled": true,
        "urlFormat": {
          "type": "string",
          "enum": [
            "hashBang",
            "slash"
          ]
        }
      },
      "additionalProperties": false
    },
    "MobileMetaData": {
      "type": "object",
      "properties": {
        "adaptiveMobileOn": true
      },
      "additionalProperties": false
    },
    "Preloader": {
      "type": "object",
      "properties": {
        "enabled": true,
        "uri": true
      },
      "additionalProperties": false
    },
    "ContactInfo": {
      "type": "object",
      "properties": {
        "companyName": true,
        "phone": true,
        "email": true,
        "address": true,
        "fax": true
      },
      "additionalProperties": false
    },
    "SocialLink": {
      "type": "object",
      "properties": {
        "id": {
          "type": "string",
          "enum": [
            "facebook",
            "twitter",
            "pinterest",
            "google_plus",
            "tumblr",
            "blogger",
            "linkedin",
            "youtube",
            "vimeo",
            "flickr"
          ]
        },
        "url": true
      },
      "additionalProperties": false
    },
    "QuickActions": {
      "type": "object",
      "properties": {
        "colorScheme": {
          "type": "string",
          "enum": [
            "dark",
            "light"
          ]
        },
        "configuration": {
          "type": "object",
          "properties": {
            "addressEnabled": true,
            "emailEnabled": true,
            "navigationMenuEnabled": true,
            "phoneEnabled": true,
            "quickActionsMenuEnabled": true,
            "socialLinksEnabled": true
          },
          "additionalProperties": false
        },
        "socialLinks": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "id": {
                "type": "string",
                "enum": [
                  "facebook",
                  "twitter",
                  "pinterest",
                  "google_plus",
                  "tumblr",
                  "blogger",
                  "linkedin",
                  "youtube",
                  "vimeo",
                  "flickr"
                ]
              },
              "url": true
            },
            "additionalProperties": false
          }
        }
      },
      "additionalProperties": false
    },
    "QuickActionBarItem": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "link": {
          "type": [
            "null",
            "string"
          ],
          "pattern": "^$|^#"
        },
        "itemType": true,
        "text": true,
        "icon": true
      },
      "additionalProperties": false
    },
    "SiteSettings": {
      "type": "object",
      "properties": {
        "siteName": true,
        "siteTitleSEO": true,
        "siteDescriptionSEO": true,
        "keywordsSEO": true,
        "allowSEFindSite": true,
        "favicon": true,
        "thumbnail": true,
        "googleAnalyticsID": true,
        "fbAdminsUserId": true,
        "suppressTrackingCookies": true
      },
      "additionalProperties": false
    },
    "AdvancedSeoSettingsDialog": {
      "type": "object",
      "properties": {
        "userMetaTags": true
      },
      "additionalProperties": false
    },
    "Anchor": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "name": true,
        "compId": true,
        "urlFragment": true
      },
      "additionalProperties": false
    },
    "BasicMenuItem": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "link": {
          "type": [
            "null",
            "string"
          ],
          "pattern": "^$|^#"
        },
        "items": {
          "type": [
            "array",
            "null"
          ],
          "items": true
        },
        "slot": true,
        "label": true,
        "isVisible": true,
        "isVisibleMobile": true,
        "displayCount": true,
        "iconRef": true
      },
      "additionalProperties": false
    },
    "CustomMenu": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "name": true,
        "menuType": true,
        "syncWithPages": true,
        "appId": true,
        "appDefinitionId": true,
        "items": {
          "type": [
            "array",
            "null"
          ],
          "items": true
        }
      },
      "additionalProperties": false
    },
    "CustomMenusCollection": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "menus": {
          "type": [
            "array",
            "null"
          ],
          "items": true
        }
      },
      "additionalProperties": false
    },
    "CustomMenuDataRef": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "menuRef": true,
        "a11y": true,
        "direction": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "itemDirection": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "submenuDirection": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "submenuSubItemDirection": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        }
      },
      "additionalProperties": false
    },
    "CustomMenuDataRefA11y": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "label": true
      },
      "additionalProperties": false
    },
    "Menu": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "items": {
          "type": [
            "array",
            "null"
          ],
          "items": true
        }
      },
      "additionalProperties": false
    },
    "FacebookLikeBox": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "facebookPageId": true,
        "showFaces": true,
        "colorScheme": {
          "type": "string",
          "enum": [
            "light",
            "dark"
          ]
        },
        "showStream": true,
        "showBorder": true,
        "showHeader": true
      },
      "additionalProperties": false
    },
    "ImageButtonA11y": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "label": true
      },
      "additionalProperties": false
    },
    "ImageButton": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "link": {
          "type": [
            "null",
            "string"
          ],
          "pattern": "^$|^#"
        },
        "alt": true,
        "a11y": true,
        "defaultImage": true,
        "hoverImage": true,
        "activeImage": true
      },
      "additionalProperties": false
    },
    "NumericStepper": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "value": true
      },
      "additionalProperties": false
    },
    "PinItPinWidget": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "pinId": true
      },
      "additionalProperties": false
    },
    "PinterestPinIt": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "uri": true,
        "description": true,
        "isHttpsEnabled": true,
        "urlFormat": {
          "type": "string",
          "enum": [
            "hashBang",
            "slash"
          ]
        }
      },
      "additionalProperties": false
    },
    "SingleAudioPlayer": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "uri": true,
        "originalFileName": true,
        "artist": true,
        "track": true
      },
      "additionalProperties": false
    },
    "SkypeCallButton": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "skypeName": true,
        "buttonType": {
          "type": "string",
          "enum": [
            "call",
            "chat"
          ]
        }
      },
      "additionalProperties": false
    },
    "SpotifyFollow": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "uri": true
      },
      "additionalProperties": false
    },
    "SpotifyPlayer": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "uri": true
      },
      "additionalProperties": false
    },
    "SubscribeForm": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "toEmailAddress": true,
        "bccEmailAddress": true,
        "firstNameFieldLabel": true,
        "lastNameFieldLabel": true,
        "emailFieldLabel": true,
        "phoneFieldLabel": true,
        "subscribeFormTitle": true,
        "textDirection": {
          "type": "string",
          "enum": [
            "left",
            "right"
          ]
        },
        "submitButtonLabel": true,
        "successMessage": true,
        "errorMessage": true,
        "validationErrorMessage": true,
        "onSubmitBehavior": {
          "type": "string",
          "enum": [
            "message",
            "link"
          ]
        },
        "link": {
          "type": [
            "null",
            "string"
          ],
          "pattern": "^$|^#"
        }
      },
      "additionalProperties": false
    },
    "YouTubeSubscribeButton": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "youtubeChannelId": true
      },
      "additionalProperties": false
    },
    "AudioPlayer": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "uri": true,
        "autoPlay": true,
        "loop": true,
        "visible": true,
        "volume": true,
        "title": true,
        "description": true,
        "icon_uri": true,
        "originalFileName": true,
        "showToolTip": true
      },
      "additionalProperties": false
    },
    "Boolean": {
      "type": "object",
      "properties": {
        "value": true
      },
      "additionalProperties": false
    },
    "CheckBox": {
      "type": "object",
      "properties": {
        "value": true,
        "indeterminate": true
      },
      "additionalProperties": false
    },
    "Grid": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "dataSource": {
          "type": "object",
          "properties": {
            "type": {
              "type": "string",
              "enum": [
                "static",
                "dynamic"
              ]
            },
            "revision": true
          },
          "additionalProperties": false
        },
        "rows": {
          "type": "array",
          "items": true
        },
        "rowsCount": true,
        "revision": true,
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        }
      },
      "additionalProperties": false
    },
    "ContactForm": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "toEmailAddress": true,
        "bccEmailAddress": true,
        "nameFieldLabel": true,
        "emailFieldLabel": true,
        "phoneFieldLabel": true,
        "addressFieldLabel": true,
        "subjectFieldLabel": true,
        "messageFieldLabel": true,
        "submitButtonLabel": true,
        "successMessage": true,
        "errorMessage": true,
        "textDirection": {
          "type": "string",
          "enum": [
            "left",
            "right"
          ]
        },
        "validationErrorMessage": true,
        "onSubmitBehavior": {
          "type": "string",
          "enum": [
            "message",
            "link"
          ]
        },
        "link": {
          "type": [
            "null",
            "string"
          ],
          "pattern": "^$|^#"
        }
      },
      "additionalProperties": false
    },
    "DynamicContactForm": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "toEmailAddress": true,
        "bccEmailAddress": true,
        "submitButtonLabel": true,
        "successMessage": true,
        "errorMessage": true,
        "textDirection": {
          "type": "string",
          "enum": [
            "left",
            "right"
          ]
        },
        "validationErrorMessage": true,
        "onSubmitBehavior": {
          "type": "string",
          "enum": [
            "message",
            "link"
          ]
        },
        "link": {
          "type": [
            "null",
            "string"
          ],
          "pattern": "^$|^#"
        },
        "formName": true,
        "dynamicFields": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "name": true,
              "inputType": true,
              "displayLabel": true,
              "required": true,
              "displayed": true
            },
            "additionalProperties": false
          }
        }
      },
      "additionalProperties": false
    },
    "EbayItemsBySeller": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "sellerId": true,
        "registrationSite": true
      },
      "additionalProperties": false
    },
    "FacebookShareButton": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "urlChoice": {
          "type": "string",
          "enum": [
            "Current page",
            "Site"
          ]
        },
        "label": true,
        "isHttpsEnabled": true,
        "urlFormat": {
          "type": "string",
          "enum": [
            "hashBang",
            "slash"
          ]
        }
      },
      "additionalProperties": false
    },
    "FlashComponent": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "linkType": {
          "type": "string",
          "enum": [
            "SMS",
            "CALL",
            "SKYPE",
            "MAP",
            "EMAIL",
            "FACEBOOK",
            "FLICKR",
            "BLOGGER",
            "MYSPACE",
            "LINKEDIN",
            "TWITTER",
            "TUMBLR",
            "YOUTUBE",
            "VIMEO",
            "PAGE",
            "FREE_LINK",
            "TEXT",
            "DELICIOUS",
            "WEBSITE",
            "DOCUMENT",
            "ADMIN_LOGIN",
            "LOGIN"
          ]
        },
        "href": true,
        "text": true,
        "target": true,
        "icon": true,
        "title": true,
        "uri": true,
        "description": true,
        "height": true,
        "width": true,
        "placeHolderImage": true
      },
      "additionalProperties": false
    },
    "FlickrBadgeWidget": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "userId": true,
        "userName": true,
        "tag": true,
        "imageCount": true,
        "whichImages": true,
        "imageSize": true,
        "layoutOrientation": true
      },
      "additionalProperties": false
    },
    "GeoMapLocation": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "address": true,
        "latitude": true,
        "longitude": true,
        "title": true,
        "description": true,
        "link": {
          "type": [
            "null",
            "string"
          ],
          "pattern": "^$|^#"
        },
        "linkTitle": true,
        "pinIcon": true,
        "pinColor": true
      },
      "additionalProperties": false
    },
    "GeoMap": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "language": {
          "type": "string",
          "enum": [
            "af",
            "sq",
            "am",
            "ar",
            "hy",
            "az",
            "eu",
            "be",
            "bn",
            "bs",
            "bg",
            "my",
            "ca",
            "zh",
            "zh-CN",
            "zh-HK",
            "zh-TW",
            "hr",
            "cs",
            "da",
            "nl",
            "en",
            "en-AU",
            "en-GB",
            "et",
            "fa",
            "fi",
            "fil",
            "fr",
            "fr-CA",
            "gl",
            "ka",
            "de",
            "el",
            "gu",
            "iw",
            "hi",
            "hu",
            "is",
            "id",
            "it",
            "ja",
            "kn",
            "kk",
            "km",
            "ko",
            "ky",
            "lo",
            "lv",
            "lt",
            "mk",
            "ms",
            "ml",
            "mr",
            "mn",
            "ne",
            "no",
            "pl",
            "pt",
            "pt-BR",
            "pt-PT",
            "pa",
            "ro",
            "ru",
            "sr",
            "si",
            "sk",
            "sl",
            "es",
            "es-419",
            "sw",
            "sv",
            "ta",
            "te",
            "th",
            "tr",
            "uk",
            "ur",
            "uz",
            "vi",
            "zu"
          ]
        },
        "locations": {
          "type": [
            "array"
          ],
          "items": true
        },
        "address": true,
        "latitude": true,
        "longitude": true,
        "addressInfo": true,
        "defaultLocation": true,
        "mapStyle": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "elementType": {
                "type": "string",
                "enum": [
                  "all",
                  "geometry",
                  "geometry.fill",
                  "geometry.stroke",
                  "labels",
                  "labels.icon",
                  "labels.text",
                  "labels.text.fill",
                  "labels.text.stroke"
                ]
              },
              "featureType": {
                "type": "string",
                "enum": [
                  "administrative",
                  "administrative.country",
                  "administrative.land_parcel",
                  "administrative.locality",
                  "administrative.neighborhood",
                  "administrative.province",
                  "all",
                  "landscape",
                  "landscape.man_made",
                  "landscape.natural",
                  "landscape.natural.landcover",
                  "landscape.natural.terrain",
                  "poi",
                  "poi.attraction",
                  "poi.business",
                  "poi.government",
                  "poi.medical",
                  "poi.park",
                  "poi.place_of_worship",
                  "poi.school",
                  "poi.sports_complex",
                  "road",
                  "road.arterial",
                  "road.highway",
                  "road.highway.controlled_access",
                  "road.local",
                  "transit",
                  "transit.line",
                  "transit.station",
                  "transit.station.airport",
                  "transit.station.bus",
                  "transit.station.rail",
                  "water"
                ]
              },
              "stylers": {
                "type": "array",
                "items": {
                  "type": "object",
                  "properties": {
                    "color": true,
                    "gamma": true,
                    "hue": true,
                    "invert_lightness": true,
                    "lightness": true,
                    "saturation": true,
                    "visibility": {
                      "type": "string",
                      "enum": [
                        "on",
                        "off",
                        "simplified"
                      ]
                    },
                    "weight": true
                  },
                  "additionalProperties": false
                }
              }
            },
            "additionalProperties": false
          }
        }
      },
      "additionalProperties": false
    },
    "HtmlComponent": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "sourceType": true,
        "url": true,
        "title": true,
        "freezeFrame": true,
        "allowFullScreen": true,
        "componentConsentPolicy": {
          "type": "string",
          "enum": [
            "essential",
            "functional",
            "analytics",
            "advertising",
            "dataToThirdParty"
          ]
        }
      },
      "additionalProperties": false
    },
    "DisqusComments": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "disqusId": true
      },
      "additionalProperties": false
    },
    "ItunesButton": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "downloadUrl": true
      },
      "additionalProperties": false
    },
    "LinkableFlashComponent": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "link": {
          "type": [
            "null",
            "string"
          ],
          "pattern": "^$|^#"
        },
        "title": true,
        "uri": true,
        "description": true,
        "height": true,
        "width": true,
        "placeHolderImage": true
      },
      "additionalProperties": false
    },
    "LinkableButton": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "link": {
          "type": [
            "null",
            "string"
          ],
          "pattern": "^$|^#"
        },
        "direction": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "label": true,
        "a11y": true
      },
      "additionalProperties": false
    },
    "LoginButton": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "language": true
      },
      "additionalProperties": false
    },
    "TinyMenu": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "loginSocialBarRef": true,
        "menuRef": true
      },
      "additionalProperties": false
    },
    "LoginSocialBar": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "menuItemsRef": true,
        "iconItemsRef": true,
        "language": true,
        "loggedInMember": {
          "type": "string",
          "enum": [
            "avatarOnly",
            "textOnly",
            "avatarAndText",
            "memberInitials"
          ]
        },
        "loggedOutMember": {
          "type": "string",
          "enum": [
            "avatarOnly",
            "textOnly",
            "avatarAndText"
          ]
        },
        "loggedInAvatarIcon": {
          "type": "string",
          "enum": [
            "profileImage",
            "initials",
            "custom"
          ]
        },
        "loggedOutAvatarIcon": {
          "type": "string",
          "enum": [
            "profileImage",
            "initials",
            "custom"
          ]
        },
        "loggedInCustomAvatar": true,
        "loggedOutCustomAvatar": true,
        "loggedOutText": true,
        "showLoggedInText": true,
        "loggedInTextState": {
          "type": "string",
          "enum": [
            "memberName",
            "custom"
          ]
        },
        "loggedInText": true,
        "customLoggedInText": true,
        "logOutText": true
      },
      "additionalProperties": false
    },
    "PagesGroupData": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "appId": true,
        "appDefinitionId": true,
        "groupName": true,
        "pages": {
          "type": "array",
          "items": true
        }
      },
      "additionalProperties": false
    },
    "PagesGroupCollection": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "groups": {
          "type": [
            "array",
            "null"
          ],
          "items": true
        }
      },
      "additionalProperties": false
    },
    "PayPalButton": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "merchantID": true
      },
      "additionalProperties": false
    },
    "PermaLink": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "appType": {
          "enum": [
            "ListsApps",
            "ThirdPartyApps"
          ]
        },
        "dataItemRef": true,
        "mutableSeoTitle": true,
        "correctPermaLinkRef": true
      },
      "additionalProperties": false
    },
    "PinterestFollow": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "urlChoice": true,
        "label": true
      },
      "additionalProperties": false
    },
    "SelectableList": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "direction": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "labelDirection": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "inputDirection": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "dropdownDirection": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "errorDirection": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "options": {
          "type": [
            "array",
            "null"
          ],
          "items": true
        },
        "label": true,
        "placeholder": {
          "type": "object",
          "properties": {
            "value": true,
            "text": true
          },
          "additionalProperties": false
        },
        "value": true,
        "name": true,
        "formGroup": true
      },
      "additionalProperties": false
    },
    "SelectOption": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "value": true,
        "text": true,
        "selectedText": true,
        "disabled": true,
        "description": true
      },
      "additionalProperties": false
    },
    "RadioButton": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "label": true,
        "value": true,
        "name": true,
        "formGroup": true
      },
      "additionalProperties": false
    },
    "RadioGroup": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "labelDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "optionsDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "defaultValue": true,
        "options": {
          "type": [
            "array",
            "null"
          ],
          "items": true
        },
        "label": true,
        "placeholder": {
          "type": "object",
          "properties": {
            "value": true,
            "text": true
          },
          "additionalProperties": false
        },
        "value": true,
        "name": true,
        "formGroup": true
      },
      "additionalProperties": false
    },
    "CheckboxGroup": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "labelDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "optionsDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "options": {
          "type": [
            "array",
            "null"
          ],
          "items": true
        },
        "label": true,
        "name": true,
        "formGroup": true
      },
      "additionalProperties": false
    },
    "FileUploader": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "buttonLabel": true,
        "placeholderLabel": true,
        "label": true,
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "labelDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "buttonLabelDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "filesDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "iconPosition": {
          "type": [
            "string"
          ],
          "enum": [
            "row",
            "rowReverse",
            "column",
            "columnReverse"
          ]
        }
      },
      "additionalProperties": false
    },
    "UploadName": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true
      },
      "additionalProperties": false
    },
    "SiteButtonA11y": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "pressed": true,
        "tabindex": true,
        "label": true,
        "live": {
          "type": "string",
          "enum": [
            "polite",
            "assertive"
          ]
        },
        "haspopup": {
          "type": "string",
          "enum": [
            "true",
            "false",
            "menu",
            "dialog",
            "listbox",
            "tree",
            "grid"
          ]
        },
        "expanded": true,
        "disabled": true
      },
      "additionalProperties": false
    },
    "SiteButton": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "linkType": {
          "type": "string",
          "enum": [
            "SMS",
            "CALL",
            "SKYPE",
            "MAP",
            "EMAIL",
            "FACEBOOK",
            "FLICKR",
            "BLOGGER",
            "MYSPACE",
            "LINKEDIN",
            "TWITTER",
            "TUMBLR",
            "YOUTUBE",
            "VIMEO",
            "PAGE",
            "FREE_LINK",
            "TEXT",
            "DELICIOUS",
            "WEBSITE",
            "DOCUMENT",
            "ADMIN_LOGIN",
            "LOGIN"
          ]
        },
        "href": true,
        "text": true,
        "target": true,
        "icon": true,
        "label": true
      },
      "additionalProperties": false
    },
    "SoundCloudWidget": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "url": true,
        "showArtWork": true,
        "autoPlay": true,
        "embedSource": true
      },
      "additionalProperties": false
    },
    "StyledTextA11y": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "label": true,
        "live": {
          "type": "string",
          "enum": [
            "polite",
            "assertive"
          ]
        },
        "level": true,
        "role": {
          "type": "string",
          "enum": [
            "heading",
            "status",
            "alert"
          ]
        },
        "atomic": true,
        "hidden": true,
        "current": {
          "type": "string",
          "enum": [
            "step",
            "page",
            "true",
            "false"
          ]
        }
      },
      "additionalProperties": false
    },
    "StyledText": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "text": true,
        "stylesMapId": true,
        "linkList": {
          "type": [
            "array",
            "null"
          ],
          "items": true
        },
        "a11y": true
      },
      "additionalProperties": false
    },
    "StyledTextLinkHelper": {
      "type": "object",
      "properties": {
        "link": {
          "type": [
            "null",
            "string"
          ],
          "pattern": "^$|^#"
        }
      },
      "additionalProperties": false
    },
    "SvgShape": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "link": {
          "type": [
            "null",
            "string"
          ],
          "pattern": "^$|^#"
        },
        "alt": true
      },
      "additionalProperties": false
    },
    "VectorImage": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "link": {
          "type": [
            "null",
            "string"
          ],
          "pattern": "^$|^#"
        },
        "alt": true,
        "decorative": true,
        "title": true,
        "svgId": true
      },
      "additionalProperties": false
    },
    "Video": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "videoId": true,
        "userId": true,
        "posterImage": true,
        "videoType": {
          "type": "string",
          "enum": [
            "YOUTUBE",
            "VIMEO",
            "FACEBOOK",
            "DAILYMOTION"
          ]
        }
      },
      "additionalProperties": false
    },
    "VKShareButton": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "style": {
          "type": "string",
          "enum": [
            "Button",
            "ButtonWithoutCounter",
            "Link",
            "LinkWithoutIcon",
            "Icon"
          ]
        },
        "text": true,
        "isHttpsEnabled": true,
        "urlFormat": {
          "type": "string",
          "enum": [
            "hashBang",
            "slash"
          ]
        }
      },
      "additionalProperties": false
    },
    "ButtonWithIcon": {
      "type": "object",
      "properties": {
        "label": true,
        "toggleMode": true,
        "disabled": true,
        "iconSrc": true,
        "iconSize": true,
        "spriteOffset": true,
        "command": true,
        "commandParameter": true,
        "action": true
      },
      "additionalProperties": false
    },
    "EditorPreferences": {
      "type": "object",
      "properties": {
        "dontShowAgainTooltips": true,
        "dontShowAgainDialogs": true
      },
      "additionalProperties": false
    },
    "TPAWidget": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "applicationId": true,
        "appDefinitionId": true,
        "widgetId": true,
        "referenceId": true,
        "usesCssPerBreakpoint": true,
        "tpaData": true
      },
      "additionalProperties": false
    },
    "TPAData": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "content": true
      },
      "additionalProperties": false
    },
    "TPAGlobalData": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "content": true,
        "appDefinitionId": true
      },
      "additionalProperties": false
    },
    "TPA": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "applicationId": true,
        "appDefinitionId": true,
        "referenceId": true,
        "widgetId": true,
        "usesCssPerBreakpoint": true,
        "tpaData": true
      },
      "additionalProperties": false
    },
    "TPASection": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "applicationId": true,
        "referenceId": true,
        "usesCssPerBreakpoint": true,
        "tpaData": true
      },
      "additionalProperties": false
    },
    "TPAMultiSection": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "applicationId": true,
        "appDefinitionId": true,
        "widgetId": true,
        "referenceId": true,
        "usesCssPerBreakpoint": true,
        "tpaData": true
      },
      "additionalProperties": false
    },
    "RssButton": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "image": true,
        "link": {
          "type": [
            "null",
            "string"
          ],
          "pattern": "^$|^#"
        }
      },
      "additionalProperties": false
    },
    "AppPart": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "appInnerID": true,
        "appLogicParams": true,
        "appLogicCustomizations": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "fieldId": true,
              "forType": true,
              "format": true,
              "key": true,
              "type": true,
              "view": true,
              "mode": true,
              "value": true
            },
            "additionalProperties": false
          }
        },
        "appPartName": true,
        "viewName": true
      },
      "additionalProperties": false
    },
    "AppPartCustomization": {
      "type": "object",
      "properties": {
        "fieldId": true,
        "forType": true,
        "format": true,
        "key": true,
        "type": true,
        "view": true,
        "mode": true,
        "value": true
      },
      "additionalProperties": false
    },
    "AppPage": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "appPageId": true,
        "appInnerID": true,
        "appPageType": true,
        "repeaterPage": true,
        "title": true,
        "hideTitle": true,
        "icon": true,
        "windowTitle": true,
        "descriptionSEO": true,
        "advancedSeoData": true,
        "metaKeywordsSEO": true,
        "pageTitleSEO": true,
        "pageUriSEO": true,
        "hidePage": true,
        "underConstruction": true,
        "tpaApplicationId": true,
        "appDefinitionId": true,
        "managingAppDefId": true,
        "tpaPageId": true,
        "parentPageId": true,
        "pageSecurity": true,
        "indexable": true,
        "mobileHidePage": true,
        "pageBackgrounds": {
          "type": "object",
          "properties": {
            "desktop": {
              "type": "object",
              "properties": {
                "custom": true,
                "mediaSizing": {
                  "type": "string",
                  "enum": [
                    "document",
                    "viewport"
                  ]
                },
                "ref": true,
                "isPreset": true
              },
              "additionalProperties": false
            },
            "mobile": {
              "type": "object",
              "properties": {
                "custom": true,
                "mediaSizing": {
                  "type": "string",
                  "enum": [
                    "document",
                    "viewport"
                  ]
                },
                "ref": true,
                "isPreset": true
              },
              "additionalProperties": false
            }
          },
          "additionalProperties": false
        },
        "isLandingPage": true,
        "isMobileLandingPage": true,
        "isPopup": true,
        "translationData": {
          "type": "object",
          "properties": {
            "uriSEOTranslated": true
          },
          "additionalProperties": false
        },
        "ogImage": true,
        "ogImageRef": true,
        "ignoreBottomBottomAnchors": true,
        "cacheMode": {
          "enum": [
            "auto",
            "manual",
            "disabled"
          ]
        },
        "cacheMaxAgeHours": true
      },
      "additionalProperties": false
    },
    "AppBuilderComponent": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "appInnerID": true,
        "appPartName": true
      },
      "additionalProperties": false
    },
    "BoxSlideShow": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "direction": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        }
      },
      "additionalProperties": false
    },
    "BoxSlideShowSlide": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "title": true
      },
      "additionalProperties": false
    },
    "StripContainerSlideShow": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "direction": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        }
      },
      "additionalProperties": false
    },
    "StripContainerSlideShowSlide": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "title": true,
        "background": true
      },
      "additionalProperties": false
    },
    "VerticalAnchorsMenu": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "pageTopLabel": true,
        "pageBottomLabel": true,
        "hiddenAnchorIds": true,
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "bulletPosition": {
          "type": [
            "string"
          ],
          "enum": [
            "row",
            "rowReverse",
            "column",
            "columnReverse"
          ]
        }
      },
      "additionalProperties": false
    },
    "WFacebookComment": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "isHttpsEnabled": true,
        "urlFormat": {
          "type": "string",
          "enum": [
            "hashBang",
            "slash"
          ]
        }
      },
      "additionalProperties": false
    },
    "WFacebookLike": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "isHttpsEnabled": true,
        "urlFormat": {
          "type": "string",
          "enum": [
            "hashBang",
            "slash"
          ]
        }
      },
      "additionalProperties": false
    },
    "AppController": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "applicationId": true,
        "name": true,
        "controllerType": true,
        "settings": true,
        "externalId": true
      },
      "additionalProperties": false
    },
    "RepeaterA11y": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "label": true,
        "role": {
          "type": "string",
          "enum": [
            "region",
            "none",
            "radiogroup",
            "list",
            "group"
          ]
        }
      },
      "additionalProperties": false
    },
    "Repeater": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "direction": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "items": {
          "type": "array",
          "items": true
        },
        "a11y": true
      },
      "additionalProperties": false
    },
    "RepeatedData": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "original": true,
        "overrides": true
      },
      "additionalProperties": false
    },
    "ImageButtonWithText": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "label": true,
        "icon": true,
        "predefinedClass": true
      },
      "additionalProperties": false
    },
    "Icon": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "url": true,
        "width": true,
        "height": true,
        "title": true
      },
      "additionalProperties": false
    },
    "WidgetRef": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "appDefinitionId": true,
        "widgetId": true,
        "variationId": true,
        "name": true
      },
      "additionalProperties": false
    },
    "InternalRef": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "rootCompId": true,
        "pageId": true
      },
      "additionalProperties": false
    },
    "InternalBlocksRef": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "rootCompId": true,
        "pageId": true
      },
      "additionalProperties": false
    },
    "LightboxA11y": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "label": true
      },
      "additionalProperties": false
    },
    "LightboxContainer": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "a11y": true
      },
      "additionalProperties": false
    },
    "ContainerA11y": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "tabindex": true,
        "role": {
          "type": "string",
          "enum": [
            "region",
            "group",
            "none",
            "status",
            "alert",
            "nav",
            "list",
            "listitem",
            "tablist",
            "tab",
            "tabpanel",
            "menubar",
            "presentation",
            "heading"
          ]
        },
        "roledescription": true,
        "label": true,
        "level": true,
        "live": {
          "type": "string",
          "enum": [
            "polite",
            "assertive"
          ]
        },
        "atomic": true,
        "current": {
          "type": "string",
          "enum": [
            "step",
            "page",
            "true",
            "false"
          ]
        },
        "hidden": true,
        "relevant": {
          "type": "string",
          "enum": [
            "all",
            "additions",
            "text",
            "removals"
          ]
        }
      },
      "additionalProperties": false
    },
    "ContainerData": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "a11y": true
      },
      "additionalProperties": false
    },
    "MediaBoxData": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "a11y": true
      },
      "additionalProperties": false
    },
    "SlotsPlaceholderData": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "interfaces": {
          "type": "array",
          "items": true
        }
      },
      "additionalProperties": false
    },
    "LinkType": {
      "type": "string",
      "enum": [
        "SMS",
        "CALL",
        "SKYPE",
        "MAP",
        "EMAIL",
        "FACEBOOK",
        "FLICKR",
        "BLOGGER",
        "MYSPACE",
        "LINKEDIN",
        "TWITTER",
        "TUMBLR",
        "YOUTUBE",
        "VIMEO",
        "PAGE",
        "FREE_LINK",
        "TEXT",
        "DELICIOUS",
        "WEBSITE",
        "DOCUMENT",
        "ADMIN_LOGIN",
        "LOGIN"
      ]
    },
    "UrlFormat": {
      "type": "string",
      "enum": [
        "hashBang",
        "slash"
      ]
    },
    "MultiStateBoxDataA11y": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "label": true,
        "live": {
          "type": "string",
          "enum": [
            "polite",
            "assertive"
          ]
        },
        "tabindex": true,
        "role": {
          "type": "string",
          "enum": [
            "region",
            "group",
            "tablist",
            "tab",
            "tabpanel",
            "alert",
            "status",
            "list",
            "menubar",
            "presentation",
            "none",
            "nav",
            "listitem"
          ]
        },
        "atomic": true,
        "hidden": true,
        "current": {
          "type": "string",
          "enum": [
            "step",
            "page",
            "true",
            "false",
            "location",
            "date",
            "time"
          ]
        },
        "expanded": true,
        "relevant": true,
        "busy": true,
        "owns": true
      },
      "additionalProperties": false
    },
    "MultiStateBoxData": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "defaultStateId": true,
        "selectedStateId": true,
        "a11y": true
      },
      "additionalProperties": false
    },
    "AppsInstallState": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "stateMap": {
          "type": "object",
          "properties": {},
          "additionalProperties": {
            "type": "object",
            "properties": {
              "status": {
                "type": "string",
                "enum": [
                  "INSTALLED",
                  "REMOVED"
                ]
              },
              "version": true
            }
          }
        }
      },
      "additionalProperties": false
    },
    "StateBoxA11y": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "label": true,
        "live": {
          "type": "string",
          "enum": [
            "polite",
            "assertive"
          ]
        },
        "tabindex": true,
        "role": {
          "type": "string",
          "enum": [
            "region",
            "group",
            "tablist",
            "tab",
            "tabpanel",
            "alert",
            "status",
            "list",
            "menubar",
            "presentation",
            "none",
            "nav",
            "listitem"
          ]
        },
        "atomic": true,
        "hidden": true,
        "current": {
          "type": "string",
          "enum": [
            "step",
            "page",
            "true",
            "false",
            "location",
            "date",
            "time"
          ]
        },
        "expanded": true,
        "relevant": true,
        "busy": true,
        "owns": true
      },
      "additionalProperties": false
    },
    "StateBox": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "a11y": true
      },
      "additionalProperties": false
    },
    "StateBoxStateA11y": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "label": true,
        "live": {
          "type": "string",
          "enum": [
            "polite",
            "assertive"
          ]
        },
        "tabindex": true,
        "role": {
          "type": "string",
          "enum": [
            "region",
            "group",
            "tablist",
            "tab",
            "tabpanel",
            "alert",
            "status",
            "list",
            "menubar",
            "presentation",
            "none",
            "nav",
            "listitem"
          ]
        },
        "atomic": true,
        "hidden": true,
        "current": {
          "type": "string",
          "enum": [
            "step",
            "page",
            "true",
            "false",
            "location",
            "date",
            "time"
          ]
        },
        "expanded": true,
        "relevant": true,
        "busy": true,
        "owns": true
      },
      "additionalProperties": false
    },
    "StateBoxState": {
      "type": "object",
      "properties": {
        "a11y": true
      },
      "additionalProperties": false
    },
    "Builder.MenuItem": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "link": {
          "type": [
            "null",
            "string"
          ],
          "pattern": "^$|^#"
        },
        "items": {
          "type": [
            "array",
            "null"
          ],
          "items": true
        },
        "container": true,
        "label": true,
        "isVisible": true
      },
      "additionalProperties": false
    },
    "Builder.MenuItems": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "name": true,
        "items": {
          "type": [
            "array",
            "null"
          ],
          "items": true
        }
      },
      "additionalProperties": false
    },
    "Builder.Image": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "uri": true,
        "name": true,
        "width": true,
        "height": true
      },
      "additionalProperties": false
    },
    "Builder.Video": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "uri": true,
        "sources": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "quality": {
                "type": "string",
                "enum": [
                  "1080p",
                  "720p",
                  "480p",
                  "360p"
                ]
              },
              "width": true,
              "height": true,
              "types": {
                "type": "array",
                "items": {
                  "type": "object",
                  "properties": {
                    "format": {
                      "type": "string",
                      "enum": [
                        "mp4",
                        "mp4-luminance"
                      ]
                    },
                    "uri": true
                  },
                  "additionalProperties": false
                }
              }
            },
            "additionalProperties": false
          }
        },
        "adaptiveSources": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "format": {
                "type": "string",
                "enum": [
                  "hls",
                  "dash"
                ]
              },
              "uri": true
            },
            "additionalProperties": false
          }
        },
        "hasAudio": true,
        "fps": true,
        "poster": true,
        "duration": true
      },
      "additionalProperties": false
    },
    "Builder.VectorArt": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "uri": true
      },
      "additionalProperties": false
    },
    "Builder.RichText": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "text": true,
        "linkList": {
          "type": [
            "array",
            "null"
          ],
          "items": true
        }
      },
      "additionalProperties": false
    },
    "mobui.MobuiButton": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "contentType": {
          "type": "string",
          "enum": [
            "Text",
            "Icon",
            "Text and icon"
          ]
        },
        "label": true,
        "icon": true,
        "iconPosition": {
          "type": "string",
          "enum": [
            "Left",
            "Right"
          ]
        },
        "buttonType": {
          "type": "string",
          "enum": [
            "Full",
            "Outline",
            "Link"
          ]
        },
        "size": {
          "type": "string",
          "enum": [
            "Small",
            "Medium",
            "Large"
          ]
        }
      },
      "additionalProperties": false
    },
    "mobui.MobuiDatePicker": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "label": true,
        "initialText": {
          "type": "string",
          "enum": [
            "today's date",
            "placeholder"
          ]
        },
        "placeholder": true,
        "icon": true,
        "fieldType": {
          "type": "string",
          "enum": [
            "form",
            "settings",
            "filter"
          ]
        },
        "pickerType": {
          "type": "string",
          "enum": [
            "wheel",
            "calendar"
          ]
        },
        "pickerTitle": true,
        "showPastDates": true,
        "showFutureDates": true,
        "wheelMode": {
          "type": "string",
          "enum": [
            "DD/MM/YY",
            "MM/YY"
          ]
        },
        "firstDay": {
          "type": "string",
          "enum": [
            "Sunday",
            "Monday"
          ]
        },
        "disabledDaysOfWeek": {
          "type": [
            "array"
          ],
          "items": true
        },
        "enabledDateRanges": {
          "type": [
            "array"
          ],
          "items": true
        },
        "disabledDateRanges": {
          "type": [
            "array"
          ],
          "items": true
        },
        "readOnly": true,
        "required": true,
        "requiredErrorMessage": true,
        "validateOnStart": true,
        "validateOnChange": true,
        "disabledDates": {
          "type": [
            "array"
          ],
          "items": true
        },
        "minDate": true,
        "maxDate": true,
        "timeZone": true
      },
      "additionalProperties": false
    },
    "defaultItemSchemaType": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "label": true,
        "value": true,
        "disabled": true,
        "isDefault": true,
        "unavailable": true
      },
      "additionalProperties": false
    },
    "MobuiDateRangeType": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "label": true,
        "value": true,
        "disabled": true,
        "isDefault": true,
        "unavailable": true,
        "startDate": true,
        "endDate": true
      },
      "additionalProperties": false
    },
    "mobui.MobuiImage": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "src": true,
        "isExternalSource": true,
        "resizeMode": {
          "type": "string",
          "enum": [
            "cover",
            "contain",
            "stretch",
            "repeat",
            "center"
          ]
        }
      },
      "additionalProperties": false
    },
    "mobui.MobuiPicker": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "fieldType": {
          "type": "string",
          "enum": [
            "form",
            "filter",
            "settings"
          ]
        },
        "label": true,
        "placeholder": true,
        "pickerType": {
          "type": "string",
          "enum": [
            "fullScreen",
            "dialog"
          ]
        },
        "optionsDialogTitle": true,
        "optionsDialogSubtitle": true,
        "hasItemSubtitle": true,
        "isMultiselect": true,
        "selectionLimit": true,
        "hasSearchBar": true,
        "readOnly": true,
        "requiredErrorMessage": true,
        "validateOnStart": true,
        "validateOnChange": true,
        "validateOnBlur": true,
        "options": {
          "type": [
            "array"
          ],
          "items": true
        }
      },
      "additionalProperties": false
    },
    "MobuiPickerItemType": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "label": true,
        "value": true,
        "disabled": true,
        "isDefault": true,
        "unavailable": true,
        "subtitle": true,
        "isSelected": true
      },
      "additionalProperties": false
    },
    "mobui.MobuiSwitch": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "value": true
      },
      "additionalProperties": false
    },
    "mobui.MobuiText": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "text": true,
        "selectable": true
      },
      "additionalProperties": false
    },
    "mobui.MobuiTextInput": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "inputType": {
          "type": "string",
          "enum": [
            "text",
            "password",
            "phone",
            "email",
            "url",
            "number"
          ]
        },
        "label": true,
        "placeholder": true,
        "initialValue": true,
        "hasCharLimit": true,
        "maxInputLength": true,
        "prefixValue": true,
        "suffixValue": true,
        "requiredErrorMessage": true,
        "validatorErrorMessageValue": true,
        "validatorType": {
          "type": "string",
          "enum": [
            "none",
            "number",
            "email",
            "url",
            "required"
          ]
        },
        "textContentType": true,
        "autoComplete": true,
        "validateOnStart": true,
        "validateOnChange": true,
        "validateOnBlur": true
      },
      "additionalProperties": false
    },
    "mobui.MobuiVideoPlayer": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "title": true,
        "src": true,
        "poster": true,
        "isPlaying": true,
        "muteOnStart": true,
        "playInLoop": true,
        "enableFullScreen": true,
        "enableCasting": true,
        "showVideoSettings": true
      },
      "additionalProperties": false
    },
    "mobui.MobuiMultiStateBoxData": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "defaultStateId": true,
        "selectedStateId": true
      },
      "additionalProperties": false
    },
    "wixui.ExternalComponent": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "url": true,
        "compProps": true,
        "isTrusted": true,
        "importKey": true
      },
      "additionalProperties": false
    },
    "wixui.HamburgerOverlay": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "showBackgroundOverlay": true,
        "tapOutsideToClose": true,
        "isMenuContainerFullscreen": true
      },
      "additionalProperties": false
    },
    "wixui.Logo": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "isLoadingData": true,
        "logoId": true,
        "alt": true,
        "link": {
          "type": [
            "null",
            "string"
          ],
          "pattern": "^$|^#"
        },
        "preset": true,
        "hasBackground": true,
        "brandId": true,
        "backgroundColor": true,
        "logoUrl": true
      },
      "additionalProperties": false
    },
    "wixui.LottieEmbed": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "animationUrl": true,
        "speed": true,
        "loop": true,
        "autoplay": true,
        "alt": true,
        "isDecorative": true,
        "showPlaybackControl": true
      },
      "additionalProperties": false
    },
    "wixui.ProductSpecification": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "items": {
          "type": [
            "array"
          ],
          "items": true
        }
      },
      "additionalProperties": false
    },
    "wixui.RangeSlider": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "label": true,
        "sliderType": {
          "type": "string",
          "enum": [
            "Continuous",
            "Stepped"
          ]
        },
        "stepType": {
          "type": "string",
          "enum": [
            "Number",
            "Value"
          ]
        },
        "step": true,
        "direction": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl"
          ]
        },
        "rootDirection": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "labelDirection": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "sliderDirection": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "min": true,
        "max": true,
        "prefix": true,
        "suffix": true,
        "minValue": true,
        "maxValue": true,
        "thumbShape": {
          "type": "string",
          "enum": [
            "Circle",
            "Square",
            "Rectangle",
            "Bar"
          ]
        },
        "marksTickShape": {
          "type": "string",
          "enum": [
            "Lines",
            "Dots"
          ]
        },
        "thumbSize": true,
        "readOnly": true,
        "accessibleName": true
      },
      "additionalProperties": false
    },
    "wixui.Rive": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "animationFileUrl": true,
        "thumbnailFileUrl": true,
        "artboard": true,
        "stateMachine": true,
        "fit": true,
        "alignment": true,
        "isAutoPlayOn": true,
        "isTouchScrollEnabled": true,
        "alt": true,
        "fileName": true,
        "isDecorative": true
      },
      "additionalProperties": false
    },
    "wixui.ShareButtons": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "buttons": {
          "type": [
            "array"
          ],
          "items": true
        },
        "pageToShare": true,
        "shareUrl": true,
        "direction": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        }
      },
      "additionalProperties": false
    },
    "IShareButton": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "label": true,
        "value": true,
        "disabled": true,
        "isDefault": true,
        "unavailable": true,
        "platformId": true,
        "illustration": true,
        "isHidden": true
      },
      "additionalProperties": false
    },
    "wixui.SingleTab": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "tabId": true,
        "label": true,
        "isParentStretched": true
      },
      "additionalProperties": false
    },
    "AccordionContainerData": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "items": {
          "type": "array",
          "items": {
            "type": [
              "object"
            ],
            "properties": {
              "id": true,
              "label": true
            },
            "additionalProperties": false
          }
        }
      },
      "additionalProperties": false
    },
    "AccordionItemData": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "isParentStretched": true
      },
      "additionalProperties": false
    },
    "AddressInput": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "labelDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "inputDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "optionsDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "locale": true,
        "googleMapsApiKey": true,
        "filter": {
          "type": "object",
          "properties": {
            "country": true
          },
          "additionalProperties": false
        },
        "sorting": {
          "type": "object",
          "properties": {
            "location": {
              "type": "object",
              "properties": {
                "lat": true,
                "lng": true
              },
              "additionalProperties": false
            },
            "radius": true,
            "formatted": true
          },
          "additionalProperties": false
        },
        "placeholder": true,
        "label": true
      },
      "additionalProperties": false
    },
    "BoltComponentData": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true
      },
      "additionalProperties": false,
      "anyOf": [
        {
          "properties": {},
          "additionalProperties": false
        }
      ]
    },
    "BreadcrumbsData": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "svgId": true,
        "menuRef": true,
        "a11y": true,
        "direction": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "itemDirection": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "submenuDirection": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "submenuSubItemDirection": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        }
      },
      "additionalProperties": false
    },
    "Captcha": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "captchaType": {
          "type": "string",
          "enum": [
            "image",
            "audio"
          ]
        }
      },
      "additionalProperties": false
    },
    "CollapsibleTextData": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "text": true,
        "readMoreText": true,
        "readLessText": true,
        "link": {
          "type": [
            "null",
            "string"
          ],
          "pattern": "^$|^#"
        },
        "linkText": true,
        "textDescription": true,
        "tag": true,
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "textDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "buttonDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        }
      },
      "additionalProperties": false
    },
    "ComboBoxInputData": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "direction": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "labelDirection": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "inputDirection": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "dropdownDirection": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "errorDirection": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "options": {
          "type": [
            "array",
            "null"
          ],
          "items": true
        },
        "label": true,
        "placeholder": {
          "type": "object",
          "properties": {
            "value": true,
            "text": true
          },
          "additionalProperties": false
        },
        "value": true,
        "name": true,
        "formGroup": true
      },
      "additionalProperties": false
    },
    "CustomElement": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "tagName": true,
        "url": true,
        "hostedInCorvid": true,
        "initialAttributes": true,
        "shouldReload": true,
        "scriptType": {
          "type": "string",
          "enum": [
            "none",
            "module"
          ]
        },
        "appDefinitionId": true,
        "widgetId": true
      },
      "additionalProperties": false
    },
    "wixui.FastGallery": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "items": {
          "type": [
            "array"
          ],
          "items": true
        },
        "itemClickAction": {
          "type": "string",
          "enum": [
            "ACTION",
            "LINK",
            "NOTHING"
          ]
        },
        "downloadProtection": true,
        "wixSDKItems": {
          "type": [
            "array"
          ],
          "items": true
        }
      },
      "additionalProperties": false
    },
    "wixui.HamburgerMenuContainer": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true
      },
      "additionalProperties": false
    },
    "wixui.HamburgerMenuRoot": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true
      },
      "additionalProperties": false
    },
    "ImageX": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "image": {
          "type": "object",
          "properties": {
            "uri": true,
            "alt": true,
            "name": true,
            "height": true,
            "width": true,
            "decorative": true
          },
          "additionalProperties": false
        },
        "link": true,
        "scopedData": {
          "type": [
            "null",
            "array"
          ],
          "items": {
            "type": "object",
            "properties": {
              "breakpoint": true,
              "crop": {
                "type": "object",
                "properties": {
                  "x": true,
                  "y": true,
                  "width": true,
                  "height": true,
                  "svgId": true,
                  "rotate": true,
                  "flip": {
                    "type": "string",
                    "enum": [
                      "x",
                      "y",
                      "xy",
                      "none"
                    ]
                  }
                },
                "additionalProperties": false
              },
              "focalPoint": {
                "type": "object",
                "properties": {
                  "x": true,
                  "y": true
                },
                "additionalProperties": false
              },
              "displayMode": {
                "type": "string",
                "enum": [
                  "fill",
                  "fit",
                  "fitWidth"
                ]
              },
              "scrollEffect": {
                "type": "string",
                "enum": [
                  "parallax",
                  "fixed",
                  "zoomIn",
                  "fadeIn",
                  "none"
                ]
              },
              "clickAction": {
                "type": "string",
                "enum": [
                  "none",
                  "goToLink"
                ]
              }
            },
            "additionalProperties": false
          }
        },
        "mask": {
          "type": [
            "object",
            "null"
          ],
          "properties": {
            "x": true,
            "y": true,
            "width": true,
            "height": true,
            "svgId": true,
            "flip": {
              "type": "string",
              "enum": [
                "x",
                "y",
                "xy",
                "none"
              ]
            },
            "rotate": true,
            "mode": {
              "type": "string",
              "enum": [
                "alpha",
                "luminance"
              ]
            }
          },
          "additionalProperties": false
        },
        "parallaxSpeed": true,
        "parallaxDirection": {
          "type": "string",
          "enum": [
            "normal",
            "reverse"
          ]
        },
        "hasAnimation": true
      },
      "additionalProperties": false
    },
    "Crop": {
      "type": "object",
      "properties": {
        "x": true,
        "y": true,
        "width": true,
        "height": true,
        "svgId": true,
        "rotate": true,
        "flip": {
          "type": "string",
          "enum": [
            "x",
            "y",
            "xy",
            "none"
          ]
        }
      },
      "additionalProperties": false
    },
    "FocalPoint": {
      "type": "object",
      "properties": {
        "x": true,
        "y": true
      },
      "additionalProperties": false
    },
    "LanguageSelector": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        }
      },
      "additionalProperties": false
    },
    "wixui.MegaMenuContainerItem": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true
      },
      "additionalProperties": false
    },
    "MenuData": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "direction": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "itemDirection": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "submenuDirection": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "submenuItemDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "submenuSubItemDirection": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "navAriaLabel": true,
        "menuRef": true,
        "a11y": true
      },
      "additionalProperties": false
    },
    "wixui.MenuList": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "menus": {
          "type": [
            "array"
          ],
          "items": true
        }
      },
      "additionalProperties": false
    },
    "MusicPlayerData": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "coverDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "textDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "audioRef": true,
        "audioUrl": true,
        "playListId": true,
        "playlist": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "artistName": true,
              "trackName": true,
              "url": true,
              "cover": true,
              "durationFormatted": true
            },
            "additionalProperties": false
          }
        },
        "coverRef": true,
        "coverUrl": true,
        "artistName": true,
        "trackName": true,
        "description": true
      },
      "additionalProperties": false
    },
    "WixAudio": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "uri": true,
        "title": true,
        "duration": true
      },
      "additionalProperties": false
    },
    "Pagination": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "totalPages": true,
        "currentPage": true,
        "nextText": true,
        "previousText": true,
        "firstText": true,
        "lastText": true,
        "nextAriaLabel": true,
        "previousAriaLabel": true,
        "firstAriaLabel": true,
        "lastAriaLabel": true,
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "a11y": true
      },
      "additionalProperties": false
    },
    "PaginationA11y": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "label": true
      },
      "additionalProperties": false
    },
    "ProgressBar": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "value": true,
        "targetValue": true,
        "label": true,
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "labelDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "barDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        }
      },
      "additionalProperties": false
    },
    "RatingsDisplay": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "labelDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "ratingsDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "rating": true,
        "svgId": true,
        "numRatings": true,
        "reviewsCountLabel": true,
        "noReviewsPlaceholder": true
      },
      "additionalProperties": false
    },
    "RatingsInput": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "value": true,
        "titleText": true,
        "svgId": true,
        "labels": true,
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        }
      },
      "additionalProperties": false
    },
    "wixui.RichContentViewer": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "content": true,
        "trimEnabled": true,
        "trimMode": true,
        "trimLengthParagraph": true,
        "trimLengthWord": true,
        "trimExclude": true,
        "trimEllipsisEnabled": true,
        "trimEllipsisExpandText": true,
        "trimEllipsisCollapseText": true
      },
      "additionalProperties": false
    },
    "RichTextBox": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "maxLength": true,
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "labelDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "inputDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "value": true,
        "name": true,
        "formGroup": true
      },
      "additionalProperties": false
    },
    "SearchBox": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "placeholder": true,
        "suggestionsEnabled": true,
        "clearButtonText": true,
        "displaySettingsToggles": true
      },
      "additionalProperties": false
    },
    "Section": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "a11y": true
      },
      "additionalProperties": false
    },
    "SectionA11y": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "tabindex": true,
        "label": true,
        "live": {
          "type": "string",
          "enum": [
            "polite",
            "assertive"
          ]
        },
        "role": {
          "type": "string",
          "enum": [
            "heading",
            "alert",
            "status"
          ]
        },
        "atomic": true,
        "hidden": true,
        "current": {
          "type": "string",
          "enum": [
            "step",
            "page",
            "true",
            "false",
            "location",
            "date",
            "time"
          ]
        },
        "level": true
      },
      "additionalProperties": false
    },
    "wixui.SelectableContainer": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true
      },
      "additionalProperties": false
    },
    "wixui.SelectableContainerInput": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true
      },
      "additionalProperties": false
    },
    "SelectionTagsList": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "options": {
          "type": [
            "array"
          ],
          "items": true
        },
        "value": {
          "type": "array",
          "items": true
        },
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "labelDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "inputDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        }
      },
      "additionalProperties": false
    },
    "SelectionTag": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "value": true,
        "label": true,
        "link": true,
        "rel": {
          "type": "string",
          "enum": [
            "nofollow"
          ]
        }
      },
      "additionalProperties": false
    },
    "SignatureInput": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "titleText": true,
        "clearButtonText": true,
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "labelDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "inputDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "buttonDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "radioButtonsDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        }
      },
      "additionalProperties": false
    },
    "SiteButtonData": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "direction": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "link": {
          "type": [
            "null",
            "string"
          ],
          "pattern": "^$|^#"
        },
        "label": true,
        "a11y": true
      },
      "additionalProperties": false
    },
    "Slider": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "labelDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "trackDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "tooltipDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "min": true,
        "max": true,
        "value": true,
        "step": true,
        "stepType": {
          "type": "string",
          "enum": [
            "value",
            "count"
          ]
        },
        "disabled": true,
        "readOnly": true,
        "label": true
      },
      "additionalProperties": false
    },
    "wixui.Slideshow": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "direction": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        }
      },
      "additionalProperties": false
    },
    "SocialAuth": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true
      },
      "additionalProperties": false
    },
    "StylableButton": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "link": true,
        "label": true,
        "svgId": true,
        "isIconAnimated": true,
        "animatedIcon": {
          "type": "object",
          "properties": {
            "svgIdAnimationSelected": true,
            "customAnimatedIcon": {
              "type": [
                "object"
              ],
              "properties": {
                "svgIdAnimationStart": true,
                "svgIdAnimationEnd": true,
                "svgIdAnimationSelected": true
              },
              "additionalProperties": false
            },
            "animationDuration": true
          },
          "additionalProperties": false
        },
        "a11y": true,
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        }
      },
      "additionalProperties": false
    },
    "StylableButtonA11y": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "tabindex": true,
        "pressed": true,
        "expanded": true,
        "disabled": true,
        "haspopup": {
          "type": "string",
          "enum": [
            "true",
            "false",
            "dialog",
            "menu"
          ]
        },
        "label": true,
        "live": {
          "type": "string",
          "enum": [
            "polite",
            "assertive"
          ]
        }
      },
      "additionalProperties": false
    },
    "Submenu": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "itemDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "subItemDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        }
      },
      "additionalProperties": false
    },
    "SvgImage": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "decorative": true,
        "alt": true,
        "displayMode": {
          "type": "string",
          "enum": [
            "fit",
            "stretch"
          ]
        },
        "svgId": true,
        "link": {
          "type": [
            "null",
            "string"
          ],
          "pattern": "^$|^#"
        }
      },
      "additionalProperties": false
    },
    "wixui.Tabs": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "tabIds": {
          "type": "array",
          "items": true
        },
        "defaultTabId": true,
        "a11y": true,
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        }
      },
      "additionalProperties": false
    },
    "TabsA11y": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "tabindex": true,
        "label": true
      },
      "additionalProperties": false
    },
    "TextEffectsSharedData": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "text": true,
        "link": {
          "type": [
            "null",
            "string"
          ],
          "pattern": "^$|^#"
        },
        "isDecorative": true,
        "tagName": {
          "type": "string",
          "enum": [
            "h1",
            "h2",
            "h3",
            "h4",
            "h5",
            "h6",
            "blockquote",
            "div",
            "p"
          ]
        },
        "textDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "patternScope": {
          "type": "string",
          "enum": [
            "none",
            "character",
            "word"
          ]
        }
      },
      "additionalProperties": false
    },
    "TextMarqueeData": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "movementDirection": {
          "type": "string",
          "enum": [
            "rtl",
            "ltr"
          ]
        },
        "speed": true,
        "pauseOnHover": true,
        "textDirection": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl"
          ]
        },
        "headingLevel": true,
        "isDecorative": true,
        "tagName": {
          "type": "string",
          "enum": [
            "h1",
            "h2",
            "h3",
            "h4",
            "h5",
            "h6",
            "blockquote",
            "div",
            "p"
          ]
        },
        "svgId": true,
        "items": {
          "type": [
            "array"
          ],
          "items": true
        }
      },
      "additionalProperties": false
    },
    "TextMarqueeItem": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "link": {
          "type": [
            "null",
            "string"
          ],
          "pattern": "^$|^#"
        },
        "text": true
      },
      "additionalProperties": false
    },
    "TextFxData": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "text": true,
        "headingLevel": true,
        "isDecorative": true,
        "direction": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl"
          ]
        },
        "link": {
          "type": [
            "null",
            "string"
          ],
          "pattern": "^$|^#"
        },
        "tagName": {
          "type": "string",
          "enum": [
            "h1",
            "h2",
            "h3",
            "h4",
            "h5",
            "h6",
            "blockquote",
            "div",
            "p"
          ]
        }
      },
      "additionalProperties": false
    },
    "TextOnPathData": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "isDecorative": true,
        "text": true,
        "path": true,
        "pathLength": true,
        "viewBox": true,
        "speed": true,
        "movementDirection": {
          "type": "string",
          "enum": [
            "forward",
            "reverse"
          ]
        },
        "pauseOnHover": true,
        "direction": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl"
          ]
        },
        "tagName": {
          "type": "string",
          "enum": [
            "h1",
            "h2",
            "h3",
            "h4",
            "h5",
            "h6",
            "blockquote",
            "div"
          ]
        },
        "fillMode": {
          "type": "string",
          "enum": [
            "normal",
            "repeat",
            "justify"
          ]
        },
        "link": {
          "type": [
            "null",
            "string"
          ],
          "pattern": "^$|^#"
        },
        "startOffset": true,
        "fontSize": true,
        "pathStrokeWidth": true
      },
      "additionalProperties": false
    },
    "TimePickerData": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "labelDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "inputDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "placeholder": true,
        "step": true,
        "label": true,
        "margin": true,
        "disabledTimes": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "startTime": true,
              "endTime": true
            },
            "additionalProperties": false
          }
        },
        "value": true,
        "name": true,
        "formGroup": true
      },
      "additionalProperties": false
    },
    "ToggleSwitch": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "checked": true,
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "value": true,
        "name": true,
        "formGroup": true
      },
      "additionalProperties": false
    },
    "UnsupportedComponentData": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "migratedFrom": true
      },
      "additionalProperties": false
    },
    "VideoPlayer": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "videoType": {
          "type": "string",
          "enum": [
            "dailymotion",
            "facebook",
            "file",
            "twitch",
            "vimeo",
            "youtube"
          ]
        },
        "videoRef": true,
        "videoUrl": true,
        "posterUrl": true,
        "videoTitle": true,
        "description": true,
        "logoRef": true
      },
      "additionalProperties": false
    },
    "dsgnsys.ControlTypes": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "shortString": true,
        "longString": true,
        "options": {
          "type": [
            "array"
          ],
          "items": true
        },
        "dropdown": {
          "type": "string",
          "enum": [
            "Options 1",
            "Options 2",
            "Options 3",
            "Options 4"
          ]
        },
        "radioButtons": {
          "type": "string",
          "enum": [
            "Options 1",
            "Options 2",
            "Options 3",
            "Options 4"
          ]
        },
        "toggleSwitch": true,
        "thumbnails": true,
        "link": {
          "type": [
            "null",
            "string"
          ],
          "pattern": "^$|^#"
        },
        "slider": true,
        "numericInput": true,
        "colorPickerInput": true,
        "selectedFont": true
      },
      "additionalProperties": false
    },
    "dsgnsys.DashboardButton": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "label": true,
        "link": {
          "type": [
            "null",
            "string"
          ],
          "pattern": "^$|^#"
        },
        "skin": {
          "type": "string",
          "enum": [
            "Standard",
            "Light",
            "Destructive",
            "Premium",
            "Premium light",
            "Dark",
            "Transparent"
          ]
        },
        "showPrefix": true,
        "prefixIcon": true,
        "showSuffix": true,
        "suffixIcon": true,
        "disabled": true,
        "size": {
          "type": "string",
          "enum": [
            "Tiny",
            "Small",
            "Medium",
            "Large"
          ]
        },
        "priority": {
          "type": "string",
          "enum": [
            "Primary",
            "Secondary"
          ]
        }
      },
      "additionalProperties": false
    },
    "dsgnsys.DashboardHeading": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "text": true,
        "size": {
          "type": "string",
          "enum": [
            "Page title H1",
            "Modal title H2",
            "Card title H3",
            "Section title H4",
            "Card section title H5",
            "Caption H6"
          ]
        },
        "invertColor": true,
        "textAlignment": {
          "type": "string",
          "enum": [
            "Left",
            "Center",
            "Right"
          ]
        }
      },
      "additionalProperties": false
    },
    "dsgnsys.DashboardIconButton": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "icon": true,
        "tooltip": true,
        "link": {
          "type": [
            "null",
            "string"
          ],
          "pattern": "^$|^#"
        },
        "skin": {
          "type": "string",
          "enum": [
            "Standard",
            "Premium",
            "Light",
            "Transparent"
          ]
        },
        "disabled": true,
        "size": {
          "type": "string",
          "enum": [
            "Tiny",
            "Small",
            "Medium",
            "Large"
          ]
        },
        "priority": {
          "type": "string",
          "enum": [
            "Primary",
            "Secondary"
          ]
        }
      },
      "additionalProperties": false
    },
    "dsgnsys.DashboardInfoIcon": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "tooltip": true,
        "addLink": true,
        "tooltipLinkText": true,
        "tooltipLink": {
          "type": [
            "null",
            "string"
          ],
          "pattern": "^$|^#"
        },
        "size": {
          "type": "string",
          "enum": [
            "Small",
            "Medium"
          ]
        }
      },
      "additionalProperties": false
    },
    "dsgnsys.DashboardInput": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "label": true,
        "placeholder": true,
        "value": true,
        "showTooltip": true,
        "tooltip": true,
        "showPrefix": true,
        "prefixType": {
          "type": "string",
          "enum": [
            "Icon",
            "Text"
          ]
        },
        "prefixIcon": true,
        "prefixValue": true,
        "showSuffix": true,
        "suffixType": {
          "type": "string",
          "enum": [
            "Icon",
            "Text"
          ]
        },
        "suffixIcon": true,
        "suffixValue": true,
        "required": true,
        "setMaxLength": true,
        "maxLength": true,
        "disabled": true,
        "readOnly": true,
        "size": {
          "type": "string",
          "enum": [
            "Small",
            "Medium",
            "Large"
          ]
        },
        "border": {
          "type": "string",
          "enum": [
            "Default",
            "Round",
            "Line",
            "None"
          ]
        },
        "labelPosition": {
          "type": "string",
          "enum": [
            "Top",
            "Left",
            "Right"
          ]
        }
      },
      "additionalProperties": false
    },
    "dsgnsys.DashboardNumberInput": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "label": true,
        "placeholder": true,
        "value": true,
        "showTooltip": true,
        "tooltip": true,
        "showPrefix": true,
        "prefixType": {
          "type": "string",
          "enum": [
            "Icon",
            "Text"
          ]
        },
        "prefixIcon": true,
        "prefixValue": true,
        "showSuffix": true,
        "suffixType": {
          "type": "string",
          "enum": [
            "Icon",
            "Text"
          ]
        },
        "suffixIcon": true,
        "suffixValue": true,
        "required": true,
        "minAndMaxValues": true,
        "min": true,
        "max": true,
        "stepSize": true,
        "disabled": true,
        "readOnly": true,
        "size": {
          "type": "string",
          "enum": [
            "Small",
            "Medium",
            "Large"
          ]
        },
        "border": {
          "type": "string",
          "enum": [
            "Default",
            "Round",
            "Line",
            "None"
          ]
        },
        "labelPlacement": {
          "type": "string",
          "enum": [
            "Top",
            "Left",
            "Right"
          ]
        }
      },
      "additionalProperties": false
    },
    "dsgnsys.DashboardText": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "text": true,
        "preset": {
          "type": "string",
          "enum": [
            "Standard",
            "Standard secondary",
            "Light",
            "Light secondary",
            "Success",
            "Destructive",
            "Primary",
            "Premium",
            "Disabled"
          ]
        },
        "size": {
          "type": "string",
          "enum": [
            "Tiny",
            "Small",
            "Medium"
          ]
        },
        "weight": {
          "type": "string",
          "enum": [
            "Bold",
            "Normal",
            "Thin"
          ]
        },
        "textAlignment": {
          "type": "string",
          "enum": [
            "Left",
            "Center",
            "Right"
          ]
        },
        "overflow": {
          "type": "string",
          "enum": [
            "Wrap",
            "Ellipsis"
          ]
        },
        "maxLines": true
      },
      "additionalProperties": false
    },
    "dsgnsys.DashboardTextButton": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "label": true,
        "link": {
          "type": [
            "null",
            "string"
          ],
          "pattern": "^$|^#"
        },
        "skin": {
          "type": "string",
          "enum": [
            "Standard",
            "Premium",
            "Light",
            "Dark",
            "Destructive"
          ]
        },
        "showPrefix": true,
        "prefixIcon": true,
        "showSuffix": true,
        "suffixIcon": true,
        "underline": {
          "type": "string",
          "enum": [
            "Never",
            "On hover",
            "Always"
          ]
        },
        "disabled": true,
        "size": {
          "type": "string",
          "enum": [
            "Tiny",
            "Small",
            "Medium"
          ]
        },
        "weight": {
          "type": "string",
          "enum": [
            "Regular",
            "Medium"
          ]
        }
      },
      "additionalProperties": false
    },
    "dsgnsys.DashboardToggleSwitch": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "label": true,
        "checked": true,
        "skin": {
          "type": "string",
          "enum": [
            "Standard",
            "Success",
            "Destructive"
          ]
        },
        "showTooltip": true,
        "tooltip": true,
        "disabled": true,
        "size": {
          "type": "string",
          "enum": [
            "Small",
            "Medium",
            "Large"
          ]
        },
        "labelPosition": {
          "type": "string",
          "enum": [
            "Top",
            "Left",
            "Right"
          ]
        }
      },
      "additionalProperties": false
    },
    "dsgnsys.SettingsPanelContainer": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "theme": {
          "type": "string",
          "enum": [
            "classic",
            "responsive"
          ]
        },
        "debug": true
      },
      "additionalProperties": false
    },
    "dsgnsys.WbuAccordion": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "label": true,
        "tooltip": true,
        "openByDefault": true
      },
      "additionalProperties": false
    },
    "dsgnsys.WbuBackButton": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "label": true
      },
      "additionalProperties": false
    },
    "dsgnsys.WbuButton": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "fieldTitle": true,
        "tooltipInfo": true,
        "label": true,
        "skin": {
          "type": "string",
          "enum": [
            "standard",
            "standard secondary",
            "premium",
            "premium secondary",
            "alert",
            "alert secondary",
            "inverted"
          ]
        },
        "size": {
          "type": "string",
          "enum": [
            "small",
            "medium",
            "large"
          ]
        },
        "prefixIcon": true,
        "suffixIcon": true,
        "fullWidth": true,
        "divider": {
          "type": "string",
          "enum": [
            "long",
            "short",
            "none"
          ]
        }
      },
      "additionalProperties": false
    },
    "dsgnsys.WbuCheckboxGroup": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "fieldTitle": true,
        "options": {
          "type": [
            "array"
          ],
          "items": true
        },
        "tooltipInfo": true,
        "divider": {
          "type": "string",
          "enum": [
            "long",
            "short",
            "none"
          ]
        }
      },
      "additionalProperties": false
    },
    "dsgnsys.WbuColorPicker": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "label": true,
        "tooltip": true,
        "opacity": true,
        "showPercentage": true,
        "opacitySliderEnabled": true,
        "color": true,
        "divider": {
          "type": "string",
          "enum": [
            "long",
            "short",
            "none"
          ]
        }
      },
      "additionalProperties": false
    },
    "dsgnsys.WbuColorSelector": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "label": true,
        "color": true,
        "divider": {
          "type": "string",
          "enum": [
            "long",
            "short",
            "none"
          ]
        }
      },
      "additionalProperties": false
    },
    "dsgnsys.WbuColumnControllerControl": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "fieldTitle": true,
        "tooltipMessage": true,
        "enableReorder": true,
        "minimumValue": true,
        "dividerType": {
          "type": "string",
          "enum": [
            "long",
            "short",
            "none"
          ]
        },
        "columns": {
          "type": [
            "array"
          ],
          "items": true
        }
      },
      "additionalProperties": false
    },
    "dsgnsys.WbuDatePicker": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "label": true,
        "tooltip": true,
        "placeholder": true,
        "divider": {
          "type": "string",
          "enum": [
            "long",
            "short",
            "none"
          ]
        }
      },
      "additionalProperties": false
    },
    "dsgnsys.WbuDrillDown": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "label": true,
        "description": true,
        "iconType": {
          "type": "string",
          "enum": [
            "None",
            "Info",
            "Alert"
          ]
        },
        "tooltip": true
      },
      "additionalProperties": false
    },
    "dsgnsys.WbuDropdown": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "fieldTitle": true,
        "options": {
          "type": [
            "array"
          ],
          "items": true
        },
        "tooltipInfo": true,
        "placeholder": true,
        "divider": {
          "type": "string",
          "enum": [
            "long",
            "short",
            "none"
          ]
        }
      },
      "additionalProperties": false
    },
    "dsgnsys.WbuEmptyState": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "label": true,
        "description": true,
        "textButtonLabel": true,
        "url": true,
        "illustration": true
      },
      "additionalProperties": false
    },
    "dsgnsys.WbuFontAndColorPicker": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "label": true,
        "tooltip": true,
        "font": true,
        "color": true,
        "divider": {
          "type": "string",
          "enum": [
            "long",
            "short",
            "none"
          ]
        }
      },
      "additionalProperties": false
    },
    "dsgnsys.WbuHorizontalTabs": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "tabsStyle": {
          "type": "string",
          "enum": [
            "Folder",
            "Arrowed",
            "Arrowed Without a Line"
          ]
        },
        "options": {
          "type": [
            "array"
          ],
          "items": true
        },
        "maxVisibleTabs": true,
        "tabsToScroll": true
      },
      "additionalProperties": false
    },
    "dsgnsys.WbuLeftTextButton": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "text": true,
        "url": true,
        "size": {
          "type": "string",
          "enum": [
            "tiny",
            "small",
            "medium"
          ]
        },
        "skin": {
          "type": "string",
          "enum": [
            "standard",
            "premium"
          ]
        },
        "weight": {
          "type": "string",
          "enum": [
            "thin",
            "normal"
          ]
        },
        "prefixIcon": true,
        "suffixIcon": true,
        "divider": {
          "type": "string",
          "enum": [
            "long",
            "short",
            "none"
          ]
        }
      },
      "additionalProperties": false
    },
    "dsgnsys.WbuMultilineTextInput": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "label": true,
        "tooltip": true,
        "value": true,
        "placeholder": true,
        "maxLength": true,
        "closeOnEnterKeyPress": true,
        "autoFocus": true,
        "selectTextOnFocus": true,
        "readOnly": true,
        "usePatternValidation": true,
        "regexPattern": true,
        "validationMessage": true,
        "divider": {
          "type": "string",
          "enum": [
            "long",
            "short",
            "none"
          ]
        }
      },
      "additionalProperties": false
    },
    "dsgnsys.WbuNotificationBanner": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "label": true,
        "skin": {
          "type": "string",
          "enum": [
            "standard",
            "premium",
            "alert",
            "success"
          ]
        },
        "linkText": true,
        "linkUrl": true,
        "iconTooltipText": true,
        "multiline": true
      },
      "additionalProperties": false
    },
    "dsgnsys.WbuNumericInput": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "title": true,
        "value": true,
        "unitSuffix": {
          "type": "string",
          "enum": [
            "None",
            "Pixels",
            "Percentage",
            "Degrees"
          ]
        },
        "numberOfFractions": true,
        "steps": true,
        "stepControls": true,
        "minValue": true,
        "maxValue": true,
        "divider": {
          "type": "string",
          "enum": [
            "long",
            "short",
            "none"
          ]
        }
      },
      "additionalProperties": false
    },
    "dsgnsys.WbuRadioButtonGroup": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "fieldTitle": true,
        "options": {
          "type": [
            "array"
          ],
          "items": true
        },
        "tooltipInfo": true,
        "divider": {
          "type": "string",
          "enum": [
            "long",
            "short",
            "none"
          ]
        }
      },
      "additionalProperties": false
    },
    "dsgnsys.WbuRichText": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "richTextContent": true,
        "richTextLabel": true,
        "link": {
          "type": [
            "null",
            "string"
          ],
          "pattern": "^$|^#"
        },
        "richTextLink": true,
        "alignTextToCenter": true,
        "divider": {
          "type": "string",
          "enum": [
            "long",
            "short",
            "none"
          ]
        }
      },
      "additionalProperties": false
    },
    "dsgnsys.WbuSectionDivider": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "sectionTitle": true,
        "tooltipInfo": true
      },
      "additionalProperties": false
    },
    "dsgnsys.WbuSlider": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "fieldTitle": true,
        "tooltipInfo": true,
        "unitOfMeasurement": {
          "type": "string",
          "enum": [
            "number",
            "percentage",
            "pixels",
            "angle"
          ]
        },
        "defaultSelectedValue": true,
        "minimumValue": true,
        "maximumValue": true,
        "stepValue": true,
        "showNumericInput": true,
        "divider": {
          "type": "string",
          "enum": [
            "long",
            "short",
            "none"
          ]
        }
      },
      "additionalProperties": false
    },
    "dsgnsys.WbuTextInput": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "fieldTitle": true,
        "tooltipInfo": true,
        "defaultText": true,
        "placeholder": true,
        "prefix": true,
        "readOnly": true,
        "autofocus": true,
        "selectedOnFocus": true,
        "charactersLimit": true,
        "usePatternValidation": true,
        "regexPattern": true,
        "errorMessage": true,
        "divider": {
          "type": "string",
          "enum": [
            "long",
            "short",
            "none"
          ]
        }
      },
      "additionalProperties": false
    },
    "dsgnsys.WbuThumbnails": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "fieldTitle": true,
        "tooltipInfo": true,
        "setNumberOfColumns": true,
        "showEmptyThumbnail": true,
        "thumbnailHeight": {
          "type": "string",
          "enum": [
            "Fixed ratio (1:1)",
            "Fluid"
          ]
        },
        "displayLabels": true,
        "options": {
          "type": [
            "array"
          ],
          "items": true
        },
        "divider": {
          "type": "string",
          "enum": [
            "long",
            "short",
            "none"
          ]
        }
      },
      "additionalProperties": false
    },
    "ThumbnailItemData": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "label": true,
        "value": true,
        "disabled": true,
        "isDefault": true,
        "unavailable": true,
        "illustration": true
      },
      "additionalProperties": false
    },
    "dsgnsys.WbuToggleSwitch": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "label": true,
        "toggleSwitch": true,
        "disabled": true,
        "divider": {
          "type": "string",
          "enum": [
            "long",
            "short",
            "none"
          ]
        }
      },
      "additionalProperties": false
    },
    "dsgnsys.WutAvatar": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "firstName": true,
        "lastName": true,
        "src": true
      },
      "additionalProperties": false
    },
    "dsgnsys.WutAvatarGroup": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "maxAvatars": true,
        "showHiddenAvatarCount": true,
        "avatars": {
          "type": [
            "array"
          ],
          "items": true
        }
      },
      "additionalProperties": false
    },
    "dsgnsys.WutBadge": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "text": true,
        "icon": true,
        "composition": {
          "type": "string",
          "enum": [
            "TextAndIcon",
            "Text",
            "Icon",
            "None"
          ]
        },
        "alt": true
      },
      "additionalProperties": false
    },
    "dsgnsys.WutRadioButton": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "radioGroupName": true,
        "value": true,
        "checked": true,
        "required": true
      },
      "additionalProperties": false
    }
  },
  "naming.json": {
    "$id": "urn:dm:schemas:naming.json",
    "naming": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "name": true
      },
      "additionalProperties": false
    }
  },
  "notifications.json": {
    "$id": "urn:dm:schemas:notifications.json",
    "Notifications": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "items": {
          "type": "array",
          "items": {
            "type": "object",
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "fixedPages": {
                    "type": "array",
                    "items": true
                  },
                  "type": {
                    "type": "string",
                    "enum": [
                      "SectionsFixer"
                    ]
                  }
                },
                "additionalProperties": false
              },
              {
                "type": "object",
                "properties": {
                  "sticky": true,
                  "pinned": true,
                  "masterVertical": true,
                  "type": {
                    "type": "string",
                    "enum": [
                      "PinToSticky"
                    ]
                  }
                },
                "additionalProperties": false
              }
            ]
          }
        }
      },
      "additionalProperties": false
    },
    "SectionsFixer": {
      "type": "object",
      "properties": {
        "fixedPages": {
          "type": "array",
          "items": true
        },
        "type": {
          "type": "string",
          "enum": [
            "SectionsFixer"
          ]
        }
      },
      "additionalProperties": false
    },
    "PinToSticky": {
      "type": "object",
      "properties": {
        "sticky": true,
        "pinned": true,
        "masterVertical": true,
        "type": {
          "type": "string",
          "enum": [
            "PinToSticky"
          ]
        }
      },
      "additionalProperties": false
    }
  },
  "pageSections.json": {
    "$id": "urn:dm:schemas:pageSections.json",
    "pageSections": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "isSectionsEnabled": true,
        "isMigratedFromAdi": true,
        "preserveEditorFontsOrder": true,
        "migrationVersion": true,
        "migrationSkipCount": true,
        "sections": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "name": true,
              "contentRole": true,
              "children": {
                "type": "array",
                "items": true
              }
            },
            "additionalProperties": false
          }
        }
      },
      "additionalProperties": false
    }
  },
  "patterns.json": {
    "$id": "urn:dm:schemas:patterns.json",
    "Pattern": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "items": {
          "type": [
            "array",
            "null"
          ],
          "items": true
        }
      },
      "additionalProperties": false
    },
    "NthChild": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "repeat": true,
        "offset": true,
        "variant": true
      },
      "additionalProperties": false
    }
  },
  "presets.json": {
    "$id": "urn:dm:schemas:presets.json",
    "PresetData": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "layout": true,
        "style": true
      },
      "additionalProperties": false
    },
    "RefArray": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "values": {
          "type": [
            "array"
          ],
          "items": true
        }
      },
      "additionalProperties": false
    },
    "VariantRelation": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "variants": {
          "type": "array",
          "items": true
        },
        "remoteVariants": {
          "type": "array",
          "items": true
        },
        "from": true,
        "to": true
      },
      "additionalProperties": false
    }
  },
  "reactions.json": {
    "$id": "urn:dm:schemas:reactions.json",
    "Reactions": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "values": {
          "type": [
            "array",
            "null"
          ],
          "items": true
        }
      },
      "additionalProperties": false
    },
    "BaseStateReaction": {
      "type": "object",
      "properties": {
        "presetKey": true,
        "state": true
      },
      "additionalProperties": false
    },
    "ToggleState": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "presetKey": true,
        "state": true
      },
      "additionalProperties": false
    },
    "RemoveState": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "presetKey": true,
        "state": true
      },
      "additionalProperties": false
    },
    "AddState": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "presetKey": true,
        "state": true
      },
      "additionalProperties": false
    },
    "RemoveAllStates": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true
      },
      "additionalProperties": false
    },
    "ScrollForward": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true
      },
      "additionalProperties": false
    },
    "ScrollBackward": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true
      },
      "additionalProperties": false
    },
    "Play": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "effect": true,
        "once": true
      },
      "additionalProperties": false
    },
    "TogglePlay": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "effect": true
      },
      "additionalProperties": false
    },
    "Scrub": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "effect": true
      },
      "additionalProperties": false
    },
    "RefArray": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "values": {
          "type": [
            "array"
          ],
          "items": true
        }
      },
      "additionalProperties": false
    },
    "VariantRelation": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "variants": {
          "type": "array",
          "items": true
        },
        "remoteVariants": {
          "type": "array",
          "items": true
        },
        "from": true,
        "to": true
      },
      "additionalProperties": false
    }
  },
  "slots.json": {
    "$id": "urn:dm:schemas:slots.json",
    "PlaceholderSlot": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "slots": {
          "type": "object",
          "properties": {
            "slot": true
          },
          "additionalProperties": false
        }
      },
      "additionalProperties": false
    },
    "DynamicSlots": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "slots": {
          "type": "object",
          "properties": {},
          "additionalProperties": true
        }
      },
      "additionalProperties": false
    },
    "SlotRef": true
  },
  "source.json": {
    "$id": "urn:dm:schemas:source.json",
    "Source": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "original": {
          "type": "string",
          "enum": [
            "template",
            "preset",
            "user",
            "application",
            "translation",
            "caas",
            "ai"
          ]
        },
        "current": {
          "type": "string",
          "enum": [
            "template",
            "preset",
            "user",
            "application",
            "translation",
            "caas",
            "ai"
          ]
        },
        "changed": true,
        "ai_semantics": true
      },
      "additionalProperties": false
    },
    "SourceEnumType": {
      "type": "string",
      "enum": [
        "template",
        "preset",
        "user",
        "application",
        "translation",
        "caas",
        "ai"
      ]
    }
  },
  "states.json": {
    "$id": "urn:dm:schemas:states.json",
    "States": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "values": {
          "type": "array",
          "items": true
        }
      },
      "additionalProperties": false
    }
  },
  "structure.json": {
    "$id": "urn:dm:schemas:structure.json",
    "DesignQuery": true,
    "DataQuery": true,
    "PropertyQuery": true,
    "VariantsQuery": true,
    "StyleId": true,
    "MobileHintsQuery": true,
    "BehaviorQuery": true,
    "ConnectionQuery": true,
    "LayoutQuery": true,
    "AnchorQuery": true,
    "BreakpointsQuery": true,
    "BreakpointVariantsQuery": true,
    "TransformationQuery": true,
    "TransitionQuery": true,
    "ModesDefinition": {
      "type": "object",
      "properties": {
        "definitions": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "label": true,
              "modeId": true,
              "params": true,
              "settings": {
                "type": "object",
                "properties": {
                  "pagesGroupId": true
                },
                "additionalProperties": false
              },
              "type": {
                "type": "string",
                "enum": [
                  "HOVER",
                  "DEFAULT",
                  "SHOW_ON_SOME_PAGES",
                  "POPOVER"
                ]
              }
            },
            "additionalProperties": false
          }
        },
        "isHiddenByModes": true,
        "overrides": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "isHiddenByModes": true,
              "modeIds": {
                "type": "array",
                "items": true
              },
              "layout": {
                "type": "object",
                "properties": {
                  "x": true,
                  "y": true,
                  "width": true,
                  "height": true,
                  "rotationInDegrees": true,
                  "fixedPosition": true,
                  "scale": true,
                  "docked": {
                    "type": "object",
                    "properties": {
                      "left": {
                        "type": "object",
                        "properties": {
                          "px": true,
                          "pct": true,
                          "vw": true,
                          "vh": true
                        },
                        "additionalProperties": false
                      },
                      "right": {
                        "type": "object",
                        "properties": {
                          "px": true,
                          "pct": true,
                          "vw": true,
                          "vh": true
                        },
                        "additionalProperties": false
                      },
                      "top": {
                        "type": "object",
                        "properties": {
                          "px": true,
                          "pct": true,
                          "vw": true,
                          "vh": true
                        },
                        "additionalProperties": false
                      },
                      "bottom": {
                        "type": "object",
                        "properties": {
                          "px": true,
                          "pct": true,
                          "vw": true,
                          "vh": true
                        },
                        "additionalProperties": false
                      },
                      "hCenter": {
                        "type": "object",
                        "properties": {
                          "px": true,
                          "pct": true,
                          "vw": true,
                          "vh": true
                        },
                        "additionalProperties": false
                      },
                      "vCenter": {
                        "type": "object",
                        "properties": {
                          "px": true,
                          "pct": true,
                          "vw": true,
                          "vh": true
                        },
                        "additionalProperties": false
                      }
                    },
                    "additionalProperties": false
                  },
                  "anchors": {
                    "type": [
                      "null",
                      "array"
                    ],
                    "items": {
                      "type": "object",
                      "properties": {
                        "distance": true,
                        "type": {
                          "type": "string",
                          "enum": [
                            "TOP_TOP",
                            "BOTTOM_TOP",
                            "BOTTOM_PARENT",
                            "BOTTOM_BOTTOM",
                            "LOCK_BOTTOM"
                          ]
                        },
                        "locked": true,
                        "targetComponent": true
                      },
                      "additionalProperties": false
                    }
                  }
                },
                "additionalProperties": false
              },
              "designQuery": true,
              "propertyQuery": true,
              "styleId": true
            },
            "additionalProperties": false
          }
        }
      },
      "additionalProperties": false
    },
    "AnchorDefinition": {
      "type": "object",
      "properties": {
        "distance": true,
        "type": {
          "type": "string",
          "enum": [
            "TOP_TOP",
            "BOTTOM_TOP",
            "BOTTOM_PARENT",
            "BOTTOM_BOTTOM",
            "LOCK_BOTTOM"
          ]
        },
        "locked": true,
        "targetComponent": true
      },
      "additionalProperties": false
    },
    "PartialLayoutObjectForMasterPage": {
      "type": "object",
      "properties": {
        "y": {
          "enum": [
            0
          ]
        },
        "rotationInDegrees": {
          "enum": [
            0
          ]
        },
        "anchors": {
          "type": [
            "null",
            "array"
          ],
          "items": {
            "type": "object",
            "properties": {
              "distance": true,
              "type": {
                "type": "string",
                "enum": [
                  "TOP_TOP",
                  "BOTTOM_TOP",
                  "BOTTOM_PARENT",
                  "BOTTOM_BOTTOM",
                  "LOCK_BOTTOM"
                ]
              },
              "locked": true,
              "targetComponent": true
            },
            "additionalProperties": false
          }
        }
      },
      "additionalProperties": false
    },
    "DockingUnitSize": {
      "type": "object",
      "properties": {
        "px": true,
        "pct": true,
        "vw": true,
        "vh": true
      },
      "additionalProperties": false
    },
    "DockingDefinition": {
      "type": "object",
      "properties": {
        "left": {
          "type": "object",
          "properties": {
            "px": true,
            "pct": true,
            "vw": true,
            "vh": true
          },
          "additionalProperties": false
        },
        "right": {
          "type": "object",
          "properties": {
            "px": true,
            "pct": true,
            "vw": true,
            "vh": true
          },
          "additionalProperties": false
        },
        "top": {
          "type": "object",
          "properties": {
            "px": true,
            "pct": true,
            "vw": true,
            "vh": true
          },
          "additionalProperties": false
        },
        "bottom": {
          "type": "object",
          "properties": {
            "px": true,
            "pct": true,
            "vw": true,
            "vh": true
          },
          "additionalProperties": false
        },
        "hCenter": {
          "type": "object",
          "properties": {
            "px": true,
            "pct": true,
            "vw": true,
            "vh": true
          },
          "additionalProperties": false
        },
        "vCenter": {
          "type": "object",
          "properties": {
            "px": true,
            "pct": true,
            "vw": true,
            "vh": true
          },
          "additionalProperties": false
        }
      },
      "additionalProperties": false
    },
    "BaseComponentObject": {
      "type": "object",
      "properties": {
        "metaData": true,
        "id": true,
        "type": true,
        "parent": true
      },
      "additionalProperties": false
    },
    "MetaDataForComponents": {
      "type": "object",
      "properties": {},
      "additionalProperties": false
    },
    "LayoutObjectForComponents": {
      "type": "object",
      "properties": {
        "x": true,
        "y": true,
        "width": true,
        "height": true,
        "rotationInDegrees": true,
        "fixedPosition": true,
        "scale": true,
        "docked": {
          "type": "object",
          "properties": {
            "left": {
              "type": "object",
              "properties": {
                "px": true,
                "pct": true,
                "vw": true,
                "vh": true
              },
              "additionalProperties": false
            },
            "right": {
              "type": "object",
              "properties": {
                "px": true,
                "pct": true,
                "vw": true,
                "vh": true
              },
              "additionalProperties": false
            },
            "top": {
              "type": "object",
              "properties": {
                "px": true,
                "pct": true,
                "vw": true,
                "vh": true
              },
              "additionalProperties": false
            },
            "bottom": {
              "type": "object",
              "properties": {
                "px": true,
                "pct": true,
                "vw": true,
                "vh": true
              },
              "additionalProperties": false
            },
            "hCenter": {
              "type": "object",
              "properties": {
                "px": true,
                "pct": true,
                "vw": true,
                "vh": true
              },
              "additionalProperties": false
            },
            "vCenter": {
              "type": "object",
              "properties": {
                "px": true,
                "pct": true,
                "vw": true,
                "vh": true
              },
              "additionalProperties": false
            }
          },
          "additionalProperties": false
        },
        "anchors": {
          "type": [
            "null",
            "array"
          ],
          "items": {
            "type": "object",
            "properties": {
              "distance": true,
              "type": {
                "type": "string",
                "enum": [
                  "TOP_TOP",
                  "BOTTOM_TOP",
                  "BOTTOM_PARENT",
                  "BOTTOM_BOTTOM",
                  "LOCK_BOTTOM"
                ]
              },
              "locked": true,
              "targetComponent": true
            },
            "additionalProperties": false
          }
        }
      },
      "additionalProperties": false
    },
    "ShouldReallyBeAnIntAtSomePoint": true,
    "ComponentsList": {
      "type": [
        "array",
        "null"
      ],
      "items": true
    },
    "Component": {
      "type": [
        "object"
      ],
      "properties": {
        "metaData": true,
        "id": true,
        "type": true,
        "parent": true,
        "dataQuery": true,
        "propertyQuery": true,
        "designQuery": true,
        "mobileHintsQuery": true,
        "behaviorQuery": true,
        "connectionQuery": true,
        "layoutQuery": true,
        "anchorQuery": true,
        "breakpointsQuery": true,
        "breakpointVariantsQuery": true,
        "transformationQuery": true,
        "transitionQuery": true,
        "variantsQuery": true,
        "styleId": true,
        "layout": {
          "type": "object",
          "properties": {
            "x": true,
            "y": true,
            "width": true,
            "height": true,
            "rotationInDegrees": true,
            "fixedPosition": true,
            "scale": true,
            "docked": {
              "type": "object",
              "properties": {
                "left": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                },
                "right": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                },
                "top": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                },
                "bottom": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                },
                "hCenter": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                },
                "vCenter": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            "anchors": {
              "type": [
                "null",
                "array"
              ],
              "items": {
                "type": "object",
                "properties": {
                  "distance": true,
                  "type": {
                    "type": "string",
                    "enum": [
                      "TOP_TOP",
                      "BOTTOM_TOP",
                      "BOTTOM_PARENT",
                      "BOTTOM_BOTTOM",
                      "LOCK_BOTTOM"
                    ]
                  },
                  "locked": true,
                  "targetComponent": true
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "classnamesQuery": true,
        "contentRoleQuery": true,
        "controllersQuery": true,
        "cursorQuery": true,
        "discussionsQuery": true,
        "editorsettingsQuery": true,
        "effectsQuery": true,
        "groupingQuery": true,
        "innerElementsQuery": true,
        "innerElementsMetaDataQuery": true,
        "intentQuery": true,
        "layoutSettingsQuery": true,
        "manifestQuery": true,
        "measurementsQuery": true,
        "migrationQuery": true,
        "namingQuery": true,
        "notificationsQuery": true,
        "pageSectionsQuery": true,
        "presetsQuery": true,
        "reactionsQuery": true,
        "slotsQuery": true,
        "sourceQuery": true,
        "statesQuery": true,
        "triggersQuery": true,
        "variablesQuery": true,
        "componentType": true,
        "skin": true,
        "modes": {
          "type": "object",
          "properties": {
            "definitions": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "label": true,
                  "modeId": true,
                  "params": true,
                  "settings": {
                    "type": "object",
                    "properties": {
                      "pagesGroupId": true
                    },
                    "additionalProperties": false
                  },
                  "type": {
                    "type": "string",
                    "enum": [
                      "HOVER",
                      "DEFAULT",
                      "SHOW_ON_SOME_PAGES",
                      "POPOVER"
                    ]
                  }
                },
                "additionalProperties": false
              }
            },
            "isHiddenByModes": true,
            "overrides": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "isHiddenByModes": true,
                  "modeIds": {
                    "type": "array",
                    "items": true
                  },
                  "layout": {
                    "type": "object",
                    "properties": {
                      "x": true,
                      "y": true,
                      "width": true,
                      "height": true,
                      "rotationInDegrees": true,
                      "fixedPosition": true,
                      "scale": true,
                      "docked": {
                        "type": "object",
                        "properties": {
                          "left": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          },
                          "right": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          },
                          "top": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          },
                          "bottom": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          },
                          "hCenter": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          },
                          "vCenter": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          }
                        },
                        "additionalProperties": false
                      },
                      "anchors": {
                        "type": [
                          "null",
                          "array"
                        ],
                        "items": {
                          "type": "object",
                          "properties": {
                            "distance": true,
                            "type": {
                              "type": "string",
                              "enum": [
                                "TOP_TOP",
                                "BOTTOM_TOP",
                                "BOTTOM_PARENT",
                                "BOTTOM_BOTTOM",
                                "LOCK_BOTTOM"
                              ]
                            },
                            "locked": true,
                            "targetComponent": true
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    "additionalProperties": false
                  },
                  "designQuery": true,
                  "propertyQuery": true,
                  "styleId": true
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        }
      },
      "additionalProperties": false
    },
    "ComponentQueries": {
      "type": "object",
      "properties": {
        "dataQuery": true,
        "propertyQuery": true,
        "designQuery": true,
        "mobileHintsQuery": true,
        "behaviorQuery": true,
        "connectionQuery": true,
        "layoutQuery": true,
        "anchorQuery": true,
        "breakpointsQuery": true,
        "breakpointVariantsQuery": true,
        "transformationQuery": true,
        "transitionQuery": true,
        "variantsQuery": true,
        "styleId": true,
        "layout": {
          "type": "object",
          "properties": {
            "x": true,
            "y": true,
            "width": true,
            "height": true,
            "rotationInDegrees": true,
            "fixedPosition": true,
            "scale": true,
            "docked": {
              "type": "object",
              "properties": {
                "left": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                },
                "right": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                },
                "top": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                },
                "bottom": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                },
                "hCenter": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                },
                "vCenter": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            "anchors": {
              "type": [
                "null",
                "array"
              ],
              "items": {
                "type": "object",
                "properties": {
                  "distance": true,
                  "type": {
                    "type": "string",
                    "enum": [
                      "TOP_TOP",
                      "BOTTOM_TOP",
                      "BOTTOM_PARENT",
                      "BOTTOM_BOTTOM",
                      "LOCK_BOTTOM"
                    ]
                  },
                  "locked": true,
                  "targetComponent": true
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "classnamesQuery": true,
        "contentRoleQuery": true,
        "controllersQuery": true,
        "cursorQuery": true,
        "discussionsQuery": true,
        "editorsettingsQuery": true,
        "effectsQuery": true,
        "groupingQuery": true,
        "innerElementsQuery": true,
        "innerElementsMetaDataQuery": true,
        "intentQuery": true,
        "layoutSettingsQuery": true,
        "manifestQuery": true,
        "measurementsQuery": true,
        "migrationQuery": true,
        "namingQuery": true,
        "notificationsQuery": true,
        "pageSectionsQuery": true,
        "presetsQuery": true,
        "reactionsQuery": true,
        "slotsQuery": true,
        "sourceQuery": true,
        "statesQuery": true,
        "triggersQuery": true,
        "variablesQuery": true
      },
      "additionalProperties": false
    },
    "RefComponent": {
      "type": [
        "object"
      ],
      "properties": {
        "metaData": true,
        "id": true,
        "type": true,
        "parent": true,
        "dataQuery": true,
        "propertyQuery": true,
        "designQuery": true,
        "mobileHintsQuery": true,
        "behaviorQuery": true,
        "connectionQuery": true,
        "layoutQuery": true,
        "anchorQuery": true,
        "breakpointsQuery": true,
        "breakpointVariantsQuery": true,
        "transformationQuery": true,
        "transitionQuery": true,
        "variantsQuery": true,
        "styleId": true,
        "layout": {
          "type": "object",
          "properties": {
            "x": true,
            "y": true,
            "width": true,
            "height": true,
            "rotationInDegrees": true,
            "fixedPosition": true,
            "scale": true,
            "docked": {
              "type": "object",
              "properties": {
                "left": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                },
                "right": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                },
                "top": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                },
                "bottom": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                },
                "hCenter": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                },
                "vCenter": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            "anchors": {
              "type": [
                "null",
                "array"
              ],
              "items": {
                "type": "object",
                "properties": {
                  "distance": true,
                  "type": {
                    "type": "string",
                    "enum": [
                      "TOP_TOP",
                      "BOTTOM_TOP",
                      "BOTTOM_PARENT",
                      "BOTTOM_BOTTOM",
                      "LOCK_BOTTOM"
                    ]
                  },
                  "locked": true,
                  "targetComponent": true
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "classnamesQuery": true,
        "contentRoleQuery": true,
        "controllersQuery": true,
        "cursorQuery": true,
        "discussionsQuery": true,
        "editorsettingsQuery": true,
        "effectsQuery": true,
        "groupingQuery": true,
        "innerElementsQuery": true,
        "innerElementsMetaDataQuery": true,
        "intentQuery": true,
        "layoutSettingsQuery": true,
        "manifestQuery": true,
        "measurementsQuery": true,
        "migrationQuery": true,
        "namingQuery": true,
        "notificationsQuery": true,
        "pageSectionsQuery": true,
        "presetsQuery": true,
        "reactionsQuery": true,
        "slotsQuery": true,
        "sourceQuery": true,
        "statesQuery": true,
        "triggersQuery": true,
        "variablesQuery": true,
        "componentType": true,
        "skin": true,
        "modes": {
          "type": "object",
          "properties": {
            "definitions": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "label": true,
                  "modeId": true,
                  "params": true,
                  "settings": {
                    "type": "object",
                    "properties": {
                      "pagesGroupId": true
                    },
                    "additionalProperties": false
                  },
                  "type": {
                    "type": "string",
                    "enum": [
                      "HOVER",
                      "DEFAULT",
                      "SHOW_ON_SOME_PAGES",
                      "POPOVER"
                    ]
                  }
                },
                "additionalProperties": false
              }
            },
            "isHiddenByModes": true,
            "overrides": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "isHiddenByModes": true,
                  "modeIds": {
                    "type": "array",
                    "items": true
                  },
                  "layout": {
                    "type": "object",
                    "properties": {
                      "x": true,
                      "y": true,
                      "width": true,
                      "height": true,
                      "rotationInDegrees": true,
                      "fixedPosition": true,
                      "scale": true,
                      "docked": {
                        "type": "object",
                        "properties": {
                          "left": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          },
                          "right": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          },
                          "top": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          },
                          "bottom": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          },
                          "hCenter": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          },
                          "vCenter": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          }
                        },
                        "additionalProperties": false
                      },
                      "anchors": {
                        "type": [
                          "null",
                          "array"
                        ],
                        "items": {
                          "type": "object",
                          "properties": {
                            "distance": true,
                            "type": {
                              "type": "string",
                              "enum": [
                                "TOP_TOP",
                                "BOTTOM_TOP",
                                "BOTTOM_PARENT",
                                "BOTTOM_BOTTOM",
                                "LOCK_BOTTOM"
                              ]
                            },
                            "locked": true,
                            "targetComponent": true
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    "additionalProperties": false
                  },
                  "designQuery": true,
                  "propertyQuery": true,
                  "styleId": true
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "components": {
          "type": [
            "array",
            "null"
          ],
          "items": true
        }
      },
      "additionalProperties": false
    },
    "RepeaterContainer": {
      "type": [
        "object"
      ],
      "properties": {
        "metaData": true,
        "id": true,
        "type": true,
        "parent": true,
        "dataQuery": true,
        "propertyQuery": true,
        "designQuery": true,
        "mobileHintsQuery": true,
        "behaviorQuery": true,
        "connectionQuery": true,
        "layoutQuery": true,
        "anchorQuery": true,
        "breakpointsQuery": true,
        "breakpointVariantsQuery": true,
        "transformationQuery": true,
        "transitionQuery": true,
        "variantsQuery": true,
        "styleId": true,
        "layout": {
          "type": "object",
          "properties": {
            "x": true,
            "y": true,
            "width": true,
            "height": true,
            "rotationInDegrees": true,
            "fixedPosition": true,
            "scale": true,
            "docked": {
              "type": "object",
              "properties": {
                "left": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                },
                "right": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                },
                "top": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                },
                "bottom": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                },
                "hCenter": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                },
                "vCenter": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            "anchors": {
              "type": [
                "null",
                "array"
              ],
              "items": {
                "type": "object",
                "properties": {
                  "distance": true,
                  "type": {
                    "type": "string",
                    "enum": [
                      "TOP_TOP",
                      "BOTTOM_TOP",
                      "BOTTOM_PARENT",
                      "BOTTOM_BOTTOM",
                      "LOCK_BOTTOM"
                    ]
                  },
                  "locked": true,
                  "targetComponent": true
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "classnamesQuery": true,
        "contentRoleQuery": true,
        "controllersQuery": true,
        "cursorQuery": true,
        "discussionsQuery": true,
        "editorsettingsQuery": true,
        "effectsQuery": true,
        "groupingQuery": true,
        "innerElementsQuery": true,
        "innerElementsMetaDataQuery": true,
        "intentQuery": true,
        "layoutSettingsQuery": true,
        "manifestQuery": true,
        "measurementsQuery": true,
        "migrationQuery": true,
        "namingQuery": true,
        "notificationsQuery": true,
        "pageSectionsQuery": true,
        "presetsQuery": true,
        "reactionsQuery": true,
        "slotsQuery": true,
        "sourceQuery": true,
        "statesQuery": true,
        "triggersQuery": true,
        "variablesQuery": true,
        "componentType": true,
        "skin": true,
        "modes": {
          "type": "object",
          "properties": {
            "definitions": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "label": true,
                  "modeId": true,
                  "params": true,
                  "settings": {
                    "type": "object",
                    "properties": {
                      "pagesGroupId": true
                    },
                    "additionalProperties": false
                  },
                  "type": {
                    "type": "string",
                    "enum": [
                      "HOVER",
                      "DEFAULT",
                      "SHOW_ON_SOME_PAGES",
                      "POPOVER"
                    ]
                  }
                },
                "additionalProperties": false
              }
            },
            "isHiddenByModes": true,
            "overrides": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "isHiddenByModes": true,
                  "modeIds": {
                    "type": "array",
                    "items": true
                  },
                  "layout": {
                    "type": "object",
                    "properties": {
                      "x": true,
                      "y": true,
                      "width": true,
                      "height": true,
                      "rotationInDegrees": true,
                      "fixedPosition": true,
                      "scale": true,
                      "docked": {
                        "type": "object",
                        "properties": {
                          "left": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          },
                          "right": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          },
                          "top": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          },
                          "bottom": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          },
                          "hCenter": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          },
                          "vCenter": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          }
                        },
                        "additionalProperties": false
                      },
                      "anchors": {
                        "type": [
                          "null",
                          "array"
                        ],
                        "items": {
                          "type": "object",
                          "properties": {
                            "distance": true,
                            "type": {
                              "type": "string",
                              "enum": [
                                "TOP_TOP",
                                "BOTTOM_TOP",
                                "BOTTOM_PARENT",
                                "BOTTOM_BOTTOM",
                                "LOCK_BOTTOM"
                              ]
                            },
                            "locked": true,
                            "targetComponent": true
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    "additionalProperties": false
                  },
                  "designQuery": true,
                  "propertyQuery": true,
                  "styleId": true
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "components": {
          "type": [
            "array",
            "null"
          ],
          "items": true
        },
        "patternsQuery": true
      },
      "additionalProperties": false
    },
    "RepeaterVariantsQuery": true,
    "RepeaterQueries": {
      "type": "object",
      "properties": {
        "variantsQuery": true,
        "patternsQuery": true
      },
      "additionalProperties": false
    },
    "Container": {
      "type": [
        "object"
      ],
      "properties": {
        "metaData": true,
        "id": true,
        "type": true,
        "parent": true,
        "dataQuery": true,
        "propertyQuery": true,
        "designQuery": true,
        "mobileHintsQuery": true,
        "behaviorQuery": true,
        "connectionQuery": true,
        "layoutQuery": true,
        "anchorQuery": true,
        "breakpointsQuery": true,
        "breakpointVariantsQuery": true,
        "transformationQuery": true,
        "transitionQuery": true,
        "variantsQuery": true,
        "styleId": true,
        "layout": {
          "type": "object",
          "properties": {
            "x": true,
            "y": true,
            "width": true,
            "height": true,
            "rotationInDegrees": true,
            "fixedPosition": true,
            "scale": true,
            "docked": {
              "type": "object",
              "properties": {
                "left": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                },
                "right": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                },
                "top": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                },
                "bottom": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                },
                "hCenter": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                },
                "vCenter": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            "anchors": {
              "type": [
                "null",
                "array"
              ],
              "items": {
                "type": "object",
                "properties": {
                  "distance": true,
                  "type": {
                    "type": "string",
                    "enum": [
                      "TOP_TOP",
                      "BOTTOM_TOP",
                      "BOTTOM_PARENT",
                      "BOTTOM_BOTTOM",
                      "LOCK_BOTTOM"
                    ]
                  },
                  "locked": true,
                  "targetComponent": true
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "classnamesQuery": true,
        "contentRoleQuery": true,
        "controllersQuery": true,
        "cursorQuery": true,
        "discussionsQuery": true,
        "editorsettingsQuery": true,
        "effectsQuery": true,
        "groupingQuery": true,
        "innerElementsQuery": true,
        "innerElementsMetaDataQuery": true,
        "intentQuery": true,
        "layoutSettingsQuery": true,
        "manifestQuery": true,
        "measurementsQuery": true,
        "migrationQuery": true,
        "namingQuery": true,
        "notificationsQuery": true,
        "pageSectionsQuery": true,
        "presetsQuery": true,
        "reactionsQuery": true,
        "slotsQuery": true,
        "sourceQuery": true,
        "statesQuery": true,
        "triggersQuery": true,
        "variablesQuery": true,
        "componentType": true,
        "skin": true,
        "modes": {
          "type": "object",
          "properties": {
            "definitions": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "label": true,
                  "modeId": true,
                  "params": true,
                  "settings": {
                    "type": "object",
                    "properties": {
                      "pagesGroupId": true
                    },
                    "additionalProperties": false
                  },
                  "type": {
                    "type": "string",
                    "enum": [
                      "HOVER",
                      "DEFAULT",
                      "SHOW_ON_SOME_PAGES",
                      "POPOVER"
                    ]
                  }
                },
                "additionalProperties": false
              }
            },
            "isHiddenByModes": true,
            "overrides": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "isHiddenByModes": true,
                  "modeIds": {
                    "type": "array",
                    "items": true
                  },
                  "layout": {
                    "type": "object",
                    "properties": {
                      "x": true,
                      "y": true,
                      "width": true,
                      "height": true,
                      "rotationInDegrees": true,
                      "fixedPosition": true,
                      "scale": true,
                      "docked": {
                        "type": "object",
                        "properties": {
                          "left": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          },
                          "right": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          },
                          "top": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          },
                          "bottom": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          },
                          "hCenter": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          },
                          "vCenter": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          }
                        },
                        "additionalProperties": false
                      },
                      "anchors": {
                        "type": [
                          "null",
                          "array"
                        ],
                        "items": {
                          "type": "object",
                          "properties": {
                            "distance": true,
                            "type": {
                              "type": "string",
                              "enum": [
                                "TOP_TOP",
                                "BOTTOM_TOP",
                                "BOTTOM_PARENT",
                                "BOTTOM_BOTTOM",
                                "LOCK_BOTTOM"
                              ]
                            },
                            "locked": true,
                            "targetComponent": true
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    "additionalProperties": false
                  },
                  "designQuery": true,
                  "propertyQuery": true,
                  "styleId": true
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "components": {
          "type": [
            "array",
            "null"
          ],
          "items": true
        }
      },
      "additionalProperties": false
    },
    "PageQueries": {
      "type": "object",
      "properties": {
        "fixerVersionsQuery": true
      },
      "additionalProperties": false
    },
    "Page": {
      "type": [
        "object"
      ],
      "properties": {
        "metaData": true,
        "id": true,
        "type": true,
        "parent": true,
        "dataQuery": true,
        "propertyQuery": true,
        "designQuery": true,
        "mobileHintsQuery": true,
        "behaviorQuery": true,
        "connectionQuery": true,
        "layoutQuery": true,
        "anchorQuery": true,
        "breakpointsQuery": true,
        "breakpointVariantsQuery": true,
        "transformationQuery": true,
        "transitionQuery": true,
        "variantsQuery": true,
        "styleId": true,
        "layout": {
          "type": "object",
          "properties": {
            "x": true,
            "y": true,
            "width": true,
            "height": true,
            "rotationInDegrees": true,
            "fixedPosition": true,
            "scale": true,
            "docked": {
              "type": "object",
              "properties": {
                "left": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                },
                "right": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                },
                "top": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                },
                "bottom": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                },
                "hCenter": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                },
                "vCenter": {
                  "type": "object",
                  "properties": {
                    "px": true,
                    "pct": true,
                    "vw": true,
                    "vh": true
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            "anchors": {
              "type": [
                "null",
                "array"
              ],
              "items": {
                "type": "object",
                "properties": {
                  "distance": true,
                  "type": {
                    "type": "string",
                    "enum": [
                      "TOP_TOP",
                      "BOTTOM_TOP",
                      "BOTTOM_PARENT",
                      "BOTTOM_BOTTOM",
                      "LOCK_BOTTOM"
                    ]
                  },
                  "locked": true,
                  "targetComponent": true
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "classnamesQuery": true,
        "contentRoleQuery": true,
        "controllersQuery": true,
        "cursorQuery": true,
        "discussionsQuery": true,
        "editorsettingsQuery": true,
        "effectsQuery": true,
        "groupingQuery": true,
        "innerElementsQuery": true,
        "innerElementsMetaDataQuery": true,
        "intentQuery": true,
        "layoutSettingsQuery": true,
        "manifestQuery": true,
        "measurementsQuery": true,
        "migrationQuery": true,
        "namingQuery": true,
        "notificationsQuery": true,
        "pageSectionsQuery": true,
        "presetsQuery": true,
        "reactionsQuery": true,
        "slotsQuery": true,
        "sourceQuery": true,
        "statesQuery": true,
        "triggersQuery": true,
        "variablesQuery": true,
        "componentType": true,
        "skin": true,
        "modes": {
          "type": "object",
          "properties": {
            "definitions": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "label": true,
                  "modeId": true,
                  "params": true,
                  "settings": {
                    "type": "object",
                    "properties": {
                      "pagesGroupId": true
                    },
                    "additionalProperties": false
                  },
                  "type": {
                    "type": "string",
                    "enum": [
                      "HOVER",
                      "DEFAULT",
                      "SHOW_ON_SOME_PAGES",
                      "POPOVER"
                    ]
                  }
                },
                "additionalProperties": false
              }
            },
            "isHiddenByModes": true,
            "overrides": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "isHiddenByModes": true,
                  "modeIds": {
                    "type": "array",
                    "items": true
                  },
                  "layout": {
                    "type": "object",
                    "properties": {
                      "x": true,
                      "y": true,
                      "width": true,
                      "height": true,
                      "rotationInDegrees": true,
                      "fixedPosition": true,
                      "scale": true,
                      "docked": {
                        "type": "object",
                        "properties": {
                          "left": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          },
                          "right": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          },
                          "top": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          },
                          "bottom": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          },
                          "hCenter": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          },
                          "vCenter": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          }
                        },
                        "additionalProperties": false
                      },
                      "anchors": {
                        "type": [
                          "null",
                          "array"
                        ],
                        "items": {
                          "type": "object",
                          "properties": {
                            "distance": true,
                            "type": {
                              "type": "string",
                              "enum": [
                                "TOP_TOP",
                                "BOTTOM_TOP",
                                "BOTTOM_PARENT",
                                "BOTTOM_BOTTOM",
                                "LOCK_BOTTOM"
                              ]
                            },
                            "locked": true,
                            "targetComponent": true
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    "additionalProperties": false
                  },
                  "designQuery": true,
                  "propertyQuery": true,
                  "styleId": true
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "components": {
          "type": [
            "array",
            "null"
          ],
          "items": true
        },
        "fixerVersionsQuery": true
      },
      "additionalProperties": false
    },
    "DocumentProperties": {
      "type": "object",
      "properties": {
        "documentType": {
          "enum": [
            "document"
          ]
        },
        "layout": {
          "type": "object",
          "properties": {
            "y": {
              "enum": [
                0
              ]
            },
            "rotationInDegrees": {
              "enum": [
                0
              ]
            },
            "anchors": {
              "type": [
                "null",
                "array"
              ],
              "items": {
                "type": "object",
                "properties": {
                  "distance": true,
                  "type": {
                    "type": "string",
                    "enum": [
                      "TOP_TOP",
                      "BOTTOM_TOP",
                      "BOTTOM_PARENT",
                      "BOTTOM_BOTTOM",
                      "LOCK_BOTTOM"
                    ]
                  },
                  "locked": true,
                  "targetComponent": true
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "componentProperties": {
          "type": "object",
          "properties": {},
          "additionalProperties": false
        },
        "themeData": {
          "type": "object",
          "properties": {},
          "additionalProperties": false
        },
        "variantsQuery": true,
        "fixerVersionsQuery": true,
        "themeConfigQuery": true
      },
      "additionalProperties": false
    },
    "Document": {
      "type": [
        "object"
      ],
      "properties": {
        "metaData": true,
        "id": true,
        "type": true,
        "parent": true,
        "dataQuery": true,
        "propertyQuery": true,
        "designQuery": true,
        "mobileHintsQuery": true,
        "behaviorQuery": true,
        "connectionQuery": true,
        "layoutQuery": true,
        "anchorQuery": true,
        "breakpointsQuery": true,
        "breakpointVariantsQuery": true,
        "transformationQuery": true,
        "transitionQuery": true,
        "variantsQuery": true,
        "styleId": true,
        "layout": {
          "type": "object",
          "properties": {
            "y": {
              "enum": [
                0
              ]
            },
            "rotationInDegrees": {
              "enum": [
                0
              ]
            },
            "anchors": {
              "type": [
                "null",
                "array"
              ],
              "items": {
                "type": "object",
                "properties": {
                  "distance": true,
                  "type": {
                    "type": "string",
                    "enum": [
                      "TOP_TOP",
                      "BOTTOM_TOP",
                      "BOTTOM_PARENT",
                      "BOTTOM_BOTTOM",
                      "LOCK_BOTTOM"
                    ]
                  },
                  "locked": true,
                  "targetComponent": true
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "classnamesQuery": true,
        "contentRoleQuery": true,
        "controllersQuery": true,
        "cursorQuery": true,
        "discussionsQuery": true,
        "editorsettingsQuery": true,
        "effectsQuery": true,
        "groupingQuery": true,
        "innerElementsQuery": true,
        "innerElementsMetaDataQuery": true,
        "intentQuery": true,
        "layoutSettingsQuery": true,
        "manifestQuery": true,
        "measurementsQuery": true,
        "migrationQuery": true,
        "namingQuery": true,
        "notificationsQuery": true,
        "pageSectionsQuery": true,
        "presetsQuery": true,
        "reactionsQuery": true,
        "slotsQuery": true,
        "sourceQuery": true,
        "statesQuery": true,
        "triggersQuery": true,
        "variablesQuery": true,
        "componentType": true,
        "skin": true,
        "modes": {
          "type": "object",
          "properties": {
            "definitions": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "label": true,
                  "modeId": true,
                  "params": true,
                  "settings": {
                    "type": "object",
                    "properties": {
                      "pagesGroupId": true
                    },
                    "additionalProperties": false
                  },
                  "type": {
                    "type": "string",
                    "enum": [
                      "HOVER",
                      "DEFAULT",
                      "SHOW_ON_SOME_PAGES",
                      "POPOVER"
                    ]
                  }
                },
                "additionalProperties": false
              }
            },
            "isHiddenByModes": true,
            "overrides": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "isHiddenByModes": true,
                  "modeIds": {
                    "type": "array",
                    "items": true
                  },
                  "layout": {
                    "type": "object",
                    "properties": {
                      "x": true,
                      "y": true,
                      "width": true,
                      "height": true,
                      "rotationInDegrees": true,
                      "fixedPosition": true,
                      "scale": true,
                      "docked": {
                        "type": "object",
                        "properties": {
                          "left": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          },
                          "right": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          },
                          "top": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          },
                          "bottom": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          },
                          "hCenter": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          },
                          "vCenter": {
                            "type": "object",
                            "properties": {
                              "px": true,
                              "pct": true,
                              "vw": true,
                              "vh": true
                            },
                            "additionalProperties": false
                          }
                        },
                        "additionalProperties": false
                      },
                      "anchors": {
                        "type": [
                          "null",
                          "array"
                        ],
                        "items": {
                          "type": "object",
                          "properties": {
                            "distance": true,
                            "type": {
                              "type": "string",
                              "enum": [
                                "TOP_TOP",
                                "BOTTOM_TOP",
                                "BOTTOM_PARENT",
                                "BOTTOM_BOTTOM",
                                "LOCK_BOTTOM"
                              ]
                            },
                            "locked": true,
                            "targetComponent": true
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    "additionalProperties": false
                  },
                  "designQuery": true,
                  "propertyQuery": true,
                  "styleId": true
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "components": {
          "type": [
            "array",
            "null"
          ],
          "items": true
        },
        "documentType": {
          "enum": [
            "document"
          ]
        },
        "componentProperties": {
          "type": "object",
          "properties": {},
          "additionalProperties": false
        },
        "themeData": {
          "type": "object",
          "properties": {},
          "additionalProperties": false
        },
        "fixerVersionsQuery": true,
        "themeConfigQuery": true
      },
      "additionalProperties": false
    },
    "Parent": true,
    "ClassnamesQuery": true,
    "ContentRoleQuery": true,
    "ControllersQuery": true,
    "CursorQuery": true,
    "DiscussionsQuery": true,
    "EditorsettingsQuery": true,
    "EffectsQuery": true,
    "FixerVersionsQuery": true,
    "GroupingQuery": true,
    "InnerElementsQuery": true,
    "InnerElementsMetaDataQuery": true,
    "IntentQuery": true,
    "LayoutSettingsQuery": true,
    "ManifestQuery": true,
    "MeasurementsQuery": true,
    "MigrationQuery": true,
    "NamingQuery": true,
    "NotificationsQuery": true,
    "PageSectionsQuery": true,
    "PatternsQuery": true,
    "PresetsQuery": true,
    "ReactionsQuery": true,
    "SlotsQuery": true,
    "SourceQuery": true,
    "StatesQuery": true,
    "ThemeConfigQuery": true,
    "TriggersQuery": true,
    "VariablesQuery": true
  },
  "themeConfig.json": {
    "$id": "urn:dm:schemas:themeConfig.json",
    "themeConfig": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "colorMapping": {
          "patternProperties": {
            "^color_([0-9]|(?:1|2|3|4|5)[0-9]|6[0-5])$": {
              "type": "string",
              "pattern": "^$|^color_([0-9]|(?:1|2|3|4|5)[0-9]|6[0-5])$|__empty__"
            }
          }
        },
        "colorNaming": {
          "patternProperties": {
            "^color_([0-9]|(?:1|2|3|4|5)[0-9]|6[0-5])$": {
              "type": "object",
              "properties": {
                "name": true,
                "order": true,
                "hidden": true
              }
            }
          }
        },
        "fontNaming": {
          "patternProperties": {
            "^font_([0-9]|10)$": {
              "type": "object",
              "properties": {
                "name": true,
                "order": true,
                "hidden": true
              }
            }
          }
        }
      },
      "additionalProperties": false
    }
  },
  "theme_data.json": {
    "$id": "urn:dm:schemas:theme_data.json",
    "WFlatTheme": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "THEME_DIRECTORY": {
          "type": "string",
          "pattern": "^[\\/\\-|0-9|a-z|A-Z]*$"
        },
        "BG_DIRECTORY": {
          "type": "string",
          "pattern": "^[\\/\\-|0-9|a-z|A-Z]*$"
        },
        "CONTACT_DIRECTORY": {
          "type": "string",
          "pattern": "^[\\/\\-|0-9|a-z|A-Z]*$"
        },
        "NETWORKS_DIRECTORY": {
          "type": "string",
          "pattern": "^[\\/\\-|0-9|a-z|A-Z]*$"
        },
        "EXTERNAL_LINKS_DIRECTORY": {
          "type": "string",
          "pattern": "^[\\/\\-|0-9|a-z|A-Z]*$"
        },
        "PAGES_DIRECTORY": {
          "type": "string",
          "pattern": "^[\\/\\-|0-9|a-z|A-Z]*$"
        },
        "WEB_THEME_DIRECTORY": {
          "type": "string",
          "pattern": "^[\\/\\-|0-9|a-z|A-Z]*$"
        },
        "BASE_THEME_DIRECTORY": {
          "type": "string",
          "pattern": "^[\\/\\-|0-9|a-z|A-Z]*$"
        },
        "siteBg": true,
        "color": {
          "type": "array",
          "items": {
            "type": [
              "string",
              "null"
            ],
            "pattern": "^(^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$)$"
          }
        },
        "font": {
          "type": "array",
          "items": true
        },
        "textTheme": {
          "type": "array",
          "items": {
            "type": [
              "object"
            ],
            "properties": {
              "fontStyle": {
                "type": "string",
                "enum": [
                  "normal",
                  "italic"
                ]
              },
              "fontWeight": {
                "type": "string",
                "enum": [
                  "normal",
                  "bold",
                  "bolder",
                  "lighter",
                  "100",
                  "200",
                  "300",
                  "400",
                  "500",
                  "600",
                  "700",
                  "800",
                  "900"
                ]
              },
              "fontVariant": {
                "type": "string",
                "enum": [
                  "normal",
                  "small-caps",
                  "inherit"
                ]
              },
              "fontSize": {
                "type": "string",
                "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
              },
              "minFontSize": {
                "type": "string",
                "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
              },
              "maxFontSize": {
                "type": "string",
                "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
              },
              "scale_maxFontSize": {
                "type": "string",
                "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
              },
              "scale_minFontSize": {
                "type": "string",
                "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
              },
              "fontFamily": true,
              "color": {
                "type": "string",
                "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
              },
              "lineHeight": {
                "type": "string",
                "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
              },
              "letterSpacing": {
                "type": "string",
                "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
              }
            },
            "additionalProperties": false
          }
        },
        "theme": {
          "type": "object",
          "properties": {
            "spx": {
              "type": "object",
              "properties": {
                "refWidth": true,
                "resolverType": {
                  "type": "string",
                  "enum": [
                    "scale",
                    "fixed"
                  ]
                }
              },
              "additionalProperties": false
            }
          },
          "additionalProperties": false
        },
        "fontDisplay": {
          "type": "string",
          "enum": [
            "auto",
            "block",
            "swap",
            "fallback",
            "optional"
          ]
        },
        "border": {
          "type": "array",
          "items": {
            "type": [
              "string",
              "null"
            ],
            "pattern": "^$|^(0|([0-9]*([.][0-9]+){0,1}(px|em)[\\s]*){1,4})([Ss][Oo][Ll][Ii][Dd]|[Dd][Aa][Ss][Hh][Ee][Dd]|[Dd][Oo][Tt][Tt][Ee][Dd]|[Dd][Oo][Uu][Bb][Ll][Ee]|[Gg][Rr][Oo][Oo][Vv][Ee]|[Ii][Nn][Ss][Ee][Tt]|[Nn][Oo][Nn][Ee]|[Oo][Uu][Tt][Ss][Ee][Tt]|[Rr][Ii][Dd][Gg][Ee]){0,1}[\\s]*([{\\[]color_([0-9]{1,2}|100)[}\\]]|(#(([0-9|a-f]){3}){1,2}){0,1})|\\[borderColor\\]?$"
          }
        },
        "padding1": {
          "type": "string",
          "pattern": "^$|^\\d*(.\\d+)?$|^(\\d+(.\\d+)?(em|px)|0(.0+)?)( +(\\d+(.\\d+)?(em|px)|0(.0+)?)){0,3}$"
        },
        "padding2": {
          "type": "string",
          "pattern": "^$|^\\d*(.\\d+)?$|^(\\d+(.\\d+)?(em|px)|0(.0+)?)( +(\\d+(.\\d+)?(em|px)|0(.0+)?)){0,3}$"
        },
        "padding3": {
          "type": "string",
          "pattern": "^$|^\\d*(.\\d+)?$|^(\\d+(.\\d+)?(em|px)|0(.0+)?)( +(\\d+(.\\d+)?(em|px)|0(.0+)?)){0,3}$"
        },
        "iconSize": {
          "type": "string",
          "pattern": "^\\d+(.\\d+)?(em|px)?$"
        },
        "bulletSize": {
          "type": "string",
          "pattern": "^\\d+(.\\d+)?(em|px)?$"
        },
        "headerSpacing": {
          "type": "string",
          "pattern": "^\\d+(.\\d+)?(em|px)?$"
        },
        "componentSpacing": {
          "type": "string",
          "pattern": "^\\d+(.\\d+)?(em|px)?$"
        },
        "itemSpacing": {
          "type": "string",
          "pattern": "^\\d+(.\\d+)?(em|px)?$"
        },
        "thumbSpacing": {
          "type": "string",
          "pattern": "^\\d+(.\\d+)?(em|px)?$"
        },
        "iconSpacing": {
          "type": "string",
          "pattern": "^\\d+(.\\d+)?(em|px)?$"
        },
        "mobileBg": true,
        "themePresets": true
      },
      "additionalProperties": false
    },
    "OverridableTheme": {
      "type": "object",
      "properties": {
        "spx": {
          "type": "object",
          "properties": {
            "refWidth": true,
            "resolverType": {
              "type": "string",
              "enum": [
                "scale",
                "fixed"
              ]
            }
          },
          "additionalProperties": false
        }
      },
      "additionalProperties": false
    },
    "TextTheme": {
      "type": [
        "object"
      ],
      "properties": {
        "fontStyle": {
          "type": "string",
          "enum": [
            "normal",
            "italic"
          ]
        },
        "fontWeight": {
          "type": "string",
          "enum": [
            "normal",
            "bold",
            "bolder",
            "lighter",
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
          ]
        },
        "fontVariant": {
          "type": "string",
          "enum": [
            "normal",
            "small-caps",
            "inherit"
          ]
        },
        "fontSize": {
          "type": "string",
          "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
        },
        "minFontSize": {
          "type": "string",
          "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
        },
        "maxFontSize": {
          "type": "string",
          "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
        },
        "scale_maxFontSize": {
          "type": "string",
          "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
        },
        "scale_minFontSize": {
          "type": "string",
          "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
        },
        "fontFamily": true,
        "color": {
          "type": "string",
          "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
        },
        "lineHeight": {
          "type": "string",
          "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
        },
        "letterSpacing": {
          "type": "string",
          "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
        }
      },
      "additionalProperties": false
    },
    "FontStyle": {
      "type": "string",
      "enum": [
        "normal",
        "italic"
      ]
    },
    "FontSize": {
      "type": "string",
      "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
    },
    "FontWeight": {
      "type": "string",
      "enum": [
        "normal",
        "bold",
        "bolder",
        "lighter",
        "100",
        "200",
        "300",
        "400",
        "500",
        "600",
        "700",
        "800",
        "900"
      ]
    },
    "FontVariant": {
      "type": "string",
      "enum": [
        "normal",
        "small-caps",
        "inherit"
      ]
    },
    "FontFamily": true,
    "TextColor": {
      "type": "string",
      "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
    },
    "LineHeight": {
      "type": "string",
      "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
    },
    "LetterSpacing": {
      "type": "string",
      "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
    },
    "PartialTextTheme": {
      "type": "object",
      "properties": {
        "fontStyle": {
          "type": "string",
          "enum": [
            "normal",
            "italic"
          ]
        },
        "fontWeight": {
          "type": "string",
          "enum": [
            "normal",
            "bold",
            "bolder",
            "lighter",
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
          ]
        },
        "fontVariant": {
          "type": "string",
          "enum": [
            "normal",
            "small-caps",
            "inherit"
          ]
        },
        "fontSize": {
          "type": "string",
          "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
        },
        "maxFontSize": {
          "type": "string",
          "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
        },
        "minFontSize": {
          "type": "string",
          "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
        },
        "scale_maxFontSize": {
          "type": "string",
          "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
        },
        "scale_minFontSize": {
          "type": "string",
          "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
        },
        "fontFamily": true,
        "color": {
          "type": "string",
          "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
        },
        "lineHeight": {
          "type": "string",
          "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
        },
        "letterSpacing": {
          "type": "string",
          "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
        }
      },
      "additionalProperties": false
    },
    "TextThemeWithDefaults": {
      "type": "object",
      "properties": {
        "fontStyle": {
          "type": "string",
          "enum": [
            "normal",
            "italic"
          ]
        },
        "fontWeight": {
          "type": "string",
          "enum": [
            "normal",
            "bold",
            "bolder",
            "lighter",
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
          ]
        },
        "fontVariant": {
          "type": "string",
          "enum": [
            "normal",
            "small-caps",
            "inherit"
          ]
        },
        "fontSize": {
          "type": "string",
          "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
        },
        "minFontSize": {
          "type": "string",
          "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
        },
        "maxFontSize": {
          "type": "string",
          "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
        },
        "scale_maxFontSize": {
          "type": "string",
          "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
        },
        "scale_minFontSize": {
          "type": "string",
          "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
        },
        "fontFamily": true,
        "color": {
          "type": "string",
          "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
        },
        "lineHeight": {
          "type": "string",
          "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
        },
        "letterSpacing": {
          "type": "string",
          "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
        }
      },
      "additionalProperties": false
    },
    "TopLevelStyle": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "skin": true,
        "style": {
          "type": "object",
          "properties": {
            "properties": true,
            "background": {
              "type": "object",
              "properties": {
                "gradient": {
                  "type": [
                    "array",
                    "null"
                  ],
                  "items": true
                }
              },
              "additionalProperties": false
            },
            "propertiesSource": {
              "type": "object",
              "additionalProperties": {
                "type": "string",
                "enum": [
                  "theme",
                  "value"
                ]
              }
            },
            "groups": true,
            "propertiesOverride": {
              "type": "object",
              "properties": {},
              "additionalProperties": {
                "type": "object",
                "properties": {
                  "fontStyle": {
                    "type": "string",
                    "enum": [
                      "normal",
                      "italic"
                    ]
                  },
                  "fontWeight": {
                    "type": "string",
                    "enum": [
                      "normal",
                      "bold",
                      "bolder",
                      "lighter",
                      "100",
                      "200",
                      "300",
                      "400",
                      "500",
                      "600",
                      "700",
                      "800",
                      "900"
                    ]
                  },
                  "fontVariant": {
                    "type": "string",
                    "enum": [
                      "normal",
                      "small-caps",
                      "inherit"
                    ]
                  },
                  "fontSize": {
                    "type": "string",
                    "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
                  },
                  "maxFontSize": {
                    "type": "string",
                    "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
                  },
                  "minFontSize": {
                    "type": "string",
                    "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
                  },
                  "scale_maxFontSize": {
                    "type": "string",
                    "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
                  },
                  "scale_minFontSize": {
                    "type": "string",
                    "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
                  },
                  "fontFamily": true,
                  "color": {
                    "type": "string",
                    "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
                  },
                  "lineHeight": {
                    "type": "string",
                    "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
                  },
                  "letterSpacing": {
                    "type": "string",
                    "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
                  }
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "styleType": {
          "type": "string",
          "enum": [
            "system",
            "custom",
            "userDefined"
          ]
        },
        "pageId": true,
        "compId": true,
        "componentClassName": true
      },
      "additionalProperties": false
    },
    "ComponentStyle": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "skin": true,
        "style": {
          "type": "object",
          "properties": {
            "properties": true,
            "background": {
              "type": "object",
              "properties": {
                "gradient": {
                  "type": [
                    "array",
                    "null"
                  ],
                  "items": true
                }
              },
              "additionalProperties": false
            },
            "propertiesSource": {
              "type": "object",
              "additionalProperties": {
                "type": "string",
                "enum": [
                  "theme",
                  "value"
                ]
              }
            },
            "groups": true,
            "propertiesOverride": {
              "type": "object",
              "properties": {},
              "additionalProperties": {
                "type": "object",
                "properties": {
                  "fontStyle": {
                    "type": "string",
                    "enum": [
                      "normal",
                      "italic"
                    ]
                  },
                  "fontWeight": {
                    "type": "string",
                    "enum": [
                      "normal",
                      "bold",
                      "bolder",
                      "lighter",
                      "100",
                      "200",
                      "300",
                      "400",
                      "500",
                      "600",
                      "700",
                      "800",
                      "900"
                    ]
                  },
                  "fontVariant": {
                    "type": "string",
                    "enum": [
                      "normal",
                      "small-caps",
                      "inherit"
                    ]
                  },
                  "fontSize": {
                    "type": "string",
                    "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
                  },
                  "maxFontSize": {
                    "type": "string",
                    "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
                  },
                  "minFontSize": {
                    "type": "string",
                    "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
                  },
                  "scale_maxFontSize": {
                    "type": "string",
                    "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
                  },
                  "scale_minFontSize": {
                    "type": "string",
                    "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
                  },
                  "fontFamily": true,
                  "color": {
                    "type": "string",
                    "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
                  },
                  "lineHeight": {
                    "type": "string",
                    "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
                  },
                  "letterSpacing": {
                    "type": "string",
                    "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
                  }
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "styleType": {
          "type": "string",
          "enum": [
            "custom"
          ]
        },
        "pageId": true,
        "compId": true,
        "componentClassName": true,
        "spx": {
          "type": "object",
          "properties": {
            "refWidth": true,
            "resolverType": {
              "type": "string",
              "enum": [
                "scale",
                "fixed"
              ]
            }
          },
          "additionalProperties": false
        },
        "themeOverrides": {
          "type": "object",
          "properties": {
            "spx": {
              "type": "object",
              "properties": {
                "refWidth": true,
                "resolverType": {
                  "type": "string",
                  "enum": [
                    "scale",
                    "fixed"
                  ]
                }
              },
              "additionalProperties": false
            }
          },
          "additionalProperties": false
        }
      },
      "additionalProperties": false
    },
    "GlobalStylesCollection": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "styles": {
          "type": [
            "array"
          ],
          "items": true
        }
      },
      "additionalProperties": false
    },
    "StyleObjectDefinition": {
      "type": "object",
      "properties": {
        "skin": true,
        "style": {
          "type": "object",
          "properties": {
            "properties": true,
            "background": {
              "type": "object",
              "properties": {
                "gradient": {
                  "type": [
                    "array",
                    "null"
                  ],
                  "items": true
                }
              },
              "additionalProperties": false
            },
            "propertiesSource": {
              "type": "object",
              "additionalProperties": {
                "type": "string",
                "enum": [
                  "theme",
                  "value"
                ]
              }
            },
            "groups": true,
            "propertiesOverride": {
              "type": "object",
              "properties": {},
              "additionalProperties": {
                "type": "object",
                "properties": {
                  "fontStyle": {
                    "type": "string",
                    "enum": [
                      "normal",
                      "italic"
                    ]
                  },
                  "fontWeight": {
                    "type": "string",
                    "enum": [
                      "normal",
                      "bold",
                      "bolder",
                      "lighter",
                      "100",
                      "200",
                      "300",
                      "400",
                      "500",
                      "600",
                      "700",
                      "800",
                      "900"
                    ]
                  },
                  "fontVariant": {
                    "type": "string",
                    "enum": [
                      "normal",
                      "small-caps",
                      "inherit"
                    ]
                  },
                  "fontSize": {
                    "type": "string",
                    "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
                  },
                  "maxFontSize": {
                    "type": "string",
                    "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
                  },
                  "minFontSize": {
                    "type": "string",
                    "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
                  },
                  "scale_maxFontSize": {
                    "type": "string",
                    "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
                  },
                  "scale_minFontSize": {
                    "type": "string",
                    "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
                  },
                  "fontFamily": true,
                  "color": {
                    "type": "string",
                    "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
                  },
                  "lineHeight": {
                    "type": "string",
                    "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
                  },
                  "letterSpacing": {
                    "type": "string",
                    "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
                  }
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "styleType": {
          "type": "string",
          "enum": [
            "system",
            "custom",
            "userDefined"
          ]
        },
        "pageId": true,
        "compId": true,
        "componentClassName": true
      },
      "additionalProperties": false
    },
    "RefArray": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "values": {
          "type": [
            "array"
          ],
          "items": true
        }
      },
      "additionalProperties": false
    },
    "VariantRelation": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "variants": {
          "type": "array",
          "items": true
        },
        "remoteVariants": {
          "type": "array",
          "items": true
        },
        "from": true,
        "to": true
      },
      "additionalProperties": false
    },
    "BreakpointRelation": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "breakpoint": true,
        "ref": true
      },
      "additionalProperties": false
    },
    "GradientLinearLayer": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "opacity": true,
        "fill": {
          "type": "object",
          "properties": {
            "type": {
              "type": "string",
              "enum": [
                "GradientLinear"
              ]
            },
            "repeat": true,
            "blendMode": {
              "type": "string",
              "enum": [
                "normal",
                "multiply",
                "screen",
                "darken",
                "lighten",
                "overlay",
                "colorDodge",
                "colorBurn",
                "hardLight",
                "softLight",
                "difference",
                "exclusion",
                "hue",
                "saturation",
                "color",
                "luminosity"
              ]
            },
            "angle": true,
            "colorStops": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "size": {
                    "type": "object",
                    "properties": {
                      "value": true,
                      "type": {
                        "enum": [
                          "px",
                          "em",
                          "rem",
                          "percentage",
                          "vh",
                          "vw",
                          "vmin",
                          "vmax"
                        ]
                      }
                    },
                    "additionalProperties": false
                  },
                  "color": {
                    "type": "string",
                    "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
                  },
                  "opacity": true
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        }
      },
      "additionalProperties": false
    },
    "GradientCircleLayer": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "opacity": true,
        "fill": {
          "type": "object",
          "properties": {
            "type": {
              "type": "string",
              "enum": [
                "GradientCircle"
              ]
            },
            "repeat": true,
            "blendMode": {
              "type": "string",
              "enum": [
                "normal",
                "multiply",
                "screen",
                "darken",
                "lighten",
                "overlay",
                "colorDodge",
                "colorBurn",
                "hardLight",
                "softLight",
                "difference",
                "exclusion",
                "hue",
                "saturation",
                "color",
                "luminosity"
              ]
            },
            "size": {
              "type": "object",
              "properties": {
                "keyword": {
                  "type": "string",
                  "enum": [
                    "closest-side",
                    "closest-corner",
                    "farthest-side",
                    "farthest-corner"
                  ]
                },
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "vh",
                    "vw",
                    "vmin",
                    "vmax"
                  ]
                }
              },
              "additionalProperties": false
            },
            "position": {
              "type": "object",
              "properties": {
                "x": {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "percentage",
                        "vh",
                        "vw",
                        "vmin",
                        "vmax"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "y": {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "percentage",
                        "vh",
                        "vw",
                        "vmin",
                        "vmax"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            "colorStops": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "size": {
                    "type": "object",
                    "properties": {
                      "value": true,
                      "type": {
                        "enum": [
                          "px",
                          "em",
                          "rem",
                          "percentage",
                          "vh",
                          "vw",
                          "vmin",
                          "vmax"
                        ]
                      }
                    },
                    "additionalProperties": false
                  },
                  "color": {
                    "type": "string",
                    "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
                  },
                  "opacity": true
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        }
      },
      "additionalProperties": false
    },
    "GradientEllipseLayer": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "opacity": true,
        "fill": {
          "type": "object",
          "properties": {
            "type": {
              "type": "string",
              "enum": [
                "GradientEllipse"
              ]
            },
            "repeat": true,
            "blendMode": {
              "type": "string",
              "enum": [
                "normal",
                "multiply",
                "screen",
                "darken",
                "lighten",
                "overlay",
                "colorDodge",
                "colorBurn",
                "hardLight",
                "softLight",
                "difference",
                "exclusion",
                "hue",
                "saturation",
                "color",
                "luminosity"
              ]
            },
            "size": {
              "type": "object",
              "properties": {
                "keyword": {
                  "type": "string",
                  "enum": [
                    "closest-side",
                    "closest-corner",
                    "farthest-side",
                    "farthest-corner"
                  ]
                },
                "width": {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "percentage",
                        "vh",
                        "vw",
                        "vmin",
                        "vmax"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "height": {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "percentage",
                        "vh",
                        "vw",
                        "vmin",
                        "vmax"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            "position": {
              "type": "object",
              "properties": {
                "x": {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "percentage",
                        "vh",
                        "vw",
                        "vmin",
                        "vmax"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "y": {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "percentage",
                        "vh",
                        "vw",
                        "vmin",
                        "vmax"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            "colorStops": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "size": {
                    "type": "object",
                    "properties": {
                      "value": true,
                      "type": {
                        "enum": [
                          "px",
                          "em",
                          "rem",
                          "percentage",
                          "vh",
                          "vw",
                          "vmin",
                          "vmax"
                        ]
                      }
                    },
                    "additionalProperties": false
                  },
                  "color": {
                    "type": "string",
                    "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
                  },
                  "opacity": true
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        }
      },
      "additionalProperties": false
    },
    "GradientMeshLayer": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "opacity": true,
        "fill": {
          "type": "object",
          "properties": {
            "type": {
              "type": "string",
              "enum": [
                "GradientMesh"
              ]
            },
            "gradients": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "type": {
                    "type": "string",
                    "enum": [
                      "GradientCircle"
                    ]
                  },
                  "repeat": true,
                  "blendMode": {
                    "type": "string",
                    "enum": [
                      "normal",
                      "multiply",
                      "screen",
                      "darken",
                      "lighten",
                      "overlay",
                      "colorDodge",
                      "colorBurn",
                      "hardLight",
                      "softLight",
                      "difference",
                      "exclusion",
                      "hue",
                      "saturation",
                      "color",
                      "luminosity"
                    ]
                  },
                  "size": {
                    "type": "object",
                    "properties": {
                      "keyword": {
                        "type": "string",
                        "enum": [
                          "closest-side",
                          "closest-corner",
                          "farthest-side",
                          "farthest-corner"
                        ]
                      },
                      "value": true,
                      "type": {
                        "enum": [
                          "px",
                          "em",
                          "rem",
                          "vh",
                          "vw",
                          "vmin",
                          "vmax"
                        ]
                      }
                    },
                    "additionalProperties": false
                  },
                  "position": {
                    "type": "object",
                    "properties": {
                      "x": {
                        "type": "object",
                        "properties": {
                          "value": true,
                          "type": {
                            "enum": [
                              "px",
                              "em",
                              "rem",
                              "percentage",
                              "vh",
                              "vw",
                              "vmin",
                              "vmax"
                            ]
                          }
                        },
                        "additionalProperties": false
                      },
                      "y": {
                        "type": "object",
                        "properties": {
                          "value": true,
                          "type": {
                            "enum": [
                              "px",
                              "em",
                              "rem",
                              "percentage",
                              "vh",
                              "vw",
                              "vmin",
                              "vmax"
                            ]
                          }
                        },
                        "additionalProperties": false
                      }
                    },
                    "additionalProperties": false
                  },
                  "colorStops": {
                    "type": "array",
                    "items": {
                      "type": "object",
                      "properties": {
                        "size": {
                          "type": "object",
                          "properties": {
                            "value": true,
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "percentage",
                                "vh",
                                "vw",
                                "vmin",
                                "vmax"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        "color": {
                          "type": "string",
                          "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
                        },
                        "opacity": true
                      },
                      "additionalProperties": false
                    }
                  }
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        }
      },
      "additionalProperties": false
    },
    "GradientConicLayer": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "opacity": true,
        "fill": {
          "type": "object",
          "properties": {
            "type": {
              "type": "string",
              "enum": [
                "GradientConic"
              ]
            },
            "repeat": true,
            "blendMode": {
              "type": "string",
              "enum": [
                "normal",
                "multiply",
                "screen",
                "darken",
                "lighten",
                "overlay",
                "colorDodge",
                "colorBurn",
                "hardLight",
                "softLight",
                "difference",
                "exclusion",
                "hue",
                "saturation",
                "color",
                "luminosity"
              ]
            },
            "angle": true,
            "position": {
              "type": "object",
              "properties": {
                "x": {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "percentage",
                        "vh",
                        "vw",
                        "vmin",
                        "vmax"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "y": {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "percentage",
                        "vh",
                        "vw",
                        "vmin",
                        "vmax"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            "colorStops": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "size": {
                    "type": "object",
                    "properties": {
                      "value": true,
                      "type": {
                        "enum": [
                          "deg",
                          "percentage"
                        ]
                      }
                    },
                    "additionalProperties": false
                  },
                  "color": {
                    "type": "string",
                    "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
                  },
                  "opacity": true
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        }
      },
      "additionalProperties": false
    },
    "SolidColorLayer": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "opacity": true,
        "fill": {
          "type": "object",
          "properties": {
            "type": {
              "type": "string",
              "enum": [
                "SolidColor"
              ]
            },
            "color": {
              "type": "string",
              "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
            }
          },
          "additionalProperties": false
        }
      },
      "additionalProperties": false
    }
  },
  "transformations_data.json": {
    "$id": "urn:dm:schemas:transformations_data.json",
    "TransformData": {
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:translate\\/x|translate\\/y|origin\\/x|origin\\/y)$"
                  },
                  "variableId": true
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": true,
        "id": true,
        "metaData": true,
        "scale": {
          "type": "object",
          "properties": {
            "x": true,
            "y": true
          },
          "additionalProperties": false
        },
        "rotate": true,
        "translate": {
          "type": "object",
          "properties": {
            "x": {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            "y": {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            }
          },
          "additionalProperties": false
        },
        "skew": {
          "type": "object",
          "properties": {
            "x": true,
            "y": true
          },
          "additionalProperties": false
        },
        "origin": {
          "type": "object",
          "properties": {
            "x": {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            "y": {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            }
          },
          "additionalProperties": false
        },
        "opacity": true,
        "hidden": true,
        "zLayer": {
          "type": "string",
          "enum": [
            "BELOW_PINNED",
            "ABOVE_PINNED",
            "ABOVE_ALL_COMPS"
          ]
        }
      },
      "additionalProperties": false
    },
    "RefArray": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "values": {
          "type": [
            "array"
          ],
          "items": true
        }
      },
      "additionalProperties": false
    },
    "VariantRelation": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "variants": {
          "type": "array",
          "items": true
        },
        "remoteVariants": {
          "type": "array",
          "items": true
        },
        "from": true,
        "to": true
      },
      "additionalProperties": false
    }
  },
  "transitions_data.json": {
    "$id": "urn:dm:schemas:transitions_data.json",
    "TransitionData": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "timing-function": {
          "oneOf": [
            {
              "type": "string",
              "enum": [
                "ease",
                "linear",
                "ease-in",
                "ease-out",
                "ease-in-out"
              ]
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "cubic-bezier"
                  ]
                },
                "params": {
                  "type": "array",
                  "items": true
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "duration": true,
        "delay": true,
        "viewPortThreshold": true,
        "isLegacyCrossFade": true
      },
      "additionalProperties": false
    },
    "RefArray": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "values": {
          "type": [
            "array"
          ],
          "items": true
        }
      },
      "additionalProperties": false
    },
    "VariantRelation": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "variants": {
          "type": "array",
          "items": true
        },
        "remoteVariants": {
          "type": "array",
          "items": true
        },
        "from": true,
        "to": true
      },
      "additionalProperties": false
    }
  },
  "triggers.json": {
    "$id": "urn:dm:schemas:triggers.json",
    "Triggers": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "values": {
          "type": "array",
          "items": true
        }
      },
      "additionalProperties": false
    }
  },
  "variables.json": {
    "$id": "urn:dm:schemas:variables.json",
    "VariablesList": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "variables": {
          "type": [
            "array"
          ],
          "items": true
        }
      },
      "additionalProperties": false
    },
    "UnitSizeVar": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "name": true,
        "value": true
      },
      "additionalProperties": false
    },
    "UnitSizeValue": {
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": true
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": true,
        "id": true,
        "metaData": true,
        "value": {
          "type": "object",
          "properties": {
            "value": true,
            "type": {
              "enum": [
                "px",
                "em",
                "rem",
                "fr",
                "percentage",
                "vh",
                "vw",
                "spx",
                "siteWidthPercentage"
              ]
            }
          },
          "additionalProperties": false
        }
      },
      "additionalProperties": false
    },
    "NumberVar": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "name": true,
        "value": true
      },
      "additionalProperties": false
    },
    "NumberValue": {
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": true
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": true,
        "id": true,
        "metaData": true,
        "value": true
      },
      "additionalProperties": false
    },
    "ItemsAlignmentVar": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "name": true,
        "value": true
      },
      "additionalProperties": false
    },
    "ItemsAlignmentValue": {
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": true
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": true,
        "id": true,
        "metaData": true,
        "value": {
          "type": "string",
          "enum": [
            "start",
            "end",
            "center",
            "stretch",
            "content"
          ]
        }
      },
      "additionalProperties": false
    },
    "JustifyContentVar": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "name": true,
        "value": true
      },
      "additionalProperties": false
    },
    "JustifyContentValue": {
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": true
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": true,
        "id": true,
        "metaData": true,
        "value": {
          "enum": [
            "start",
            "center",
            "end",
            "spaceBetween",
            "spaceAround",
            "spaceEvenly"
          ]
        }
      },
      "additionalProperties": false
    },
    "PositionTypeVar": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "name": true,
        "value": true
      },
      "additionalProperties": false
    },
    "PositionTypeValue": {
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": true
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": true,
        "id": true,
        "metaData": true,
        "value": {
          "enum": [
            "sticky",
            "stickyToHeader",
            "absolute",
            "relative"
          ]
        }
      },
      "additionalProperties": false
    },
    "LayoutSizeVar": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "name": true,
        "value": true
      },
      "additionalProperties": false
    },
    "LayoutSizeValue": {
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": true
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": true,
        "id": true,
        "metaData": true,
        "value": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "value": true,
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "formula": true,
                    "values": {
                      "type": "object",
                      "properties": {},
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "properties": {
                              "value": true,
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": true
                            }
                          }
                        ]
                      }
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        }
      },
      "additionalProperties": false
    },
    "HeightVar": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "name": true,
        "value": true
      },
      "additionalProperties": false
    },
    "HeightValue": {
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": true
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": true,
        "id": true,
        "metaData": true,
        "value": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "type": {
                  "enum": [
                    "aspectRatio"
                  ]
                },
                "value": true
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "value": true,
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": true
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "properties": {
                        "formula": true,
                        "values": {
                          "type": "object",
                          "properties": {},
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "properties": {
                                  "value": true,
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": true
                                }
                              }
                            ]
                          }
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            }
          ]
        }
      },
      "additionalProperties": false
    },
    "KeywordLengthVar": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "name": true,
        "value": true
      },
      "additionalProperties": false
    },
    "KeywordLengthValue": {
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": true
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": true,
        "id": true,
        "metaData": true,
        "value": {
          "enum": [
            "auto-fill",
            "auto-fit"
          ]
        }
      },
      "additionalProperties": false
    },
    "NumVar": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "name": true,
        "value": true
      },
      "additionalProperties": false
    },
    "NumValue": {
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": true
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": true,
        "id": true,
        "metaData": true,
        "value": {
          "allOf": [
            {
              "anyOf": [
                {
                  "type": "string",
                  "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$"
                },
                true,
                {
                  "type": "string",
                  "enum": [
                    "inherit",
                    "initial",
                    "unset",
                    "revert",
                    "revert-layer"
                  ]
                }
              ]
            },
            {}
          ]
        }
      },
      "additionalProperties": false
    },
    "LengthVar": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "name": true,
        "value": true
      },
      "additionalProperties": false
    },
    "LengthValue": {
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": true
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": true,
        "id": true,
        "metaData": true,
        "value": {
          "allOf": [
            {
              "anyOf": [
                {
                  "type": "string",
                  "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$"
                },
                true,
                {
                  "type": "string",
                  "enum": [
                    "inherit",
                    "initial",
                    "unset",
                    "revert",
                    "revert-layer"
                  ]
                }
              ]
            },
            {}
          ]
        }
      },
      "additionalProperties": false
    },
    "AngleVar": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "name": true,
        "value": true
      },
      "additionalProperties": false
    },
    "AngleValue": {
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": true
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": true,
        "id": true,
        "metaData": true,
        "value": {
          "allOf": [
            {
              "anyOf": [
                {
                  "type": "string",
                  "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$"
                },
                true,
                {
                  "type": "string",
                  "enum": [
                    "inherit",
                    "initial",
                    "unset",
                    "revert",
                    "revert-layer"
                  ]
                }
              ]
            },
            {}
          ]
        }
      },
      "additionalProperties": false
    },
    "ColorVar": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "name": true,
        "value": true
      },
      "additionalProperties": false
    },
    "ColorValue": {
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": true
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": true,
        "id": true,
        "metaData": true,
        "value": {
          "allOf": [
            {
              "anyOf": [
                {
                  "type": "string",
                  "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$"
                },
                true,
                {
                  "type": "string",
                  "enum": [
                    "inherit",
                    "initial",
                    "unset",
                    "revert",
                    "revert-layer"
                  ]
                }
              ]
            },
            {}
          ]
        }
      },
      "additionalProperties": false
    },
    "PercentageVar": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "name": true,
        "value": true
      },
      "additionalProperties": false
    },
    "PercentageValue": {
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": true
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": true,
        "id": true,
        "metaData": true,
        "value": {
          "allOf": [
            {
              "anyOf": [
                {
                  "type": "string",
                  "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$"
                },
                true,
                {
                  "type": "string",
                  "enum": [
                    "inherit",
                    "initial",
                    "unset",
                    "revert",
                    "revert-layer"
                  ]
                }
              ]
            },
            {}
          ]
        }
      },
      "additionalProperties": false
    },
    "BorderEdgeStyleVar": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "name": true,
        "value": true
      },
      "additionalProperties": false
    },
    "BorderEdgeStyleValue": {
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": true
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": true,
        "id": true,
        "metaData": true,
        "value": {
          "allOf": [
            {
              "anyOf": [
                {
                  "type": "string",
                  "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$"
                },
                {
                  "type": "string",
                  "enum": [
                    "none",
                    "hidden",
                    "dotted",
                    "dashed",
                    "solid",
                    "double",
                    "groove",
                    "ridge",
                    "inset",
                    "outset"
                  ]
                },
                {
                  "type": "string",
                  "enum": [
                    "inherit",
                    "initial",
                    "unset",
                    "revert",
                    "revert-layer"
                  ]
                }
              ]
            },
            {}
          ]
        }
      },
      "additionalProperties": false
    },
    "BorderEdgeWidthVar": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "name": true,
        "value": true
      },
      "additionalProperties": false
    },
    "BorderEdgeWidthValue": {
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": true
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": true,
        "id": true,
        "metaData": true,
        "value": {
          "allOf": [
            {
              "anyOf": [
                {
                  "allOf": [
                    {
                      "anyOf": [
                        {
                          "type": "string",
                          "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$"
                        },
                        true,
                        {
                          "type": "string",
                          "enum": [
                            "inherit",
                            "initial",
                            "unset",
                            "revert",
                            "revert-layer"
                          ]
                        }
                      ]
                    },
                    {}
                  ]
                },
                {
                  "type": "string",
                  "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$"
                },
                true,
                {
                  "type": "string",
                  "enum": [
                    "inherit",
                    "initial",
                    "unset",
                    "revert",
                    "revert-layer"
                  ]
                }
              ]
            },
            {}
          ]
        }
      },
      "additionalProperties": false
    },
    "BorderWidthVar": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "name": true,
        "value": true
      },
      "additionalProperties": false
    },
    "BorderWidthValue": {
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": true
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": true,
        "id": true,
        "metaData": true,
        "value": {
          "allOf": [
            {
              "anyOf": [
                {
                  "allOf": [
                    {
                      "anyOf": [
                        {
                          "type": "string",
                          "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$"
                        },
                        true,
                        {
                          "type": "string",
                          "enum": [
                            "inherit",
                            "initial",
                            "unset",
                            "revert",
                            "revert-layer"
                          ]
                        }
                      ]
                    },
                    {}
                  ]
                },
                {
                  "type": "string",
                  "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$"
                },
                {
                  "type": "string",
                  "pattern": "^(thin|medium|thick|calc\\([^(),]+\\)|(\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))(\\s+(thin|medium|thick|calc\\([^(),]+\\)|(\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))){0,3}$"
                },
                {
                  "type": "string",
                  "enum": [
                    "inherit",
                    "initial",
                    "unset",
                    "revert",
                    "revert-layer"
                  ]
                }
              ]
            },
            {}
          ]
        }
      },
      "additionalProperties": false
    },
    "BorderStyleVar": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "name": true,
        "value": true
      },
      "additionalProperties": false
    },
    "BorderStyleValue": {
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": true
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": true,
        "id": true,
        "metaData": true,
        "value": {
          "allOf": [
            {
              "anyOf": [
                {
                  "type": "string",
                  "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$"
                },
                {
                  "type": "string",
                  "pattern": "^(none|hidden|dotted|dashed|solid|double|groove|ridge|inset|outset)(\\s+(none|hidden|dotted|dashed|solid|double|groove|ridge|inset|outset)){0,3}$"
                },
                {
                  "type": "string",
                  "enum": [
                    "inherit",
                    "initial",
                    "unset",
                    "revert",
                    "revert-layer"
                  ]
                }
              ]
            },
            {}
          ]
        }
      },
      "additionalProperties": false
    },
    "BorderColorVar": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "name": true,
        "value": true
      },
      "additionalProperties": false
    },
    "BorderColorValue": {
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": true
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": true,
        "id": true,
        "metaData": true,
        "value": {
          "allOf": [
            {
              "anyOf": [
                {
                  "allOf": [
                    {
                      "anyOf": [
                        {
                          "type": "string",
                          "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$"
                        },
                        true,
                        {
                          "type": "string",
                          "enum": [
                            "inherit",
                            "initial",
                            "unset",
                            "revert",
                            "revert-layer"
                          ]
                        }
                      ]
                    },
                    {}
                  ]
                },
                {
                  "type": "string",
                  "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$"
                },
                true,
                {
                  "type": "string",
                  "enum": [
                    "inherit",
                    "initial",
                    "unset",
                    "revert",
                    "revert-layer"
                  ]
                }
              ]
            },
            {}
          ]
        }
      },
      "additionalProperties": false
    },
    "BorderVar": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "name": true,
        "value": true
      },
      "additionalProperties": false
    },
    "BorderValue": {
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": true
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": true,
        "id": true,
        "metaData": true,
        "value": {
          "allOf": [
            {
              "anyOf": [
                {
                  "type": "string",
                  "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$"
                },
                true,
                {
                  "type": "string",
                  "enum": [
                    "inherit",
                    "initial",
                    "unset",
                    "revert",
                    "revert-layer"
                  ]
                }
              ]
            },
            {}
          ]
        }
      },
      "additionalProperties": false
    },
    "BorderCornerRadiusVar": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "name": true,
        "value": true
      },
      "additionalProperties": false
    },
    "BorderCornerRadiusValue": {
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": true
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": true,
        "id": true,
        "metaData": true,
        "value": {
          "allOf": [
            {
              "anyOf": [
                {
                  "allOf": [
                    {
                      "anyOf": [
                        {
                          "allOf": [
                            {
                              "anyOf": [
                                {
                                  "type": "string",
                                  "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$"
                                },
                                true,
                                {
                                  "type": "string",
                                  "enum": [
                                    "inherit",
                                    "initial",
                                    "unset",
                                    "revert",
                                    "revert-layer"
                                  ]
                                }
                              ]
                            },
                            {}
                          ]
                        },
                        {
                          "type": "string",
                          "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$"
                        },
                        true,
                        {
                          "type": "string",
                          "enum": [
                            "inherit",
                            "initial",
                            "unset",
                            "revert",
                            "revert-layer"
                          ]
                        }
                      ]
                    },
                    {}
                  ]
                },
                {
                  "allOf": [
                    {
                      "anyOf": [
                        {
                          "type": "string",
                          "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$"
                        },
                        true,
                        {
                          "type": "string",
                          "enum": [
                            "inherit",
                            "initial",
                            "unset",
                            "revert",
                            "revert-layer"
                          ]
                        }
                      ]
                    },
                    {}
                  ]
                },
                {
                  "type": "string",
                  "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$"
                },
                {
                  "type": "string",
                  "pattern": "^(calc\\([^(),]+\\)|\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%))(\\s+(calc\\([^(),]+\\)|\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%)))?$"
                },
                {
                  "type": "string",
                  "enum": [
                    "inherit",
                    "initial",
                    "unset",
                    "revert",
                    "revert-layer"
                  ]
                }
              ]
            },
            {}
          ]
        }
      },
      "additionalProperties": false
    },
    "BorderRadiusVar": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "name": true,
        "value": true
      },
      "additionalProperties": false
    },
    "BorderRadiusValue": {
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": true
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": true,
        "id": true,
        "metaData": true,
        "value": {
          "allOf": [
            {
              "anyOf": [
                {
                  "type": "string",
                  "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$"
                },
                {
                  "type": "string",
                  "pattern": "^(0|calc\\([^(),]+\\)|\\d+(\\.\\d+)?(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%))(\\s+(0|calc\\([^(),]+\\)|\\d+(\\.\\d+)?(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%))){0,3}(\\s*/\\s*(0|calc\\([^(),]+\\)|\\d+(\\.\\d+)?(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%))(\\s+(0|calc\\([^(),]+\\)|\\d+(\\.\\d+)?(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%))){0,3})?$"
                },
                {
                  "type": "string",
                  "enum": [
                    "inherit",
                    "initial",
                    "unset",
                    "revert",
                    "revert-layer"
                  ]
                }
              ]
            },
            {}
          ]
        }
      },
      "additionalProperties": false
    },
    "FontVar": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "name": true,
        "value": true
      },
      "additionalProperties": false
    },
    "FontValue": {
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": true
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": true,
        "id": true,
        "metaData": true,
        "value": {
          "allOf": [
            {
              "anyOf": [
                {
                  "type": "string",
                  "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$"
                },
                true,
                {
                  "type": "string",
                  "enum": [
                    "inherit",
                    "initial",
                    "unset",
                    "revert",
                    "revert-layer"
                  ]
                }
              ]
            },
            {}
          ]
        }
      },
      "additionalProperties": false
    },
    "FontSizeVar": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "name": true,
        "value": true
      },
      "additionalProperties": false
    },
    "FontSizeValue": {
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": true
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": true,
        "id": true,
        "metaData": true,
        "value": {
          "allOf": [
            {
              "anyOf": [
                {
                  "allOf": [
                    {
                      "anyOf": [
                        {
                          "type": "string",
                          "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$"
                        },
                        true,
                        {
                          "type": "string",
                          "enum": [
                            "inherit",
                            "initial",
                            "unset",
                            "revert",
                            "revert-layer"
                          ]
                        }
                      ]
                    },
                    {}
                  ]
                },
                {
                  "type": "string",
                  "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$"
                },
                true,
                {
                  "type": "string",
                  "enum": [
                    "inherit",
                    "initial",
                    "unset",
                    "revert",
                    "revert-layer"
                  ]
                }
              ]
            },
            {}
          ]
        }
      },
      "additionalProperties": false
    },
    "FontStretchVar": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "name": true,
        "value": true
      },
      "additionalProperties": false
    },
    "FontStretchValue": {
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": true
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": true,
        "id": true,
        "metaData": true,
        "value": {
          "allOf": [
            {
              "anyOf": [
                {
                  "allOf": [
                    {
                      "anyOf": [
                        {
                          "type": "string",
                          "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$"
                        },
                        true,
                        {
                          "type": "string",
                          "enum": [
                            "inherit",
                            "initial",
                            "unset",
                            "revert",
                            "revert-layer"
                          ]
                        }
                      ]
                    },
                    {}
                  ]
                },
                {
                  "type": "string",
                  "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$"
                },
                true,
                {
                  "type": "string",
                  "enum": [
                    "inherit",
                    "initial",
                    "unset",
                    "revert",
                    "revert-layer"
                  ]
                }
              ]
            },
            {}
          ]
        }
      },
      "additionalProperties": false
    },
    "FontStyleVar": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "name": true,
        "value": true
      },
      "additionalProperties": false
    },
    "FontStyleValue": {
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": true
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": true,
        "id": true,
        "metaData": true,
        "value": {
          "allOf": [
            {
              "anyOf": [
                {
                  "type": "string",
                  "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$"
                },
                true,
                {
                  "type": "string",
                  "enum": [
                    "inherit",
                    "initial",
                    "unset",
                    "revert",
                    "revert-layer"
                  ]
                }
              ]
            },
            {}
          ]
        }
      },
      "additionalProperties": false
    },
    "FontVariantVar": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "name": true,
        "value": true
      },
      "additionalProperties": false
    },
    "FontVariantValue": {
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": true
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": true,
        "id": true,
        "metaData": true,
        "value": {
          "allOf": [
            {
              "anyOf": [
                {
                  "type": "string",
                  "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$"
                },
                true,
                {
                  "type": "string",
                  "enum": [
                    "inherit",
                    "initial",
                    "unset",
                    "revert",
                    "revert-layer"
                  ]
                }
              ]
            },
            {}
          ]
        }
      },
      "additionalProperties": false
    },
    "FontWeightVar": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "name": true,
        "value": true
      },
      "additionalProperties": false
    },
    "FontWeightValue": {
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": true
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": true,
        "id": true,
        "metaData": true,
        "value": {
          "allOf": [
            {
              "anyOf": [
                {
                  "type": "string",
                  "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$"
                },
                true,
                {
                  "type": "string",
                  "enum": [
                    "inherit",
                    "initial",
                    "unset",
                    "revert",
                    "revert-layer"
                  ]
                }
              ]
            },
            {}
          ]
        }
      },
      "additionalProperties": false
    },
    "FontFamilyVar": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "name": true,
        "value": true
      },
      "additionalProperties": false
    },
    "FontFamilyValue": {
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": true
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": true,
        "id": true,
        "metaData": true,
        "value": {
          "allOf": [
            {
              "anyOf": [
                {
                  "allOf": [
                    {
                      "anyOf": [
                        {
                          "type": "string",
                          "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$"
                        },
                        {
                          "type": "string",
                          "pattern": "^\"(?:[^\"\\\\]|\\\\.)*\"|'(?:[^'\\\\]|\\\\.)*'$"
                        },
                        {
                          "type": "string",
                          "enum": [
                            "inherit",
                            "initial",
                            "unset",
                            "revert",
                            "revert-layer"
                          ]
                        }
                      ]
                    },
                    {}
                  ]
                },
                {
                  "type": "string",
                  "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$"
                },
                true,
                {
                  "type": "string",
                  "enum": [
                    "inherit",
                    "initial",
                    "unset",
                    "revert",
                    "revert-layer"
                  ]
                }
              ]
            },
            {}
          ]
        }
      },
      "additionalProperties": false
    },
    "LineHeightVar": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "name": true,
        "value": true
      },
      "additionalProperties": false
    },
    "LineHeightValue": {
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": true
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": true,
        "id": true,
        "metaData": true,
        "value": {
          "allOf": [
            {
              "anyOf": [
                {
                  "allOf": [
                    {
                      "anyOf": [
                        {
                          "type": "string",
                          "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$"
                        },
                        true,
                        {
                          "type": "string",
                          "enum": [
                            "inherit",
                            "initial",
                            "unset",
                            "revert",
                            "revert-layer"
                          ]
                        }
                      ]
                    },
                    {}
                  ]
                },
                {
                  "type": "string",
                  "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$"
                },
                true,
                {
                  "type": "string",
                  "enum": [
                    "inherit",
                    "initial",
                    "unset",
                    "revert",
                    "revert-layer"
                  ]
                }
              ]
            },
            {}
          ]
        }
      },
      "additionalProperties": false
    },
    "LetterSpacingVar": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "name": true,
        "value": true
      },
      "additionalProperties": false
    },
    "LetterSpacingValue": {
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": true
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": true,
        "id": true,
        "metaData": true,
        "value": {
          "allOf": [
            {
              "anyOf": [
                {
                  "allOf": [
                    {
                      "anyOf": [
                        {
                          "type": "string",
                          "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$"
                        },
                        true,
                        {
                          "type": "string",
                          "enum": [
                            "inherit",
                            "initial",
                            "unset",
                            "revert",
                            "revert-layer"
                          ]
                        }
                      ]
                    },
                    {}
                  ]
                },
                {
                  "type": "string",
                  "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$"
                },
                true,
                {
                  "type": "string",
                  "enum": [
                    "inherit",
                    "initial",
                    "unset",
                    "revert",
                    "revert-layer"
                  ]
                }
              ]
            },
            {}
          ]
        }
      },
      "additionalProperties": false
    },
    "TextAlignVar": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "name": true,
        "value": true
      },
      "additionalProperties": false
    },
    "TextAlignValue": {
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": true
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": true,
        "id": true,
        "metaData": true,
        "value": {
          "allOf": [
            {
              "anyOf": [
                {
                  "type": "string",
                  "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$"
                },
                {
                  "type": "string",
                  "enum": [
                    "left",
                    "right",
                    "center",
                    "justify",
                    "start",
                    "end",
                    "match-parent"
                  ]
                },
                {
                  "type": "string",
                  "enum": [
                    "inherit",
                    "initial",
                    "unset",
                    "revert",
                    "revert-layer"
                  ]
                }
              ]
            },
            {}
          ]
        }
      },
      "additionalProperties": false
    },
    "TextTransformVar": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "name": true,
        "value": true
      },
      "additionalProperties": false
    },
    "TextTransformValue": {
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": true
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": true,
        "id": true,
        "metaData": true,
        "value": {
          "allOf": [
            {
              "anyOf": [
                {
                  "type": "string",
                  "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$"
                },
                {
                  "type": "string",
                  "enum": [
                    "none",
                    "capitalize",
                    "uppercase",
                    "lowercase",
                    "full-width",
                    "full-size-kana"
                  ]
                },
                {
                  "type": "string",
                  "enum": [
                    "inherit",
                    "initial",
                    "unset",
                    "revert",
                    "revert-layer"
                  ]
                }
              ]
            },
            {}
          ]
        }
      },
      "additionalProperties": false
    },
    "TextShadowVar": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "name": true,
        "value": true
      },
      "additionalProperties": false
    },
    "TextShadowValue": {
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": true
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": true,
        "id": true,
        "metaData": true,
        "value": {
          "allOf": [
            {
              "anyOf": [
                {
                  "type": "string",
                  "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$"
                },
                true,
                {
                  "type": "string",
                  "enum": [
                    "inherit",
                    "initial",
                    "unset",
                    "revert",
                    "revert-layer"
                  ]
                }
              ]
            },
            {}
          ]
        }
      },
      "additionalProperties": false
    },
    "TextDecorationVar": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "name": true,
        "value": true
      },
      "additionalProperties": false
    },
    "TextDecorationValue": {
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": true
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": true,
        "id": true,
        "metaData": true,
        "value": {
          "allOf": [
            {
              "anyOf": [
                {
                  "type": "string",
                  "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$"
                },
                true,
                {
                  "type": "string",
                  "enum": [
                    "inherit",
                    "initial",
                    "unset",
                    "revert",
                    "revert-layer"
                  ]
                }
              ]
            },
            {}
          ]
        }
      },
      "additionalProperties": false
    },
    "TextDecorationLineVar": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "name": true,
        "value": true
      },
      "additionalProperties": false
    },
    "TextDecorationLineValue": {
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": true
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": true,
        "id": true,
        "metaData": true,
        "value": {
          "allOf": [
            {
              "anyOf": [
                {
                  "type": "string",
                  "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$"
                },
                true,
                {
                  "type": "string",
                  "enum": [
                    "inherit",
                    "initial",
                    "unset",
                    "revert",
                    "revert-layer"
                  ]
                }
              ]
            },
            {}
          ]
        }
      },
      "additionalProperties": false
    },
    "TextDecorationStyleVar": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "name": true,
        "value": true
      },
      "additionalProperties": false
    },
    "TextDecorationStyleValue": {
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": true
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": true,
        "id": true,
        "metaData": true,
        "value": {
          "allOf": [
            {
              "anyOf": [
                {
                  "type": "string",
                  "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$"
                },
                {
                  "type": "string",
                  "enum": [
                    "solid",
                    "double",
                    "dotted",
                    "dashed",
                    "wavy"
                  ]
                },
                {
                  "type": "string",
                  "enum": [
                    "inherit",
                    "initial",
                    "unset",
                    "revert",
                    "revert-layer"
                  ]
                }
              ]
            },
            {}
          ]
        }
      },
      "additionalProperties": false
    },
    "TextDecorationThicknessVar": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "name": true,
        "value": true
      },
      "additionalProperties": false
    },
    "TextDecorationThicknessValue": {
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": true
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": true,
        "id": true,
        "metaData": true,
        "value": {
          "allOf": [
            {
              "anyOf": [
                {
                  "allOf": [
                    {
                      "anyOf": [
                        {
                          "type": "string",
                          "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$"
                        },
                        true,
                        {
                          "type": "string",
                          "enum": [
                            "inherit",
                            "initial",
                            "unset",
                            "revert",
                            "revert-layer"
                          ]
                        }
                      ]
                    },
                    {}
                  ]
                },
                {
                  "type": "string",
                  "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$"
                },
                true,
                {
                  "type": "string",
                  "enum": [
                    "inherit",
                    "initial",
                    "unset",
                    "revert",
                    "revert-layer"
                  ]
                }
              ]
            },
            {}
          ]
        }
      },
      "additionalProperties": false
    },
    "PaddingVar": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "name": true,
        "value": true
      },
      "additionalProperties": false
    },
    "PaddingValue": {
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": true
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": true,
        "id": true,
        "metaData": true,
        "value": {
          "anyOf": [
            {
              "type": "string",
              "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$"
            },
            {
              "type": "string",
              "pattern": "^(0|calc\\([^(),]+\\)|(\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%)))(\\s+(0|calc\\([^(),]+\\)|(\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%)))){0,3}$"
            },
            {
              "type": "string",
              "enum": [
                "inherit",
                "initial",
                "unset",
                "revert",
                "revert-layer"
              ]
            }
          ]
        }
      },
      "additionalProperties": false
    },
    "PaddingEdgeVar": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "name": true,
        "value": true
      },
      "additionalProperties": false
    },
    "PaddingEdgeValue": {
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": true
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": true,
        "id": true,
        "metaData": true,
        "value": {
          "anyOf": [
            {
              "allOf": [
                {
                  "anyOf": [
                    {
                      "allOf": [
                        {
                          "anyOf": [
                            {
                              "type": "string",
                              "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$"
                            },
                            true,
                            {
                              "type": "string",
                              "enum": [
                                "inherit",
                                "initial",
                                "unset",
                                "revert",
                                "revert-layer"
                              ]
                            }
                          ]
                        },
                        {}
                      ]
                    },
                    {
                      "type": "string",
                      "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$"
                    },
                    true,
                    {
                      "type": "string",
                      "enum": [
                        "inherit",
                        "initial",
                        "unset",
                        "revert",
                        "revert-layer"
                      ]
                    }
                  ]
                },
                {}
              ]
            },
            {
              "allOf": [
                {
                  "anyOf": [
                    {
                      "type": "string",
                      "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$"
                    },
                    true,
                    {
                      "type": "string",
                      "enum": [
                        "inherit",
                        "initial",
                        "unset",
                        "revert",
                        "revert-layer"
                      ]
                    }
                  ]
                },
                {}
              ]
            },
            {
              "type": "string",
              "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$"
            },
            true,
            {
              "type": "string",
              "enum": [
                "inherit",
                "initial",
                "unset",
                "revert",
                "revert-layer"
              ]
            }
          ]
        }
      },
      "additionalProperties": false
    },
    "MarginVar": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "name": true,
        "value": true
      },
      "additionalProperties": false
    },
    "MarginValue": {
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": true
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": true,
        "id": true,
        "metaData": true,
        "value": {
          "anyOf": [
            {
              "type": "string",
              "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$"
            },
            true,
            {
              "type": "string",
              "enum": [
                "inherit",
                "initial",
                "unset",
                "revert",
                "revert-layer"
              ]
            }
          ]
        }
      },
      "additionalProperties": false
    },
    "MarginEdgeVar": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "name": true,
        "value": true
      },
      "additionalProperties": false
    },
    "MarginEdgeValue": {
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": true
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": true,
        "id": true,
        "metaData": true,
        "value": {
          "anyOf": [
            {
              "allOf": [
                {
                  "anyOf": [
                    {
                      "allOf": [
                        {
                          "anyOf": [
                            {
                              "type": "string",
                              "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$"
                            },
                            true,
                            {
                              "type": "string",
                              "enum": [
                                "inherit",
                                "initial",
                                "unset",
                                "revert",
                                "revert-layer"
                              ]
                            }
                          ]
                        },
                        {}
                      ]
                    },
                    {
                      "type": "string",
                      "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$"
                    },
                    true,
                    {
                      "type": "string",
                      "enum": [
                        "inherit",
                        "initial",
                        "unset",
                        "revert",
                        "revert-layer"
                      ]
                    }
                  ]
                },
                {}
              ]
            },
            {
              "allOf": [
                {
                  "anyOf": [
                    {
                      "type": "string",
                      "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$"
                    },
                    true,
                    {
                      "type": "string",
                      "enum": [
                        "inherit",
                        "initial",
                        "unset",
                        "revert",
                        "revert-layer"
                      ]
                    }
                  ]
                },
                {}
              ]
            },
            {
              "type": "string",
              "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$"
            },
            true,
            {
              "type": "string",
              "enum": [
                "inherit",
                "initial",
                "unset",
                "revert",
                "revert-layer"
              ]
            }
          ]
        }
      },
      "additionalProperties": false
    },
    "BoxShadowVar": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "name": true,
        "value": true
      },
      "additionalProperties": false
    },
    "BoxShadowValue": {
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": true
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": true,
        "id": true,
        "metaData": true,
        "value": {
          "anyOf": [
            {
              "type": "string",
              "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$"
            },
            true,
            {
              "type": "string",
              "enum": [
                "inherit",
                "initial",
                "unset",
                "revert",
                "revert-layer"
              ]
            }
          ]
        }
      },
      "additionalProperties": false
    },
    "OpacityVar": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "name": true,
        "value": true
      },
      "additionalProperties": false
    },
    "OpacityValue": {
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": true
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": true,
        "id": true,
        "metaData": true,
        "value": {
          "anyOf": [
            {
              "allOf": [
                {
                  "anyOf": [
                    {
                      "type": "string",
                      "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$"
                    },
                    true,
                    {
                      "type": "string",
                      "enum": [
                        "inherit",
                        "initial",
                        "unset",
                        "revert",
                        "revert-layer"
                      ]
                    }
                  ]
                },
                {}
              ]
            },
            {
              "type": "string",
              "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$"
            },
            true,
            {
              "type": "string",
              "enum": [
                "inherit",
                "initial",
                "unset",
                "revert",
                "revert-layer"
              ]
            }
          ]
        }
      },
      "additionalProperties": false
    },
    "CssJustifyContentVar": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "name": true,
        "value": true
      },
      "additionalProperties": false
    },
    "CssJustifyContentValue": {
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": true
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": true,
        "id": true,
        "metaData": true,
        "value": {
          "allOf": [
            {
              "anyOf": [
                {
                  "type": "string",
                  "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$"
                },
                true,
                {
                  "type": "string",
                  "enum": [
                    "inherit",
                    "initial",
                    "unset",
                    "revert",
                    "revert-layer"
                  ]
                }
              ]
            },
            {}
          ]
        }
      },
      "additionalProperties": false
    },
    "BackgroundVar": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "name": true,
        "value": true
      },
      "additionalProperties": false
    },
    "BackgroundValue": {
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": true
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": true,
        "id": true,
        "metaData": true,
        "value": {
          "anyOf": [
            {
              "type": "string",
              "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$"
            },
            true,
            {
              "type": "string",
              "enum": [
                "inherit",
                "initial",
                "unset",
                "revert",
                "revert-layer"
              ]
            }
          ]
        }
      },
      "additionalProperties": false
    },
    "WritingModeVar": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "name": true,
        "value": true
      },
      "additionalProperties": false
    },
    "WritingModeValue": {
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": true
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": true,
        "id": true,
        "metaData": true,
        "value": {
          "allOf": [
            {
              "anyOf": [
                {
                  "type": "string",
                  "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$"
                },
                {
                  "type": "string",
                  "enum": [
                    "horizontal-tb",
                    "vertical-rl",
                    "vertical-lr",
                    "sideways-rl",
                    "sideways-lr"
                  ]
                },
                {
                  "type": "string",
                  "enum": [
                    "inherit",
                    "initial",
                    "unset",
                    "revert",
                    "revert-layer"
                  ]
                }
              ]
            },
            {}
          ]
        }
      },
      "additionalProperties": false
    },
    "DisplayVar": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "name": true,
        "value": true
      },
      "additionalProperties": false
    },
    "DisplayValue": {
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": true
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": true,
        "id": true,
        "metaData": true,
        "value": {
          "allOf": [
            {
              "anyOf": [
                {
                  "type": "string",
                  "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$"
                },
                true,
                {
                  "type": "string",
                  "enum": [
                    "inherit",
                    "initial",
                    "unset",
                    "revert",
                    "revert-layer"
                  ]
                }
              ]
            },
            {}
          ]
        }
      },
      "additionalProperties": false
    },
    "FilterVar": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "name": true,
        "value": true
      },
      "additionalProperties": false
    },
    "FilterValue": {
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": true
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": true,
        "id": true,
        "metaData": true,
        "value": {
          "allOf": [
            {
              "anyOf": [
                {
                  "type": "string",
                  "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$"
                },
                true,
                {
                  "type": "string",
                  "enum": [
                    "inherit",
                    "initial",
                    "unset",
                    "revert",
                    "revert-layer"
                  ]
                }
              ]
            },
            {}
          ]
        }
      },
      "additionalProperties": false
    },
    "GapVar": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "name": true,
        "value": true
      },
      "additionalProperties": false
    },
    "GapValue": {
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": true
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": true,
        "id": true,
        "metaData": true,
        "value": {
          "allOf": [
            {
              "anyOf": [
                {
                  "allOf": [
                    {
                      "anyOf": [
                        {
                          "allOf": [
                            {
                              "anyOf": [
                                {
                                  "type": "string",
                                  "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$"
                                },
                                true,
                                {
                                  "type": "string",
                                  "enum": [
                                    "inherit",
                                    "initial",
                                    "unset",
                                    "revert",
                                    "revert-layer"
                                  ]
                                }
                              ]
                            },
                            {}
                          ]
                        },
                        {
                          "type": "string",
                          "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$"
                        },
                        true,
                        {
                          "type": "string",
                          "enum": [
                            "inherit",
                            "initial",
                            "unset",
                            "revert",
                            "revert-layer"
                          ]
                        }
                      ]
                    },
                    {}
                  ]
                },
                {
                  "allOf": [
                    {
                      "anyOf": [
                        {
                          "type": "string",
                          "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$"
                        },
                        true,
                        {
                          "type": "string",
                          "enum": [
                            "inherit",
                            "initial",
                            "unset",
                            "revert",
                            "revert-layer"
                          ]
                        }
                      ]
                    },
                    {}
                  ]
                },
                {
                  "type": "string",
                  "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$"
                },
                {
                  "type": "string",
                  "pattern": "^(normal|0|calc\\([^(),]+\\)|\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%))(\\s|$){1,2}"
                },
                {
                  "type": "string",
                  "enum": [
                    "inherit",
                    "initial",
                    "unset",
                    "revert",
                    "revert-layer"
                  ]
                }
              ]
            },
            {}
          ]
        }
      },
      "additionalProperties": false
    },
    "RefArray": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "values": {
          "type": [
            "array"
          ],
          "items": true
        }
      },
      "additionalProperties": false
    },
    "VariantRelation": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "variants": {
          "type": "array",
          "items": true
        },
        "remoteVariants": {
          "type": "array",
          "items": true
        },
        "from": true,
        "to": true
      },
      "additionalProperties": false
    }
  },
  "variants_data.json": {
    "$id": "urn:dm:schemas:variants_data.json",
    "Hover": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "componentId": true
      },
      "additionalProperties": false
    },
    "Mobile": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "componentId": true
      },
      "additionalProperties": false
    },
    "State": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "componentId": true,
        "name": true
      },
      "additionalProperties": false
    },
    "Selected": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "componentId": true
      },
      "additionalProperties": false
    },
    "Trigger": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "componentId": true,
        "trigger": true,
        "params": {
          "type": "object",
          "additionalProperties": true
        }
      },
      "additionalProperties": false,
      "anyOf": [
        {
          "properties": {
            "trigger": {
              "type": "string",
              "enum": [
                "viewport-enter",
                "viewport-leave"
              ]
            },
            "params": {
              "type": "object",
              "properties": {
                "threshold": true,
                "margin": {
                  "type": "object",
                  "properties": {
                    "top": {
                      "type": "object",
                      "properties": {
                        "value": true,
                        "type": {
                          "enum": [
                            "px",
                            "percentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    "bottom": {
                      "type": "object",
                      "properties": {
                        "value": true,
                        "type": {
                          "enum": [
                            "px",
                            "percentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    "left": {
                      "type": "object",
                      "properties": {
                        "value": true,
                        "type": {
                          "enum": [
                            "px",
                            "percentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    "right": {
                      "type": "object",
                      "properties": {
                        "value": true,
                        "type": {
                          "enum": [
                            "px",
                            "percentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            }
          },
          "additionalProperties": true
        },
        {
          "properties": {
            "trigger": {
              "type": "string",
              "enum": [
                "animation-start",
                "animation-end"
              ]
            },
            "params": {
              "type": "object",
              "properties": {
                "effect": true
              },
              "additionalProperties": false
            }
          },
          "additionalProperties": true
        },
        {
          "properties": {
            "trigger": {
              "type": "string",
              "enum": [
                "pointer-move"
              ]
            },
            "params": {
              "type": "object",
              "properties": {
                "hitArea": {
                  "type": "string",
                  "enum": [
                    "self",
                    "root"
                  ]
                }
              },
              "additionalProperties": false
            }
          },
          "additionalProperties": true
        },
        {
          "properties": {
            "trigger": {
              "type": "string",
              "enum": [
                "click",
                "tap",
                "mouse-in",
                "mouse-out",
                "hover",
                "view-progress",
                "scroll-progress",
                "page-visible"
              ]
            },
            "params": {
              "type": "object",
              "additionalProperties": false
            }
          },
          "additionalProperties": true
        }
      ]
    },
    "Preset": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "componentId": true
      },
      "additionalProperties": false
    },
    "RepeaterPattern": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "componentId": true,
        "tag": true
      },
      "additionalProperties": false
    },
    "RepeaterPatternList": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "componentId": true,
        "values": {
          "type": [
            "array"
          ],
          "items": true
        }
      },
      "additionalProperties": false
    },
    "VariantsList": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "componentId": true,
        "values": {
          "type": [
            "array"
          ],
          "items": true
        }
      },
      "additionalProperties": false
    },
    "BreakpointsData": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "values": {
          "type": [
            "array",
            "null"
          ],
          "items": true
        },
        "componentId": true
      },
      "additionalProperties": false
    },
    "BreakpointRange": {
      "type": [
        "object"
      ],
      "properties": {
        "type": true,
        "id": true,
        "metaData": true,
        "min": true,
        "max": true,
        "canvasSize": true
      },
      "additionalProperties": false
    }
  }
}
